import * as i0 from '@angular/core';
import { Directive, NgModule, Injectable, Pipe, EventEmitter, Inject, forwardRef, Input, SecurityContext, Component, Output, ViewChild, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ContentChild, HostListener, ViewChildren, RendererStyleFlags2, Optional, ElementRef, ContentChildren, InjectionToken, Version } from '@angular/core';
import * as i3 from '@angular/cdk/a11y';
import { A11yModule, CdkTrapFocus } from '@angular/cdk/a11y';
import * as i3$2 from '@angular/common';
import { CommonModule, DOCUMENT, Location } from '@angular/common';
import { Observable, Subject, fromEvent, Subscription, ReplaySubject, BehaviorSubject } from 'rxjs';
import { map, debounceTime, take, filter, throttleTime, shareReplay } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i3$1 from '@angular/cdk/platform';
import * as i1$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbNav, NgbTooltip, NgbTooltipModule, NgbDatepickerConfig, NgbDateParserFormatter, NgbProgressbarModule, NgbDropdownItem, NgbDropdown, NgbDropdownMenu, NgbModalModule, NgbPopover, NgbDropdownModule, NgbTypeaheadModule, NgbTimepicker, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1$2 from '@angular/platform-browser';
import * as i2 from '@angular/cdk/bidi';
import { trigger, transition, animate, keyframes, style, state } from '@angular/animations';
import { __awaiter } from 'tslib';
import * as i6 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, NG_VALIDATORS, FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i5 from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import * as i1$3 from '@angular/router';
import { RouterModule, NavigationEnd, RouterLinkActive } from '@angular/router';
import * as i2$1 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';

let consumerData;
let submitted = false;
/**
 * Validate and store provided Consumer Data
 * */
const message = 'Please refer to the documentation on providing the required consumer data:  https://ng.bento.ui.int.thomsonreuters.com/getting-started';
class ConsumerDataValidator {
    constructor() {
        if (!submitted) {
            if (!consumerData || !consumerData.assetId) {
                throw new Error(`The Bento consumer data Asset ID must be defined. ${message}`);
            }
            else if (typeof consumerData.assetId !== 'number' || consumerData.assetId.toString().length != 6) {
                throw new Error(`The Bento consumer data assetId must be a six digit Asset ID number. ${message}`);
            }
        }
        else {
            submitted = true;
        }
    }
}
/**
 * Consumer Data to be provided by the develop
 *
 * Asset ID: (6 digit number)
 *
 * */
/**
 * Function that will be called from main.ts by the developer to provide required consumer data
 */
function setConsumerData(data) {
    consumerData = data;
}

/* eslint-disable  @angular-eslint/directive-selector */
class BentoFocusMonitorDirective {
    constructor(elementRef, r, focusMonitor) {
        this.elementRef = elementRef;
        this.focusMonitor = focusMonitor;
        this.focusMonitor.monitor(elementRef, true);
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.elementRef);
    }
}
BentoFocusMonitorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFocusMonitorDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i3.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive });
BentoFocusMonitorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFocusMonitorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i3.FocusMonitor }]; } });

class BentoFocusMonitorModule extends ConsumerDataValidator {
}
BentoFocusMonitorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFocusMonitorModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoFocusMonitorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFocusMonitorModule, declarations: [BentoFocusMonitorDirective], imports: [CommonModule], exports: [BentoFocusMonitorDirective] });
BentoFocusMonitorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFocusMonitorModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFocusMonitorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoFocusMonitorDirective],
                    imports: [CommonModule],
                    exports: [BentoFocusMonitorDirective],
                    providers: []
                }]
        }] });

class BentoTranslate {
    // Constructor
    constructor(http) {
        this.http = http;
        this._isLoading = false;
    }
    /**
     * Load JSON translations from an URL within the same domain
     */
    load(url) {
        this._isLoading = true;
        this._httpObservable = this.http.get(url).pipe(map(response => {
            const json = response;
            this.setTranslation(json);
            return json;
        }));
        this._httpObservable.subscribe(json => this._onTranslationLoad(json));
        return this._httpObservable;
    }
    /**
     * Translation change subscribable
     */
    get translationChange() {
        return BentoTranslate.change;
    }
    /**
     * Add or update a translation
     */
    add(key, translation) {
        BentoTranslate.defaultTranslation[key] = translation;
        BentoTranslate.change.next(BentoTranslate.defaultTranslation);
    }
    /**
     * Set translation with a new JSON {key:string,translation:string}
     */
    setTranslation(json) {
        for (const label in json) {
            if (json.hasOwnProperty(label)) {
                BentoTranslate.defaultTranslation[label] = json[label];
            }
        }
        BentoTranslate.change.next(BentoTranslate.defaultTranslation);
    }
    /**
     * Get the current translation set
     */
    getTranslation() {
        return BentoTranslate.defaultTranslation;
    }
    /**
     * Translate a label with an observable as return
     * This is suitable for retrieving translations from servers asynchronously
     */
    translate(label) {
        if (this._isLoading) {
            return this._httpObservable;
        }
        else {
            const observable = new Observable(observer => {
                observer.next(this.instantTranslate(label));
                /* istanbul ignore next */
                return () => { };
            });
            return observable;
        }
    }
    /**
     * Translates a label and return its instant translation
     * Note: This ONLY returns the translation which exists in the translation
     * JSON, otherwise the original label is returned
     */
    instantTranslate(label) {
        return BentoTranslate.defaultTranslation[label] || label;
    }
    // Private methods
    //
    // On translation loaded from the http observable
    _onTranslationLoad(json) {
        this._isLoading = false;
        this._httpObservable = null;
    }
}
BentoTranslate.defaultTranslation = {
    // Component Translations
    BENTO_UI_ALERT_CLOSE_BUTTON: 'Dismiss alert',
    BENTO_UI_BUSY_LOADER_LOADING: 'Loading content',
    BENTO_UI_BUSY_LOADER_LOADED: 'Content loaded',
    BENTO_UI_EXPAND_ALL: 'Expand all',
    BENTO_UI_COLLAPSE_ALL: 'Collapse all',
    BENTO_UI_FILE_SELECTOR_A11Y_CAUTION: 'Caution',
    BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON: 'Press enter key to browse file',
    BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL: 'Browse for file',
    BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL: 'Drag and drop files here',
    BENTO_UI_FILE_SELECTOR_DROP_FILED_OR: 'or',
    BENTO_UI_FILE_SELECTOR_DROP_FILED_ACTION_LABEL: 'Drop here',
    BENTO_UI_FILE_SELECTOR_FILE_NAME: 'File _FILE_NUMBER_ of _NUM_FILES_, file name: _FILE_NAME_',
    BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE: ' loading complete',
    BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_MESSAGE: 'Uploading files',
    BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS: ' loading',
    BENTO_UI_FILE_SELECTOR_FILE_ERROR: ' The _DISPLAY_TYPE_ <em>_NAME_</em> could not be uploaded. ',
    BENTO_UI_FILE_SELECTOR_FILE_EXT_ERROR: 'Only files with the following extensions are allowed: <em>_ACCEPT_</em>',
    BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON: 'Remove _FILE_NAME_',
    BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE: '_FILE_NAME_ is removed',
    BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO: 'All (_NUMBER_) selected',
    BENTO_UI_MULTISELECT_OVERLAY_CANCEL: 'Cancel',
    BENTO_UI_MULTISELECT_OVERLAY_DONE: 'Done',
    BENTO_UI_MULTISELECT_OVERLAY_EDIT: 'Edit',
    BENTO_UI_MULTISELECT_OVERLAY_SELECT: 'Select',
    BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL: 'Select all',
    BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO: '_NUMBER_ selected',
    BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL: 'All items',
    BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED: 'Selected items',
    BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL: 'Search all items',
    BENTO_UI_MULTISELECT_OVERLAY_MAX_SELECTED_INFO: 'Select at most one item',
    BENTO_UI_MULTISELECT_OVERLAY_MAX_SELECTED_INFO_PLURAL: 'Select up to _NUMBER_ items',
    BENTO_UI_NAV_TOOLBAR_MORE: 'More',
    BENTO_UI_NUMBER_INPUT_INCREASE: 'Increase number',
    BENTO_UI_NUMBER_INPUT_DECREASE: 'Decrease number',
    BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON: 'Menu',
    BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON: 'Close menu',
    BENTO_UI_OFF_CANVAS_MENU_ASIDE_TITLE: 'Menu',
    BENTO_UI_OFF_CANVAS_MENU_RIGHT_ASIDE_TITLE: 'Menu',
    BENTO_UI_PAGINATION: 'Pagination',
    BENTO_UI_PAGINATION_GO_BUTTON: 'Go',
    BENTO_UI_PAGINATION_INFO_PAGE_TEXT: 'Page _PAGE_ of _PAGES_',
    BENTO_UI_PAGINATION_SHOWING_TEXT: 'Showing _START_ to _END_ of _MAX_',
    BENTO_UI_RESET_ARIA_LABEL: 'Reset _LABEL_',
    BENTO_UI_SIDE_NAV_EXPAND: 'expand',
    BENTO_UI_SIDE_NAV_COLLAPSE: 'collapse',
    BENTO_UI_SIDE_NAV_SEARCH: 'Filter',
    BENTO_UI_SPLITTER_GROUP: 'This is a splitter group, press Tab key to proceed to its contents.',
    BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND: 'Expand',
    BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE: 'Collapse',
    BENTO_UI_SPLITTER_GROUP_TOP_BAR: '_ACTION_ top panel',
    BENTO_UI_SPLITTER_GROUP_BOTTOM_BAR: '_ACTION_ bottom panel',
    BENTO_UI_SPLITTER_GROUP_LEFT_BAR: '_ACTION_ left panel',
    BENTO_UI_SPLITTER_GROUP_RIGHT_BAR: '_ACTION_ right panel',
    BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON: 'Click and hold down the left mouse button and drag to resize the window',
    BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON: 'Press arrow key or click to increase the panel',
    BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON: 'Press arrow key or click to decrease the panel',
    BENTO_UI_TAGS_INPUT_EDIT_TEXT: 'Press enter to edit the label. ',
    BENTO_UI_TAGS_INPUT_REMOVE_TEXT: 'Press delete or backspace to remove the label. ',
    BENTO_UI_TAGS_INPUT_EDIT: 'Edit _LABEL_',
    BENTO_UI_TAGS_INPUT_CLOSE: 'Remove _LABEL_',
    BENTO_UI_TAGS_INPUT_EDIT_ELEMENT: 'Edit the label and press enter to save it or press esc key to cancel the edit',
    BENTO_UI_TAGS_INPUT_EMPTY_PILL: 
    // eslint-disable-next-line  max-len
    'Error: Pill text cannot be empty. Provide some meaningful pill value and press enter key to save or press esc key to cancel the edit ',
    BENTO_UI_TILE_RIBBON_TOGGLE_SHOW: 'Show',
    BENTO_UI_TILE_RIBBON_TOGGLE_HIDE: 'Hide',
    BENTO_UI_TILE_RIBBON_SCROLL_LEFT: 'Scroll left',
    BENTO_UI_TILE_RIBBON_SCROLL_RIGHT: 'Scroll right',
    BENTO_UI_TILE_SUCCESS: 'Success icon',
    BENTO_UI_TILE_INFO: 'Info icon',
    BENTO_UI_TILE_WARNING: 'Warning icon',
    BENTO_UI_TILE_DANGER: 'Danger icon',
    BENTO_UI_TOAST_CLOSE_BUTTON: 'Close',
    BENTO_UI_TOGGLE_ON: 'Toggle is on. Space bar to turn it off',
    BENTO_UI_TOGGLE_OFF: 'Toggle is off. Space bar to turn it on',
    BENTO_UI_TOOLBAR_MORE: 'More',
    BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE: 'Add',
    BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO: 'Remove',
    BENTO_UI_TRANSFER_BOX_BTN_TEXT: 'Transfer',
    BENTO_UI_TRANSFER_BOX_SUB_TITLE: '_SELECTED_ of _TOTAL_ checked',
    BENTO_UI_TRANSFER_BOX_LEFT_PANEL: 'Left panel',
    BENTO_UI_TRANSFER_BOX_RIGHT_PANEL: 'Right panel',
    BENTO_UI_TRANSFER_BOX_MIDDLE_BAR: 'Drag to resize',
    BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD: 'Add',
    BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE: 'Remove',
    BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT: 'Filter list',
    BENTO_UI_TRANSFER_BOX_BASIC_A11Y_SORT_BY: 'Sort by',
    BENTO_UI_TREE_EXPAND: 'expand _LABEL_',
    BENTO_UI_TREE_COLLAPSE: 'collapse _LABEL_',
    BENTO_UI_TREE_EXPAND_ALL: 'Expand all',
    BENTO_UI_TREE_COLLAPSE_ALL: 'Collapse all',
    BENTO_UI_TREE_VIEW_EXPAND: 'expand',
    BENTO_UI_TREE_VIEW_COLLAPSE: 'collapse',
    BENTO_UI_TREE_VIEW_EXPAND_ALL: 'Expand all',
    BENTO_UI_TREE_VIEW_COLLAPSE_ALL: 'Collapse all',
    BENTO_UI_WIZARD_DESCRIPTION: 'Wizard to complete a process. Tab key to proceed to wizard steps. ' +
        'Enter key to select each wizard step and its content.',
    BENTO_UI_WIZARD_STEP_NAME: 'Wizard step title.',
    BENTO_UI_WIZARD_COMPLETE_LABEL: 'Completed',
    BENTO_UI_WIZARD_BUTTON_CANCEL: 'Cancel',
    BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION: 'Cancel',
    BENTO_UI_WIZARD_BUTTON_DONE: 'Done',
    BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION: 'Done with the last step.',
    BENTO_UI_WIZARD_BUTTON_NEXT: 'Next',
    BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION: 'Proceed to next wizard step.',
    BENTO_UI_WIZARD_BUTTON_PREVIOUS: 'Previous',
    BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION: 'Back to the previous wizard step.',
    // Static translations
    BENTO_UI_TODAY: 'Today',
    BENTO_UI_TOMORROW: 'Tomorrow',
    BENTO_UI_YESTERDAY: 'Yesterday',
    BENTO_UI_N_DAY_AGO: '_NUMBER_ days ago',
    // A11Y translations
    // Transferbox
    BENTO_UI_TRANSFER_BOX_BTN_A11Y_ADD_BUTTON: 'Add items from _TITLE_',
    BENTO_UI_TRANSFER_BOX_BTN_A11Y_REMOVE_BUTTON: 'Remove items from _TITLE_',
    BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_ON_FILTERS: 'Turn on filters for _TITLE_',
    BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_OFF_FILTERS: 'Turn off filters for _TITLE_',
    BENTO_UI_TRANSFER_BOX_A11Y_SEARCH_TEXT: 'Search _TITLE_',
    BENTO_UI_TRANSFER_BOX_A11Y_CHECKBOX_LABEL: '_TITLE_ _COLUMN_KEY_: _COLUMN_KEY_VALUE_',
    BENTO_UI_TRANSFER_BOX_A11Y_HEADER_CHECKBOX_LABEL: 'Toggle all _TITLE_',
    BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_FIRST: 'Go to first page of _TITLE_',
    BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_NEXT: 'Go to next page of _TITLE_',
    BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_PREVIOUS: 'Go to previous page of _TITLE_',
    BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_LAST: 'Go to last page of _TITLE_',
    BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_PAGE_NUM: 'Enter page number to go to',
    BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_GOTO_PAGE: 'Go to page _PAGE_ of _TITLE_',
    BENTO_TRANSFER_BOX_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items per page of _TITLE_',
    // Transferbox Basic
    BENTO_UI_TRANSFER_BOX_BASIC_A11Y_DESCRIPTION: 'The Transferbox is a tool to move items between two lists,' +
        ' typically using the left side as the source for a new list as the desination on the right.',
    BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_ADDED: 'Added _NUMBER_ to _LABEL_',
    BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_REMOVED: 'Removed _NUMBER_ from _LABEL_',
    BENTO_UI_TRANSFER_BOX_BASIC_A11Y_HEADER_CHECKBOX_LABEL: 'Toggle all',
    BENTO_UI_TRANSFER_BOX_BASIC_A11Y_CHECKBOX_LABEL: 'Row _ROW_ID_',
    // Pagination
    BENTO_UI_PAGINATION_A11Y_FIRST_BUTTON: 'First',
    BENTO_UI_PAGINATION_A11Y_PREVIOUS_BUTTON: 'Previous',
    BENTO_UI_PAGINATION_A11Y_NEXT_BUTTON: 'Next',
    BENTO_UI_PAGINATION_A11Y_LAST_BUTTON: 'Last',
    BENTO_UI_PAGINATION_A11Y_FIRST: 'Go to first page',
    BENTO_UI_PAGINATION_A11Y_NEXT: 'Go to next page',
    BENTO_UI_PAGINATION_A11Y_PREVIOUS: 'Go to previous page',
    BENTO_UI_PAGINATION_A11Y_LAST: 'Go to last page',
    BENTO_UI_PAGINATION_A11Y_PAGE_NUM: 'Enter page number to go to',
    BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: 'Go to page',
    BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items per page',
    // scrollable bar
    BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT: 'Scroll left',
    BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT: 'Scroll right',
    // combobox
    BENTO_UI_CBOX_A11Y_NO_RESULTS: 'No results found',
    BENTO_UI_CBOX_DROPDOWN_ICON_OPEN: 'Enter to expand',
    BENTO_UI_CBOX_DROPDOWN_ICON_CLOSE: 'Enter to collapse',
    BENTO_UI_CBOX_INPUT_LABEL: 'Select here',
    BENTO_UI_CBOX_OPTIONS: 'Options',
    // contextual-header
    BENTO_UI_CONTEXTUAL_HEADER_BACK: 'Go back',
    // multiselect-overlay
    BENTO_UI_MULTISELECT_OLAY_ALL_DESC: 'Shows list of all items (both selected and non-selected)',
    BENTO_UI_MULTISELECT_OLAY_SELECTED_DESC: 'Shows list of only selected items',
    BENTO_UI_MULTISELECT_OVERLAY_A11Y_NOTHING_FOUND: 'No results found',
    BENTO_UI_MULTISELECT_OVERLAY_A11Y_FOUND_N_RESULTS: 'Found _NUMBER_ results',
    // universal-filter
    BENTO_UI_UNIVERSAL_FILTER_BACK: 'Go back',
    BENTO_UI_UNIVERSAL_FILTER_EXPAND: 'Expand',
    BENTO_UI_UNIVERSAL_FILTER_COLLAPSE: 'Collapse',
    // wizard
    BENTO_UI_WIZARD_LEFT: 'Previous step',
    BENTO_UI_WIZARD_RIGHT: 'Next step',
    // tabs scroll
    BENTO_UI_TABSET_SCROLL_LEFTMOST: 'Scroll to the start',
    BENTO_UI_TABSET_SCROLL_LEFT: 'Scroll left',
    BENTO_UI_TABSET_SCROLL_RIGHT: 'Scroll right',
    BENTO_UI_TABSET_SCROLL_RIGHTMOST: 'Scroll to the end',
    // timepicker
    BENTO_UI_TIMEPICKER_LEGEND: 'Timepicker',
    // tree view
    BENTO_UI_TREEVIEW_PRINT: 'Print',
    BENTO_UI_TREEVIEW_CONFIGURE: 'Configure',
    // modal confirmation
    BENTO_UI_MODAL_CONFIRMATION_CLOSE: 'Close'
};
BentoTranslate.change = new Subject();
BentoTranslate.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslate, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
BentoTranslate.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslate });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslate, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

/**
 * Bento Translate Pipe
 *
 * Usage: `'TEXT_LABEL_TO_BE_TRANSLATED` | bentoTranslate`
 */
class BentoTranslatePipe {
    constructor(translate) {
        this._translation = '';
        this._translate = translate;
    }
    transform(label, translateOverride) {
        if (translateOverride && translateOverride.length > 0) {
            this._translation = translateOverride;
        }
        else {
            this._translation = this._translate.instantTranslate(label);
        }
        return this._translation;
    }
}
BentoTranslatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslatePipe, deps: [{ token: BentoTranslate }], target: i0.ɵɵFactoryTarget.Pipe });
BentoTranslatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslatePipe, name: "bentoTranslate", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslatePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bentoTranslate', pure: false }]
        }], ctorParameters: function () { return [{ type: BentoTranslate }]; } });

class BentoTranslateModule extends ConsumerDataValidator {
}
BentoTranslateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslateModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTranslateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslateModule, declarations: [BentoTranslatePipe], exports: [BentoTranslatePipe] });
BentoTranslateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslateModule, providers: [BentoTranslate] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTranslateModule, decorators: [{
            type: NgModule,
            args: [{ declarations: [BentoTranslatePipe], exports: [BentoTranslatePipe], providers: [BentoTranslate] }]
        }] });

/**
 * A pipe to replace number into string file size representations
 */
class BentoFileSizePipe {
    transform(value) {
        let output = '0 Byte';
        if (value < 1000) {
            output = value + 'B';
        }
        else if (value < 100000) {
            output = Math.round(value / 100) / 10 + 'KB';
        }
        else if (value < 1000000) {
            output = Math.round(value / 1000) + 'KB';
        }
        else if (value < 100000000) {
            output = Math.round(value / 100000) / 10 + 'MB';
        }
        else if (value < 1000000000) {
            output = Math.round(value / 1000000) + 'MB';
        }
        else if (value < 100000000000) {
            output = Math.round(value / 100000000) / 10 + 'GB';
        }
        else if (value < 1000000000000) {
            output = Math.round(value / 1000000000) + 'GB';
        }
        else if (value < 100000000000000) {
            output = Math.round(value / 100000000000) / 10 + 'TB';
        }
        else if (value < 1000000000000000) {
            output = Math.round(value / 1000000000000) + 'TB';
        }
        return output;
    }
}
BentoFileSizePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BentoFileSizePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSizePipe, name: "bentoFileSizeFilter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSizePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bentoFileSizeFilter' }]
        }] });

/* eslint-disable  no-console */
class BentoLogService {
    log(...params) {
        console.log(...params);
    }
    warn(...params) {
        console.warn(...params);
    }
    error(...params) {
        console.error(...params);
    }
}
BentoLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoLogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoLogService, decorators: [{
            type: Injectable
        }] });

/**
 * Main debounce time
 */
const DEBOUNCE_TIME = 110; // Default transition duration is 100ms for Bento
class BentoNotification {
    /**
     * Emit resize to broadcast
     */
    emitResize(component) {
        if (BentoNotification._initialized && BentoNotification.resizeEvent) {
            // Only broadcast if there is at least one notification subscribed
            BentoNotification.resizeObserver.next(component);
        }
    }
    /**
     * Get resize notification subscribable
     */
    get resizeNotification() {
        if (!BentoNotification._initialized) {
            BentoNotification._initialized = true;
            // For broadcasting
            Observable.create(o => {
                BentoNotification.resizeObserver = o;
            })
                .pipe(debounceTime(DEBOUNCE_TIME))
                .subscribe(c => {
                BentoNotification.resizeEvent.emit(c);
            });
            try {
                // Add an event listener to the window object to listen browser window resize
                fromEvent(window, 'resize')
                    .pipe(debounceTime(DEBOUNCE_TIME))
                    .subscribe(e => {
                    BentoNotification.resizeEvent.emit(window);
                });
            }
            catch (e) {
                // Running in SSR mode no need to listen to window
            }
        }
        return BentoNotification.resizeEvent;
    }
}
/**
 * Main event emitter for resizes
 */
BentoNotification.resizeEvent = new EventEmitter();
/**
 * Resize observer for global resize broadcasts
 */
BentoNotification.resizeObserver = null;
BentoNotification._initialized = false;
BentoNotification.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNotification, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoNotification.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNotification, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNotification, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

let scrollbarWidth;
/**
 * Is used to inject window objects
 */
class WindowRef {
    constructor(document, platform) {
        this.document = document;
        this.platform = platform;
        try {
            this.window = window;
        }
        catch (e) {
            // We are in SSR mode
            this.window = {};
        }
    }
    /**
     * Return window object
     */
    get nativeWindow() {
        return this.window;
    }
    /**
     * Return document objext
     */
    get nativeDocument() {
        return this.document;
    }
    /**
     * Return a scrollbar width
     */
    get scrollbarWidth() {
        if (scrollbarWidth == null) {
            try {
                // Scrollbar width is not defined yet
                const outter = this.document.createElement('div');
                const inner = this.document.createElement('div');
                let width;
                outter.style.width = '100px';
                outter.style.height = '100px';
                outter.style.overflow = 'auto';
                outter.style.position = 'fixed';
                outter.style.top = '-200px';
                inner.style.height = '110px';
                outter.appendChild(inner);
                this.document.body.appendChild(outter);
                width = 100 - inner.offsetWidth;
                this.document.body.removeChild(outter);
                scrollbarWidth = width;
            }
            catch (e) {
                // Nope, we are running in SSR mode
            }
        }
        return scrollbarWidth || 0;
    }
    /**
     * Return if browser is FF
     */
    get isFF() {
        return this.platform.FIREFOX;
    }
    /**
     * Return if browser is IE and Edge
     */
    get isIEEdge() {
        return this.platform.EDGE;
    }
    get isIE() {
        return this.platform.TRIDENT;
    }
}
WindowRef.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: WindowRef, deps: [{ token: DOCUMENT }, { token: i3$1.Platform }], target: i0.ɵɵFactoryTarget.Injectable });
WindowRef.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: WindowRef });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: WindowRef, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: globalThis.Document, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: i3$1.Platform }];
    } });

/**
 * Helper service to normallize all pointer tapes and help to translate  pointer locations
 */
class BentoPointerService {
    constructor(winRef) {
        /**
         * Pointer down event type name
         */
        this.pointerDown = 'mousedown';
        /**
         * Pointer move event type name
         */
        this.pointerMove = 'mousemove';
        /**
         * Pointer up event type name
         */
        this.pointerUp = 'mouseup';
        /**
         * Pointer out event type name
         */
        this.pointerOut = 'mouseout';
        /**
         * Pointer cancel event type name
         */
        this.pointerCancel = 'pointercancel';
        /**
         * Indicates if there is touch
         */
        this.hasTouch = false;
        this.exitSubscription = Subscription.EMPTY;
        this.emptyFunc = () => { };
        const win = winRef.nativeWindow;
        if (win.hasOwnProperty('PointerEvent')) {
            // Only update where supported.  Ex. Surface
            this.pointerDown = 'pointerdown';
            this.pointerMove = 'pointermove';
            this.pointerUp = 'pointerup';
            this.pointerOut = 'pointerout';
        }
        if (win.hasOwnProperty('TouchEvent')) {
            this.hasTouch = true;
        }
        // Create observable for pointer exit
        this.documentExit = Observable.create(sub => {
            this.exitSubscription = fromEvent(winRef.nativeDocument, this.pointerOut).subscribe((e) => {
                const from = e.relatedTarget;
                if (!from || from.nodeName === 'HTML') {
                    sub.next();
                }
            });
        });
    }
    ngOnDestroy() {
        this.exitSubscription.unsubscribe();
    }
    listenPointerDown(r, el, func) {
        return this.listenPointerEvent(r, this.pointerDown, 'touchstart', el, func);
    }
    listenPointerMove(r, el, func) {
        return this.listenPointerEvent(r, this.pointerMove, 'touchmove', el, func);
    }
    listenPointerUp(r, el, func) {
        return this.listenPointerEvent(r, this.pointerUp, 'touchup', el, func);
    }
    listenPointerCancel(r, el, func) {
        return this.listenPointerEvent(r, this.pointerCancel, 'touchcacel', el, func);
    }
    /**
     * Get pointer X and Y values from an pointer event
     */
    getPointerXY(e) {
        const pointer = e.hasOwnProperty('changedTouches') // `changedTouches` is available on Windows touch surfaces
            ? e['changedTouches'][0]
            : e;
        const pointerX = pointer.clientX ? pointer.clientX : pointer.pageX;
        const pointerY = pointer.clientY ? pointer.clientY : pointer.pageY;
        return { x: pointerX, y: pointerY };
    }
    listenPointerEvent(r, pointerEventType, touchEventType, el, func) {
        const callback = (e) => {
            func(e);
            e.stopImmediatePropagation();
        };
        const pointDownCancel = r.listen(el, pointerEventType, callback);
        const touchStartCancel = this.hasTouch ? r.listen(el, touchEventType, callback) : this.emptyFunc;
        return () => {
            pointDownCancel();
            touchStartCancel();
        };
    }
}
BentoPointerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPointerService, deps: [{ token: WindowRef }], target: i0.ɵɵFactoryTarget.Injectable });
BentoPointerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPointerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPointerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: WindowRef }]; } });

class BentoPositioning {
    constructor(windowRef) { }
    /**
     * Reset the width of an element
     * @param r Renderer2 object
     * @param el Element to be reset
     */
    static resetWidth(r, el) {
        r.removeStyle(el, 'width');
        r.removeStyle(el, 'max-width');
    }
    /**
     * Main method to position a target element against the host element included in a container
     * @param renderer Angular Renderer2 for rendering
     * @param host The HTMLElement that is to be aligned to
     * @param target The HTMLElement that is to be placed to align with the `host`
     * @param container Container HTMLElement to host the `target` element
     * @param placement Only work for 'top' and 'bottom' at this point
     * @param alignment Horizontal alignment 'left' and 'right' TODO: 'center' to come later
     * @param offset Offset in pixels to fine tune the placement location
     * @param autoRealign Auto relaign to the container with the `target` is out of boundary
     */
    positionElement(renderer, host, target, container, placement = 'bottom', alignment = 'left', offset = 0, autoRealign = false) {
        const containerClientWidth = container.clientWidth;
        this.r = renderer;
        this.r.setStyle(target, 'visibility', 'hidden');
        if (placement === 'bottom') {
            this.r.setStyle(target, 'top', '0');
            this.r.setStyle(target, 'bottom', 'auto');
        }
        else {
            this.r.setStyle(target, 'bottom', '0');
            this.r.setStyle(target, 'top', 'auto');
        }
        if (alignment === 'left') {
            this.r.setStyle(target, 'left', '0');
            this.r.setStyle(target, 'right', 'auto');
        }
        else {
            this.r.setStyle(target, 'right', '0');
            this.r.setStyle(target, 'left', 'auto');
        }
        if (autoRealign) {
            // Set max width to the target el if there is an auto-relaignment
            this.r.setStyle(target, 'max-width', containerClientWidth + 'px');
        }
        this.r.appendChild(container, target);
        const hostRect = host.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const dTop = hostRect.bottom - targetRect.top;
        const dBottom = hostRect.top - targetRect.bottom;
        let dLeft = Math.max(hostRect.left - targetRect.left, containerRect.left - targetRect.left);
        let dRight = hostRect.right - targetRect.right;
        if (autoRealign) {
            // We still need a temporary element to measure the content location against
            // the viewport so that we can conpensate gaps with all borders and scrollbars(in RTL)
            // without having gaps
            let tempEl = this.r.createElement('div');
            let tempRect;
            this.r.setStyle(tempEl, 'visibility', 'hidden');
            this.r.setStyle(tempEl, 'height', '0');
            this.r.appendChild(container, tempEl);
            tempRect = tempEl.getBoundingClientRect();
            // Remove and clean temporary element
            this.r.removeChild(container, tempEl);
            tempEl = null;
            if (alignment === 'left' && hostRect.left + targetRect.width > tempRect.right) {
                // `target` is out of boundary on the right need to move it back
                dLeft = tempRect.right - targetRect.width - targetRect.left;
            }
            else if (alignment === 'right' && hostRect.right - targetRect.width < tempRect.left) {
                // `target` is out of boundary on the left and need to align left
                dRight = tempRect.left + targetRect.width - targetRect.right;
            }
        }
        // There are only two case for now 'top' and 'bottom'
        // Will exrtend to 'left' and 'right' when required
        switch (placement) {
            case 'top':
                if (alignment === 'left') {
                    this.updatePositionStyles(target, 'auto', 'auto', -dBottom + offset + 'px', dLeft + 'px');
                }
                else {
                    this.updatePositionStyles(target, 'auto', -dRight + 'px', -dBottom + offset + 'px', 'auto');
                }
                break;
            default:
                if (alignment === 'left') {
                    this.updatePositionStyles(target, dTop + offset + 'px', 'auto', 'auto', dLeft + 'px');
                }
                else {
                    this.updatePositionStyles(target, dTop + offset + 'px', -dRight + 'px', 'auto', 'auto');
                }
        }
        // Show element
        this.r.removeStyle(target, 'visibility');
    }
    /**
     * Reset style positioning values previously assigned by `.positionElement(...)`
     * @param r Renderer2 used to render
     * @param el HTMLElement to be reset
     */
    resetPosition(r, el) {
        r.removeStyle(el, 'top');
        r.removeStyle(el, 'left');
        r.removeStyle(el, 'right');
        r.removeStyle(el, 'bottom');
    }
    /**
     * Update positioning CSS styles
     */
    updatePositionStyles(el, top, right, bottom, left, width) {
        this.r.setStyle(el, 'top', top);
        this.r.setStyle(el, 'right', right);
        this.r.setStyle(el, 'bottom', bottom);
        this.r.setStyle(el, 'left', left);
        if (width) {
            this.r.setStyle(el, 'width', width);
        }
    }
}
BentoPositioning.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPositioning, deps: [{ token: WindowRef }], target: i0.ɵɵFactoryTarget.Injectable });
BentoPositioning.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPositioning, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPositioning, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: WindowRef }]; } });

class BentoRefreshNotifierDirective {
    constructor(nav, notification) {
        this.nav = nav;
        this.notification = notification;
        this.changeSubscription = Subscription.EMPTY;
    }
    ngOnInit() {
        this.changeSubscription = this.nav.navChange.subscribe(event => {
            let condition = true;
            if (event && this.notificationCondition && this.notificationCondition.name && this.notificationCondition.value) {
                /**
                 * The `name` property of `notificationCondition` matches to `NgbTabChangeEvent`'s `nextId` property
                 * In the below logic `event[this.notificationCondition.name]` is same as `event.nextId`
                 */
                condition = event[this.notificationCondition.name] === this.notificationCondition.value;
            }
            if (event && condition) {
                this.notification.emitResize();
            }
        });
    }
    ngOnDestroy() {
        this.changeSubscription.unsubscribe();
    }
}
BentoRefreshNotifierDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRefreshNotifierDirective, deps: [{ token: forwardRef(() => NgbNav) }, { token: BentoNotification }], target: i0.ɵɵFactoryTarget.Directive });
BentoRefreshNotifierDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoRefreshNotifierDirective, selector: "[ngbNav][bentoRefreshNotifier]", inputs: { notificationCondition: "notificationCondition" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRefreshNotifierDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[ngbNav][bentoRefreshNotifier]' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgbNav, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbNav)]
                    }] }, { type: BentoNotification }];
    }, propDecorators: { notificationCondition: [{
                type: Input
            }] } });

// https://stackoverflow.com/questions/42048836/change-a-tag-dynamically-angular-2
class BentoReplaceTagDirective {
    constructor(winRef, el, templateRef, vcf, sanitizer) {
        this.el = el;
        this.templateRef = templateRef;
        this.vcf = vcf;
        this.sanitizer = sanitizer;
        this.document = winRef.nativeDocument;
    }
    set tag(t) {
        this._tag = t;
        this.vcf.clear();
        this.vcf.createEmbeddedView(this.templateRef);
    }
    ngAfterViewInit() {
        this._updateTemplate();
    }
    _updateTemplate() {
        const template = this.el.nativeElement.previousElementSibling;
        if (template) {
            const r = this.document.createElement(this._tag);
            template.getAttributeNames().forEach(attrName => {
                r.setAttribute(attrName, template.getAttribute(attrName));
            });
            r.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, template.innerHTML);
            this.el.nativeElement.parentNode.replaceChild(r, template);
        }
    }
}
BentoReplaceTagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoReplaceTagDirective, deps: [{ token: WindowRef }, { token: i0.ElementRef }, { token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive });
BentoReplaceTagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoReplaceTagDirective, selector: "[replaceTag]", inputs: { tag: ["replaceTag", "tag"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoReplaceTagDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[replaceTag]'
                }]
        }], ctorParameters: function () { return [{ type: WindowRef }, { type: i0.ElementRef }, { type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i1$2.DomSanitizer }]; }, propDecorators: { tag: [{
                type: Input,
                args: ['replaceTag']
            }] } });

/**
 * String Services and Pipes
 */
/**
 * A pipe used to replace strings
 */
class BentoStringReplacePipe {
    transform(value, find, replaceWith) {
        const re = new RegExp(find, 'g');
        return value.replace(re, replaceWith);
    }
}
BentoStringReplacePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStringReplacePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BentoStringReplacePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStringReplacePipe, name: "bentoStringReplace" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStringReplacePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bentoStringReplace' }]
        }] });

class BentoTabService {
    /**
     * Find focussable elements in an element
     */
    findFocussable(element) {
        const els = element.querySelectorAll('a,input,select,textarea,button,[tabindex]:not(.cdk-visually-hidden)');
        const elArray = [];
        let el;
        for (let i = 0, len = els.length; i < len; i++) {
            el = els[i];
            if (this.isVisible(el) && (!el.hasAttribute('disabled') || el.nodeName === 'A') && el.tabIndex > -1) {
                elArray.push(el);
            }
        }
        return elArray;
    }
    /**
     * Find tabbable element in an element
     */
    findTabbable(element) {
        const elArray = this.findFocussable(element);
        return elArray.filter(item => {
            const a = item.getAttribute('tabindex');
            if (!a || a !== -1) {
                return true;
            }
        });
    }
    isVisible(element) {
        return !(element.offsetWidth === 0 && element.offsetHeight === 0);
    }
}
BentoTabService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoTabService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * A service to create UIDs
 */
class BentoUidService {
    generate() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
    }
}
BentoUidService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUidService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoUidService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUidService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUidService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class BentoUtilsModule extends ConsumerDataValidator {
}
BentoUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUtilsModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUtilsModule, declarations: [BentoStringReplacePipe, BentoFileSizePipe, BentoReplaceTagDirective, BentoRefreshNotifierDirective], exports: [BentoStringReplacePipe, BentoFileSizePipe, BentoReplaceTagDirective, BentoRefreshNotifierDirective] });
BentoUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUtilsModule, providers: [
        BentoTabService,
        BentoUidService,
        WindowRef,
        BentoNotification,
        BentoPositioning,
        BentoLogService,
        BentoPointerService
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoStringReplacePipe, BentoFileSizePipe, BentoReplaceTagDirective, BentoRefreshNotifierDirective],
                    providers: [
                        BentoTabService,
                        BentoUidService,
                        WindowRef,
                        BentoNotification,
                        BentoPositioning,
                        BentoLogService,
                        BentoPointerService
                    ],
                    exports: [BentoStringReplacePipe, BentoFileSizePipe, BentoReplaceTagDirective, BentoRefreshNotifierDirective]
                }]
        }] });

class BentoAlertItemComponent {
    constructor(elRef, windowRef, dir) {
        this.elRef = elRef;
        /**
         * Emit event when this instance is closed
         */
        this.close = new EventEmitter();
        /**
         * Flag to determine if this alert is in RTL mode or not
         */
        this.isRTL = false;
        this.document = windowRef.nativeDocument;
        dir.change.subscribe(() => {
            this.isRTL = dir.value === 'rtl';
        });
    }
    ngOnInit() {
        if (this.options.timeout) {
            const time = this.options.timeout;
            setTimeout(() => {
                this.closeAlert();
            }, time);
        }
    }
    ngAfterViewInit() {
        if ((this.options.type === 'danger' && this.options.timeout) ||
            (this.options.type === 'warning' && this.options.timeout)) {
            const errorString = `Note: accessibility compliance encourages timed alerts should only be used with success and informational alerts.`;
            console.warn(errorString);
        }
        this.lastActiveElement = this.document.activeElement;
    }
    isActiveElement() {
        return this.elRef.nativeElement.contains(this.document.activeElement);
    }
    /**
     * Close the current alert UI instance
     */
    closeAlert() {
        this.close.emit({ alert: this.options, index: this.index, focusedEl: this.lastActiveElement });
    }
}
BentoAlertItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertItemComponent, deps: [{ token: i0.ElementRef }, { token: WindowRef }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoAlertItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoAlertItemComponent, selector: "bento-alert-item", inputs: { options: "options", index: "index", grabFocus: "grabFocus" }, outputs: { close: "close" }, viewQueries: [{ propertyName: "alertRef", first: true, predicate: ["alert"], descendants: true, static: true }], ngImport: i0, template: "<div\n  class=\"alert bento-alert\"\n  [attr.bento-alert-index]=\"index\"\n  [ngClass]=\"['alert-' + (options.type || 'warning'), options.closeable ? 'alert-dismissable' : '']\"\n  role=\"alert\"\n  #alert\n>\n  <div *ngIf=\"options.template; else defaultTemplate\"\n  cdkTrapFocus=\"false\" [cdkTrapFocusAutoCapture]=\"grabFocus\">\n    <ng-container *ngTemplateOutlet=\"options.template; context: {options: options, index: index}\"></ng-container>\n  </div>\n  <button\n    *ngIf=\"options.closeable\"\n    type=\"button\"\n    class=\"close\"\n    (click)=\"closeAlert()\"\n    [attr.aria-label]=\"'BENTO_UI_ALERT_CLOSE_BUTTON' | bentoTranslate: alert.closeButtonLabel\"\n  >\n    <i class=\"bui-alert-close-indicator\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n<ng-template #defaultTemplate>\n  <span [innerHTML]=\"options.msg\"\n  cdkTrapFocus=\"false\" [cdkTrapFocusAutoCapture]=\"grabFocus\"></span>\n</ng-template>\n", directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-alert-item', template: "<div\n  class=\"alert bento-alert\"\n  [attr.bento-alert-index]=\"index\"\n  [ngClass]=\"['alert-' + (options.type || 'warning'), options.closeable ? 'alert-dismissable' : '']\"\n  role=\"alert\"\n  #alert\n>\n  <div *ngIf=\"options.template; else defaultTemplate\"\n  cdkTrapFocus=\"false\" [cdkTrapFocusAutoCapture]=\"grabFocus\">\n    <ng-container *ngTemplateOutlet=\"options.template; context: {options: options, index: index}\"></ng-container>\n  </div>\n  <button\n    *ngIf=\"options.closeable\"\n    type=\"button\"\n    class=\"close\"\n    (click)=\"closeAlert()\"\n    [attr.aria-label]=\"'BENTO_UI_ALERT_CLOSE_BUTTON' | bentoTranslate: alert.closeButtonLabel\"\n  >\n    <i class=\"bui-alert-close-indicator\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n<ng-template #defaultTemplate>\n  <span [innerHTML]=\"options.msg\"\n  cdkTrapFocus=\"false\" [cdkTrapFocusAutoCapture]=\"grabFocus\"></span>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: WindowRef }, { type: i2.Directionality }]; }, propDecorators: { options: [{
                type: Input
            }], index: [{
                type: Input
            }], grabFocus: [{
                type: Input,
                args: ['grabFocus']
            }], close: [{
                type: Output
            }], alertRef: [{
                type: ViewChild,
                args: ['alert', { static: true }]
            }] } });

class BentoAlertComponent {
    constructor() {
        /**
         * An event emitted when the close button is clicked. This event returns a payload with the alert item's index number.
         * Only relevant for dismissible alerts.
         */
        this.close = new EventEmitter();
        /**
         * Flag to determine of all Bento Alert items are displayed inline with other elements
         */
        this.inline = false;
        /**
         * When set to `true`, this will do two things.
         * First, if any interactive elements exist in the alert (other than the close button),
         * focus will automatically be moved to the first focusable element in the alert.
         * Second, when the alert is closed, focus will automatically be moved to the element that triggered the alert.
         * See _Accessibility_ for more information.
         */
        this.grabFocus = true;
    }
    /**
     * on close alert
     */
    onAlertClose($event) {
        // remove alert from array
        const index = this.items.indexOf($event.alert);
        if (index > -1) {
            this.items.splice(index, 1);
        }
        // bubble emit
        this.close.emit($event.index);
        // after closing, focus on original trigger element
        if ($event.focusedEl) {
            setTimeout(() => {
                $event.focusedEl.focus();
            });
        }
    }
}
BentoAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BentoAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoAlertComponent, selector: "bento-alert", inputs: { items: "items", inline: "inline", grabFocus: "grabFocus" }, outputs: { close: "close" }, host: { properties: { "class.bento-alert-inline": "this.inline" } }, ngImport: i0, template: "<div class=\"alert-container refresh-data\">\n  <bento-alert-item\n    *ngFor=\"let alert of items; let i = index\"\n    class=\"bento-alert-container\"\n    [@fadeInOut]\n    [options]=\"alert\"\n    [index]=\"i\"\n    (close)=\"onAlertClose($event)\"\n    [attr.rel]=\"'bento-alert-' + i\"\n    [grabFocus]=\"grabFocus\"\n  ></bento-alert-item>\n</div>\n", styles: [".ng-bento bento-alert .alert{text-align:left;box-sizing:border-box;position:relative;font-size:14px;padding:11px 62px 10px 50px;min-height:44px}[dir=rtl] .ng-bento bento-alert .alert{text-align:right;padding:11px 50px 10px 62px}.ng-bento bento-alert .alert a{text-decoration:underline}.ng-bento bento-alert .alert a:hover{opacity:.9}.ng-bento bento-alert .alert:before{font-family:bento-icons;font-style:normal;font-weight:400;font-size:20px;line-height:1;position:absolute;left:5px;width:40px;text-align:center;-webkit-font-smoothing:antialiased}[dir=rtl] .ng-bento bento-alert .alert:before{left:auto;right:5px}.ng-bento bento-alert .alert button.close{align-items:center;background:transparent;border-radius:15px;border:none;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;position:absolute;right:10px;text-align:center;text-shadow:none;top:10px;width:24px}[dir=rtl] .ng-bento bento-alert .alert button.close{right:auto;left:10px}.ng-bento bento-alert .alert button.close i{font-family:bento-icons;top:0;font-style:normal}.ng-bento bento-alert .alert button.close:focus{outline:none}.ng-bento bento-alert .alert button.close:hover{transition:background .3s}.ng-bento bento-alert .alert button.close:hover i{transition:color .1s}.ng-bento bento-alert .alert-dismissable .close{top:0}.ng-bento bento-alert .bento-alert{box-shadow:2px 2px 6px #0000004d;margin-bottom:5px;transition:opacity .5s,filter .5s}bento-alert-inline .ng-bento bento-alert .bento-alert{box-shadow:none}.ng-bento bento-alert .alert-container{left:50%;min-width:300px;position:fixed;top:37px;transform:translate(-50%);z-index:1000000}.ng-bento bento-alert .alert-container:focus{outline:none}.ng-bento bento-alert .alert-container.right{left:auto;right:20px;transform:translate(0)}[dir=rtl] .ng-bento bento-alert .alert-container.right{left:20px;right:auto}.ng-bento bento-alert .alert-container.right>div{width:auto;max-width:100%;display:inline-block}.ng-bento bento-alert .alert-container.left{left:20px;transform:translate(0)}[dir=rtl] .ng-bento bento-alert .alert-container.left{left:auto;right:20px}.ng-bento bento-alert.bento-alert-inline .alert-container{z-index:auto;display:block;position:relative;top:auto;left:auto;width:100%;min-width:0;transform:none;-ms-transform:none;-webkit-transform:none}@media (min-width: 1200px){.ng-bento bento-alert .alert-container{width:40%}}@media (min-width: 992px) and (max-width: 1199px){.ng-bento bento-alert .alert-container{width:55%}}@media (min-width: 768px) and (max-width: 991px){.ng-bento bento-alert .alert-container{width:75%}}@media (max-width: 767px){.ng-bento bento-alert .alert-container{width:80%}}.ng-bento bento-alert .bento-alert-container{display:block;transition:.2s linear all}.ng-bento bento-alert .bento-alert-container.ng-enter{opacity:0}.ng-bento bento-alert .bento-alert-container.ng-enter.ng-enter-active{opacity:1}.ng-bento bento-alert .bento-alert-container.ng-leave{overflow:hidden;opacity:1}.ng-bento bento-alert .bento-alert-container.ng-leave.ng-leave-active{opacity:0}.ng-bento bento-alert .bento-alert-container.ng-leave.ng-leave-active:not(:last-child){height:0!important}\n"], components: [{ type: BentoAlertItemComponent, selector: "bento-alert-item", inputs: ["options", "index", "grabFocus"], outputs: ["close"] }], directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], animations: [
        trigger('fadeInOut', [
            transition('void => *', [animate(100, keyframes([style({ opacity: 0 }), style({ opacity: 1 })]))]),
            transition('* => void', [animate(100, keyframes([style({ opacity: 1 }), style({ opacity: 0, height: 0 })]))])
        ])
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-alert', encapsulation: ViewEncapsulation.None, animations: [
                        trigger('fadeInOut', [
                            transition('void => *', [animate(100, keyframes([style({ opacity: 0 }), style({ opacity: 1 })]))]),
                            transition('* => void', [animate(100, keyframes([style({ opacity: 1 }), style({ opacity: 0, height: 0 })]))])
                        ])
                    ], template: "<div class=\"alert-container refresh-data\">\n  <bento-alert-item\n    *ngFor=\"let alert of items; let i = index\"\n    class=\"bento-alert-container\"\n    [@fadeInOut]\n    [options]=\"alert\"\n    [index]=\"i\"\n    (close)=\"onAlertClose($event)\"\n    [attr.rel]=\"'bento-alert-' + i\"\n    [grabFocus]=\"grabFocus\"\n  ></bento-alert-item>\n</div>\n", styles: [".ng-bento bento-alert .alert{text-align:left;box-sizing:border-box;position:relative;font-size:14px;padding:11px 62px 10px 50px;min-height:44px}[dir=rtl] .ng-bento bento-alert .alert{text-align:right;padding:11px 50px 10px 62px}.ng-bento bento-alert .alert a{text-decoration:underline}.ng-bento bento-alert .alert a:hover{opacity:.9}.ng-bento bento-alert .alert:before{font-family:bento-icons;font-style:normal;font-weight:400;font-size:20px;line-height:1;position:absolute;left:5px;width:40px;text-align:center;-webkit-font-smoothing:antialiased}[dir=rtl] .ng-bento bento-alert .alert:before{left:auto;right:5px}.ng-bento bento-alert .alert button.close{align-items:center;background:transparent;border-radius:15px;border:none;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;position:absolute;right:10px;text-align:center;text-shadow:none;top:10px;width:24px}[dir=rtl] .ng-bento bento-alert .alert button.close{right:auto;left:10px}.ng-bento bento-alert .alert button.close i{font-family:bento-icons;top:0;font-style:normal}.ng-bento bento-alert .alert button.close:focus{outline:none}.ng-bento bento-alert .alert button.close:hover{transition:background .3s}.ng-bento bento-alert .alert button.close:hover i{transition:color .1s}.ng-bento bento-alert .alert-dismissable .close{top:0}.ng-bento bento-alert .bento-alert{box-shadow:2px 2px 6px #0000004d;margin-bottom:5px;transition:opacity .5s,filter .5s}bento-alert-inline .ng-bento bento-alert .bento-alert{box-shadow:none}.ng-bento bento-alert .alert-container{left:50%;min-width:300px;position:fixed;top:37px;transform:translate(-50%);z-index:1000000}.ng-bento bento-alert .alert-container:focus{outline:none}.ng-bento bento-alert .alert-container.right{left:auto;right:20px;transform:translate(0)}[dir=rtl] .ng-bento bento-alert .alert-container.right{left:20px;right:auto}.ng-bento bento-alert .alert-container.right>div{width:auto;max-width:100%;display:inline-block}.ng-bento bento-alert .alert-container.left{left:20px;transform:translate(0)}[dir=rtl] .ng-bento bento-alert .alert-container.left{left:auto;right:20px}.ng-bento bento-alert.bento-alert-inline .alert-container{z-index:auto;display:block;position:relative;top:auto;left:auto;width:100%;min-width:0;transform:none;-ms-transform:none;-webkit-transform:none}@media (min-width: 1200px){.ng-bento bento-alert .alert-container{width:40%}}@media (min-width: 992px) and (max-width: 1199px){.ng-bento bento-alert .alert-container{width:55%}}@media (min-width: 768px) and (max-width: 991px){.ng-bento bento-alert .alert-container{width:75%}}@media (max-width: 767px){.ng-bento bento-alert .alert-container{width:80%}}.ng-bento bento-alert .bento-alert-container{display:block;transition:.2s linear all}.ng-bento bento-alert .bento-alert-container.ng-enter{opacity:0}.ng-bento bento-alert .bento-alert-container.ng-enter.ng-enter-active{opacity:1}.ng-bento bento-alert .bento-alert-container.ng-leave{overflow:hidden;opacity:1}.ng-bento bento-alert .bento-alert-container.ng-leave.ng-leave-active{opacity:0}.ng-bento bento-alert .bento-alert-container.ng-leave.ng-leave-active:not(:last-child){height:0!important}\n"] }]
        }], propDecorators: { items: [{
                type: Input
            }], close: [{
                type: Output
            }], inline: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.bento-alert-inline']
            }], grabFocus: [{
                type: Input
            }] } });

class BentoAlertModule extends ConsumerDataValidator {
}
BentoAlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoAlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertModule, declarations: [BentoAlertComponent, BentoAlertItemComponent], imports: [CommonModule, BentoTranslateModule, A11yModule, BentoUtilsModule, BentoFocusMonitorModule], exports: [BentoAlertComponent, BentoAlertItemComponent] });
BentoAlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertModule, imports: [[CommonModule, BentoTranslateModule, A11yModule, BentoUtilsModule, BentoFocusMonitorModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoAlertComponent, BentoAlertItemComponent],
                    imports: [CommonModule, BentoTranslateModule, A11yModule, BentoUtilsModule, BentoFocusMonitorModule],
                    exports: [BentoAlertComponent, BentoAlertItemComponent]
                }]
        }] });

/**
 * A bento version of append to parent
 */
class BentoAppendToDirective {
    /**
     *
     */
    constructor(elementRef, _bentoNotification, r, windowRef, bentoPositioning, logService, dir) {
        this._bentoNotification = _bentoNotification;
        this.r = r;
        this.bentoPositioning = bentoPositioning;
        this.logService = logService;
        this.dir = dir;
        /**
         * Input to get the reference of the container that this element is appended to
         */
        this.bentoAppendTo = false;
        /**
         * Resize width to the reference
         */
        this.reszieWidthToReference = false;
        /**
         * Flag to determin of dropdown auto hides when window scrolls
         */
        this.autoHideOnContainerScroll = true;
        /**
         * Alignment of this element based on its side
         */
        this.alignment = 'left';
        /**
         * Flag to determine if vertical alignment is set to auto
         */
        this.autoVerticalAlignment = true;
        /**
         * Event emitter when the open attribute is changed
         */
        this.openChange = new EventEmitter();
        /**
         * Flag to determine if el is open
         */
        this.isOpen = false;
        /**
         * Variable of side
         */
        this._side = 'bottom';
        this._el = elementRef.nativeElement;
        this.window = windowRef.nativeWindow;
        this.document = windowRef.nativeDocument;
    }
    /**
     * Input to show/hide dropdown
     */
    set open(v) {
        if (v) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    get side() {
        return this._side;
    }
    /**
     * Determine if this is a dropup menu. Default `'bottom'`
     */
    set side(s) {
        const el = this._el;
        this._side = s || 'bottom';
        switch (s) {
            case 'top':
                this.r.addClass(el, 'dropdown-menu-up');
                this.r.removeClass(el, 'dropdown-menu-left');
                this.r.removeClass(el, 'dropdown-menu-right');
                break;
            case 'left':
                this.r.addClass(el, 'dropdown-menu-left');
                this.r.removeClass(el, 'dropdown-menu-top');
                this.r.removeClass(el, 'dropdown-menu-right');
                break;
            case 'right':
                this.r.addClass(el, 'dropdown-menu-right');
                this.r.removeClass(el, 'dropdown-menu-left');
                this.r.removeClass(el, 'dropdown-menu-up');
                break;
            default:
                this.r.removeClass(el, 'dropdown-menu-up');
                this.r.removeClass(el, 'dropdown-menu-left');
                this.r.removeClass(el, 'dropdown-menu-right');
                break;
        }
    }
    /**
     * Logic when the view is initiated
     */
    ngAfterViewInit() {
        // Assign `_appendToEl` reference for appending
        if (!this.bentoAppendTo || this.bentoAppendTo === '') {
            this._appendToEl = null;
            return;
        }
        else if (typeof this.bentoAppendTo === 'string') {
            this._appendToEl = this.document.querySelector(this.bentoAppendTo);
            if (!this._appendToEl) {
                // The original query is not correct
                this.logService.warn(
                // eslint-disable-next-line  @typescript-eslint/quotes
                "BentoAppendTo: HTMLElement '", this.bentoAppendTo, 
                // eslint-disable-next-line  @typescript-eslint/quotes
                "' does not exist. Default to" + ' <BODY>');
                this._appendToEl = this.document.querySelector('body');
            }
            if (!this._appendToEl) {
                this.logService.error('[bentoAppendTo]: Selector', this.bentoAppendTo, 'does not exit in the DOM structure.');
                return;
            }
        }
        else if (this.bentoAppendTo instanceof Element) {
            // This is an ElementRef
            this._appendToEl = this.bentoAppendTo;
        }
        else {
            // This is an ElementRef
            this._appendToEl = this.bentoAppendTo.nativeElement;
        }
        this._nextSibling = this._el.nextElementSibling;
        this._parentEl = this._el.parentElement;
    }
    /**
     * Cleanup
     */
    ngOnDestroy() {
        if (this._onScrollSubscription) {
            this._onScrollSubscription.unsubscribe();
        }
        if (this._onResizeSubscription) {
            this._onResizeSubscription.unsubscribe();
        }
    }
    /**
     * Show component element
     */
    show() {
        if (!this._appendToEl || this.isOpen) {
            return;
        }
        if (!this.referenceTo && this._appendToEl) {
            this.logService.error('[bentoAppendTo]:', 'missing reference element');
            return;
        }
        if (this.autoHideOnContainerScroll) {
            // Add scroll subscription
            this._onScrollSubscription = fromEvent(this.window, 'scroll', { capture: true, once: true }).subscribe((event) => {
                const target = event.target;
                const hostIncluded = target.contains(this.referenceTo);
                const targetIncluded = this._el.contains(target);
                if ((!hostIncluded && !targetIncluded) || (hostIncluded && !targetIncluded)) {
                    // Need to hide dropdown
                    if (target !== this._el) {
                        this.hide();
                        this.openChange.emit(false);
                    }
                }
            });
        }
        // Add resize subscription
        this._onResizeSubscription = this._bentoNotification.resizeNotification.subscribe(() => {
            // Need to hide dropdown when some where of the screen is resized
            this.hide();
            this.openChange.emit(false);
        });
        const refEl = this.getReference();
        if (this.reszieWidthToReference) {
            this.r.setStyle(this._el, 'width', refEl.offsetWidth + 'px');
            this.r.setStyle(this._el, 'min-width', refEl.offsetWidth + 'px');
        }
        this.r.addClass(this._el, 'bento-append-to');
        this.positionElement();
        if (this.reszieWidthToReference) {
            // There can be a new scroll bar that alters the width of the reference element
            setTimeout(() => {
                this.r.setStyle(this._el, 'width', refEl.offsetWidth + 'px');
                this.r.setStyle(this._el, 'min-width', refEl.offsetWidth + 'px');
            });
        }
        this.isOpen = true;
    }
    /**
     * Hide component element
     */
    hide() {
        if (!this._appendToEl || !this.isOpen) {
            return;
        }
        if (!this.referenceTo && this._appendToEl) {
            this.logService.error('[bentoAppendTo]:', 'missing reference element');
            return;
        }
        // Clean subscriptions
        if (this._onResizeSubscription) {
            this._onResizeSubscription.unsubscribe();
        }
        if (this._onScrollSubscription) {
            this._onScrollSubscription.unsubscribe();
        }
        this._onResizeSubscription = null;
        this._onScrollSubscription = null;
        if (this._nextSibling) {
            this.r.insertBefore(this._parentEl, this._el, this._nextSibling);
        }
        else {
            this.r.appendChild(this._parentEl, this._el);
        }
        this.r.removeClass(this._el, 'bento-append-to');
        this.bentoPositioning.resetPosition(this.r, this._el);
        this.isOpen = false;
    }
    /**
     * Position component element to the designated HTMLElement
     */
    positionElement() {
        const referenceEl = this.getReference();
        let side = this.side;
        const referenceElRect = referenceEl.getBoundingClientRect();
        const viewportHeight = Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0);
        const bottom = viewportHeight - referenceElRect.bottom;
        let alignment = this.alignment;
        if (this.dir.value === 'rtl') {
            // Swap left and right when app is in RTL mode
            if (alignment === 'left') {
                alignment = 'right';
            }
            else if (alignment === 'right') {
                alignment = 'left';
            }
        }
        if (this.autoVerticalAlignment) {
            if (side === 'bottom' && bottom < this._el.offsetHeight && referenceElRect.top >= this._el.offsetHeight) {
                // Automatically invert side from bottom to top when there is not enough space under
                // the reference
                side = 'top';
            }
            else if (side === 'top' && referenceElRect.top < this._el.offsetHeight && bottom >= this._el.offsetHeight) {
                // Automatically invert side from top to bottom when there is not enough space above
                // the reference
                side = 'bottom';
            }
        }
        this.r.removeClass(this._el, 'top');
        this.r.removeClass(this._el, 'bottom');
        this.r.removeClass(this._el, 'left');
        this.r.removeClass(this._el, 'right');
        this.r.addClass(this._el, side);
        this.bentoPositioning.positionElement(this.r, this.getReference(), this._el, this._appendToEl, side, alignment, -1);
    }
    /**
     * Get HTMLElement from the reference element
     */
    getReference() {
        return this.referenceTo.nativeElement
            ? this.referenceTo.nativeElement
            : this.referenceTo;
    }
}
BentoAppendToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAppendToDirective, deps: [{ token: i0.ElementRef }, { token: BentoNotification }, { token: i0.Renderer2 }, { token: WindowRef }, { token: BentoPositioning }, { token: BentoLogService }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Directive });
BentoAppendToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoAppendToDirective, selector: "[bentoAppendTo]:not(.dropdown-menu)", inputs: { bentoAppendTo: "bentoAppendTo", referenceTo: "referenceTo", reszieWidthToReference: "reszieWidthToReference", autoHideOnContainerScroll: "autoHideOnContainerScroll", alignment: "alignment", autoVerticalAlignment: "autoVerticalAlignment", open: "open", side: "side" }, outputs: { openChange: "openChange" }, providers: [BentoNotification], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAppendToDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoAppendTo]:not(.dropdown-menu)',
                    providers: [BentoNotification]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoNotification }, { type: i0.Renderer2 }, { type: WindowRef }, { type: BentoPositioning }, { type: BentoLogService }, { type: i2.Directionality }]; }, propDecorators: { bentoAppendTo: [{
                type: Input
            }], referenceTo: [{
                type: Input
            }], reszieWidthToReference: [{
                type: Input
            }], autoHideOnContainerScroll: [{
                type: Input
            }], alignment: [{
                type: Input
            }], autoVerticalAlignment: [{
                type: Input
            }], openChange: [{
                type: Output
            }], open: [{
                type: Input
            }], side: [{
                type: Input
            }] } });

/**
 * Similar to `BentoAppendToDirective` this directive supports `NgbDropdown` components
 */
class BentoNgbDropdownAppendToDirective extends BentoAppendToDirective {
    /**
     */
    constructor(elementRef, _ngbDropdown, _bentoNotification, r, windowRef, bentoPositioning, logService, dir) {
        super(elementRef, _bentoNotification, r, windowRef, bentoPositioning, logService, dir);
        this._ngbDropdown = _ngbDropdown;
        this._bentoNotification = _bentoNotification;
        this.r = r;
        this.logService = logService;
        this.dir = dir;
        /**
         * Flag to determine if the dropdown should be horizontally auto re-aligned
         */
        this.autoRealign = false;
        /**
         * Offset for the dropdow for fine tuning
         */
        this.offset = 0;
        /**
         * Subscription on the _ngbDropdown change
         */
        this._onNgbChangeSubscription = Subscription.EMPTY;
    }
    /**
     * Init code
     */
    ngOnInit() {
        this._onNgbChangeSubscription = this._ngbDropdown.openChange.subscribe(isOpen => {
            this._onDropdownChange(isOpen);
        });
        // Since v4.1.0 NgbDropdown._positionMenu interferes our positionElement() method
        // We need to override it with not doing anything
        this._ngbDropdown['_positionMenu'] = () => { };
    }
    /**
     * Logic when component view is initiated
     */
    ngAfterViewInit() {
        this.referenceTo = this._findNgbToggle();
        super.ngAfterViewInit();
    }
    /**
     * Destroy code
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this._onNgbChangeSubscription.unsubscribe();
    }
    /**
     * Extend the hide method from super class
     */
    hide() {
        super.hide();
        const placement = this._ngbDropdown.placement;
        this._ngbDropdown.close();
        if (placement.indexOf('top') > -1) {
            this.r.addClass(this._el, 'dropdown-menu-up');
        }
        else {
            this.r.removeClass(this._el, 'dropdown-menu-up');
        }
        if (this.autoRealign) {
            // Need to reset width when auto relaign is applied
            BentoPositioning.resetWidth(this.r, this._el);
        }
        this.isOpen = false;
    }
    /**
     * Position component element to the designated HTMLElement
     */
    positionElement() {
        const referenceTo = this.referenceTo.nativeElement
            ? this.referenceTo.nativeElement
            : this.referenceTo;
        let alignment = 'center';
        const referenceEl = this.getReference();
        const placement = this._ngbDropdown.placement;
        let side = placement.indexOf('top') > -1 ? 'top' : 'bottom';
        const referenceElRect = referenceEl.getBoundingClientRect();
        const viewportHeight = Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0);
        const styles = this.window.getComputedStyle(this._el);
        const bottom = viewportHeight - referenceElRect.bottom;
        const isRTL = this.dir.value === 'rtl';
        // Horizontal Alignment
        if (placement.indexOf('right') > -1) {
            alignment = isRTL ? 'left' : 'right';
        }
        else if (placement.indexOf('left') > -1) {
            alignment = isRTL ? 'right' : 'left';
        }
        if (this.autoVerticalAlignment) {
            // Top & Bottom
            if (side === 'bottom' && bottom < this._el.offsetHeight && referenceElRect.top >= this._el.offsetHeight) {
                // Automatically invert side from bottom to top when there is not enough space under
                // the reference
                side = 'top';
            }
            if (side === 'top' && referenceElRect.top < this._el.offsetHeight && bottom >= this._el.offsetHeight) {
                // Automatically invert side from top to bottom when there is not enough space above
                // the reference
                side = 'bottom';
            }
        }
        // When offset is set through CSS
        // we need to know what the offset is
        let calculatedOffSet;
        if (side === 'bottom' && styles.marginTop !== '0px') {
            calculatedOffSet = parseFloat(styles.marginTop.replace('px', ''));
        }
        else if (side === 'top' && styles.marginBottom !== '0px') {
            calculatedOffSet = parseFloat(styles.marginBottom.replace('px', ''));
        }
        // Update host CSS class
        if (side === 'bottom') {
            this.r.removeClass(this._el, 'dropdown-menu-up');
        }
        else {
            this.r.addClass(this._el, 'dropdown-menu-up');
        }
        this.bentoPositioning.positionElement(this.r, referenceTo, this._el, this._appendToEl, side, alignment, this.offset || calculatedOffSet, this.autoRealign);
    }
    /**
     * Callback when the dropdown toggle is updated
     */
    _onDropdownChange(isOpen) {
        if (isOpen && !this.isOpen) {
            this.show();
        }
        else if (this.isOpen) {
            this.hide();
        }
    }
    /**
     * Look for the toggle that belongs to this dropdown menu
     */
    _findNgbToggle() {
        const ngbDropdownEl = this._findNgbDropdownEl();
        if (!ngbDropdownEl) {
            this.logService.warn('[bentoAppendTo]:', '[NgbDropdown] is undefined');
            return;
        }
        return ngbDropdownEl.querySelector('[NgbDropdownToggle]');
    }
    /**
     * Look for NgbDropdown main HTMLElement
     */
    _findNgbDropdownEl(el = this._el) {
        if (el.nodeName === 'BODY') {
            return false;
        }
        else if (el.hasAttribute('ngbDropdown')) {
            return el;
        }
        else {
            return this._findNgbDropdownEl(el.parentElement);
        }
    }
}
BentoNgbDropdownAppendToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAppendToDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.NgbDropdown }, { token: BentoNotification }, { token: i0.Renderer2 }, { token: WindowRef }, { token: BentoPositioning }, { token: BentoLogService }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Directive });
BentoNgbDropdownAppendToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoNgbDropdownAppendToDirective, selector: "[bentoAppendTo].dropdown-menu, bento-megamenu[bentoAppendTo]", inputs: { bentoAppendTo: "bentoAppendTo", autoRealign: "autoRealign", offset: "offset" }, providers: [BentoNotification], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAppendToDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoAppendTo].dropdown-menu, bento-megamenu[bentoAppendTo]',
                    providers: [BentoNotification]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.NgbDropdown }, { type: BentoNotification }, { type: i0.Renderer2 }, { type: WindowRef }, { type: BentoPositioning }, { type: BentoLogService }, { type: i2.Directionality }]; }, propDecorators: { bentoAppendTo: [{
                type: Input
            }], autoRealign: [{
                type: Input
            }], offset: [{
                type: Input
            }] } });

class BentoAppendToModule extends ConsumerDataValidator {
}
BentoAppendToModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAppendToModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoAppendToModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAppendToModule, declarations: [BentoAppendToDirective, BentoNgbDropdownAppendToDirective], imports: [BentoUtilsModule], exports: [BentoAppendToDirective, BentoNgbDropdownAppendToDirective] });
BentoAppendToModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAppendToModule, imports: [[BentoUtilsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoAppendToModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoAppendToDirective, BentoNgbDropdownAppendToDirective],
                    imports: [BentoUtilsModule],
                    exports: [BentoAppendToDirective, BentoNgbDropdownAppendToDirective]
                }]
        }] });

/* eslint-disable  @angular-eslint/component-selector */
class BentoBadgeComponent {
    constructor() { }
    ngOnInit() { }
}
BentoBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BentoBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoBadgeComponent, selector: "a.badge", ngImport: i0, template: "<span>\n  <ng-content></ng-content>\n</span>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a.badge', template: "<span>\n  <ng-content></ng-content>\n</span>\n" }]
        }], ctorParameters: function () { return []; } });

class BentoBadgeModule extends ConsumerDataValidator {
}
BentoBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBadgeModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBadgeModule, declarations: [BentoBadgeComponent], imports: [CommonModule], exports: [BentoBadgeComponent] });
BentoBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBadgeModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoBadgeComponent],
                    imports: [CommonModule],
                    exports: [BentoBadgeComponent],
                    providers: []
                }]
        }] });

// The variable at the module level ensure that the string will be allocated only once
const svgCode = `
<svg class="bento-busyloader-svg" preserveAspectRatio="none" viewBox="0 0 75 75">
  <path d="M39.331 67.444a30 30 0 0018.048-7.475"/>
  <path d="M59.969 57.379a30 30 0 007.475-18.048"/>
  <path d="M67.444 35.669a30 30 0 00-7.475-18.048"/>
  <path d="M57.379 15.031A30 30 0 0039.33 7.556"/>
  <path d="M35.669 7.556a30 30 0 00-18.048 7.475"/>
  <path d="M15.031 17.621A30 30 0 007.556 35.67"/>
  <path d="M7.556 39.331a30 30 0 007.475 18.048"/>
  <path d="M17.621 59.969a30 30 0 0018.048 7.475"/>
</svg>`;
/**
 * This creates a DOM Node that is not attached to the document to create a template that the busy loader will use.
 * Using a template ensures that the strings with HTML and SVG code are
 * being parsed only once into the whole application saving time when the loader is mounted and unmounted.
 * `loaderTemplate` should never be used directly to avoid memory references between busy loader,
 * it should always be consumed with document.importNode(loaderTemplate, true);
 */
let loaderTemplate;
function getLoaderTemplate(r) {
    if (loaderTemplate === undefined) {
        loaderTemplate = r.createElement('div');
        r.addClass(loaderTemplate, 'bento-busyloader-blocker');
        r.setProperty(loaderTemplate, 'innerHTML', `<div class="bento-busyloader-wrapper">
      <div class="bento-busyloader-inner">
        ${svgCode}
      </div>
    </div>`);
    }
    return loaderTemplate;
}
class BusyLoader {
    /**
     *
     */
    constructor(dom, r, windowRef) {
        this.r = r;
        this.isPositionedStatic = false;
        this.document = windowRef.nativeDocument;
        this.window = windowRef.nativeWindow;
        this.mainDom = typeof dom === 'string' ? this.document.querySelector(dom) : dom;
        this.tabbingBlocker = this.tabbingBlocker.bind(this);
    }
    /**
     * Show and insert loader into DOM
     */
    show(delay, size) {
        this.clearTimeout();
        this.showTimeoutID = setTimeout(() => {
            if (!this.loader) {
                this.init(size);
            }
            const firstChild = this.mainDom.children[0];
            // Adding loader
            this.r.appendChild(this.mainDom, this.loader);
            this.r.insertBefore(this.mainDom, this.blocker, firstChild);
            try {
                // Make parent container 'relative' when it is static
                const mainDomPosition = this.window.getComputedStyle(this.mainDom).position;
                // Check and assign `relative` position where it is at default, `static`
                if (mainDomPosition.length === 0 || mainDomPosition === 'static') {
                    this.r.setStyle(this.mainDom, 'position', 'relative');
                    this.isPositionedStatic = true;
                }
            }
            catch (e) {
                // Running in SSR mode
            }
            // svg render disabled
            this.startAnimate();
            /*
              Gain focus if necessary and
              ONLY gains focus when this loader is an overlay
              */
            this.activeElement = this.document.activeElement;
            if (this.mainDom.contains(this.activeElement) && this.mainDom !== this.activeElement) {
                this.loader.focus();
            }
            else {
                this.activeElement = undefined;
            }
            // Callback
            if (this.onBusyLoaderChange) {
                this.onBusyLoaderChange(true);
            }
        }, delay);
    }
    /**
     * Hide loader from DOM
     */
    hide(delay) {
        this.clearTimeout();
        // Loader is not ready
        if (!this.loader) {
            return;
        }
        this.hideTimeoutID = setTimeout(() => {
            // Put static positioning back
            if (this.isPositionedStatic) {
                this.r.removeStyle(this.mainDom, 'position');
            }
            this.stopAnimate();
            /*
            Return focus if necessary
            */
            if (this.activeElement &&
                (this.document.activeElement === this.loader || this.document.activeElement === this.blocker)) {
                this.activeElement.focus();
            }
            this.r.removeChild(this.loader.parentElement, this.loader);
            this.r.removeChild(this.blocker.parentElement, this.blocker);
            this.loader.removeEventListener('keydown', this.tabbingBlocker);
            this.blocker.removeEventListener('keydown', this.tabbingBlocker);
            // clear memory and who knows when this loader is going to be called again
            this.loader = null;
            this.blocker = null;
            // Callback
            if (this.onBusyLoaderChange) {
                this.onBusyLoaderChange(false);
            }
        }, delay);
    }
    /**
     * Initialize loader
     */
    init(size = 'md') {
        // Create loader dom elements
        const template = getLoaderTemplate(this.r);
        this.loader = this.document.importNode(template, true);
        const svg = this.loader.querySelector('svg');
        this.r.addClass(svg, `bento-busyloader-svg-${size}`);
        this.blocker = this.r.createElement('div');
        this.r.setAttribute(this.blocker, 'tabindex', '0');
        this.r.addClass(this.blocker, 'bento-busyloader-front-blocker');
        // SR Support
        /*applySR();
          function applySR() {
          $bentoTranslate.translate('BENTO_UI_BUSY_LOADER_LOADING')
          .then(function (value) {
          loader.attr('aria-label', value);
          blocker.attr('aria-label', value);
          });
          }*/
        /*$bentoTranslate.onChange(applySR);
          loader.on('$destroy', function () {
          $bentoTranslate.removeOnChange(applySR);
          });*/
        // Add event listeners
        this.loader.addEventListener('keydown', this.tabbingBlocker);
        this.blocker.addEventListener('keydown', this.tabbingBlocker);
    }
    tabbingBlocker(event) {
        // Bypass the content from tabbing
        if (!event.shiftKey && event.keyCode === 9) {
            this.loader.focus();
        }
    }
    /**
     * Clear any previous timeout IDs
     */
    clearTimeout() {
        if (this.showTimeoutID) {
            clearTimeout(this.showTimeoutID);
        }
        if (this.hideTimeoutID) {
            clearTimeout(this.hideTimeoutID);
        }
    }
    // svg spinner animation code
    // rFA is used for animation part to minimize CPU load
    /**
     * Start animation
     */
    startAnimate() {
        this.r.addClass(this.loader, 'bento-play');
    }
    /**
     * Stop animation
     */
    stopAnimate() {
        this.r.removeClass(this.loader, 'bento-play');
    }
}

/**
 * The Busy Loader is a "take-over" DOM blocker displaying a spinner to signify an unavailable, waiting state.
 * This helps applications to block user interaction during the processing of background data,
 * avoiding front-end interruption.
 */
class BentoBusyLoaderDirective {
    /**
     */
    constructor(elementRef, r, windowRef, translate, sanitizer) {
        this.r = r;
        this.translate = translate;
        this.sanitizer = sanitizer;
        this.baseClass = false;
        /**
         * Defines the size of the busyloader
         * * `'sm'` - Small with eight segments
         * * `'md'` - Medium with eight segments
         * * `'lg'` - Large with eight segments
         */
        this.size = 'md';
        /**
         * Delay in milliseconds to show the busyloader
         */
        this.showDelay = 0;
        /**
         * Delay in milliseconds to hide the busyloader
         */
        this.hideDelay = 0;
        /**
         * Event emitter to notify when loader becomes visible
         */
        this.show = new EventEmitter();
        /**
         * Event emitter to notify when loader hides
         */
        this.hide = new EventEmitter();
        /**
         * Flag to show if this directive view is ready
         */
        this.viewReady = false;
        /**
         * Should show busyloader when this directive is ready
         */
        this.shouldShowWhenReady = false;
        /**
         * Timeout ID from the previous timeout
         */
        this.timeoutID = 0;
        this.el = elementRef.nativeElement;
        this._busyLoader = new BusyLoader(this.el, r, windowRef);
        this._busyLoader.onBusyLoaderChange = (show) => {
            show ? this.show.emit() : this.hide.emit();
        };
        // <div class="sr-only" aria-live="assertive">
        //   loading
        // </div>
        this.srEl = r.createElement('div');
        r.setAttribute(this.srEl, 'class', 'sr-only');
        r.setAttribute(this.srEl, 'aria-live', 'assertive');
        r.setProperty(this.srEl, 'innerHTML', '');
    }
    /**
     * Main flag to show/hide this busyloader
     */
    set bentoBusyLoader(val) {
        if (this.viewReady) {
            // Only show when main view is ready
            this.showBusyLoader(val).catch(console.error);
            this.baseClass = false;
        }
        else {
            // This directive view is not ready, will put in an order to show
            // when view is ready
            this.shouldShowWhenReady = val;
        }
    }
    /**
     * Implements AfterViewInit interface methods
     */
    ngAfterViewInit() {
        this.viewReady = true;
        this.r.appendChild(this.el.parentElement, this.srEl);
        if (this.shouldShowWhenReady) {
            // Order is in already!!
            this.showBusyLoader(true).catch(console.error);
        }
    }
    ngOnDestroy() {
        this._busyLoader.hide(0);
        this._busyLoader = null;
        if (this.srEl.parentElement) {
            // Remove screen reader help element
            this.r.removeChild(this.srEl.parentElement, this.srEl);
        }
        clearTimeout(this.timeoutID);
    }
    /**
     * Show/Hide BusyLoader
     */
    showBusyLoader(show) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const el = this.el;
            const tagName = el.tagName.toLowerCase();
            if (['bento-toolbar', 'button'].includes(tagName) || ((_a = el.classList) === null || _a === void 0 ? void 0 : _a.contains('btn'))) {
                this.size = 'sm';
            }
            clearTimeout(this.timeoutID);
            let translationLabel = '';
            if (show) {
                translationLabel = 'BENTO_UI_BUSY_LOADER_LOADING';
                this._busyLoader.show(this.showDelay, this.size);
                yield this.show.pipe(take(1)).toPromise();
                this.el.classList.add('bento-is-busy');
            }
            else {
                translationLabel = 'BENTO_UI_BUSY_LOADER_LOADED';
                this._busyLoader.hide(this.hideDelay);
                this.el.classList.remove('bento-is-busy');
                yield this.hide.pipe(take(1)).toPromise();
            }
            this.r.setProperty(this.srEl, 'innerHTML', this.sanitizer.sanitize(SecurityContext.HTML, this.translate.instantTranslate(translationLabel)));
        });
    }
}
BentoBusyLoaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBusyLoaderDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: WindowRef }, { token: BentoTranslate }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive });
BentoBusyLoaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: { bentoBusyLoader: "bentoBusyLoader", size: "size", showDelay: "showDelay", hideDelay: "hideDelay" }, outputs: { show: "show", hide: "hide" }, providers: [BentoTranslate], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBusyLoaderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[bentoBusyLoader]', providers: [BentoTranslate] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: WindowRef }, { type: BentoTranslate }, { type: i1$2.DomSanitizer }]; }, propDecorators: { bentoBusyLoader: [{
                type: Input
            }], size: [{
                type: Input
            }], showDelay: [{
                type: Input
            }], hideDelay: [{
                type: Input
            }], show: [{
                type: Output
            }], hide: [{
                type: Output
            }] } });

class BentoBusyLoaderModule extends ConsumerDataValidator {
}
BentoBusyLoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBusyLoaderModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoBusyLoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBusyLoaderModule, declarations: [BentoBusyLoaderDirective], imports: [BentoUtilsModule], exports: [BentoBusyLoaderDirective] });
BentoBusyLoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBusyLoaderModule, imports: [[BentoUtilsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoBusyLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoBusyLoaderDirective],
                    imports: [BentoUtilsModule],
                    exports: [BentoBusyLoaderDirective]
                }]
        }] });

const BENTO_CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoCheckboxComponent),
    multi: true
};
/**
 * This "tri-state" Checkbox is a new component that doesn't have a predecessor in Bento.UI 1.x.
 * Use this wherever you need to support both the "indeterminate" state, and the Bento checkbox style seen in FlexGrid.
 */
class BentoCheckboxComponent {
    constructor(elRef, r, changeDetector, focusMonitor) {
        this.elRef = elRef;
        this.r = r;
        this.changeDetector = changeDetector;
        this.focusMonitor = focusMonitor;
        /**
         * Callback when indeterminate state is changed
         */
        this.indeterminateChange = new EventEmitter();
        this.iconOptions = { checked: 'bui-checkbox-checked', indeterminate: 'bui-checkbox-indeterminate' };
        this._value = false;
        this.onTouchedCallback = () => { };
        this.onChangeCallback = (_) => { };
    }
    /**
     * Set checkbox's indeterminate state
     */
    set indeterminate(v) {
        if (!this._indeterminate === !v) {
            return;
        }
        this._indeterminate = v;
        this.updateIconClass();
    }
    get indeterminate() {
        return this._indeterminate;
    }
    /**
     * Implements ControlValueAccessor
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * From ControlValueAccessor interface
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = () => {
            fn();
            this.changeDetector.markForCheck();
        };
    }
    /**
     * NgModel setter
     */
    writeValue(v) {
        this.value = v;
        /* In case one of the parent components is using ChangeDetectoionStarategy.OnPush */
        this.changeDetector.markForCheck();
    }
    /**
     * Set Disabled state for ngModel
     */
    setDisabledState(v) {
        this._disabled = v;
        this.updateIconClass();
        /* In case one of the parent components is using ChangeDetectoionStarategy.OnPush */
        this.changeDetector.markForCheck();
    }
    /**
     * Class value setter
     */
    set value(v) {
        this._value = v;
        this.updateIconClass();
    }
    /**
     * Class value getter
     */
    get value() {
        return this._value;
    }
    ngAfterViewInit() {
        this.updateIconClass();
        const attributes = ['id', 'role', 'aria-describedby', 'aria-labeledby', 'aria-label', 'tabindex'];
        this.focusMonitor.monitor(this.elRef.nativeElement, true);
        attributes.forEach(attribute => {
            const property = this.elRef.nativeElement.getAttribute(attribute);
            if (property && property.length) {
                // Pass the aria tag to the actual checkbox
                this.r.setAttribute(this.cbRef.nativeElement, attribute, property);
                this.r.removeAttribute(this.elRef.nativeElement, attribute);
            }
        });
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.elRef.nativeElement);
        this.changeDetector.detach();
    }
    /**
     * On checkbox click
     */
    onCheckBoxChange(value) {
        this._indeterminate = false;
        this.indeterminateChange.emit(false);
        // gain focus to the component
        this.elRef.nativeElement.focus();
        this.value = value;
        this.onChangeCallback(value);
    }
    /**
     * On checkbox blur
     */
    onCheckboxBlur(e) {
        this.onTouchedCallback();
    }
    /**
     * Update icon HTML view
     */
    updateIconClass() {
        const el = this.iconRef.nativeElement;
        const iconOptions = this.iconOptions;
        if (this._indeterminate) {
            this.r.removeClass(el, iconOptions.checked);
            this.r.addClass(el, this.iconOptions.indeterminate);
        }
        else {
            this.r.removeClass(el, this.iconOptions.indeterminate);
            if (this._value) {
                this.r.addClass(el, iconOptions.checked);
            }
        }
        if (this._disabled) {
            this.r.addClass(el, 'disabled');
            this.r.addClass(this.elRef.nativeElement, 'disabled');
        }
        else {
            this.r.removeClass(el, 'disabled');
            this.r.removeClass(this.elRef.nativeElement, 'disabled');
        }
    }
}
BentoCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoCheckboxComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i3.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component });
BentoCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoCheckboxComponent, selector: "bento-checkbox", inputs: { indeterminate: "indeterminate" }, outputs: { indeterminateChange: "indeterminateChange" }, providers: [BENTO_CHECKBOX_VALUE_ACCESSOR], viewQueries: [{ propertyName: "cbRef", first: true, predicate: ["checkbox"], descendants: true, static: true }, { propertyName: "iconRef", first: true, predicate: ["icon"], descendants: true, static: true }], ngImport: i0, template: "<input\n  #checkbox\n  [ngModel]=\"value\"\n  (ngModelChange)=\"onCheckBoxChange($event)\"\n  type=\"checkbox\"\n  (blur)=\"onCheckboxBlur($event)\"\n  [disabled]=\"_disabled\"\n  [attr.aria-checked]=\"_indeterminate ? 'mixed' : value\"\n  [attr.aria-disabled]=\"_disabled\"\n/>\n<i class=\"bui-checkbox-unchecked\" aria-hidden=\"true\"></i>\n<i #icon aria-hidden=\"true\"></i>\n", styles: [".ng-bento bento-checkbox{display:inline-block;background:white;position:relative;font-size:14px;height:1em;width:1em;line-height:1em;margin-right:7px;vertical-align:text-bottom}.ng-bento bento-checkbox.disabled{pointer-events:none}[dir=rtl] .ng-bento bento-checkbox{margin-left:7px;margin-right:0}.ng-bento bento-checkbox i{direction:ltr;font-size:1em;height:14px;left:0;line-height:14px;margin:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:background-color .2s,border-color .1s;width:0}.ng-bento bento-checkbox i.bui-checkbox-unchecked{width:14px}.ng-bento bento-checkbox i:before{display:block;height:14px;width:14px;text-align:center}.ng-bento bento-checkbox [aria-checked=true]~i.bui-checkbox-checked,.ng-bento bento-checkbox [aria-checked=true]~i.bui-checkbox-indeterminate,.ng-bento bento-checkbox [aria-checked=mixed]~i.bui-checkbox-checked,.ng-bento bento-checkbox [aria-checked=mixed]~i.bui-checkbox-indeterminate{transition:width .4s;width:14px}.ng-bento bento-checkbox input{height:1em;left:0;opacity:0;position:absolute;top:0;width:1em;z-index:1}[dir=rtl] .ng-bento bento-checkbox input{left:auto;right:0}\n"], directives: [{ type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-checkbox', providers: [BENTO_CHECKBOX_VALUE_ACCESSOR], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<input\n  #checkbox\n  [ngModel]=\"value\"\n  (ngModelChange)=\"onCheckBoxChange($event)\"\n  type=\"checkbox\"\n  (blur)=\"onCheckboxBlur($event)\"\n  [disabled]=\"_disabled\"\n  [attr.aria-checked]=\"_indeterminate ? 'mixed' : value\"\n  [attr.aria-disabled]=\"_disabled\"\n/>\n<i class=\"bui-checkbox-unchecked\" aria-hidden=\"true\"></i>\n<i #icon aria-hidden=\"true\"></i>\n", styles: [".ng-bento bento-checkbox{display:inline-block;background:white;position:relative;font-size:14px;height:1em;width:1em;line-height:1em;margin-right:7px;vertical-align:text-bottom}.ng-bento bento-checkbox.disabled{pointer-events:none}[dir=rtl] .ng-bento bento-checkbox{margin-left:7px;margin-right:0}.ng-bento bento-checkbox i{direction:ltr;font-size:1em;height:14px;left:0;line-height:14px;margin:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:background-color .2s,border-color .1s;width:0}.ng-bento bento-checkbox i.bui-checkbox-unchecked{width:14px}.ng-bento bento-checkbox i:before{display:block;height:14px;width:14px;text-align:center}.ng-bento bento-checkbox [aria-checked=true]~i.bui-checkbox-checked,.ng-bento bento-checkbox [aria-checked=true]~i.bui-checkbox-indeterminate,.ng-bento bento-checkbox [aria-checked=mixed]~i.bui-checkbox-checked,.ng-bento bento-checkbox [aria-checked=mixed]~i.bui-checkbox-indeterminate{transition:width .4s;width:14px}.ng-bento bento-checkbox input{height:1em;left:0;opacity:0;position:absolute;top:0;width:1em;z-index:1}[dir=rtl] .ng-bento bento-checkbox input{left:auto;right:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i3.FocusMonitor }]; }, propDecorators: { indeterminate: [{
                type: Input
            }], indeterminateChange: [{
                type: Output
            }], cbRef: [{
                type: ViewChild,
                args: ['checkbox', { static: true }]
            }], iconRef: [{
                type: ViewChild,
                args: ['icon', { static: true }]
            }] } });

class BentoCheckboxModule extends ConsumerDataValidator {
}
BentoCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoCheckboxModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoCheckboxModule, declarations: [BentoCheckboxComponent], imports: [CommonModule, FormsModule], exports: [BentoCheckboxComponent] });
BentoCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoCheckboxModule, imports: [[CommonModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [BentoCheckboxComponent],
                    exports: [BentoCheckboxComponent]
                }]
        }] });

/**
 * This Class is designed to be extended to stream data without constant detection cycle checks
 */
class BentoListSubscribable {
    constructor() {
        /**
         * Main data
         */
        this._data = [];
        /**
         * Event Emitter when this class is ready
         */
        this.ready = new EventEmitter();
    }
    /**
     * Used when view is initialized
     */
    ngAfterViewInit() {
        setTimeout(() => {
            this.ready.emit();
        }, 100);
    }
    /**
     * Logic to control data
     */
    _setDataObservable(observable) {
        // Reset the main data array
        this._data = [];
        if (this._dataSubscription) {
            // Un-subscribe the previous data stream subscription
            // and reset data before the new subscription starts
            this._dataSubscription.unsubscribe();
        }
        // Declare first initial data stream subscription
        // Fire interface callback
        this._onDataReload(this._data);
        if (observable) {
            // Subscribe the recurrent subscription
            this._subscribeDataUpdate(observable);
        }
    }
    /**
     * Subscribe to when data is on update
     */
    _subscribeDataUpdate(observable) {
        this._dataSubscription = observable.subscribe(value => {
            if (!value || !Array.isArray(value)) {
                // Invalid data type for `value`
                this._dataSubscription.unsubscribe();
                throw new Error('[dataObservable]: Invalid data type.  Must be [Array<any>]');
            }
            // Append the new data to the end of the
            // main data
            this._updateData(value);
            // Fire interface update callback
            this._onDataUpdate(this._data);
        });
    }
    /**
     * Method to update data
     */
    _updateData(data) {
        this._data = data;
    }
    /**
     * handle data updates
     */
    _onDataUpdate(data) {
        // To be overridden
    }
    /**
     * Callback to when data is reloaded
     */
    _onDataReload(data) {
        // to be overridden
    }
}
BentoListSubscribable.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListSubscribable, deps: [], target: i0.ɵɵFactoryTarget.Component });
BentoListSubscribable.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoListSubscribable, selector: "ng-component", outputs: { ready: "ready" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListSubscribable, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], propDecorators: { ready: [{
                type: Output
            }] } });

/**
 * Default variables for the width and height of this element
 */
const DEFAULT_LIST_WIDTH = 300;
const DEFAULT_LIST_HEIGHT = 300;
const DEFAULT_ROW_HEIGHT = 30;
const DEFAULT_LIST_MAX_HEIGHT = Number.POSITIVE_INFINITY;
class BentoListComponent extends BentoListSubscribable {
    constructor(r, elRef, changeDetector) {
        super();
        this.r = r;
        this.changeDetector = changeDetector;
        this.autoHeightResize = false;
        this.minWidth = 0;
        this.endOfScroll = new EventEmitter();
        this.heightChange = new EventEmitter();
        this.scrollBarChange = new EventEmitter();
        this.itemHeight = DEFAULT_ROW_HEIGHT;
        this.lastRenderedEnd = 0;
        this.el = elRef.nativeElement;
        this.onElementScroll = this.onElementScroll.bind(this);
    }
    set width(v) { }
    set height(v) {
        this._height = v || DEFAULT_LIST_HEIGHT;
        this.r.setStyle(this.el, 'height', this._height + 'px');
        this.vScroll.checkViewportSize();
    }
    set dataObservable(observable) {
        this._setDataObservable(observable);
    }
    set maxHeight(v) {
        this._maxHeight = v || DEFAULT_LIST_MAX_HEIGHT;
    }
    /**
     * Row height that is used here (default: 30px)
     */
    set _itemHeight(h) {
        // Make sure that there is no `undefined` for `h`
        this.itemHeight = h || DEFAULT_ROW_HEIGHT;
    }
    ngOnInit() {
        // Use custom template if available
        this.rowTemp = this.customRowTemp || this.defaultRowTemp;
        // Scroll Listener
        this.vScroll.elementScrolled().subscribe(this.onElementScroll);
        this.listEl = this.vScroll.getElementRef().nativeElement;
    }
    ngOnDestroy() {
        clearTimeout(this.timeoutID);
    }
    trackByFn(index, item) {
        return index;
    }
    getScrollTop() {
        return this.vScroll.getViewportSize();
    }
    scrollToRow(row) {
        this.vScroll.scrollToIndex(this._data.indexOf(row));
    }
    checkViewportSize() {
        this.vScroll.checkViewportSize();
    }
    getRowRangeInView() {
        const scrollTop = this.vScroll.measureScrollOffset('top');
        const height = this.vScroll.getViewportSize();
        const start = Math.ceil(scrollTop / this.itemHeight);
        const end = Math.floor((scrollTop + height) / this.itemHeight);
        return { from: start, to: end };
    }
    scrollToRowIndex(index) {
        this.vScroll.scrollToIndex(index);
    }
    /**
     * Make a row visible in the scroll pane
     */
    showRow(row) {
        this.showRowIndex(this._data.indexOf(row));
    }
    /**
     * Make a row visible in thescroll pane by its index
     */
    showRowIndex(index) {
        const rowOffsetTop = index * this.itemHeight;
        const listHeight = this.listEl.offsetHeight;
        const scrollTop = this.listEl.scrollTop;
        if (rowOffsetTop + this.itemHeight > listHeight + scrollTop) {
            this.vScroll.scrollTo({ top: rowOffsetTop - listHeight + this.itemHeight });
        }
        else if (rowOffsetTop < scrollTop) {
            this.vScroll.scrollTo({ top: rowOffsetTop });
        }
        else {
            this.vScroll.scrollToIndex(index, 'smooth');
        }
    }
    /**
     * Data reload callback
     */
    _onDataReload(data) {
        this.lastRenderedEnd = 0;
    }
    /**
     * Update callback
     */
    _onDataUpdate(data) {
        this._dataSize = data.length;
        this.timeoutID = setTimeout(() => {
            // Data update sometimes comes faster than UI
            // need to wait here
            if (this.autoHeightResize) {
                // Set the height of this list accordingly
                this.height = Math.min(this._maxHeight, this._dataSize * this.itemHeight);
                this.heightChange.emit(this._height);
            }
            this.scrollBarChange.emit(this.vScroll.getViewportSize() < this._dataSize * this.itemHeight);
            this.changeDetector.markForCheck();
        });
    }
    onElementScroll(e) {
        const range = this.vScroll.getRenderedRange();
        if (range.end === this._dataSize && this.lastRenderedEnd < range.end) {
            this.lastRenderedEnd = range.end;
            this.endOfScroll.emit();
        }
    }
}
BentoListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoListComponent, selector: "bento-list", inputs: { autoHeightResize: "autoHeightResize", width: "width", height: "height", dataObservable: "dataObservable", maxHeight: "maxHeight", options: "options", minWidth: "minWidth", _itemHeight: ["itemHeight", "_itemHeight"] }, outputs: { endOfScroll: "endOfScroll", heightChange: "heightChange", scrollBarChange: "scrollBarChange" }, host: { properties: { "style.min-width.px": "this.minWidth" } }, queries: [{ propertyName: "customRowTemp", first: true, predicate: ["rowTemplate"], descendants: true, static: true }], viewQueries: [{ propertyName: "vScroll", first: true, predicate: CdkVirtualScrollViewport, descendants: true, static: true }, { propertyName: "defaultRowTemp", first: true, predicate: ["defaultRowTemp"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<cdk-virtual-scroll-viewport [itemSize]=\"itemHeight\"\n                             class=\"bento-list-viewport\">\n  <ng-container *cdkVirtualFor=\"let row of _data; let index = index; trackBy:trackByFn\">\n    <ng-container\n                  *ngTemplateOutlet=\"rowTemp; context: {row: row, options: options, data: {_data:_data, row: row},index:index}\">\n    </ng-container>\n  </ng-container>\n\n</cdk-virtual-scroll-viewport>\n\n<ng-template #defaultRowTemp let-$row=\"row\" let-$options=\"options\">\n  <div class=\"bento-list-row\" tabindex=\"-1\">\n    {{$row}}\n  </div>\n</ng-template>", styles: [".ng-bento bento-list-core{display:block;position:relative;width:100%}.ng-bento bento-list{display:block;min-width:200px;height:200px;border:1px solid transparent}.ng-bento .bento-list-viewport{display:block;height:100%}.ng-bento .bento-list-inner{position:absolute;display:block;width:100%;height:200%}.ng-bento .bento-list-row{height:30px;line-height:29px;border-bottom:1px solid grey;font-size:12px}\n"], components: [{ type: i5.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }], directives: [{ type: i5.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { type: i5.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-list', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<cdk-virtual-scroll-viewport [itemSize]=\"itemHeight\"\n                             class=\"bento-list-viewport\">\n  <ng-container *cdkVirtualFor=\"let row of _data; let index = index; trackBy:trackByFn\">\n    <ng-container\n                  *ngTemplateOutlet=\"rowTemp; context: {row: row, options: options, data: {_data:_data, row: row},index:index}\">\n    </ng-container>\n  </ng-container>\n\n</cdk-virtual-scroll-viewport>\n\n<ng-template #defaultRowTemp let-$row=\"row\" let-$options=\"options\">\n  <div class=\"bento-list-row\" tabindex=\"-1\">\n    {{$row}}\n  </div>\n</ng-template>", styles: [".ng-bento bento-list-core{display:block;position:relative;width:100%}.ng-bento bento-list{display:block;min-width:200px;height:200px;border:1px solid transparent}.ng-bento .bento-list-viewport{display:block;height:100%}.ng-bento .bento-list-inner{position:absolute;display:block;width:100%;height:200%}.ng-bento .bento-list-row{height:30px;line-height:29px;border-bottom:1px solid grey;font-size:12px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { autoHeightResize: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], dataObservable: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], options: [{
                type: Input
            }], minWidth: [{
                type: HostBinding,
                args: ['style.min-width.px']
            }, {
                type: Input
            }], endOfScroll: [{
                type: Output
            }], heightChange: [{
                type: Output
            }], scrollBarChange: [{
                type: Output
            }], vScroll: [{
                type: ViewChild,
                args: [CdkVirtualScrollViewport, { static: true }]
            }], defaultRowTemp: [{
                type: ViewChild,
                args: ['defaultRowTemp', { static: true }]
            }], customRowTemp: [{
                type: ContentChild,
                args: ['rowTemplate', { static: true }]
            }], _itemHeight: [{
                type: Input,
                args: ['itemHeight']
            }] } });

// Used to create uid
let comboboxListId = 0;
class BentoComboboxListComponent extends BentoListSubscribable {
    constructor(elRef, windowRef, r, changeDetector) {
        super();
        this.elRef = elRef;
        this.windowRef = windowRef;
        this.r = r;
        this.changeDetector = changeDetector;
        /**
         * On row change
         */
        this.selectedRowChange = new EventEmitter();
        /**
         * Emits end of scroll event
         */
        this.endOfScroll = new EventEmitter();
        this.highlightedIDChange = new EventEmitter();
        /**
         * ScrollBar width
         */
        this._scrollBarWidth = 0;
        /**
         * Keep track on what the height of the list is
         */
        this._listHeight = '0';
        /**
         * Flag to determine if the list has table structure
         */
        this._isGrid = false;
        /**
         * The size of data
         */
        this._dataSize = 0;
        /**
         * Unique ID of this component
         */
        this.uid = `bui-combobox-list-${comboboxListId++}`;
        const comp = this;
        const el = elRef.nativeElement;
        r.addClass(el, 'bui-bento-combobox-container-list');
        r.addClass(el, 'bento-combox-container-list');
        this._listOptions = { _highlightedIndex: -1 };
        this._listOptions.comboboxOptions = {};
        this._listOptions.onRowClick = this.onRowClick.bind(this);
        /**
         * Define highlightedIndex to include emitter
         */
        Object.defineProperty(this._listOptions, 'highlightedIndex', {
            get: function () {
                return this._highlightedIndex;
            },
            set: function (index) {
                this._highlightedIndex = index;
                if (index < 0) {
                    comp.highlightedIDChange.emit(null);
                }
                else {
                    comp.highlightedIDChange.emit(`${comp.uid}-${index},${index}`);
                }
            }
        });
    }
    /**
     * API to set observable
     */
    set dataObservable(observable) {
        this._setDataObservable(observable);
        this._list.dataObservable = observable;
    }
    /**
     * List Options
     */
    set options(v) {
        if (v) {
            this._listOptions.comboboxOptions = v;
        }
    }
    /**
     * Set and get selected row
     */
    set selectedRow(r) {
        if (r === this._selectedRow) {
            return;
        }
        this._selectedRow = r;
        // reset row highlight
        // this.resetHighlight();
        if (this._data) {
            this._listOptions.selectedIndex = this._data.indexOf(r);
        }
    }
    get selectedRow() {
        return this._selectedRow;
    }
    set highlightedRow(r) {
        if (this._data) {
            this._listOptions.highlightedIndex = this._data.indexOf(r);
        }
    }
    /**
     * Returns the length of the list
     */
    get length() {
        if (this._data) {
            return this._data.length;
        }
        return 0;
    }
    /**
     * Returns the id of the list component
     */
    get listUID() {
        return this.uid;
    }
    /**
     * Check viewport size and rerender
     */
    checkViewportSize() {
        this._list.checkViewportSize();
    }
    /**
     * Highlight next row
     */
    highlightNext() {
        const length = this._data.length;
        const index = length > 0 ? (this._listOptions.highlightedIndex + 1) % length : -1;
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    }
    /**
     * Highlight previous row
     */
    highlightPrevious() {
        const length = this._data.length;
        const index = length > 0 ? (this._listOptions.highlightedIndex - 1 + length) % length : -1;
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    }
    /**
     * Highlight on the currently selected row
     */
    highlightSelectedRow() {
        const index = this._data.indexOf(this._selectedRow);
        if (index > -1) {
            this._list.showRowIndex(index);
            this._listOptions.highlightedIndex = index;
        }
    }
    /**
     * Page down
     */
    pageDown() {
        const range = this._list.getRowRangeInView();
        const highlightedIndex = this._listOptions.highlightedIndex || 0;
        const index = Math.min(highlightedIndex + Math.ceil((range.to + range.from) * 0.5), this._dataSize - 1);
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    }
    /**
     * Page up
     */
    pageUp() {
        const range = this._list.getRowRangeInView();
        const highlightedIndex = this._listOptions.highlightedIndex || 0;
        const index = Math.max(0, highlightedIndex - Math.max(0, Math.ceil((range.to + range.from) * 0.5)));
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    }
    /**
     * Scroll to End
     */
    end() {
        this._list.showRowIndex((this._listOptions.highlightedIndex = this._data.length - 1));
    }
    /**
     * Scroll to home
     */
    home() {
        this._list.showRowIndex((this._listOptions.highlightedIndex = 0));
    }
    /**
     * Reset highlighted row
     */
    resetHighlight() {
        this._listOptions.highlightedIndex = -1;
    }
    /**
     * Select the highlighted row
     * This will fire the `selectedRowChange` callback
     *
     * NOTE: This method will ONLY execute when highlight index is changed
     */
    selectHighlightedRow() {
        // Only select a highlighted row when it's changed
        const options = this._listOptions;
        if (this.selectedRow === this._data[options.highlightedIndex]) {
            // Do nothing when the selection and highlight are the same
            return;
        }
        else if (options.highlightedIndex === -1 || isNaN(options.highlightedIndex)) {
            // Clear selection since there is no highlight
            options.selectedIndex = -1;
            this.selectedRow = null;
            this.selectedRowChange.emit({ row: null });
        }
        else {
            // Update selection based on the current highlight
            options.selectedIndex = options.highlightedIndex;
            this.selectedRow = this._data[options.highlightedIndex];
            this.selectedRowChange.emit({ row: this._data[options.selectedIndex] });
        }
    }
    /**
     * Initialization
     */
    ngOnInit() {
        // Make sure there is a least one template, the custom template cannot be used with the grid.
        if (this._isGrid) {
            this._listOptions.rowTemplate = this.defaultTemplate;
        }
        else {
            this._listOptions.rowTemplate = this.rowTemplate || this.defaultTemplate;
        }
        setTimeout(() => {
            this._isGrid = this._listOptions.comboboxOptions.columns && this._listOptions.comboboxOptions.columns.length > 1;
            this.r.setAttribute(this.elRef.nativeElement, 'role', this._isGrid ? 'grid' : 'listbox');
            this.r.setAttribute(this.elRef.nativeElement, 'aria-labelledby', this._isGrid ? this.gridLabelId : 'listbox');
            this.changeDetector.markForCheck();
        });
    }
    /**
     * Row click
     */
    onRowClick($event, row, index) {
        if (this._selectedRow === row) {
            return;
        }
        this.selectedRow = row;
        this.selectedRowChange.emit({ row, isClickEvent: true });
    }
    /**
     * Data reload - reset scrolling
     */
    _onDataReload() {
        if (typeof this.selectedRow !== 'undefined') {
            this._listOptions.selectedIndex = this._data.indexOf(this.selectedRow);
        }
        this._dataSize = this._data.length;
    }
    /**
     * Data update - keep scroll to top
     */
    _onDataUpdate(data) {
        if (typeof this.selectedRow !== 'undefined' || !this.selectedRow) {
            this._listOptions.selectedIndex = data.indexOf(this.selectedRow);
        }
        this._dataSize = this._data.length;
        this.changeDetector.markForCheck();
    }
    /**
     * When the virtual list height has changed
     */
    _onListHeightChange(h) {
        this._listHeight = (this._data.length === 0 ? 150 : h) + 'px';
        this.changeDetector.markForCheck();
    }
    /**
     * Callback to check scrollbar visibility change
     */
    _onScrollBarVisChange(visible) {
        this._scrollBarWidth = visible ? this.windowRef.scrollbarWidth : 0;
        this.changeDetector.markForCheck();
    }
    /**
     * End of scroll listener
     */
    _onEOS() {
        this.endOfScroll.emit();
    }
}
BentoComboboxListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxListComponent, deps: [{ token: i0.ElementRef }, { token: WindowRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoComboboxListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoComboboxListComponent, selector: "bento-combobox-list", inputs: { options: "options", rowTemplate: "rowTemplate", selectedRow: "selectedRow", highlightedRow: "highlightedRow", gridLabelId: "gridLabelId" }, outputs: { selectedRowChange: "selectedRowChange", endOfScroll: "endOfScroll", highlightedIDChange: "highlightedIDChange" }, viewQueries: [{ propertyName: "defaultTemplate", first: true, predicate: ["defaultRowTemplate"], descendants: true, static: true }, { propertyName: "_list", first: true, predicate: BentoListComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"_isGrid\" class=\"bui-bento-combobox-container-header bento-combobox-container-header\" role=\"row\">\n  <ng-template [ngIf]=\"_listOptions.comboboxOptions.headerTranslation\">\n    <div\n      *ngFor=\"let column of _listOptions.comboboxOptions.columns; let i = index\"\n      [attr.id]=\"uid + '-header-' + i\"\n      role=\"columnheader\"\n      [ngStyle]=\"{width: column.width}\"\n      class=\"bui-bento-combobox-container-header-label\"\n    >\n      {{ _listOptions.comboboxOptions.headerTranslation[column.name ? column.name : column] }}\n    </div>\n    <div\n      *ngIf=\"_scrollBarWidth\"\n      [style.width.px]=\"_scrollBarWidth\"\n      class=\"bui-bento-combobox-container-header-label bui-bento-combobox-container-header-label-filler\"\n    ></div>\n  </ng-template>\n  <ng-template [ngIf]=\"!_listOptions.comboboxOptions.headerTranslation\">\n    <div\n      *ngFor=\"let column of _listOptions.comboboxOptions.columns; let i = index\"\n      role=\"columnheader\"\n      [attr.id]=\"uid + '-header-' + i\"\n      class=\"bui-bento-combobox-container-header-label\"\n    >\n      {{ column.name ? column.name : column }}\n    </div>\n  </ng-template>\n</div>\n<div class=\"bui-bento-combobox-list-wrapper bento-combobox-list-wrapper\" [style.height]=\"_listHeight\">\n  <bento-list\n    [options]=\"_listOptions\"\n    [maxHeight]=\"300\"\n    [itemHeight]=\"_listOptions.comboboxOptions.itemHeight\"\n    [autoHeightResize]=\"true\"\n    (endOfScroll)=\"_onEOS()\"\n    (scrollBarChange)=\"_onScrollBarVisChange($event)\"\n    (heightChange)=\"_onListHeightChange($event)\"\n  >\n    <ng-template #rowTemplate let-$data=\"data\" let-$o=\"options\" let-$i=\"index\">\n      <div\n        [attr.id]=\"uid + '-' + $i\"\n        [style.height.px]=\"_listOptions.comboboxOptions.itemHeight\"\n        class=\"bento-list-row bui-bento-combobox-container-item bento-combobox-container-item\"\n        (click)=\"$o.onRowClick($event, $data.row, $i)\"\n        [ngClass]=\"($i == $o.selectedIndex ? 'selected ' : '') + ($i == $o.highlightedIndex ? 'highlighted ' : '')\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$i + 1\"\n        [attr.aria-selected]=\"$i == $o.selectedIndex\"\n        [attr.role]=\"_isGrid ? 'row' : 'option'\"\n      >\n        <ng-container\n          *ngTemplateOutlet=\"$o.rowTemplate; context: {options: $o.comboboxOptions, data: $data, index: $i}\"\n        ></ng-container>\n      </div>\n    </ng-template>\n  </bento-list>\n</div>\n\n<ng-template #defaultRowTemplate let-$data=\"data\" let-$options=\"options\" let-$index=\"index\">\n  <ng-template [ngIf]=\"$options.columns\">\n    <div\n      *ngFor=\"let column of $options.columns; let i = index\"\n      class=\"bento-list-cell bento-combobox-item-cell\"\n      [attr.role]=\"_isGrid ? 'gridcell' : 'cell'\"\n      [attr.aria-describedby]=\"uid + '-header-' + i\"\n      [ngStyle]=\"{width: column.width}\"\n      [attr.id]=\"uid + '-grid-cell-' + $index + 'x' + i\"\n    >\n      {{ $data.row[column.name ? column.name : column] }}\n    </div>\n  </ng-template>\n  <div class=\"bento-list-item bento-combobox-item\" *ngIf=\"!$options.columns\">\n    {{ $options.label ? $data.row[$options.label] : $data.row }}\n  </div>\n</ng-template>\n<i\n  role=\"img\"\n  [attr.aria-label]=\"'BENTO_UI_CBOX_A11Y_NO_RESULTS' | bentoTranslate\"\n  class=\"bento-icon-file-viewer bento-combobox-container-empty-label\"\n  *ngIf=\"!this._data.length\"\n></i>\n", components: [{ type: BentoListComponent, selector: "bento-list", inputs: ["autoHeightResize", "width", "height", "dataObservable", "maxHeight", "options", "minWidth", "itemHeight"], outputs: ["endOfScroll", "heightChange", "scrollBarChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-combobox-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"_isGrid\" class=\"bui-bento-combobox-container-header bento-combobox-container-header\" role=\"row\">\n  <ng-template [ngIf]=\"_listOptions.comboboxOptions.headerTranslation\">\n    <div\n      *ngFor=\"let column of _listOptions.comboboxOptions.columns; let i = index\"\n      [attr.id]=\"uid + '-header-' + i\"\n      role=\"columnheader\"\n      [ngStyle]=\"{width: column.width}\"\n      class=\"bui-bento-combobox-container-header-label\"\n    >\n      {{ _listOptions.comboboxOptions.headerTranslation[column.name ? column.name : column] }}\n    </div>\n    <div\n      *ngIf=\"_scrollBarWidth\"\n      [style.width.px]=\"_scrollBarWidth\"\n      class=\"bui-bento-combobox-container-header-label bui-bento-combobox-container-header-label-filler\"\n    ></div>\n  </ng-template>\n  <ng-template [ngIf]=\"!_listOptions.comboboxOptions.headerTranslation\">\n    <div\n      *ngFor=\"let column of _listOptions.comboboxOptions.columns; let i = index\"\n      role=\"columnheader\"\n      [attr.id]=\"uid + '-header-' + i\"\n      class=\"bui-bento-combobox-container-header-label\"\n    >\n      {{ column.name ? column.name : column }}\n    </div>\n  </ng-template>\n</div>\n<div class=\"bui-bento-combobox-list-wrapper bento-combobox-list-wrapper\" [style.height]=\"_listHeight\">\n  <bento-list\n    [options]=\"_listOptions\"\n    [maxHeight]=\"300\"\n    [itemHeight]=\"_listOptions.comboboxOptions.itemHeight\"\n    [autoHeightResize]=\"true\"\n    (endOfScroll)=\"_onEOS()\"\n    (scrollBarChange)=\"_onScrollBarVisChange($event)\"\n    (heightChange)=\"_onListHeightChange($event)\"\n  >\n    <ng-template #rowTemplate let-$data=\"data\" let-$o=\"options\" let-$i=\"index\">\n      <div\n        [attr.id]=\"uid + '-' + $i\"\n        [style.height.px]=\"_listOptions.comboboxOptions.itemHeight\"\n        class=\"bento-list-row bui-bento-combobox-container-item bento-combobox-container-item\"\n        (click)=\"$o.onRowClick($event, $data.row, $i)\"\n        [ngClass]=\"($i == $o.selectedIndex ? 'selected ' : '') + ($i == $o.highlightedIndex ? 'highlighted ' : '')\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$i + 1\"\n        [attr.aria-selected]=\"$i == $o.selectedIndex\"\n        [attr.role]=\"_isGrid ? 'row' : 'option'\"\n      >\n        <ng-container\n          *ngTemplateOutlet=\"$o.rowTemplate; context: {options: $o.comboboxOptions, data: $data, index: $i}\"\n        ></ng-container>\n      </div>\n    </ng-template>\n  </bento-list>\n</div>\n\n<ng-template #defaultRowTemplate let-$data=\"data\" let-$options=\"options\" let-$index=\"index\">\n  <ng-template [ngIf]=\"$options.columns\">\n    <div\n      *ngFor=\"let column of $options.columns; let i = index\"\n      class=\"bento-list-cell bento-combobox-item-cell\"\n      [attr.role]=\"_isGrid ? 'gridcell' : 'cell'\"\n      [attr.aria-describedby]=\"uid + '-header-' + i\"\n      [ngStyle]=\"{width: column.width}\"\n      [attr.id]=\"uid + '-grid-cell-' + $index + 'x' + i\"\n    >\n      {{ $data.row[column.name ? column.name : column] }}\n    </div>\n  </ng-template>\n  <div class=\"bento-list-item bento-combobox-item\" *ngIf=\"!$options.columns\">\n    {{ $options.label ? $data.row[$options.label] : $data.row }}\n  </div>\n</ng-template>\n<i\n  role=\"img\"\n  [attr.aria-label]=\"'BENTO_UI_CBOX_A11Y_NO_RESULTS' | bentoTranslate\"\n  class=\"bento-icon-file-viewer bento-combobox-container-empty-label\"\n  *ngIf=\"!this._data.length\"\n></i>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: WindowRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { options: [{
                type: Input
            }], rowTemplate: [{
                type: Input
            }], selectedRow: [{
                type: Input
            }], highlightedRow: [{
                type: Input
            }], gridLabelId: [{
                type: Input
            }], selectedRowChange: [{
                type: Output
            }], endOfScroll: [{
                type: Output
            }], highlightedIDChange: [{
                type: Output
            }], defaultTemplate: [{
                type: ViewChild,
                args: ['defaultRowTemplate', { static: true }]
            }], _list: [{
                type: ViewChild,
                args: [BentoListComponent, { static: true }]
            }] } });

/**
 * Bento Combobox Search Event
 */
class BentoComboboxSearchEvent {
    constructor(search, currentIndex = 0) {
        this.search = search;
        this.currentIndex = currentIndex;
    }
}

/**
 * Defines an user journey in a Combobox
 */
class ComboboxUserJourney {
    constructor() {
        /**
         * If the user has visited the component
         */
        this._visited = false;
        /**
         * When user finished interaction with this component
         */
        this._finished = false;
        /**
         * When user has interacted in this component
         */
        this._edited = false;
        /**
         * When user has made a selection in this component
         */
        this._selected = false;
        /**
         * When user tried search
         */
        this._searched = false;
        /**
         * When user had a keypress
         */
        this._keypressed = false;
    }
    get visited() {
        return this._visited;
    }
    get edited() {
        return this._edited;
    }
    get finished() {
        return this._finished;
    }
    get selected() {
        return this._selected;
    }
    get searched() {
        return this._searched;
    }
    get keypressed() {
        return this._keypressed;
    }
    visit() {
        this._visited = true;
    }
    edit() {
        this._edited = true;
    }
    finish() {
        this._finished = true;
    }
    search(v = true) {
        this._searched = v;
        this._edited = true;
    }
    select() {
        this._selected = true;
        this._edited = true;
        // Need to start another search session to flip the flag
        this._searched = false;
    }
    keypress() {
        this._keypressed = true;
        this._edited = true;
    }
    reset() {
        this._edited = false;
        this._finished = false;
        this._visited = false;
        this._selected = false;
        this._searched = false;
        this._keypressed = false;
    }
}

const DEFAULT_DEBOUNCE_TIME = 200;

/**
 * Keyboard Constant Variables
 * CAPS_LOCK: number; ESC: number; SPACE: number; PAGE_UP: number; PAGE_DOWN: number; END: number; HOME: number;
 * LEFT: number; UP: number; RIGHT: number; DOWN: number; INSERT: number; DELETE: number; COMMAND: number}}
 */
const Keyboard = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    INSERT: 45,
    DELETE: 46,
    COMMAND: 91,
    RIGHT_COMMAND: 92,
    NUM_0: 96,
    NUM_1: 97,
    NUM_2: 98,
    NUM_3: 99,
    NUM_4: 100,
    NUM_5: 101,
    NUM_6: 102,
    NUM_7: 103,
    NUM_8: 104,
    NUM_9: 105,
    NUM_ASTERISK: 106,
    NUM_ADD: 107,
    NUM_MINUS: 109,
    NUM_POINT: 110,
    NUM_DIVIDE: 111,
    COMMA: 188
};

class BentoNgbTooltipSupportDirective {
    constructor(tooltip, r, winRef, elementRef) {
        this.tooltip = tooltip;
        this.r = r;
        this.shownSub = Subscription.EMPTY;
        this.hiddenSub = Subscription.EMPTY;
        this.document = winRef.nativeDocument;
        this.el = elementRef.nativeElement;
        this.initHoverScreenEl();
    }
    ngOnInit() {
        this.shownSub = this.tooltip.shown.subscribe(e => {
            setTimeout(() => {
                // Catch when a tooltip is shown
                const tooltipWindowEl = this.document.querySelector(`#${this.tooltip['_ngbTooltipWindowId']}`);
                if (tooltipWindowEl) {
                    this.r.addClass(tooltipWindowEl, 'tooltip-shown');
                    setTimeout(() => {
                        // Need to wait for the next CPU computation cycle
                        this.tooltip.container !== 'body' && this.calcHoverScreenEl(tooltipWindowEl);
                    });
                }
            });
        });
        this.hiddenSub = this.tooltip.hidden.subscribe(e => this.resetHoverScreenEl());
    }
    ngOnDestroy() {
        this.shownSub.unsubscribe();
        this.hiddenSub.unsubscribe();
    }
    /**
     * Calculate hover screen element to match tooltip
     */
    calcHoverScreenEl(tooltipWindowEl) {
        const tooltipRect = tooltipWindowEl.getBoundingClientRect();
        const hsRect = this.hoverScreenEl.getBoundingClientRect();
        const hsEl = this.hoverScreenEl;
        this.r.setStyle(hsEl, 'top', `${tooltipRect.top - hsRect.top - 1}px`);
        this.r.setStyle(hsEl, 'left', `${tooltipRect.left - hsRect.left - 1}px`);
        this.r.setStyle(hsEl, 'width', `${tooltipRect.width + 2}px`);
        this.r.setStyle(hsEl, 'height', `${tooltipRect.height + 2}px`);
    }
    /**
     * Initialize hover screen element for WCAG 2.1
     */
    initHoverScreenEl() {
        const el = this.r.createElement('div');
        this.r.setStyle(el, 'z-index', '2002');
        this.r.setStyle(el, 'position', 'absolute');
        this.r.setStyle(el, 'background-color', 'transparent');
        this.r.addClass(el, 'bento-tooltip-hover-overlay');
        this.r.setAttribute(el, 'aria-hidden', 'true');
        this.el.appendChild(el);
        this.hoverScreenEl = el;
        this.resetHoverScreenEl();
    }
    /**
     * Reset hover screen element dimension and size to its initial values
     */
    resetHoverScreenEl() {
        const el = this.hoverScreenEl;
        this.r.setStyle(el, 'top', '0');
        this.r.setStyle(el, 'left', '0');
        this.r.setStyle(el, 'width', '0');
        this.r.setStyle(el, 'height', '0');
    }
}
BentoNgbTooltipSupportDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbTooltipSupportDirective, deps: [{ token: forwardRef(() => NgbTooltip) }, { token: i0.Renderer2 }, { token: WindowRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoNgbTooltipSupportDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]", providers: [WindowRef], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbTooltipSupportDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[ngbTooltip]', providers: [WindowRef] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgbTooltip, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbTooltip)]
                    }] }, { type: i0.Renderer2 }, { type: WindowRef }, { type: i0.ElementRef }];
    } });

/* eslint-disable  @typescript-eslint/no-use-before-define */
const BENTO_COMBOBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoComboboxComponent),
    multi: true
};
const BENTO_COMBOBOX_VALUE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => BentoComboboxComponent),
    multi: true
};
let comboboxId = 0;
/* eslint-disable  @angular-eslint/no-host-metadata-property */
/**
 * Similar to native browser dropdown comboboxes, this component presents
 * a list of values in a dropdown list. In addition, it supports input filtering,
 * lazy-loading, and searching.
 */
class BentoComboboxComponent extends BentoListSubscribable {
    /**
     */
    constructor(elRef, r, tabService, logService, translate, sanitizer, cd, winRef) {
        super();
        this.elRef = elRef;
        this.r = r;
        this.tabService = tabService;
        this.logService = logService;
        this.translate = translate;
        this.sanitizer = sanitizer;
        this.cd = cd;
        /**
         * Element to append the dropdown to when this component is inside of
         * a container where overflow is hidden
         */
        this.appendTo = null;
        /**
         * Combobox options to customize its behavior
         */
        this.options = {};
        /**
         * Determine if the list is a drop-up menu
         */
        this.up = false;
        /**
         * Flag for `readonly` state
         */
        this._isReadOnly = false;
        /**
         * Callback when a **server search** needs to be performed. A `BentoComboboxSearchEvent` object is passed in as
         * reference. Each search callback **MUST** emit results back even when it is empty, otherwise Combobox component will
         * wait for all search results to return before it renders the final list
         *
         * **Note**: This event is only emitted when `BentoComboboxOptions.useServerSearch` is set to `true`
         */
        this.search = new EventEmitter();
        /**
         * Callback when data needs to reset.
         *
         * **Note**: This event is only emitted when `BentoComboboxOptions.useServerSearch` is set to `true`
         */
        this.resetItems = new EventEmitter();
        /**
         * Callback when end of scroll is reached in dropdown list.  This event is **only**
         * fired when there is a scroll. A `BentoComboboxSearchEvent` object is passed in as reference
         */
        this.endOfScroll = new EventEmitter();
        /**
         * Callback when the open state is changed in Combobox
         */
        this.openChange = new EventEmitter();
        /**
         * Flag to decide if this form component is required or not
         */
        this.required = false;
        /**
         * Revert search input when its entry is invalid. It overrides `BentoComboboxFooterItem.clearInputOnAction`
         */
        this.revertOnInvalidInput = false;
        /**
         * If multiple colums are used, a label for this component is created. This allows the user to supply the text for the label.
         * If text is not provided, it will show text instructing the user to do so
         */
        this.inputLabelText = '';
        /**
         * Disabled flag
         */
        this._isDisabled = false;
        /**
         * Main Data
         */
        this._data = [];
        /**
         * Data that is used for the dropdown
         */
        this._listData = [];
        /**
         * Event Emitter for data change
         */
        this._listDataChange = new ReplaySubject(1);
        /**
         * Reactive FormControl for the main input
         */
        this._inputLabelControl = new FormControl();
        /**
         * Define if this component is in searching mode
         */
        this._isSearching = false;
        /**
         * Unique ID of this component
         */
        this.uid = `bui-combobox-${comboboxId++}`;
        /**
         * Unique ID when this is a Combo-Grid componenet
         */
        this.uidGrid = `${comboboxId++}`;
        /**
         * This variable is used by `isListVisible`
         */
        this._isListVisible = false;
        /**
         * User journey to keep tap on how user is interaction with the component
         */
        this.userJourney = new ComboboxUserJourney();
        /**
         * Keep track on how many requests are sent
         */
        this.serverRequestCount = 0;
        this.focusedCellClass = 'bento-focused-cell';
        /**
         * Grid Combo variables
         */
        this.isGrid = false;
        this.colsCount = 0;
        this.activeColIndex = 0;
        this.activeRowIndex = 0;
        /* istanbul ignore next */
        this._changeFunction = v => { };
        /* istanbul ignore next */
        this._touchFunction = () => { };
        /* istanbul ignore next */
        this._windowClickSubscription = () => { };
        this.document = winRef.nativeDocument;
        // Add classes
        const el = elRef.nativeElement;
        r.addClass(el, 'bento-select');
        r.addClass(el, 'form-control');
        this.currentEl = el;
        this.showSelectorInputLabel = true;
    }
    /**
     * Flag to container visibility
     */
    set isListVisible(v) {
        this.listWillBeVisible = v;
        if (v) {
            this._isListVisible = v;
            setTimeout(() => {
                this.r.addClass(this._listContainer.nativeElement, 'in');
                this.r.removeClass(this._listContainer.nativeElement, 'out');
            });
        }
        else {
            setTimeout(() => {
                this.r.addClass(this._listContainer.nativeElement, 'out');
                setTimeout(() => {
                    this.r.removeClass(this._listContainer.nativeElement, 'in');
                    this.r.removeClass(this._listContainer.nativeElement, 'out');
                    this._isListVisible = false;
                    this.cd.markForCheck();
                }, 200);
            });
        }
    }
    get isListVisible() {
        return this._isListVisible;
    }
    /**
     * Manually open or close Combobox dropdown
     */
    set open(isOpen) {
        if (isOpen !== this._isListVisible) {
            // Only toggle when it really needs a toggle
            this.toggleContainerVisibility();
        }
    }
    get open() {
        return this._isListVisible;
    }
    /**
     * Data observable object for subscribing to data updates.
     * Changing this Observable instance will rest the dropdown list
     */
    set itemsObservable(observable) {
        if (observable) {
            // Forward the observable to the super class to handle the logic
            this._setDataObservable(observable);
        }
    }
    /**
     * HTML element id of this component used for A11y
     */
    set id(v) {
        this._id = v;
    }
    get id() {
        return this._id;
    }
    /**
     * If multiple colums are used, a label for this component is created.
     * This allows the user to supply a class that will be applied to the label
     */
    set inputLabelClass(v) {
        if (v) {
            this._inputLabelClass = v;
        }
    }
    get inputLabelClass() {
        return this._inputLabelClass;
    }
    /**
     * When ngModel is udpated
     */
    writeValue(row) {
        this._selectedRow = row;
        this.inputLabel = this._formatLabel(row);
        this._isSearching = false;
        this._searchValue = undefined;
        this._list.selectedRow = row;
        if (!row) {
            // Reset dropdown list highlights when a selected item is cleared
            this._list.resetHighlight();
        }
        this.cd.markForCheck();
    }
    /**
     * Validator
     */
    validate(control) {
        if (this.required && !(this._inputLabel && this._inputLabel.length)) {
            return { required: false };
        }
        return null;
    }
    /**
     * When disabled state is updated
     */
    setDisabledState(v) {
        this._isDisabled = v;
        this._isSearching = false;
        this._searchValue = undefined;
        if (v) {
            this._inputLabelControl.disable();
        }
        else {
            this._inputLabelControl.enable();
        }
        this.cd.markForCheck();
    }
    /**
     * Referencing ngModel change function
     */
    registerOnChange(fn) {
        this._changeFunction = fn;
    }
    /**
     * Referencing component touch event
     */
    registerOnTouched(fn) {
        this._touchFunction = () => {
            fn();
            this.cd.markForCheck();
        };
    }
    /**
     * Override data update from BentoListSubscribable
     */
    _updateData(data) {
        this.serverRequestCount = Math.max(this.serverRequestCount - 1, 0);
        if (this.serverRequestCount === 0) {
            // There is no more request in the queue, therefore update data and view
            this._data = this._data.concat(data);
        }
    }
    /**
     * Overriding  BentoListSubscribable
     */
    _onDataReload(data) {
        this._listDataChange = new ReplaySubject(1);
        this._list.dataObservable = this._listDataChange;
        this._list.resetHighlight();
        this.serverRequestCount++;
    }
    /**
     * Overriding  BentoListSubscribable
     */
    _onDataUpdate(data) {
        this._listData = data.slice();
        // Emit data change to the ComboboxList component
        this._listDataChange.next(this._listData);
        if (this.userJourney.searched && this.options.useServerSearch) {
            // Handles highlight and/or selections when in server search mode
            if (this._inputLabel.trim().length > 0) {
                // Highlight the first item in the result set only when user searched for something
                this._list.highlightNext();
            }
            if (this.userJourney.finished) {
                // User has already tabbed/focused out and the data finally comes in
                this.updateChanges();
            }
        }
    }
    /**
     * Init
     */
    ngOnInit() {
        // debounce keystroke events
        this._inputLabelControl.valueChanges
            .pipe(debounceTime(this.options.useServerSearch ? this.options.debounceTime || DEFAULT_DEBOUNCE_TIME : 0))
            .subscribe(newValue => {
            this._onInputLabelChange(newValue);
        });
        this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_OPEN');
        this.colsCount = this.options.columns ? this.options.columns.length : 0;
        if (this.colsCount > 1) {
            this.isGrid = true;
            if (!this.inputLabelText) {
                const errorString = `Required: use [inputLabelText] property to provide the label text.`;
                console.error(errorString);
            }
            this.setupComboGrid();
        }
        else {
            this.setupA11y();
        }
    }
    /**
     * Destroy -> cleanup
     */
    ngOnDestroy() {
        this.cd.detach();
        if (this._dataSubscription) {
            this._dataSubscription.unsubscribe();
        }
        if (this._windowClickSubscription) {
            this._windowClickSubscription();
        }
        // List container can be appended to other containers when this
        // component is destroyed and causing memory leak
        const el = this._listContainer.nativeElement;
        this.r.removeChild(el.parentElement, el);
    }
    /**
     * Callback when highlighted index is changed
     */
    _onHighlightedRowChange(data) {
        if (data) {
            const ids = data.split(',');
            const id = ids[0];
            this.activeRowIndex = parseInt(ids[1], 10);
            if (!this._list._isGrid) {
                this.r.setAttribute(this._inputElRef.nativeElement, 'aria-activedescendant', id);
            }
        }
        else {
            this.r.removeAttribute(this._inputElRef.nativeElement, 'aria-activedescendant');
        }
    }
    /**
     * Callback when a row is selected
     */
    _onRowSelect(e) {
        const row = e.row;
        // In case the row is null with a random string remaining in the input field
        this.inputLabel = this._formatLabel(row);
        if (row === this._selectedRow) {
            // No need to process selected row
            /* istanbul ignore next */
            return;
        }
        // Notify `ngModel`
        this._changeFunction(row);
        // Update the current row private reference
        this._selectedRow = row;
        // Reset the list data back to normal
        this._resetListData();
        if (this.options.useServerSearch) {
            // The result might not be in the list when data is reset in server search mode
            this._list.resetHighlight();
        }
        else {
            // Move highlighted selection to the current selected row
            this._list.highlightSelectedRow();
        }
        if (e.isClickEvent) {
            // Bring focus back to the input field
            this._inputElRef.nativeElement.focus();
            // Collapse only when clicked since there is a keyboard management to handle the collapse already
            this.toggleContainerVisibility();
        }
        // Update user journey
        this.userJourney.select();
    }
    /**
     * Input label input
     */
    set inputLabel(v) {
        this._inputLabel = v;
        // Update input label
        this._inputLabelControl.setValue(v);
    }
    get inputLabel() {
        return this._inputLabel;
    }
    /**
     * When the main input gains focus
     */
    _onInputFocus(e) {
        if (!this.options.searchable || this._isDisabled || this._isReadOnly) {
            // ignore when disabled
            return;
        }
        const inputEl = this._inputElRef.nativeElement;
        setTimeout(() => inputEl.setSelectionRange(0, inputEl.value.length));
    }
    /**
     * Format label as specified based on the given row object
     */
    _formatLabel(row) {
        let label;
        if (!row) {
            return '';
        }
        else if (this.options.labelFormatter) {
            label = this.options.labelFormatter(row);
        }
        else if (typeof row === 'string' || !this.options.columns || !this.options.columns.length) {
            label = row;
        }
        else {
            const column = this.options.columns[0];
            label = row[column.name];
        }
        return label;
    }
    /**
     * When the input is changed
     */
    _onInputLabelChange(value) {
        if (this._inputLabel === value) {
            return;
        }
        this._inputLabel = value;
        this.searchData(value);
    }
    /**
     * Reset the view data for the list
     */
    _resetListData() {
        setTimeout(() => {
            // Need to delay emit since we need make sure that all events are properly captured
            // eg. host:click
            if (this.options.useServerSearch) {
                // Fire server search
                this.resetItems.emit();
            }
            else {
                this._listDataChange.next(this._data);
            }
        });
        this._isSearching = false;
        this._searchValue = undefined;
    }
    /**
     * Default Search and Compare the current label against the each row
     */
    _defaultSearchCompare(row, value) {
        let label;
        value = value.toLowerCase();
        if (typeof row === 'string') {
            // Row is a string
            return row.toLowerCase().indexOf(value) > -1;
        }
        else if (this.options.columns && this.options.columns.length) {
            // Row has column definitions
            const columns = this.options.columns;
            let column;
            for (let i = 0, len = columns.length; i < len; i++) {
                column = columns[i];
                label = String(row[column.name ? column.name : column]).toLowerCase();
                if (label.indexOf(value) > -1) {
                    return true;
                }
            }
            return false;
        }
        else {
            // Row is an object with missing column definitions
            this.logService.warn('Bento Combobox: Missing definition for `BentoComboboxOptions.columns`');
            return true;
        }
    }
    /**
     * When a footer button is clicked
     */
    _onFooterButtonClick(button) {
        if (button.collapseOnAction && this._isListVisible) {
            this.toggleContainerVisibility();
        }
        if (button.action) {
            button.action(this._inputLabel);
        }
        if (button.clearInputOnAction) {
            this.inputLabel = '';
        }
    }
    /**
     * When Space or enter is used on the button
     */
    _onFooterItemKeydown($event, button) {
        switch ($event.keyCode) {
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                this._onFooterButtonClick(button);
                $event.preventDefault();
                $event.stopPropagation();
                break;
        }
    }
    /**
     * When end of scroll is reached in the Combobox list
     */
    _onEndOfScroll() {
        this.endOfScroll.emit(new BentoComboboxSearchEvent(this._searchValue, this._data.length));
    }
    /**
     * On list keydown
     */
    _onListKeydown(e) {
        if (e.keyCode === Keyboard.TAB) {
            const footerEl = this.footerContainer ? this.footerContainer.nativeElement : undefined;
            const tabbables = this.tabService.findTabbable(footerEl);
            const currentEl = e.target;
            const currentElIndex = tabbables.indexOf(currentEl);
            if (tabbables.length) {
                if (currentElIndex === 0 && e.shiftKey) {
                    // Focus back to the input
                    this.preventEvent(e);
                    // Focus back to the input
                    this._inputElRef.nativeElement.focus();
                }
                else if (currentElIndex === tabbables.length - 1 && !e.shiftKey) {
                    // Since this is treated as a component focusout event
                    // we need to hide the list and commit change
                    this.isListVisible = false;
                    // Give focus back to input field and let the propagated
                    // tab event to handle the rest
                    this._inputElRef.nativeElement.focus();
                }
                else {
                    // Ordinary focus management within the list
                    this.preventEvent(e);
                    if (e.shiftKey) {
                        tabbables[currentElIndex - 1].focus();
                    }
                    else {
                        tabbables[currentElIndex + 1].focus();
                    }
                }
            }
        }
    }
    /**
     * Listener to deal when Dropdown is not visisble and need to check for changes
     * @param e
     */
    onFocusOut(e) {
        setTimeout(() => {
            if (!this.listWillBeVisible &&
                !this.elRef.nativeElement.contains(this.document.activeElement) &&
                !this._list.elRef.nativeElement.contains(this.document.activeElement)) {
                if (this.userJourney.edited && !this.userJourney.finished) {
                    this.updateChanges();
                    this.userJourney.finish();
                }
                // Fire touch function to notify form that this element is touched
                this._touchFunction();
            }
        });
    }
    /**
     * Setup Grid ID, A11y label and aria relationships
     */
    setupComboGrid() {
        // Create unique Id, if available use user provided id
        let id = '';
        if (this._id) {
            id = this._id;
        }
        else {
            id = 'combobox-grid';
        }
        // Combobox Id
        id += `-${this.uidGrid}`;
        this.r.setAttribute(this.elRef.nativeElement, 'id', id);
        // Create Grid Label
        const currentEl = this.elRef.nativeElement;
        const parent = currentEl.parentElement;
        const gridLabel = document.createElement('Label');
        gridLabel.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.inputLabelText);
        if (this._inputLabelClass) {
            gridLabel.classList.add(this._inputLabelClass);
        }
        // Grid Input Id
        this._id = `${id}-input`;
        // Grid Label Id
        gridLabel.id = this.gridLabelId = `${id}-label`;
        gridLabel.setAttribute('for', this._id);
        parent.insertBefore(gridLabel, currentEl);
        // Grid Id and Aria
        const listID = `${id}-grid-box`;
        this.r.setAttribute(this._list.elRef.nativeElement, 'id', listID);
        this.r.setAttribute(this.elRef.nativeElement, 'aria-owns', listID);
        this.r.setAttribute(this._inputElRef.nativeElement, 'aria-controls', listID);
    }
    /**
     * Setup A11y label and aria relationships
     */
    setupA11y() {
        // Give list an ID
        const listID = `${this.uid}-box`;
        this.r.setAttribute(this._list.elRef.nativeElement, 'id', listID);
        this.r.setAttribute(this.elRef.nativeElement, 'aria-owns', listID);
        this.r.setAttribute(this._inputElRef.nativeElement, 'aria-controls', listID);
        this.updateElementID(this.id);
    }
    /**
     * Update Element ID
     */
    updateElementID(id) {
        var _a;
        if (id) {
            // Component has an ID assigned
            const labelEl = this.document.querySelector(`[for="${id}"]`);
            const el = this.elRef.nativeElement;
            this._id = id;
            // dev is using explicit label for the combobox, so hide the internal
            // label element
            this.showSelectorInputLabel = false;
            if (labelEl) {
                let labelElID = labelEl.getAttribute('id');
                // Check if Label Element has an ID
                if (labelElID == null) {
                    // There is no ID assigned to Label
                    // We are going to create one and assign it
                    labelElID = `${this.uid}-label`;
                    this.r.setAttribute(labelEl, 'id', labelElID);
                }
                this.r.setAttribute((_a = this._list) === null || _a === void 0 ? void 0 : _a.elRef.nativeElement, 'aria-labelledby', labelElID);
            }
            // Remove id attribute from parent
            this.r.removeAttribute(el, 'id');
        }
        else {
            this.showSelectorInputLabel = true;
            // There is no ID assigned
            setTimeout(() => this.setDefaultLabel(), 100);
        }
    }
    setDefaultLabel() {
        // make searchbox accessible - a11y
        const labelEl = this.elRef.nativeElement.querySelector('.selector-input-label');
        const inputID = `${this.uid}-input`;
        if (labelEl) {
            this.r.setAttribute(labelEl, 'for', inputID);
            this._id = inputID;
            this.cd.markForCheck();
        }
    }
    /**
     * Search and return an array with the matching condition
     */
    searchData(value, doNotToggle) {
        const minSearchCharacterCount = this.options.minSearchCharacterCount || 1;
        this._isSearching = true;
        this._searchValue = value;
        if (this.options.useServerSearch) {
            // User input has to meet the minimum search character count
            // Otherwise local search kicks in
            if (value.length >= minSearchCharacterCount) {
                // Fire server search
                this.search.emit(new BentoComboboxSearchEvent(value));
            }
            else if (value.length === 0) {
                // Since there is no value to search, we simply reset the data
                this.resetItems.emit();
                // Reset highlight
                this._list.resetHighlight();
            }
            // Remove highlight
            this._list.resetHighlight();
        }
        else {
            // Do local search
            const result = [];
            let row;
            const data = this._data;
            const searchCompareFunc = this.options.searchCompare || this._defaultSearchCompare.bind(this);
            for (let i = 0, len = data.length; i < len; i++) {
                row = data[i];
                if (searchCompareFunc(row, value)) {
                    result.push(row);
                }
            }
            // update searched data
            this._listDataChange.next(result);
            if (value && value.length > 0) {
                this._list.highlightedRow = result[0];
            }
            else {
                // Remove all kinds of highlights
                this._list.resetHighlight();
                this._list.selectedRow = null;
                this.removeAllFocusCells();
            }
        }
        if (!this._isListVisible && !doNotToggle && !this.userJourney.finished) {
            this.toggleContainerVisibility();
        }
        // Update user journey state
        this.userJourney.search();
    }
    /**
     * Toggle the main container visibility
     */
    toggleContainerVisibility() {
        // Toggle flag
        const visibility = !this._isListVisible;
        this.isListVisible = visibility;
        this.removeAllFocusCells();
        if (visibility) {
            this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_CLOSE');
            // Move container to the current selected row
            this._list.highlightSelectedRow();
            // Add Window click event listeners
            this._windowClickSubscription = this.r.listen('window', 'click', e => {
                const el = this.elRef.nativeElement;
                const listEl = this._list.elRef.nativeElement;
                if (el !== e.target &&
                    !el.contains(e.target) &&
                    !listEl.contains(e.target) &&
                    !el.contains(this.document.activeElement) &&
                    !listEl.contains(this.document.activeElement)) {
                    this.onBlur();
                }
            });
            this._list.checkViewportSize();
        }
        else {
            this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_OPEN');
            this._windowClickSubscription();
        }
        // Emit open state change
        this.openChange.emit(visibility);
    }
    /**
     * Do blur tasks
     */
    onBlur() {
        if (this.listWillBeVisible) {
            // hide list if needed
            this.toggleContainerVisibility();
        }
        this.updateChanges();
        this.userJourney.finish();
        this._touchFunction();
    }
    /**
     * Update changes to the component
     */
    updateChanges() {
        if (!this.userJourney.edited || this.serverRequestCount > 0 || !this.userJourney.searched) {
            // Nothing needs to be updated since the user didn't do anything
            // Or we are still waiting for the latest server response to come in
            return;
        }
        if (this._list.length === 0) {
            if (Array.isArray(this.options.footerItems)) {
                // ComboboxList holds the search results in the combo.
                // Only trigger add on the fly if the search result is empty.
                let button;
                const footerItem = this.options.footerItems;
                for (let i = 0, len = footerItem.length; i < len; i++) {
                    button = footerItem[i];
                    if (button.actionOnValueUpdate) {
                        this._onFooterButtonClick(button);
                    }
                }
                if (this.revertOnInvalidInput) {
                    // Revert label to the previous selected row
                    // This overrides `BentoComboboxFooterItem.clearInputOnAction`
                    this.inputLabel = this._formatLabel(this._selectedRow);
                }
            }
            else if (this.revertOnInvalidInput) {
                // Revert label to the previous selected row
                this.inputLabel = this._formatLabel(this._selectedRow);
            }
            else {
                // reset input field and list
                this.inputLabel = '';
                this._list.resetHighlight();
                this._list.selectedRow = null;
                // Update value to NULL when user input is incorrect
                this._changeFunction(null);
            }
            this.searchData('', true);
        }
        else if (this.options.autoSelect === false) {
            // autoSelect needs to strickly equal to `false`
            // disable autoselect
            if (this.revertOnInvalidInput) {
                // Revert label to the previous selected row
                this.inputLabel = this._formatLabel(this._selectedRow);
            }
            else {
                // Clear label sicne there is no absolute match
                this.inputLabel = '';
                this._list.resetHighlight();
                this._list.selectedRow = null;
                this._selectedRow = null;
                // Update value to NULL when user input is incorrect
                this._changeFunction(null);
            }
        }
        else {
            if (this.userJourney.searched) {
                // Automatically update highlight or selection when this is result
                // ONLY when user performed a search
                this._list.selectHighlightedRow();
            }
        }
    }
    getItemAt(ActiveRowIndex, ActiveColIndex) {
        return this.currentEl.querySelector(`#${this._list.uid}-grid-cell-${ActiveRowIndex}x${ActiveColIndex}`);
    }
    removeFocusCell(rowIndex, colIndex) {
        const cell = this.getItemAt(rowIndex, colIndex);
        cell.classList.remove(this.focusedCellClass);
    }
    removeAllFocusCells() {
        const gridCell = this.currentEl.querySelector(this.focusedCellClass);
        if (gridCell) {
            gridCell.classList.remove(this.focusedCellClass);
        }
    }
    focusCell(rowIndex, colIndex) {
        const cell = this.getItemAt(rowIndex, colIndex);
        cell.classList.add(this.focusedCellClass);
        const activeItem = this.getItemAt(this.activeRowIndex, this.activeColIndex);
        if (activeItem) {
            this.r.setAttribute(this._inputElRef.nativeElement, 'aria-activedescendant', activeItem.id);
        }
    }
    setActiveItems() {
        if (this.isGrid) {
            const activeRow = this.getItemAt(this.activeRowIndex, 0);
            if (activeRow) {
                activeRow.setAttribute('aria-selected', 'true');
                this.focusCell(this.activeRowIndex, this.activeColIndex);
            }
        }
    }
    /**
     * Private:On input label keydown
     */
    _onKeydown(e) {
        if (this._isDisabled || this._isReadOnly) {
            // Ignore everything when this component is disabled
            /* istanbul ignore next */
            return;
        }
        if (this.isGrid) {
            const prevActive = this.getItemAt(this.activeRowIndex, this.activeColIndex);
            if (prevActive) {
                this.removeFocusCell(this.activeRowIndex, this.activeColIndex);
                prevActive.setAttribute('aria-selected', 'false');
            }
        }
        /* eslint-disable  import/no-deprecated */
        switch (e.keyCode) {
            case Keyboard.LEFT:
                if (this.isGrid) {
                    if (this.activeColIndex <= 0) {
                        this.activeColIndex = this.colsCount - 1;
                        this._list.highlightPrevious();
                    }
                    else {
                        this.activeColIndex--;
                    }
                    this.preventEvent(e);
                    this.setActiveItems();
                }
                break;
            case Keyboard.RIGHT:
                if (this.isGrid) {
                    if (this.activeColIndex === -1 || this.activeColIndex >= this.colsCount - 1) {
                        this.activeColIndex = 0;
                        this._list.highlightNext();
                        this.preventEvent(e);
                        this.userJourney.search();
                    }
                    else {
                        this.activeColIndex++;
                    }
                    this.setActiveItems();
                    this.preventEvent(e);
                }
                break;
            case Keyboard.DOWN:
                if (!this._isListVisible || e.altKey) {
                    this.toggleContainerVisibility();
                    if (this.isGrid) {
                        const index = this._data.indexOf(this._selectedRow);
                        if (index > -1) {
                            this.focusCell(index, 0);
                            this.activeRowIndex = index;
                            this.activeColIndex = 0;
                        }
                    }
                }
                else {
                    this._list.highlightNext();
                    this.setActiveItems();
                }
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.UP:
                if (!this._isListVisible || e.altKey) {
                    this.toggleContainerVisibility();
                }
                else {
                    this._list.highlightPrevious();
                    this.setActiveItems();
                }
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.ENTER:
                if (this._isListVisible && this.userJourney.searched) {
                    if (this._list.length === 0 && this.revertOnInvalidInput) {
                        this.inputLabel = this._formatLabel(this._selectedRow);
                    }
                    else {
                        this._list.selectHighlightedRow();
                    }
                    this._resetListData();
                }
                this.toggleContainerVisibility();
                this.preventEvent(e);
                break;
            case Keyboard.PAGE_DOWN:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.pageDown();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.PAGE_UP:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.pageUp();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.END:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.end();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.HOME:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.home();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.SPACE:
                if (!this.options.searchable) {
                    this.preventEvent(e);
                }
                break;
            case Keyboard.ESC:
                const label = this._selectedRow ? this._formatLabel(this._selectedRow) : '';
                if (label !== this._inputLabel) {
                    // Revert the current selection and reset data list
                    this.inputLabel = label;
                    this._resetListData();
                }
                if (this._isListVisible) {
                    // Hide the current dropdown
                    this.toggleContainerVisibility();
                }
                this.userJourney.search(false);
                this.preventEvent(e);
                break;
            case Keyboard.TAB:
                this.processTab(e);
                break;
        }
        this.userJourney.keypress();
    }
    /**
     * Process tab and blur event based on the Element setup
     */
    processTab(e) {
        const footerEl = this.footerContainer ? this.footerContainer.nativeElement : undefined;
        if (!footerEl || !this._isListVisible || e.shiftKey) {
            // No need to worry about the buttons in footer when tabbing
            // or the combobox list is not visible
            this.onBlur();
        }
        else {
            const tabbables = this.tabService.findTabbable(footerEl);
            const currentElIndex = tabbables.indexOf(e.target);
            if (tabbables.length && currentElIndex === -1 && !e.shiftKey) {
                // Pass focus into the list
                // then let _onListKeydown() to handle the rest
                e.preventDefault();
                tabbables[0].focus();
            }
        }
    }
    /**
     * When host is clicked
     */
    _onClick(e) {
        if (this._isDisabled || this._isReadOnly) {
            // ignore when disabled
            /* istanbul ignore next */
            return;
        }
        const target = e.target;
        const listComtainerEl = this._listContainer.nativeElement;
        if (target !== listComtainerEl &&
            !listComtainerEl.contains(target) &&
            (target.tagName !== 'INPUT' || !this.options.ignoreInputClick)) {
            this.toggleContainerVisibility();
            // Firefox bug
            if (((window.navigator.userAgent.toLowerCase()).indexOf('firefox') > -1)) {
                if (!this._isListVisible) {
                    this._inputElRef.nativeElement.focus();
                }
            }
            else {
                this._inputElRef.nativeElement.focus();
            }
            if (!this._isListVisible) {
                // Fire when user closed the dropdown, we need to update changes if there is any
                this.updateChanges();
            }
        }
    }
    /**
     * When host or any of its children is focused
     */
    _onFocusin(relatedTarget) {
        if (!this.elRef.nativeElement.contains(relatedTarget)) {
            this.userJourney.reset();
            this.userJourney.visit();
        }
    }
    /**
     * Prevent the current event from bubbling up
     */
    preventEvent(e) {
        e.stopPropagation();
        e.preventDefault();
    }
}
BentoComboboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BentoTabService }, { token: BentoLogService }, { token: BentoTranslate }, { token: i1$2.DomSanitizer }, { token: i0.ChangeDetectorRef }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Component });
BentoComboboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoComboboxComponent, selector: "bento-combobox", inputs: { appendTo: "appendTo", options: "options", up: "up", _isReadOnly: ["readonly", "_isReadOnly"], open: "open", itemsObservable: "itemsObservable", required: "required", revertOnInvalidInput: "revertOnInvalidInput", rowTemplate: "rowTemplate", id: "id", inputLabelText: "inputLabelText", inputLabelClass: "inputLabelClass" }, outputs: { search: "search", resetItems: "resetItems", endOfScroll: "endOfScroll", openChange: "openChange" }, host: { listeners: { "focusout": "onFocusOut($event)", "keydown": "_onKeydown($event)", "click": "_onClick($event)", "focusin": "_onFocusin($event.relatedTarget)" }, properties: { "attr.aria-haspopup": "_list._isGrid? 'grid' : 'listbox'", "attr.role": "'combobox'", "class.open": "this.isListVisible", "attr.aria-expanded": "this.isListVisible", "class.dropup": "this.up", "class.readonly": "this._isReadOnly", "class.disabled": "this._isDisabled" } }, providers: [BENTO_COMBOBOX_VALUE_ACCESSOR, BENTO_COMBOBOX_VALUE_VALIDATOR, BentoStringReplacePipe], viewQueries: [{ propertyName: "_inputElRef", first: true, predicate: ["input"], descendants: true, static: true }, { propertyName: "_list", first: true, predicate: BentoComboboxListComponent, descendants: true, static: true }, { propertyName: "_listContainer", first: true, predicate: ["listContainer"], descendants: true, static: true }, { propertyName: "footerContainer", first: true, predicate: ["footerContainer"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<label *ngIf=\"showSelectorInputLabel && !isGrid\" class=\"selector-input-label d-none\">\n  {{ 'BENTO_UI_CBOX_INPUT_LABEL' | bentoTranslate }}\n</label>\n<div>\n  <input\n    #input\n    [attr.id]=\"id\"\n    type=\"text\"\n    class=\"form-control bui-menu-item\"\n    spellcheck=\"false\"\n    autocomplete=\"off\"\n    [formControl]=\"_inputLabelControl\"\n    [class.readonly]=\"_isReadOnly\"\n    [readonly]=\"_isReadOnly || !options.searchable\"\n    [attr.aria-describedby]=\"uid + '-dropdown-aria'\"\n    (focus)=\"_onInputFocus($event)\"\n    aria-autocomplete=\"list\"\n  />\n</div>\n<div class=\"btn btn-icon\" [ngClass]=\"_isDisabled ? 'disabled ' : ''\" *ngIf=\"!_isReadOnly\">\n  <i\n    cdkMonitorElementFocus\n    [attr.aria-describedby]=\"uid + '-dropdown-aria'\"\n    [attr.tabindex]=\"_isDisabled ? '-1' : '0'\"\n    [attr.aria-hidden]=\"_isDisabled\"\n    class=\"bento-combobox-dropdown-button-icon\"\n    [class.bento-icon-caret-up-filled]=\"(isListVisible && !up) || (!isListVisible && up)\"\n    [class.bento-icon-caret-down-filled]=\"(!isListVisible && !up) || (isListVisible && up)\"\n    role=\"button\"\n  ></i>\n</div>\n<span class=\"sr-only\" [attr.id]=\"uid + '-dropdown-aria'\">{{ dropdownAriaLabel }}</span>\n<div\n  #listContainer\n  class=\"bui-bento-combobox-container bento-combobox-container\"\n  [bentoAppendTo]=\"appendTo\"\n  [side]=\"up ? 'top' : 'bottom'\"\n  [referenceTo]=\"input\"\n  [(open)]=\"isListVisible\"\n  [reszieWidthToReference]=\"true\"\n  (keydown)=\"_onListKeydown($event)\"\n>\n  <bento-combobox-list\n    #comboboxList\n    (highlightedIDChange)=\"_onHighlightedRowChange($event)\"\n    (selectedRowChange)=\"_onRowSelect($event)\"\n    [options]=\"options\"\n    [rowTemplate]=\"rowTemplate\"\n    (endOfScroll)=\"_onEndOfScroll()\"\n    [gridLabelId]=\"gridLabelId\"\n  ></bento-combobox-list>\n  <div\n    *ngIf=\"options.footerItems && options.footerItems.length > 0\"\n    #footerContainer\n    class=\"bui-bento-combobox-container-footer bento-combobox-container-footer\"\n  >\n    <div class=\"bui-bento-combobox-footer-inner bento-combobox-footer-inner\">\n      <div class=\"bui-bento-combobox-footer-row bento-combobox-footer-row\">\n        <div\n          *ngFor=\"let button of options.footerItems\"\n          class=\"bui-bento-combobox-footer-item bento-combobox-footer-item\"\n        >\n          <div class=\"bui-bento-combobox-footer-item-inner bento-combobox-footer-item-inner\">\n            <button\n              class=\"btn btn-link\"\n              type=\"button\"\n              [attr.tabindex]=\"isListVisible ? '0' : '-1'\"\n              [attr.aria-label]=\"button.ariaLabel\"\n              [disabled]=\"button.disableWhenHasResult && _list.length > 0\"\n              (click)=\"_onFooterButtonClick(button)\"\n              (keydown)=\"_onFooterItemKeydown($event, button)\"\n              ngbTooltip=\"{{ 'BENTO_UI_CBOX_OPTIONS' | bentoTranslate }}\"\n              container=\"body\"\n            >\n              <i *ngIf=\"button.icon\" [ngClass]=\"button.icon\" aria-hidden=\"true\"></i>\n              <span *ngIf=\"button.label?.length > 0\">\n                {{ button.label | bentoStringReplace: '_ITEM_':_inputLabel || button.defaultItemText }}\n              </span>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".ng-bento bento-combobox.bento-select{box-sizing:border-box;position:relative;overflow:hidden;cursor:auto;width:100%;border-width:0;z-index:auto;display:inline-block}.ng-bento bento-combobox.bento-select:not(.readonly) .form-control[readonly]:not(:disabled){font-weight:400}.ng-bento bento-combobox.bento-select input.ng-hide-add{display:none}.ng-bento bento-combobox.bento-select.open{overflow:visible}.ng-bento bento-combobox.bento-select.open input{border-bottom-left-radius:0;border-bottom-right-radius:0}.ng-bento bento-combobox.bento-select>.btn{pointer-events:auto;cursor:default;display:flex;align-items:center;justify-content:center}.ng-bento bento-combobox.bento-select>div.input-label.disabled{cursor:not-allowed;pointer-events:none}.ng-bento bento-combobox.bento-select>.btn.disabled{cursor:not-allowed;pointer-events:none;background:transparent}.ng-bento bento-combobox.bento-select input[disabled]:not(.readonly){cursor:not-allowed;font-weight:400;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-combobox.bento-select>.preloader{position:absolute;width:40px;top:0;bottom:0;right:30px;pointer-events:none}.ng-bento bento-combobox.bento-select>.preloader .bento-busyloader-blocker{background:transparent;z-index:auto}.ng-bento bento-combobox.bento-select.input-sm .bento-combobox-container{top:28px}.ng-bento bento-combobox.bento-select.input-sm>.btn [class*=bento-icon]{font-size:11px}.ng-bento bento-combobox.bento-select>i{position:absolute;top:9px;right:59px}.ng-bento bento-combobox.bento-select i.preloader{width:24px;height:24px;background-size:24px 24px;display:none}.ng-bento bento-combobox.bento-select div.input-label,.ng-bento bento-combobox.bento-select div.placeholder{cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-combobox.bento-select div.placeholder{position:absolute;left:0;top:0}.ng-bento bento-combobox.bento-select input[type=text],.ng-bento bento-combobox.bento-select div.input-label,.ng-bento bento-combobox.bento-select div.placeholder{box-sizing:border-box;width:100%;font-size:14px}.ng-bento bento-combobox.bento-select input[type=text]:focus,.ng-bento bento-combobox.bento-select div.input-label:focus,.ng-bento bento-combobox.bento-select div.placeholder:focus{outline:none}.ng-bento bento-combobox.bento-select .btn:hover{box-shadow:none}.ng-bento bento-combobox.bento-select .btn .bento-combobox-dropdown-button-icon{font-size:14px;top:0}.ng-bento body.touch,.ng-bento body.touch .bento-combobox-container-body{-webkit-overflow-scrolling:touch}.ng-bento .bui-bento-combobox-container{display:block;position:absolute;margin-top:-1px;min-width:100%;min-height:0;z-index:10;border-width:1px;border-style:solid;width:auto;overflow:hidden;visibility:hidden;opacity:0;transition:border .3s,opacity .2s}.open .ng-bento .bui-bento-combobox-container,.ng-bento .bui-bento-combobox-container.bento-append-to{visibility:visible;opacity:1}.ng-bento .bui-bento-combobox-container.out{opacity:0;transition:opacity .2s}.up .ng-bento .bui-bento-combobox-container,.dropup .ng-bento .bui-bento-combobox-container{top:auto;margin:0 0 -1px}.ng-bento .bui-bento-combobox-container bento-list{margin-bottom:-1px;border:none;position:absolute;width:100%}.ng-bento .bui-bento-combobox-container ul,.ng-bento .bui-bento-combobox-container ol{margin:0;padding:0}.ng-bento .bui-bento-combobox-container.dropdown-menu-up{margin:0 0 -1px}.ng-bento .bui-bento-combobox-container.bento-append-to{margin:0}.ng-bento .bui-bento-combobox-list-wrapper{display:table-row}.ng-bento .bui-bento-combobox-container-header{font-weight:700;padding-right:0;text-transform:capitalize;list-style:none;white-space:nowrap;display:table-header-group;width:100%}[dir=rtl] .ng-bento .bui-bento-combobox-container-header{padding-left:0;padding-right:auto}.ng-bento .bui-bento-combobox-container-header-label{padding:5px 10px;white-space:nowrap;display:table-cell;border-bottom-width:1px;border-bottom-style:solid}.ng-bento .bui-bento-combobox-container-header-label-filler{padding:0}.ng-bento .bui-bento-combobox-container-footer{display:block;width:100%;height:35px;border-top-style:solid;border-top-width:1px;position:relative;line-height:normal;font-size:12px}.ng-bento .bui-bento-combobox-footer-inner{display:table;width:100%;height:35px}.ng-bento .bui-bento-combobox-footer-row{display:table-row}.ng-bento .bui-bento-combobox-footer-item{display:table-cell;position:relative;vertical-align:middle;text-align:center}.ng-bento .bui-bento-combobox-footer-item .btn{padding:0 3px;letter-spacing:0;cursor:pointer}.ng-bento .bui-bento-combobox-footer-item .btn:disabled{pointer-events:none}.ng-bento .bui-bento-combobox-footer-item .btn:disabled:hover span{text-decoration:none}.ng-bento .bui-bento-combobox-footer-item .btn i:first-child,.ng-bento .bui-bento-combobox-footer-item .btn i:last-child{margin:0!important;top:0;vertical-align:baseline}.ng-bento .bui-bento-combobox-footer-item .btn:hover{text-decoration:none}.ng-bento .bui-bento-combobox-footer-item .btn:hover span{text-decoration:underline}.ng-bento .bui-bento-combobox-footer-item:last-child{text-align:right}[dir=rtl] .ng-bento .bui-bento-combobox-footer-item:last-child{text-align:left}.ng-bento .bui-bento-combobox-footer-item:first-child{text-align:left}[dir=rtl] .ng-bento .bui-bento-combobox-footer-item:first-child{text-align:right}.ng-bento .bui-bento-combobox-footer-item-inner{width:100%;vertical-align:middle;white-space:nowrap;padding:0 14px;text-overflow:ellipsis;overflow:visible}.ng-bento bento-combobox-list .bento-combobox-container-empty-label{font-size:100px;height:100px;left:50%;opacity:.1;position:absolute;top:50%;transform:translate(-50%,-60px);width:100px;z-index:-1}.ng-bento .bui-bento-combobox-container-list{display:table;table-layout:fixed;position:relative;width:calc(100% + 1px)}.ng-bento .bui-bento-combobox-container-list .bento-list-viewport .cdk-virtual-scroll-content-wrapper{display:table;table-layout:fixed;width:100%}.ng-bento .bui-bento-combobox-container-item.bento-list-row{display:table-row;cursor:pointer}.ng-bento .bui-bento-combobox-container-item.bento-list-row>span,.ng-bento .bui-bento-combobox-container-item.bento-list-row>div{display:table-cell;padding:6px 10px;line-height:17px;border-bottom-width:1px;border-bottom-style:solid;overflow:hidden;box-sizing:border-box}.ng-bento .bui-bento-combobox-container-item.bento-list-row>span [class^=bento-icon-],.ng-bento .bui-bento-combobox-container-item.bento-list-row>span [class*=\" bento-icon-\"],.ng-bento .bui-bento-combobox-container-item.bento-list-row>div [class^=bento-icon-],.ng-bento .bui-bento-combobox-container-item.bento-list-row>div [class*=\" bento-icon-\"]{line-height:inherit}.ng-bento .bui-bento-combobox-container-item.bento-list-row>span:last-child,.ng-bento .bui-bento-combobox-container-item.bento-list-row>div:last-child{padding-right:23px}[dir=rtl] .ng-bento .bui-bento-combobox-container-item.bento-list-row>span:last-child,[dir=rtl] .ng-bento .bui-bento-combobox-container-item.bento-list-row>div:last-child{padding-right:10px;padding-left:23px}\n"], components: [{ type: BentoComboboxListComponent, selector: "bento-combobox-list", inputs: ["options", "rowTemplate", "selectedRow", "highlightedRow", "gridLabelId"], outputs: ["selectedRowChange", "endOfScroll", "highlightedIDChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: BentoAppendToDirective, selector: "[bentoAppendTo]:not(.dropdown-menu)", inputs: ["bentoAppendTo", "referenceTo", "reszieWidthToReference", "autoHideOnContainerScroll", "alignment", "autoVerticalAlignment", "open", "side"], outputs: ["openChange"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-combobox', providers: [BENTO_COMBOBOX_VALUE_ACCESSOR, BENTO_COMBOBOX_VALUE_VALIDATOR, BentoStringReplacePipe], encapsulation: ViewEncapsulation.None, host: {
                        '[attr.aria-haspopup]': `_list._isGrid? 'grid' : 'listbox'`,
                        '[attr.role]': `'combobox'`
                    }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<label *ngIf=\"showSelectorInputLabel && !isGrid\" class=\"selector-input-label d-none\">\n  {{ 'BENTO_UI_CBOX_INPUT_LABEL' | bentoTranslate }}\n</label>\n<div>\n  <input\n    #input\n    [attr.id]=\"id\"\n    type=\"text\"\n    class=\"form-control bui-menu-item\"\n    spellcheck=\"false\"\n    autocomplete=\"off\"\n    [formControl]=\"_inputLabelControl\"\n    [class.readonly]=\"_isReadOnly\"\n    [readonly]=\"_isReadOnly || !options.searchable\"\n    [attr.aria-describedby]=\"uid + '-dropdown-aria'\"\n    (focus)=\"_onInputFocus($event)\"\n    aria-autocomplete=\"list\"\n  />\n</div>\n<div class=\"btn btn-icon\" [ngClass]=\"_isDisabled ? 'disabled ' : ''\" *ngIf=\"!_isReadOnly\">\n  <i\n    cdkMonitorElementFocus\n    [attr.aria-describedby]=\"uid + '-dropdown-aria'\"\n    [attr.tabindex]=\"_isDisabled ? '-1' : '0'\"\n    [attr.aria-hidden]=\"_isDisabled\"\n    class=\"bento-combobox-dropdown-button-icon\"\n    [class.bento-icon-caret-up-filled]=\"(isListVisible && !up) || (!isListVisible && up)\"\n    [class.bento-icon-caret-down-filled]=\"(!isListVisible && !up) || (isListVisible && up)\"\n    role=\"button\"\n  ></i>\n</div>\n<span class=\"sr-only\" [attr.id]=\"uid + '-dropdown-aria'\">{{ dropdownAriaLabel }}</span>\n<div\n  #listContainer\n  class=\"bui-bento-combobox-container bento-combobox-container\"\n  [bentoAppendTo]=\"appendTo\"\n  [side]=\"up ? 'top' : 'bottom'\"\n  [referenceTo]=\"input\"\n  [(open)]=\"isListVisible\"\n  [reszieWidthToReference]=\"true\"\n  (keydown)=\"_onListKeydown($event)\"\n>\n  <bento-combobox-list\n    #comboboxList\n    (highlightedIDChange)=\"_onHighlightedRowChange($event)\"\n    (selectedRowChange)=\"_onRowSelect($event)\"\n    [options]=\"options\"\n    [rowTemplate]=\"rowTemplate\"\n    (endOfScroll)=\"_onEndOfScroll()\"\n    [gridLabelId]=\"gridLabelId\"\n  ></bento-combobox-list>\n  <div\n    *ngIf=\"options.footerItems && options.footerItems.length > 0\"\n    #footerContainer\n    class=\"bui-bento-combobox-container-footer bento-combobox-container-footer\"\n  >\n    <div class=\"bui-bento-combobox-footer-inner bento-combobox-footer-inner\">\n      <div class=\"bui-bento-combobox-footer-row bento-combobox-footer-row\">\n        <div\n          *ngFor=\"let button of options.footerItems\"\n          class=\"bui-bento-combobox-footer-item bento-combobox-footer-item\"\n        >\n          <div class=\"bui-bento-combobox-footer-item-inner bento-combobox-footer-item-inner\">\n            <button\n              class=\"btn btn-link\"\n              type=\"button\"\n              [attr.tabindex]=\"isListVisible ? '0' : '-1'\"\n              [attr.aria-label]=\"button.ariaLabel\"\n              [disabled]=\"button.disableWhenHasResult && _list.length > 0\"\n              (click)=\"_onFooterButtonClick(button)\"\n              (keydown)=\"_onFooterItemKeydown($event, button)\"\n              ngbTooltip=\"{{ 'BENTO_UI_CBOX_OPTIONS' | bentoTranslate }}\"\n              container=\"body\"\n            >\n              <i *ngIf=\"button.icon\" [ngClass]=\"button.icon\" aria-hidden=\"true\"></i>\n              <span *ngIf=\"button.label?.length > 0\">\n                {{ button.label | bentoStringReplace: '_ITEM_':_inputLabel || button.defaultItemText }}\n              </span>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".ng-bento bento-combobox.bento-select{box-sizing:border-box;position:relative;overflow:hidden;cursor:auto;width:100%;border-width:0;z-index:auto;display:inline-block}.ng-bento bento-combobox.bento-select:not(.readonly) .form-control[readonly]:not(:disabled){font-weight:400}.ng-bento bento-combobox.bento-select input.ng-hide-add{display:none}.ng-bento bento-combobox.bento-select.open{overflow:visible}.ng-bento bento-combobox.bento-select.open input{border-bottom-left-radius:0;border-bottom-right-radius:0}.ng-bento bento-combobox.bento-select>.btn{pointer-events:auto;cursor:default;display:flex;align-items:center;justify-content:center}.ng-bento bento-combobox.bento-select>div.input-label.disabled{cursor:not-allowed;pointer-events:none}.ng-bento bento-combobox.bento-select>.btn.disabled{cursor:not-allowed;pointer-events:none;background:transparent}.ng-bento bento-combobox.bento-select input[disabled]:not(.readonly){cursor:not-allowed;font-weight:400;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-combobox.bento-select>.preloader{position:absolute;width:40px;top:0;bottom:0;right:30px;pointer-events:none}.ng-bento bento-combobox.bento-select>.preloader .bento-busyloader-blocker{background:transparent;z-index:auto}.ng-bento bento-combobox.bento-select.input-sm .bento-combobox-container{top:28px}.ng-bento bento-combobox.bento-select.input-sm>.btn [class*=bento-icon]{font-size:11px}.ng-bento bento-combobox.bento-select>i{position:absolute;top:9px;right:59px}.ng-bento bento-combobox.bento-select i.preloader{width:24px;height:24px;background-size:24px 24px;display:none}.ng-bento bento-combobox.bento-select div.input-label,.ng-bento bento-combobox.bento-select div.placeholder{cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-combobox.bento-select div.placeholder{position:absolute;left:0;top:0}.ng-bento bento-combobox.bento-select input[type=text],.ng-bento bento-combobox.bento-select div.input-label,.ng-bento bento-combobox.bento-select div.placeholder{box-sizing:border-box;width:100%;font-size:14px}.ng-bento bento-combobox.bento-select input[type=text]:focus,.ng-bento bento-combobox.bento-select div.input-label:focus,.ng-bento bento-combobox.bento-select div.placeholder:focus{outline:none}.ng-bento bento-combobox.bento-select .btn:hover{box-shadow:none}.ng-bento bento-combobox.bento-select .btn .bento-combobox-dropdown-button-icon{font-size:14px;top:0}.ng-bento body.touch,.ng-bento body.touch .bento-combobox-container-body{-webkit-overflow-scrolling:touch}.ng-bento .bui-bento-combobox-container{display:block;position:absolute;margin-top:-1px;min-width:100%;min-height:0;z-index:10;border-width:1px;border-style:solid;width:auto;overflow:hidden;visibility:hidden;opacity:0;transition:border .3s,opacity .2s}.open .ng-bento .bui-bento-combobox-container,.ng-bento .bui-bento-combobox-container.bento-append-to{visibility:visible;opacity:1}.ng-bento .bui-bento-combobox-container.out{opacity:0;transition:opacity .2s}.up .ng-bento .bui-bento-combobox-container,.dropup .ng-bento .bui-bento-combobox-container{top:auto;margin:0 0 -1px}.ng-bento .bui-bento-combobox-container bento-list{margin-bottom:-1px;border:none;position:absolute;width:100%}.ng-bento .bui-bento-combobox-container ul,.ng-bento .bui-bento-combobox-container ol{margin:0;padding:0}.ng-bento .bui-bento-combobox-container.dropdown-menu-up{margin:0 0 -1px}.ng-bento .bui-bento-combobox-container.bento-append-to{margin:0}.ng-bento .bui-bento-combobox-list-wrapper{display:table-row}.ng-bento .bui-bento-combobox-container-header{font-weight:700;padding-right:0;text-transform:capitalize;list-style:none;white-space:nowrap;display:table-header-group;width:100%}[dir=rtl] .ng-bento .bui-bento-combobox-container-header{padding-left:0;padding-right:auto}.ng-bento .bui-bento-combobox-container-header-label{padding:5px 10px;white-space:nowrap;display:table-cell;border-bottom-width:1px;border-bottom-style:solid}.ng-bento .bui-bento-combobox-container-header-label-filler{padding:0}.ng-bento .bui-bento-combobox-container-footer{display:block;width:100%;height:35px;border-top-style:solid;border-top-width:1px;position:relative;line-height:normal;font-size:12px}.ng-bento .bui-bento-combobox-footer-inner{display:table;width:100%;height:35px}.ng-bento .bui-bento-combobox-footer-row{display:table-row}.ng-bento .bui-bento-combobox-footer-item{display:table-cell;position:relative;vertical-align:middle;text-align:center}.ng-bento .bui-bento-combobox-footer-item .btn{padding:0 3px;letter-spacing:0;cursor:pointer}.ng-bento .bui-bento-combobox-footer-item .btn:disabled{pointer-events:none}.ng-bento .bui-bento-combobox-footer-item .btn:disabled:hover span{text-decoration:none}.ng-bento .bui-bento-combobox-footer-item .btn i:first-child,.ng-bento .bui-bento-combobox-footer-item .btn i:last-child{margin:0!important;top:0;vertical-align:baseline}.ng-bento .bui-bento-combobox-footer-item .btn:hover{text-decoration:none}.ng-bento .bui-bento-combobox-footer-item .btn:hover span{text-decoration:underline}.ng-bento .bui-bento-combobox-footer-item:last-child{text-align:right}[dir=rtl] .ng-bento .bui-bento-combobox-footer-item:last-child{text-align:left}.ng-bento .bui-bento-combobox-footer-item:first-child{text-align:left}[dir=rtl] .ng-bento .bui-bento-combobox-footer-item:first-child{text-align:right}.ng-bento .bui-bento-combobox-footer-item-inner{width:100%;vertical-align:middle;white-space:nowrap;padding:0 14px;text-overflow:ellipsis;overflow:visible}.ng-bento bento-combobox-list .bento-combobox-container-empty-label{font-size:100px;height:100px;left:50%;opacity:.1;position:absolute;top:50%;transform:translate(-50%,-60px);width:100px;z-index:-1}.ng-bento .bui-bento-combobox-container-list{display:table;table-layout:fixed;position:relative;width:calc(100% + 1px)}.ng-bento .bui-bento-combobox-container-list .bento-list-viewport .cdk-virtual-scroll-content-wrapper{display:table;table-layout:fixed;width:100%}.ng-bento .bui-bento-combobox-container-item.bento-list-row{display:table-row;cursor:pointer}.ng-bento .bui-bento-combobox-container-item.bento-list-row>span,.ng-bento .bui-bento-combobox-container-item.bento-list-row>div{display:table-cell;padding:6px 10px;line-height:17px;border-bottom-width:1px;border-bottom-style:solid;overflow:hidden;box-sizing:border-box}.ng-bento .bui-bento-combobox-container-item.bento-list-row>span [class^=bento-icon-],.ng-bento .bui-bento-combobox-container-item.bento-list-row>span [class*=\" bento-icon-\"],.ng-bento .bui-bento-combobox-container-item.bento-list-row>div [class^=bento-icon-],.ng-bento .bui-bento-combobox-container-item.bento-list-row>div [class*=\" bento-icon-\"]{line-height:inherit}.ng-bento .bui-bento-combobox-container-item.bento-list-row>span:last-child,.ng-bento .bui-bento-combobox-container-item.bento-list-row>div:last-child{padding-right:23px}[dir=rtl] .ng-bento .bui-bento-combobox-container-item.bento-list-row>span:last-child,[dir=rtl] .ng-bento .bui-bento-combobox-container-item.bento-list-row>div:last-child{padding-right:10px;padding-left:23px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BentoTabService }, { type: BentoLogService }, { type: BentoTranslate }, { type: i1$2.DomSanitizer }, { type: i0.ChangeDetectorRef }, { type: WindowRef }]; }, propDecorators: { isListVisible: [{
                type: HostBinding,
                args: ['class.open']
            }, {
                type: HostBinding,
                args: ['attr.aria-expanded']
            }], appendTo: [{
                type: Input
            }], options: [{
                type: Input
            }], up: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.dropup']
            }], _isReadOnly: [{
                type: HostBinding,
                args: ['class.readonly']
            }, {
                type: Input,
                args: ['readonly']
            }], search: [{
                type: Output
            }], resetItems: [{
                type: Output
            }], endOfScroll: [{
                type: Output
            }], open: [{
                type: Input
            }], openChange: [{
                type: Output
            }], itemsObservable: [{
                type: Input
            }], required: [{
                type: Input
            }], revertOnInvalidInput: [{
                type: Input
            }], rowTemplate: [{
                type: Input
            }], id: [{
                type: Input
            }], inputLabelText: [{
                type: Input
            }], inputLabelClass: [{
                type: Input
            }], _inputElRef: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], _list: [{
                type: ViewChild,
                args: [BentoComboboxListComponent, { static: true }]
            }], _isDisabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }], _listContainer: [{
                type: ViewChild,
                args: ['listContainer', { static: true }]
            }], footerContainer: [{
                type: ViewChild,
                args: ['footerContainer', { static: true }]
            }], onFocusOut: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }], _onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], _onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], _onFocusin: [{
                type: HostListener,
                args: ['focusin', ['$event.relatedTarget']]
            }] } });

class BentoListModule extends ConsumerDataValidator {
}
BentoListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListModule, declarations: [BentoListComponent, BentoListSubscribable], imports: [CommonModule, BentoUtilsModule, ScrollingModule], exports: [BentoListComponent] });
BentoListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListModule, imports: [[CommonModule, BentoUtilsModule, ScrollingModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, BentoUtilsModule, ScrollingModule],
                    declarations: [BentoListComponent, BentoListSubscribable],
                    exports: [BentoListComponent]
                }]
        }] });

class BentoNgbTooltipSupportModule extends ConsumerDataValidator {
    constructor(tooltipConfig) {
        super();
        tooltipConfig.animation = false;
    }
}
BentoNgbTooltipSupportModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbTooltipSupportModule, deps: [{ token: i1$1.NgbTooltipConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoNgbTooltipSupportModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbTooltipSupportModule, declarations: [BentoNgbTooltipSupportDirective], imports: [CommonModule], exports: [BentoNgbTooltipSupportDirective] });
BentoNgbTooltipSupportModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbTooltipSupportModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbTooltipSupportModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoNgbTooltipSupportDirective],
                    imports: [CommonModule],
                    exports: [BentoNgbTooltipSupportDirective],
                    providers: []
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbTooltipConfig }]; } });

/**
 * This component adds a delete button at the right end of an input, to clear its current value.
 */
class BentoResetDirective {
    /**
     */
    constructor(elementRef, r, ngControl, dir, bentoTranslate, focusMonitor, windowRef) {
        this.elementRef = elementRef;
        this.r = r;
        this.ngControl = ngControl;
        this.dir = dir;
        this.bentoTranslate = bentoTranslate;
        this.focusMonitor = focusMonitor;
        /** Subscription to the Directionality change EventEmitter. */
        this.dirChangeSubscription = Subscription.EMPTY;
        this.translationChangeSubscription = Subscription.EMPTY;
        this.document = windowRef.nativeDocument;
        this.isRtl = dir.value === 'rtl';
        this.dirChangeSubscription = dir.change.subscribe(() => {
            this.flipDirection();
        });
        this.closeBtnEl = this.r.createElement('button');
        this.r.addClass(this.closeBtnEl, 'bento-reset-close-button');
        this.r.setProperty(this.closeBtnEl, 'innerHTML', `<i class="bento-icon-close-x" aria-hidden="true"></i>`);
        this.r.listen(this.closeBtnEl, 'blur', e => this.onResetButtonBlur(e));
        this.windowResizeListenerCancel = this.r.listen('window', 'resize', () => this.alignCloseButton());
        this.focusMonitor.monitor(this.closeBtnEl);
        // Mousedown
        this.r.listen(this.closeBtnEl, 'mousedown', $event => {
            // Cancel hide button timeout
            clearTimeout(this.blurTimneoutID);
            this.reset();
            $event.stopPropagation();
            $event.preventDefault();
        });
        // Keydown
        this.r.listen(this.closeBtnEl, 'keydown', ($event) => {
            if ($event.keyCode === Keyboard.ENTER || $event.keyCode === Keyboard.SPACE) {
                // Cancel hide button timeout
                clearTimeout(this.blurTimneoutID);
                this.reset();
                $event.stopPropagation();
                $event.preventDefault();
            }
        });
        // Touchstart
        this.r.listen(this.closeBtnEl, 'touchstart', $event => {
            // Cancel hide button timeout
            clearTimeout(this.blurTimneoutID);
            this.reset();
            $event.stopPropagation();
            $event.preventDefault();
        });
    }
    /**
     * Focus event listener to the input
     */
    onFocus(input) {
        this.checkAndUpdateCloseButton();
    }
    /**
     * Blur event listener to the input
     */
    onBlur(e) {
        setTimeout(() => {
            // In some browsers TAB does not directly move focus to the next tabbable element
            // Instead it focuses to the <body> element first then move on to the next element
            // so we need to wait for a bit to determine
            this.checkAndUpdateCloseButton();
        }, 1);
    }
    /**
     * Input event listener to the input
     */
    onInput(input) {
        this.value = input.value;
        this.checkAndUpdateCloseButton();
    }
    ngOnInit() {
        // ngControl Listener
        this.ngControl.valueChanges.subscribe(v => this.onValueChange(v));
    }
    /**
     * Init when the view is ready
     */
    ngAfterViewInit() {
        this.setCloseButtonTranslation();
        this.checkAndUpdateCloseButton();
        this.translationChangeSubscription = this.bentoTranslate.translationChange.subscribe(() => this.setCloseButtonTranslation());
    }
    /**
     * Clean the close button from memory
     */
    ngOnDestroy() {
        if (this.closeBtnEl.parentElement) {
            this.r.removeChild(this.closeBtnEl.parentElement, this.closeBtnEl);
        }
        this.closeBtnEl = null;
        this.dirChangeSubscription.unsubscribe();
        this.translationChangeSubscription.unsubscribe();
        this.windowResizeListenerCancel();
        this.focusMonitor.stopMonitoring(this.closeBtnEl);
    }
    /**
     * Reset input
     */
    reset() {
        this.r.setProperty(this.elementRef.nativeElement, 'value', null);
        this.elementRef.nativeElement.focus();
        this.value = null;
        this.ngControl.reset();
        this.hideCloseButton();
    }
    /**
     * Aligh close button to the input field, this method needs to be manually called in some cases
     */
    alignCloseButton() {
        if (this.closeBtnEl && this.closeBtnEl.parentElement) {
            const el = this.elementRef.nativeElement;
            const w = el.offsetWidth;
            const h = el.offsetHeight;
            const l = el.offsetLeft;
            const t = el.offsetTop;
            const bh = this.closeBtnEl.offsetHeight;
            const bw = this.closeBtnEl.offsetWidth;
            if (!bh) {
                // Cannot align since the button is not in view
                return;
            }
            this.r.setStyle(this.closeBtnEl, this.isRtl ? 'right' : 'left', l + w - bw - 5 + 'px');
            this.r.setStyle(this.closeBtnEl, 'top', t + (h - bh) * 0.5 + 'px');
        }
    }
    checkAndUpdateCloseButton() {
        const aEl = this.document.activeElement;
        const el = this.elementRef.nativeElement;
        if (aEl === this.closeBtnEl || aEl === this.elementRef.nativeElement) {
            if ((this.value && String(this.value).length > 0) || this.value === 0) {
                this.showCloseButton();
            }
            else {
                this.hideCloseButton();
            }
            this.r.addClass(el, 'bui-focused');
        }
        else {
            this.hideCloseButton();
            this.r.removeClass(el, 'bui-focused');
        }
    }
    /**
     * Show the close button
     */
    showCloseButton() {
        if (this.elementRef.nativeElement.readOnly || this.closeBtnEl.parentElement) {
            // Do not show if this element is readonly
            // Or the close button is already in viewport
            return;
        }
        const nextSibling = this.r.nextSibling(this.elementRef.nativeElement);
        const parentElement = this.elementRef.nativeElement.parentElement;
        if (nextSibling) {
            this.r.insertBefore(parentElement, this.closeBtnEl, nextSibling);
        }
        else {
            this.r.appendChild(parentElement, this.closeBtnEl);
        }
        this.alignCloseButton();
    }
    /**
     * Hide the close button
     */
    hideCloseButton() {
        if (this.closeBtnEl && this.closeBtnEl.parentElement) {
            this.r.removeChild(this.closeBtnEl.parentElement, this.closeBtnEl); // hide from all screens
        }
    }
    onResetButtonBlur(e) {
        setTimeout(() => {
            // In some browsers TAB does not directly move focus to the next tabbable element
            // Instead it focuses to the <body> element first then move on to the next element
            // so we need to wait for a bit to determine
            this.checkAndUpdateCloseButton();
        }, 1);
    }
    /**
     * Close button's aria label needs to be translated
     */
    setCloseButtonTranslation() {
        let resetString = this.bentoTranslate.instantTranslate('BENTO_UI_RESET_ARIA_LABEL');
        const inputID = this.elementRef.nativeElement.id;
        let inputLabel = '';
        let labelEl;
        if (inputID &&
            inputID.length &&
            (labelEl = this.document.querySelector('[for="' + inputID + '"]'))) {
            inputLabel = labelEl.innerText;
        }
        resetString = resetString.replace('_LABEL_', inputLabel);
        this.r.setAttribute(this.closeBtnEl, 'aria-label', resetString);
    }
    /**
     * Callback to catch value change on the formcontrol
     */
    onValueChange(v) {
        this.value = v;
        this.checkAndUpdateCloseButton();
    }
    flipDirection() {
        this.isRtl = this.dir.value === 'rtl';
    }
}
BentoResetDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoResetDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i6.NgControl }, { token: i2.Directionality }, { token: BentoTranslate }, { token: i3.FocusMonitor }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoResetDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]", host: { listeners: { "focus": "onFocus($event.target)", "blur": "onBlur($event)", "input": "onInput($event.target)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoResetDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input:not([type=checkbox])[formControlName][bentoReset],' +
                        'input:not([type=checkbox])[formControl][bentoReset],' +
                        'input:not([type=checkbox])[ngModel][bentoReset]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i6.NgControl }, { type: i2.Directionality }, { type: BentoTranslate }, { type: i3.FocusMonitor }, { type: WindowRef }]; }, propDecorators: { onFocus: [{
                type: HostListener,
                args: ['focus', ['$event.target']]
            }], onBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target']]
            }] } });

class BentoResetModule extends ConsumerDataValidator {
}
BentoResetModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoResetModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoResetModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoResetModule, declarations: [BentoResetDirective], imports: [BentoTranslateModule, BentoUtilsModule], exports: [BentoResetDirective] });
BentoResetModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoResetModule, imports: [[BentoTranslateModule, BentoUtilsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoResetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [BentoTranslateModule, BentoUtilsModule],
                    declarations: [BentoResetDirective],
                    exports: [BentoResetDirective]
                }]
        }] });

class BentoComboboxModule extends ConsumerDataValidator {
}
BentoComboboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoComboboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxModule, declarations: [BentoComboboxComponent, BentoComboboxListComponent], imports: [CommonModule,
        BentoListModule,
        BentoResetModule,
        FormsModule,
        BentoAppendToModule,
        ReactiveFormsModule,
        BentoUtilsModule,
        BentoTranslateModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule,
        A11yModule], exports: [BentoComboboxComponent] });
BentoComboboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxModule, imports: [[
            CommonModule,
            BentoListModule,
            BentoResetModule,
            FormsModule,
            BentoAppendToModule,
            ReactiveFormsModule,
            BentoUtilsModule,
            BentoTranslateModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule,
            A11yModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoListModule,
                        BentoResetModule,
                        FormsModule,
                        BentoAppendToModule,
                        ReactiveFormsModule,
                        BentoUtilsModule,
                        BentoTranslateModule,
                        BentoFocusMonitorModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule,
                        A11yModule
                    ],
                    declarations: [BentoComboboxComponent, BentoComboboxListComponent],
                    exports: [BentoComboboxComponent]
                }]
        }] });

/**
 * Contextual Header is an informational component that most of the time is used in conjunction with FlexGrid.
 * Though it resembles Breadcrumbs, nothing is clickable or navigational in it except
 * an optional "Back" button that would take a user to the previous page.
 *
 * Many times users open a page (drill down) in a different browser window instead of using navigation.
 * When multiple windows are opened, it is necessary to show the hierarchy.
 * Contextual Header allows users to easy see the difference between opened pages, and know exactly where they are.
 */
class BentoContextualHeaderComponent {
    /**
     * Component constructor
     */
    constructor(elementRef, cdr) {
        this.cdr = cdr;
        /**
         * Flag to determine if the back button is disabled
         */
        this.backButtonDisabled = false;
        /**
         * Flag to determine if the back button is hidden
         */
        this.backButtonHidden = false;
        /**
         * Callback when the back button is clicked
         */
        this.backButtonClick = new EventEmitter();
        this.el = elementRef.nativeElement;
    }
    ngAfterViewInit() {
        this.cdr.detectChanges();
    }
    /**
     * Callback when the back button is clicked
     */
    _onBackButtonClick() {
        this.backButtonClick.emit();
    }
    /**
     * Check if the string has an image extension
     */
    _isImage(v) {
        return /[^\s]+(\.(jpg|png|gif|bmp|svg)$)/.test(v);
    }
    /**
     * Gets a string for a header by its given index to tooltip when it's needed,
     * otherwise returns `false`
     */
    _getTooltipFromHeader(index) {
        if (!this.el) {
            return;
        }
        const headerEl = this.el.querySelector('div[rel="' + index + '"]');
        const subHeaderEl = this.el.querySelector('div[rel="sub-' + index + '"]');
        if ((headerEl && headerEl.offsetWidth < headerEl.scrollWidth) ||
            (subHeaderEl && subHeaderEl.offsetWidth < subHeaderEl.scrollWidth)) {
            const item = this.items[index];
            return item.subtitle ? [item.title, item.subtitle].join(' - ') : item.title;
        }
        else {
            return false;
        }
    }
    /**
     * When the custom button is clicked
     */
    _onCustomButtonClick(e) {
        if (this.customButton) {
            this.customButton.action();
        }
        e.stopPropagation();
        e.preventDefault();
    }
}
BentoContextualHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoContextualHeaderComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoContextualHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoContextualHeaderComponent, selector: "bento-contextual-header", inputs: { items: "items", backButtonDisabled: "backButtonDisabled", backButtonHidden: "backButtonHidden", customButton: "customButton" }, outputs: { backButtonClick: "backButtonClick" }, ngImport: i0, template: "<div class=\"bento-contextual-header-inner\">\n  <button\n    class=\"bch-back-button btn-flat-secondary\"\n    *ngIf=\"!backButtonHidden\"\n    (click)=\"_onBackButtonClick()\"\n    [disabled]=\"backButtonDisabled\"\n    attr.aria-label=\"{{ 'BENTO_UI_CONTEXTUAL_HEADER_BACK' | bentoTranslate }}\"\n    ngbTooltip=\"{{ 'BENTO_UI_CONTEXTUAL_HEADER_BACK' | bentoTranslate }}\"\n  >\n    <i class=\"bento-icon-arrow-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"bch-main-container\">\n    <div class=\"bch-main-container-inner\">\n      <div\n        class=\"bch-header\"\n        *ngFor=\"let item of items; let $index = index\"\n        triggers=\"click\"\n        autoClose=\"inside\"\n        [ngbTooltip]=\"_getTooltipFromHeader($index)\"\n        placement=\"bottom\"\n      >\n        <div *ngIf=\"item.icon && !_isImage(item.icon); then itemIconCSSClass\"></div>\n        <div *ngIf=\"item.icon && _isImage(item.icon); then itemIconImage\"></div>\n        <ng-template #itemIconImage>\n          <figure aria-hidden=\"true\" class=\"bch-header-graphic\">\n            <img [src]=\"item.icon\" />\n          </figure>\n        </ng-template>\n        <ng-template #itemIconCSSClass>\n          <figure aria-hidden=\"true\" class=\"bch-header-graphic\">\n            <i [class]=\"item.icon\"></i>\n          </figure>\n        </ng-template>\n        <div class=\"bch-header-title-container\">\n          <div class=\"bch-header-title\" [attr.rel]=\"$index\">{{ item.title }}</div>\n          <div *ngIf=\"item.subtitle\" [attr.rel]=\"'sub-' + $index\" class=\"bch-header-subtitle\">{{ item.subtitle }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"bch-right-container\" *ngIf=\"customButton\">\n    <button class=\"btn btn-primary btn-sm\" (click)=\"_onCustomButtonClick($event)\" [disabled]=\"customButton.disabled\">\n      {{ customButton.label }}\n    </button>\n  </div>\n</div>\n", styles: [".ng-bento bento-contextual-header{display:table;position:relative;width:100%;border-bottom-style:solid;box-sizing:content-box}.ng-bento bento-contextual-header .bento-contextual-header-inner{display:table-row}.ng-bento bento-contextual-header .bento-contextual-header-inner>div:last-child .bch-header:last-child{border:none}.ng-bento bento-contextual-header .bch-main-container{display:table-cell;width:100%;vertical-align:middle}.ng-bento bento-contextual-header .bch-main-container-inner{display:flex;position:relative}.ng-bento bento-contextual-header .bch-back-button{display:table-cell;border-width:0 1px 0 0;border-right-style:solid;background:transparent;font-size:20px;padding-top:0;padding-bottom:0;vertical-align:middle}[dir=rtl] .ng-bento bento-contextual-header .bch-back-button{border-right-width:0;border-right-style:none;border-left-width:1px;border-left-style:solid}.ng-bento bento-contextual-header .bch-header{border-right-style:solid;border-right-width:1px;cursor:default;flex-grow:1;height:26px;padding:0;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir=rtl] .ng-bento bento-contextual-header .bch-header{border-left-style:solid;border-left-width:1px;border-right-style:none;border-right-width:0}.ng-bento bento-contextual-header .bch-header-title-container{position:absolute;top:0;left:5px;bottom:0;right:0;padding:0 7px 0 10px}[dir=rtl] .ng-bento bento-contextual-header .bch-header-title-container{padding:0 10px 0 7px;left:0;right:5px}.ng-bento bento-contextual-header .bch-header-graphic{float:left;width:41px;height:26px;font-size:25px;padding:0 0 0 15px}.ng-bento bento-contextual-header .bch-header-graphic i{display:block;line-height:26px}.ng-bento bento-contextual-header .bch-header-graphic img{display:block;width:26px;max-height:26px;vertical-align:top}.ng-bento bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:41px}[dir=rtl] .ng-bento bento-contextual-header .bch-header-graphic{float:right;padding:0 15px 0 0}[dir=rtl] .ng-bento bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:0;right:41px}.ng-bento bento-contextual-header .bch-header-title{font-size:16px;line-height:16px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}.ng-bento bento-contextual-header .bch-header-title:only-child{line-height:26px}.ng-bento bento-contextual-header .bch-header-subtitle{font-size:11px;line-height:14px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}.ng-bento bento-contextual-header .bch-right-container{display:table-cell;vertical-align:middle;width:0;padding:0 15px 1px}\n"], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "bentoTranslate": BentoTranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoContextualHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-contextual-header', encapsulation: ViewEncapsulation.None, template: "<div class=\"bento-contextual-header-inner\">\n  <button\n    class=\"bch-back-button btn-flat-secondary\"\n    *ngIf=\"!backButtonHidden\"\n    (click)=\"_onBackButtonClick()\"\n    [disabled]=\"backButtonDisabled\"\n    attr.aria-label=\"{{ 'BENTO_UI_CONTEXTUAL_HEADER_BACK' | bentoTranslate }}\"\n    ngbTooltip=\"{{ 'BENTO_UI_CONTEXTUAL_HEADER_BACK' | bentoTranslate }}\"\n  >\n    <i class=\"bento-icon-arrow-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"bch-main-container\">\n    <div class=\"bch-main-container-inner\">\n      <div\n        class=\"bch-header\"\n        *ngFor=\"let item of items; let $index = index\"\n        triggers=\"click\"\n        autoClose=\"inside\"\n        [ngbTooltip]=\"_getTooltipFromHeader($index)\"\n        placement=\"bottom\"\n      >\n        <div *ngIf=\"item.icon && !_isImage(item.icon); then itemIconCSSClass\"></div>\n        <div *ngIf=\"item.icon && _isImage(item.icon); then itemIconImage\"></div>\n        <ng-template #itemIconImage>\n          <figure aria-hidden=\"true\" class=\"bch-header-graphic\">\n            <img [src]=\"item.icon\" />\n          </figure>\n        </ng-template>\n        <ng-template #itemIconCSSClass>\n          <figure aria-hidden=\"true\" class=\"bch-header-graphic\">\n            <i [class]=\"item.icon\"></i>\n          </figure>\n        </ng-template>\n        <div class=\"bch-header-title-container\">\n          <div class=\"bch-header-title\" [attr.rel]=\"$index\">{{ item.title }}</div>\n          <div *ngIf=\"item.subtitle\" [attr.rel]=\"'sub-' + $index\" class=\"bch-header-subtitle\">{{ item.subtitle }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"bch-right-container\" *ngIf=\"customButton\">\n    <button class=\"btn btn-primary btn-sm\" (click)=\"_onCustomButtonClick($event)\" [disabled]=\"customButton.disabled\">\n      {{ customButton.label }}\n    </button>\n  </div>\n</div>\n", styles: [".ng-bento bento-contextual-header{display:table;position:relative;width:100%;border-bottom-style:solid;box-sizing:content-box}.ng-bento bento-contextual-header .bento-contextual-header-inner{display:table-row}.ng-bento bento-contextual-header .bento-contextual-header-inner>div:last-child .bch-header:last-child{border:none}.ng-bento bento-contextual-header .bch-main-container{display:table-cell;width:100%;vertical-align:middle}.ng-bento bento-contextual-header .bch-main-container-inner{display:flex;position:relative}.ng-bento bento-contextual-header .bch-back-button{display:table-cell;border-width:0 1px 0 0;border-right-style:solid;background:transparent;font-size:20px;padding-top:0;padding-bottom:0;vertical-align:middle}[dir=rtl] .ng-bento bento-contextual-header .bch-back-button{border-right-width:0;border-right-style:none;border-left-width:1px;border-left-style:solid}.ng-bento bento-contextual-header .bch-header{border-right-style:solid;border-right-width:1px;cursor:default;flex-grow:1;height:26px;padding:0;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir=rtl] .ng-bento bento-contextual-header .bch-header{border-left-style:solid;border-left-width:1px;border-right-style:none;border-right-width:0}.ng-bento bento-contextual-header .bch-header-title-container{position:absolute;top:0;left:5px;bottom:0;right:0;padding:0 7px 0 10px}[dir=rtl] .ng-bento bento-contextual-header .bch-header-title-container{padding:0 10px 0 7px;left:0;right:5px}.ng-bento bento-contextual-header .bch-header-graphic{float:left;width:41px;height:26px;font-size:25px;padding:0 0 0 15px}.ng-bento bento-contextual-header .bch-header-graphic i{display:block;line-height:26px}.ng-bento bento-contextual-header .bch-header-graphic img{display:block;width:26px;max-height:26px;vertical-align:top}.ng-bento bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:41px}[dir=rtl] .ng-bento bento-contextual-header .bch-header-graphic{float:right;padding:0 15px 0 0}[dir=rtl] .ng-bento bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:0;right:41px}.ng-bento bento-contextual-header .bch-header-title{font-size:16px;line-height:16px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}.ng-bento bento-contextual-header .bch-header-title:only-child{line-height:26px}.ng-bento bento-contextual-header .bch-header-subtitle{font-size:11px;line-height:14px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}.ng-bento bento-contextual-header .bch-right-container{display:table-cell;vertical-align:middle;width:0;padding:0 15px 1px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { items: [{
                type: Input
            }], backButtonDisabled: [{
                type: Input
            }], backButtonHidden: [{
                type: Input
            }], customButton: [{
                type: Input
            }], backButtonClick: [{
                type: Output
            }] } });

/**
 * A class that defines the items that are rendered by the `BentoContextualHeaderComponent` component
 */
class BentoContextualHeaderItem {
    /**
     * Constructor of `BentoContextualHeaderItem`
     */
    constructor(title, subtitle, icon) {
        this.title = title;
        this.subtitle = subtitle;
        this.icon = icon;
    }
}

class BentoContextualHeaderModule extends ConsumerDataValidator {
}
BentoContextualHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoContextualHeaderModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoContextualHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoContextualHeaderModule, declarations: [BentoContextualHeaderComponent], imports: [NgbTooltipModule,
        CommonModule,
        BentoTranslateModule,
        BentoNgbTooltipSupportModule,
        BentoFocusMonitorModule], exports: [BentoContextualHeaderComponent] });
BentoContextualHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoContextualHeaderModule, imports: [[
            NgbTooltipModule,
            CommonModule,
            BentoTranslateModule,
            BentoNgbTooltipSupportModule,
            BentoFocusMonitorModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoContextualHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NgbTooltipModule,
                        CommonModule,
                        BentoTranslateModule,
                        BentoNgbTooltipSupportModule,
                        BentoFocusMonitorModule
                    ],
                    declarations: [BentoContextualHeaderComponent],
                    exports: [BentoContextualHeaderComponent]
                }]
        }] });

class BentoDatepickerAccessibilityDirective {
    constructor(elementRef, r) {
        this.elementRef = elementRef;
        this.r = r;
    }
    ngAfterViewInit() {
        let todayDate = this.elementRef.nativeElement.querySelector('.ngb-dp-today');
        setTimeout(() => {
            let selectedDate = this.elementRef.nativeElement.querySelector('div[ng-reflect-selected="true"]');
            if (!!selectedDate) {
                let selectParentElement = selectedDate.parentElement;
                selectParentElement.setAttribute('aria-label', selectParentElement.getAttribute('aria-label') + ', selected');
            }
        });
        this.r.setAttribute(todayDate, 'aria-current', todayDate.getAttribute('aria-label'));
    }
    onDateSelect() {
        let selectedDate = event.target;
        let selectParentElement = selectedDate.parentElement;
        if (!selectParentElement.getAttribute('aria-label').includes('selected')) {
            selectParentElement.setAttribute('aria-label', selectParentElement.getAttribute('aria-label') + ', selected');
        }
    }
}
BentoDatepickerAccessibilityDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerAccessibilityDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
BentoDatepickerAccessibilityDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoDatepickerAccessibilityDirective, selector: "[bentoDatepickerAccessibility]", inputs: { bentoDatepickerAccessibility: "bentoDatepickerAccessibility" }, host: { listeners: { "dateSelect": "onDateSelect()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerAccessibilityDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoDatepickerAccessibility]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { bentoDatepickerAccessibility: [{
                type: Input
            }], onDateSelect: [{
                type: HostListener,
                args: ['dateSelect']
            }] } });

class BentoDatepickerAccessibilityModule extends ConsumerDataValidator {
    constructor(ngbDatepickerConfig) {
        super();
    }
}
BentoDatepickerAccessibilityModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerAccessibilityModule, deps: [{ token: i1$1.NgbDatepickerConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoDatepickerAccessibilityModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerAccessibilityModule, declarations: [BentoDatepickerAccessibilityDirective], exports: [BentoDatepickerAccessibilityDirective] });
BentoDatepickerAccessibilityModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerAccessibilityModule, providers: [NgbDatepickerConfig] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerAccessibilityModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoDatepickerAccessibilityDirective],
                    exports: [BentoDatepickerAccessibilityDirective],
                    providers: [NgbDatepickerConfig]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbDatepickerConfig }]; } });

/**
 * This directive should be used on a button element to toggle datepicker popup visibility.
 * Additionally it hides popup when user clicks outside it.
 * @author <a href="mailto:raman.zhylich@thomsonreuters.com">Raman Zhylich</a>
 */
class BentoDatepickerToggleDirective {
    /**
     */
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
    }
    /**
     * Init
     */
    ngOnInit() {
        const inputDatepickerElRef = this.bentoDatepickerToggle._elRef;
        // Subscribe on focusout of parent element. We don't use document:click to avoid memory leaks.
        this._focusOutEventHandler = this._renderer.listen(inputDatepickerElRef.nativeElement.parentElement, 'focusout', $event => this.onFocusOut($event));
    }
    /**
     * Destroy -> cleanup
     */
    ngOnDestroy() {
        if (this._focusOutEventHandler) {
            this._focusOutEventHandler();
        }
    }
    /**
     * Toggle datepicker popup when button is clicked.
     */
    _onClick() {
        var _a;
        this.bentoDatepickerToggle.toggle();
        let datePicker = (_a = this.bentoDatepickerToggle['_cRef']) === null || _a === void 0 ? void 0 : _a.location.nativeElement;
        if (!!datePicker) {
            datePicker.setAttribute('role', 'dialog');
        }
    }
    /**
     * Triggered when focus is lost on datepicker's parent element or one of its children.
     */
    onFocusOut($event) {
        const datepickerCmpRef = this.bentoDatepickerToggle._cRef;
        if (this.bentoDatepickerToggle.isOpen()) {
            // Ignore cases when user clicks inside popup or on a "toggle" button.
            if (!this._elementRef.nativeElement.contains($event.relatedTarget) &&
                !datepickerCmpRef.location.nativeElement.contains($event.relatedTarget)) {
                setTimeout(() => this.bentoDatepickerToggle.close());
            }
        }
    }
}
BentoDatepickerToggleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerToggleDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoDatepickerToggleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoDatepickerToggleDirective, selector: "[bentoDatepickerToggle]", inputs: { bentoDatepickerToggle: "bentoDatepickerToggle" }, host: { listeners: { "click": "_onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoDatepickerToggle]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { bentoDatepickerToggle: [{
                type: Input,
                args: ['bentoDatepickerToggle']
            }], _onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class BentoDatepickerToggleModule extends ConsumerDataValidator {
    constructor(ngbDatepickerConfig) {
        super();
        // Per CUX design request, all outside days should be hidden
        // This also matches with Xavier datepicker UI
        ngbDatepickerConfig.outsideDays = 'hidden';
    }
}
BentoDatepickerToggleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerToggleModule, deps: [{ token: i1$1.NgbDatepickerConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoDatepickerToggleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerToggleModule, declarations: [BentoDatepickerToggleDirective], exports: [BentoDatepickerToggleDirective] });
BentoDatepickerToggleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerToggleModule, providers: [NgbDatepickerConfig] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoDatepickerToggleDirective],
                    exports: [BentoDatepickerToggleDirective],
                    providers: [NgbDatepickerConfig]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbDatepickerConfig }]; } });

class BentoDatePickerConfig {
    constructor() {
        /**
         * Contains two strings: format and type.
         *
         * type: Date type. Can be 'recent' or 'dob'
         * When type is 'recent', a '20' is inserted at the beginning of the year
         * if the user types in 2 digits for year.
         * When type is 'dob', a '19' is inserted at the beginning if the two digits
         * are greater than or equal to the last two digits of the current year + 1.
         * For example, if '05/25/21' is entered, then '05/25/1921' will be entered
         * when leaving the field.
         *
         * format: Date format. Can be 'mm/dd/yyyy', 'dd/mm/yyyy', 'yyyy-mm-dd', 'yy-mm-dd'.
         * 'yy-mm-dd' corresponds to Canadian date format.
         */
        this.datepickerConfig = { format: '', type: '' };
    }
    /**
     * Sets format property.
     * @param format Input format.
     */
    setFormat(format) {
        this.datepickerConfig.format = format;
    }
    /**
     * Sets type property.
     * @param type Input type.
     */
    setType(type) {
        this.datepickerConfig.type = type;
    }
}
BentoDatePickerConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatePickerConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoDatePickerConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatePickerConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatePickerConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * BentoDefaultNgbDateParserFormatter.
 * Parses and formats depending on what format and type are set.
 * @author <a href="mailto:lisa.schuler@thomsonreuters.com">Lisa Schuler</a>
 */
class BentoDefaultNgbDateParserFormatter extends NgbDateParserFormatter {
    /**
     * Ctor
     * @param bentoDatepickerConfig BentoDatePickerConfig
     */
    constructor(bentoDatepickerConfig) {
        super();
        this.bentoDatepickerConfig = bentoDatepickerConfig;
        /**
         * Slash delimiter
         */
        this.SLASH_DELIMITER = '/';
        /**
         * Dash delimiter
         */
        this.DASH_DELIMITER = '-';
    }
    /**
     * Getter for format
     */
    get dateFormat() {
        return this.bentoDatepickerConfig.datepickerConfig.format;
    }
    /**
     * Getter for type
     */
    get type() {
        return this.bentoDatepickerConfig.datepickerConfig.type;
    }
    /**
     * Converts input value to an Integer.
     * @param value
     */
    toInteger(value) {
        return parseInt(value.toString(), 10);
    }
    /**
     * Determines if the given value is a number.
     * @param value
     */
    isNumber(value) {
        return !isNaN(this.toInteger(value));
    }
    /**
     * Pads number with a 0 if it is a single digit.
     * @param value
     */
    padNumber(value) {
        if (this.isNumber(value)) {
            if (value.toString().length > 1) {
                return value.toString();
            }
            else {
                return '0' + value.toString();
            }
        }
        else {
            return '';
        }
    }
    /**
     * Parses mm/dd/yyyy into NgbDateStruct
     * @param value
     */
    parseUS(value) {
        let result = null;
        if (value) {
            const slashDate = value.split(this.SLASH_DELIMITER);
            if (slashDate.length === 1) {
                result = {
                    month: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    day: null,
                    year: null
                };
            }
            else if (slashDate.length === 2) {
                result = {
                    month: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    year: null
                };
            }
            else if (slashDate.length === 3) {
                result = {
                    day: parseInt(slashDate[1] ? slashDate[1] : undefined, 10),
                    month: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    year: parseInt(slashDate[2] ? slashDate[2] : undefined, 10)
                };
            }
        }
        return result;
    }
    /**
     * Parses dd/mm/yyyy into NgbDateStruct
     * @param value
     */
    parseDateFirst(value) {
        let result = null;
        if (value) {
            const slashDate = value.split(this.SLASH_DELIMITER);
            if (slashDate.length === 1) {
                result = {
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    month: null,
                    year: null
                };
            }
            else if (slashDate.length === 2) {
                result = {
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    month: parseInt(slashDate[1] ? slashDate[1] : undefined, 10),
                    year: null
                };
            }
            else if (slashDate.length === 3) {
                result = {
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    month: parseInt(slashDate[1] ? slashDate[1] : undefined, 10),
                    year: parseInt(slashDate[2] ? slashDate[2] : undefined, 10)
                };
            }
        }
        return result;
    }
    /**
     * Parses yyyy-mm-dd into NgbDateStruct
     * @param value
     */
    parseYearFirst(value) {
        let result = null;
        if (value) {
            const dashDate = value.split(this.DASH_DELIMITER);
            if (dashDate.length === 1) {
                result = {
                    day: null,
                    month: null,
                    year: parseInt(dashDate[0] ? dashDate[0] : undefined, 10)
                };
            }
            else if (dashDate.length === 2) {
                result = {
                    day: null,
                    month: parseInt(dashDate[1] ? dashDate[1] : undefined, 10),
                    year: parseInt(dashDate[0] ? dashDate[0] : undefined, 10)
                };
            }
            else if (dashDate.length === 3) {
                result = {
                    day: parseInt(dashDate[2] ? dashDate[2] : undefined, 10),
                    month: parseInt(dashDate[1] ? dashDate[1] : undefined, 10),
                    year: parseInt(dashDate[0] ? dashDate[0] : undefined, 10)
                };
            }
        }
        return result;
    }
    /**
     * Parses string depending on dateFormat.
     * @param value
     */
    parse(value) {
        if (this.dateFormat === 'mm/dd/yyyy') {
            return this.parseUS(value);
        }
        if (this.dateFormat === 'dd/mm/yyyy') {
            return this.parseDateFirst(value);
        }
        if (this.dateFormat === 'yy-mm-dd' || this.dateFormat === 'yyyy-mm-dd') {
            return this.parseYearFirst(value);
        }
        return null;
    }
    /**
     * Formats NgbDateStruct into mm/dd/yyyy.
     * @param date
     */
    formatUS(date) {
        let result = '';
        if (date) {
            if (date.month !== undefined) {
                result += this.padNumber(date.month).toString() + this.SLASH_DELIMITER;
            }
            if (date.day !== undefined) {
                result += this.padNumber(date.day).toString() + this.SLASH_DELIMITER;
            }
            if (date.year !== undefined) {
                result += date.year.toString();
            }
            return result;
        }
        return result;
    }
    /**
     * Formats NgbDateStruct into dd/mm/yyyy.
     * @param date
     */
    formatDateFirst(date) {
        let result = '';
        if (date) {
            if (date.day !== undefined) {
                result += this.padNumber(date.day).toString() + this.SLASH_DELIMITER;
            }
            if (date.month !== undefined) {
                result += this.padNumber(date.month).toString() + this.SLASH_DELIMITER;
            }
            if (date.year !== undefined) {
                result += date.year.toString();
            }
            return result;
        }
        return result;
    }
    /**
     * Formats NgbDateStruct into yyyy-mm-dd.
     * @param date
     */
    formatYearFirst(date) {
        let result = '';
        if (date) {
            if (date.year !== undefined) {
                result += date.year.toString() + this.DASH_DELIMITER;
            }
            if (date.month !== undefined) {
                result += this.padNumber(date.month).toString() + this.DASH_DELIMITER;
            }
            if (date.day !== undefined) {
                result += this.padNumber(date.day).toString();
            }
            return result;
        }
        return result;
    }
    /**
     * Formats NgbDateStruct into string depending on date format.
     * @param date
     */
    format(date) {
        if (this.dateFormat === 'mm/dd/yyyy') {
            return this.formatUS(date);
        }
        if (this.dateFormat === 'dd/mm/yyyy') {
            return this.formatDateFirst(date);
        }
        if (this.dateFormat === 'yy-mm-dd' || this.dateFormat === 'yyyy-mm-dd') {
            return this.formatYearFirst(date);
        }
        return '';
    }
}
BentoDefaultNgbDateParserFormatter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDefaultNgbDateParserFormatter, deps: [{ token: BentoDatePickerConfig }], target: i0.ɵɵFactoryTarget.Injectable });
BentoDefaultNgbDateParserFormatter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDefaultNgbDateParserFormatter, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDefaultNgbDateParserFormatter, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: BentoDatePickerConfig }]; } });

function getLastTwoDigitsOfCurrentYear() {
    // 2020
    const currentYear = new Date().getFullYear();
    return parseInt(currentYear.toString().substr(2, 2), 10);
}
/**
 * This directive should be used on an input element for NgbDatepicker.
 * It takes in a DatepickerConfig which consists of a format and a type.
 * It inserts a '/' or '-' as the user types with the exception of CA (format: yy-mm-dd).
 * @author <a href="mailto:lisa.schuler@thomsonreuters.com">Lisa Schuler</a>
 */
class BentoDatepickerConfigDirective {
    /**
     * Ctor
     * @param elementRef
     * @param bentoDatepickerConfig
     * @param customDatePicker
     */
    constructor(elementRef, bentoNgbDatepickerConfig, customDatePicker, winRef, platform) {
        this.elementRef = elementRef;
        this.bentoNgbDatepickerConfig = bentoNgbDatepickerConfig;
        this.customDatePicker = customDatePicker;
        this.winRef = winRef;
        this.platform = platform;
        /**
         * Regex for two digits, ie '12', '05', etc.
         */
        this.TWO_DIGIT_REGEX = /^[0-9]{2}$/;
        /**
         * Regex for two digits, a slash and another 2 digits, ie 04/25, 10/22, 21/05, etc.
         */
        this.FOUR_DIGIT_REGEX = /^[0-9]{2}\/[0-9]{2}$/;
        /**
         * Regex for mm/dd/yy or dd/mm/yy.
         */
        this.PARTIAL_YEAR_REGEX = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{1,2}$/;
        /**
         * Regex for yy-mm-dd.
         */
        this.PARTIAL_YEAR_REGEX_CA = /^\d{1,2}\-[0-9]{2}\-[0-9]{2}$/;
        /**
         * Regex for 8 digits dates with no slashes, ie 20201031.
         */
        this.NO_SLASH_REGEX_8_DIGITS = /^[0-9]{8}$/;
        /**
         * Regex for 6 digits dates with no slashes, ie 201031.
         */
        this.NO_SLASH_REGEX_6_DIGITS = /^[0-9]{6}$/;
        /**
         * Regex for 4 digits.
         */
        this.YEAR_REGEX = /^\d{4}$/;
        /**
         * Regex for four digits, a dash and 2 digits, ie 1985-04, 2020-05, etc.
         */
        this.YEAR_MONTH_REGEX = /^\d{4}\-[0-9]{2}$/;
        /**
         * Regex for four digits, a dash and 2 digits, ie 1985-04, 2020-05, etc.
         */
        this.SHORT_YEAR_MONTH_REGEX = /^\d{2}\-[0-9]{2}$/;
        /**
         * datePickerConfig
         */
        this.datepickerConfig = { format: '', type: '' };
        /**
         * This number is the last two digits of the current year.
         * Gets calculated once per component initialization and saved on a public member
         * to allow override it on the tests and prevent tests that are dependent on the time when
         * are executed.
         */
        this.lastTwoDigitsOfCurrentYear = getLastTwoDigitsOfCurrentYear();
        this.el = this.elementRef.nativeElement;
    }
    /**
     * Init
     */
    ngOnInit() {
        this.datepickerConfig = this.bentoDatepickerConfig;
        this.bentoNgbDatepickerConfig.setFormat(this.datepickerConfig.format);
        this.bentoNgbDatepickerConfig.setType(this.datepickerConfig.type);
    }
    ngOnChanges(changes) {
        if (changes['bentoDatepickerConfig']) {
            this.datepickerConfig = this.bentoDatepickerConfig;
            this.bentoNgbDatepickerConfig.setFormat(this.datepickerConfig.format);
            this.bentoNgbDatepickerConfig.setType(this.datepickerConfig.type);
        }
    }
    /**
     * Listens for input events and adds dashes and slashes where appropriate for a given date format.
     * @param $event Input Event
     */
    onInput($event) {
        if (this.datepickerConfig.format === 'mm/dd/yyyy' || this.datepickerConfig.format === 'dd/mm/yyyy') {
            if ($event.inputType !== 'deleteContentBackward' &&
                (this.TWO_DIGIT_REGEX.test($event.target.value) || this.FOUR_DIGIT_REGEX.test($event.target.value))) {
                this.el.value = $event.target.value + '/';
            }
        }
        else if (this.datepickerConfig.format === 'yyyy-mm-dd') {
            if ($event.inputType !== 'deleteContentBackward' &&
                (this.YEAR_REGEX.test($event.target.value) || this.YEAR_MONTH_REGEX.test($event.target.value))) {
                this.el.value = $event.target.value + '-';
            }
        }
        /*
        // Per business needs, Canadian date format should not be corrected during user input
        // Uncomment this block when needed again
    
        else if (this.datepickerConfig.format === 'yy-mm-dd') {
          if (
            $event.inputType !== 'deleteContentBackward' &&
            (this.TWO_DIGIT_REGEX.test($event.target.value) || this.SHORT_YEAR_MONTH_REGEX.test($event.target.value))
          ) {
            this.el.value = $event.target.value + '-';
          }
        }
        */
    }
    /**
     * Listens for blur events and handles two digit years for a given date format and type.
     * For mm/dd/yy, dd/mm/yym yy-mm-dd, yymmdd:
     *    If there are 2 digits for year:
     *      If type is recent:
     *        Append a '20' to the front of year.
     *      If type is dob:
     *        If two digit year is greater than or equal to last two digits of current year:
     *          Append a '19' to the front of year.
     *        Else
     *          Append a '20' to the front of year.
     *
     * For yyyymmdd and yymmdd:
     *    Adds dashes.
     * @param value Value of input field when blur event is triggered.
     */
    onBlur(value) {
        this.formatInput(value);
    }
    /**
     * Handle live format paste events
     */
    onPaste(e) {
        if (this.platform.isBrowser) {
            const win = this.winRef.nativeWindow;
            let pastedText;
            if (win.clipboardData && win.clipboardData.getData) {
                // IE
                pastedText = win.clipboardData.getData('Text');
            }
            else if (e.clipboardData && e.clipboardData.getData) {
                pastedText = e.clipboardData.getData('text/plain');
            }
            e.preventDefault();
            this.formatInput(pastedText);
        }
    }
    formatInput(value) {
        const dateFormat = this.datepickerConfig.format;
        if (this.PARTIAL_YEAR_REGEX.test(value) && (dateFormat === 'mm/dd/yyyy' || dateFormat === 'dd/mm/yyyy')) {
            const splitDate = value.split('/');
            if (this.datepickerConfig.type === 'recent') {
                this.el.value = [
                    this.customDatePicker.padNumber(splitDate[0]),
                    this.customDatePicker.padNumber(splitDate[1]),
                    `20${this.customDatePicker.padNumber(splitDate[2])}`
                ].join('/');
                this.el.dispatchEvent(new Event('input'));
            }
            else if (this.datepickerConfig.type === 'dob') {
                if (parseInt(splitDate[2], 10) >= this.lastTwoDigitsOfCurrentYear + 1) {
                    this.el.value = [
                        this.customDatePicker.padNumber(splitDate[0]),
                        this.customDatePicker.padNumber(splitDate[1]),
                        `19${this.customDatePicker.padNumber(splitDate[2])}`
                    ].join('/');
                }
                else {
                    this.el.value = [
                        this.customDatePicker.padNumber(splitDate[0]),
                        this.customDatePicker.padNumber(splitDate[1]),
                        `20${this.customDatePicker.padNumber(splitDate[2])}`
                    ].join('/');
                }
                this.el.dispatchEvent(new Event('input'));
            }
        }
        if (dateFormat === 'yy-mm-dd' && this.PARTIAL_YEAR_REGEX_CA.test(value)) {
            const split = value.split('-');
            if (this.datepickerConfig.type === 'recent') {
                this.el.value = [
                    `20${this.customDatePicker.padNumber(split[0])}`,
                    this.customDatePicker.padNumber(split[1]),
                    this.customDatePicker.padNumber(split[2])
                ].join('-');
                this.el.dispatchEvent(new Event('input'));
            }
            else if (this.datepickerConfig.type === 'dob') {
                if (parseInt(split[0], 10) >= this.lastTwoDigitsOfCurrentYear + 1) {
                    this.el.value = [
                        `19${this.customDatePicker.padNumber(split[0])}`,
                        this.customDatePicker.padNumber(split[1]),
                        this.customDatePicker.padNumber(split[2])
                    ].join('-');
                }
                else {
                    this.el.value = [
                        `20${this.customDatePicker.padNumber(split[0])}`,
                        this.customDatePicker.padNumber(split[1]),
                        this.customDatePicker.padNumber(split[2])
                    ].join('-');
                }
                this.el.dispatchEvent(new Event('input'));
            }
        }
        if (dateFormat === 'yy-mm-dd' && this.NO_SLASH_REGEX_6_DIGITS.test(value)) {
            const year = value.substr(0, 2);
            const month = value.substr(2, 2);
            const day = value.substr(4, 2);
            if (this.datepickerConfig.type === 'recent') {
                this.el.value =
                    '20' + year + '-' + this.customDatePicker.padNumber(month) + '-' + this.customDatePicker.padNumber(day);
                this.el.dispatchEvent(new Event('input'));
            }
            else if (this.datepickerConfig.type === 'dob') {
                if (parseInt(year, 10) >= this.lastTwoDigitsOfCurrentYear + 1) {
                    this.el.value = [
                        `19${this.customDatePicker.padNumber(year)}`,
                        this.customDatePicker.padNumber(month),
                        this.customDatePicker.padNumber(day)
                    ].join('-');
                }
                else {
                    this.el.value = [
                        `20${this.customDatePicker.padNumber(year)}`,
                        this.customDatePicker.padNumber(month),
                        this.customDatePicker.padNumber(day)
                    ].join('-');
                }
                this.el.dispatchEvent(new Event('input'));
            }
        }
        if (this.NO_SLASH_REGEX_8_DIGITS.test(value)) {
            if (dateFormat === 'yy-mm-dd' || dateFormat === 'yyyy-mm-dd') {
                const year = value.substr(0, 4);
                const month = value.substr(4, 2);
                const day = value.substr(6, 2);
                this.el.value = [year, this.customDatePicker.padNumber(month), this.customDatePicker.padNumber(day)].join('-');
                this.el.dispatchEvent(new Event('input'));
            }
            else if (dateFormat === 'mm/dd/yyyy' || dateFormat === 'dd/mm/yyyy') {
                const year = value.substr(4, 4);
                const group1 = value.substr(0, 2);
                const group2 = value.substr(2, 2);
                this.el.value = [this.customDatePicker.padNumber(group1), this.customDatePicker.padNumber(group2), year].join('/');
                this.el.dispatchEvent(new Event('input'));
            }
        }
    }
}
BentoDatepickerConfigDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerConfigDirective, deps: [{ token: i0.ElementRef }, { token: BentoDatePickerConfig }, { token: BentoDefaultNgbDateParserFormatter }, { token: WindowRef }, { token: i3$1.Platform }], target: i0.ɵɵFactoryTarget.Directive });
BentoDatepickerConfigDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoDatepickerConfigDirective, selector: "[bentoDatepickerConfig]", inputs: { bentoDatepickerConfig: "bentoDatepickerConfig" }, host: { listeners: { "input": "onInput($event)", "blur": "onBlur($event.target.value)", "paste": "onPaste($event)" } }, providers: [{ provide: NgbDateParserFormatter, useClass: BentoDefaultNgbDateParserFormatter }], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerConfigDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoDatepickerConfig]',
                    providers: [{ provide: NgbDateParserFormatter, useClass: BentoDefaultNgbDateParserFormatter }]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoDatePickerConfig }, { type: BentoDefaultNgbDateParserFormatter }, { type: WindowRef }, { type: i3$1.Platform }]; }, propDecorators: { bentoDatepickerConfig: [{
                type: Input
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['blur', ['$event.target.value']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class BentoDatepickerMaskModule extends ConsumerDataValidator {
}
BentoDatepickerMaskModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerMaskModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoDatepickerMaskModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerMaskModule, declarations: [BentoDatepickerConfigDirective], exports: [BentoDatepickerConfigDirective] });
BentoDatepickerMaskModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerMaskModule, providers: [BentoDefaultNgbDateParserFormatter] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerMaskModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoDatepickerConfigDirective],
                    exports: [BentoDatepickerConfigDirective],
                    providers: [BentoDefaultNgbDateParserFormatter]
                }]
        }] });

/**
 * This is a UI component to show a standard Expand/Collapse button group
 */
class BentoExpandCollapseButtonGroupComponent {
    constructor() {
        /**
         * HTML "title" attribute for expand all (+) button
         */
        this.expandAllTitle = undefined;
        /**
         * HTML "title" attribute for collapse all (-) button
         */
        this.collapseAllTitle = undefined;
        /**
         * Event emitter for when expand (+) is clicked
         */
        this.expand = new EventEmitter();
        /**
         * Event emitter for when collapse (-) is clicked
         */
        this.collapse = new EventEmitter();
    }
    /**
     * Callback when expand all is clicked
     */
    _onExpandAll() {
        this.expand.emit();
    }
    /**
     * Callback when collapse all is clicked
     */
    _onCollapseAll() {
        this.collapse.emit();
    }
}
BentoExpandCollapseButtonGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoExpandCollapseButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BentoExpandCollapseButtonGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoExpandCollapseButtonGroupComponent, selector: "bento-expand-collapse-button-group", inputs: { expandAllTitle: "expandAllTitle", collapseAllTitle: "collapseAllTitle" }, outputs: { expand: "expand", collapse: "collapse" }, ngImport: i0, template: "<button\n  class=\"btn btn-outline-primary btn-xs btn-icon\"\n  type=\"button\"\n  (click)=\"_onExpandAll()\"\n  [attr.aria-label]=\"expandAllTitle || ('BENTO_UI_EXPAND_ALL' | bentoTranslate)\"\n  ngbTooltip=\"{{ expandAllTitle || ('BENTO_UI_EXPAND_ALL' | bentoTranslate) }}\"\n>\n  <i class=\"bento-icon-plus-plain\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-expand-divider\"></div>\n<button\n  class=\"btn btn-outline-primary btn-xs btn-icon\"\n  type=\"button\"\n  (click)=\"_onCollapseAll()\"\n  [attr.aria-label]=\"collapseAllTitle || ('BENTO_UI_COLLAPSE_ALL' | bentoTranslate)\"\n  ngbTooltip=\"{{ collapseAllTitle || ('BENTO_UI_COLLAPSE_ALL' | bentoTranslate) }}\"\n>\n  <i class=\"bento-icon-minus-plain\" aria-hidden=\"true\"></i>\n</button>\n", styles: [".ng-bento .bento-expand-collapse-button-group,.ng-bento bento-expand-collapse-button-group{display:block;border-bottom-width:1px;border-bottom-style:solid}.ng-bento .bento-expand-collapse-button-group.no-border,.ng-bento bento-expand-collapse-button-group.no-border{border:none}.ng-bento .bento-expand-collapse-button-group .btn-xs,.ng-bento bento-expand-collapse-button-group .btn-xs{font-size:10px}.ng-bento .bento-expand-collapse-button-group .bento-expand-divider,.ng-bento bento-expand-collapse-button-group .bento-expand-divider{display:inline-block;font-size:20px;line-height:0}.ng-bento .bento-expand-collapse-button-group .bento-expand-divider:before,.ng-bento bento-expand-collapse-button-group .bento-expand-divider:before{content:\"/\";margin:0 4px}\n"], directives: [{ type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }], pipes: { "bentoTranslate": BentoTranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoExpandCollapseButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-expand-collapse-button-group', encapsulation: ViewEncapsulation.None, template: "<button\n  class=\"btn btn-outline-primary btn-xs btn-icon\"\n  type=\"button\"\n  (click)=\"_onExpandAll()\"\n  [attr.aria-label]=\"expandAllTitle || ('BENTO_UI_EXPAND_ALL' | bentoTranslate)\"\n  ngbTooltip=\"{{ expandAllTitle || ('BENTO_UI_EXPAND_ALL' | bentoTranslate) }}\"\n>\n  <i class=\"bento-icon-plus-plain\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-expand-divider\"></div>\n<button\n  class=\"btn btn-outline-primary btn-xs btn-icon\"\n  type=\"button\"\n  (click)=\"_onCollapseAll()\"\n  [attr.aria-label]=\"collapseAllTitle || ('BENTO_UI_COLLAPSE_ALL' | bentoTranslate)\"\n  ngbTooltip=\"{{ collapseAllTitle || ('BENTO_UI_COLLAPSE_ALL' | bentoTranslate) }}\"\n>\n  <i class=\"bento-icon-minus-plain\" aria-hidden=\"true\"></i>\n</button>\n", styles: [".ng-bento .bento-expand-collapse-button-group,.ng-bento bento-expand-collapse-button-group{display:block;border-bottom-width:1px;border-bottom-style:solid}.ng-bento .bento-expand-collapse-button-group.no-border,.ng-bento bento-expand-collapse-button-group.no-border{border:none}.ng-bento .bento-expand-collapse-button-group .btn-xs,.ng-bento bento-expand-collapse-button-group .btn-xs{font-size:10px}.ng-bento .bento-expand-collapse-button-group .bento-expand-divider,.ng-bento bento-expand-collapse-button-group .bento-expand-divider{display:inline-block;font-size:20px;line-height:0}.ng-bento .bento-expand-collapse-button-group .bento-expand-divider:before,.ng-bento bento-expand-collapse-button-group .bento-expand-divider:before{content:\"/\";margin:0 4px}\n"] }]
        }], propDecorators: { expandAllTitle: [{
                type: Input
            }], collapseAllTitle: [{
                type: Input
            }], expand: [{
                type: Output
            }], collapse: [{
                type: Output
            }] } });

class BentoExpandCollapseButtonGroupModule extends ConsumerDataValidator {
    constructor(collapseConfig) {
        super();
        collapseConfig.animation = false;
    }
}
BentoExpandCollapseButtonGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoExpandCollapseButtonGroupModule, deps: [{ token: i1$1.NgbCollapseConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoExpandCollapseButtonGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoExpandCollapseButtonGroupModule, declarations: [BentoExpandCollapseButtonGroupComponent], imports: [CommonModule,
        BentoTranslateModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule], exports: [BentoExpandCollapseButtonGroupComponent] });
BentoExpandCollapseButtonGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoExpandCollapseButtonGroupModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoExpandCollapseButtonGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoFocusMonitorModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule
                    ],
                    declarations: [BentoExpandCollapseButtonGroupComponent],
                    exports: [BentoExpandCollapseButtonGroupComponent]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbCollapseConfig }]; } });

/**
 * Injectable BentoFileSelectorComponentServices to supper file selector component
 */
class BentoFileSelectorComponentServices {
    constructor(r, sanitizer) {
        this.r = r;
        this.sanitizer = sanitizer;
    }
    /**
     * Parse a File out from the file list and forward it back to the callback function
     *
     */
    parseFiles(originalFiles, newFiles, fileTypes, multiple, appendOnSelection, accepted, element, errorFiles) {
        return __awaiter(this, void 0, void 0, function* () {
            // Ignore non-file selection
            if (typeof newFiles === 'undefined') {
                return;
            }
            // Determinie how many files are allowed
            let newFileArray = multiple ? newFiles : [newFiles[0]];
            const filteredFiles = yield this.filterFiles(originalFiles, newFileArray, fileTypes, accepted, element, errorFiles);
            const selectedFiles = filteredFiles.selected;
            // Determine if it needs to append to the existing file array or not
            if (appendOnSelection && Array.isArray(originalFiles) && multiple) {
                newFileArray = originalFiles.concat(selectedFiles);
            }
            else {
                // Add a file reference to scope
                newFileArray = selectedFiles;
            }
            return {
                allFiles: newFileArray,
                newFiles: selectedFiles,
                duplicatedFiles: filteredFiles.duplicated
            };
        });
    }
    /**
     * Determine if the two files are identical
     */
    fileEqual(f1, f2) {
        return f1.lastModified === f2.lastModified && f1.name === f2.name && f1.size === f2.size;
    }
    /**
     * Determine if a file exist in a file array
     */
    hasFileAtIndex(fileArray, file) {
        for (let i = 0, len = fileArray.length; i < len; i++) {
            if (this.fileEqual(fileArray[i], file)) {
                return i;
            }
        }
        return -1;
    }
    /**
     * Determine if the first element in files has the right file type
     */
    isValidFileType(file, fileTypes) {
        const _ft = !!fileTypes ? fileTypes.trim() : '';
        const fileNameBreakDown = file.name.split('.');
        const fileExtension = fileNameBreakDown[fileNameBreakDown.length - 1];
        // This is no filetype specified
        if (typeof _ft === 'undefined' || _ft.length === 0) {
            return true;
        }
        // Check if this file extension exists in fileTypes string
        if (fileTypes.search(fileExtension) !== -1) {
            return true;
        }
        // File extension does not exist in the fileTypes
        return false;
    }
    /**
     * is file accepted
     */
    isFileAccepted(file, accepted, element, errorFiles) {
        return __awaiter(this, void 0, void 0, function* () {
            let fileAccepted = true;
            let isFile = yield this.isFile(file);
            if (!isFile && file.size % 4096 === 0) {
                // This is a folder
                file.displayType = 'folder';
                fileAccepted = false;
            }
            else if (file.type === 'unknown') {
                file.displayType = 'unknown';
                file.name = 'file or folder';
                fileAccepted = false;
            }
            else {
                file.displayType = 'file';
            }
            if (fileAccepted) {
                // this file type is not accepted
                const indexOfExt = file.name.lastIndexOf('.');
                const selectedFileExtension = indexOfExt < 0 ? '' : file.name.slice(indexOfExt).toLowerCase();
                // list only the files that are accepted
                if (accepted && accepted.length && accepted.indexOf(selectedFileExtension) === -1) {
                    fileAccepted = false;
                }
            }
            this.updateFileNotAcceptedUI(file, fileAccepted, element, errorFiles);
            return fileAccepted;
        });
    }
    /**
     * This approach could be changed to the usage of 'webkitGetAsEntry' on 'drop' event
     * when IE support is no longer needed
     *
     * Promise will return true if it's a file.
     * If it's a folder the promise will return false.
     *
     * https://stackoverflow.com/questions/47362320/how-to-identify-the-difference-between-file-and-folder-ondropping-in-javascript
     *
     * @param {*} file - File that is uploaded
     */
    isFile(file) {
        return new Promise(resolve => {
            let start = 0; // start byte
            let stop = 4; // end byte - to avoid read all the content
            try {
                let reader = new FileReader();
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        let bytes = new Uint8Array(evt.target.result);
                        let length = bytes.byteLength;
                        if (length == 0) {
                            resolve(false);
                        }
                        else {
                            resolve(true);
                        }
                    }
                    else {
                        resolve(false);
                    }
                };
                let blob = file.slice(start, stop + 1);
                reader.readAsArrayBuffer(blob);
            }
            catch (e) {
                resolve(false);
            }
        });
    }
    /**
     * updateFileNotAcceptedUI
     */
    updateFileNotAcceptedUI(file, fileAccepted, element, errorFiles) {
        const fsContainer = element;
        const fsErrorEl = element.querySelector('.bento-file-selector-error');
        if (fileAccepted) {
            // do not reset any old errors, if present
            if (errorFiles.length === 0) {
                if (fsContainer) {
                    fsContainer.classList.remove('selector-has-error');
                }
                if (fsErrorEl) {
                    fsErrorEl.classList.remove('show');
                }
            }
        }
        else {
            if (fsContainer) {
                fsContainer.classList.add('selector-has-error');
            }
            if (fsErrorEl) {
                fsErrorEl.classList.add('show');
            }
            // push the new file
            errorFiles.push(file);
        }
    }
    /**
     * Construct a new HTMLInputElement
     */
    getFileInput(accept, multiple) {
        accept = this.sanitizer.sanitize(SecurityContext.HTML, accept);
        const attrAccept = accept && accept.length > 1 ? ' accept="' + accept + '"' : '';
        const fileInputStr = '<input type="file" name="fileselect_' +
            performance.now() +
            '"' +
            ' class="sr-only"' +
            ' tabindex="-1"' +
            attrAccept +
            (multiple ? ' multiple' : '') +
            ' />';
        const divWrapper = this.r.createElement('div');
        this.r.setProperty(divWrapper, 'innerHTML', fileInputStr);
        return divWrapper.children[0];
    }
    /**
     * Return a valid file list from a FileList
     */
    filterFiles(originalFileList = [], fileList, fileTypes, accepted, element, errorFiles) {
        return __awaiter(this, void 0, void 0, function* () {
            const selectedFiles = [];
            const duplicatedFiles = [];
            const originalList = originalFileList || [];
            for (const file of fileList) {
                const dupeIndex = this.hasFileAtIndex(originalFileList, file);
                if (dupeIndex > -1) {
                    duplicatedFiles.push(originalFileList[dupeIndex]);
                }
                else {
                    let isFile = yield this.isFile(file);
                    let isFileAccepted = yield this.isFileAccepted(file, accepted, element, errorFiles);
                    if (isFile && isFileAccepted && this.isValidFileType(file, fileTypes) && originalList.indexOf(file) === -1) {
                        // only add the current file when it's the valid file type
                        selectedFiles.push(file);
                    }
                }
            }
            return {
                selected: selectedFiles,
                duplicated: duplicatedFiles
            };
        });
    }
}
BentoFileSelectorComponentServices.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorComponentServices, deps: [{ token: i0.Renderer2 }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
BentoFileSelectorComponentServices.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorComponentServices });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorComponentServices, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$2.DomSanitizer }]; } });

/**
 * Default Fade In Out Metadata
 */
const FadeInOut = FadeInOutFunc('FadeInOut', 100);
const FadeInOutLong = FadeInOutFunc('FadeInOutLong', 300);
/**
 * Function to delcare Animation Trigger Metadata by its given trigger name and duration
 */
function FadeInOutFunc(triggerName, duration) {
    return trigger(triggerName, [
        state('void', style({ opacity: 0 })),
        transition('void => *', [animate(duration)]),
        transition('* => void', [animate(duration)])
    ]);
}

const BENTO_FILE_SELECTOR_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoFileSelectorComponent),
    multi: true
};
let BENTO_FILE_SELECTOR_ID = 0;
class BentoFileSelectorComponent {
    /**
     */
    constructor(elementRef, services, r, cd, windowRef) {
        this.services = services;
        this.r = r;
        this.cd = cd;
        /**
         * Event emitter when at least a file is selected from the browser, a `BentoFileSelectorEvent` object will be passed
         * into its callback
         */
        this.fileSelect = new EventEmitter();
        /**
         * Event emitter when at least a file has already been selected, a `BentoFileSelectorEvent` object will be passed
         * into its callback
         */
        this.duplicateSelect = new EventEmitter();
        /**
         * Event emitter when a file is removed from the file list, a `BentoFileSelectorEvent` object will be passed
         * into its callback
         */
        this.fileRemove = new EventEmitter();
        /**
         * File types that are allowed and displayed in file explorers. If the value of the type attribute is file,
         * this attribute indicates the types of files that the server accepts; otherwise it is ignored.
         * The value must be a comma-separated list of unique content type specifiers:
         *
         *   * A file extension starting with the STOP character (`U+002E`). (E.g.: `'.jpg,.png,.doc'`)
         *   * A valid MIME type with no extensions
         *   * `audio/*` representing sound files HTML5
         *   * `video/*` representing video files HTML5
         *   * `image/*` representing image files HTML5
         *
         * Note: The support of this attribute is browser specific.
         * Please refer to this [link](http://caniuse.com/#search=accept) for the browsers that it currently supports.
         *
         */
        this.accept = '';
        /**
         * Allow appending of files to current selection
         */
        this.appendOnSelection = false;
        /**
         * Disable file selector during upload.
         */
        this.disableDuringUpload = true;
        /**
         * Allow multiple file selection
         */
        this.multiple = false;
        /**
         * Show selected files in File Selector Container
         */
        this.showSelectedFiles = false;
        /**
         * Show file size info
         */
        this.showFileSize = false;
        /**
         * show percentage label on the progress bar
         */
        this.showProgressPercentage = false;
        /**
         * UID of this component
         */
        this.uid = `bui-file-selector-${BENTO_FILE_SELECTOR_ID++}`;
        /**
         * Model to gage the current upload percentage
         */
        this._uploadProgressPercentage = -1;
        /**
         * List of currently disabled file objects
         */
        this._disabledFiles = [];
        /**
         * List of the file progress
         */
        this._fileProgressList = [];
        this._errorFiles = [];
        /**
         * Sequence counter for animation
         */
        this._animateSquenceCounter = 0;
        /**
         * Disabled flag
         */
        this._isDisabled = false;
        this._el = elementRef.nativeElement;
        this._changeFunction = (_) => { };
        this.touchedFunction = () => { };
        this.document = windowRef.nativeDocument;
    }
    get _fileSelectorInProgress() {
        return this._uploadProgressPercentage > 0;
    }
    /**
     * When ngModel is udpated
     */
    writeValue(v) {
        this._fileList = v;
        this._disabledFiles = [];
        this._fileProgressList = [];
        this._animateSquenceCounter = 0;
        this.cd.markForCheck();
    }
    /**
     * When disabled state is updated
     */
    setDisabledState(v) {
        this._isDisabled = v;
        this.cd.markForCheck();
    }
    /**
     * Referencing ngModel change function
     */
    registerOnChange(fn) {
        this._changeFunction = fn;
    }
    /**
     * Referencing component touch event
     */
    registerOnTouched(fn) {
        this.touchedFunction = () => {
            fn();
            this.cd.markForCheck();
        };
    }
    /**
     * Initial setups when the view is ready
     */
    ngAfterViewInit() {
        // Make sure that an input field is in the component
        this.refreshFileInput();
        // Assign upload progress
        if (this.uploadProgress) {
            this._uploadProgressSubscription = this.uploadProgress.subscribe((p) => {
                this.updateFileUploadProgress(p);
            });
        }
        this._progressbarEl = this._el.querySelector('.progress > div');
        // this._accepted = (this.accept && this.accept.length) ? this.accept.replace(/ /g, '').toLowerCase().split(',') :
        // undefined;
        this._accepted = this.parseAcceptFileList(this.accept);
    }
    /**
     * Tasks to execute when this component is destroyed
     */
    ngOnDestroy() {
        if (this._uploadProgressSubscription) {
            this._uploadProgressSubscription.unsubscribe();
        }
        if (this._fileInputChangeSubscription) {
            this._fileInputChangeSubscription.unsubscribe();
        }
        this.cd.detach();
    }
    /**
     * Callback when the browse button is clicked
     */
    _onBrowseClick(e) {
        if (this._isDisabled) {
            // this component is disabled
            return;
        }
        this._fileInput.click();
        if (e) {
            // Stop the button to make form submissions
            e.stopPropagation();
            e.preventDefault();
        }
    }
    /**
     * On file remove click
     */
    _onRemoveClick(index) {
        if (this._isDisabled) {
            // this component is disabled
            return;
        }
        const fileToBeRemoved = this._fileList.splice(index, 1);
        this._removedFilename = fileToBeRemoved.name;
        // Focus on an aria label for screen reader
        this._postRemovalMessage.nativeElement.focus();
        // Emit remove event
        this.fileRemove.emit({ files: fileToBeRemoved });
        // Call ngModel change
        this._changeFunction(this._fileList.slice());
        // Decrease counter by 1
        this._animateSquenceCounter--;
        // Refresh input for the next batch of selections
        this.refreshFileInput();
    }
    /**
     * Animate next file to enter the view
     */
    _animateNext(e) {
        if (e.toState === 'in') {
            setTimeout(() => {
                this._animateSquenceCounter++;
                this.cd.markForCheck();
            }, 100);
        }
    }
    /**
     * Callback
     */
    _onFileInputChange(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const fileList = e.target.files;
            if (fileList.length > 0) {
                yield this.parseAndUpdateFiles(fileList);
            }
            // We need to refresh the input every time when there is an interaction with the file input
            this.refreshFileInput();
            // Detect changes
            this.cd.markForCheck();
        });
    }
    /**
     * Update current file upload progress with a given BentoFileProgress array
     */
    updateFileUploadProgress(progressList) {
        if (progressList && progressList.length > 0) {
            if (!Array.isArray(progressList)) {
                throw new Error('Bento File Selector: incorrect "upload-progress" data structure.\nUse' + ' [<BentoFileProgress>{...},...]');
            }
            else if (progressList.length > 0) {
                let totalFileSize = 0;
                let totalPosition = 0;
                let fileObj;
                let fileIndex;
                for (const progress of progressList) {
                    // calculate the percentage and file disabled states
                    fileObj = progress;
                    fileIndex = this._fileList.indexOf(fileObj.file);
                    if (fileIndex > -1) {
                        totalFileSize += fileObj.file.size;
                        totalPosition += fileObj.bytes;
                        this._disabledFiles[fileIndex] = fileObj.file.size > fileObj.bytes;
                        this._fileProgressList[fileIndex] = Math.floor((fileObj.bytes / fileObj.file.size) * 100);
                    }
                }
                this._uploadProgressPercentage = Math.floor((totalPosition / totalFileSize) * 100);
                if (this._uploadProgressPercentage >= 100 ||
                    totalFileSize === 0 // No more files
                ) {
                    // remove all progress references
                    this._fileProgressList = [];
                    this.r.removeAttribute(this._progressbarEl, 'aria-live');
                    // reset progress bar after hiding
                    setTimeout(() => {
                        this._uploadProgressPercentage = 0;
                    }, 100);
                }
            }
        }
        else {
            this._uploadProgressPercentage = 0;
            this._disabledFiles = [];
        }
        this.cd.markForCheck();
    }
    /**
     * Parse and update file list
     */
    parseAndUpdateFiles(files) {
        return __awaiter(this, void 0, void 0, function* () {
            this._errorFiles = [];
            const parsedFileListObj = yield this.services.parseFiles(this._fileList, files, this.fileType, this.multiple, this.appendOnSelection, this._accepted, this._el, this._errorFiles);
            if (this._errorFiles.length) {
                setTimeout(() => {
                    const errorContainers = this._el.querySelectorAll('.bento-file-selector-error');
                    if (errorContainers) {
                        for (let i = 0; i < errorContainers.length; i++) {
                            this.r.appendChild(this._el.parentElement, errorContainers[i]);
                        }
                    }
                });
            }
            else {
                const errorContainers = this._el.parentElement.querySelectorAll('.bento-file-selector-error');
                if (errorContainers) {
                    for (let i = 0; i < errorContainers.length; i++) {
                        for (let j = 0; j < errorContainers[i].children.length; j++) {
                            this.r.removeChild(errorContainers[i], errorContainers[i].children[j]);
                        }
                    }
                }
            }
            if (parsedFileListObj.newFiles.length > 0) {
                // When there is a new file that is selected
                this._fileList = parsedFileListObj.allFiles;
                // Fire callbacks
                this.fileSelect.emit({ files: parsedFileListObj.newFiles });
                // update ngModel
                this._changeFunction(this._fileList);
                if (!this.appendOnSelection || !this.multiple) {
                    // Renew lists for rendering
                    this._disabledFiles = [];
                    this._fileProgressList = [];
                    this._animateSquenceCounter = 0;
                }
                if (this.showSelectedFiles) {
                    setTimeout(() => {
                        // focus to the first file label
                        const firstFileNameEl = this._el.querySelector('.bento-file-selector-filename');
                        firstFileNameEl && firstFileNameEl.focus();
                    }, 100);
                }
            }
            if (parsedFileListObj.duplicatedFiles.length > 0) {
                // Emit when there are duplicated selection
                this.duplicateSelect.emit({ files: parsedFileListObj.duplicatedFiles });
            }
        });
    }
    parseAcceptFileList(sAcceptTypes) {
        let consolidatedAcceptFileTypeList;
        const acceptedTypeLists = sAcceptTypes && sAcceptTypes.length ? sAcceptTypes.replace(/ /g, '').toLowerCase().split(',') : undefined;
        if (!acceptedTypeLists) {
            return undefined;
        }
        let acceptedType;
        for (acceptedType of acceptedTypeLists) {
            // if the accept string is a MIME type, then prepare the list, else convert string to array
            const mime = this.getMime(acceptedType);
            if (mime && mime.type) {
                let acceptedFileList;
                switch (mime && mime.type) {
                    case 'audio':
                        acceptedFileList =
                            mime.extension === '*'
                                ? ['.aac', '.mid', '.midi', '.oga', '.wav', '.weba', '.3gp', '.3g2']
                                : [mime.extension];
                        break;
                    case 'video':
                        acceptedFileList =
                            mime.extension === '*' ? ['.avi', '.mpeg', '.ogv', '.webm', '.3gp', '.3g2'] : [mime.extension];
                        break;
                    case 'image':
                        acceptedFileList =
                            mime.extension === '*'
                                ? ['.bmp', '.gif', '.ico', '.jpeg', '.jpg', '.png', '.svg', '.tif', '.tiff', '.webp']
                                : [mime.extension];
                        break;
                    case 'text':
                        acceptedFileList =
                            mime.extension === '*' ? ['.css', '.csv', '.html', '.calendar', '.plain'] : [mime.extension];
                        break;
                    default:
                        break;
                }
                if (acceptedFileList) {
                    !consolidatedAcceptFileTypeList && (consolidatedAcceptFileTypeList = []);
                    for (const fileList of acceptedFileList) {
                        consolidatedAcceptFileTypeList.push(fileList);
                    }
                }
            }
            else {
                !consolidatedAcceptFileTypeList && (consolidatedAcceptFileTypeList = []);
                consolidatedAcceptFileTypeList.push(acceptedType);
            }
        }
        return consolidatedAcceptFileTypeList;
    }
    getMime(sAccept) {
        let mime;
        if (sAccept && sAccept.length) {
            const index = sAccept.indexOf('/');
            if (index !== -1) {
                const extension = sAccept.slice(index + 1, sAccept.length);
                mime = { type: sAccept.slice(0, index), extension: extension === '*' ? extension : '.' + extension };
            }
        }
        return mime;
    }
    /**
     * Callback when files are dropped into the zone
     */
    _onDrop(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            if ((!this.appendOnSelection && this._uploadProgressPercentage > -1) || this._isDisabled) {
                // cannot drop and an upload is in progress and there is not appendOnSelection allowed
                // OR this component is disabled
                return;
            }
            this._draggedOver = false;
            const dataTranfer = this._getDataTransfer(e);
            if (!dataTranfer) {
                return;
            }
            /**
             * IE 11
             * Drag and Drop for Folders behaves little different in IE. Every
             * drop method callback will be supplied with event . This event
             * argument is little different for IE when a folder is dropped.
             * Basically the file list (inside event) comes empty, where as in
             * Chrome or FF, the file list shows up with the folder name and a
             * default size of 4096.
             */
            if (dataTranfer && dataTranfer.files && !dataTranfer.files.length) {
                const file = { type: 'unknown' };
                this._errorFiles = [];
                yield this.services.isFileAccepted(file, '', this._el, this._errorFiles);
                setTimeout(() => {
                    const errorContainers = this._el.querySelectorAll('.bento-file-selector-error');
                    if (errorContainers) {
                        for (let i = 0; i < errorContainers.length; i++) {
                            this.r.appendChild(this._el.parentElement, errorContainers[i]);
                        }
                    }
                });
                return;
            }
            yield this.parseAndUpdateFiles(dataTranfer.files);
            for (let i = 0; i < dataTranfer.files.length; i++) {
                let file = dataTranfer.files[i];
                this.services.isFile(file).then(isFile => {
                    if (!isFile && file.size % 4096 === 0) {
                        this._fileInput.click();
                    }
                });
            }
            // Not sure if drop events are automatically mark for change
            // we are going to mark it just in case
            this.cd.markForCheck();
        });
    }
    /**
     * Callback when files are dragged over
     */
    _onDragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        if ((!this.appendOnSelection && this._uploadProgressPercentage > -1) || this._isDisabled) {
            // cannot drop and an upload is in progress and there is not appendOnSelection allowed
            // OR this component is disabled
            return;
        }
        const dataTranfer = this._getDataTransfer(e);
        if (!dataTranfer) {
            return;
        }
        dataTranfer.dropEffect = 'copy';
    }
    /**
     * Callback to constantly check dragging state (every 350ms by browser)
     * This method is REQUIRED in order for 'drop' to work
     */
    _onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        if ((!this.appendOnSelection && this._uploadProgressPercentage > -1) || this._isDisabled) {
            // cannot drop and an upload is in progress and there is not appendOnSelection allowed
            // OR this component is disabled
            return;
        }
        const dataTranfer = this._getDataTransfer(e);
        if (!dataTranfer) {
            return;
        }
        this._draggedOver = true;
    }
    /**
     * Handles when files are dragged out of the zone without dropping
     */
    _onDragLeave(e) {
        this._draggedOver = false;
    }
    _onFocusout(e) {
        setTimeout(() => {
            if (!this._el.contains(this.document.activeElement)) {
                // Fire touch function when focused out
                this.touchedFunction();
            }
        });
    }
    /**
     * Refresh file input element
     */
    refreshFileInput() {
        const newInput = this.services.getFileInput(this.accept, this.multiple);
        let newInputChangeSubscription;
        newInputChangeSubscription = fromEvent(newInput, 'change').subscribe((e) => __awaiter(this, void 0, void 0, function* () {
            yield this._onFileInputChange(e);
        }));
        if (this._fileInput) {
            // Remove the old file selector
            if (this._fileInput.parentElement) {
                this.r.removeChild(this._fileInput.parentElement, this._fileInput);
            }
            this._fileInputChangeSubscription.unsubscribe();
        }
        // Update global object references
        this._fileInput = newInput;
        this._fileInputChangeSubscription = newInputChangeSubscription;
        // Add the element into the component DOM tree
        this.r.appendChild(this._el, this._fileInput);
        // Need to refresh UI based on the new data
        this.cd.markForCheck();
    }
    /**
     * Get a dataTransfer object from DragEvent
     */
    _getDataTransfer(e) {
        return e.dataTransfer || e.originalEvent.dataTransfer;
    }
}
BentoFileSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorComponent, deps: [{ token: i0.ElementRef }, { token: BentoFileSelectorComponentServices }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Component });
BentoFileSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoFileSelectorComponent, selector: "bento-file-selector", inputs: { accept: "accept", appendOnSelection: "appendOnSelection", browseButtonLabel: "browseButtonLabel", disableDuringUpload: "disableDuringUpload", dropFieldLabel: "dropFieldLabel", fileType: "fileType", multiple: "multiple", showSelectedFiles: "showSelectedFiles", showFileSize: "showFileSize", showProgressPercentage: "showProgressPercentage", uploadProgress: "uploadProgress" }, outputs: { fileSelect: "fileSelect", duplicateSelect: "duplicateSelect", fileRemove: "fileRemove" }, host: { listeners: { "drop": "_onDrop($event)", "dragenter": "_onDragEnter($event)", "dragover": "_onDragOver($event)", "dragleave": "_onDragLeave($event)", "focusout": "_onFocusout($event)" }, properties: { "class.bento-file-selector-progress-percentage": "this.showProgressPercentage", "class.bento-file-selector-in-progress": "this._fileSelectorInProgress", "class.dragover": "this._draggedOver", "class.disabled": "this._isDisabled" } }, providers: [BENTO_FILE_SELECTOR_VALUE_ACCESSOR, BentoFileSelectorComponentServices], viewQueries: [{ propertyName: "_postRemovalMessage", first: true, predicate: ["postRemovalMessage"], descendants: true, static: true }], ngImport: i0, template: "<div>\n  <span class=\"header\">{{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL' | bentoTranslate: dropFieldLabel }}</span>\n  <p class=\"mb-2\">{{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_OR' | bentoTranslate }}</p>\n  <button\n    class=\"btn btn-primary\"\n    (click)=\"_onBrowseClick($event)\"\n    [attr.aria-label]=\"'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON' | bentoTranslate\"\n    [disabled]=\"(!appendOnSelection && _uploadProgressPercentage > 0) || _isDisabled\"\n  >\n    <span>{{ 'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL' | bentoTranslate: browseButtonLabel }}</span>\n  </button>\n  <div class=\"clearfix\"></div>\n  <div class=\"filename-container\">\n    <div #postRemovalMessage class=\"sr-only bento-file-selector-post-removal-message\" tabindex=\"-1\">\n      {{\n        'BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE' | bentoTranslate | bentoStringReplace: '_FILE_NAME_':_removedFilename\n      }}\n    </div>\n    <ng-template [ngIf]=\"showSelectedFiles\">\n      <div\n        class=\"btn btn-outline-primary bento-file-selector-filename btn-sm\"\n        *ngFor=\"let file of _fileList; let i = index\"\n        [class.disabled]=\"_disabledFiles[i] && disableDuringUpload\"\n        [class.loading]=\"_disabledFiles[i]\"\n        [attr.rel]=\"'file_' + i\"\n        [attr.aria-busy]=\"_disabledFiles[i]\"\n        [attr.aria-label]=\"\n          ('BENTO_UI_FILE_SELECTOR_FILE_NAME'\n            | bentoTranslate\n            | bentoStringReplace: '_FILE_NAME_':file.name\n            | bentoStringReplace: '_NUM_FILES_':_fileList.length\n            | bentoStringReplace: '_FILE_NUMBER_':i + 1) +\n          ' ' +\n          (showFileSize ? '(' + (file.size | bentoFileSizeFilter) + ')' : '') +\n          ' ' +\n          (_fileProgressList[i] >= 0 && _fileProgressList[i] < 100\n            ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS' | bentoTranslate)\n            : _fileProgressList[i]\n            ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE' | bentoTranslate)\n            : '')\n        \"\n        [@fileFadeIn]=\"_animateSquenceCounter >= i ? 'in' : 'hidden'\"\n        (@fileFadeIn.start)=\"_animateNext($event)\"\n        tabindex=\"0\"\n      >\n        <span>{{ file.name }}{{ showFileSize ? ' (' + (file.size | bentoFileSizeFilter) + ')' : '' }}</span>\n\n        <button\n          (click)=\"_onRemoveClick(i)\"\n          [attr.aria-label]=\"\n            'BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON' | bentoTranslate | bentoStringReplace: '_FILE_NAME_':file.name\n          \"\n          [disabled]=\"_disabledFiles[i] && disableDuringUpload\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n        <div class=\"bento-file-selector-file-progress-bg\" [ngStyle]=\"{width: _fileProgressList[i] + '%'}\"></div>\n      </div>\n    </ng-template>\n  </div>\n  <div class=\"bento-progressbar\">\n    <ngb-progressbar\n      aria-live=\"polite\"\n      [value]=\"_uploadProgressPercentage\"\n      [striped]=\"true\"\n      type=\"success\"\n      [attr.aria-describedby]=\"'upload-message-' + uid\"\n    ></ngb-progressbar>\n    <div class=\"sr-only\" [attr.id]=\"'upload-message-' + uid\">\n      {{ 'BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_MESSAGE' | bentoTranslate }}\n    </div>\n  </div>\n  <div class=\"bento-file-selector-progress-percentage-label\">{{ _uploadProgressPercentage }}%</div>\n  <div [@FadeInOut] *ngIf=\"_draggedOver\" class=\"dragover-overlay\">\n    <div class=\"dragover-overlay-label\">\n      {{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_ACTION_LABEL' | bentoTranslate }}\n    </div>\n  </div>\n</div>\n<div class=\"bento-file-selector-error\" aria-live=\"assertive\">\n  <div *ngFor=\"let file of _errorFiles\">\n    <span class=\"sr-only\">{{ 'BENTO_UI_FILE_SELECTOR_A11Y_CAUTION' | bentoTranslate }}</span>\n    <i class=\"bento-icon-warning\" aria-hidden=\"true\"></i>\n    <span class=\"selector-error-message\">\n      <span\n        [innerHTML]=\"\n          'BENTO_UI_FILE_SELECTOR_FILE_ERROR'\n            | bentoTranslate\n            | bentoStringReplace: '_DISPLAY_TYPE_':file.displayType\n            | bentoStringReplace: '_NAME_':file.name\n        \"\n      ></span>\n      <span\n        *ngIf=\"accept\"\n        [innerHTML]=\"'BENTO_UI_FILE_SELECTOR_FILE_EXT_ERROR' | bentoTranslate | bentoStringReplace: '_ACCEPT_':accept\"\n      ></span>\n    </span>\n  </div>\n</div>\n", styles: [".ng-bento bento-file-selector{position:relative;width:100%;padding:50px 0 20px;display:block;text-align:center;border-width:1px;border-style:dashed;overflow:hidden}.ng-bento bento-file-selector.disabled{pointer-events:none}.ng-bento bento-file-selector .bento-progressbar{opacity:0;overflow:hidden;position:absolute;transition:bottom .2s,opacity .2s;width:auto}.ng-bento bento-file-selector .bento-file-selector-progress-percentage-label{display:none;opacity:0;transition:opacity .2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-file-selector.bento-file-selector-in-progress .bento-progressbar{opacity:1}.ng-bento bento-file-selector.bento-file-selector-in-progress .bento-file-selector-progress-percentage-label{opacity:1}.ng-bento bento-file-selector.bento-file-selector-progress-percentage .bento-file-selector-progress-percentage-label{position:absolute;width:35px;font-size:.9em;text-align:right;display:block}.ng-bento bento-file-selector>button{margin-top:10px}.ng-bento bento-file-selector .header{display:block;font-size:16px}.ng-bento bento-file-selector.dragover div,.ng-bento bento-file-selector.dragover span,.ng-bento bento-file-selector.dragover button,.ng-bento bento-file-selector.dragover input{pointer-events:none}.ng-bento bento-file-selector .dragover-overlay{bottom:0;left:0;overflow:hidden;position:absolute;right:0;top:0;transition:opacity .1s}.ng-bento bento-file-selector .filename-container{position:relative;display:block;padding:10px;max-width:100%;min-height:52px}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename{position:relative;margin:5px 5px 5px 0;text-transform:none;padding-right:20px;white-space:nowrap}[dir=rtl] .ng-bento bento-file-selector .filename-container .bento-file-selector-filename{margin:5px 0 5px 5px;padding-right:7.3px;padding-left:20px}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename span{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename>button{border-radius:7px;border:none;background:transparent;height:14px;width:14px;line-height:14px;text-align:center;position:absolute;right:4px;top:3px;padding:0;display:flex;align-items:center;justify-content:center}[dir=rtl] .ng-bento bento-file-selector .filename-container .bento-file-selector-filename>button{right:auto;left:4px}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename>button i{font-size:9px;margin:0;width:100%}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading{border-color:transparent!important;overflow:hidden;transform:translateZ(0)}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading[disabled]{pointer-events:none}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename.loading .bento-file-selector-file-progress-bg{display:block}.ng-bento bento-file-selector ngb-progressbar{display:block;width:100%}.ng-bento bento-file-selector ngb-progressbar .progress-bar-striped{transition:width .2s,background-position 2s}.ng-bento .dragover-overlay-label{font-size:2em;font-weight:700;position:absolute;top:50%;transform:translateY(-50%);width:100%}.ng-bento .bento-file-selector-file-progress-bg{bottom:0;display:none;left:0;position:absolute;top:0;transition:width .5s;width:0}[dir=rtl] .ng-bento .bento-file-selector-file-progress-bg{right:0;left:auto}.ng-bento .selector-has-error{border-width:1px;border-style:solid}.ng-bento .bento-file-selector-error{display:flex;margin-top:20px}.ng-bento .bento-file-selector-error .bento-icon-warning,.ng-bento .bento-file-selector-error .selector-error-message{align-self:flex-start}.ng-bento .bento-file-selector-error .selector-error-message{padding-left:5px}[dir=rtl] .ng-bento .bento-file-selector-error .selector-error-message{padding-right:5px}\n"], components: [{ type: i1$1.NgbProgressbar, selector: "ngb-progressbar", inputs: ["max", "animated", "striped", "showValue", "textType", "type", "value", "height"] }], directives: [{ type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe, "bentoFileSizeFilter": BentoFileSizePipe }, animations: [
        trigger('fileFadeIn', [
            state('in', style({ opacity: 1, transform: 'scale(1)' })),
            state('hidden', style({ opacity: 0, transform: 'scale(1.1)' })),
            state('void', style({ opacity: 0, transform: 'scale(0.9)' })),
            transition('hidden => in', [animate(200)]),
            transition('void => in', [style({ transform: 'scale(1.1)' }), animate(200)])
        ]),
        FadeInOut
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-file-selector', providers: [BENTO_FILE_SELECTOR_VALUE_ACCESSOR, BentoFileSelectorComponentServices], encapsulation: ViewEncapsulation.None, animations: [
                        trigger('fileFadeIn', [
                            state('in', style({ opacity: 1, transform: 'scale(1)' })),
                            state('hidden', style({ opacity: 0, transform: 'scale(1.1)' })),
                            state('void', style({ opacity: 0, transform: 'scale(0.9)' })),
                            transition('hidden => in', [animate(200)]),
                            transition('void => in', [style({ transform: 'scale(1.1)' }), animate(200)])
                        ]),
                        FadeInOut
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\n  <span class=\"header\">{{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL' | bentoTranslate: dropFieldLabel }}</span>\n  <p class=\"mb-2\">{{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_OR' | bentoTranslate }}</p>\n  <button\n    class=\"btn btn-primary\"\n    (click)=\"_onBrowseClick($event)\"\n    [attr.aria-label]=\"'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON' | bentoTranslate\"\n    [disabled]=\"(!appendOnSelection && _uploadProgressPercentage > 0) || _isDisabled\"\n  >\n    <span>{{ 'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL' | bentoTranslate: browseButtonLabel }}</span>\n  </button>\n  <div class=\"clearfix\"></div>\n  <div class=\"filename-container\">\n    <div #postRemovalMessage class=\"sr-only bento-file-selector-post-removal-message\" tabindex=\"-1\">\n      {{\n        'BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE' | bentoTranslate | bentoStringReplace: '_FILE_NAME_':_removedFilename\n      }}\n    </div>\n    <ng-template [ngIf]=\"showSelectedFiles\">\n      <div\n        class=\"btn btn-outline-primary bento-file-selector-filename btn-sm\"\n        *ngFor=\"let file of _fileList; let i = index\"\n        [class.disabled]=\"_disabledFiles[i] && disableDuringUpload\"\n        [class.loading]=\"_disabledFiles[i]\"\n        [attr.rel]=\"'file_' + i\"\n        [attr.aria-busy]=\"_disabledFiles[i]\"\n        [attr.aria-label]=\"\n          ('BENTO_UI_FILE_SELECTOR_FILE_NAME'\n            | bentoTranslate\n            | bentoStringReplace: '_FILE_NAME_':file.name\n            | bentoStringReplace: '_NUM_FILES_':_fileList.length\n            | bentoStringReplace: '_FILE_NUMBER_':i + 1) +\n          ' ' +\n          (showFileSize ? '(' + (file.size | bentoFileSizeFilter) + ')' : '') +\n          ' ' +\n          (_fileProgressList[i] >= 0 && _fileProgressList[i] < 100\n            ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS' | bentoTranslate)\n            : _fileProgressList[i]\n            ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE' | bentoTranslate)\n            : '')\n        \"\n        [@fileFadeIn]=\"_animateSquenceCounter >= i ? 'in' : 'hidden'\"\n        (@fileFadeIn.start)=\"_animateNext($event)\"\n        tabindex=\"0\"\n      >\n        <span>{{ file.name }}{{ showFileSize ? ' (' + (file.size | bentoFileSizeFilter) + ')' : '' }}</span>\n\n        <button\n          (click)=\"_onRemoveClick(i)\"\n          [attr.aria-label]=\"\n            'BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON' | bentoTranslate | bentoStringReplace: '_FILE_NAME_':file.name\n          \"\n          [disabled]=\"_disabledFiles[i] && disableDuringUpload\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n        <div class=\"bento-file-selector-file-progress-bg\" [ngStyle]=\"{width: _fileProgressList[i] + '%'}\"></div>\n      </div>\n    </ng-template>\n  </div>\n  <div class=\"bento-progressbar\">\n    <ngb-progressbar\n      aria-live=\"polite\"\n      [value]=\"_uploadProgressPercentage\"\n      [striped]=\"true\"\n      type=\"success\"\n      [attr.aria-describedby]=\"'upload-message-' + uid\"\n    ></ngb-progressbar>\n    <div class=\"sr-only\" [attr.id]=\"'upload-message-' + uid\">\n      {{ 'BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_MESSAGE' | bentoTranslate }}\n    </div>\n  </div>\n  <div class=\"bento-file-selector-progress-percentage-label\">{{ _uploadProgressPercentage }}%</div>\n  <div [@FadeInOut] *ngIf=\"_draggedOver\" class=\"dragover-overlay\">\n    <div class=\"dragover-overlay-label\">\n      {{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_ACTION_LABEL' | bentoTranslate }}\n    </div>\n  </div>\n</div>\n<div class=\"bento-file-selector-error\" aria-live=\"assertive\">\n  <div *ngFor=\"let file of _errorFiles\">\n    <span class=\"sr-only\">{{ 'BENTO_UI_FILE_SELECTOR_A11Y_CAUTION' | bentoTranslate }}</span>\n    <i class=\"bento-icon-warning\" aria-hidden=\"true\"></i>\n    <span class=\"selector-error-message\">\n      <span\n        [innerHTML]=\"\n          'BENTO_UI_FILE_SELECTOR_FILE_ERROR'\n            | bentoTranslate\n            | bentoStringReplace: '_DISPLAY_TYPE_':file.displayType\n            | bentoStringReplace: '_NAME_':file.name\n        \"\n      ></span>\n      <span\n        *ngIf=\"accept\"\n        [innerHTML]=\"'BENTO_UI_FILE_SELECTOR_FILE_EXT_ERROR' | bentoTranslate | bentoStringReplace: '_ACCEPT_':accept\"\n      ></span>\n    </span>\n  </div>\n</div>\n", styles: [".ng-bento bento-file-selector{position:relative;width:100%;padding:50px 0 20px;display:block;text-align:center;border-width:1px;border-style:dashed;overflow:hidden}.ng-bento bento-file-selector.disabled{pointer-events:none}.ng-bento bento-file-selector .bento-progressbar{opacity:0;overflow:hidden;position:absolute;transition:bottom .2s,opacity .2s;width:auto}.ng-bento bento-file-selector .bento-file-selector-progress-percentage-label{display:none;opacity:0;transition:opacity .2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-file-selector.bento-file-selector-in-progress .bento-progressbar{opacity:1}.ng-bento bento-file-selector.bento-file-selector-in-progress .bento-file-selector-progress-percentage-label{opacity:1}.ng-bento bento-file-selector.bento-file-selector-progress-percentage .bento-file-selector-progress-percentage-label{position:absolute;width:35px;font-size:.9em;text-align:right;display:block}.ng-bento bento-file-selector>button{margin-top:10px}.ng-bento bento-file-selector .header{display:block;font-size:16px}.ng-bento bento-file-selector.dragover div,.ng-bento bento-file-selector.dragover span,.ng-bento bento-file-selector.dragover button,.ng-bento bento-file-selector.dragover input{pointer-events:none}.ng-bento bento-file-selector .dragover-overlay{bottom:0;left:0;overflow:hidden;position:absolute;right:0;top:0;transition:opacity .1s}.ng-bento bento-file-selector .filename-container{position:relative;display:block;padding:10px;max-width:100%;min-height:52px}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename{position:relative;margin:5px 5px 5px 0;text-transform:none;padding-right:20px;white-space:nowrap}[dir=rtl] .ng-bento bento-file-selector .filename-container .bento-file-selector-filename{margin:5px 0 5px 5px;padding-right:7.3px;padding-left:20px}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename span{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename>button{border-radius:7px;border:none;background:transparent;height:14px;width:14px;line-height:14px;text-align:center;position:absolute;right:4px;top:3px;padding:0;display:flex;align-items:center;justify-content:center}[dir=rtl] .ng-bento bento-file-selector .filename-container .bento-file-selector-filename>button{right:auto;left:4px}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename>button i{font-size:9px;margin:0;width:100%}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading{border-color:transparent!important;overflow:hidden;transform:translateZ(0)}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading[disabled]{pointer-events:none}.ng-bento bento-file-selector .filename-container .bento-file-selector-filename.loading .bento-file-selector-file-progress-bg{display:block}.ng-bento bento-file-selector ngb-progressbar{display:block;width:100%}.ng-bento bento-file-selector ngb-progressbar .progress-bar-striped{transition:width .2s,background-position 2s}.ng-bento .dragover-overlay-label{font-size:2em;font-weight:700;position:absolute;top:50%;transform:translateY(-50%);width:100%}.ng-bento .bento-file-selector-file-progress-bg{bottom:0;display:none;left:0;position:absolute;top:0;transition:width .5s;width:0}[dir=rtl] .ng-bento .bento-file-selector-file-progress-bg{right:0;left:auto}.ng-bento .selector-has-error{border-width:1px;border-style:solid}.ng-bento .bento-file-selector-error{display:flex;margin-top:20px}.ng-bento .bento-file-selector-error .bento-icon-warning,.ng-bento .bento-file-selector-error .selector-error-message{align-self:flex-start}.ng-bento .bento-file-selector-error .selector-error-message{padding-left:5px}[dir=rtl] .ng-bento .bento-file-selector-error .selector-error-message{padding-right:5px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoFileSelectorComponentServices }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: WindowRef }]; }, propDecorators: { fileSelect: [{
                type: Output
            }], duplicateSelect: [{
                type: Output
            }], fileRemove: [{
                type: Output
            }], accept: [{
                type: Input
            }], appendOnSelection: [{
                type: Input
            }], browseButtonLabel: [{
                type: Input
            }], disableDuringUpload: [{
                type: Input
            }], dropFieldLabel: [{
                type: Input
            }], fileType: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showSelectedFiles: [{
                type: Input
            }], showFileSize: [{
                type: Input
            }], showProgressPercentage: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.bento-file-selector-progress-percentage']
            }], _fileSelectorInProgress: [{
                type: HostBinding,
                args: ['class.bento-file-selector-in-progress']
            }], uploadProgress: [{
                type: Input
            }], _draggedOver: [{
                type: HostBinding,
                args: ['class.dragover']
            }], _postRemovalMessage: [{
                type: ViewChild,
                args: ['postRemovalMessage', { static: true }]
            }], _isDisabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }], _onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }], _onDragEnter: [{
                type: HostListener,
                args: ['dragenter', ['$event']]
            }], _onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], _onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], _onFocusout: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

class BentoFileSelectorModule extends ConsumerDataValidator {
}
BentoFileSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoFileSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorModule, declarations: [BentoFileSelectorComponent], imports: [FormsModule,
        CommonModule,
        // BrowserAnimationsModule,
        BentoTranslateModule,
        NgbProgressbarModule,
        BentoUtilsModule,
        BentoFocusMonitorModule], exports: [BentoFileSelectorComponent] });
BentoFileSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorModule, imports: [[
            FormsModule,
            CommonModule,
            // BrowserAnimationsModule,
            BentoTranslateModule,
            NgbProgressbarModule,
            BentoUtilsModule,
            BentoFocusMonitorModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFileSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        CommonModule,
                        // BrowserAnimationsModule,
                        BentoTranslateModule,
                        NgbProgressbarModule,
                        BentoUtilsModule,
                        BentoFocusMonitorModule
                    ],
                    declarations: [BentoFileSelectorComponent],
                    exports: [BentoFileSelectorComponent]
                }]
        }] });

/**
 * A directive to help with responsive behavior in Global Header.
 *
 * The directive will hide or show the global header's `.topbar-middle` element
 * depending on how narrow or wide the global header's dimensions are on browser resize.
 * Use the event payload's boolean property `menuHidden` to determine whether to
 * hide or display the off canvas menu button or take any other desired actions.
 *
 * To hide or display the menu button in the [Off Canvas Menu](/components/off-canvas-menu),
 * you can set its `menuButtonIsHidden` attribute to true or false.
 */
class BentoGlobalHeaderChangeDirective {
    constructor(elementRef, bentoNotfication) {
        this.elementRef = elementRef;
        /**
         * Event emitter when header has resized. Payload returns an object with a
         * boolean property called `menuHidden` set to true if items in `.topbar-middle` elements
         * are hidden.
         */
        this.headerResize = new EventEmitter();
        this.totalWidth = 0;
        bentoNotfication.resizeNotification.subscribe(() => {
            this.onResize();
        });
    }
    ngAfterContentInit() {
        setTimeout(() => {
            const leftElement = this.elementRef.nativeElement.querySelector('.topbar-left');
            const leftWidth = leftElement ? leftElement.getBoundingClientRect().width : 0;
            const rightElement = this.elementRef.nativeElement.querySelector('.topbar-right');
            const rightWidth = rightElement ? rightElement.getBoundingClientRect().width : 0;
            this.middleElement = this.elementRef.nativeElement.querySelector('.topbar-middle');
            const middleWidth = this.middleElement.getBoundingClientRect().width;
            this.totalWidth = leftWidth + rightWidth + middleWidth;
            this.onResize();
        });
    }
    onResize() {
        const elementWidth = this.elementRef.nativeElement.getBoundingClientRect().width;
        if (this.totalWidth > elementWidth) {
            this.hideMenu();
        }
        else {
            this.showMenu();
        }
    }
    hideMenu() {
        this.middleElement.classList.add('hidden');
        this.headerResize.emit({
            menuHidden: true
        });
    }
    showMenu() {
        this.middleElement.classList.remove('hidden');
        this.headerResize.emit({
            menuHidden: false
        });
    }
}
BentoGlobalHeaderChangeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoGlobalHeaderChangeDirective, deps: [{ token: i0.ElementRef }, { token: BentoNotification }], target: i0.ɵɵFactoryTarget.Directive });
BentoGlobalHeaderChangeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoGlobalHeaderChangeDirective, selector: "[bentoGlobalHeaderChange]", outputs: { headerResize: "bentoGlobalHeaderChange" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoGlobalHeaderChangeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoGlobalHeaderChange]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoNotification }]; }, propDecorators: { headerResize: [{
                type: Output,
                args: ['bentoGlobalHeaderChange']
            }] } });

class BentoGlobalHeaderModule extends ConsumerDataValidator {
}
BentoGlobalHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoGlobalHeaderModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoGlobalHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoGlobalHeaderModule, declarations: [BentoGlobalHeaderChangeDirective], exports: [BentoGlobalHeaderChangeDirective] });
BentoGlobalHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoGlobalHeaderModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoGlobalHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [BentoGlobalHeaderChangeDirective],
                    exports: [BentoGlobalHeaderChangeDirective]
                }]
        }] });

class BentoMegamenuHTagRankDirective {
    constructor(elementRef, r, sanitizer, dir) {
        this.r = r;
        this.sanitizer = sanitizer;
        this.isRtl = false;
        this.el = elementRef.nativeElement;
        this.isRtl = dir.value === 'rtl';
    }
    ngOnInit() {
        if (this.item.label) {
            if (!this.hTagRank) {
                // default to 5 - as previous
                this.hTagRank = 5;
            }
            const headerEl = this.r.createElement('h' + this.hTagRank);
            let label = this.item.label;
            if (this.item.id) {
                this.r.setAttribute(headerEl, 'id', this.item.id);
            }
            if (this.item.icon) {
                label = `<i class="${this.item.icon} ${this.isRtl ? 'ml-1' : 'mr-1'}"></i>${label}`;
            }
            /**
             * .h5 class added by design. It is to preserve the design and UI while meet a11y requirements
             * when different heading levels are needed based on the location of the megamenu in a view
             */
            this.r.addClass(headerEl, 'h5'); // @TODO remove this and relace with design tokens in css
            this.r.addClass(headerEl, 'bui-megamenu-column-header');
            this.r.setProperty(headerEl, 'innerHTML', this.sanitizer.sanitize(SecurityContext.HTML, label));
            this.r.insertBefore(this.el, headerEl, this.el.firstChild);
        }
    }
}
BentoMegamenuHTagRankDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuHTagRankDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$2.DomSanitizer }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Directive });
BentoMegamenuHTagRankDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoMegamenuHTagRankDirective, selector: "[megamenuHTagRank]", inputs: { item: "item", hTagRank: "hTagRank" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuHTagRankDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[megamenuHTagRank]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$2.DomSanitizer }, { type: i2.Directionality }]; }, propDecorators: { item: [{
                type: Input
            }], hTagRank: [{
                type: Input
            }] } });

class BentoMegaMenuItemDirective extends NgbDropdownItem {
    constructor(elementRef) {
        super(elementRef);
        this.elementRef = elementRef;
    }
}
BentoMegaMenuItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegaMenuItemDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoMegaMenuItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoMegaMenuItemDirective, selector: "[bentoMegamenuItem]", providers: [{ provide: NgbDropdownItem, useExisting: forwardRef(() => BentoMegaMenuItemDirective) }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegaMenuItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoMegamenuItem]',
                    providers: [{ provide: NgbDropdownItem, useExisting: forwardRef(() => BentoMegaMenuItemDirective) }]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class BentoMegamenuDefaultComponent {
    /**
     */
    constructor(r, elementRef, bentoNotification, windowRef, dropdown) {
        this.r = r;
        this.bentoNotification = bentoNotification;
        this.dropdown = dropdown;
        /**
         * Main items data model to store Bento Megamenu content
         */
        this.items = [];
        // Property to know if this component is embedded in another component.  If so, enable role="menu".
        // Currently used when megamenu default is embedded in the scollable toolbar
        // Internal use only, not published to the API
        this.isEmbedded = false;
        this.document = windowRef.nativeDocument;
        this.el = elementRef.nativeElement;
    }
    /**
     * Reference element is used to make this megamenu to be self aware on its width and
     */
    set widthElRef(elRef) {
        if (elRef) {
            this.widthRefEl = elRef.nativeElement ? elRef.nativeElement : elRef;
        }
        else {
            this.widthRefEl = this.document.querySelector('body');
        }
    }
    /**
     * Implementation of AfterViewInit
     * Need to get the width reference element here
     */
    ngAfterViewInit() {
        this.parentEl = this.el.parentElement;
        // Default the widthRefEl
        if (!this.appendToEl) {
            this.widthRefEl = this.widthRefEl || this.document.querySelector('body');
            this.toggleEl = this.findToggleEl();
            this.maxWidth = !!this.maxWidth && this.maxWidth > 0 ? this.maxWidth : Number.POSITIVE_INFINITY;
        }
    }
    /**
     * Implement OnInit
     */
    ngOnInit() {
        if (!this.appendToEl) {
            // Only setup layout management when BentoAppendTo is not used
            this.r.addClass(this.el.parentElement, 'bento-megamenu-rendering');
            this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe(() => {
                this.updateMenuLayout();
            });
            this.dropdownOpenSub = this.dropdown.openChange.subscribe(v => {
                if (v) {
                    setTimeout(() => {
                        this.updateMenuLayout();
                        this.r.removeClass(this.el.parentElement, 'bento-megamenu-rendering');
                    });
                }
                else {
                    this.r.setStyle(this.el, 'left', 'auto');
                }
            });
        }
        if (!this.ariaLabel) {
            console.warn('Aria label is required with the Megamenu Default.');
        }
    }
    /**
     * Implement OnDestroy
     */
    ngOnDestroy() {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
        if (this.dropdownOpenSub) {
            this.dropdownOpenSub.unsubscribe();
        }
    }
    onMenuClick(e, item, column) {
        if (column.disabled) {
            return;
        }
        // Call item click events
        if (item.action) {
            item.action(item);
        }
        if (!(item.anchor && item.anchor.href)) {
            e.preventDefault();
        }
    }
    /**
     * Update Megamenu layout based on widthRefEl width
     */
    updateMenuLayout() {
        const maxWidth = this.widthRefEl.clientWidth;
        this.r.setStyle(this.parentEl, 'max-width', maxWidth + 'px');
        this.parentEl.querySelector('.column-flex-container').setAttribute('style', 'display: flex;');
        if (this.widthRefEl.clientWidth <= this.parentEl.clientWidth + this.parentEl.getBoundingClientRect().left) {
            // The follow a11y code from task [BENTO-3575] generates regression on fundamental megamenu UI
            // leaving it out until further investigation
            // this.parentEl.querySelector('.column-flex-container').setAttribute('style', 'display: block;');
        }
    }
    /**
     * Since dropdown doesn't expose toggleElement, we need to manually look for it
     */
    findToggleEl() {
        let dEl;
        let elRef = this.el.parentElement;
        let counter = 0;
        // find ngbDropdown;
        while (elRef.parentElement && elRef.parentElement.tagName !== 'BODY' && counter < 20) {
            if (elRef.hasAttribute('ngbDropdown')) {
                dEl = elRef;
                break;
            }
            elRef = elRef.parentElement;
            counter++;
        }
        if (dEl) {
            return dEl.querySelector('[ngbDropdownToggle]');
        }
        else {
            throw new Error('Megamenu: [ngbDropdown] is missing');
        }
    }
}
BentoMegamenuDefaultComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuDefaultComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: BentoNotification }, { token: WindowRef }, { token: forwardRef(() => NgbDropdown) }], target: i0.ɵɵFactoryTarget.Component });
BentoMegamenuDefaultComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoMegamenuDefaultComponent, selector: "bento-megamenu-default", inputs: { items: "items", hTagRank: "hTagRank", widthElRef: "widthElRef", maxWidth: "maxWidth", appendToEl: "appendToEl", isRtl: "isRtl", isEmbedded: "isEmbedded", ariaLabel: "ariaLabel" }, providers: [BentoNotification], viewQueries: [{ propertyName: "menuItems", predicate: NgbDropdownItem, descendants: true }], ngImport: i0, template: "<div\n  class=\"column-flex-container\"\n  [attr.role]=\"isEmbedded ? 'menu' : 'navigation'\"\n  [attr.aria-label]=\"isEmbedded ? null : ariaLabel ? ariaLabel : null\"\n>\n  <div *ngFor=\"let column of items\" class=\"column\" megamenuHTagRank [item]=\"column\" [hTagRank]=\"hTagRank\">\n    <ng-container *ngFor=\"let item of column.menu; let itemIndex = index\">\n      <a\n        *ngIf=\"item?.routerLink?.href; else defaultLink\"\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        [attr.role]=\"isEmbedded ? 'menuitem' : null\"\n        [attr.id]=\"item.id ? item.id : null\"\n        [routerLink]=\"item?.routerLink?.href\"\n        [queryParams]=\"item?.routerLink?.queryParams\"\n        [fragment]=\"item?.routerLink?.fragment\"\n        [queryParamsHandling]=\"item?.routerLink?.queryParamsHandling\"\n        [preserveFragment]=\"item?.routerLink?.preserveFragment\"\n        [skipLocationChange]=\"item?.routerLink?.skipLocationChange\"\n        [replaceUrl]=\"item?.routerLink?.replaceUrl\"\n        [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n        (click)=\"onMenuClick($event, item, column)\"\n        [class.active]=\"item.active\"\n        [class.disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-selected]=\"item.active\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.routerLink?.text || item.anchor?.text || item.label\"></span>\n      </a>\n      <ng-template #defaultLink>\n        <a\n          bentoMegamenuItem\n          class=\"dropdown-item\"\n          [attr.role]=\"isEmbedded ? 'menuitem' : null\"\n          [attr.id]=\"item.id ? item.id : null\"\n          [attr.href]=\"item?.anchor?.href || '#'\"\n          [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n          (click)=\"onMenuClick($event, item, column)\"\n          [class.active]=\"item.active\"\n          [class.disabled]=\"item.disabled || column.disabled\"\n          [attr.aria-disabled]=\"item.disabled || column.disabled\"\n          [attr.aria-selected]=\"item.active\"\n          [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n        >\n          <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"item.routerLink?.text || item.anchor?.text || item.label\"></span>\n        </a>\n      </ng-template>\n    </ng-container>\n  </div>\n</div>\n", directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoMegamenuHTagRankDirective, selector: "[megamenuHTagRank]", inputs: ["item", "hTagRank"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: BentoMegaMenuItemDirective, selector: "[bentoMegamenuItem]" }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuDefaultComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-megamenu-default', providers: [BentoNotification], template: "<div\n  class=\"column-flex-container\"\n  [attr.role]=\"isEmbedded ? 'menu' : 'navigation'\"\n  [attr.aria-label]=\"isEmbedded ? null : ariaLabel ? ariaLabel : null\"\n>\n  <div *ngFor=\"let column of items\" class=\"column\" megamenuHTagRank [item]=\"column\" [hTagRank]=\"hTagRank\">\n    <ng-container *ngFor=\"let item of column.menu; let itemIndex = index\">\n      <a\n        *ngIf=\"item?.routerLink?.href; else defaultLink\"\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        [attr.role]=\"isEmbedded ? 'menuitem' : null\"\n        [attr.id]=\"item.id ? item.id : null\"\n        [routerLink]=\"item?.routerLink?.href\"\n        [queryParams]=\"item?.routerLink?.queryParams\"\n        [fragment]=\"item?.routerLink?.fragment\"\n        [queryParamsHandling]=\"item?.routerLink?.queryParamsHandling\"\n        [preserveFragment]=\"item?.routerLink?.preserveFragment\"\n        [skipLocationChange]=\"item?.routerLink?.skipLocationChange\"\n        [replaceUrl]=\"item?.routerLink?.replaceUrl\"\n        [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n        (click)=\"onMenuClick($event, item, column)\"\n        [class.active]=\"item.active\"\n        [class.disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-selected]=\"item.active\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.routerLink?.text || item.anchor?.text || item.label\"></span>\n      </a>\n      <ng-template #defaultLink>\n        <a\n          bentoMegamenuItem\n          class=\"dropdown-item\"\n          [attr.role]=\"isEmbedded ? 'menuitem' : null\"\n          [attr.id]=\"item.id ? item.id : null\"\n          [attr.href]=\"item?.anchor?.href || '#'\"\n          [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n          (click)=\"onMenuClick($event, item, column)\"\n          [class.active]=\"item.active\"\n          [class.disabled]=\"item.disabled || column.disabled\"\n          [attr.aria-disabled]=\"item.disabled || column.disabled\"\n          [attr.aria-selected]=\"item.active\"\n          [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n        >\n          <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"item.routerLink?.text || item.anchor?.text || item.label\"></span>\n        </a>\n      </ng-template>\n    </ng-container>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: BentoNotification }, { type: WindowRef }, { type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }];
    }, propDecorators: { items: [{
                type: Input
            }], hTagRank: [{
                type: Input
            }], widthElRef: [{
                type: Input
            }], menuItems: [{
                type: ViewChildren,
                args: [NgbDropdownItem]
            }], maxWidth: [{
                type: Input
            }], appendToEl: [{
                type: Input
            }], isRtl: [{
                type: Input
            }], isEmbedded: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }] } });

class BentoMegaMenuFlowComponent extends BentoMegamenuDefaultComponent {
    /**
     */
    constructor(renderer, windowRef, elementRef, bentoNotification, dropdown) {
        super(renderer, elementRef, bentoNotification, windowRef, dropdown);
        this.dropdown = dropdown;
        this._computedColWidth = 140;
    }
    /**
     * Column width
     */
    set columnWidth(w) {
        if (!!w && w > 0) {
            this._computedColWidth = w - 1; // 1 is used as gap
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.width = !!this.width && this.width > 0 ? this.width : Number.POSITIVE_INFINITY;
        if (!this.ariaLabel) {
            console.warn('Aria label is required with the Megamenu Flow.');
        }
    }
    /**
     * Update Megamenu layout based on widthRefEl width
     */
    updateMenuLayout() {
        const maxWidth = this.widthRefEl.clientWidth;
        if (maxWidth > 600) {
            const computedStyle = getComputedStyle(this.el);
            const sidePaddings = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
            const megamenuWidth = Math.min(maxWidth, this.width + sidePaddings);
            this.r.setStyle(this.parentEl, 'width', megamenuWidth + 'px');
            this.r.setStyle(this.parentEl, 'height', 'auto');
            this.r.setStyle(this.parentEl, 'max-height', 'none !important');
        }
        else {
            this.r.setStyle(this.parentEl, 'width', 'auto');
            this.r.setStyle(this.parentEl, 'max-height', '45vh !important');
        }
    }
}
BentoMegaMenuFlowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegaMenuFlowComponent, deps: [{ token: i0.Renderer2 }, { token: WindowRef }, { token: i0.ElementRef }, { token: BentoNotification }, { token: forwardRef(() => NgbDropdown) }], target: i0.ɵɵFactoryTarget.Component });
BentoMegaMenuFlowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoMegaMenuFlowComponent, selector: "bento-megamenu-flow", inputs: { columnWidth: "columnWidth", width: "width", isRtl: "isRtl", ariaLabel: "ariaLabel" }, host: { properties: { "style.column-width.px": "this._computedColWidth" } }, providers: [
        BentoNotification,
        { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(() => BentoMegaMenuFlowComponent) }
    ], usesInheritance: true, ngImport: i0, template: "<nav\n  *ngFor=\"let column of items\"\n  class=\"column\"\n  [ngClass]=\"column.label ? 'bento-megamenu-whole-column ' : ''\"\n  megamenuHTagRank\n  [item]=\"column\"\n  [hTagRank]=\"hTagRank\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n>\n  <ng-container *ngFor=\"let item of column.menu; let itemIndex = index\">\n    <a\n      *ngIf=\"item?.routerLink?.href; else defaultLink\"\n      bentoMegamenuItem\n      class=\"dropdown-item\"\n      [attr.id]=\"item.id ? item.id : null\"\n      [routerLink]=\"item?.routerLink?.href\"\n      [queryParams]=\"item?.routerLink?.queryParams\"\n      [fragment]=\"item?.routerLink?.fragment\"\n      [queryParamsHandling]=\"item?.routerLink?.queryParamsHandling\"\n      [preserveFragment]=\"item?.routerLink?.preserveFragment\"\n      [skipLocationChange]=\"item?.routerLink?.skipLocationChange\"\n      [replaceUrl]=\"item?.routerLink?.replaceUrl\"\n      [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n      (click)=\"onMenuClick($event, item, column)\"\n      [class.active]=\"item.active\"\n      [class.disabled]=\"item.disabled || column.disabled\"\n      [attr.aria-disabled]=\"item.disabled || column.disabled\"\n      [attr.aria-selected]=\"item.active\"\n      [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n    >\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n      <span [innerHTML]=\"item.routerLink?.text || item.label\"></span>\n    </a>\n    <ng-template #defaultLink>\n      <a\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        [attr.id]=\"item.id ? item.id : null\"\n        [attr.href]=\"item.anchor?.href || '#'\"\n        (click)=\"onMenuClick($event, item, column)\"\n        [class.active]=\"item.active\"\n        [class.disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-selected]=\"item.active\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n      </a>\n    </ng-template>\n  </ng-container>\n</nav>\n", directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoMegamenuHTagRankDirective, selector: "[megamenuHTagRank]", inputs: ["item", "hTagRank"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: BentoMegaMenuItemDirective, selector: "[bentoMegamenuItem]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegaMenuFlowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-megamenu-flow', providers: [
                        BentoNotification,
                        { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(() => BentoMegaMenuFlowComponent) }
                    ], template: "<nav\n  *ngFor=\"let column of items\"\n  class=\"column\"\n  [ngClass]=\"column.label ? 'bento-megamenu-whole-column ' : ''\"\n  megamenuHTagRank\n  [item]=\"column\"\n  [hTagRank]=\"hTagRank\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n>\n  <ng-container *ngFor=\"let item of column.menu; let itemIndex = index\">\n    <a\n      *ngIf=\"item?.routerLink?.href; else defaultLink\"\n      bentoMegamenuItem\n      class=\"dropdown-item\"\n      [attr.id]=\"item.id ? item.id : null\"\n      [routerLink]=\"item?.routerLink?.href\"\n      [queryParams]=\"item?.routerLink?.queryParams\"\n      [fragment]=\"item?.routerLink?.fragment\"\n      [queryParamsHandling]=\"item?.routerLink?.queryParamsHandling\"\n      [preserveFragment]=\"item?.routerLink?.preserveFragment\"\n      [skipLocationChange]=\"item?.routerLink?.skipLocationChange\"\n      [replaceUrl]=\"item?.routerLink?.replaceUrl\"\n      [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n      (click)=\"onMenuClick($event, item, column)\"\n      [class.active]=\"item.active\"\n      [class.disabled]=\"item.disabled || column.disabled\"\n      [attr.aria-disabled]=\"item.disabled || column.disabled\"\n      [attr.aria-selected]=\"item.active\"\n      [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n    >\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n      <span [innerHTML]=\"item.routerLink?.text || item.label\"></span>\n    </a>\n    <ng-template #defaultLink>\n      <a\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        [attr.id]=\"item.id ? item.id : null\"\n        [attr.href]=\"item.anchor?.href || '#'\"\n        (click)=\"onMenuClick($event, item, column)\"\n        [class.active]=\"item.active\"\n        [class.disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-disabled]=\"item.disabled || column.disabled\"\n        [attr.aria-selected]=\"item.active\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n      </a>\n    </ng-template>\n  </ng-container>\n</nav>\n" }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: WindowRef }, { type: i0.ElementRef }, { type: BentoNotification }, { type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }];
    }, propDecorators: { columnWidth: [{
                type: Input
            }], width: [{
                type: Input
            }], isRtl: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], _computedColWidth: [{
                type: HostBinding,
                args: ['style.column-width.px']
            }] } });

class BentoMegamenuTakeoverComponent extends BentoMegamenuDefaultComponent {
    /**
     *
     */
    constructor(r, elementRef, bentoNotification, windowRef, dropdown) {
        super(r, elementRef, bentoNotification, windowRef, dropdown);
        this.r = r;
        this.elementRef = elementRef;
        this.dropdown = dropdown;
        /**
         * Current sub-menu array
         */
        this.currentMenu = [];
        this.initialHeaderHeight = 0;
        this.isHeaderClicked = false;
    }
    /**
     * Implement OnInit
     */
    ngOnInit() {
        this.openChangeSub = this.dropdown.openChange.subscribe(v => {
            if (v) {
                this.updateMenuLayout();
            }
            else {
                this.isHeaderClicked = false;
            }
        });
        // Need to override NgbDropdown's positioning
        this.dropdown['_positionMenu'] = () => { };
    }
    /**
     * Implement OnDestroy
     */
    ngOnDestroy() {
        this.openChangeSub.unsubscribe();
    }
    /**
     * Callback when user hits arrow keys in the header menu
     */
    onHeaderKeydown(event) {
        switch (event.keyCode) {
            case Keyboard.RIGHT:
                const firstElement = this.takeoverMenus.nativeElement.querySelector('a');
                if (firstElement) {
                    firstElement.focus();
                }
                event.preventDefault();
                return;
            case Keyboard.UP:
                this.focusOnHeaderAtIndex(this.getCurrentHeaderIndex() - 1);
                event.preventDefault();
                return;
            case Keyboard.DOWN:
                this.focusOnHeaderAtIndex(this.getCurrentHeaderIndex() + 1);
                event.preventDefault();
                return;
        }
    }
    /**
     * Callback when user hits arrow keys in the sub menu
     */
    onSubMenuKeydown(event) {
        switch (event.keyCode) {
            case Keyboard.LEFT: // -> back to header menu
                this.focusOnHeaderAtIndex(this.getCurrentHeaderIndex());
                return;
            case Keyboard.UP:
                const pSibling = event.currentTarget.previousElementSibling;
                if (pSibling) {
                    pSibling.querySelector('a').focus();
                }
                event.preventDefault();
                return;
            case Keyboard.DOWN:
                const nSibling = event.currentTarget.nextElementSibling;
                if (nSibling) {
                    nSibling.querySelector('a').focus();
                }
                event.preventDefault();
                return;
        }
    }
    /**
     * Event listner to Click, Focus and MouseOver
     */
    onHeaderFocus(event, column) {
        event.stopPropagation();
        event.preventDefault();
        if (event.type === 'click' && typeof column.action === 'function') {
            // If there is an action assigned to the header, we fire its action
            column.action();
            if (!column.menu || !column.menu.length) {
                // Close the dropdown if there is no submenu
                this.dropdown.close();
            }
        }
        if (this.isHeaderClicked && event.type === 'mouseenter') {
            // Ignore all 'mouseenter' event when one of the headers is clicked already
            return;
        }
        if (event.type === 'click') {
            // Focus is taking care of the selection already
            // so we only register a click here
            this.isHeaderClicked = true;
            return;
        }
        if (column === this.currentColumn) {
            // Nothing is changed here
            return;
        }
        // Update the current column to render
        this.currentColumn = column;
        this.currentMenu = column.menu;
    }
    /**
     * Update Megamenu layout based on widthRefEl width
     */
    updateMenuLayout() {
        const maxWidth = this.widthRefEl.clientWidth;
        const toggleRect = this.toggleEl.getBoundingClientRect();
        const widthRefRect = this.widthRefEl.getBoundingClientRect();
        const toggleOffsetLeft = toggleRect.left - widthRefRect.left;
        this.r.setStyle(this.parentEl, 'width', maxWidth + 'px');
        // https://stackoverflow.com/a/49823129
        // eslint-disable-next-line  no-bitwise
        const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
        this.r.setStyle(this.parentEl, 'transform', `translateX(${-toggleOffsetLeft}px)`, flags);
        this.r.setStyle(this.parentEl, 'right', 'auto');
        this.r.setStyle(this.parentEl, 'left', '0', flags);
        setTimeout(() => this.resizeSubmenu());
    }
    /**
     * Need some dom resizing after rendering done
     */
    resizeSubmenu() {
        const headersEl = this.takeoverHeaders.nativeElement;
        const headerHeight = headersEl.offsetHeight;
        const submenuEl = this.takeoverMenus.nativeElement;
        const nativeEl = this.elementRef.nativeElement;
        const nativeWidth = nativeEl.offsetWidth;
        if (this.initialHeaderHeight === 0) {
            this.initialHeaderHeight = headerHeight;
        }
        // Check if the submenu is overflowing
        const diff = nativeEl.scrollWidth - nativeEl.offsetWidth;
        if (diff > 0) {
            // Need change the submenu height with the same size in area
            const area = submenuEl.offsetHeight * (nativeWidth - headersEl.offsetWidth);
            const submenuVWidth = nativeWidth - diff - headersEl.offsetWidth;
            this.r.setStyle(submenuEl, 'height', area / submenuVWidth + 'px');
        }
        else {
            this.r.setStyle(submenuEl, 'height', this.initialHeaderHeight + 'px');
        }
    }
    /**
     * Get the current header index from the header
     */
    getCurrentHeaderIndex() {
        return this.items.indexOf(this.currentColumn);
    }
    /**
     * Focus on a header by its index
     */
    focusOnHeaderAtIndex(index) {
        // out of bound
        if (index < 0) {
            return;
        }
        const children = this.takeoverHeaders.nativeElement.querySelectorAll('li a');
        // out of bound
        if (index >= children.length) {
            return;
        }
        children.item(index).focus();
    }
}
BentoMegamenuTakeoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuTakeoverComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: BentoNotification }, { token: WindowRef }, { token: forwardRef(() => NgbDropdown) }], target: i0.ɵɵFactoryTarget.Component });
BentoMegamenuTakeoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoMegamenuTakeoverComponent, selector: "bento-megamenu-takeover", inputs: { items: "items", isRtl: "isRtl" }, providers: [
        BentoNotification,
        { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(() => BentoMegamenuTakeoverComponent) }
    ], viewQueries: [{ propertyName: "takeoverMenus", first: true, predicate: ["takeoverMenus"], descendants: true, static: true }, { propertyName: "takeoverHeaders", first: true, predicate: ["takeoverHeaders"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"bento-megamenu-takeover-flex-container\">\n  <ul #takeoverHeaders class=\"bento-megamenu-takeover-headers\" role=\"menu\">\n    <li *ngFor=\"let column of items\" [class.active]=\"currentColumn === column\" (keydown)=\"onHeaderKeydown($event)\">\n      <a\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        href=\"#\"\n        (click)=\"onHeaderFocus($event, column)\"\n        (focus)=\"onHeaderFocus($event, column)\"\n        (mouseenter)=\"onHeaderFocus($event, column)\"\n        role=\"menuitem\"\n      >\n        <i *ngIf=\"column.menu\" class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n        <span>\n          <i *ngIf=\"column.icon\" [ngClass]=\"column.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"column.label\"></span>\n        </span>\n      </a>\n    </li>\n  </ul>\n  <ul #takeoverMenus tabindex=\"-1\" class=\"bento-megamenu-takeover-items\" role=\"menu\">\n    <li *ngFor=\"let item of currentMenu\" (keydown)=\"onSubMenuKeydown($event)\">\n      <a\n        *ngIf=\"item?.routerLink?.href; else defaultLink\"\n        (click)=\"onMenuClick($event, item, currentColumn)\"\n        [routerLink]=\"item?.routerLink?.href\"\n        [queryParams]=\"item?.routerLink?.queryParams\"\n        [fragment]=\"item?.routerLink?.fragment\"\n        [queryParamsHandling]=\"item?.routerLink?.queryParamsHandling\"\n        [preserveFragment]=\"item?.routerLink?.preserveFragment\"\n        [skipLocationChange]=\"item?.routerLink?.skipLocationChange\"\n        [replaceUrl]=\"item?.routerLink?.replaceUrl\"\n        role=\"menuitem\"\n        [class.disabled]=\"item.disabled || currentColumn.disabled\"\n        [attr.aria-disabled]=\"item.disabled || currentColumn.disabled\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.routerLink?.text || item.label\"></span>\n      </a>\n      <ng-template #defaultLink>\n        <a\n          href=\"#\"\n          (click)=\"onMenuClick($event, item, currentColumn)\"\n          [attr.href]=\"item.anchor?.href || '#'\"\n          role=\"menuitem\"\n          [class.disabled]=\"item.disabled || currentColumn.disabled\"\n          [attr.aria-disabled]=\"item.disabled || currentColumn.disabled\"\n          [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n        >\n          <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n        </a>\n      </ng-template>\n    </li>\n  </ul>\n</div>\n", directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: BentoMegaMenuItemDirective, selector: "[bentoMegamenuItem]" }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuTakeoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-megamenu-takeover', providers: [
                        BentoNotification,
                        { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(() => BentoMegamenuTakeoverComponent) }
                    ], template: "<div class=\"bento-megamenu-takeover-flex-container\">\n  <ul #takeoverHeaders class=\"bento-megamenu-takeover-headers\" role=\"menu\">\n    <li *ngFor=\"let column of items\" [class.active]=\"currentColumn === column\" (keydown)=\"onHeaderKeydown($event)\">\n      <a\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        href=\"#\"\n        (click)=\"onHeaderFocus($event, column)\"\n        (focus)=\"onHeaderFocus($event, column)\"\n        (mouseenter)=\"onHeaderFocus($event, column)\"\n        role=\"menuitem\"\n      >\n        <i *ngIf=\"column.menu\" class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n        <span>\n          <i *ngIf=\"column.icon\" [ngClass]=\"column.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"column.label\"></span>\n        </span>\n      </a>\n    </li>\n  </ul>\n  <ul #takeoverMenus tabindex=\"-1\" class=\"bento-megamenu-takeover-items\" role=\"menu\">\n    <li *ngFor=\"let item of currentMenu\" (keydown)=\"onSubMenuKeydown($event)\">\n      <a\n        *ngIf=\"item?.routerLink?.href; else defaultLink\"\n        (click)=\"onMenuClick($event, item, currentColumn)\"\n        [routerLink]=\"item?.routerLink?.href\"\n        [queryParams]=\"item?.routerLink?.queryParams\"\n        [fragment]=\"item?.routerLink?.fragment\"\n        [queryParamsHandling]=\"item?.routerLink?.queryParamsHandling\"\n        [preserveFragment]=\"item?.routerLink?.preserveFragment\"\n        [skipLocationChange]=\"item?.routerLink?.skipLocationChange\"\n        [replaceUrl]=\"item?.routerLink?.replaceUrl\"\n        role=\"menuitem\"\n        [class.disabled]=\"item.disabled || currentColumn.disabled\"\n        [attr.aria-disabled]=\"item.disabled || currentColumn.disabled\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.routerLink?.text || item.label\"></span>\n      </a>\n      <ng-template #defaultLink>\n        <a\n          href=\"#\"\n          (click)=\"onMenuClick($event, item, currentColumn)\"\n          [attr.href]=\"item.anchor?.href || '#'\"\n          role=\"menuitem\"\n          [class.disabled]=\"item.disabled || currentColumn.disabled\"\n          [attr.aria-disabled]=\"item.disabled || currentColumn.disabled\"\n          [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n        >\n          <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n        </a>\n      </ng-template>\n    </li>\n  </ul>\n</div>\n" }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: BentoNotification }, { type: WindowRef }, { type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }];
    }, propDecorators: { items: [{
                type: Input
            }], isRtl: [{
                type: Input
            }], takeoverMenus: [{
                type: ViewChild,
                args: ['takeoverMenus', { static: true }]
            }], takeoverHeaders: [{
                type: ViewChild,
                args: ['takeoverHeaders', { static: true }]
            }] } });

/* eslint-disable  @angular-eslint/no-host-metadata-property */
/**
 * This is an extension to [Dropdown](#/components/dropdown),
 * in which links are shown in multiple columns. Now horizontal space can
 * be full utilized to display a large quantity of links. All Dropdown
 * options apply to Megamenu as well, including `.dropup`
 */
class BentoMegamenuComponent extends NgbDropdownMenu {
    /**
     * Constructor
     */
    constructor(dropdown, r, elementRef, dir, bentoUIDService) {
        super(dropdown, elementRef);
        this.dropdown = dropdown;
        this.r = r;
        this.dir = dir;
        this.bentoUIDService = bentoUIDService;
        /**
         * This property is **ONLY** applied when Megamenu is `type="flow"`
         */
        this.flowColumnWidth = 150;
        // Property to know if this component is embedded in another component.  If so, enable role="menu".
        // Currently used when megamenu default is embedded in the scollable toolbar
        // Internal use only, not published to the API
        this.isEmbedded = false;
        // Private variables
        this._items = [];
        this._type = 'default';
        /** Subscription to the Directionality change EventEmitter. */
        this.dirChangeSubscription = Subscription.EMPTY;
        this.el = elementRef.nativeElement;
        r.addClass(elementRef.nativeElement, 'dropdown-menu');
        r.addClass(elementRef.nativeElement, 'bento-megamenu-height');
        this.isRtl = this.dir.value === 'rtl';
        this.dirChangeSubscription = dir.change.subscribe(() => {
            this.flipDirection();
        });
    }
    /**
     * Main items data model to store Bento Megamenu content
     */
    set items(items) {
        this._items = items.map(item => {
            const id = item.id;
            if (item && !id) {
                const uniqueID = `megamenu-column-${this.bentoUIDService.generate()}`;
                return Object.assign(Object.assign({}, item), { id: uniqueID });
            }
            return item;
        });
    }
    get items() {
        return this._items;
    }
    /**
     * Indicates the type of this Megamenu: `default`, `takeover` and `flow`
     */
    set type(t) {
        this._type = t || 'default';
        this.setClass();
    }
    get type() {
        return this._type;
    }
    /**
     * Init lifecycle hook
     */
    ngOnInit() {
        this.setClass();
    }
    /**
     * Destroy lifecycle hook
     */
    ngOnDestroy() {
        this.dirChangeSubscription.unsubscribe();
    }
    /**
     * Set main container element CSS class
     */
    setClass() {
        this.r.removeClass(this.el, 'bento-megamenu-default');
        this.r.removeClass(this.el, 'bento-megamenu-takeover');
        this.r.removeClass(this.el, 'bento-megamenu-flow');
        this.r.addClass(this.el, 'bento-megamenu-' + this._type);
    }
    flipDirection() {
        this.isRtl = this.dir.value === 'rtl';
    }
}
BentoMegamenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuComponent, deps: [{ token: forwardRef(() => NgbDropdown) }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i2.Directionality }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoMegamenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoMegamenuComponent, selector: "bento-megamenu", inputs: { items: "items", widthElRef: "widthElRef", maxWidth: "maxWidth", flowColumnWidth: "flowColumnWidth", bentoAppendTo: "bentoAppendTo", type: "type", hTagRank: "hTagRank", isEmbedded: "isEmbedded", ariaLabel: "ariaLabel" }, host: { properties: { "class.show": "dropdown.isOpen()" } }, providers: [{ provide: NgbDropdownMenu, useExisting: forwardRef(() => BentoMegamenuComponent) }, BentoUidService], usesInheritance: true, ngImport: i0, template: "<ng-container [ngSwitch]=\"type\">\n  <bento-megamenu-takeover\n    *ngSwitchCase=\"'takeover'\"\n    [widthElRef]=\"widthElRef\"\n    [items]=\"items\"\n    [isRtl]=\"isRtl\"\n    [appendToEl]=\"bentoAppendTo\"\n  ></bento-megamenu-takeover>\n  <bento-megamenu-flow\n    *ngSwitchCase=\"'flow'\"\n    [widthElRef]=\"widthElRef\"\n    [width]=\"maxWidth\"\n    [columnWidth]=\"flowColumnWidth\"\n    [items]=\"items\"\n    [isRtl]=\"isRtl\"\n    [appendToEl]=\"bentoAppendTo\"\n    [hTagRank]=\"hTagRank\"\n    [ariaLabel]=\"ariaLabel\"\n  ></bento-megamenu-flow>\n  <bento-megamenu-default\n    *ngSwitchDefault\n    [widthElRef]=\"widthElRef\"\n    [maxWidth]=\"maxWidth\"\n    [items]=\"items\"\n    [appendToEl]=\"bentoAppendTo\"\n    [isRtl]=\"isRtl\"\n    [hTagRank]=\"hTagRank\"\n    [isEmbedded]=\"isEmbedded\"\n    [ariaLabel]=\"ariaLabel\"\n  ></bento-megamenu-default>\n</ng-container>\n", styles: [".ng-bento bento-megamenu.dropdown-menu,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu{overflow:auto;padding:0!important}.ng-bento bento-megamenu.dropdown-menu.bento-megamenu-rendering,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu.bento-megamenu-rendering{box-shadow:none;opacity:0}.dropup .ng-bento bento-megamenu.dropdown-menu,.dropup .ng-bento .bento-toolbar bento-megamenu.dropdown-menu{bottom:auto}.ng-bento bento-megamenu.dropdown-menu .dropdown-item.disabled,.ng-bento bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu .dropdown-item.disabled,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled{opacity:.5}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow{margin:0;padding:12px 4px;display:block;max-width:100vw;-moz-column-gap:0;column-gap:0}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container{-ms-box-orient:horizontal;display:-moz-flex;display:flex;flex-direction:row}@media screen and (max-width: 600px){.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container{flex-direction:column;max-height:45vh!important}}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column{white-space:normal;padding:0 4px;margin-bottom:6px}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty{height:0;border:none;padding:0}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header{margin:0 0 6px;padding:0 4px;border:1px solid transparent}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{page-break-inside:avoid;-moz-column-break-inside:avoid;break-inside:avoid;text-align:left;display:block;cursor:pointer;padding:5px 4px;font-size:12px;line-height:1.2em!important;font-weight:400;height:auto;white-space:nowrap;background:none;border:1px solid transparent}[dir=rtl] .ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] .ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,[dir=rtl] .ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] .ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{text-align:right}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover{text-decoration:underline}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow{box-sizing:content-box}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow a,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow a{white-space:normal!important}.ng-bento bento-megamenu.dropdown-menubento-megamenu-takeover,.ng-bento .bento-toolbar bento-megamenu.dropdown-menubento-megamenu-takeover{border:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column{background:inherit;margin-bottom:6px}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a{background:none;padding:0 5px;height:auto;line-height:22px!important}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a:hover,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a:hover{text-decoration:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover{display:block;max-width:100vw}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-flex-container{display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers{list-style-type:none;padding:8px 0;min-width:131px;margin:0}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{display:block;padding:6px 52px 6px 13px;line-height:unset;height:auto;cursor:default;font-size:12px}[dir=rtl] .ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{padding:6px 13px 6px 52px}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:hover{text-decoration:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:focus{text-decoration:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:right;margin-right:-39px}[dir=rtl] .ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:left;margin-right:0;margin-left:-39px;transform:scaleX(-1)}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items{margin:0;padding:10px 8px 0;list-style-type:none;display:flex;flex-flow:column wrap;justify-content:flex-start;align-items:stretch}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a{padding:0 8px;font-size:12px;line-height:26px;height:26px;background:none!important}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:hover,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:focus{outline:none;text-decoration:none}\n"], components: [{ type: BentoMegamenuTakeoverComponent, selector: "bento-megamenu-takeover", inputs: ["items", "isRtl"] }, { type: BentoMegaMenuFlowComponent, selector: "bento-megamenu-flow", inputs: ["columnWidth", "width", "isRtl", "ariaLabel"] }, { type: BentoMegamenuDefaultComponent, selector: "bento-megamenu-default", inputs: ["items", "hTagRank", "widthElRef", "maxWidth", "appendToEl", "isRtl", "isEmbedded", "ariaLabel"] }], directives: [{ type: i3$2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i3$2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i3$2.NgSwitchDefault, selector: "[ngSwitchDefault]" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-megamenu', encapsulation: ViewEncapsulation.None, host: { '[class.show]': 'dropdown.isOpen()' }, providers: [{ provide: NgbDropdownMenu, useExisting: forwardRef(() => BentoMegamenuComponent) }, BentoUidService], template: "<ng-container [ngSwitch]=\"type\">\n  <bento-megamenu-takeover\n    *ngSwitchCase=\"'takeover'\"\n    [widthElRef]=\"widthElRef\"\n    [items]=\"items\"\n    [isRtl]=\"isRtl\"\n    [appendToEl]=\"bentoAppendTo\"\n  ></bento-megamenu-takeover>\n  <bento-megamenu-flow\n    *ngSwitchCase=\"'flow'\"\n    [widthElRef]=\"widthElRef\"\n    [width]=\"maxWidth\"\n    [columnWidth]=\"flowColumnWidth\"\n    [items]=\"items\"\n    [isRtl]=\"isRtl\"\n    [appendToEl]=\"bentoAppendTo\"\n    [hTagRank]=\"hTagRank\"\n    [ariaLabel]=\"ariaLabel\"\n  ></bento-megamenu-flow>\n  <bento-megamenu-default\n    *ngSwitchDefault\n    [widthElRef]=\"widthElRef\"\n    [maxWidth]=\"maxWidth\"\n    [items]=\"items\"\n    [appendToEl]=\"bentoAppendTo\"\n    [isRtl]=\"isRtl\"\n    [hTagRank]=\"hTagRank\"\n    [isEmbedded]=\"isEmbedded\"\n    [ariaLabel]=\"ariaLabel\"\n  ></bento-megamenu-default>\n</ng-container>\n", styles: [".ng-bento bento-megamenu.dropdown-menu,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu{overflow:auto;padding:0!important}.ng-bento bento-megamenu.dropdown-menu.bento-megamenu-rendering,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu.bento-megamenu-rendering{box-shadow:none;opacity:0}.dropup .ng-bento bento-megamenu.dropdown-menu,.dropup .ng-bento .bento-toolbar bento-megamenu.dropdown-menu{bottom:auto}.ng-bento bento-megamenu.dropdown-menu .dropdown-item.disabled,.ng-bento bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu .dropdown-item.disabled,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled{opacity:.5}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow{margin:0;padding:12px 4px;display:block;max-width:100vw;-moz-column-gap:0;column-gap:0}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container{-ms-box-orient:horizontal;display:-moz-flex;display:flex;flex-direction:row}@media screen and (max-width: 600px){.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container{flex-direction:column;max-height:45vh!important}}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column{white-space:normal;padding:0 4px;margin-bottom:6px}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty{height:0;border:none;padding:0}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header{margin:0 0 6px;padding:0 4px;border:1px solid transparent}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{page-break-inside:avoid;-moz-column-break-inside:avoid;break-inside:avoid;text-align:left;display:block;cursor:pointer;padding:5px 4px;font-size:12px;line-height:1.2em!important;font-weight:400;height:auto;white-space:nowrap;background:none;border:1px solid transparent}[dir=rtl] .ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] .ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,[dir=rtl] .ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] .ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{text-align:right}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover{text-decoration:underline}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow{box-sizing:content-box}.ng-bento bento-megamenu.dropdown-menu>bento-megamenu-flow a,.ng-bento .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow a{white-space:normal!important}.ng-bento bento-megamenu.dropdown-menubento-megamenu-takeover,.ng-bento .bento-toolbar bento-megamenu.dropdown-menubento-megamenu-takeover{border:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column{background:inherit;margin-bottom:6px}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a{background:none;padding:0 5px;height:auto;line-height:22px!important}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a:hover,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a:hover{text-decoration:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover{display:block;max-width:100vw}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-flex-container{display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers{list-style-type:none;padding:8px 0;min-width:131px;margin:0}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{display:block;padding:6px 52px 6px 13px;line-height:unset;height:auto;cursor:default;font-size:12px}[dir=rtl] .ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{padding:6px 13px 6px 52px}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:hover{text-decoration:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:focus{text-decoration:none}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:right;margin-right:-39px}[dir=rtl] .ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:left;margin-right:0;margin-left:-39px;transform:scaleX(-1)}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items{margin:0;padding:10px 8px 0;list-style-type:none;display:flex;flex-flow:column wrap;justify-content:flex-start;align-items:stretch}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a{padding:0 8px;font-size:12px;line-height:26px;height:26px;background:none!important}.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:hover,.ng-bento .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:focus{outline:none;text-decoration:none}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i2.Directionality }, { type: BentoUidService }];
    }, propDecorators: { items: [{
                type: Input
            }], widthElRef: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], flowColumnWidth: [{
                type: Input
            }], bentoAppendTo: [{
                type: Input
            }], type: [{
                type: Input
            }], hTagRank: [{
                type: Input
            }], isEmbedded: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }] } });

class BentoMegamenuModule extends ConsumerDataValidator {
}
BentoMegamenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoMegamenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuModule, declarations: [BentoMegamenuComponent,
        BentoMegamenuDefaultComponent,
        BentoMegamenuTakeoverComponent,
        BentoMegaMenuFlowComponent,
        BentoMegaMenuItemDirective,
        BentoMegamenuHTagRankDirective], imports: [CommonModule, FormsModule, BentoUtilsModule, BentoFocusMonitorModule, RouterModule], exports: [BentoMegamenuComponent] });
BentoMegamenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuModule, providers: [NgbDropdown, BentoNgbDropdownAppendToDirective, BentoMegamenuHTagRankDirective], imports: [[CommonModule, FormsModule, BentoUtilsModule, BentoFocusMonitorModule, RouterModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMegamenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, BentoUtilsModule, BentoFocusMonitorModule, RouterModule],
                    declarations: [
                        BentoMegamenuComponent,
                        BentoMegamenuDefaultComponent,
                        BentoMegamenuTakeoverComponent,
                        BentoMegaMenuFlowComponent,
                        BentoMegaMenuItemDirective,
                        BentoMegamenuHTagRankDirective
                    ],
                    exports: [BentoMegamenuComponent],
                    providers: [NgbDropdown, BentoNgbDropdownAppendToDirective, BentoMegamenuHTagRankDirective]
                }]
        }] });

/* eslint-disable  @angular-eslint/directive-class-suffix */
class BentoFooterTabHelper {
    constructor(elRef, winRef, r) {
        this.r = r;
        this.window = winRef.nativeWindow;
        this.document = winRef.nativeDocument;
        this.el = elRef.nativeElement;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            // Need to wait one cycle for theme CSS to kick in
            const focusedEl = this.document.activeElement;
            const style = this.window.getComputedStyle(this.el);
            if (style.flexDirection === 'row-reverse') {
                // Some magic here to rever the element orders back with
                // CSS corrections so that Tabs should flow in the correct
                // order
                this.r.setStyle(this.el, 'flexDirection', 'row');
                /* Flip content alignment */
                if (style.justifyContent === 'flex-start') {
                    this.r.setStyle(this.el, 'justifyContent', 'flex-end');
                }
                else {
                    this.r.setStyle(this.el, 'justifyContent', 'flex-start');
                }
                // Reverse element order
                const children = Array.from(this.el.children);
                for (let i = children.length - 1; i > -1; i--) {
                    this.el.appendChild(children[i]);
                }
                // Make suer the focus is still at where
                // Ngb has originally assigned
                focusedEl.focus();
            }
        });
    }
}
BentoFooterTabHelper.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFooterTabHelper, deps: [{ token: i0.ElementRef }, { token: WindowRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
BentoFooterTabHelper.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoFooterTabHelper, selector: "[class=\"modal-footer\"]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFooterTabHelper, decorators: [{
            type: Directive,
            args: [{
                    selector: '[class="modal-footer"]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: WindowRef }, { type: i0.Renderer2 }]; } });

/**
 * To provide default confirmation modal behaviors
 *
 * This class is used internally by the `BentoModalConfirmationService` injectable
 */
class BentoModalConfirmationComponent {
    constructor(activeModal, win, platform, cd) {
        this.activeModal = activeModal;
        this.platform = platform;
        this.cd = cd;
        this.buttonType = 'primary';
        this.iconColorType = 'primary';
        this.cancelButtonText = 'Cancel';
        this.confirmButtonText = 'Confirm';
        this.confirmButtonType = 'primary';
        this.message = 'Are you sure?';
        this.title = 'Confirm';
        // eslint-disable  @typescript-eslint/no-unused-vars
        this.hasCustomTitle = false;
        this.enableCloseButton = true;
        this.window = win.nativeWindow;
    }
    ngAfterViewInit() {
        if (this.platform.isBrowser) {
            setTimeout(() => {
                // We need to make sure that close button is not enabled if CSS is used to
                // hide close button
                const display = this.window.getComputedStyle(this.closeButtonElRef.nativeElement).display;
                if (display === 'none') {
                    this.enableCloseButton = false;
                    this.cancelButtonElRef.nativeElement.focus();
                    this.cd.markForCheck();
                }
            });
        }
    }
    /**
     * Configure how and what needs to be render in UI
     * @param message Message that is displayed in the modl
     * @param config configuration to customize text labels
     */
    setConfig(message, config = {}) {
        this.buttonType = config.buttonType || this.buttonType;
        this.iconName = config.iconName || this.iconName;
        this.iconColorType = config.iconColorType || this.iconColorType;
        this.closeButtonText = config.closeButtonText || this.closeButtonText;
        this.cancelButtonText = config.cancelButtonText || this.cancelButtonText;
        this.confirmButtonText = config.confirmButtonText || this.confirmButtonText;
        this.confirmButtonType = config.buttonType || this.confirmButtonType;
        this.message = message || this.message;
        this.title = config.titleText || this.title;
        this.hasCustomTitle = !!config.titleText;
    }
}
BentoModalConfirmationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationComponent, deps: [{ token: i1$1.NgbActiveModal }, { token: WindowRef }, { token: i3$1.Platform }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoModalConfirmationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoModalConfirmationComponent, selector: "bento-modal-confirmation", host: { properties: { "class.bui-modal-has-title": "this.hasCustomTitle" } }, viewQueries: [{ propertyName: "closeButtonElRef", first: true, predicate: ["closeButton"], descendants: true }, { propertyName: "cancelButtonElRef", first: true, predicate: ["cancelButton"], descendants: true }], ngImport: i0, template: "<button\n  #closeButton\n  type=\"button\"\n  class=\"close\"\n  ngbAutoFocus\n  (click)=\"activeModal.dismiss('Close')\"\n  ngbTooltip=\"{{ 'BENTO_UI_MODAL_CONFIRMATION_CLOSE' | bentoTranslate: closeButtonText }}\"\n  placement=\"bottom\"\n  container=\"body\"\n  *ngIf=\"enableCloseButton\"\n>\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<h3 class=\"modal-header h2\">{{ title }}</h3>\n<div class=\"modal-body\">\n  <i *ngIf=\"iconName\" class=\"modal-confirmation-icon {{ iconName }} text-{{ iconColorType }}\" aria-hidden=\"true\"></i>\n  <div>{{ message }}</div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn\" [ngClass]=\"'btn-' + buttonType\" (click)=\"activeModal.close('Confirm')\">\n    {{ confirmButtonText }}\n  </button>\n  <button #cancelButton type=\"button\" class=\"btn btn-outline-primary\" (click)=\"activeModal.close('Cancel')\">\n    {{ cancelButtonText }}\n  </button>\n</div>\n", styles: [""], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-modal-confirmation', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\n  #closeButton\n  type=\"button\"\n  class=\"close\"\n  ngbAutoFocus\n  (click)=\"activeModal.dismiss('Close')\"\n  ngbTooltip=\"{{ 'BENTO_UI_MODAL_CONFIRMATION_CLOSE' | bentoTranslate: closeButtonText }}\"\n  placement=\"bottom\"\n  container=\"body\"\n  *ngIf=\"enableCloseButton\"\n>\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<h3 class=\"modal-header h2\">{{ title }}</h3>\n<div class=\"modal-body\">\n  <i *ngIf=\"iconName\" class=\"modal-confirmation-icon {{ iconName }} text-{{ iconColorType }}\" aria-hidden=\"true\"></i>\n  <div>{{ message }}</div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn\" [ngClass]=\"'btn-' + buttonType\" (click)=\"activeModal.close('Confirm')\">\n    {{ confirmButtonText }}\n  </button>\n  <button #cancelButton type=\"button\" class=\"btn btn-outline-primary\" (click)=\"activeModal.close('Cancel')\">\n    {{ cancelButtonText }}\n  </button>\n</div>\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbActiveModal }, { type: WindowRef }, { type: i3$1.Platform }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { hasCustomTitle: [{
                type: HostBinding,
                args: ['class.bui-modal-has-title']
            }], closeButtonElRef: [{
                type: ViewChild,
                args: ['closeButton']
            }], cancelButtonElRef: [{
                type: ViewChild,
                args: ['cancelButton']
            }] } });

/**
 * Categorises the reason when a confirmation modal is closed.
 * This does not include the dissmissal of a modal, use `ModalDismissReasons`
 * from NG-Bootstrap.
 */
var BentoModalConfirmationCloseReason;
(function (BentoModalConfirmationCloseReason) {
    /**
     * When modal is confirmed by an user
     */
    BentoModalConfirmationCloseReason["Confirm"] = "Confirm";
    /**
     * When modal confirmation is canceled by an user
     */
    BentoModalConfirmationCloseReason["Cancel"] = "Cancel";
})(BentoModalConfirmationCloseReason || (BentoModalConfirmationCloseReason = {}));
/**
 * This is a helper service to provide a confirmation modal without implemeting templates
 * and other neccessary default behaviors
 */
class BentoModalConfirmationService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    /**
     * Opens a confirmation modal window
     */
    open(message, config, modalConfig, animationOn = false) {
        // Create a default modal config or using the one that's provided by user
        const mConfig = modalConfig || { windowClass: '', animation: animationOn };
        // Make sure to add our custom modal confirmation window class
        mConfig.windowClass = 'bui-modal-confirmation ' + mConfig.windowClass;
        const modalRef = this.modalService.open(BentoModalConfirmationComponent, mConfig);
        const instance = modalRef.componentInstance;
        instance.setConfig(message, config);
        return modalRef;
    }
}
BentoModalConfirmationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationService, deps: [{ token: i1$1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
BentoModalConfirmationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.NgbModal }]; } });

class BentoModalConfirmationModule extends ConsumerDataValidator {
    constructor(modalConfig) {
        super();
        modalConfig.animation = false;
        modalConfig.centered = true; // Default to vertically center aligned for Bento
    }
}
BentoModalConfirmationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationModule, deps: [{ token: i1$1.NgbModalConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoModalConfirmationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationModule, declarations: [BentoModalConfirmationComponent, BentoFooterTabHelper], imports: [CommonModule,
        BentoFocusMonitorModule,
        NgbModalModule,
        A11yModule,
        BentoUtilsModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule,
        BentoTranslateModule], exports: [BentoFooterTabHelper] });
BentoModalConfirmationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationModule, providers: [BentoModalConfirmationService], imports: [[
            CommonModule,
            BentoFocusMonitorModule,
            NgbModalModule,
            A11yModule,
            BentoUtilsModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule,
            BentoTranslateModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModalConfirmationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoModalConfirmationComponent, BentoFooterTabHelper],
                    imports: [
                        CommonModule,
                        BentoFocusMonitorModule,
                        NgbModalModule,
                        A11yModule,
                        BentoUtilsModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule,
                        BentoTranslateModule
                    ],
                    exports: [BentoFooterTabHelper],
                    providers: [BentoModalConfirmationService]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbModalConfig }]; } });

var Selection;
(function (Selection) {
    Selection[Selection["all"] = 0] = "all";
    Selection[Selection["selected"] = 1] = "selected";
})(Selection || (Selection = {}));
class BentoMultiselectListComponent extends BentoListSubscribable {
    constructor(bentoUid, logService, liveAnnouncer, translate, elementRef) {
        super();
        this.logService = logService;
        this.liveAnnouncer = liveAnnouncer;
        this.translate = translate;
        this.elementRef = elementRef;
        /**
         * Replace search input field help text default
         */
        this.searchLabelHelpText = '';
        /**
         * The maximum number of items that can be selected by the user.  0 is the default, indicates no restrictions.
         */
        this.maxSelectedItems = 0;
        /**
         * Notify when the length of the main items data is changed
         */
        this.lengthChange = new EventEmitter();
        /**
         * Notify when a row is clicked with an OS pointer
         */
        this.rowClick = new EventEmitter();
        /**
         * List Height
         */
        this._listHeight = 0;
        /**
         * List Width
         */
        this._listWidth = 0;
        /**
         * Emit Data change
         */
        this._dataChange = new EventEmitter();
        /**
         * Refernce to current datasize
         */
        this._dataSize = 0;
        /**
         * Index to determine which item is active
         */
        this._activeIndex = -1;
        /**
         * If the list is disabled, don't allow selections via keyboard.
         */
        this._isListDisabled = false;
        this.selectedListChange = new EventEmitter();
        /**
         * Selection to defines filtering of the list
         */
        this._selection = Selection.all;
        /**
         * Select all row
         */
        this._selectAllRow = {
            name: 'BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL',
            isSelectAll: true
        };
        /**
         * A status list to represent whether an item is checked or not
         */
        this.checkStatusRef = new Map();
        this._listOptions = { checkStatusRef: this.checkStatusRef };
        this._uid = bentoUid.generate();
    }
    /**
     * Main Data seter
     */
    set itemsObservable(observable) {
        this._setDataObservable(observable);
    }
    /**
     * Set the height of the list
     */
    set height(v) {
        this._listHeight = v - this.topPanel.nativeElement.offsetHeight;
    }
    /**
     * Width setting to this component
     */
    set width(v) {
        this._listWidth = v;
    }
    /**
     * selected list
     */
    get selectedList() {
        const list = [];
        for (const item of this._data) {
            if (this.checkStatusRef.get(item)) {
                list.push(item);
            }
        }
        return list;
    }
    set _selectedList(v) {
        if (this._data) {
            let notIncluded = false;
            // Check if ALL objects are in the main dataset
            for (const row of v) {
                if (this._data.indexOf(row) === -1) {
                    notIncluded = true;
                    this.logService.warn('Bento Multiselect Overlay:', 'Object is not in the original dataset ->', row);
                }
            }
            // Do not proceed when selected list does not qualify
            if (notIncluded) {
                return;
            }
            // clear all checked status
            this.clearCheckStatus();
            // update selected list
            for (const listItem of v) {
                this.checkStatusRef.set(listItem, true);
            }
            // update select all row checkbox
            this.checkAllSelected();
        }
    }
    /**
     * Gain focus on the search field
     */
    focusOnSearchField() {
        // Focus back to search field
        setTimeout(() => {
            this.searchFieldRef.nativeElement.focus();
        });
    }
    /**
     * Gain focus on the show all button
     */
    focusOnShowAllButton() {
        // Focus back to show all button
        setTimeout(() => {
            this.showAllRef.nativeElement.focus();
        });
    }
    /**
     * Set list selection
     */
    show(s) {
        this._activeIndex = -1;
        this._selection = s;
        this.onSearch(this._searchTerm);
    }
    /**
     * Clear search input
     */
    clearSearchItem() {
        this._searchTerm = '';
        this.searchFieldRef.nativeElement.value = '';
    }
    /**
     * Re-render the list
     */
    refreshView() {
        this.list.checkViewportSize();
    }
    /**
     * Search and display the list based on search string `s`
     */
    onSearch(s, isQuietUpdate) {
        if (!s || s.length === 0) {
            if (this._selection === Selection.all) {
                this._filteredList = this.processDefaultFilteredList(this._data);
            }
            else {
                this._filteredList = this.selectedList;
            }
        }
        else {
            if (this._selection === Selection.all) {
                this._filteredList = this.processDefaultFilteredList(this.searchFromList(this._data, s));
            }
            else {
                this._filteredList = this.searchFromList(this.selectedList, s);
            }
        }
        this._dataSize = this._filteredList.length;
        // update select all row checkbox
        this.checkAllSelected();
        this._searchTerm = s;
        // Notify Bento List
        this._dataChange.emit(this._filteredList);
        this._announceFilterResults();
    }
    _announceFilterResults() {
        const msg = this._dataSize === 0
            ? this.translate.instantTranslate('BENTO_UI_MULTISELECT_OVERLAY_A11Y_NOTHING_FOUND')
            : this.translate
                .instantTranslate('BENTO_UI_MULTISELECT_OVERLAY_A11Y_FOUND_N_RESULTS')
                .replace('_NUMBER_', String(this._dataSize));
        this.liveAnnouncer.announce(msg);
    }
    /**
     * Toggle the row that is clicked
     */
    toggleRowChecked(row) {
        // Flip checked state
        const checked = !this.checkStatusRef.get(row);
        if (!(this._isListDisabled && checked)) {
            this.checkStatusRef.set(row, checked);
        }
        if (row.isSelectAll) {
            // Select all
            for (const r of this._filteredList) {
                this.checkStatusRef.set(r, checked);
            }
        }
        this.checkAllSelected();
        // Emit changes
        this.selectedListChange.emit(this.selectedList);
    }
    /**
     * Search a string from an array
     */
    searchFromList(a, s) {
        const l = [];
        const searchCompare = this.searchCompare ||
            ((item, search) => {
                // Default search and compare function and only searches the name property
                return item.name.toLowerCase().indexOf(search) > -1;
            });
        s = s.toLowerCase();
        for (const row of a) {
            if (searchCompare(row, s)) {
                l.push(row);
            }
        }
        return l;
    }
    /**
     * When a row is clicked
     * ~@private
     */
    _onRowClick($event, $row, $index) {
        this._activeIndex = $index;
        this.toggleRowChecked($row);
        // Emit row click
        this.rowClick.emit($event);
        this.focusOnSearchField();
        $event.preventDefault();
        $event.stopPropagation();
    }
    /**
     * When a keydown event is executed on the row
     */
    _onTabsKeydown(e) {
        if ([Keyboard.SPACE, Keyboard.ENTER].includes(e.keyCode)) {
            this._selection === Selection.selected ? this.show(Selection.all) : this.show(Selection.selected);
        }
        if ([Keyboard.RIGHT, Keyboard.LEFT].includes(e.keyCode)) {
            const navButtons = Array.from(this.elementRef.nativeElement.querySelectorAll('.nav-pills button'));
            const currentFocusedNdx = navButtons.findIndex(el => el === document.activeElement);
            const nextFocusedNdx = (currentFocusedNdx + 1) % navButtons.length;
            const elToFocus = navButtons[nextFocusedNdx];
            elToFocus === null || elToFocus === void 0 ? void 0 : elToFocus.focus();
        }
    }
    /**
     * When a keydown event is executed on the row
     */
    _onRowKeydown(e, $row) {
        switch (e.keyCode) {
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                this.toggleRowChecked($row);
                // Emit row click
                this.rowClick.emit(e);
                e.preventDefault();
                break;
        }
    }
    /**
     * Callback when BentoList gains focus
     */
    _onListFocus(e) {
        if (this._activeIndex < 0) {
            this._activeIndex = 0;
        }
    }
    _onListKeydown(e) {
        const dataSize = this._filteredList.length;
        switch (e.keyCode) {
            case Keyboard.DOWN:
                this._activeIndex = (this._activeIndex + 1) % dataSize;
                this.list.showRowIndex(this._activeIndex);
                e.preventDefault();
                break;
            case Keyboard.UP:
                this._activeIndex = (this._activeIndex - 1 + dataSize) % dataSize;
                this.list.showRowIndex(this._activeIndex);
                e.preventDefault();
                break;
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                this.toggleRowChecked(this._filteredList[this._activeIndex]);
                // Emit row click
                this.rowClick.emit(e);
                e.preventDefault();
                break;
        }
    }
    /**
     * Override `BentoListSubscribable` method
     */
    _onDataUpdate(data) {
        this.updateCheckedStatusRef();
        this.lengthChange.emit(this._data.length);
        this.onSearch(this._searchTerm, true);
    }
    /**
     * Update checked status ref everytime when base data set is updated
     */
    updateCheckedStatusRef() {
        const newStatusRef = new Map();
        for (const listItem of this._data) {
            newStatusRef.set(listItem, this.checkStatusRef.get(listItem));
        }
        delete this.checkStatusRef;
        // Assign the new status reference
        this.checkStatusRef = newStatusRef;
        // Make sure to update the list options reference as well
        this._listOptions.checkStatusRef = newStatusRef;
    }
    /**
     * Check if all in the filtered list are selected
     */
    checkAllSelected() {
        let dataListToCheck;
        let allChecked = true;
        // There are selections
        if (Array.isArray(this._filteredList) && this._filteredList.length) {
            // only check where there is a filtered list
            dataListToCheck = this._filteredList;
        }
        else {
            dataListToCheck = this._data;
        }
        for (const item of dataListToCheck) {
            // Check and see if all items in the current list are checked
            if (!this.checkStatusRef.get(item) && item.name !== this._selectAllRow.name) {
                // There is at least one that is not checked
                allChecked = false;
                break;
            }
        }
        if (this.maxSelectedItems > 0) {
            const selCount = this._data.filter(item => this.checkStatusRef.has(item)).length;
            if (selCount >= this.maxSelectedItems) {
                for (const item of this._data) {
                    if (!this.checkStatusRef.has(item)) {
                        item.disabled = 1;
                    }
                }
                this._isListDisabled = true;
            }
            else {
                for (const item of this._data) {
                    item.disabled = 0;
                }
                this._isListDisabled = false;
            }
            this._dataChange.emit(dataListToCheck);
        }
        this.checkStatusRef.set(this._selectAllRow, allChecked);
    }
    /**
     * Format the list structure based on a filtered list
     */
    processDefaultFilteredList(list) {
        return list.length > 1 && this.maxSelectedItems === 0 ? [this._selectAllRow].concat(list) : list;
    }
    /**
     * Clear all checked status
     */
    clearCheckStatus() {
        this.checkStatusRef = new Map();
        delete this._listOptions.checkStatusRef;
        this._listOptions.checkStatusRef = this.checkStatusRef;
    }
}
BentoMultiselectListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectListComponent, deps: [{ token: BentoUidService }, { token: BentoLogService }, { token: i3.LiveAnnouncer }, { token: BentoTranslate }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoMultiselectListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoMultiselectListComponent, selector: "bento-multiselect-list", inputs: { showAllText: "showAllText", showSelectedText: "showSelectedText", selectAllText: "selectAllText", searchLabelText: "searchLabelText", searchLabelHelpText: "searchLabelHelpText", itemsObservable: "itemsObservable", height: "height", width: "width", listItemTemplate: "listItemTemplate", searchCompare: "searchCompare", maxSelectedItems: "maxSelectedItems", _selectedList: ["selectedList", "_selectedList"] }, outputs: { lengthChange: "lengthChange", rowClick: "rowClick", selectedListChange: "selectedListChange" }, viewQueries: [{ propertyName: "topPanel", first: true, predicate: ["topPanel"], descendants: true, static: true }, { propertyName: "list", first: true, predicate: ["list"], descendants: true, static: true }, { propertyName: "searchFieldRef", first: true, predicate: ["searchField"], descendants: true, static: true }, { propertyName: "showAllRef", first: true, predicate: ["showAll"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div #topPanel class=\"bento-multiselect-list-item bento-multiselect-search\">\n  <div class=\"pills\">\n    <ul\n      cdkMonitorElementFocus\n      (keydown)=\"_onTabsKeydown($event)\"\n      class=\"nav nav-pills\"\n      role=\"tablist\">\n      <li [attr.id]=\"'show-all' + _uid\" [ngClass]=\"_selection == 0 ? 'active ' : ''\">\n        <button\n          role=\"tab\"\n          (click)=\"show(0)\"\n          [attr.aria-selected]=\"_selection == 0 ? true : false\"\n          type=\"button\"\n          #showAll\n        >\n          <span>\n            {{ 'BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate: showAllText }}\n          </span>\n        </button>\n      </li>\n      <li [attr.id]=\"'show-selected' + _uid\" [ngClass]=\"_selection == 1 ? 'active ' : ''\">\n        <button role=\"tab\" (click)=\"show(1)\" [attr.aria-selected]=\"_selection == 1 ? true : false\" type=\"button\">\n          <span>\n            {{ 'BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate: showSelectedText }}\n          </span>\n        </button>\n      </li>\n    </ul>\n  </div>\n  <label class=\"bento-search-label\" [attr.for]=\"'multiselect-filter-items-' + _uid\">\n    {{ 'BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL' | bentoTranslate: searchLabelText }}\n    <span class=\"form-text\" *ngIf=\"searchLabelHelpText != ''\">\n      {{ searchLabelHelpText }}\n    </span>\n  </label>\n  <div class=\"bento-search\">\n    <input\n      [attr.id]=\"'multiselect-filter-items-' + _uid\"\n      bentoReset\n      #searchField\n      type=\"text\"\n      [ngModel]=\"_searchTerm\"\n      (ngModelChange)=\"onSearch($event)\"\n      class=\"form-control\"\n      aria-invalid=\"false\"\n    />\n  </div>\n  <div class=\"bento-items-label\" [attr.id]=\"'bento-items-label-' + _uid\">\n    <span>\n      {{\n        _selection === 0\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate: showAllText)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate: showSelectedText)\n      }}\n    </span>\n    <span class=\"bento-multi-line-span\" [hidden]=\"maxSelectedItems === 0\">\n      {{\n        maxSelectedItems === 1\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_MAX_SELECTED_INFO' | bentoTranslate)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_MAX_SELECTED_INFO_PLURAL'\n            | bentoTranslate\n            | bentoStringReplace: '_NUMBER_':maxSelectedItems)\n      }}\n    </span>\n  </div>\n</div>\n\n<bento-list\n  #list\n  cdkMonitorElementFocus\n  [dataObservable]=\"_dataChange\"\n  [options]=\"_listOptions\"\n  [height]=\"_listHeight\"\n  [width]=\"_listWidth\"\n  [attr.id]=\"_selection == 0 ? 'show-all-panel' + _uid : 'show-selected-panel' + _uid\"\n  [attr.aria-labelledby]=\"'bento-items-label-' + _uid\"\n  (focus)=\"_onListFocus($event)\"\n  (keydown)=\"_onListKeydown($event)\"\n  aria-hidden=\"false\"\n  role=\"listbox\"\n  [attr.aria-activedescendant]=\"'row' + _uid + _activeIndex\"\n  aria-multiselectable=\"true\"\n  tabindex=\"0\"\n>\n  <ng-template #rowTemplate let-$index=\"index\" let-$row=\"row\" let-$o=\"options\">\n    <ng-container *ngIf=\"listItemTemplate && !$row.isSelectAll; else defaultListItemTemplate\">\n      <div\n        [attr.id]=\"'row' + _uid + $index\"\n        class=\"bento-list-row bento-multiselect-list-item\"\n        (click)=\"_onRowClick($event, $row, $index)\"\n        role=\"option\"\n        [attr.aria-selected]=\"!!$o.checkStatusRef.get($row)\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$index + 1\"\n      >\n        <bento-checkbox [ngModel]=\"$o.checkStatusRef.get($row)\" tabindex=\"-1\" aria-hidden=\"true\"></bento-checkbox>\n        <div class=\"bento-multiselect-list-item-label\">\n          <ng-container\n            *ngTemplateOutlet=\"listItemTemplate; context: {item: $row, index: $index, options: $o}\"\n          ></ng-container>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-template #defaultListItemTemplate>\n      <div\n        [attr.id]=\"'row' + _uid + $index\"\n        class=\"bento-list-row bento-multiselect-list-item\"\n        [ngClass]=\"{\n          'bento-item-disabled': $row.disabled && $row.disabled === 1,\n          focused: $index === _activeIndex\n        }\"\n        (click)=\"_onRowClick($event, $row, $index)\"\n        role=\"option\"\n        [attr.aria-selected]=\"!!$o.checkStatusRef.get($row)\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$index + 1\"\n        [attr.title]=\"$row.isSelectAll ? '' : $row.name\"\n      >\n        <bento-checkbox [ngModel]=\"$o.checkStatusRef.get($row)\" tabindex=\"-1\" aria-hidden=\"true\"></bento-checkbox>\n        <div class=\"bento-multiselect-list-item-label\">\n          {{ $row.isSelectAll ? ($row.name | bentoTranslate: selectAllText) : $row.name }}\n        </div>\n      </div>\n    </ng-template>\n  </ng-template>\n</bento-list>\n", styles: [".ng-bento .bento-item-disabled{opacity:.5;pointer-events:none}.ng-bento .bento-multi-line-span{display:flex;flex-direction:row;flex-wrap:wrap;font-weight:400;justify-content:left;line-height:normal}.ng-bento bento-multiselect-list{display:block;box-sizing:border-box;position:relative;height:100%}.ng-bento bento-multiselect-list bento-checkbox{pointer-events:none}.ng-bento bento-multiselect-list bento-list{border:none;position:relative;z-index:1}.ng-bento bento-multiselect-list .pills{margin:-10px -10px 10px;border-bottom-width:1px;border-bottom-style:solid}.ng-bento bento-multiselect-list .nav-pills{white-space:nowrap;padding:0}.ng-bento bento-multiselect-list .nav-pills>li{display:inline-block;width:50%;position:relative}.ng-bento bento-multiselect-list .nav-pills>li:before{content:\"\"}.ng-bento bento-multiselect-list .nav-pills>li+li{margin-left:0}.ng-bento bento-multiselect-list .nav-pills>li.active button{background-color:transparent}.ng-bento bento-multiselect-list .nav-pills>li button{border-bottom:4px solid transparent!important;width:100%;border-radius:0;border-width:0;text-align:center;padding:12px 15px 12px 10px;display:block;line-height:1}.ng-bento bento-multiselect-list .nav-pills>li button:focus{outline:none}.ng-bento bento-multiselect-list .nav-pills>li button:not(:active):focus{text-decoration:underline}.ng-bento bento-multiselect-list .nav-pills>li button:hover{text-decoration:underline}.ng-bento bento-multiselect-list .bento-multiselect-list-item{align-items:center;border:none;border-top-style:solid;border-top-width:1px;cursor:pointer;display:flex;justify-content:flex-start;overflow:hidden;padding:0 10px;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;width:100%}.ng-bento bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search{display:block;cursor:default}.ng-bento bento-multiselect-list .bento-multiselect-list-item:last-of-type{border-bottom-width:1px;border-bottom-style:solid}.ng-bento bento-multiselect-list .bento-multiselect-list-item:first-child{border:none}.ng-bento bento-multiselect-list .bento-multiselect-list-item .nav-pills{margin:0}.ng-bento bento-multiselect-list .bento-multiselect-list-item .nav-pills>li>a{padding-top:0;padding-bottom:0}.ng-bento bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search{padding:10px 10px 0;border-bottom-width:1px;border-bottom-style:solid}.ng-bento bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search>input{background:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' width='23.495px' height='23.495px' viewBox='0 0 23.495 23.495' enable-background='new 0 0 23.495 23.495' xml:space='preserve'%3E%3Cg id='search_1_'%3E%3Cpath fill='%23606060' d='M23.347 20.505l-5.878-5.879c0.956-1.481 1.521-3.24 1.521-5.132C18.99 4.3 14.7 0 9.5 0 C4.258 0 0 4.3 0 9.494c0 5.2 4.3 9.5 9.5 9.495c1.891 0 3.649-0.562 5.132-1.52l5.878 5.9 c0.195 0.2 0.5 0.2 0.7 0l2.132-2.132C23.544 21 23.5 20.7 23.3 20.505z M3.015 9.5 c0-3.571 2.906-6.479 6.479-6.479s6.479 2.9 6.5 6.479c0 3.573-2.904 6.479-6.479 6.479C5.921 16 3 13.1 3 9.5 z'/%3E%3C/g%3E%3C/svg%3E\") 9px center no-repeat;background-size:20px;-webkit-background-clip:padding-box;box-sizing:border-box;margin:0;outline:none;padding-left:36px;border-width:1px;border-style:solid;border-radius:0}.ng-bento bento-multiselect-list .bento-multiselect-list-item>i{margin-right:5px;top:.0714px}.ng-bento bento-multiselect-list .bento-multiselect-list-item-label{flex-basis:0;flex-grow:1;max-height:100%}[dir=rtl] .ng-bento bento-multiselect-list .bento-multiselect-list-item{text-align:right}[dir=rtl] .ng-bento bento-multiselect-list .bento-multiselect-list-item>i{margin-right:auto;margin-left:5px}\n"], components: [{ type: BentoListComponent, selector: "bento-list", inputs: ["autoHeightResize", "width", "height", "dataObservable", "maxHeight", "options", "minWidth", "itemHeight"], outputs: ["endOfScroll", "heightChange", "scrollBarChange"] }, { type: BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-multiselect-list', encapsulation: ViewEncapsulation.None, template: "<div #topPanel class=\"bento-multiselect-list-item bento-multiselect-search\">\n  <div class=\"pills\">\n    <ul\n      cdkMonitorElementFocus\n      (keydown)=\"_onTabsKeydown($event)\"\n      class=\"nav nav-pills\"\n      role=\"tablist\">\n      <li [attr.id]=\"'show-all' + _uid\" [ngClass]=\"_selection == 0 ? 'active ' : ''\">\n        <button\n          role=\"tab\"\n          (click)=\"show(0)\"\n          [attr.aria-selected]=\"_selection == 0 ? true : false\"\n          type=\"button\"\n          #showAll\n        >\n          <span>\n            {{ 'BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate: showAllText }}\n          </span>\n        </button>\n      </li>\n      <li [attr.id]=\"'show-selected' + _uid\" [ngClass]=\"_selection == 1 ? 'active ' : ''\">\n        <button role=\"tab\" (click)=\"show(1)\" [attr.aria-selected]=\"_selection == 1 ? true : false\" type=\"button\">\n          <span>\n            {{ 'BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate: showSelectedText }}\n          </span>\n        </button>\n      </li>\n    </ul>\n  </div>\n  <label class=\"bento-search-label\" [attr.for]=\"'multiselect-filter-items-' + _uid\">\n    {{ 'BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL' | bentoTranslate: searchLabelText }}\n    <span class=\"form-text\" *ngIf=\"searchLabelHelpText != ''\">\n      {{ searchLabelHelpText }}\n    </span>\n  </label>\n  <div class=\"bento-search\">\n    <input\n      [attr.id]=\"'multiselect-filter-items-' + _uid\"\n      bentoReset\n      #searchField\n      type=\"text\"\n      [ngModel]=\"_searchTerm\"\n      (ngModelChange)=\"onSearch($event)\"\n      class=\"form-control\"\n      aria-invalid=\"false\"\n    />\n  </div>\n  <div class=\"bento-items-label\" [attr.id]=\"'bento-items-label-' + _uid\">\n    <span>\n      {{\n        _selection === 0\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate: showAllText)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate: showSelectedText)\n      }}\n    </span>\n    <span class=\"bento-multi-line-span\" [hidden]=\"maxSelectedItems === 0\">\n      {{\n        maxSelectedItems === 1\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_MAX_SELECTED_INFO' | bentoTranslate)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_MAX_SELECTED_INFO_PLURAL'\n            | bentoTranslate\n            | bentoStringReplace: '_NUMBER_':maxSelectedItems)\n      }}\n    </span>\n  </div>\n</div>\n\n<bento-list\n  #list\n  cdkMonitorElementFocus\n  [dataObservable]=\"_dataChange\"\n  [options]=\"_listOptions\"\n  [height]=\"_listHeight\"\n  [width]=\"_listWidth\"\n  [attr.id]=\"_selection == 0 ? 'show-all-panel' + _uid : 'show-selected-panel' + _uid\"\n  [attr.aria-labelledby]=\"'bento-items-label-' + _uid\"\n  (focus)=\"_onListFocus($event)\"\n  (keydown)=\"_onListKeydown($event)\"\n  aria-hidden=\"false\"\n  role=\"listbox\"\n  [attr.aria-activedescendant]=\"'row' + _uid + _activeIndex\"\n  aria-multiselectable=\"true\"\n  tabindex=\"0\"\n>\n  <ng-template #rowTemplate let-$index=\"index\" let-$row=\"row\" let-$o=\"options\">\n    <ng-container *ngIf=\"listItemTemplate && !$row.isSelectAll; else defaultListItemTemplate\">\n      <div\n        [attr.id]=\"'row' + _uid + $index\"\n        class=\"bento-list-row bento-multiselect-list-item\"\n        (click)=\"_onRowClick($event, $row, $index)\"\n        role=\"option\"\n        [attr.aria-selected]=\"!!$o.checkStatusRef.get($row)\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$index + 1\"\n      >\n        <bento-checkbox [ngModel]=\"$o.checkStatusRef.get($row)\" tabindex=\"-1\" aria-hidden=\"true\"></bento-checkbox>\n        <div class=\"bento-multiselect-list-item-label\">\n          <ng-container\n            *ngTemplateOutlet=\"listItemTemplate; context: {item: $row, index: $index, options: $o}\"\n          ></ng-container>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-template #defaultListItemTemplate>\n      <div\n        [attr.id]=\"'row' + _uid + $index\"\n        class=\"bento-list-row bento-multiselect-list-item\"\n        [ngClass]=\"{\n          'bento-item-disabled': $row.disabled && $row.disabled === 1,\n          focused: $index === _activeIndex\n        }\"\n        (click)=\"_onRowClick($event, $row, $index)\"\n        role=\"option\"\n        [attr.aria-selected]=\"!!$o.checkStatusRef.get($row)\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$index + 1\"\n        [attr.title]=\"$row.isSelectAll ? '' : $row.name\"\n      >\n        <bento-checkbox [ngModel]=\"$o.checkStatusRef.get($row)\" tabindex=\"-1\" aria-hidden=\"true\"></bento-checkbox>\n        <div class=\"bento-multiselect-list-item-label\">\n          {{ $row.isSelectAll ? ($row.name | bentoTranslate: selectAllText) : $row.name }}\n        </div>\n      </div>\n    </ng-template>\n  </ng-template>\n</bento-list>\n", styles: [".ng-bento .bento-item-disabled{opacity:.5;pointer-events:none}.ng-bento .bento-multi-line-span{display:flex;flex-direction:row;flex-wrap:wrap;font-weight:400;justify-content:left;line-height:normal}.ng-bento bento-multiselect-list{display:block;box-sizing:border-box;position:relative;height:100%}.ng-bento bento-multiselect-list bento-checkbox{pointer-events:none}.ng-bento bento-multiselect-list bento-list{border:none;position:relative;z-index:1}.ng-bento bento-multiselect-list .pills{margin:-10px -10px 10px;border-bottom-width:1px;border-bottom-style:solid}.ng-bento bento-multiselect-list .nav-pills{white-space:nowrap;padding:0}.ng-bento bento-multiselect-list .nav-pills>li{display:inline-block;width:50%;position:relative}.ng-bento bento-multiselect-list .nav-pills>li:before{content:\"\"}.ng-bento bento-multiselect-list .nav-pills>li+li{margin-left:0}.ng-bento bento-multiselect-list .nav-pills>li.active button{background-color:transparent}.ng-bento bento-multiselect-list .nav-pills>li button{border-bottom:4px solid transparent!important;width:100%;border-radius:0;border-width:0;text-align:center;padding:12px 15px 12px 10px;display:block;line-height:1}.ng-bento bento-multiselect-list .nav-pills>li button:focus{outline:none}.ng-bento bento-multiselect-list .nav-pills>li button:not(:active):focus{text-decoration:underline}.ng-bento bento-multiselect-list .nav-pills>li button:hover{text-decoration:underline}.ng-bento bento-multiselect-list .bento-multiselect-list-item{align-items:center;border:none;border-top-style:solid;border-top-width:1px;cursor:pointer;display:flex;justify-content:flex-start;overflow:hidden;padding:0 10px;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;width:100%}.ng-bento bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search{display:block;cursor:default}.ng-bento bento-multiselect-list .bento-multiselect-list-item:last-of-type{border-bottom-width:1px;border-bottom-style:solid}.ng-bento bento-multiselect-list .bento-multiselect-list-item:first-child{border:none}.ng-bento bento-multiselect-list .bento-multiselect-list-item .nav-pills{margin:0}.ng-bento bento-multiselect-list .bento-multiselect-list-item .nav-pills>li>a{padding-top:0;padding-bottom:0}.ng-bento bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search{padding:10px 10px 0;border-bottom-width:1px;border-bottom-style:solid}.ng-bento bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search>input{background:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' width='23.495px' height='23.495px' viewBox='0 0 23.495 23.495' enable-background='new 0 0 23.495 23.495' xml:space='preserve'%3E%3Cg id='search_1_'%3E%3Cpath fill='%23606060' d='M23.347 20.505l-5.878-5.879c0.956-1.481 1.521-3.24 1.521-5.132C18.99 4.3 14.7 0 9.5 0 C4.258 0 0 4.3 0 9.494c0 5.2 4.3 9.5 9.5 9.495c1.891 0 3.649-0.562 5.132-1.52l5.878 5.9 c0.195 0.2 0.5 0.2 0.7 0l2.132-2.132C23.544 21 23.5 20.7 23.3 20.505z M3.015 9.5 c0-3.571 2.906-6.479 6.479-6.479s6.479 2.9 6.5 6.479c0 3.573-2.904 6.479-6.479 6.479C5.921 16 3 13.1 3 9.5 z'/%3E%3C/g%3E%3C/svg%3E\") 9px center no-repeat;background-size:20px;-webkit-background-clip:padding-box;box-sizing:border-box;margin:0;outline:none;padding-left:36px;border-width:1px;border-style:solid;border-radius:0}.ng-bento bento-multiselect-list .bento-multiselect-list-item>i{margin-right:5px;top:.0714px}.ng-bento bento-multiselect-list .bento-multiselect-list-item-label{flex-basis:0;flex-grow:1;max-height:100%}[dir=rtl] .ng-bento bento-multiselect-list .bento-multiselect-list-item{text-align:right}[dir=rtl] .ng-bento bento-multiselect-list .bento-multiselect-list-item>i{margin-right:auto;margin-left:5px}\n"] }]
        }], ctorParameters: function () { return [{ type: BentoUidService }, { type: BentoLogService }, { type: i3.LiveAnnouncer }, { type: BentoTranslate }, { type: i0.ElementRef }]; }, propDecorators: { showAllText: [{
                type: Input
            }], showSelectedText: [{
                type: Input
            }], selectAllText: [{
                type: Input
            }], searchLabelText: [{
                type: Input
            }], searchLabelHelpText: [{
                type: Input
            }], itemsObservable: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], listItemTemplate: [{
                type: Input
            }], searchCompare: [{
                type: Input
            }], maxSelectedItems: [{
                type: Input
            }], lengthChange: [{
                type: Output
            }], rowClick: [{
                type: Output
            }], topPanel: [{
                type: ViewChild,
                args: ['topPanel', { static: true }]
            }], list: [{
                type: ViewChild,
                args: ['list', { static: true }]
            }], _selectedList: [{
                type: Input,
                args: ['selectedList']
            }], selectedListChange: [{
                type: Output
            }], searchFieldRef: [{
                type: ViewChild,
                args: ['searchField', { static: true }]
            }], showAllRef: [{
                type: ViewChild,
                args: ['showAll', { static: true }]
            }] } });

const OVERLAY_MARGIN = 20;
const DEFAULT_MAX_HEIGHT = 600;
const BENTO_MO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoMultiselectOverlayComponent),
    multi: true
};
/**
 * This component is used to make selections from a filtered list. It appears as an overlay,
 * attached to its trigger element via a pointer on either the left or right side.
 */
class BentoMultiselectOverlayComponent {
    constructor(elRef, r, dir, windowRef, changeDetector) {
        this.elRef = elRef;
        this.r = r;
        this.changeDetector = changeDetector;
        /**
         * Replace search input field help text
         */
        this.searchLableHelpText = '';
        /**
         * Set max height of the overlay in pixel. (Default `600`)
         */
        this.overlayMaxHeight = DEFAULT_MAX_HEIGHT;
        /**
         * Flag to show selected list text next to button when overlay is closed.
         */
        this.showSelectedListText = true;
        /**
         * Variable to keep custom translations that are defined specifically for this component instance
         */
        this.customTranslation = {};
        this._isOpen = false;
        this._showOverlay = false;
        /**
         * ngModel Variables
         */
        this.selectedList = [];
        this._preselectedList = [];
        this._disabled = false;
        this._side = 'right';
        this._listHeight = 0;
        this.isRTL = false;
        this.dirSubscription = Subscription.EMPTY;
        this._ariaHiddenValues = new Map();
        this.onChange = (_) => { };
        this.onTouch = () => { };
        this.window = windowRef.nativeWindow;
        this.document = windowRef.nativeDocument;
        this.dirSubscription = dir.change.subscribe(() => {
            this.isRTL = dir.value === 'rtl';
            this.changeDetector.markForCheck();
        });
    }
    /**
     * ControlValueAccessor interface
     */
    writeValue(v) {
        if (this.selectedList === v) {
            return;
        }
        this.selectedList = v || [];
        this._preselectedList = this.selectedList.slice();
        this.changeDetector.markForCheck();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = () => {
            fn();
            this.changeDetector.markForCheck();
        };
    }
    setDisabledState(v) {
        this._disabled = v;
        this.changeDetector.markForCheck();
    }
    /**
     * Custom translations can be set here.
     *
     * Translation labels that are used:
     * * `BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_CANCEL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_DONE`
     * * `BENTO_UI_MULTISELECT_OVERLAY_EDIT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_A11Y_NOTHING_FOUND`
     * * `BENTO_UI_MULTISELECT_A11Y_OVERLAY_FOUND_N_RESULTS`
     */
    setTranslation(translation) {
        this.customTranslation = translation;
        this.changeDetector.markForCheck();
    }
    /**
     * Garbage cleaning on destroy
     */
    ngOnDestroy() {
        this.changeDetector.detach();
        if (this._onWindowClickCancel) {
            this._onWindowClickCancel();
        }
        if (this._onWindowTouchCancel) {
            this._onWindowTouchCancel();
        }
        if (this._onWindowResizeCancel) {
            this._onWindowResizeCancel();
        }
        if (this._windowWheelCancel) {
            this._windowWheelCancel();
        }
        if (this._windowKeydownCancel) {
            this._windowKeydownCancel();
        }
        this.dirSubscription.unsubscribe();
    }
    /**
     * On window click
     */
    _onWindowClick(event) {
        if (event.target.window || // Window object
            (!this.elRef.nativeElement.contains(event.target) && !this.containerWrapper.nativeElement.contains(event.target))) {
            this._onDoneClick(event, true);
            event.stopPropagation();
            event.preventDefault();
            this.changeDetector.markForCheck();
        }
    }
    /**
     * Prevent Wheel Scroll
     */
    _preventWheelScroll(event) {
        if (!this.containerWrapper.nativeElement.contains(event.target)) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
    /**
     * Window keydown event listener
     */
    _onWindowKeydown(e) {
        const keysToPrevent = {};
        keysToPrevent[Keyboard.SPACE] = 0;
        keysToPrevent[Keyboard.PAGE_UP] = 1;
        keysToPrevent[Keyboard.PAGE_DOWN] = 1;
        keysToPrevent[Keyboard.END] = 1;
        keysToPrevent[Keyboard.HOME] = 1;
        keysToPrevent[Keyboard.ESC] = 1;
        if (keysToPrevent[e.keyCode]) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (e.keyCode === Keyboard.ESC) {
            this._onDoneClick(e, true);
            this.changeDetector.markForCheck();
        }
    }
    /**
     * Callback when selection is changed
     */
    _onSelectionChange(selection) {
        this._preselectedList = selection;
    }
    /**
     * On Toggle button click
     */
    _onToggleClick($event, isDismissal) {
        if (!this._isOpen) {
            this._isOpen = true;
            this._setAriaHidden(this.elRef.nativeElement);
            // Reset Selection tab
            this.multiselectList.show(Selection.all);
            setTimeout(() => {
                // `click` should not be used since the items clicked in the overlay could disappear before
                // the window recieves its event
                this._onWindowClickCancel = this.r.listen('window', 'mousedown', e => this._onWindowClick(e));
                this._onWindowTouchCancel = this.r.listen('window', 'touchstart', e => this._onWindowClick(e));
                // Render after the overlay is not hidden on stage
                this._onWindowResizeCancel = this.r.listen('window', 'resize', e => this._onWindowResize(e));
                this.renderOverlay();
                this.multiselectList.refreshView();
                // UX: focus on to the show all button
                this.multiselectList.focusOnShowAllButton();
            });
            this._windowWheelCancel = this.r.listen('window', 'wheel', e => {
                this._preventWheelScroll(e);
            });
            this._windowKeydownCancel = this.r.listen('window', 'keydown', (e) => {
                this._onWindowKeydown(e);
            });
        }
        else {
            this._onDoneClick($event, isDismissal);
        }
    }
    _setAriaHidden(element) {
        const parent = element.parentElement;
        if (parent && element !== document.body) {
            Array.from(parent.children).forEach(sibling => {
                if (sibling !== element && sibling.nodeName !== 'SCRIPT') {
                    this._ariaHiddenValues.set(sibling, sibling.getAttribute('aria-hidden'));
                    sibling.setAttribute('aria-hidden', 'true');
                }
            });
            this._setAriaHidden(parent);
        }
    }
    _revertAriaHidden() {
        this._ariaHiddenValues.forEach((value, element) => {
            if (value) {
                element.setAttribute('aria-hidden', value);
            }
            else {
                element.removeAttribute('aria-hidden');
            }
        });
        this._ariaHiddenValues.clear();
    }
    /**
     * When the done button is clicked
     * This is also used with the cancel button
     */
    _onDoneClick(event, isDismissal) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        this.multiselectList.clearSearchItem();
        // Remove animation flag
        this.r.removeClass(this.containerWrapper.nativeElement, 'in');
        this.r.addClass(this.containerWrapper.nativeElement, 'out');
        this._revertAriaHidden();
        setTimeout(() => {
            this._isOpen = false;
            this._showOverlay = false;
            this.r.removeClass(this.containerWrapper.nativeElement, 'out');
            this.r.appendChild(this.overlay.nativeElement, this.containerWrapper.nativeElement);
            this.changeDetector.markForCheck();
        }, 200);
        if (this._windowWheelCancel) {
            this._windowWheelCancel();
        }
        if (this._windowKeydownCancel) {
            this._windowKeydownCancel();
        }
        // remove window listener
        if (this._onWindowClickCancel) {
            this._onWindowClickCancel();
        }
        if (this._onWindowTouchCancel) {
            this._onWindowTouchCancel();
        }
        // Render after the overlay is not hidden on stage
        if (this._onWindowResizeCancel) {
            this._onWindowResizeCancel();
        }
        if (this.revertSelectionsOnDismissal && isDismissal) {
            this._preselectedList = this.selectedList.slice();
        }
        else {
            this.selectedList = this._preselectedList.slice();
            this.onChange(this.selectedList);
        }
        if (this.selectedList.length === 0) {
            // focus back to the toggle button
            // since there is nothing that is selected
            this.toggleButton.nativeElement.focus();
        }
    }
    /**
     * Render overlay location
     */
    renderOverlay() {
        const parentElement = this.containerWrapper.nativeElement;
        const overlayContainer = this.overlayContainer.nativeElement;
        const overlay = this.overlay.nativeElement;
        const toggleButton = this.toggleButton.nativeElement;
        const doneButton = this.doneButton.nativeElement;
        const overlayFooter = this.overlayFooter.nativeElement;
        const viewport = {
            width: Math.max(this.document.documentElement.clientWidth, this.window.innerWidth || 0),
            height: Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0)
        };
        this._scrollableParent = this.getScrollableParent(this.elRef.nativeElement);
        if (viewport.width < 601 || viewport.height < 421) {
            this.r.addClass(parentElement, 'bento-side-overlay-container-wrapper-fixed');
            this.r.addClass(parentElement, 'open');
            this.r.appendChild(this.document.body, parentElement);
            this._listHeight = overlayContainer.offsetHeight - overlayFooter.offsetHeight - 2;
            this._listWidth = overlayContainer.offsetWidth - 2;
        }
        else {
            this.r.removeClass(parentElement, 'bento-side-overlay-container-wrapper-fixed');
            this.r.removeClass(parentElement, 'open');
            this.r.appendChild(overlay, this.containerWrapper.nativeElement);
            const maxOverlayHeight = Math.min(this.overlayMaxHeight, this._scrollableParent.offsetHeight - OVERLAY_MARGIN * 2);
            const overlayInnerHeight = 0;
            const toggleOffset = this._getElementOffsetFrom(toggleButton, this._scrollableParent);
            const toggleOffsetTop = toggleOffset.top - (this.document.documentElement.scrollTop || this.document.body.scrollTop);
            let toggleCenterOffsetTop = toggleOffsetTop + toggleButton.offsetHeight * 0.5;
            // check toggle button location and realign if needed
            // for better layout spacing
            const allowedTopSpacing = OVERLAY_MARGIN + 25;
            let overlayHeight;
            let targetOverlayTop;
            // adjust overlay height based on the scrollable container or body
            if (overlayInnerHeight > 0) {
                // overlayHeight is bigger than max-height
                if (overlayInnerHeight > maxOverlayHeight - overlayFooter.offsetHeight) {
                    overlayHeight = maxOverlayHeight;
                }
                else {
                    overlayHeight = overlayInnerHeight + overlayFooter.offsetHeight;
                }
            }
            else {
                overlayHeight = maxOverlayHeight;
            }
            this.r.setStyle(overlayContainer, 'height', overlayHeight + 'px');
            this._listHeight = maxOverlayHeight - overlayFooter.offsetHeight;
            this._listWidth = 0; // reset width
            // Get the overlay height of max is updated
            overlayHeight = overlayContainer.offsetHeight;
            // when the scrollable is <BODY>
            if (this._scrollableParent.tagName === 'HTML' || this._scrollableParent.tagName === 'BODY') {
                const scrollingElement = this.document.scrollingElement || this.document.documentElement;
                // We need to scroll up a little bit
                if (toggleCenterOffsetTop < allowedTopSpacing) {
                    this.r.setProperty(scrollingElement, 'scrollTop', toggleOffset.top - allowedTopSpacing);
                    toggleCenterOffsetTop = allowedTopSpacing + toggleButton.offsetHeight * 0.5;
                }
                else if (toggleCenterOffsetTop > this._scrollableParent.offsetHeight - allowedTopSpacing) {
                    // We need to scroll down a little
                    this.r.setProperty(scrollingElement, 'scrollTop', toggleOffset.top + toggleButton.offsetHeight - this._scrollableParent.offsetHeight + allowedTopSpacing);
                    toggleCenterOffsetTop =
                        this._scrollableParent.offsetHeight - allowedTopSpacing - toggleButton.offsetHeight * 0.5;
                }
                // Set default
                targetOverlayTop = -overlayHeight * 0.5;
                if (-targetOverlayTop > toggleCenterOffsetTop - OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the top
                    targetOverlayTop = -(toggleCenterOffsetTop - OVERLAY_MARGIN + toggleButton.offsetHeight * 0.25);
                }
                else if (overlayHeight + targetOverlayTop >
                    this._scrollableParent.offsetHeight - toggleCenterOffsetTop - OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the bottom
                    targetOverlayTop =
                        this._scrollableParent.offsetHeight -
                            toggleCenterOffsetTop -
                            OVERLAY_MARGIN -
                            overlayHeight -
                            toggleButton.offsetHeight * 0.25;
                }
            }
            else {
                // Scrollable is other
                if (toggleOffset.bottom < allowedTopSpacing) {
                    // We need to scroll up a little bit
                    this.r.setProperty(this._scrollableParent, 'scrollTop', this._scrollableParent.scrollTop + allowedTopSpacing - toggleOffset.bottom);
                }
                else if (toggleOffset.top < allowedTopSpacing) {
                    // We need to scroll down a little
                    this.r.setProperty(this._scrollableParent, 'scrollTop', this._scrollableParent.scrollTop - allowedTopSpacing - toggleOffset.top);
                }
                const overlayLocalRect = this._getElementOffsetFrom(overlayContainer, this._scrollableParent);
                // set default
                targetOverlayTop = -overlayContainer.offsetHeight * 0.5;
                if (targetOverlayTop < OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the top
                    targetOverlayTop = overlayContainer.offsetTop - overlayLocalRect.top + OVERLAY_MARGIN;
                }
                else if (overlayLocalRect.bottom + targetOverlayTop < OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the bottom
                    targetOverlayTop = overlayContainer.offsetTop + overlayLocalRect.bottom - OVERLAY_MARGIN;
                }
                if (targetOverlayTop > -doneButton.offsetHeight * 0.5 - OVERLAY_MARGIN) {
                    targetOverlayTop = -doneButton.offsetHeight * 0.5 - OVERLAY_MARGIN;
                }
                else if (targetOverlayTop + overlayLocalRect.height < doneButton.offsetHeight * 0.5 + OVERLAY_MARGIN) {
                    targetOverlayTop = -overlayLocalRect.height + doneButton.offsetHeight * 0.5 + OVERLAY_MARGIN;
                }
            }
            this.r.setStyle(overlayContainer, 'top', targetOverlayTop + 'px');
            this.r.setStyle(overlayContainer, 'transform-origin', `${this.isRTL ? '100%' : '0%'} ${Math.abs(targetOverlayTop / overlayContainer.offsetHeight) * 100}%`);
            this.r.addClass(parentElement, 'in');
        }
        // animate in
        if (!this._showOverlay) {
            setTimeout(() => {
                this._showOverlay = true;
                this.changeDetector.markForCheck();
            }, 10);
        }
    }
    /**
     * Event Listener when the window is resizing
     */
    _onWindowResize(e) {
        if (this._isOpen) {
            clearTimeout(this._windowResizeTimeoutID);
            if (this.elRef.nativeElement.contains(this.document.activeElement)) {
                this.activeElement = this.document.activeElement;
            }
            this._windowResizeTimeoutID = setTimeout(() => {
                this.renderOverlay();
                if (this.activeElement) {
                    this.activeElement.focus();
                }
            }, 100);
        }
    }
    /**
     * Get offset of el1 from el2
     */
    _getElementOffsetFrom(el, fromEl) {
        const parentRect = fromEl.getBoundingClientRect();
        const toggleRect = el.getBoundingClientRect();
        // Return the relative RECT of the toggle button to the given parent
        return {
            left: toggleRect.left - parentRect.left,
            right: parentRect.right - toggleRect.right,
            top: toggleRect.top - parentRect.top,
            bottom: parentRect.bottom - toggleRect.bottom,
            width: toggleRect.width,
            height: toggleRect.height
        };
    }
    /**
     * Monitor when this user blurs from this component
     */
    _onFocusout(e) {
        setTimeout(() => {
            if (!this.elRef.nativeElement.contains(this.document.activeElement)) {
                this.onTouch();
            }
        });
    }
    /**
     * Get the closest scrollable parent
     */
    getScrollableParent(el) {
        if (el === null) {
            return;
        }
        const cStyle = this.window.getComputedStyle(el);
        const overflowY = cStyle.getPropertyValue('overflow-y');
        const overflow = cStyle.getPropertyValue('overflow');
        const display = cStyle.getPropertyValue('display');
        if ((display.indexOf('block') > -1 || display.indexOf('flex') > -1) &&
            (overflowY === 'auto' ||
                overflowY === 'scroll' ||
                overflow === 'auto' ||
                overflow === 'scroll' ||
                overflow === 'hidden' ||
                overflowY === 'hidden')) {
            return el;
        }
        else if (el.nodeName === 'HTML') {
            return el;
        }
        else {
            return this.getScrollableParent(el.parentElement);
        }
    }
    /**
     * Callback when the length of the items dataset is changed
     */
    _itemsLengthChange(v) {
        this._itemsLength = v;
    }
}
BentoMultiselectOverlayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectOverlayComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i2.Directionality }, { token: WindowRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoMultiselectOverlayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoMultiselectOverlayComponent, selector: "bento-multiselect-overlay", inputs: { selectButtonText: "selectButtonText", editButtonText: "editButtonText", allSelectedInfoText: "allSelectedInfoText", selectedInfoText: "selectedInfoText", doneButtonText: "doneButtonText", cancelButtonText: "cancelButtonText", searchLableText: "searchLableText", searchLableHelpText: "searchLableHelpText", itemsObservable: "itemsObservable", showAllText: "showAllText", showSelectedText: "showSelectedText", selectAllText: "selectAllText", revertSelectionsOnDismissal: "revertSelectionsOnDismissal", listItemTemplate: "listItemTemplate", overlayMaxHeight: "overlayMaxHeight", maxSelectedItems: "maxSelectedItems", searchCompare: "searchCompare", showSelectedListText: "showSelectedListText" }, host: { listeners: { "focusout": "_onFocusout($event)" } }, providers: [BENTO_MO_VALUE_ACCESSOR], viewQueries: [{ propertyName: "overlay", first: true, predicate: ["overlay"], descendants: true, static: true }, { propertyName: "toggleButton", first: true, predicate: ["toggleButton"], descendants: true, static: true }, { propertyName: "containerWrapper", first: true, predicate: ["containerWrapper"], descendants: true, static: true }, { propertyName: "doneButton", first: true, predicate: ["doneButton"], descendants: true, static: true }, { propertyName: "cancelButton", first: true, predicate: ["cancelButton"], descendants: true }, { propertyName: "overlayContainer", first: true, predicate: ["overlayContainer"], descendants: true, static: true }, { propertyName: "overlayFooter", first: true, predicate: ["overlayFooter"], descendants: true, static: true }, { propertyName: "label", first: true, predicate: ["label"], descendants: true, static: true }, { propertyName: "multiselectList", first: true, predicate: BentoMultiselectListComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"bento-multiselect-overlay-inner\">\n  <div\n    #overlay\n    class=\"bento-side-overlay\"\n    [ngClass]=\"\n      (_side == 'right' ? 'bento-side-overlay-right ' : '') +\n      (_side == 'left' ? 'bento-side-overlay-left ' : '') +\n      (_isOpen ? 'open ' : '')\n    \"\n    tabindex=\"-1\"\n  >\n    <button\n      #toggleButton\n      class=\"bento-side-overlay-toggle btn btn-outline-primary btn-multiselect-overlay\"\n      [disabled]=\"_disabled\"\n      (click)=\"_onToggleClick($event, revertSelectionsOnDismissal)\"\n      aria-haspopup=\"true\"\n      type=\"button\"\n    >\n      {{\n        selectedList.length === 0\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_SELECT'\n            | bentoTranslate: selectButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_EDIT'\n            | bentoTranslate: editButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_EDIT)\n      }}\n    </button>\n    <div\n      #containerWrapper\n      role=\"dialog\"\n      class=\"bui-bento-side-overlay-container-wrapper bento-side-overlay-container-wrapper\"\n      [ngClass]=\"_showOverlay ? 'show-overlay ' : ''\"\n    >\n      <div #overlayContainer class=\"bento-side-overlay-container\" tabindex=\"-1\" cdkTrapFocus>\n        <bento-multiselect-list\n          [itemsObservable]=\"itemsObservable\"\n          [height]=\"_listHeight\"\n          [width]=\"_listWidth\"\n          [showAllText]=\"showAllText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL\"\n          [showSelectedText]=\"showSelectedText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED\"\n          [selectAllText]=\"selectAllText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL\"\n          [searchLabelText]=\"searchLableText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL\"\n          [searchLabelHelpText]=\"searchLableHelpText\"\n          [selectedList]=\"_preselectedList\"\n          (selectedListChange)=\"_onSelectionChange($event)\"\n          [listItemTemplate]=\"listItemTemplate\"\n          [searchCompare]=\"searchCompare\"\n          (lengthChange)=\"_itemsLengthChange($event)\"\n          class=\"fill\"\n          [maxSelectedItems]=\"maxSelectedItems || 0\"\n        ></bento-multiselect-list>\n        <div #overlayFooter class=\"bento-side-overlay-container-footer\">\n          <button\n            #doneButton\n            class=\"btn bento-side-overlay-container-footer-done\"\n            [ngClass]=\"revertSelectionsOnDismissal ? 'btn-primary' : 'btn-outline-primary btn-multiselect-overlay'\"\n            type=\"button\"\n            (click)=\"_onDoneClick($event, false)\"\n          >\n            {{\n              'BENTO_UI_MULTISELECT_OVERLAY_DONE'\n                | bentoTranslate: doneButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_DONE\n            }}\n          </button>\n          <button\n            #cancelButton\n            class=\"btn btn-outline-primary bento-side-overlay-container-footer-cancel\"\n            type=\"button\"\n            *ngIf=\"revertSelectionsOnDismissal\"\n            (click)=\"_onDoneClick($event, true)\"\n          >\n            {{\n              'BENTO_UI_MULTISELECT_OVERLAY_CANCEL'\n                | bentoTranslate: cancelButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_CANCEL\n            }}\n          </button>\n        </div>\n      </div>\n      <div class=\"bento-side-overlay-left-arrow\">\n        <svg height=\"35\" width=\"20\">\n          <polygon points=\"21,0 0.5,17.5 21,35\" class=\"bento-side-overlay-triangle\" />\n        </svg>\n      </div>\n      <div class=\"bento-side-overlay-right-arrow\">\n        <svg height=\"35\" width=\"20\">\n          <polygon points=\"-1,0 19.5,17.5 -1,35\" class=\"bento-side-overlay-triangle\" />\n        </svg>\n      </div>\n    </div>\n  </div>\n  <ng-container *ngIf=\"showSelectedListText\">\n    <span #label class=\"bento-multiselect-overlay-label\" aria-live=\"polite\" [attr.aria-hidden]=\"selectedList.length === 0\" [hidden]=\"selectedList.length === 0\">\n      {{\n        selectedList.length === 1\n          ? selectedList[0].name\n          : selectedList.length === _itemsLength\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO'\n            | bentoTranslate: allSelectedInfoText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO\n            | bentoStringReplace: '_NUMBER_':selectedList.length)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO'\n            | bentoTranslate: selectedInfoText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO\n            | bentoStringReplace: '_NUMBER_':selectedList.length)\n      }}\n    </span>\n  </ng-container>\n</div>\n", styles: [".ng-bento bento-multiselect-overlay .bento-side-overlay{display:inline-block;position:relative}.ng-bento bento-multiselect-overlay .bento-side-overlay .btn{vertical-align:baseline}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-toggle{cursor:pointer;display:inline-block}.ng-bento bento-multiselect-overlay .bento-side-overlay:focus{outline:none}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{position:absolute;left:0;top:-21px}[dir=rtl] .ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{display:none}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-right-arrow{position:absolute;right:0;top:-21px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-container-wrapper{margin-left:5px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:none}[dir=rtl] .ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:block}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container-wrapper{margin-right:5px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-left-arrow{display:none}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container{left:auto;right:19px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container-wrapper{margin-left:-100%}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-container-wrapper{display:none;position:relative}.ng-bento bento-multiselect-overlay .bento-side-overlay.open .bento-side-overlay-container-wrapper{display:inline-block;left:auto;position:relative}.ng-bento .bui-bento-side-overlay-container-wrapper{opacity:0;transition:opacity .1s}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{position:absolute;font-size:13px;left:19px;height:500px;min-width:300px;padding:0;list-style:none;border-width:1px;border-style:solid;box-shadow:0 5px 10px #0003;-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box}[dir=rtl] .ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{right:19px;left:0}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .fill{position:relative;height:100%}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container:focus{outline:none}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-container-footer{position:absolute;left:0;right:0;bottom:0;width:auto;height:auto;padding:10px;text-align:center;border-top-width:1px;border-top-style:solid}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container{padding:20px;font-size:.95em;max-width:300px;border-top-width:1px;border-top-style:solid;white-space:normal}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container textarea{resize:none;box-sizing:border-box;width:100%;height:60px;font-size:.95em;margin:0}.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed{background-color:RGBA(0,0,0,.2);position:fixed;top:0;left:0;right:0;bottom:0}.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-right-arrow,.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-left-arrow{display:none}.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-container{height:calc(100% - 50px)!important;left:50%!important;max-height:calc(100% - 50px)!important;max-width:450px;top:25px!important;transform:translate(-50%);width:calc(100% - 50px)!important}.ng-bento .bui-bento-side-overlay-container-wrapper.show-overlay{opacity:1}.ng-bento .bui-bento-side-overlay-container-wrapper.out{opacity:0;transition:opacity .2s}.ng-bento bento-multiselect-overlay .bento-side-overlay-triangle{stroke-width:1}\n", ".ng-bento bento-multiselect-overlay .bento-side-overlay-content{padding-bottom:50px}.ng-bento bento-multiselect-overlay .bento-multiselect-overlay-inner{display:inline-block}.ng-bento bento-multiselect-overlay .bento-side-overlay{float:left}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-content:focus{outline:none}.ng-bento bento-multiselect-overlay[disabled=disabled] .bento-multiselect-overlay-inner>span{opacity:.65}.ng-bento bento-multiselect-overlay .bento-multiselect-overlay-label{display:inline-block;margin-left:10px}\n"], components: [{ type: BentoMultiselectListComponent, selector: "bento-multiselect-list", inputs: ["showAllText", "showSelectedText", "selectAllText", "searchLabelText", "searchLabelHelpText", "itemsObservable", "height", "width", "listItemTemplate", "searchCompare", "maxSelectedItems", "selectedList"], outputs: ["lengthChange", "rowClick", "selectedListChange"] }], directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-multiselect-overlay', providers: [BENTO_MO_VALUE_ACCESSOR], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bento-multiselect-overlay-inner\">\n  <div\n    #overlay\n    class=\"bento-side-overlay\"\n    [ngClass]=\"\n      (_side == 'right' ? 'bento-side-overlay-right ' : '') +\n      (_side == 'left' ? 'bento-side-overlay-left ' : '') +\n      (_isOpen ? 'open ' : '')\n    \"\n    tabindex=\"-1\"\n  >\n    <button\n      #toggleButton\n      class=\"bento-side-overlay-toggle btn btn-outline-primary btn-multiselect-overlay\"\n      [disabled]=\"_disabled\"\n      (click)=\"_onToggleClick($event, revertSelectionsOnDismissal)\"\n      aria-haspopup=\"true\"\n      type=\"button\"\n    >\n      {{\n        selectedList.length === 0\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_SELECT'\n            | bentoTranslate: selectButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_EDIT'\n            | bentoTranslate: editButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_EDIT)\n      }}\n    </button>\n    <div\n      #containerWrapper\n      role=\"dialog\"\n      class=\"bui-bento-side-overlay-container-wrapper bento-side-overlay-container-wrapper\"\n      [ngClass]=\"_showOverlay ? 'show-overlay ' : ''\"\n    >\n      <div #overlayContainer class=\"bento-side-overlay-container\" tabindex=\"-1\" cdkTrapFocus>\n        <bento-multiselect-list\n          [itemsObservable]=\"itemsObservable\"\n          [height]=\"_listHeight\"\n          [width]=\"_listWidth\"\n          [showAllText]=\"showAllText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL\"\n          [showSelectedText]=\"showSelectedText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED\"\n          [selectAllText]=\"selectAllText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL\"\n          [searchLabelText]=\"searchLableText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL\"\n          [searchLabelHelpText]=\"searchLableHelpText\"\n          [selectedList]=\"_preselectedList\"\n          (selectedListChange)=\"_onSelectionChange($event)\"\n          [listItemTemplate]=\"listItemTemplate\"\n          [searchCompare]=\"searchCompare\"\n          (lengthChange)=\"_itemsLengthChange($event)\"\n          class=\"fill\"\n          [maxSelectedItems]=\"maxSelectedItems || 0\"\n        ></bento-multiselect-list>\n        <div #overlayFooter class=\"bento-side-overlay-container-footer\">\n          <button\n            #doneButton\n            class=\"btn bento-side-overlay-container-footer-done\"\n            [ngClass]=\"revertSelectionsOnDismissal ? 'btn-primary' : 'btn-outline-primary btn-multiselect-overlay'\"\n            type=\"button\"\n            (click)=\"_onDoneClick($event, false)\"\n          >\n            {{\n              'BENTO_UI_MULTISELECT_OVERLAY_DONE'\n                | bentoTranslate: doneButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_DONE\n            }}\n          </button>\n          <button\n            #cancelButton\n            class=\"btn btn-outline-primary bento-side-overlay-container-footer-cancel\"\n            type=\"button\"\n            *ngIf=\"revertSelectionsOnDismissal\"\n            (click)=\"_onDoneClick($event, true)\"\n          >\n            {{\n              'BENTO_UI_MULTISELECT_OVERLAY_CANCEL'\n                | bentoTranslate: cancelButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_CANCEL\n            }}\n          </button>\n        </div>\n      </div>\n      <div class=\"bento-side-overlay-left-arrow\">\n        <svg height=\"35\" width=\"20\">\n          <polygon points=\"21,0 0.5,17.5 21,35\" class=\"bento-side-overlay-triangle\" />\n        </svg>\n      </div>\n      <div class=\"bento-side-overlay-right-arrow\">\n        <svg height=\"35\" width=\"20\">\n          <polygon points=\"-1,0 19.5,17.5 -1,35\" class=\"bento-side-overlay-triangle\" />\n        </svg>\n      </div>\n    </div>\n  </div>\n  <ng-container *ngIf=\"showSelectedListText\">\n    <span #label class=\"bento-multiselect-overlay-label\" aria-live=\"polite\" [attr.aria-hidden]=\"selectedList.length === 0\" [hidden]=\"selectedList.length === 0\">\n      {{\n        selectedList.length === 1\n          ? selectedList[0].name\n          : selectedList.length === _itemsLength\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO'\n            | bentoTranslate: allSelectedInfoText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO\n            | bentoStringReplace: '_NUMBER_':selectedList.length)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO'\n            | bentoTranslate: selectedInfoText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO\n            | bentoStringReplace: '_NUMBER_':selectedList.length)\n      }}\n    </span>\n  </ng-container>\n</div>\n", styles: [".ng-bento bento-multiselect-overlay .bento-side-overlay{display:inline-block;position:relative}.ng-bento bento-multiselect-overlay .bento-side-overlay .btn{vertical-align:baseline}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-toggle{cursor:pointer;display:inline-block}.ng-bento bento-multiselect-overlay .bento-side-overlay:focus{outline:none}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{position:absolute;left:0;top:-21px}[dir=rtl] .ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{display:none}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-right-arrow{position:absolute;right:0;top:-21px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-container-wrapper{margin-left:5px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:none}[dir=rtl] .ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:block}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container-wrapper{margin-right:5px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-left-arrow{display:none}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container{left:auto;right:19px}.ng-bento bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container-wrapper{margin-left:-100%}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-container-wrapper{display:none;position:relative}.ng-bento bento-multiselect-overlay .bento-side-overlay.open .bento-side-overlay-container-wrapper{display:inline-block;left:auto;position:relative}.ng-bento .bui-bento-side-overlay-container-wrapper{opacity:0;transition:opacity .1s}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{position:absolute;font-size:13px;left:19px;height:500px;min-width:300px;padding:0;list-style:none;border-width:1px;border-style:solid;box-shadow:0 5px 10px #0003;-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box}[dir=rtl] .ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{right:19px;left:0}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .fill{position:relative;height:100%}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container:focus{outline:none}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-container-footer{position:absolute;left:0;right:0;bottom:0;width:auto;height:auto;padding:10px;text-align:center;border-top-width:1px;border-top-style:solid}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container{padding:20px;font-size:.95em;max-width:300px;border-top-width:1px;border-top-style:solid;white-space:normal}.ng-bento .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container textarea{resize:none;box-sizing:border-box;width:100%;height:60px;font-size:.95em;margin:0}.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed{background-color:RGBA(0,0,0,.2);position:fixed;top:0;left:0;right:0;bottom:0}.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-right-arrow,.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-left-arrow{display:none}.ng-bento .bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-container{height:calc(100% - 50px)!important;left:50%!important;max-height:calc(100% - 50px)!important;max-width:450px;top:25px!important;transform:translate(-50%);width:calc(100% - 50px)!important}.ng-bento .bui-bento-side-overlay-container-wrapper.show-overlay{opacity:1}.ng-bento .bui-bento-side-overlay-container-wrapper.out{opacity:0;transition:opacity .2s}.ng-bento bento-multiselect-overlay .bento-side-overlay-triangle{stroke-width:1}\n", ".ng-bento bento-multiselect-overlay .bento-side-overlay-content{padding-bottom:50px}.ng-bento bento-multiselect-overlay .bento-multiselect-overlay-inner{display:inline-block}.ng-bento bento-multiselect-overlay .bento-side-overlay{float:left}.ng-bento bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-content:focus{outline:none}.ng-bento bento-multiselect-overlay[disabled=disabled] .bento-multiselect-overlay-inner>span{opacity:.65}.ng-bento bento-multiselect-overlay .bento-multiselect-overlay-label{display:inline-block;margin-left:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i2.Directionality }, { type: WindowRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { selectButtonText: [{
                type: Input
            }], editButtonText: [{
                type: Input
            }], allSelectedInfoText: [{
                type: Input
            }], selectedInfoText: [{
                type: Input
            }], doneButtonText: [{
                type: Input
            }], cancelButtonText: [{
                type: Input
            }], searchLableText: [{
                type: Input
            }], searchLableHelpText: [{
                type: Input
            }], itemsObservable: [{
                type: Input
            }], showAllText: [{
                type: Input
            }], showSelectedText: [{
                type: Input
            }], selectAllText: [{
                type: Input
            }], revertSelectionsOnDismissal: [{
                type: Input
            }], listItemTemplate: [{
                type: Input
            }], overlayMaxHeight: [{
                type: Input
            }], maxSelectedItems: [{
                type: Input
            }], searchCompare: [{
                type: Input
            }], showSelectedListText: [{
                type: Input
            }], overlay: [{
                type: ViewChild,
                args: ['overlay', { static: true }]
            }], toggleButton: [{
                type: ViewChild,
                args: ['toggleButton', { static: true }]
            }], containerWrapper: [{
                type: ViewChild,
                args: ['containerWrapper', { static: true }]
            }], doneButton: [{
                type: ViewChild,
                args: ['doneButton', { static: true }]
            }], cancelButton: [{
                type: ViewChild,
                args: ['cancelButton']
            }], overlayContainer: [{
                type: ViewChild,
                args: ['overlayContainer', { static: true }]
            }], overlayFooter: [{
                type: ViewChild,
                args: ['overlayFooter', { static: true }]
            }], label: [{
                type: ViewChild,
                args: ['label', { static: true }]
            }], multiselectList: [{
                type: ViewChild,
                args: [BentoMultiselectListComponent, { static: true }]
            }], _onFocusout: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

class BentoMultiselectOverlayModule extends ConsumerDataValidator {
}
BentoMultiselectOverlayModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectOverlayModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoMultiselectOverlayModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectOverlayModule, declarations: [BentoMultiselectOverlayComponent, BentoMultiselectListComponent], imports: [CommonModule,
        BentoListModule,
        BentoResetModule,
        FormsModule,
        BentoUtilsModule,
        BentoTranslateModule,
        A11yModule,
        BentoFocusMonitorModule,
        BentoCheckboxModule], exports: [BentoMultiselectOverlayComponent] });
BentoMultiselectOverlayModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectOverlayModule, imports: [[
            CommonModule,
            BentoListModule,
            BentoResetModule,
            FormsModule,
            BentoUtilsModule,
            BentoTranslateModule,
            A11yModule,
            BentoFocusMonitorModule,
            BentoCheckboxModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoMultiselectOverlayModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoListModule,
                        BentoResetModule,
                        FormsModule,
                        BentoUtilsModule,
                        BentoTranslateModule,
                        A11yModule,
                        BentoFocusMonitorModule,
                        BentoCheckboxModule
                    ],
                    declarations: [BentoMultiselectOverlayComponent, BentoMultiselectListComponent],
                    exports: [BentoMultiselectOverlayComponent]
                }]
        }] });

/* eslint-disable  @angular-eslint/directive-selector */
class BentoNgbDropdownAnimationDirective {
    constructor(r, dropdown, dropdownMenu, elementRef) {
        this.r = r;
        this.el = elementRef.nativeElement;
        // Override original dropdown open and close to support animations
        const dropdownOpen = dropdown.open;
        const dropdownClose = dropdown.close;
        dropdown.open = () => {
            clearTimeout(this.timeoutID);
            dropdownOpen.call(dropdown);
            this.r.removeClass(this.el, 'out');
            setTimeout(() => {
                this.r.addClass(this.el, 'in');
            });
        };
        dropdown.close = () => {
            // delay close so that there is enough time to perform transition
            const toggleEl = dropdown['_anchor'].nativeElement; // From Dropdown private API
            clearTimeout(this.timeoutID);
            this.r.removeClass(this.el, 'in');
            this.r.addClass(this.el, 'out');
            this.r.addClass(toggleEl, 'out');
            setTimeout(() => {
                this.r.removeClass(this.el, 'out');
                this.r.removeClass(toggleEl, 'out');
                this.timeoutID = dropdownClose.call(dropdown);
            }, 200);
        };
    }
    ngOnInit() { }
}
BentoNgbDropdownAnimationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAnimationDirective, deps: [{ token: i0.Renderer2 }, { token: forwardRef(() => NgbDropdown) }, { token: forwardRef(() => NgbDropdownMenu) }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoNgbDropdownAnimationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAnimationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngbDropdownMenu], bento-megamenu'
                }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }, { type: i1$1.NgbDropdownMenu, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdownMenu)]
                    }] }, { type: i0.ElementRef }];
    } });

class BentoNgbDropdownAnimationModule extends ConsumerDataValidator {
}
BentoNgbDropdownAnimationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAnimationModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoNgbDropdownAnimationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAnimationModule, declarations: [BentoNgbDropdownAnimationDirective], imports: [CommonModule], exports: [BentoNgbDropdownAnimationDirective] });
BentoNgbDropdownAnimationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAnimationModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbDropdownAnimationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoNgbDropdownAnimationDirective],
                    imports: [CommonModule],
                    exports: [BentoNgbDropdownAnimationDirective],
                    providers: []
                }]
        }] });

class BentoNgbPopoverAnimationDirective {
    constructor(popover, elementRef, windowRef, r) {
        this.popover = popover;
        this.shownSubscription = Subscription.EMPTY;
        this.shownSubscription = popover.shown.subscribe(() => {
            setTimeout(() => {
                // We need to use attrubite instead of CSS class since the windowRef uses host[class] bindings
                r.setAttribute(popover['_windowRef'].location.nativeElement, `in`, 'true');
            });
        });
        /*
        Re-wire close to support fadeout for the popover window
        */
        this.close = popover.close;
        popover.close = () => {
            const popoverWindowRef = popover['_windowRef'];
            if (popoverWindowRef) {
                // Only perform close when popover windowRef exists
                r.removeAttribute(popoverWindowRef.location.nativeElement, `in`);
                setTimeout(() => {
                    this.close.call(popover);
                }, 200);
            }
        };
    }
    ngOnInit() { }
    ngOnDestroy() {
        // Called once, before the instance is destroyed.
        // Add 'implements OnDestroy' to the class.
        this.shownSubscription.unsubscribe();
        this.popover.close = () => { };
        this.close.call(this.popover);
    }
}
BentoNgbPopoverAnimationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbPopoverAnimationDirective, deps: [{ token: forwardRef(() => NgbPopover) }, { token: i0.ElementRef }, { token: WindowRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
BentoNgbPopoverAnimationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoNgbPopoverAnimationDirective, selector: "[ngbPopover]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbPopoverAnimationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngbPopover]'
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbPopover)]
                    }] }, { type: i0.ElementRef }, { type: WindowRef }, { type: i0.Renderer2 }];
    } });

class BentoNgbPopoverAnimationModule extends ConsumerDataValidator {
    constructor(popoverConfig) {
        super();
        popoverConfig.animation = false;
    }
}
BentoNgbPopoverAnimationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbPopoverAnimationModule, deps: [{ token: i1$1.NgbPopoverConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoNgbPopoverAnimationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbPopoverAnimationModule, declarations: [BentoNgbPopoverAnimationDirective], imports: [CommonModule], exports: [BentoNgbPopoverAnimationDirective] });
BentoNgbPopoverAnimationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbPopoverAnimationModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgbPopoverAnimationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoNgbPopoverAnimationDirective],
                    imports: [CommonModule],
                    exports: [BentoNgbPopoverAnimationDirective],
                    providers: []
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbPopoverConfig }]; } });

/**
 * This is a custom number input component with up and down keys and keyboard control.
 * It supports localization when combined with either [Translate](#/components/translate)
 * or [Angular i18n](https://angular.io/docs/ts/latest/cookbook/i18n.html).
 *
 * TODO: make sure this i18n info is relevant
 */
class BentoNumberInputComponent {
    constructor(elementRef, windowRef, uidGen, r, changeDetector, focusMonitor) {
        this.r = r;
        this.changeDetector = changeDetector;
        this.focusMonitor = focusMonitor;
        /**
         * Decimal Separator
         */
        this.decimalSeparator = '.';
        /**
         * Increment step for both arrow keys and buttons
         */
        this.step = 1;
        /**
         * Maximum value allowed
         */
        this.max = Number.POSITIVE_INFINITY;
        /**
         * Minimum value allowed
         */
        this.min = Number.NEGATIVE_INFINITY;
        /**
         * Flag to determine if the current input is pasted
         */
        this.isPasted = false;
        /**
         * Flag to determine if this component is disabled
         * @
         */
        this._isDisabled = false;
        /**
         * Input field aria-live setting
         */
        this._ariaLivePolitenessSetting = 'off';
        /**
         * Variable that implements the BentoTranslatable
         */
        this.customTranslation = {};
        this.el = elementRef.nativeElement;
        /* istanbul ignore next */
        this._onChange = (_) => { };
        /* istanbul ignore next */
        this._onTouch = () => { };
        this.uid = uidGen.generate();
        this.document = windowRef.nativeDocument;
        // No longer bubbles focus, focus bubbling resulted in multiple elements displaying focus
        this.focusMonitor.monitor(this.el, false);
    }
    /**
     * ID of this element
     */
    set _id(v) {
        this.id = v;
        this.setupAria();
    }
    /**
     * Used to update ngModel flag `touched`
     */
    onHostFocusout(e) {
        setTimeout(() => {
            if (!this.el.contains(this.document.activeElement)) {
                this._onTouch();
            }
        });
    }
    /**
     * ControlValueAccessor interface function
     */
    setDisabledState(isDisabled) {
        this._isDisabled = isDisabled;
        this.changeDetector.markForCheck();
    }
    ngOnInit() {
        this.setupAria();
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.el);
        this.changeDetector.detach();
    }
    ngAfterViewInit() {
        const buttonDownID = 'button-down-' + this.uid;
        const buttonUpID = 'button-up-' + this.uid;
        this.r.setAttribute(this.buttonDownRef.nativeElement, 'id', buttonDownID);
        this.r.setAttribute(this.buttonUpRef.nativeElement, 'id', buttonUpID);
    }
    /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     * * BENTO_UI_NUMBER_INPUT_INCREASE: 'Increase Number'
     * * BENTO_UI_NUMBER_INPUT_DECREASE: 'Decrease Number'
     */
    setTranslation(customTranslation) {
        this.customTranslation = customTranslation;
        this.changeDetector.detectChanges();
    }
    /**
     * ControlValueAccessor interface function
     */
    writeValue(v) {
        this.value = Number(v);
        this.inputBuffer = this.value.toString();
        if (isNaN(this.value) || // v is not a number
            (!v && v !== 0) || // v is either `undefined` or `null`
            (typeof v === 'string' && v.trim().length === 0) // v is an empty string
        ) {
            // Invalid dev input
            this.value = null;
            this._stringValue = '';
        }
        else {
            // Valid dev input
            this._stringValue = this._encode(this.value);
            this._onChange(this.value);
        }
    }
    /**
     * ControlValueAccessor interface function
     */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /**
     * ControlValueAccessor interface function
     */
    registerOnTouched(fn) {
        this._onTouch = () => {
            fn();
            this.changeDetector.markForCheck();
        };
    }
    /**
     * FormControl Validator implementation
     */
    validate(formControl) {
        // Value to be validated
        const value = formControl.value;
        const validator = {};
        let isValid = true;
        if (typeof value === 'undefined' || value === null) {
            // NaN
            validator.isNaN = true;
            isValid = false;
        }
        else {
            // All other invalid inputs
            if (value > this.max) {
                // Out of boundary with the max number
                validator.max = { outOfBoundary: true, actualLength: value, requiredLength: this.max };
                isValid = false;
            }
            if (value < this.min) {
                // Out of boundary with teh min number
                validator.min = { outOfBoundary: true, actualLength: value, requiredLength: this.min };
                isValid = false;
            }
        }
        return isValid ? null : validator;
    }
    /**
     * Catch input event on the input for value validation
     */
    _onInput(e) {
        this._validateAndSetValue(this._decode(e.currentTarget.value));
    }
    /**
     * Keydown callback on the input
     */
    _onKeydown(e) {
        if (e.keyCode === Keyboard.UP) {
            // Key UP
            this._setValue(this._updateValueWithStep(this.value, this.step));
            e.preventDefault();
            e.stopPropagation();
        }
        else if (e.keyCode === Keyboard.DOWN) {
            // Key DOWN
            this._setValue(this._updateValueWithStep(this.value, -this.step));
            e.preventDefault();
            e.stopPropagation();
        }
        else if (e.keyCode === Keyboard.SPACE) {
            // Ignore space character
            e.preventDefault();
            e.stopPropagation();
        }
    }
    /**
     * Keypress callback on the input
     *
     */
    _onKeypress(e) {
        const char = String.fromCharCode(e.charCode);
        if (!(char === '-' && (!this.inputBuffer || this.inputBuffer.length === 1) && this.min < 0)) {
            if (
            // eslint-disable-next-line  max-len
            (isNaN(Number(char)) &&
                e.charCode > 0 &&
                char !== '-' &&
                char !== this.decimalSeparator &&
                e.charCode !== 13) || // Enter key on chrome
                (char === '-' && e.currentTarget.selectionStart > 0)) {
                // Prevent non-number input keypress
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
    /**
     * Keydown listener
     */
    _onArrowKeydown(e, direction) {
        if (e.keyCode === Keyboard.ENTER || e.keyCode === Keyboard.SPACE) {
            this._setValue(this._updateValueWithStep(this.value, direction));
        }
    }
    /**
     * Mouse/Touch down callback on the up and down arrow buttons
     */
    _onArrowPointerDown(e, direction) {
        let step = this.step * direction;
        const self = this;
        let delay = 1000;
        const slowInterval = 100;
        const fastInterval = 30;
        const speedUpCountThreshhold = 30;
        const speedJumpCountThreshhold = 180;
        let count = 0; // Tick counter
        let timeoutID;
        let unlistenWindowMouseUp = () => { };
        let unlistenWindowTouchEnd = () => { };
        if (e.type === 'mousedown') {
            const mouseEvent = e;
            if (mouseEvent.button !== 0) {
                // Let the mouse down only takes the main click button
                return;
            }
            unlistenWindowMouseUp = this.r.listen('window', 'mouseup', onArrowPointerUp.bind(this));
        }
        else if (e.type === 'touchstart') {
            unlistenWindowTouchEnd = this.r.listen('window', 'touchend', onArrowPointerUp.bind(this));
        }
        // Call  function to start the tick
        updateValue();
        /**
         * Update the current value with step and direction
         */
        function updateValue() {
            self._setValue(self._updateValueWithStep(self.value, step));
            // Set timeout for the next tick
            timeoutID = setTimeout(updateValue, delay);
            // Tick counter
            count++;
            if (count === 1) {
                delay = slowInterval;
            }
            else if (count === speedUpCountThreshhold) {
                delay = fastInterval;
            }
            else if (count === speedJumpCountThreshhold) {
                step *= 10;
            }
        }
        /**
         * Mouse/Touch up callback on the window to terminate auto increment
         */
        function onArrowPointerUp() {
            clearTimeout(timeoutID);
            unlistenWindowMouseUp();
            unlistenWindowTouchEnd();
        }
    }
    /**
     * On up/down arrows focus
     */
    _onArrowFocus() {
        this._ariaLivePolitenessSetting = 'polite';
    }
    /**
     * On up/down arrows blur
     */
    _onArrowBlur() {
        this._ariaLivePolitenessSetting = 'off';
    }
    /**
     * Catch paste event on the input
     */
    _onPaste(e) {
        this.isPasted = true;
    }
    /**
     * Update main ngModel value with a given number
     */
    _updateValueWithStep(val, step) {
        let value = typeof val === 'undefined' ? 0 : val;
        // Since JS doesn't do additions precisely, float is needed
        value = Math.round((Number(value) + step) * 1000000000000) / 1000000000000;
        if (value > this.max) {
            value = this.max;
        }
        else if (value < this.min) {
            value = this.min;
        }
        return value;
    }
    /**
     * _encode a number to string with appropriate decimal separator
     */
    _encode(val) {
        // when val is UNDEFINED or NULL
        if (val == null) {
            return '';
        }
        // Handle user who is typing a negative sign then a zero for a negative decimal value
        let addNegativeSign = false;
        if (val === 0 && 1 / val < 0) {
            addNegativeSign = true;
        }
        const sVal = String(val);
        let returnVal = sVal.replace('.', this.decimalSeparator);
        if (addNegativeSign && returnVal.substring(0, 1) != '-') {
            returnVal = '-' + returnVal;
        }
        return returnVal;
    }
    /**
     * _decode a string back into a number
     */
    _decode(val) {
        // when number is UNDEFINED or NULL
        if (!val) {
            return null;
        }
        // Handle user who is typing a negative sign then a zero for a negative decimal value
        let addNegativeSign = false;
        if (val.toString() === '-0') {
            addNegativeSign = true;
        }
        let returnVal = val.replace(this.decimalSeparator, '.');
        if (addNegativeSign && returnVal.substring(0, 1) != '-') {
            returnVal = '-' + returnVal;
        }
        return returnVal;
    }
    /**
     * Set input field value
     */
    set _stringValue(val) {
        this.inputElRef.nativeElement.value = val;
    }
    /**
     * Set value and propagate changes to NgModel without validations
     * FAST
     */
    _setValue(val) {
        this._previousValue = this.value = val;
        this._stringValue = !val && val !== 0 ? '' : this._encode(val);
        // update changes to the ngModel for parent controls
        this._onChange(val);
    }
    /**
     * Validate and set value then propagate changes to NgModel
     */
    _validateAndSetValue(inputVal) {
        this.inputBuffer = inputVal;
        if (inputVal === '-' && this.min < 0) {
            return;
        }
        // No need to update the ngModel since there is no change in string
        if (Number(inputVal) === this._previousValue &&
            // Number('') results to 0 and it
            !(inputVal === '' && this._previousValue === 0)) {
            return;
        }
        this.isPasted = false;
        // Proceed with number validation
        const newValObj = this._validateValue(inputVal);
        if (typeof newValObj.numberString === 'undefined' || newValObj.numberString === null) {
            // There is a case where the returned value is undefined <string>
            // need to handle this special case from `_validateValue` and reset the input field
            this._setValue(null);
            return;
        }
        const newVal = newValObj.numberString === this.decimalSeparator || newValObj.numberString === null
            ? null
            : Number(newValObj.numberString);
        const input = this.inputElRef.nativeElement;
        const caratPos = newValObj.isRollback ? input.selectionStart - 1 : input.selectionStart;
        this._setValue(newVal);
        // make sure to bring the selection back after setting the value after rendering
        input.setSelectionRange(caratPos, caratPos);
    }
    /**
     * Validate the current value and make corrections
     */
    _validateValue(stringVal) {
        const vNum = Number(stringVal);
        const max = this.max;
        const min = this.min;
        const maxDigits = this.max !== Number.POSITIVE_INFINITY ? String(this.max).length : 20;
        const minDigits = this.min !== Number.NEGATIVE_INFINITY ? String(this.min).length : 21;
        const valueLength = stringVal ? stringVal.length : 0;
        let isRollback = false;
        let newNum = stringVal;
        if (stringVal == null || valueLength === 0) {
            newNum = null;
        }
        else if (stringVal === '-' && this.inputBuffer.length === 1 && this.min < 0) {
            newNum = stringVal;
        }
        else if (isNaN(vNum) || vNum > max || vNum < min) {
            if (this.isPasted) {
                // we need to do concat the value
                newNum = vNum > max ? stringVal.slice(0, maxDigits) : stringVal.slice(0, minDigits);
            }
            else if ((vNum > max && ((valueLength >= maxDigits && max >= 0) || valueLength >= minDigits)) ||
                (vNum < min && ((valueLength >= minDigits && min < 0) || valueLength >= maxDigits)) ||
                (min < 0 && max < 0 && vNum >= 0)) {
                // Rollback when out of bound
                newNum = !this._previousValue && this._previousValue !== 0 ? null : String(this._previousValue);
                isRollback = true;
            }
        }
        else if (stringVal.indexOf('-') === 0 || stringVal.indexOf('.') > -1) {
            if (min >= 0 && max >= 0 && stringVal.indexOf('-') > -1) {
                // Minus sign is used when max and min are all positive
                newNum = !this._previousValue && this._previousValue !== 0 ? null : String(this._previousValue);
                isRollback = true;
            }
            else if (vNum < this.min || vNum > this.max) {
                newNum = !this._previousValue && this._previousValue !== 0 ? null : String(this._previousValue);
                isRollback = true;
            }
            else {
                // OK to add both minus sign and default decimal separator
                newNum = stringVal.trim();
            }
        }
        return { numberString: newNum, isRollback };
    }
    /**
     * Setup aria values
     */
    setupAria() {
        let ariaAttribute = this.el.getAttribute('aria-label');
        this.ariaLabel = ariaAttribute ? ariaAttribute : this.ariaLabel;
        ariaAttribute = this.el.getAttribute('aria-describedby');
        this.ariaDescribedby = ariaAttribute ? ariaAttribute : this.ariaDescribedby;
        ariaAttribute = this.el.getAttribute('aria-labelledby');
        this.ariaLabelledby = ariaAttribute ? ariaAttribute : this.ariaLabelledby;
        if (!(typeof this.id === 'string' && this.id.length)) {
            this.id = 'bui-input-' + this.uid;
        }
        else {
            this.r.removeAttribute(this.el, 'id');
        }
        if (this.ariaLabel && this.ariaLabel.length) {
            // Move aria-label
            this.r.removeAttribute(this.el, 'aria-label');
        }
        if (this.ariaDescribedby && this.ariaDescribedby.length) {
            // Move aria-describedby
            this.r.removeAttribute(this.el, 'aria-describedby');
        }
        this._inputID = this.id;
        this.changeDetector.markForCheck();
    }
}
BentoNumberInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNumberInputComponent, deps: [{ token: i0.ElementRef }, { token: WindowRef }, { token: BentoUidService }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i3.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component });
BentoNumberInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoNumberInputComponent, selector: "bento-number-input", inputs: { decimalSeparator: "decimalSeparator", step: "step", max: "max", min: "min", _id: ["id", "_id"] }, host: { listeners: { "focusout": "onHostFocusout($event)" } }, providers: [
        // Access ngModel
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BentoNumberInputComponent), multi: true },
        // Activate Validator
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => BentoNumberInputComponent), multi: true },
        // UID Generator
        BentoUidService
    ], viewQueries: [{ propertyName: "inputElRef", first: true, predicate: ["input"], descendants: true, static: true }, { propertyName: "buttonUpRef", first: true, predicate: ["buttonUp"], descendants: true, static: true }, { propertyName: "buttonDownRef", first: true, predicate: ["buttonDown"], descendants: true, static: true }], ngImport: i0, template: "<input\n  #input\n  class=\"form-control bui-menu-item\"\n  type=\"text\"\n  (input)=\"_onInput($event)\"\n  (keydown)=\"_onKeydown($event)\"\n  (keypress)=\"_onKeypress($event)\"\n  (paste)=\"_onPaste($event)\"\n  [disabled]=\"_isDisabled\"\n  [attr.id]=\"_inputID\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n  [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n/>\n<button\n  #buttonDown\n  cdkMonitorElementFocus\n  class=\"bento-number-input-button bento-number-input-button-down\"\n  type=\"button\"\n  (mousedown)=\"_onArrowPointerDown($event, -1)\"\n  (touchstart)=\"_onArrowPointerDown($event, -1)\"\n  (keydown)=\"_onArrowKeydown($event, -1)\"\n  (focus)=\"_onArrowFocus()\"\n  (blur)=\"_onArrowBlur()\"\n  [disabled]=\"_isDisabled || value === min\"\n  [attr.aria-controls]=\"_inputID\"\n  [attr.aria-label]=\"\n    'BENTO_UI_NUMBER_INPUT_DECREASE' | bentoTranslate: customTranslation['BENTO_UI_NUMBER_INPUT_DECREASE']\n  \"\n>\n  <i class=\"bento-icon-chevron-down\" aria-hidden=\"true\"></i>\n</button>\n<button\n  #buttonUp\n  cdkMonitorElementFocus\n  class=\"bento-number-input-button bento-number-input-button-up\"\n  type=\"button\"\n  (mousedown)=\"_onArrowPointerDown($event, 1)\"\n  (touchstart)=\"_onArrowPointerDown($event, 1)\"\n  (keydown)=\"_onArrowKeydown($event, 1)\"\n  (focus)=\"_onArrowFocus()\"\n  (blur)=\"_onArrowBlur()\"\n  [disabled]=\"_isDisabled || value === max\"\n  [attr.aria-controls]=\"_inputID\"\n  [attr.aria-label]=\"\n    'BENTO_UI_NUMBER_INPUT_INCREASE' | bentoTranslate: customTranslation['BENTO_UI_NUMBER_INPUT_INCREASE']\n  \"\n>\n  <i class=\"bento-icon-chevron-up\" aria-hidden=\"true\"></i>\n</button>\n<span class=\"sr-only\" [attr.aria-live]=\"_ariaLivePolitenessSetting\">{{ this.value }}</span>\n", styles: [".ng-bento bento-number-input{display:flex;position:relative;vertical-align:middle;width:100%}.ng-bento bento-number-input input:disabled~.bento-number-input-button{pointer-events:none}.ng-bento bento-number-input>input.form-control{border-radius:0}[dir=rtl] .ng-bento bento-number-input>input.form-control{padding-right:11.9px}.ng-bento bento-number-input input[type=number]{-moz-appearance:textfield}.ng-bento bento-number-input input::-webkit-outer-spin-button,.ng-bento bento-number-input input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.ng-bento bento-number-input.input-group{flex-wrap:nowrap}.ng-bento bento-number-input.input-group input.form-control{flex:1 1 100%}.ng-bento bento-number-input.full-width{width:100%}.ng-bento bento-number-input.input-lg{padding:0}.ng-bento bento-number-input.input-lg .form-control{height:50px}[dir=rtl] .ng-bento bento-number-input.input-lg .bento-number-input-button.bento-number-input-button-down{right:auto}.ng-bento bento-number-input.input-sm{padding:0}[dir=rtl] .ng-bento bento-number-input.input-sm .bento-number-input-button.bento-number-input-button-down{right:auto}.ng-bento bento-number-input .bento-number-input-button{transition:border-color .2s}.ng-bento bento-number-input .bento-number-input-button.bento-number-input-button-up{border-radius:0}.ng-bento bento-number-input .bento-number-input-button.bento-number-input-button-down{border-radius:0}.ng-bento bento-number-input .form-inline .bento-number-input-wrapper{display:inline-block}.ng-bento bento-number-input .bento-number-input-button{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;align-items:center;border-width:1px;border-style:solid;display:flex;font-size:18px;justify-content:center;padding:0;text-align:center}[dir=rtl] .ng-bento bento-number-input .bento-number-input-button{right:auto;left:0}.ng-bento bento-number-input .bento-number-input-button i{top:0;vertical-align:baseline}[dir=rtl] .ng-bento bento-number-input .bento-number-input-button.bento-number-input-button-down{right:auto}\n"], directives: [{ type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNumberInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-number-input', providers: [
                        // Access ngModel
                        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BentoNumberInputComponent), multi: true },
                        // Activate Validator
                        { provide: NG_VALIDATORS, useExisting: forwardRef(() => BentoNumberInputComponent), multi: true },
                        // UID Generator
                        BentoUidService
                    ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<input\n  #input\n  class=\"form-control bui-menu-item\"\n  type=\"text\"\n  (input)=\"_onInput($event)\"\n  (keydown)=\"_onKeydown($event)\"\n  (keypress)=\"_onKeypress($event)\"\n  (paste)=\"_onPaste($event)\"\n  [disabled]=\"_isDisabled\"\n  [attr.id]=\"_inputID\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n  [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n/>\n<button\n  #buttonDown\n  cdkMonitorElementFocus\n  class=\"bento-number-input-button bento-number-input-button-down\"\n  type=\"button\"\n  (mousedown)=\"_onArrowPointerDown($event, -1)\"\n  (touchstart)=\"_onArrowPointerDown($event, -1)\"\n  (keydown)=\"_onArrowKeydown($event, -1)\"\n  (focus)=\"_onArrowFocus()\"\n  (blur)=\"_onArrowBlur()\"\n  [disabled]=\"_isDisabled || value === min\"\n  [attr.aria-controls]=\"_inputID\"\n  [attr.aria-label]=\"\n    'BENTO_UI_NUMBER_INPUT_DECREASE' | bentoTranslate: customTranslation['BENTO_UI_NUMBER_INPUT_DECREASE']\n  \"\n>\n  <i class=\"bento-icon-chevron-down\" aria-hidden=\"true\"></i>\n</button>\n<button\n  #buttonUp\n  cdkMonitorElementFocus\n  class=\"bento-number-input-button bento-number-input-button-up\"\n  type=\"button\"\n  (mousedown)=\"_onArrowPointerDown($event, 1)\"\n  (touchstart)=\"_onArrowPointerDown($event, 1)\"\n  (keydown)=\"_onArrowKeydown($event, 1)\"\n  (focus)=\"_onArrowFocus()\"\n  (blur)=\"_onArrowBlur()\"\n  [disabled]=\"_isDisabled || value === max\"\n  [attr.aria-controls]=\"_inputID\"\n  [attr.aria-label]=\"\n    'BENTO_UI_NUMBER_INPUT_INCREASE' | bentoTranslate: customTranslation['BENTO_UI_NUMBER_INPUT_INCREASE']\n  \"\n>\n  <i class=\"bento-icon-chevron-up\" aria-hidden=\"true\"></i>\n</button>\n<span class=\"sr-only\" [attr.aria-live]=\"_ariaLivePolitenessSetting\">{{ this.value }}</span>\n", styles: [".ng-bento bento-number-input{display:flex;position:relative;vertical-align:middle;width:100%}.ng-bento bento-number-input input:disabled~.bento-number-input-button{pointer-events:none}.ng-bento bento-number-input>input.form-control{border-radius:0}[dir=rtl] .ng-bento bento-number-input>input.form-control{padding-right:11.9px}.ng-bento bento-number-input input[type=number]{-moz-appearance:textfield}.ng-bento bento-number-input input::-webkit-outer-spin-button,.ng-bento bento-number-input input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.ng-bento bento-number-input.input-group{flex-wrap:nowrap}.ng-bento bento-number-input.input-group input.form-control{flex:1 1 100%}.ng-bento bento-number-input.full-width{width:100%}.ng-bento bento-number-input.input-lg{padding:0}.ng-bento bento-number-input.input-lg .form-control{height:50px}[dir=rtl] .ng-bento bento-number-input.input-lg .bento-number-input-button.bento-number-input-button-down{right:auto}.ng-bento bento-number-input.input-sm{padding:0}[dir=rtl] .ng-bento bento-number-input.input-sm .bento-number-input-button.bento-number-input-button-down{right:auto}.ng-bento bento-number-input .bento-number-input-button{transition:border-color .2s}.ng-bento bento-number-input .bento-number-input-button.bento-number-input-button-up{border-radius:0}.ng-bento bento-number-input .bento-number-input-button.bento-number-input-button-down{border-radius:0}.ng-bento bento-number-input .form-inline .bento-number-input-wrapper{display:inline-block}.ng-bento bento-number-input .bento-number-input-button{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;align-items:center;border-width:1px;border-style:solid;display:flex;font-size:18px;justify-content:center;padding:0;text-align:center}[dir=rtl] .ng-bento bento-number-input .bento-number-input-button{right:auto;left:0}.ng-bento bento-number-input .bento-number-input-button i{top:0;vertical-align:baseline}[dir=rtl] .ng-bento bento-number-input .bento-number-input-button.bento-number-input-button-down{right:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: WindowRef }, { type: BentoUidService }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i3.FocusMonitor }]; }, propDecorators: { inputElRef: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], decimalSeparator: [{
                type: Input
            }], step: [{
                type: Input
            }], max: [{
                type: Input
            }], min: [{
                type: Input
            }], _id: [{
                type: Input,
                args: ['id']
            }], buttonUpRef: [{
                type: ViewChild,
                args: ['buttonUp', { static: true }]
            }], buttonDownRef: [{
                type: ViewChild,
                args: ['buttonDown', { static: true }]
            }], onHostFocusout: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

class BentoNumberInputModule extends ConsumerDataValidator {
}
BentoNumberInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNumberInputModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoNumberInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNumberInputModule, declarations: [BentoNumberInputComponent], imports: [CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, A11yModule], exports: [BentoNumberInputComponent] });
BentoNumberInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNumberInputModule, imports: [[CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, A11yModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNumberInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, A11yModule],
                    declarations: [BentoNumberInputComponent],
                    exports: [BentoNumberInputComponent]
                }]
        }] });

var Side;
(function (Side) {
    Side[Side["Left"] = 0] = "Left";
    Side[Side["Right"] = 1] = "Right";
})(Side || (Side = {}));
const DEFAULT_PANEL_WIDTH = 340;
/**
 * This component acts as a page template. It can be broadly used by HTML5/CSS3 compatible browsers.
 * It is responsive to different sizes of viewports and behaves differently based on window width.
 * In order to experience its responsive behavior on desktop, slowly drag the right side of your
 * browser window to narrow the viewport. Observe how the side menu and toolbar buttons react.
 * These alternate manifestations will be the default on mobile devices.
 *
 * TODO: the above statements are true of Bento 1.x, but not yet Bento NG.
 * RWD is currently not in place.
 * Also, "Tasks" button is not properly offset to appear centered.
 */
class BentoOffCanvasMenuComponent {
    constructor(cd, tabService, r, platform, notification, dir, winRef, elRef) {
        this.cd = cd;
        this.tabService = tabService;
        this.r = r;
        this.platform = platform;
        this.winRef = winRef;
        this.elRef = elRef;
        /**
         * Defines how side nav behaves when it shows
         * * `'over'` Side nav comes in and overlaps the content
         * * `'push'` Side nav comes in and pushes the content to the other side without resizing
         * * `'side'` Side nav comes in and resize the main content so that both contents are visible
         */
        this.mode = 'push';
        /**
         * Emits when `isOpen` is changed
         */
        this.isOpenChange = new EventEmitter(true);
        /**
         * Flag to determine if the overlay is hidden when a side panel is out
         */
        this.hideOverlay = false;
        /**
         * Flag to determine if the right panel header and close button should be shown
         */
        this.showRightPanelHeader = false;
        /**
         * Emits when `rightIsOpen` is changed
         */
        this.rightIsOpenChange = new EventEmitter(true);
        /**
         * Hide/Show Hamburger menu button
         */
        this.menuButtonIsHidden = false;
        // Private but used by the template
        this._isAsideHidden = true;
        this._isRightAsideHidden = true;
        /**
         * Flag to determine if this component is responsive to window size
         */
        this.responsive = false;
        // Add state classes depending on opening direction
        this._isOpen = false;
        this._rightIsOpen = false;
        this._isPushOver = true;
        this._alwaysOpen = false;
        /**
         * [Private variables]
         */
        this._animationDuration = 200;
        this.dirChangeSubscription = Subscription.EMPTY;
        this.resizeSubscription = Subscription.EMPTY;
        this.windowScrollSubscription = Subscription.EMPTY;
        this.leftPanelWidth = DEFAULT_PANEL_WIDTH;
        this.rightPanelWidth = DEFAULT_PANEL_WIDTH;
        this.document = winRef.nativeDocument;
        this.dirChangeSubscription = dir.change.subscribe(() => {
            this._isRTL = dir.value === 'rtl';
        });
        this.resizeSubscription = notification.resizeNotification.subscribe(this.onWindowResize.bind(this));
        if (platform.isBrowser) {
            this.windowScrollSubscription = fromEvent(winRef.nativeWindow, 'scroll', { capture: true })
                .pipe(filter(() => this.tooltips.length > 0))
                .subscribe(this.onWindowScroll.bind(this));
        }
        this.el = this.elRef.nativeElement;
        // disable all transition during init
        this.r.addClass(this.el, 'bento-off-canvas-menu-rendering');
        this.leftPanelWrapperRef;
        this.rightPanelWrapperRef;
    }
    /**
     * Flag to determine open/close state of the left panel
     */
    set isOpen(value) {
        if (value == null) {
            // Skip when `isOpen` is not defined
            return;
        }
        if (this._alwaysOpen && !value) {
            // alwaysOpen will ignore all program instructions
            // Revert value for parent component
            this.isOpenChange.emit(this._isOpen);
            return;
        }
        this._isOpen = value;
        this._togglePanel(Side.Left);
        this.isOpenChange.emit(value);
        if (this._rightIsOpen && value && !this.hideOverlay) {
            // Close the opposite side
            this.rightIsOpen = false;
        }
        this.setContentPanelLocation();
    }
    /**
     * Flag to determine open/close state of the right panel
     */
    set rightIsOpen(value) {
        this._rightIsOpen = value;
        this._togglePanel(Side.Right);
        this.rightIsOpenChange.emit(value);
        if (this._isOpen && value && !this.hideOverlay) {
            // Close the opposite side
            this.isOpen = false;
        }
        this.setContentPanelLocation();
        setTimeout(() => {
            this.checkScrollbar();
        });
    }
    checkScrollbar() {
        const el = this.rightPanelWrapperRef.nativeElement;
        if (el.scrollHeight > el.clientHeight) {
            el.classList.add('bento-is-scrollable');
        }
        else {
            el.classList.remove('bento-is-scrollable');
        }
    }
    /**
     * Specify the left panel width otherwise it will default to the theme specification
     */
    set leftPanelWidthPx(v) {
        this.leftPanelWidth = Math.abs(v || DEFAULT_PANEL_WIDTH);
        this.setLeftPanelSize(this.leftPanelWidth);
        this.setContentPanelLocation();
    }
    /**
     * Specify the right panel width otherwise it will default to the theme specification
     */
    set rightPanelWidthPx(v) {
        this.rightPanelWidth = Math.abs(v || DEFAULT_PANEL_WIDTH);
        this.setRightPanelSize(this.rightPanelWidth);
        this.setContentPanelLocation();
    }
    get notResponsive() {
        return !this.responsive;
    }
    /**
     * [Hostbindings]
     */
    // Adds default class to host element
    get setDefaultClass() {
        return true;
    }
    ngOnInit() {
        if (!this.responsive) {
            // Need to add this class before rendering
            this.r.addClass(this.el, 'not-responsive');
        }
        this.onWindowResize();
    }
    ngAfterViewInit() {
        this.setLeftPanelSize(this.leftPanelWidth);
        this.setRightPanelSize(this.rightPanelWidth);
        this.setContentPanelLocation();
        // restore all transition properties
        this.r.removeClass(this.el, 'bento-off-canvas-menu-rendering');
    }
    ngOnDestroy() {
        this.dirChangeSubscription.unsubscribe();
        this.resizeSubscription.unsubscribe();
        this.windowScrollSubscription.unsubscribe();
    }
    /**
     * Open left panel
     */
    _toggleLeft() {
        if (this.leftPanelRef) {
            this.isOpen = !this._isOpen;
        }
    }
    /**
     * [Toggle left(_isOpen) or right panel(_rightIsOpen)]
     */
    _togglePanel(side) {
        this.unsubscribeOverlayEvents();
        const isInitializing = this.el.classList.contains('bento-off-canvas-menu-rendering');
        if (this._isOpen && side === Side.Left) {
            // Clear timeout
            clearTimeout(this._menuTimer);
            // Show panel
            this._isAsideHidden = false;
            // Subscribe to escape and overlay click events
            this.subscribeOverlayEvents();
            // Select first focusable and tabbable element (close button)
            this._menuTimer = setTimeout(() => {
                if (this._alwaysOpen || this.hideOverlay) {
                    this.leftTrapFocus.enabled = false;
                }
                if (!isInitializing) {
                    // Only focus when this component is not initially rendering
                    this.focusFirstTabbableElement(this.leftPanelRef.nativeElement);
                }
                this.cd.markForCheck();
            }, this._animationDuration);
        }
        else if (!this._isOpen) {
            // Close panel, reset focus to original trigger
            this._menuTimer = setTimeout(() => {
                if (!this._alwaysOpen) {
                    this._isAsideHidden = true;
                    this.cd.markForCheck();
                }
            }, this._animationDuration);
        }
        if (this._rightIsOpen && side === Side.Right) {
            this.lastActiveElement = this.document.activeElement;
            // Clear timeout
            clearTimeout(this._rightMenuTimer);
            // Show panel
            this._isRightAsideHidden = false;
            // Subscribe to escape and overlay click events
            this.subscribeOverlayEvents();
            // Select first focusable and tabbable element
            this._rightMenuTimer = setTimeout(() => {
                if (this.hideOverlay) {
                    this.rightTrapFocus.enabled = false;
                }
                if (!isInitializing) {
                    // Only focus when this component is not initially rendering
                    this.focusFirstTabbableElement(this.rightPanelRef.nativeElement);
                }
                this.cd.markForCheck();
            }, this._animationDuration);
        }
        else if (!this._rightIsOpen) {
            // Close panel, reset focus to original trigger
            this._rightMenuTimer = setTimeout(() => {
                var _a;
                this._isRightAsideHidden = true;
                this.cd.markForCheck();
                (_a = this.lastActiveElement) === null || _a === void 0 ? void 0 : _a.focus();
                this.lastActiveElement = null;
            }, this._animationDuration);
        }
    }
    /**
     * [Unsubscribe from user interaction events for closing panel]
     */
    unsubscribeOverlayEvents() {
        // [Unsubscribe from window overlay click events]
        if (this._windowClickSubscription) {
            this._windowClickSubscription.unsubscribe();
        }
        // [Unsubscribe from escape key press events]
        if (this._windowESCSubscription) {
            this._windowESCSubscription.unsubscribe();
        }
    }
    /**
     * [Subscribe to user interaction events for closing panel]
     */
    subscribeOverlayEvents() {
        // [Subscribe to window overlay click events]
        this._windowClickSubscription = fromEvent(window, 'click')
            .pipe(filter((event) => event.target === this.overlay.nativeElement))
            .subscribe(() => {
            this.isOpen = false;
            this.rightIsOpen = false;
        });
        // [Subscribe to escape key press events]
        this._windowESCSubscription = fromEvent(window, 'keydown')
            .pipe(filter((e) => e.keyCode === Keyboard.ESC))
            .subscribe(() => {
            this.isOpen = false;
            this.rightIsOpen = false;
        });
    }
    /**
     * [Set focus on first focusable and tabbable element ]
     */
    focusFirstTabbableElement(panel) {
        var _a;
        const tabbables = this.tabService.findTabbable(panel);
        // Pass focus onto close button or first tabbable element, first and last are the focus trap anchors
        (_a = tabbables[0]) === null || _a === void 0 ? void 0 : _a.focus();
    }
    onWindowResize() {
        this.checkScrollbar();
        if (this.platform.isBrowser && this.responsive) {
            // Make sure that this is running in a browser
            const win = this.winRef.nativeWindow;
            const windowWidth = win.innerWidth;
            if (windowWidth > 1300) {
                if (!this._alwaysOpen) {
                    // set always open
                    this._alwaysOpen = true;
                    this.isOpen = true;
                }
            }
            else if (this._alwaysOpen) {
                this._alwaysOpen = false;
                this.isOpen = false;
                this.cd.markForCheck();
            }
        }
    }
    setLeftPanelSize(v) {
        this.setPanelSize('left', v);
    }
    setRightPanelSize(v) {
        this.setPanelSize('right', v);
    }
    /**
     * Set panel size based on its given side
     */
    setPanelSize(side, v) {
        const oppositeSide = side === 'right' ? 'left' : 'right';
        const panelRef = this[`${side}PanelRef`].nativeElement;
        const panelWrapperRef = this[`${side}PanelWrapperRef`].nativeElement;
        if (panelRef && v) {
            if (v > 0) {
                // Set manual size
                this.r.setAttribute(panelRef, 'style', `width:${v}px; ${this._isRTL ? oppositeSide : side}:-${v}px`);
                this.r.setAttribute(panelWrapperRef, 'style', `width:${v}px;`);
            }
            else {
                this.r.removeAttribute(panelRef, 'style');
                this.r.removeAttribute(panelWrapperRef, 'style');
            }
        }
    }
    /**
     * Set content panel location and offset based on current status
     */
    setContentPanelLocation() {
        var _a;
        if (this.content.nativeElement) {
            // Set content panel and overlay location when available
            let style = '';
            const left = this._isRTL ? 'right' : 'left';
            const right = this._isRTL ? 'left' : 'right';
            let offset;
            let margin;
            if (this._isOpen && this.leftPanelRef) {
                offset = this.mode == 'over' ? 0 : this.leftPanelWidth;
                margin = this.calcRightMargin(this.leftPanelWidth);
                style = `${left}:${offset}px; ${right}:${margin}px`;
            }
            else if (this._rightIsOpen && this.rightPanelRef) {
                offset = this.mode == 'over' ? 0 : this.rightPanelWidth;
                margin = this.calcLeftMargin(this.rightPanelWidth);
                style = `${right}:${offset}px; ${left}:${margin}px`;
            }
            if (!margin && !offset) {
                if (this.el.style.overflow) {
                    // Content is filling up the viewport
                    // No need to adjust overflow
                    setTimeout(() => {
                        this.r.removeStyle(this.el, 'overflow');
                    }, 200);
                }
            }
            else if (!this.hideOverlay) {
                this.r.setStyle(this.el, 'overflow', 'hidden');
            }
            this.r.setAttribute(this.content.nativeElement, 'style', style);
            this.r.setAttribute(this.overlay.nativeElement, 'style', style);
            if ((_a = this.topbar) === null || _a === void 0 ? void 0 : _a.nativeElement) {
                this.r.setAttribute(this.topbar.nativeElement, 'style', style);
            }
        }
    }
    /**
     * Calculate right margin for the main content based on current open/close condition
     */
    calcRightMargin(panelWidth) {
        if (this.mode === 'side' || this._alwaysOpen) {
            if (this.rightPanelRef && this._rightIsOpen) {
                return this.rightPanelRef.nativeElement.offsetWidth;
            }
            return 0;
        }
        if (this.mode === 'push') {
            return -panelWidth;
        }
        return 0;
    }
    /**
     * Calculate left margin for the main content based on current open/close condition
     */
    calcLeftMargin(panelWidth) {
        if (this.mode === 'side' || this._alwaysOpen) {
            if (this.leftPanelRef && (this._isOpen || this._alwaysOpen)) {
                return this.leftPanelRef.nativeElement.offsetWidth;
            }
            return 0;
        }
        if (this.mode === 'push') {
            return -panelWidth;
        }
        return 0;
    }
    /**
     * Listener to handle window scroll
     */
    onWindowScroll(e) {
        // When tooltip is set to append to body scrolling breaks
        // Adding this empty callback seems to resolve this issue
        const tooltips = this.tooltips.toArray();
        tooltips.forEach((tooltip) => {
            tooltip.close();
        });
    }
}
BentoOffCanvasMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoOffCanvasMenuComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: BentoTabService }, { token: i0.Renderer2 }, { token: i3$1.Platform }, { token: BentoNotification }, { token: i2.Directionality }, { token: WindowRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoOffCanvasMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoOffCanvasMenuComponent, selector: "bento-off-canvas-menu", inputs: { isOpen: "isOpen", mode: "mode", hideOverlay: "hideOverlay", showRightPanelHeader: "showRightPanelHeader", rightIsOpen: "rightIsOpen", menuTitle: "menuTitle", rightMenuTitle: "rightMenuTitle", leftPanelWidthPx: "leftPanelWidthPx", rightPanelWidthPx: "rightPanelWidthPx", menuButtonIsHidden: "menuButtonIsHidden", responsive: "responsive" }, outputs: { isOpenChange: "isOpenChange", rightIsOpenChange: "rightIsOpenChange" }, host: { properties: { "class.bento-off-canvas-menu-hide-overlay": "this.hideOverlay", "class.not-responsive": "this.notResponsive", "class.bento-off-canvas-menu": "this.setDefaultClass", "class.open": "this._isOpen", "class.open-right": "this._rightIsOpen", "class.push-over": "this._isPushOver", "class.always-open": "this._alwaysOpen" } }, viewQueries: [{ propertyName: "overlay", first: true, predicate: ["overlay"], descendants: true, static: true }, { propertyName: "leftPanelRef", first: true, predicate: ["leftPanel"], descendants: true, static: true }, { propertyName: "rightPanelRef", first: true, predicate: ["rightPanel"], descendants: true, static: true }, { propertyName: "leftPanelWrapperRef", first: true, predicate: ["leftPanelWrapper"], descendants: true, static: true }, { propertyName: "rightPanelWrapperRef", first: true, predicate: ["rightPanelWrapper"], descendants: true, static: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true, static: true }, { propertyName: "topbar", first: true, predicate: ["topbar"], descendants: true, static: true }, { propertyName: "leftTrapFocus", first: true, predicate: ["leftPanelFocus"], descendants: true, read: CdkTrapFocus }, { propertyName: "rightTrapFocus", first: true, predicate: ["rightPanelFocus"], descendants: true, read: CdkTrapFocus }, { propertyName: "tooltips", predicate: NgbTooltip, descendants: true }], ngImport: i0, template: "<div #topbar class=\"bento-off-canvas-menu-topbar\" [ngClass]=\"menuButtonIsHidden ? 'menu-button-is-hidden ' : ''\">\n  <button\n    *ngIf=\"!menuButtonIsHidden\"\n    class=\"bento-off-canvas-menu-button\"\n    type=\"button\"\n    (click)=\"_toggleLeft()\"\n    [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON' | bentoTranslate\"\n    [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON' | bentoTranslate\"\n    container=\"body\"\n  >\n    <i class=\"bento-icon-hamburger-menu\" aria-hidden=\"true\"></i>\n  </button>\n  <ng-content select=\"[bento-off-canvas-menu-topbar]\"></ng-content>\n</div>\n<div #leftPanelWrapper class=\"bento-off-canvas-menu-aside-wrapper\">\n  <div #leftPanel role=\"region\" [attr.aria-expanded]=\"_isOpen\" tabindex=\"-1\" class=\"bento-off-canvas-menu-aside\">\n    <div #leftPanelFocus cdkTrapFocus [cdkTrapFocusAutoCapture]=\"!_alwaysOpen\" *ngIf=\"!_isAsideHidden\">\n      <!-- cdkFocusInitial -->\n      <div class=\"bento-off-canvas-menu-header\">\n        <h2 #leftPanelTitle class=\"h5 bento-off-canvas-menu-header-title\">\n          {{ 'BENTO_UI_OFF_CANVAS_MENU_ASIDE_TITLE ' | bentoTranslate: menuTitle }}\n        </h2>\n        <button\n          class=\"bento-off-canvas-menu-close-button btn-flat-secondary\"\n          type=\"button\"\n          *ngIf=\"!_alwaysOpen\"\n          cdkMonitorElementFocus\n          (click)=\"isOpen = false\"\n          [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          container=\"body\"\n          [placement]=\"_isRTL ? 'right' : 'left'\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n      <ng-content select=\"[bento-off-canvas-menu-aside]\"></ng-content>\n    </div>\n  </div>\n</div>\n<div class=\"bento-off-canvas-menu-aside-bg\"></div>\n<div #rightPanelWrapper class=\"bento-off-canvas-menu-aside-right-wrapper\">\n  <div #rightPanel role=\"region\" class=\"bento-off-canvas-menu-aside-right\" [attr.aria-expanded]=\"!_isRightAsideHidden\">\n    <div #rightPanelFocus *ngIf=\"!_isRightAsideHidden\" cdkTrapFocus>\n      <div class=\"bento-off-canvas-menu-header\" *ngIf=\"this.showRightPanelHeader\">\n        <h2 #rightPanelTitle class=\"h5 bento-off-canvas-menu-header-title\">\n          {{ 'BENTO_UI_OFF_CANVAS_MENU_RIGHT_ASIDE_TITLE' | bentoTranslate: rightMenuTitle }}\n        </h2>\n        <button\n          class=\"bento-off-canvas-menu-close-button btn-flat-secondary\"\n          type=\"button\"\n          cdkMonitorElementFocus\n          (click)=\"rightIsOpen = false\"\n          [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          container=\"body\"\n          [placement]=\"_isRTL ? 'right' : 'left'\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n      <ng-content select=\"[bento-off-canvas-menu-aside-right]\"></ng-content>\n    </div>\n  </div>\n</div>\n\n<div #content class=\"bento-off-canvas-menu-content\">\n  <ng-content select=\"[bento-off-canvas-menu-content]\"></ng-content>\n</div>\n<div #overlay class=\"bento-off-canvas-menu-content-overlay\"></div>\n", styles: [".ng-bento body.bento-off-canvas-menu-bg-color,.ng-bento html.bento-off-canvas-menu-bg-color{height:100%;margin:0;padding:0;position:relative}.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-color,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-right,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-right,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-content-overlay,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-content,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-topbar{transition:none!important}.ng-bento bento-off-canvas-menu{position:absolute;left:0;right:0;top:0;bottom:0;-webkit-overflow-scrolling:touch}.ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar{width:auto}.ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:24px}[dir=rtl] .ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:auto;right:24px}.ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-content-overlay{opacity:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar{position:absolute;left:0;max-width:100%;top:0;right:0;box-shadow:0 0 10px #0003}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:0}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:auto;margin-right:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left{left:0}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left{left:auto;right:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:auto;right:0}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:0;right:auto}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{line-height:normal;padding:15px 15px 13px;box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;display:block;margin-top:0;float:left}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{float:right}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .btn-group{white-space:normal;font-size:1em}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .triangle-down{margin:5px 0 2px 4px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;display:inline-block}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{text-transform:uppercase;padding-right:20px}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{padding-right:0;padding-left:20px}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;border:none;cursor:pointer;font-size:25px;padding:0;opacity:.7;transition:all .2s}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{left:auto;right:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:focus{opacity:1}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:hover{opacity:1}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header{border-bottom-width:1px;border-bottom-style:solid;display:flex;font-size:18px;width:100%}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header{left:auto;right:0}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:right;margin-left:auto;margin-right:19px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:left;flex:1;font-size:16px;margin-left:19px;margin-top:25px;text-align:left}.ng-bento bento-off-canvas-menu button.bento-off-canvas-menu-close-button{border:none;text-align:center;font-size:14px;float:right;margin:0;transition:background-color .2s}[dir=rtl] .ng-bento bento-off-canvas-menu button.bento-off-canvas-menu-close-button{float:left}.ng-bento bento-off-canvas-menu button.bento-off-canvas-menu-close-button:focus{outline:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside:focus,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-right:focus{outline:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside hr{border-top-width:1px;border-top-style:solid;border-bottom:none;margin:0}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-right,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{position:inherit;top:0;box-sizing:border-box;max-width:100%;min-height:100%;-webkit-box-sizing:border-box}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-right,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{right:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{position:absolute;top:0;box-sizing:border-box;max-width:100%;text-align:center;-webkit-box-sizing:border-box}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside button,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button{margin-top:20px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside button.bento-off-canvas-menu-close-button,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button.bento-off-canvas-menu-close-button{margin-top:0}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a:first-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a:first-child{border-top-style:solid;border-top-width:1px;border-bottom-style:solid;border-bottom-width:1px;margin-top:-1px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li:last-child>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li:last-child>a{border-bottom:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a{position:relative;z-index:2}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a{padding:8px 20px 0;display:block;font-size:.9em;position:relative}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside a.menu-icon:hover,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a.menu-icon:hover{text-decoration:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{padding:0;margin:0;text-align:left;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{text-align:right}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta{margin-top:10px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li{padding:0 19px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a{padding:5px 19px;font-size:1em;line-height:20px;border:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a:hover,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a:hover{text-decoration:underline}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li:last-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li:last-child{margin-bottom:10px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li{padding:0;margin:0;position:relative}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a{display:block;line-height:20px;font-size:18px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a:first-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a:first-child{padding:18px 20px 16px 15px;width:100%}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{padding:0;position:absolute;right:20px;min-width:20px;text-align:center;top:22px}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{right:auto;left:20px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a{z-index:2}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{content:\"\";display:block;position:absolute;width:5px;left:0;top:0;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{left:auto;right:0;border-right:none;border-left-width:1px;border-left-style:solid}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled],.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]{pointer-events:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]>a{cursor:default}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]:hover>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]:hover>a{background:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu>li:last-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu>li:last-child{border-bottom:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{height:100%}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{height:100%}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{right:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-content-overlay{z-index:-1000;position:absolute;opacity:0;left:0;right:0;bottom:0}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-content{position:absolute;left:0;right:0;padding:20px 20px 40px}.ng-bento bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside,.ng-bento bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-right-wapper .bento-off-canvas-menu-aside-right{overflow-y:auto;bottom:0}.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right,.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{right:0!important}[dir=rtl] .ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right,[dir=rtl] .ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{left:0!important;right:auto!important}.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{box-shadow:0 0 20px #00000080}[dir=rtl] .ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content{left:auto}.ng-bento bento-off-canvas-menu.open-right.push-over{overflow-y:hidden}.ng-bento bento-off-canvas-menu.open-right.push-over>.bento-off-canvas-menu-content-overlay{top:0}.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside,.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{left:0!important}[dir=rtl] .ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside,[dir=rtl] .ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{left:auto!important;right:0!important}.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{box-shadow:0 0 20px #00000080}.ng-bento bento-off-canvas-menu.open.push-over{overflow-y:hidden}.ng-bento bento-off-canvas-menu.open.push-over>.bento-off-canvas-menu-content-overlay{top:0}.ng-bento .bento-off-canvas-menu>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside ul li a:first-child[target=_blank]{padding-right:40px}.ng-bento .bento-off-canvas-menu .bento-off-canvas-menu-aside ul li a i{position:absolute;right:12px;top:50%;transform:translateY(-50%)}.ng-bento .bento-off-canvas-menu-aside-right-wrapper,.ng-bento .bento-off-canvas-menu-aside-wrapper{bottom:0;position:absolute;top:0;width:0;transition:width .2s;overflow:auto;max-width:100%}.ng-bento .bento-off-canvas-menu-aside-right-wrapper,.ng-bento [dir=rtl] .bento-off-canvas-menu-aside-wrapper{right:0}.ng-bento .bento-off-canvas-menu-aside-wrapper,.ng-bento [dir=rtl] .bento-off-canvas-menu-aside-right-wrapper{left:0}@media only screen and (min-width: 1305px){.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar{padding:0}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:none}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{box-shadow:inset -15px 0 20px -20px #000;left:0}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{left:auto;right:0}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;transition:none}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{left:auto}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{right:0;width:auto}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{left:auto}.ng-bento bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;left:auto;right:100%}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{left:100%;right:auto}.ng-bento bento-off-canvas-menu:not(.not-responsive).open:not(.open-right) .bento-off-canvas-menu-content-overlay{display:none}}@media only screen and (max-width: 1199px){.ng-bento .hide-on-ipad{display:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{padding:0 15px;margin-left:-1px;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid;float:left}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{float:right;margin-left:0;margin-right:-1px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item:last-child{padding:0 15px;border-right:none}}@media only screen and (max-width: 320px){.ng-bento .bento-off-canvas-menu>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside ul li a:first-child[target=_blank]{padding:8px 20px 30px}.ng-bento .bento-off-canvas-menu>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside ul li a:first-child[target=_blank] i{bottom:8px;left:20px;top:auto;transform:translateY(0)}}.ng-bento bento-off-canvas-menu [bento-off-canvas-menu-content]>.global-subnav{margin:-20px -20px 20px;display:block;width:auto}.ng-bento .bento-off-canvas-menu-hide-overlay .bento-off-canvas-menu-content-overlay{display:none}\n"], directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoOffCanvasMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-off-canvas-menu', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #topbar class=\"bento-off-canvas-menu-topbar\" [ngClass]=\"menuButtonIsHidden ? 'menu-button-is-hidden ' : ''\">\n  <button\n    *ngIf=\"!menuButtonIsHidden\"\n    class=\"bento-off-canvas-menu-button\"\n    type=\"button\"\n    (click)=\"_toggleLeft()\"\n    [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON' | bentoTranslate\"\n    [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON' | bentoTranslate\"\n    container=\"body\"\n  >\n    <i class=\"bento-icon-hamburger-menu\" aria-hidden=\"true\"></i>\n  </button>\n  <ng-content select=\"[bento-off-canvas-menu-topbar]\"></ng-content>\n</div>\n<div #leftPanelWrapper class=\"bento-off-canvas-menu-aside-wrapper\">\n  <div #leftPanel role=\"region\" [attr.aria-expanded]=\"_isOpen\" tabindex=\"-1\" class=\"bento-off-canvas-menu-aside\">\n    <div #leftPanelFocus cdkTrapFocus [cdkTrapFocusAutoCapture]=\"!_alwaysOpen\" *ngIf=\"!_isAsideHidden\">\n      <!-- cdkFocusInitial -->\n      <div class=\"bento-off-canvas-menu-header\">\n        <h2 #leftPanelTitle class=\"h5 bento-off-canvas-menu-header-title\">\n          {{ 'BENTO_UI_OFF_CANVAS_MENU_ASIDE_TITLE ' | bentoTranslate: menuTitle }}\n        </h2>\n        <button\n          class=\"bento-off-canvas-menu-close-button btn-flat-secondary\"\n          type=\"button\"\n          *ngIf=\"!_alwaysOpen\"\n          cdkMonitorElementFocus\n          (click)=\"isOpen = false\"\n          [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          container=\"body\"\n          [placement]=\"_isRTL ? 'right' : 'left'\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n      <ng-content select=\"[bento-off-canvas-menu-aside]\"></ng-content>\n    </div>\n  </div>\n</div>\n<div class=\"bento-off-canvas-menu-aside-bg\"></div>\n<div #rightPanelWrapper class=\"bento-off-canvas-menu-aside-right-wrapper\">\n  <div #rightPanel role=\"region\" class=\"bento-off-canvas-menu-aside-right\" [attr.aria-expanded]=\"!_isRightAsideHidden\">\n    <div #rightPanelFocus *ngIf=\"!_isRightAsideHidden\" cdkTrapFocus>\n      <div class=\"bento-off-canvas-menu-header\" *ngIf=\"this.showRightPanelHeader\">\n        <h2 #rightPanelTitle class=\"h5 bento-off-canvas-menu-header-title\">\n          {{ 'BENTO_UI_OFF_CANVAS_MENU_RIGHT_ASIDE_TITLE' | bentoTranslate: rightMenuTitle }}\n        </h2>\n        <button\n          class=\"bento-off-canvas-menu-close-button btn-flat-secondary\"\n          type=\"button\"\n          cdkMonitorElementFocus\n          (click)=\"rightIsOpen = false\"\n          [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          container=\"body\"\n          [placement]=\"_isRTL ? 'right' : 'left'\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n      <ng-content select=\"[bento-off-canvas-menu-aside-right]\"></ng-content>\n    </div>\n  </div>\n</div>\n\n<div #content class=\"bento-off-canvas-menu-content\">\n  <ng-content select=\"[bento-off-canvas-menu-content]\"></ng-content>\n</div>\n<div #overlay class=\"bento-off-canvas-menu-content-overlay\"></div>\n", styles: [".ng-bento body.bento-off-canvas-menu-bg-color,.ng-bento html.bento-off-canvas-menu-bg-color{height:100%;margin:0;padding:0;position:relative}.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-color,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-right,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-right,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-content-overlay,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-content,.ng-bento .bento-off-canvas-menu-rendering .bento-off-canvas-menu-topbar{transition:none!important}.ng-bento bento-off-canvas-menu{position:absolute;left:0;right:0;top:0;bottom:0;-webkit-overflow-scrolling:touch}.ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar{width:auto}.ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:24px}[dir=rtl] .ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:auto;right:24px}.ng-bento bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-content-overlay{opacity:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar{position:absolute;left:0;max-width:100%;top:0;right:0;box-shadow:0 0 10px #0003}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:0}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:auto;margin-right:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left{left:0}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left{left:auto;right:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:auto;right:0}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:0;right:auto}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{line-height:normal;padding:15px 15px 13px;box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;display:block;margin-top:0;float:left}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{float:right}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .btn-group{white-space:normal;font-size:1em}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .triangle-down{margin:5px 0 2px 4px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;display:inline-block}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{text-transform:uppercase;padding-right:20px}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{padding-right:0;padding-left:20px}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;border:none;cursor:pointer;font-size:25px;padding:0;opacity:.7;transition:all .2s}[dir=rtl] .ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{left:auto;right:0}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:focus{opacity:1}.ng-bento bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:hover{opacity:1}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header{border-bottom-width:1px;border-bottom-style:solid;display:flex;font-size:18px;width:100%}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header{left:auto;right:0}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:right;margin-left:auto;margin-right:19px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:left;flex:1;font-size:16px;margin-left:19px;margin-top:25px;text-align:left}.ng-bento bento-off-canvas-menu button.bento-off-canvas-menu-close-button{border:none;text-align:center;font-size:14px;float:right;margin:0;transition:background-color .2s}[dir=rtl] .ng-bento bento-off-canvas-menu button.bento-off-canvas-menu-close-button{float:left}.ng-bento bento-off-canvas-menu button.bento-off-canvas-menu-close-button:focus{outline:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside:focus,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-right:focus{outline:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside hr{border-top-width:1px;border-top-style:solid;border-bottom:none;margin:0}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-right,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{position:inherit;top:0;box-sizing:border-box;max-width:100%;min-height:100%;-webkit-box-sizing:border-box}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-right,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{right:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{position:absolute;top:0;box-sizing:border-box;max-width:100%;text-align:center;-webkit-box-sizing:border-box}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside button,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button{margin-top:20px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside button.bento-off-canvas-menu-close-button,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button.bento-off-canvas-menu-close-button{margin-top:0}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a:first-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a:first-child{border-top-style:solid;border-top-width:1px;border-bottom-style:solid;border-bottom-width:1px;margin-top:-1px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li:last-child>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li:last-child>a{border-bottom:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a{position:relative;z-index:2}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a{padding:8px 20px 0;display:block;font-size:.9em;position:relative}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside a.menu-icon:hover,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a.menu-icon:hover{text-decoration:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{padding:0;margin:0;text-align:left;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{text-align:right}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta{margin-top:10px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li{padding:0 19px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a{padding:5px 19px;font-size:1em;line-height:20px;border:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a:hover,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a:hover{text-decoration:underline}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li:last-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li:last-child{margin-bottom:10px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li{padding:0;margin:0;position:relative}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a{display:block;line-height:20px;font-size:18px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a:first-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a:first-child{padding:18px 20px 16px 15px;width:100%}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{padding:0;position:absolute;right:20px;min-width:20px;text-align:center;top:22px}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{right:auto;left:20px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a{z-index:2}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{content:\"\";display:block;position:absolute;width:5px;left:0;top:0;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{left:auto;right:0;border-right:none;border-left-width:1px;border-left-style:solid}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled],.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]{pointer-events:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]>a{cursor:default}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]:hover>a,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]:hover>a{background:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu>li:last-child,.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu>li:last-child{border-bottom:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{height:100%}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{height:100%}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{right:auto}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-content-overlay{z-index:-1000;position:absolute;opacity:0;left:0;right:0;bottom:0}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-content{position:absolute;left:0;right:0;padding:20px 20px 40px}.ng-bento bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside,.ng-bento bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-right-wapper .bento-off-canvas-menu-aside-right{overflow-y:auto;bottom:0}.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right,.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{right:0!important}[dir=rtl] .ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right,[dir=rtl] .ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{left:0!important;right:auto!important}.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}.ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{box-shadow:0 0 20px #00000080}[dir=rtl] .ng-bento bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content{left:auto}.ng-bento bento-off-canvas-menu.open-right.push-over{overflow-y:hidden}.ng-bento bento-off-canvas-menu.open-right.push-over>.bento-off-canvas-menu-content-overlay{top:0}.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside,.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{left:0!important}[dir=rtl] .ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside,[dir=rtl] .ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{left:auto!important;right:0!important}.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}.ng-bento bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{box-shadow:0 0 20px #00000080}.ng-bento bento-off-canvas-menu.open.push-over{overflow-y:hidden}.ng-bento bento-off-canvas-menu.open.push-over>.bento-off-canvas-menu-content-overlay{top:0}.ng-bento .bento-off-canvas-menu>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside ul li a:first-child[target=_blank]{padding-right:40px}.ng-bento .bento-off-canvas-menu .bento-off-canvas-menu-aside ul li a i{position:absolute;right:12px;top:50%;transform:translateY(-50%)}.ng-bento .bento-off-canvas-menu-aside-right-wrapper,.ng-bento .bento-off-canvas-menu-aside-wrapper{bottom:0;position:absolute;top:0;width:0;transition:width .2s;overflow:auto;max-width:100%}.ng-bento .bento-off-canvas-menu-aside-right-wrapper,.ng-bento [dir=rtl] .bento-off-canvas-menu-aside-wrapper{right:0}.ng-bento .bento-off-canvas-menu-aside-wrapper,.ng-bento [dir=rtl] .bento-off-canvas-menu-aside-right-wrapper{left:0}@media only screen and (min-width: 1305px){.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar{padding:0}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:none}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{box-shadow:inset -15px 0 20px -20px #000;left:0}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{left:auto;right:0}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;transition:none}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{left:auto}.ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{right:0;width:auto}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{left:auto}.ng-bento bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;left:auto;right:100%}[dir=rtl] .ng-bento bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{left:100%;right:auto}.ng-bento bento-off-canvas-menu:not(.not-responsive).open:not(.open-right) .bento-off-canvas-menu-content-overlay{display:none}}@media only screen and (max-width: 1199px){.ng-bento .hide-on-ipad{display:none}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{padding:0 15px;margin-left:-1px;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid;float:left}[dir=rtl] .ng-bento bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{float:right;margin-left:0;margin-right:-1px}.ng-bento bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item:last-child{padding:0 15px;border-right:none}}@media only screen and (max-width: 320px){.ng-bento .bento-off-canvas-menu>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside ul li a:first-child[target=_blank]{padding:8px 20px 30px}.ng-bento .bento-off-canvas-menu>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside ul li a:first-child[target=_blank] i{bottom:8px;left:20px;top:auto;transform:translateY(0)}}.ng-bento bento-off-canvas-menu [bento-off-canvas-menu-content]>.global-subnav{margin:-20px -20px 20px;display:block;width:auto}.ng-bento .bento-off-canvas-menu-hide-overlay .bento-off-canvas-menu-content-overlay{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: BentoTabService }, { type: i0.Renderer2 }, { type: i3$1.Platform }, { type: BentoNotification }, { type: i2.Directionality }, { type: WindowRef }, { type: i0.ElementRef }]; }, propDecorators: { isOpen: [{
                type: Input
            }], mode: [{
                type: Input
            }], isOpenChange: [{
                type: Output
            }], hideOverlay: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.bento-off-canvas-menu-hide-overlay']
            }], showRightPanelHeader: [{
                type: Input
            }], rightIsOpen: [{
                type: Input
            }], rightIsOpenChange: [{
                type: Output
            }], menuTitle: [{
                type: Input
            }], rightMenuTitle: [{
                type: Input
            }], leftPanelWidthPx: [{
                type: Input
            }], rightPanelWidthPx: [{
                type: Input
            }], menuButtonIsHidden: [{
                type: Input
            }], responsive: [{
                type: Input
            }], notResponsive: [{
                type: HostBinding,
                args: ['class.not-responsive']
            }], setDefaultClass: [{
                type: HostBinding,
                args: ['class.bento-off-canvas-menu']
            }], _isOpen: [{
                type: HostBinding,
                args: ['class.open']
            }], _rightIsOpen: [{
                type: HostBinding,
                args: ['class.open-right']
            }], _isPushOver: [{
                type: HostBinding,
                args: ['class.push-over']
            }], _alwaysOpen: [{
                type: HostBinding,
                args: ['class.always-open']
            }], overlay: [{
                type: ViewChild,
                args: ['overlay', { static: true }]
            }], leftPanelRef: [{
                type: ViewChild,
                args: ['leftPanel', { static: true }]
            }], rightPanelRef: [{
                type: ViewChild,
                args: ['rightPanel', { static: true }]
            }], leftPanelWrapperRef: [{
                type: ViewChild,
                args: ['leftPanelWrapper', { static: true }]
            }], rightPanelWrapperRef: [{
                type: ViewChild,
                args: ['rightPanelWrapper', { static: true }]
            }], content: [{
                type: ViewChild,
                args: ['content', { static: true }]
            }], topbar: [{
                type: ViewChild,
                args: ['topbar', { static: true }]
            }], tooltips: [{
                type: ViewChildren,
                args: [NgbTooltip]
            }], leftTrapFocus: [{
                type: ViewChild,
                args: ['leftPanelFocus', { read: CdkTrapFocus }]
            }], rightTrapFocus: [{
                type: ViewChild,
                args: ['rightPanelFocus', { read: CdkTrapFocus }]
            }] } });

class BentoOffCanvasMenuModule extends ConsumerDataValidator {
}
BentoOffCanvasMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoOffCanvasMenuModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoOffCanvasMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoOffCanvasMenuModule, declarations: [BentoOffCanvasMenuComponent], imports: [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        A11yModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule], exports: [BentoOffCanvasMenuComponent] });
BentoOffCanvasMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoOffCanvasMenuModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            A11yModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoOffCanvasMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoUtilsModule,
                        A11yModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule
                    ],
                    declarations: [BentoOffCanvasMenuComponent],
                    exports: [BentoOffCanvasMenuComponent]
                }]
        }] });

/**
 * The `bentoSelect` directive gives the HTML `<select>` element consistent
 * visual signature across most browsers.
 */
class BentoSelectDirective {
    constructor(elRef, r, windowRef) {
        this.r = r;
        this.windowRef = windowRef;
        this.el = elRef.nativeElement;
    }
    ngOnDestroy() {
        if (this.wrapperEl.parentElement) {
            this.wrapperEl.parentElement.removeChild(this.wrapperEl);
        }
    }
    ngOnInit() {
        this.render(this.el);
    }
    /**
     * Render layout
     */
    render(el) {
        const wrapper = this.r.createElement('div');
        const button = this.r.createElement('div');
        this.r.addClass(button, 'btn');
        this.r.addClass(button, 'btn-icon');
        this.r.setProperty(button, 'innerHTML', '<i class="bento-icon-caret-down-filled" aria-hidden="true"></i>');
        this.r.addClass(wrapper, 'bento-select');
        this.r.appendChild(el.parentElement, wrapper);
        this.r.appendChild(wrapper, el);
        // Move class to wrapper
        if (el.classList.contains('input-sm')) {
            this.r.removeClass(el, 'input-sm');
            this.r.addClass(wrapper, 'input-sm');
        }
        else if (el.classList.contains('input-lg')) {
            this.r.removeClass(el, 'input-lg');
            this.r.addClass(wrapper, 'input-lg');
        }
        // Firefox version for better UI look and feel
        if (this.windowRef.isFF) {
            this.r.addClass(wrapper, 'firefox');
            const border = this.r.createElement('div');
            this.r.addClass(border, 'bento-select-border');
            this.r.appendChild(wrapper, border);
        }
        this.r.appendChild(wrapper, button);
        this.wrapperEl = wrapper;
    }
}
BentoSelectDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSelectDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoSelectDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoSelectDirective, selector: "select[bentoSelect]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSelectDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'select[bentoSelect]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: WindowRef }]; } });

// Used to create unique id
let paginationFieldId = 0;
/**
 * This minimal pagination component provides previous/next functionality, jump-to-page input,
 * and amount of items per page. The 'Go' button, 'Page 1 of 18,' and '1 to 25 of 1000 Entries' labels
 * are i18n-ready. Translations are not provided by Bento.UI, they are at the discretion of your team.
 */
class BentoPaginationComponent {
    constructor(elRef, bentoNotification, changeDetector) {
        this.changeDetector = changeDetector;
        this.itemsPerPage = 25;
        /**
         * Flag to display the 'go to page' input field and button
         */
        this.goToLink = true;
        /**
         * Flag to hide/display the 'items per page' select input
         */
        this.hideItemsPerPage = false;
        this.boundaryLinks = true;
        /**
         * Unique ID of this component
         */
        this.uid = `${paginationFieldId++}`;
        // Options
        /**
         * Flag to show/hide direction links
         */
        this.directionLinks = true;
        /**
         * Option for the page item number selection dropdown.  This property is **immutable**
         */
        this.itemsArray = [10, 25, 50, 100];
        /**
         * Flag to set the current page always to `1`
         */
        this.pageOverride = false;
        /**
         * Accessibility guidelines encourages to use real words for buttons instead
         * of symbols and hidden text. Use this property to use strings instead of
         * symbols (<<, <, >, >>) for pagination component.
         * component.
         * By default this will be set to false, to make your product fully accessible,
         * set this to true when using pagination component.
         */
        this.useStrings = false;
        // Callbacks
        /**
         * Callback when the current page is changed
         */
        this.pageChange = new EventEmitter();
        /**
         * Callback when items per page is changed
         */
        this.itemsPerPageChange = new EventEmitter();
        /**
         * (Experimental) Callback when an internal event is dispatched within Bento Pagination
         */
        this.eventTracking = new EventEmitter();
        // Private variables
        /**
         * Flag to set the last button margin
         */
        this.lastButtonSmallMargin = false;
        /**
         * Current max page count
         */
        this.maxPage = 2;
        /**
         * Flag for buttons spanning full width
         */
        this.breakpointSmall = false;
        /**
         * go input field model
         */
        this.paginationInputModel = undefined;
        /**
         * Variable that implements the BentoTranslatable
         */
        this.customTranslation = {};
        this.nativeElement = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this._checkElementWidthAndRender());
    }
    /**
     * Current page number
     */
    set _page(value) {
        this.page = this._normalizePageNumber(value);
    }
    /**
     * Total number of items this pagination should display
     */
    set _totalItems(value) {
        this.totalItems = value;
        this.maxPage = this._getTotalPages();
        // tracking
        this.eventTracking.emit({ eventName: 'total items changed', value });
    }
    /**
     * Number of item in a page
     */
    set _itemsPerPage(value) {
        this.itemsPerPage = value;
        this.maxPage = this._getTotalPages();
    }
    /**
     * Flag to display the first and last page links (buttons)
     */
    set _boundaryLinks(value) {
        if (typeof value !== 'undefined') {
            this.boundaryLinks = value;
        }
        this._checkElementWidthAndRender();
    }
    /**
     * Use method to refresh the rendering of the component when the container's width changes or was previously
     * `display:none`. (e.g. when pagination is used in modal, tabs, dropdowns, etc...)
     */
    refresh() {
        this._checkElementWidthAndRender();
    }
    /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     *
     * * BENTO_UI_PAGINATION_GO_BUTTON: 'Go',
     * * BENTO_UI_PAGINATION_INFO_PAGE_TEXT: 'Page \_PAGE\_ of \_PAGES\_',
     * * BENTO_UI_PAGINATION_SHOWING_TEXT: 'Showing \_START\_ to \_END\_ of \_MAX\_',
     * * BENTO_UI_PAGINATION_A11Y_FIRST: 'Go to First Page',
     * * BENTO_UI_PAGINATION_A11Y_NEXT: 'Go to Next Page',
     * * BENTO_UI_PAGINATION_A11Y_PREVIOUS: 'Go to Previous Page',
     * * BENTO_UI_PAGINATION_A11Y_LAST: 'Go to Last Page',
     * * BENTO_UI_PAGINATION_A11Y_PAGE_NUM: 'Enter Page number to go to',
     * * BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: 'Go to Page',
     * * BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items Per Page',
     *
     */
    setTranslation(customTranslation) {
        this.customTranslation = customTranslation;
        this.changeDetector.markForCheck();
    }
    /**
     * Method to go to a page by it's number
     */
    _goToPage(page, event) {
        let targetPage;
        let keyCode;
        let isEnter;
        if (isNaN(page) || page < 1) {
            // User input is incorrect
            return;
        }
        targetPage = this._normalizePageNumber(page);
        if (event.type === 'keypress') {
            keyCode = event.keyCode;
            isEnter = keyCode === Keyboard.ENTER;
        }
        if (isEnter || event.type === 'click') {
            event.target.value = this.page = targetPage;
            event.stopPropagation();
            event.preventDefault();
            // reset go input field
            this.paginationInputModel = undefined;
            this.pageChange.emit(Number(this.page));
            // tracking
            this.eventTracking.emit({
                eventName: 'current page value modification',
                value: 'input value => ' + page + ' value@ ' + this.page
            });
        }
    }
    /**
     * Get start index for current page
     */
    _getStartIndex() {
        return (this.page - 1) * this.itemsPerPage + 1;
    }
    /**
     * Get the end index for current page
     */
    _getEndIndex() {
        return this.totalItems < this.itemsPerPage * this.page ? this.totalItems : this.itemsPerPage * this.page;
    }
    /**
     * Callback when itemsPerPage changes in the select dropdown
     */
    _onItemsPerPageChange(itemsPerPage) {
        this._calculatePages(itemsPerPage);
        this.itemsPerPage = itemsPerPage;
        this.maxPage = this._getTotalPages();
        this.page = 1;
        // fire callbacks
        this.itemsPerPageChange.emit(Number(itemsPerPage));
        this.pageChange.emit(Number(this.page));
        // tracking
        this.eventTracking.emit({ eventName: 'items per page changed', value: itemsPerPage });
    }
    /**
     * Calculate number of pages in total
     */
    _getTotalPages() {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    }
    /**
     * Called when this component is destroyed
     */
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
    }
    /**
     * Calculate and set the current page
     */
    _calculatePages(newItemsPerPage) {
        this.page = this.pageOverride ? 1 : Math.ceil(this._getStartIndex() / newItemsPerPage);
    }
    /**
     * Calculate and change layout responsively
     */
    _checkElementWidthAndRender() {
        if (!this.element) {
            this.element = this.nativeElement.children[0];
        }
        const width = this.element.offsetWidth;
        if (width < 340) {
            this.breakpointSmall = true;
        }
        else {
            this.breakpointSmall = false;
        }
        this.changeDetector.markForCheck();
    }
    /**
     * Normalize the current page number
     */
    _normalizePageNumber(page) {
        const numPages = this._getTotalPages();
        let targetPage = page > numPages ? numPages : page;
        targetPage = targetPage < -1 ? 1 : targetPage;
        return targetPage;
    }
}
BentoPaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPaginationComponent, deps: [{ token: i0.ElementRef }, { token: BentoNotification }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoPaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoPaginationComponent, selector: "bento-pagination", inputs: { _page: ["page", "_page"], _totalItems: ["totalItems", "_totalItems"], _itemsPerPage: ["itemsPerPage", "_itemsPerPage"], goToLink: "goToLink", hideItemsPerPage: "hideItemsPerPage", _boundaryLinks: ["boundaryLinks", "_boundaryLinks"], infoText: "infoText", infoPageText: "infoPageText", goToText: "goToText", directionLinks: "directionLinks", itemsArray: "itemsArray", pageOverride: "pageOverride", useStrings: "useStrings" }, outputs: { pageChange: "pageChange", itemsPerPageChange: "itemsPerPageChange", eventTracking: "eventTracking" }, providers: [BentoNotification], ngImport: i0, template: "<nav\n  role=\"navigation\"\n  class=\"bento-pagination d-flex flex-wrap\"\n  [class.is-small-break]=\"useStrings && breakpointSmall\"\n  [attr.aria-label]=\"!useStrings ? ('BENTO_UI_PAGINATION' | bentoTranslate) : ''\"\n>\n  <div class=\"d-flex flex-wrap bento-pagination-nav-controls\">\n    <div class=\"bento-pagination-browse-section\">\n      <div class=\"paginate-info mb-1\" *ngIf=\"maxPage > 0\" aria-live=\"polite\">\n        {{\n          infoPageText ||\n            ('BENTO_UI_PAGINATION_INFO_PAGE_TEXT'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_INFO_PAGE_TEXT'])\n            | bentoStringReplace: '_PAGE_':page\n            | bentoStringReplace: '_PAGES_':_getTotalPages()\n        }}\n      </div>\n      <div class=\"bento-pagination-buttons d-flex flex-wrap\">\n        <div\n          *ngIf=\"boundaryLinks !== false\"\n          class=\"paginate-button first\"\n          [class.disabled]=\"page === 1 || maxPage === 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(1, $event)\"\n            [disabled]=\"page === 1 || maxPage === 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_FIRST'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_FIRST'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_FIRST'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_FIRST'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-first-left\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_FIRST_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n        <div\n          *ngIf=\"directionLinks !== false\"\n          class=\"paginate-button previous\"\n          [class.first]=\"!boundaryLinks\"\n          [class.disabled]=\"page === 1 || maxPage === 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(page - 1, $event)\"\n            [disabled]=\"page === 1 || maxPage === 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_PREVIOUS'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PREVIOUS'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_PREVIOUS'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PREVIOUS'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_PREVIOUS_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n        <div\n          *ngIf=\"directionLinks !== false\"\n          class=\"paginate-button next\"\n          [class.last]=\"!boundaryLinks\"\n          [class.disabled]=\"page === maxPage || maxPage <= 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(page + 1, $event)\"\n            [disabled]=\"page === maxPage || maxPage <= 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_NEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_NEXT'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_NEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_NEXT'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_NEXT_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n        <div\n          *ngIf=\"boundaryLinks !== false\"\n          class=\"paginate-button last\"\n          [class.disabled]=\"page === maxPage || maxPage <= 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(_getTotalPages(), $event)\"\n            [disabled]=\"page === maxPage || maxPage <= 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_LAST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_LAST'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_LAST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_LAST'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-last-right\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_LAST_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"d-flex paginate-input-wrap\" *ngIf=\"goToLink !== false && maxPage > 1\">\n      <label [attr.for]=\"'go-to-page-' + uid\" class=\"mb-1\">{{ 'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE' | bentoTranslate }}</label>\n      <div class=\"input-group paginate-input-group\">\n        <input\n          #paginationInput\n          [attr.id]=\"'go-to-page-' + uid\"\n          class=\"form-control\"\n          container=\"body\"\n          [(ngModel)]=\"paginationInputModel\"\n          (keypress)=\"_goToPage(+$event.target.value, $event)\"\n          placement=\"top\"\n          [ngbTooltip]=\"\n            'BENTO_UI_PAGINATION_A11Y_PAGE_NUM' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PAGE_NUM']\n          \"\n        />\n        <button\n          type=\"button\"\n          class=\"go btn btn-outline-primary\"\n          container=\"body\"\n          (click)=\"_goToPage(+paginationInput.value, $event)\"\n          placement=\"top\"\n          [ngbTooltip]=\"\n            'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_GOTO_PAGE']\n              | bentoStringReplace: '_PAGE_':paginationInputModel || page\n          \"\n          [attr.aria-label]=\"\n            'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_GOTO_PAGE']\n              | bentoStringReplace: '_PAGE_':paginationInputModel || page\n          \"\n        >\n          {{\n            goToText ||\n              ('BENTO_UI_PAGINATION_GO_BUTTON' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_GO_BUTTON'])\n          }}\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"paginate-bento-select d-flex flex-wrap\" *ngIf=\"hideItemsPerPage !== true\">\n    <div class=\"d-flex bento-pagination-items-showing paginate-info-select\">\n      {{\n        infoText ||\n          ('BENTO_UI_PAGINATION_SHOWING_TEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_SHOWING_TEXT'])\n          | bentoStringReplace: '_START_':_getStartIndex()\n          | bentoStringReplace: '_END_':_getEndIndex()\n          | bentoStringReplace: '_MAX_':totalItems\n      }}\n    </div>\n    <div class=\"d-flex paginate-bento-select bento-pagination-items-per-page\" *ngIf=\"maxPage > 0\">\n      <label [attr.for]=\"'items-per-page-' + uid\" class=\"mb-1\">{{ 'BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE' | bentoTranslate }}</label>\n      <select\n        [attr.id]=\"'items-per-page-' + uid\"\n        bentoSelect\n        #bpSelect\n        class=\"form-control\"\n        container=\"body\"\n        [ngModel]=\"itemsPerPage\"\n        (change)=\"_onItemsPerPageChange(bpSelect.value)\"\n        placement=\"top\"\n        [ngbTooltip]=\"\n          'BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE'\n            | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE']\n        \"\n        container=\"body\"\n      >\n        <option [value]=\"item\" *ngFor=\"let item of itemsArray\">{{ item }}</option>\n      </select>\n    </div>\n  </div>\n</nav>\n", styles: [".ng-bento .bento-pagination-browse-section,.ng-bento .paginate-input-wrap{margin-right:24px}[dir=rtl] .ng-bento .bento-pagination-browse-section,[dir=rtl] .ng-bento .paginate-input-wrap{margin-left:24px;margin-right:0!important}.ng-bento .bento-pagination-browse-section,.ng-bento .paginate-input-wrap,.ng-bento .paginate-bento-select{margin-bottom:16px}.ng-bento bento-pagination .bento-pagination{position:relative;padding:0;margin:20px 0;width:100%}.ng-bento bento-pagination .bento-pagination .go.btn{border-radius:0;margin-left:-1px;z-index:1;padding:0 7px;min-width:0}.ng-bento bento-pagination .bento-pagination .bento-select .btn>span{line-height:1.2em}.ng-bento bento-pagination .bento-pagination .bento-select .btn-icon{text-align:center}.ng-bento bento-pagination .bento-pagination button{padding:0 1.6em;cursor:pointer;margin-right:-1px;border-radius:0;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}.ng-bento bento-pagination .bento-pagination button:focus{position:relative;z-index:1}.ng-bento bento-pagination .bento-pagination .paginate-button.previous>button,.ng-bento bento-pagination .bento-pagination .paginate-button.next>button,.ng-bento bento-pagination .bento-pagination .paginate-button.first>button,.ng-bento bento-pagination .bento-pagination .paginate-button.last>button{padding:0 1em}.ng-bento bento-pagination .bento-pagination .paginate-button{margin-right:-1px}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-button{margin-right:0;margin-left:-1px}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-button button i{transform:scaleX(-1)}.ng-bento bento-pagination .bento-pagination .paginate-button.first>button{margin-left:0}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-button.first>button{margin-left:auto;margin-right:0}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-bento-select{margin-left:0!important;margin-right:auto}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-info{margin-right:0!important;margin-left:auto}.ng-bento bento-pagination .bento-pagination .paginate-info{clear:both}.ng-bento bento-pagination .bento-pagination .bento-pagination-items-showing,.ng-bento bento-pagination .bento-pagination .bento-pagination-items-per-page{flex:0 0 auto}.ng-bento bento-pagination .bento-pagination .bento-pagination-items-showing{align-items:flex-end;margin-bottom:12px;margin-right:12px}.ng-bento bento-pagination .bento-pagination .bento-pagination-items-per-page{flex-direction:column;margin-bottom:8px}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap{flex-direction:column;width:auto}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap>span{padding:0;border:none;background:transparent;margin:0}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap>span:hover,.ng-bento bento-pagination .bento-pagination .paginate-input-wrap>span:active{background:transparent}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-button-group{float:left;margin-right:40px}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group{flex-wrap:nowrap}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control{box-shadow:none;display:inline;flex:none;position:relative;text-align:center;width:60px;-webkit-box-shadow:none}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control:hover{z-index:auto}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .dataTables-info{margin-right:20px}.ng-bento bento-pagination .bento-pagination .bento-pagination-nav-controls{margin-right:auto}[dir=rtl] .ng-bento bento-pagination .bento-pagination .bento-pagination-nav-controls{margin-left:auto}.ng-bento bento-pagination .bento-pagination.is-small-break{flex-direction:column}.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-nav-controls,.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination,.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-buttons{flex-direction:column}.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-nav-controls,.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-browse-section{margin-right:0}[dir=rtl] .ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-nav-controls,[dir=rtl] .ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-browse-section{margin-left:0}.ng-bento bento-pagination .bento-pagination.is-small-break .paginate-button{margin-bottom:8px}.ng-bento bento-pagination .bento-pagination.is-small-break .paginate-button .btn{width:100%}@-moz-document url-prefix(){.ng-bento bento-pagination .bento-pagination .bento-select select{padding-top:9px}}.ng-bento .bento-splitter-group-main-inner bento-pagination .bento-pagination{padding:0 10px}.ng-bento bento-pagination .bento-pagination.has-padding{padding:0 20px}\n"], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i6.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i6.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-pagination', providers: [BentoNotification], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<nav\n  role=\"navigation\"\n  class=\"bento-pagination d-flex flex-wrap\"\n  [class.is-small-break]=\"useStrings && breakpointSmall\"\n  [attr.aria-label]=\"!useStrings ? ('BENTO_UI_PAGINATION' | bentoTranslate) : ''\"\n>\n  <div class=\"d-flex flex-wrap bento-pagination-nav-controls\">\n    <div class=\"bento-pagination-browse-section\">\n      <div class=\"paginate-info mb-1\" *ngIf=\"maxPage > 0\" aria-live=\"polite\">\n        {{\n          infoPageText ||\n            ('BENTO_UI_PAGINATION_INFO_PAGE_TEXT'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_INFO_PAGE_TEXT'])\n            | bentoStringReplace: '_PAGE_':page\n            | bentoStringReplace: '_PAGES_':_getTotalPages()\n        }}\n      </div>\n      <div class=\"bento-pagination-buttons d-flex flex-wrap\">\n        <div\n          *ngIf=\"boundaryLinks !== false\"\n          class=\"paginate-button first\"\n          [class.disabled]=\"page === 1 || maxPage === 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(1, $event)\"\n            [disabled]=\"page === 1 || maxPage === 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_FIRST'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_FIRST'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_FIRST'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_FIRST'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-first-left\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_FIRST_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n        <div\n          *ngIf=\"directionLinks !== false\"\n          class=\"paginate-button previous\"\n          [class.first]=\"!boundaryLinks\"\n          [class.disabled]=\"page === 1 || maxPage === 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(page - 1, $event)\"\n            [disabled]=\"page === 1 || maxPage === 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_PREVIOUS'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PREVIOUS'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_PREVIOUS'\n                  | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PREVIOUS'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_PREVIOUS_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n        <div\n          *ngIf=\"directionLinks !== false\"\n          class=\"paginate-button next\"\n          [class.last]=\"!boundaryLinks\"\n          [class.disabled]=\"page === maxPage || maxPage <= 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(page + 1, $event)\"\n            [disabled]=\"page === maxPage || maxPage <= 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_NEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_NEXT'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_NEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_NEXT'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_NEXT_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n        <div\n          *ngIf=\"boundaryLinks !== false\"\n          class=\"paginate-button last\"\n          [class.disabled]=\"page === maxPage || maxPage <= 1\"\n        >\n          <button\n            type=\"button\"\n            (click)=\"_goToPage(_getTotalPages(), $event)\"\n            [disabled]=\"page === maxPage || maxPage <= 1\"\n            container=\"body\"\n            class=\"btn btn-outline-primary btn-icon\"\n            placement=\"top\"\n            [ngbTooltip]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_LAST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_LAST'])\n                : ''\n            \"\n            [attr.aria-label]=\"\n              !useStrings\n                ? ('BENTO_UI_PAGINATION_A11Y_LAST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_LAST'])\n                : ''\n            \"\n          >\n            <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-last-right\" aria-hidden=\"true\"></i>\n            <ng-template #showStrings>\n              {{ 'BENTO_UI_PAGINATION_A11Y_LAST_BUTTON' | bentoTranslate }}\n            </ng-template>\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"d-flex paginate-input-wrap\" *ngIf=\"goToLink !== false && maxPage > 1\">\n      <label [attr.for]=\"'go-to-page-' + uid\" class=\"mb-1\">{{ 'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE' | bentoTranslate }}</label>\n      <div class=\"input-group paginate-input-group\">\n        <input\n          #paginationInput\n          [attr.id]=\"'go-to-page-' + uid\"\n          class=\"form-control\"\n          container=\"body\"\n          [(ngModel)]=\"paginationInputModel\"\n          (keypress)=\"_goToPage(+$event.target.value, $event)\"\n          placement=\"top\"\n          [ngbTooltip]=\"\n            'BENTO_UI_PAGINATION_A11Y_PAGE_NUM' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PAGE_NUM']\n          \"\n        />\n        <button\n          type=\"button\"\n          class=\"go btn btn-outline-primary\"\n          container=\"body\"\n          (click)=\"_goToPage(+paginationInput.value, $event)\"\n          placement=\"top\"\n          [ngbTooltip]=\"\n            'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_GOTO_PAGE']\n              | bentoStringReplace: '_PAGE_':paginationInputModel || page\n          \"\n          [attr.aria-label]=\"\n            'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_GOTO_PAGE']\n              | bentoStringReplace: '_PAGE_':paginationInputModel || page\n          \"\n        >\n          {{\n            goToText ||\n              ('BENTO_UI_PAGINATION_GO_BUTTON' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_GO_BUTTON'])\n          }}\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"paginate-bento-select d-flex flex-wrap\" *ngIf=\"hideItemsPerPage !== true\">\n    <div class=\"d-flex bento-pagination-items-showing paginate-info-select\">\n      {{\n        infoText ||\n          ('BENTO_UI_PAGINATION_SHOWING_TEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_SHOWING_TEXT'])\n          | bentoStringReplace: '_START_':_getStartIndex()\n          | bentoStringReplace: '_END_':_getEndIndex()\n          | bentoStringReplace: '_MAX_':totalItems\n      }}\n    </div>\n    <div class=\"d-flex paginate-bento-select bento-pagination-items-per-page\" *ngIf=\"maxPage > 0\">\n      <label [attr.for]=\"'items-per-page-' + uid\" class=\"mb-1\">{{ 'BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE' | bentoTranslate }}</label>\n      <select\n        [attr.id]=\"'items-per-page-' + uid\"\n        bentoSelect\n        #bpSelect\n        class=\"form-control\"\n        container=\"body\"\n        [ngModel]=\"itemsPerPage\"\n        (change)=\"_onItemsPerPageChange(bpSelect.value)\"\n        placement=\"top\"\n        [ngbTooltip]=\"\n          'BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE'\n            | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE']\n        \"\n        container=\"body\"\n      >\n        <option [value]=\"item\" *ngFor=\"let item of itemsArray\">{{ item }}</option>\n      </select>\n    </div>\n  </div>\n</nav>\n", styles: [".ng-bento .bento-pagination-browse-section,.ng-bento .paginate-input-wrap{margin-right:24px}[dir=rtl] .ng-bento .bento-pagination-browse-section,[dir=rtl] .ng-bento .paginate-input-wrap{margin-left:24px;margin-right:0!important}.ng-bento .bento-pagination-browse-section,.ng-bento .paginate-input-wrap,.ng-bento .paginate-bento-select{margin-bottom:16px}.ng-bento bento-pagination .bento-pagination{position:relative;padding:0;margin:20px 0;width:100%}.ng-bento bento-pagination .bento-pagination .go.btn{border-radius:0;margin-left:-1px;z-index:1;padding:0 7px;min-width:0}.ng-bento bento-pagination .bento-pagination .bento-select .btn>span{line-height:1.2em}.ng-bento bento-pagination .bento-pagination .bento-select .btn-icon{text-align:center}.ng-bento bento-pagination .bento-pagination button{padding:0 1.6em;cursor:pointer;margin-right:-1px;border-radius:0;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}.ng-bento bento-pagination .bento-pagination button:focus{position:relative;z-index:1}.ng-bento bento-pagination .bento-pagination .paginate-button.previous>button,.ng-bento bento-pagination .bento-pagination .paginate-button.next>button,.ng-bento bento-pagination .bento-pagination .paginate-button.first>button,.ng-bento bento-pagination .bento-pagination .paginate-button.last>button{padding:0 1em}.ng-bento bento-pagination .bento-pagination .paginate-button{margin-right:-1px}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-button{margin-right:0;margin-left:-1px}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-button button i{transform:scaleX(-1)}.ng-bento bento-pagination .bento-pagination .paginate-button.first>button{margin-left:0}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-button.first>button{margin-left:auto;margin-right:0}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-bento-select{margin-left:0!important;margin-right:auto}[dir=rtl] .ng-bento bento-pagination .bento-pagination .paginate-info{margin-right:0!important;margin-left:auto}.ng-bento bento-pagination .bento-pagination .paginate-info{clear:both}.ng-bento bento-pagination .bento-pagination .bento-pagination-items-showing,.ng-bento bento-pagination .bento-pagination .bento-pagination-items-per-page{flex:0 0 auto}.ng-bento bento-pagination .bento-pagination .bento-pagination-items-showing{align-items:flex-end;margin-bottom:12px;margin-right:12px}.ng-bento bento-pagination .bento-pagination .bento-pagination-items-per-page{flex-direction:column;margin-bottom:8px}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap{flex-direction:column;width:auto}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap>span{padding:0;border:none;background:transparent;margin:0}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap>span:hover,.ng-bento bento-pagination .bento-pagination .paginate-input-wrap>span:active{background:transparent}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-button-group{float:left;margin-right:40px}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group{flex-wrap:nowrap}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control{box-shadow:none;display:inline;flex:none;position:relative;text-align:center;width:60px;-webkit-box-shadow:none}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control:hover{z-index:auto}.ng-bento bento-pagination .bento-pagination .paginate-input-wrap .dataTables-info{margin-right:20px}.ng-bento bento-pagination .bento-pagination .bento-pagination-nav-controls{margin-right:auto}[dir=rtl] .ng-bento bento-pagination .bento-pagination .bento-pagination-nav-controls{margin-left:auto}.ng-bento bento-pagination .bento-pagination.is-small-break{flex-direction:column}.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-nav-controls,.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination,.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-buttons{flex-direction:column}.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-nav-controls,.ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-browse-section{margin-right:0}[dir=rtl] .ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-nav-controls,[dir=rtl] .ng-bento bento-pagination .bento-pagination.is-small-break .bento-pagination-browse-section{margin-left:0}.ng-bento bento-pagination .bento-pagination.is-small-break .paginate-button{margin-bottom:8px}.ng-bento bento-pagination .bento-pagination.is-small-break .paginate-button .btn{width:100%}@-moz-document url-prefix(){.ng-bento bento-pagination .bento-pagination .bento-select select{padding-top:9px}}.ng-bento .bento-splitter-group-main-inner bento-pagination .bento-pagination{padding:0 10px}.ng-bento bento-pagination .bento-pagination.has-padding{padding:0 20px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoNotification }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { _page: [{
                type: Input,
                args: ['page']
            }], _totalItems: [{
                type: Input,
                args: ['totalItems']
            }], _itemsPerPage: [{
                type: Input,
                args: ['itemsPerPage']
            }], goToLink: [{
                type: Input
            }], hideItemsPerPage: [{
                type: Input
            }], _boundaryLinks: [{
                type: Input,
                args: ['boundaryLinks']
            }], infoText: [{
                type: Input
            }], infoPageText: [{
                type: Input
            }], goToText: [{
                type: Input
            }], directionLinks: [{
                type: Input
            }], itemsArray: [{
                type: Input
            }], pageOverride: [{
                type: Input
            }], useStrings: [{
                type: Input
            }], pageChange: [{
                type: Output
            }], itemsPerPageChange: [{
                type: Output
            }], eventTracking: [{
                type: Output
            }] } });

class BentoSelectModule extends ConsumerDataValidator {
}
BentoSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSelectModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSelectModule, declarations: [BentoSelectDirective], imports: [BentoUtilsModule], exports: [BentoSelectDirective] });
BentoSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSelectModule, imports: [[BentoUtilsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoSelectDirective],
                    imports: [BentoUtilsModule],
                    exports: [BentoSelectDirective]
                }]
        }] });

class BentoPaginationModule extends ConsumerDataValidator {
}
BentoPaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPaginationModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoPaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPaginationModule, declarations: [BentoPaginationComponent], imports: [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        FormsModule,
        BentoSelectModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule], exports: [BentoPaginationComponent] });
BentoPaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPaginationModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            FormsModule,
            BentoSelectModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoUtilsModule,
                        FormsModule,
                        BentoSelectModule,
                        BentoFocusMonitorModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule
                    ],
                    declarations: [BentoPaginationComponent],
                    exports: [BentoPaginationComponent]
                }]
        }] });

/**
 * Transition utility to help custom transitions
 */
const EasingFunctions = {
    // no easing, no acceleration
    linear: t => t,
    // accelerating from zero velocity
    easeInQuad: t => t * t,
    // decelerating to zero velocity
    easeOutQuad: t => t * (2 - t),
    // acceleration until halfway, then deceleration
    easeInOutQuad: t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
    // accelerating from zero velocity
    easeInCubic: t => t * t * t,
    // decelerating to zero velocity
    easeOutCubic: t => --t * t * t + 1,
    // acceleration until halfway, then deceleration
    easeInOutCubic: t => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
    // accelerating from zero velocity
    easeInQuart: t => t * t * t * t,
    // decelerating to zero velocity
    easeOutQuart: t => 1 - --t * t * t * t,
    // acceleration until halfway, then deceleration
    easeInOutQuart: t => (t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t),
    // accelerating from zero velocity
    easeInQuint: t => t * t * t * t * t,
    // decelerating to zero velocity
    easeOutQuint: t => 1 + --t * t * t * t * t,
    // acceleration until halfway, then deceleration
    easeInOutQuint: t => (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t)
};
class BentoTransition {
    constructor() {
        /**
         * Initial value before the transition starts
         */
        this.beginVal = 0;
        /**
         * Final value when the transition ends
         */
        this.endVal = 1;
        /**
         * Ease
         */
        this.ease = EasingFunctions.easeOutCubic;
        /**
         * Private variables
         */
        this._tickCallbackStack = [];
        this._doneCallbackStack = [];
        try {
            // Running in browsers
            this.window = window;
        }
        catch (e) {
            // Running in SSR mode
            // Polyfill with dummy here
            this.window = {
                cancelAnimationFrame: id => { },
                requestAnimationFrame: func => {
                    return 0;
                }
            };
        }
    }
    /**
     * Start the transition
     */
    start() {
        this._dVal = this.endVal - this.beginVal;
        this._startTime = null;
        this._tick();
    }
    /**
     * Stop the transition
     */
    stop() {
        this.window.cancelAnimationFrame(this._rAFID);
    }
    /**
     * Add onTick callback function to this class
     */
    onTick(func) {
        if (this._tickCallbackStack.indexOf(func) < 0) {
            this._tickCallbackStack.push(func);
        }
    }
    /**
     * Remove a onTick callback function to this class
     */
    offTick(func) {
        const fnIndex = this._tickCallbackStack.indexOf(func);
        if (fnIndex >= 0) {
            this._tickCallbackStack.splice(fnIndex, 1);
        }
    }
    /**
     * Add onDone callback function to this class
     */
    onDone(func) {
        if (this._doneCallbackStack.indexOf(func) < 0) {
            this._doneCallbackStack.push(func);
        }
    }
    /**
     * Tick function to call the position at the given time
     */
    _tick(time) {
        if (this._startTime == null && time != null) {
            this._startTime = time;
        }
        const dTime = (time || 0) - this._startTime;
        const vRatio = this.ease(Math.min(1, dTime / this.duration));
        let val;
        if (vRatio === 1) {
            // Done with the transition
            this.fireTickCallbacks(this.endVal);
            this.fireDoneCallbacks(this.endVal);
        }
        else {
            // Update the current val
            val = this.beginVal + this._dVal * vRatio;
            this.fireTickCallbacks(val);
            // Move to the next tick
            this._rAFID = this.window['requestAnimationFrameTest']
                ? // Made for testing
                    this.window['requestAnimationFrameTest'](this._tick.bind(this))
                : // The real thing
                    this.window.requestAnimationFrame(this._tick.bind(this));
        }
    }
    /**
     * Fire callback functions from the callback stack
     */
    fireTickCallbacks(val) {
        for (let i = 0, len = this._tickCallbackStack.length; i < len; i++) {
            this._tickCallbackStack[i](val);
        }
    }
    /**
     * Fire callback functions from the callback stack
     */
    fireDoneCallbacks(val) {
        for (let i = 0, len = this._doneCallbackStack.length; i < len; i++) {
            this._doneCallbackStack[i](val);
        }
    }
}

const TRANSITON_DURATION = 750;
class BentoScrollableBarComponent {
    constructor(elRef, r, tween, bentoNotification, dir) {
        this.r = r;
        this.tween = tween;
        this.dir = dir;
        this.hasScroll = false;
        // Virtually private variables
        this._isLeftArrowDisabled = false;
        this._isRightArrowDisabled = false;
        this.el = elRef.nativeElement;
        // Bind `this` to listeners
        this.onInnerScroll = this.onInnerScroll.bind(this);
        this.renderUI = this.renderUI.bind(this);
        this.onMouseScroll = this.onMouseScroll.bind(this);
        this.onScrollTransitionTick = this.onScrollTransitionTick.bind(this);
        // Add resize subscription
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe(this.renderUI);
        // Setup tween
        this.tween.onTick(this.onScrollTransitionTick);
        this.tween.duration = TRANSITON_DURATION;
        this.tween.ease = EasingFunctions.easeOutQuint;
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.innerEl = this.el.querySelector('.bento-scrollable-bar-inner');
            this.innerScrollSubscription = fromEvent(this.innerEl, 'scroll').subscribe(this.onInnerScroll);
            this.r.listen(this.innerEl, 'wheel', this.onMouseScroll);
            yield Promise.resolve();
            yield this.refresh();
        });
    }
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
        this.innerScrollSubscription.unsubscribe();
        this.tween.offTick(this.onScrollTransitionTick);
    }
    /**
     * Scroll forward to the next half of screen
     */
    scrollForward() {
        const maxScroll = this.innerEl.scrollWidth - this.innerEl.offsetWidth;
        this.tween.stop();
        this.tween.beginVal = this.innerEl.scrollLeft;
        this.tween.endVal = this.innerEl.scrollLeft + this.innerEl.offsetWidth * 0.5;
        if (this.tween.endVal > maxScroll) {
            this.tween.endVal = maxScroll;
        }
        this.tween.start();
    }
    /**
     * Scroll back to the previous screen
     */
    scrollBack() {
        this.tween.stop();
        this.tween.beginVal = this.innerEl.scrollLeft;
        this.tween.endVal = this.innerEl.scrollLeft - this.innerEl.offsetWidth * 0.5;
        if (this.tween.endVal < 0) {
            this.tween.endVal = 0;
        }
        this.tween.start();
    }
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     */
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.renderUI(() => this.r.setProperty(this.innerEl, 'scrollLeft', 0));
        });
    }
    /**
     * Scroll content on mouse vertical scroll
     */
    onMouseScroll(e) {
        let delta;
        if (e.deltaX === 0) {
            delta = this.dir.value === 'rtl' ? -e.deltaY : e.deltaY;
        }
        else {
            delta = e.deltaX;
        }
        // Only apply to vertical scroll. eg Mouse wheels
        this.r.setProperty(this.innerEl, 'scrollLeft', this.innerEl.scrollLeft + delta);
        e.preventDefault();
        e.stopPropagation();
    }
    /**
     * Display scroll
     * @param val the value from the current transtion tick
     */
    onScrollTransitionTick(val) {
        this.r.setProperty(this.innerEl, 'scrollLeft', val);
    }
    /**
     * Callback when the inner container is scrolled
     * We will need to check the arrow states
     * @param e
     */
    onInnerScroll(e) {
        const scrollLeft = this.innerEl.scrollLeft;
        if (scrollLeft === 0) {
            this._isLeftArrowDisabled = true;
            this._isRightArrowDisabled = false;
        }
        else if (scrollLeft + this.innerEl.offsetWidth === this.innerEl.scrollWidth) {
            this._isLeftArrowDisabled = false;
            this._isRightArrowDisabled = true;
        }
        else {
            this._isLeftArrowDisabled = false;
            this._isRightArrowDisabled = false;
        }
    }
    /**
     * Render arrows and gradients based on the width of this bar
     */
    renderUI(onComplete) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hasScroll = this.innerEl.scrollWidth > this.el.offsetWidth;
            if (this.hasScroll) {
                yield Promise.resolve();
                if (typeof onComplete === 'function') {
                    onComplete();
                }
                this.onInnerScroll();
            }
        });
    }
}
BentoScrollableBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableBarComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BentoTransition }, { token: BentoNotification }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoScrollableBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoScrollableBarComponent, selector: "bento-scrollable-bar", host: { properties: { "class.bento-scroll-bar-has-scroll": "this.hasScroll" } }, providers: [BentoNotification, BentoTransition, WindowRef], ngImport: i0, template: "<button\n  class=\"bento-scrollable-bar-side-arrow left\"\n  type=\"button\"\n  cdkMonitorElementFocus\n  [disabled]=\"_isLeftArrowDisabled\"\n  (click)=\"scrollBack()\"\n  aria-keyshortcuts=\"left\"\n  [attr.aria-label]=\"'BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT' | bentoTranslate\"\n>\n  <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-scrollable-bar-left-anchor\" tabindex=\"-1\"></div>\n<div class=\"bento-scrollable-bar-inner\">\n  <div>\n    <ng-content></ng-content>\n  </div>\n</div>\n<div class=\"bento-scrollable-bar-right-anchor\" tabindex=\"-1\"></div>\n<button\n  class=\"bento-scrollable-bar-side-arrow right\"\n  type=\"button\"\n  cdkMonitorElementFocus\n  [disabled]=\"_isRightArrowDisabled\"\n  (click)=\"scrollForward()\"\n  aria-keyshortcuts=\"right\"\n  [attr.aria-label]=\"'BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT' | bentoTranslate\"\n>\n  <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-scrollable-bar-cover left\" [hidden]=\"_isLeftArrowDisabled\"></div>\n<div class=\"bento-scrollable-bar-cover right\" [hidden]=\"_isRightArrowDisabled\"></div>\n", styles: [".ng-bento bento-scrollable-bar{display:block;position:relative;width:100%}.ng-bento .bento-scrollable-bar-inner{width:100%;overflow:hidden;position:relative;-webkit-overflow-scrolling:touch;-ms-overflow-style:none}.ng-bento .bento-scrollable-bar-inner::-webkit-scrollbar{display:none}.ng-bento .bento-scrollable-bar-inner>div{display:inline-block;white-space:nowrap}.ng-bento .bento-scrollable-bar-right-anchor,.ng-bento .bento-scrollable-bar-left-anchor{width:0;height:0;position:absolute}.ng-bento button.bento-scrollable-bar-side-arrow{background:none;border:none;bottom:1px;cursor:default;display:none;font-size:1.2em;line-height:0;padding:0;position:absolute;text-align:center;top:0;transition:opacity .1s;z-index:1}.ng-bento button.bento-scrollable-bar-side-arrow i{opacity:.7}.ng-bento button.bento-scrollable-bar-side-arrow.left{left:0}.ng-bento button.bento-scrollable-bar-side-arrow.right{right:0}.ng-bento button.bento-scrollable-bar-side-arrow:hover i,.ng-bento button.bento-scrollable-bar-side-arrow:active i,.ng-bento button.bento-scrollable-bar-side-arrow:focus i{opacity:1}.ng-bento button.bento-scrollable-bar-side-arrow:focus{outline:none}.ng-bento button.bento-scrollable-bar-side-arrow[disabled],.ng-bento button.bento-scrollable-bar-side-arrow.disabled{background:transparent;opacity:.3}.ng-bento .bento-scroll-bar-has-scroll button.bento-scrollable-bar-side-arrow,.ng-bento .bento-scroll-bar-has-scroll .bento-scrollable-bar-cover{display:flex;align-items:center}.ng-bento .bento-scrollable-bar-cover{display:none;height:100%;position:absolute;pointer-events:none;top:0}\n"], directives: [{ type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-scrollable-bar', encapsulation: ViewEncapsulation.None, providers: [BentoNotification, BentoTransition, WindowRef], template: "<button\n  class=\"bento-scrollable-bar-side-arrow left\"\n  type=\"button\"\n  cdkMonitorElementFocus\n  [disabled]=\"_isLeftArrowDisabled\"\n  (click)=\"scrollBack()\"\n  aria-keyshortcuts=\"left\"\n  [attr.aria-label]=\"'BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT' | bentoTranslate\"\n>\n  <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-scrollable-bar-left-anchor\" tabindex=\"-1\"></div>\n<div class=\"bento-scrollable-bar-inner\">\n  <div>\n    <ng-content></ng-content>\n  </div>\n</div>\n<div class=\"bento-scrollable-bar-right-anchor\" tabindex=\"-1\"></div>\n<button\n  class=\"bento-scrollable-bar-side-arrow right\"\n  type=\"button\"\n  cdkMonitorElementFocus\n  [disabled]=\"_isRightArrowDisabled\"\n  (click)=\"scrollForward()\"\n  aria-keyshortcuts=\"right\"\n  [attr.aria-label]=\"'BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT' | bentoTranslate\"\n>\n  <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-scrollable-bar-cover left\" [hidden]=\"_isLeftArrowDisabled\"></div>\n<div class=\"bento-scrollable-bar-cover right\" [hidden]=\"_isRightArrowDisabled\"></div>\n", styles: [".ng-bento bento-scrollable-bar{display:block;position:relative;width:100%}.ng-bento .bento-scrollable-bar-inner{width:100%;overflow:hidden;position:relative;-webkit-overflow-scrolling:touch;-ms-overflow-style:none}.ng-bento .bento-scrollable-bar-inner::-webkit-scrollbar{display:none}.ng-bento .bento-scrollable-bar-inner>div{display:inline-block;white-space:nowrap}.ng-bento .bento-scrollable-bar-right-anchor,.ng-bento .bento-scrollable-bar-left-anchor{width:0;height:0;position:absolute}.ng-bento button.bento-scrollable-bar-side-arrow{background:none;border:none;bottom:1px;cursor:default;display:none;font-size:1.2em;line-height:0;padding:0;position:absolute;text-align:center;top:0;transition:opacity .1s;z-index:1}.ng-bento button.bento-scrollable-bar-side-arrow i{opacity:.7}.ng-bento button.bento-scrollable-bar-side-arrow.left{left:0}.ng-bento button.bento-scrollable-bar-side-arrow.right{right:0}.ng-bento button.bento-scrollable-bar-side-arrow:hover i,.ng-bento button.bento-scrollable-bar-side-arrow:active i,.ng-bento button.bento-scrollable-bar-side-arrow:focus i{opacity:1}.ng-bento button.bento-scrollable-bar-side-arrow:focus{outline:none}.ng-bento button.bento-scrollable-bar-side-arrow[disabled],.ng-bento button.bento-scrollable-bar-side-arrow.disabled{background:transparent;opacity:.3}.ng-bento .bento-scroll-bar-has-scroll button.bento-scrollable-bar-side-arrow,.ng-bento .bento-scroll-bar-has-scroll .bento-scrollable-bar-cover{display:flex;align-items:center}.ng-bento .bento-scrollable-bar-cover{display:none;height:100%;position:absolute;pointer-events:none;top:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BentoTransition }, { type: BentoNotification }, { type: i2.Directionality }]; }, propDecorators: { hasScroll: [{
                type: HostBinding,
                args: ['class.bento-scroll-bar-has-scroll']
            }] } });

class BentoScrollableBarModule extends ConsumerDataValidator {
}
BentoScrollableBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableBarModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoScrollableBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableBarModule, declarations: [BentoScrollableBarComponent], imports: [CommonModule, BentoTranslateModule, A11yModule], exports: [BentoScrollableBarComponent] });
BentoScrollableBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableBarModule, imports: [[CommonModule, BentoTranslateModule, A11yModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, BentoTranslateModule, A11yModule],
                    declarations: [BentoScrollableBarComponent],
                    exports: [BentoScrollableBarComponent]
                }]
        }] });

/**
 * Make NgbDropdown to support keyboard navigations
 */
class BentoToolbarKeyboardSupportDirective {
    constructor(elementRef, windowRef, r, dropdown) {
        this.r = r;
        this.dropdown = dropdown;
        this.document = windowRef.nativeDocument;
        this.el = elementRef.nativeElement;
        this.onToggleKeydown = this.onToggleKeydown.bind(this);
        this.onMenuKeydown = this.onMenuKeydown.bind(this);
        // Add a unique class called (b)ento (ui) (d)rop(d)own (k)eyboard (support)
        this.r.addClass(this.el, BentoToolbarKeyboardSupportDirective.CSS_CLASS_NAME);
    }
    ngAfterViewInit() {
        this.dropdownMenuEl = this.el.querySelector('.dropdown-menu');
        this.toggleEl = this.el.querySelector('.dropdown-toggle');
        this.r.listen(this.toggleEl, 'keydown', this.onToggleKeydown);
        this.r.listen(this.dropdownMenuEl, 'keydown', this.onMenuKeydown);
    }
    onMenuKeydown(e) {
        // wip: This is just a temporary fix to get rid of the console error.
        // need to come up with a solution to address this.
        if (!this.menuItems) {
            return;
        }
        let currentFocusedIndex = this.menuItems.indexOf(this.document.activeElement);
        const menuItemSize = this.menuItems.length;
        currentFocusedIndex = currentFocusedIndex < 0 ? 0 : currentFocusedIndex;
        switch (e.keyCode) {
            case Keyboard.UP:
                this.menuItems[(currentFocusedIndex - 1 + menuItemSize) % menuItemSize].focus();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.DOWN:
                this.menuItems[(currentFocusedIndex + 1) % menuItemSize].focus();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.ESC:
                this.toggleEl.focus();
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout(() => this.dropdown.close());
                break;
        }
    }
    onToggleKeydown(e) {
        switch (e.keyCode) {
            case Keyboard.UP:
            case Keyboard.DOWN:
                this.showDropdown();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout(() => this.dropdown.close());
                break;
        }
    }
    showDropdown() {
        this.menuItems = Array.from(this.dropdownMenuEl.querySelectorAll('[role="menuitem"]'));
        this.dropdown.open();
        this.menuItems[0].focus();
    }
}
// Class name used to determine if the HTMLElement is initialized already or not
// (B)ento (T)ool(B)ar (K)eyboard (Support)
BentoToolbarKeyboardSupportDirective.CSS_CLASS_NAME = 'bui-tb-k-support';
BentoToolbarKeyboardSupportDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarKeyboardSupportDirective, deps: [{ token: i0.ElementRef }, { token: WindowRef }, { token: i0.Renderer2 }, { token: forwardRef(() => NgbDropdown) }], target: i0.ɵɵFactoryTarget.Directive });
BentoToolbarKeyboardSupportDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoToolbarKeyboardSupportDirective, selector: "[bentoToolbarKeyboardSupport]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarKeyboardSupportDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoToolbarKeyboardSupport]'
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: WindowRef }, { type: i0.Renderer2 }, { type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }];
    } });

class BentoScrollableToolbarItemComponent {
    constructor() {
        /**
         * Menu Item
         */
        this.item = {};
    }
    ngOnDestroy() {
        if (this.dropdown) {
            this.dropdown.hide();
        }
    }
}
BentoScrollableToolbarItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BentoScrollableToolbarItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoScrollableToolbarItemComponent, selector: "bento-scrollable-toolbar-item", inputs: { item: "item", appendTo: "appendTo" }, viewQueries: [{ propertyName: "dropdown", first: true, predicate: BentoNgbDropdownAppendToDirective, descendants: true }], ngImport: i0, template: "<div ngbDropdown bentoToolbarKeyboardSupport placement=\"left\" *ngIf=\"!item.hidden && item.dropdown; else megamenu\">\n  <button\n    ngbDropdownToggle\n    cdkMonitorElementFocus\n    type=\"button\"\n    role=\"menuitem\"\n    class=\"bui-menu-item\"\n    [attr.id]=\"'toggleDropdown' + item.label\"\n    aria-haspopup=\"true\"\n    (click)=\"item.action && item.action()\"\n    [disabled]=\"item.disabled\"\n  >\n    <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n    {{ item.label }}\n  </button>\n  <div\n    class=\"dropdown-menu bui-bento-scrollable-toolbar-dropdown-menu\"\n    ngbDropdownMenu\n    [bentoAppendTo]=\"appendTo\"\n    [autoRealign]=\"true\"\n    [attr.aria-labelledby]=\"'toggleDropdown' + item.label\"\n    role=\"menu\"\n  >\n    <ng-container *ngFor=\"let dropdownItem of item.dropdown\">\n      <button\n        class=\"dropdown-item\"\n        cdkMonitorElementFocus\n        *ngIf=\"!dropdownItem.hidden\"\n        [attr.id]=\"dropdownItem.id ? dropdownItem.id : null\"\n        role=\"menuitem\"\n        tabindex=\"-1\"\n        (click)=\"dropdownItem.action && dropdownItem.action()\"\n        [disabled]=\"dropdownItem.disabled\"\n      >\n        <i *ngIf=\"dropdownItem.icon\" [attr.class]=\"dropdownItem.icon\" aria-hidden=\"true\"></i>\n        {{ dropdownItem.label }}\n      </button>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #megamenu>\n  <div ngbDropdown bentoToolbarKeyboardSupport placement=\"left\" *ngIf=\"item.megamenu; else customTemplate\">\n    <button\n      ngbDropdownToggle\n      cdkMonitorElementFocus\n      type=\"button\"\n      role=\"menuitem\"\n      [attr.id]=\"'toggleDropdown' + item.label\"\n      (click)=\"item.action && item.action()\"\n      aria-haspopup=\"true\"\n      class=\"bui-menu-item\"\n      [disabled]=\"item.disabled\"\n    >\n      <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n      {{ item.label }}\n    </button>\n    <bento-megamenu\n      *ngIf=\"item.megamenu\"\n      [bentoAppendTo]=\"appendTo\"\n      [autoRealign]=\"true\"\n      [items]=\"item.megamenu\"\n      [type]=\"item.type\"\n      [maxWidth]=\"item.maxWidth\"\n      [flowColumnWidth]=\"item.flowColumnWidth\"\n      [widthElRef]=\"appendTo\"\n      [hTagRank]=\"'3'\"\n      [attr.aria-label]=\"item.ariaLabel ? item.ariaLabel : null\"\n      [isEmbedded]=\"true\"\n    ></bento-megamenu>\n  </div>\n</ng-template>\n\n<ng-template #customTemplate>\n  <ng-container *ngIf=\"item.templateRef; else buttonOnly\">\n    <div class=\"bento-toolbar-custom-item\">\n      <ng-content *ngTemplateOutlet=\"item.templateRef; context: {control: this.item.control}\"></ng-content>\n    </div>\n  </ng-container>\n</ng-template>\n\n<ng-template #buttonOnly>\n  <button\n    type=\"button\"\n    cdkMonitorElementFocus\n    role=\"menuitem\"\n    *ngIf=\"!item.hidden\"\n    [hidden]=\"item.hidden\"\n    (click)=\"item.action && item.action()\"\n    [ngClass]=\"item.class || item.cssClass\"\n    [disabled]=\"item.disabled\"\n    [attr.id]=\"item.id ? item.id : null\"\n    class=\"bui-menu-item\"\n  >\n    <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n    {{ item.label }}\n  </button>\n</ng-template>\n", styles: [".ng-bento bento-scrollable-toolbar{display:block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:0;border-top-width:1px;border-bottom-width:1px;height:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled],.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled{background:transparent}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}.ng-bento ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}.ng-bento ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.ng-bento .bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.ng-bento .bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}\n"], components: [{ type: BentoMegamenuComponent, selector: "bento-megamenu", inputs: ["items", "widthElRef", "maxWidth", "flowColumnWidth", "bentoAppendTo", "type", "hTagRank", "isEmbedded", "ariaLabel"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: BentoToolbarKeyboardSupportDirective, selector: "[bentoToolbarKeyboardSupport]" }, { type: i1$1.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: BentoNgbDropdownAppendToDirective, selector: "[bentoAppendTo].dropdown-menu, bento-megamenu[bentoAppendTo]", inputs: ["bentoAppendTo", "autoRealign", "offset"] }, { type: i1$1.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: BentoAppendToDirective, selector: "[bentoAppendTo]:not(.dropdown-menu)", inputs: ["bentoAppendTo", "referenceTo", "reszieWidthToReference", "autoHideOnContainerScroll", "alignment", "autoVerticalAlignment", "open", "side"], outputs: ["openChange"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-scrollable-toolbar-item', encapsulation: ViewEncapsulation.None, template: "<div ngbDropdown bentoToolbarKeyboardSupport placement=\"left\" *ngIf=\"!item.hidden && item.dropdown; else megamenu\">\n  <button\n    ngbDropdownToggle\n    cdkMonitorElementFocus\n    type=\"button\"\n    role=\"menuitem\"\n    class=\"bui-menu-item\"\n    [attr.id]=\"'toggleDropdown' + item.label\"\n    aria-haspopup=\"true\"\n    (click)=\"item.action && item.action()\"\n    [disabled]=\"item.disabled\"\n  >\n    <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n    {{ item.label }}\n  </button>\n  <div\n    class=\"dropdown-menu bui-bento-scrollable-toolbar-dropdown-menu\"\n    ngbDropdownMenu\n    [bentoAppendTo]=\"appendTo\"\n    [autoRealign]=\"true\"\n    [attr.aria-labelledby]=\"'toggleDropdown' + item.label\"\n    role=\"menu\"\n  >\n    <ng-container *ngFor=\"let dropdownItem of item.dropdown\">\n      <button\n        class=\"dropdown-item\"\n        cdkMonitorElementFocus\n        *ngIf=\"!dropdownItem.hidden\"\n        [attr.id]=\"dropdownItem.id ? dropdownItem.id : null\"\n        role=\"menuitem\"\n        tabindex=\"-1\"\n        (click)=\"dropdownItem.action && dropdownItem.action()\"\n        [disabled]=\"dropdownItem.disabled\"\n      >\n        <i *ngIf=\"dropdownItem.icon\" [attr.class]=\"dropdownItem.icon\" aria-hidden=\"true\"></i>\n        {{ dropdownItem.label }}\n      </button>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #megamenu>\n  <div ngbDropdown bentoToolbarKeyboardSupport placement=\"left\" *ngIf=\"item.megamenu; else customTemplate\">\n    <button\n      ngbDropdownToggle\n      cdkMonitorElementFocus\n      type=\"button\"\n      role=\"menuitem\"\n      [attr.id]=\"'toggleDropdown' + item.label\"\n      (click)=\"item.action && item.action()\"\n      aria-haspopup=\"true\"\n      class=\"bui-menu-item\"\n      [disabled]=\"item.disabled\"\n    >\n      <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n      {{ item.label }}\n    </button>\n    <bento-megamenu\n      *ngIf=\"item.megamenu\"\n      [bentoAppendTo]=\"appendTo\"\n      [autoRealign]=\"true\"\n      [items]=\"item.megamenu\"\n      [type]=\"item.type\"\n      [maxWidth]=\"item.maxWidth\"\n      [flowColumnWidth]=\"item.flowColumnWidth\"\n      [widthElRef]=\"appendTo\"\n      [hTagRank]=\"'3'\"\n      [attr.aria-label]=\"item.ariaLabel ? item.ariaLabel : null\"\n      [isEmbedded]=\"true\"\n    ></bento-megamenu>\n  </div>\n</ng-template>\n\n<ng-template #customTemplate>\n  <ng-container *ngIf=\"item.templateRef; else buttonOnly\">\n    <div class=\"bento-toolbar-custom-item\">\n      <ng-content *ngTemplateOutlet=\"item.templateRef; context: {control: this.item.control}\"></ng-content>\n    </div>\n  </ng-container>\n</ng-template>\n\n<ng-template #buttonOnly>\n  <button\n    type=\"button\"\n    cdkMonitorElementFocus\n    role=\"menuitem\"\n    *ngIf=\"!item.hidden\"\n    [hidden]=\"item.hidden\"\n    (click)=\"item.action && item.action()\"\n    [ngClass]=\"item.class || item.cssClass\"\n    [disabled]=\"item.disabled\"\n    [attr.id]=\"item.id ? item.id : null\"\n    class=\"bui-menu-item\"\n  >\n    <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n    {{ item.label }}\n  </button>\n</ng-template>\n", styles: [".ng-bento bento-scrollable-toolbar{display:block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:0;border-top-width:1px;border-bottom-width:1px;height:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled],.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled{background:transparent}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}.ng-bento ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}.ng-bento ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.ng-bento .bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.ng-bento .bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}\n"] }]
        }], propDecorators: { item: [{
                type: Input
            }], appendTo: [{
                type: Input
            }], dropdown: [{
                type: ViewChild,
                args: [BentoNgbDropdownAppendToDirective]
            }] } });

/**
 * Function is used to trigger mouse events manually
 * https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent
 */
function triggerMouseEvent(node, eventType, mouseEventInit) {
    const event = new MouseEvent(eventType, mouseEventInit || { bubbles: true, cancelable: true });
    node.dispatchEvent(event);
}
/**
 * Function is used to trigger mouse events manually
 * https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent
 */
function triggerPointerEvent(node, eventType, pointerEventInit) {
    const event = new PointerEvent(eventType, pointerEventInit || { bubbles: true, cancelable: true });
    node.dispatchEvent(event);
}
/**
 * Function is used to trigger mouse events manually
 * https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent/TouchEvent
 *
 * Supported Browsers: https://caniuse.com/#search=touch
 */
function triggerTouchEvent(node, eventType, touchEventInit) {
    const event = new TouchEvent(eventType, touchEventInit || { bubbles: true, cancelable: true });
    node.dispatchEvent(event);
}
/**
 * Function is used to trigger keyboard events manually
 *
 */
function triggerKeyboardEvent(node, eventType, keyCode, altKey = false, ctrlKey = false, shiftKey = false, metaKey = false, bubbles = false) {
    let e;
    e = createNewEvent(eventType, bubbles);
    e.key = String.fromCharCode(keyCode); // just enter the char you want to send
    e.keyCode = keyCode;
    e.charCode = keyCode;
    e.which = keyCode;
    e.altKey = altKey;
    e.ctrlKey = ctrlKey;
    e.shiftKey = shiftKey;
    e.metaKey = metaKey;
    node.dispatchEvent(e);
    return e;
}
/**
 * Gain focus then send a string into an inputfield and notify the inputfield on change
 */
function sendKeyValueToInputWithString(input, str) {
    const lastCharCode = str.charCodeAt(str.length - 1);
    input.focus();
    input.value = str;
    triggerKeyboardEvent(input, 'keydown', lastCharCode);
    triggerKeyboardEvent(input, 'keypress', lastCharCode);
    triggerKeyboardEvent(input, 'input', lastCharCode);
    triggerKeyboardEvent(input, 'keyup', lastCharCode);
}
function createNewEvent(eventName, bubbles) {
    let newEvent;
    if (typeof Event === 'function') {
        newEvent = new Event(eventName, { bubbles });
    }
    else {
        try {
            // for IE 11
            newEvent = document.createEvent('Event');
            newEvent.initEvent(eventName, bubbles, true);
        }
        catch (e) { }
    }
    return newEvent;
}

/**
 * Scrollable Toolbar similar to [Bento Toolbar](#/components/toolbar)
 * takes inspiration from the
 * [Bootstrap Navbar](https://getbootstrap.com/docs/4.0/components/navbar/), but
 * take pains to go beyond that to include responsive behaviors, as well as
 * ARIA roles as we work toward WCAG 2.0 Level AA (Accessibility) conformance.
 *
 * The content that displays menu items becomes side scrollable when visible
 * area becomes limited.
 *
 */
class BentoScrollableToolbarComponent {
    constructor(elRef, dir) {
        this.dir = dir;
        /**
         * Items that takes both `BentoToolbarItem` for default bahaviors similar to Bento Toolbar, or using own templates
         * for custom toolbar items
         */
        this.items = [];
        this.el = elRef.nativeElement;
    }
    /**
     * Listen to the left and right arrow key events
     */
    onElKeydown(e) {
        const isRTL = this.dir.value === 'rtl';
        switch (e.keyCode) {
            case Keyboard.LEFT:
                this.shiftItemFocus(isRTL ? 1 : -1, e);
                break;
            case Keyboard.RIGHT:
                this.shiftItemFocus(isRTL ? -1 : 1, e);
                break;
            case Keyboard.TAB:
                let item;
                const targetClassName = e.target.className.trim();
                if (e.shiftKey && targetClassName === 'bento-scrollable-bar-side-arrow right') {
                    item = this.findVisibleMenuItem(false);
                }
                else if (targetClassName === 'bento-scrollable-bar-side-arrow left' && !e.shiftKey) {
                    item = this.findVisibleMenuItem();
                }
                if (item) {
                    item.focus();
                    e.preventDefault();
                }
                break;
        }
    }
    onElementFocus(el) {
        if (el.classList.contains('bui-menu-item')) {
            this.currentFocusedEl = el;
        }
    }
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     */
    refresh() {
        this.scrollBar.refresh();
    }
    ngAfterViewInit() { }
    /**
     * Keydown listener for the scrollable bar
     */
    _onScrollableBarKeydown(e) {
        const target = e.target;
        if (e.keyCode === Keyboard.TAB && !target.classList.contains('bento-scrollable-bar-side-arrow')) {
            const anchor = this.scrollBar.el.querySelector(e.shiftKey ? '.bento-scrollable-bar-left-anchor' : '.bento-scrollable-bar-right-anchor');
            anchor.focus();
        }
    }
    /**
     * Find visible menu in scrollable pane
     */
    findVisibleMenuItem(fromLeft = true) {
        const scrollEl = this.scrollBar.innerEl;
        const itemArray = Array.from(scrollEl.querySelectorAll('bento-scrollable-toolbar-item'));
        const itemArraySize = itemArray.length;
        const viewLeft = scrollEl.scrollLeft;
        const viewRight = viewLeft + scrollEl.offsetWidth;
        let itemToFocus;
        if (fromLeft) {
            for (let i = 0; i < itemArraySize; i++) {
                const item = itemArray[i];
                if ((itemToFocus = this.isItemInView(item, viewLeft, viewRight))) {
                    return itemToFocus;
                }
            }
        }
        else {
            for (let i = itemArraySize - 1; i >= 0; i--) {
                const item = itemArray[i];
                if ((itemToFocus = this.isItemInView(item, viewLeft, viewRight))) {
                    return itemToFocus;
                }
            }
        }
    }
    isItemInView(el, viewLeft, viewRight) {
        const elCenter = (el.offsetLeft * 2 + el.offsetWidth) * 0.5;
        const item = el.querySelector('.bui-menu-item:not(:disabled)');
        if (item && elCenter > viewLeft && elCenter < viewRight) {
            return item;
        }
        return null;
    }
    /**
     * Shift and focus to the next element based on the index
     */
    shiftItemFocus(direction, e) {
        if (this.currentFocusedEl.tagName === 'INPUT' && this.currentFocusedEl['type'] === 'text') {
            // For input type="text"
            const inputEl = this.currentFocusedEl;
            const start = inputEl.selectionStart;
            const end = inputEl.selectionEnd;
            const inputLength = inputEl.value ? inputEl.value.length : 0;
            if (start === end) {
                if ((direction === 1 && start < inputLength) || (direction === -1 && start > 0)) {
                    return;
                }
            }
        }
        const els = this.getAriaHaspopupEl();
        const activeElIndex = els.indexOf(this.currentFocusedEl);
        const activeExpanded = this.currentFocusedEl
            ? this.currentFocusedEl.getAttribute('aria-expanded') === 'true'
            : false;
        const elToFocus = els[(activeElIndex + direction + els.length) % els.length];
        elToFocus.focus();
        e.preventDefault();
        if (activeExpanded && elToFocus.classList.contains('dropdown-toggle')) {
            // Manually trigger down arrow event for BentoDropdownKeyboardSupportDirective to catch the expansion
            triggerKeyboardEvent(elToFocus, 'keydown', Keyboard.DOWN);
        }
    }
    /**
     * All elements that are disabled with `.bui-menu-item` will be selected
     */
    getAriaHaspopupEl() {
        return Array.from(this.el.querySelectorAll('.bui-menu-item:not(:disabled)'));
    }
}
BentoScrollableToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarComponent, deps: [{ token: i0.ElementRef }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoScrollableToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoScrollableToolbarComponent, selector: "bento-scrollable-toolbar", inputs: { items: "items" }, host: { listeners: { "keydown": "onElKeydown($event)", "focusin": "onElementFocus($event.target)" } }, viewQueries: [{ propertyName: "scrollBar", first: true, predicate: BentoScrollableBarComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"bento-scrollable-toolbar-wrapper bui-bento-toolbar bento-toolbar\">\n  <div class=\"bento-scrollable-toolbar-inner\" role=\"menu\">\n    <ng-content select=\".navbar-left\"></ng-content>\n    <div class=\"navbar-nav\">\n      <bento-scrollable-bar (keydown)=\"_onScrollableBarKeydown($event)\">\n        <ul class=\"bento-scrollable-toolbar-inner-menu\">\n          <li *ngFor=\"let item of items\">\n            <bento-scrollable-toolbar-item [item]=\"item\" [appendTo]=\"el\"></bento-scrollable-toolbar-item>\n          </li>\n        </ul>\n      </bento-scrollable-bar>\n    </div>\n    <ng-content select=\".navbar-right\"></ng-content>\n  </div>\n</div>\n", styles: [".ng-bento bento-toolbar,.ng-bento .bui-bento-toolbar{border-style:solid;border-width:1px}.ng-bento bento-toolbar .bento-smart-badge,.ng-bento .bui-bento-toolbar .bento-smart-badge{position:relative;left:auto;bottom:auto;right:auto;vertical-align:super;display:inline-block;top:50%;transform:translateY(-50%)}.ng-bento bento-toolbar .navbar-nav,.ng-bento .bui-bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.ng-bento bento-toolbar .navbar-nav>li.transparent,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.ng-bento .bui-bento-toolbar .navbar-nav>li.transparent,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent{opacity:0;height:1px}.ng-bento bento-toolbar .navbar-nav>li>button,.ng-bento bento-toolbar .navbar-nav>li>a,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav>li>button,.ng-bento .bui-bento-toolbar .navbar-nav>li>a,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]{border:none;background:transparent;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.ng-bento bento-toolbar .navbar-nav>li>button:focus,.ng-bento bento-toolbar .navbar-nav>li>a:focus,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus{outline:none}.ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.ng-bento bento-toolbar .divider,.ng-bento .bui-bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle span,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.ng-bento bento-toolbar [ngbdropdown],.ng-bento .bui-bento-toolbar [ngbdropdown]{display:block;position:relative}.ng-bento bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,.ng-bento .bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:after,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:after{content:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"]{vertical-align:middle}[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{text-align:right;padding:0 15px 0 30px}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a[disabled]:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown,.ng-bento .bui-bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.ng-bento bento-toolbar .open.toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.ng-bento bento-toolbar .more-button,.ng-bento .bui-bento-toolbar .more-button{display:none}.ng-bento bento-toolbar .toolbar-dropdown-toggle:after,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .ng-bento bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled{cursor:pointer}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu{list-style:none;max-height:0;overflow:hidden;padding:0;transition:all .3s ease-out;visibility:hidden}.ng-bento bento-toolbar .toolbar-dropdown-menu .divider,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu .divider{display:block}.ng-bento bento-toolbar .toolbar-dropdown-menu>li>a,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.ng-bento bento-toolbar.bg-faded,.ng-bento .bui-bento-toolbar.bg-faded{border:none}.ng-bento bento-toolbar .bento-toolbar-custom-item,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.ng-bento bento-toolbar .bento-toolbar-custom-item label,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .ng-bento bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] .ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}\n", ".ng-bento bento-scrollable-toolbar{display:block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:0;border-top-width:1px;border-bottom-width:1px;height:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled],.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled{background:transparent}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}.ng-bento ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}.ng-bento ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.ng-bento .bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.ng-bento .bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}\n"], components: [{ type: BentoScrollableBarComponent, selector: "bento-scrollable-bar" }, { type: BentoScrollableToolbarItemComponent, selector: "bento-scrollable-toolbar-item", inputs: ["item", "appendTo"] }], directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-scrollable-toolbar', encapsulation: ViewEncapsulation.None, template: "<div class=\"bento-scrollable-toolbar-wrapper bui-bento-toolbar bento-toolbar\">\n  <div class=\"bento-scrollable-toolbar-inner\" role=\"menu\">\n    <ng-content select=\".navbar-left\"></ng-content>\n    <div class=\"navbar-nav\">\n      <bento-scrollable-bar (keydown)=\"_onScrollableBarKeydown($event)\">\n        <ul class=\"bento-scrollable-toolbar-inner-menu\">\n          <li *ngFor=\"let item of items\">\n            <bento-scrollable-toolbar-item [item]=\"item\" [appendTo]=\"el\"></bento-scrollable-toolbar-item>\n          </li>\n        </ul>\n      </bento-scrollable-bar>\n    </div>\n    <ng-content select=\".navbar-right\"></ng-content>\n  </div>\n</div>\n", styles: [".ng-bento bento-toolbar,.ng-bento .bui-bento-toolbar{border-style:solid;border-width:1px}.ng-bento bento-toolbar .bento-smart-badge,.ng-bento .bui-bento-toolbar .bento-smart-badge{position:relative;left:auto;bottom:auto;right:auto;vertical-align:super;display:inline-block;top:50%;transform:translateY(-50%)}.ng-bento bento-toolbar .navbar-nav,.ng-bento .bui-bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.ng-bento bento-toolbar .navbar-nav>li.transparent,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.ng-bento .bui-bento-toolbar .navbar-nav>li.transparent,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent{opacity:0;height:1px}.ng-bento bento-toolbar .navbar-nav>li>button,.ng-bento bento-toolbar .navbar-nav>li>a,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav>li>button,.ng-bento .bui-bento-toolbar .navbar-nav>li>a,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]{border:none;background:transparent;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.ng-bento bento-toolbar .navbar-nav>li>button:focus,.ng-bento bento-toolbar .navbar-nav>li>a:focus,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus{outline:none}.ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.ng-bento bento-toolbar .divider,.ng-bento .bui-bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle span,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.ng-bento bento-toolbar [ngbdropdown],.ng-bento .bui-bento-toolbar [ngbdropdown]{display:block;position:relative}.ng-bento bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,.ng-bento .bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:after,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:after{content:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"]{vertical-align:middle}[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{text-align:right;padding:0 15px 0 30px}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a[disabled]:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown,.ng-bento .bui-bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.ng-bento bento-toolbar .open.toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.ng-bento bento-toolbar .more-button,.ng-bento .bui-bento-toolbar .more-button{display:none}.ng-bento bento-toolbar .toolbar-dropdown-toggle:after,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .ng-bento bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled{cursor:pointer}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu{list-style:none;max-height:0;overflow:hidden;padding:0;transition:all .3s ease-out;visibility:hidden}.ng-bento bento-toolbar .toolbar-dropdown-menu .divider,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu .divider{display:block}.ng-bento bento-toolbar .toolbar-dropdown-menu>li>a,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.ng-bento bento-toolbar.bg-faded,.ng-bento .bui-bento-toolbar.bg-faded{border:none}.ng-bento bento-toolbar .bento-toolbar-custom-item,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.ng-bento bento-toolbar .bento-toolbar-custom-item label,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .ng-bento bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] .ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}\n", ".ng-bento bento-scrollable-toolbar{display:block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] .ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:0;border-top-width:1px;border-bottom-width:1px;height:100%}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled],.ng-bento bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled{background:transparent}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}.ng-bento bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}.ng-bento ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}.ng-bento ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.ng-bento .bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.ng-bento .bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.ng-bento .bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i2.Directionality }]; }, propDecorators: { items: [{
                type: Input
            }], scrollBar: [{
                type: ViewChild,
                args: [BentoScrollableBarComponent, { static: true }]
            }], onElKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onElementFocus: [{
                type: HostListener,
                args: ['focusin', ['$event.target']]
            }] } });

class BentoScrollableToolbarModule extends ConsumerDataValidator {
}
BentoScrollableToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoScrollableToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarModule, declarations: [BentoScrollableToolbarComponent,
        BentoScrollableToolbarItemComponent,
        BentoToolbarKeyboardSupportDirective], imports: [CommonModule,
        BentoTranslateModule,
        BentoScrollableBarModule,
        BentoAppendToModule,
        NgbDropdownModule,
        BentoMegamenuModule,
        BentoFocusMonitorModule,
        A11yModule,
        BentoNgbDropdownAnimationModule], exports: [BentoScrollableToolbarComponent, BentoToolbarKeyboardSupportDirective] });
BentoScrollableToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoScrollableBarModule,
            BentoAppendToModule,
            NgbDropdownModule,
            BentoMegamenuModule,
            BentoFocusMonitorModule,
            A11yModule,
            BentoNgbDropdownAnimationModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoScrollableToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoScrollableBarModule,
                        BentoAppendToModule,
                        NgbDropdownModule,
                        BentoMegamenuModule,
                        BentoFocusMonitorModule,
                        A11yModule,
                        BentoNgbDropdownAnimationModule
                    ],
                    declarations: [
                        BentoScrollableToolbarComponent,
                        BentoScrollableToolbarItemComponent,
                        BentoToolbarKeyboardSupportDirective
                    ],
                    exports: [BentoScrollableToolbarComponent, BentoToolbarKeyboardSupportDirective]
                }]
        }] });

/* eslint-disable  @angular-eslint/component-selector */
/**
 * Bento Side Navigation item component
 */
class BentoSideNavItemComponent {
    constructor(r, cd, router, uidGen, elRef, bidi, ngZone) {
        this.r = r;
        this.cd = cd;
        /**
         * Depth indicator to get the number of levels that it's away from the root item
         */
        this.depth = 0;
        /**
         * Flag to determine if this navigation item is collapsible
         */
        this.collapsible = false;
        /**
         * Select state change event emitter
         */
        this.selectedChange = new EventEmitter();
        /**
         * Flag to show if this item is a branch (aka category)
         */
        this.isBranch = false;
        /**
         * Flag to determine if this component is in a RTL environment
         */
        this.isRTL = false;
        /**
         * Flag to determine if the item data object has been initialized or not
         * to support rendering and event triggering
         */
        this.isDataInitialized = false;
        this.bidiSubscription = Subscription.EMPTY;
        this.routerEventSubscription = Subscription.EMPTY;
        this.el = elRef.nativeElement;
        this.uid = `bui-${uidGen.generate()}`;
        this.isRTL = bidi.value === 'rtl';
        this.bidiSubscription = bidi.change.subscribe(() => {
            this.isRTL = bidi.value === 'rtl';
            cd.markForCheck();
        });
        this.r.setAttribute(this.el, 'id', this.uid + '-li');
        if (router) {
            this.routerEventSubscription = router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    this.cd.markForCheck();
                }
            });
        }
        const ngZoneSub = ngZone.onStable.subscribe(() => {
            if (this.rla && this.rla.isActive && !this.selected) {
                // When this component is dynamically recreated, we need to
                // have another round of change detection to make sure that
                // this.rla.isActive is properly updated and rendered with
                // the current `page` or `location` states
                this.cd.markForCheck();
            }
            // Only execute this method once in the beginning
            ngZoneSub.unsubscribe();
        });
    }
    /**
     * Side navigation item data object that is used in this component
     */
    set _item(item) {
        this.item = item;
        this.hookItemEvents(item);
    }
    /**
     * Using template to forward search (aka filter) value that is entered by user
     */
    set searchValue(v) {
        if (v != null && this.sideNav) {
            // Only filter when the value `v` exists
            this.filter(v);
        }
    }
    /**
     * Object reference to BentoSideNav component
     */
    set _sideNav(sideNav) {
        this.sideNav = sideNav;
        if (sideNav && this.selected) {
            this.sideNav._setCurrentSideNavItem(this.item, this.isDataInitialized);
        }
    }
    /**
     * Get all the child items if there are some
     */
    set _viewItems(items) {
        this.viewItems = items.toArray();
    }
    set ariaCurrent(c) {
        this._ariaCurrent = c;
        switch (c) {
            case 'page':
                this.r.addClass(this.el, 'current-page');
                this.r.removeClass(this.el, 'current-location');
                break;
            case 'location':
                this.r.addClass(this.el, 'current-location');
                this.r.removeClass(this.el, 'current-page');
                break;
            default:
                this.r.removeClass(this.el, 'current-location');
                this.r.removeClass(this.el, 'current-page');
        }
    }
    get ariaCurrent() {
        return this._ariaCurrent;
    }
    ngOnInit() {
        setTimeout(() => {
            this.setAriaExpandedAttribute();
        });
    }
    ngOnDestroy() {
        this.bidiSubscription.unsubscribe();
        this.routerEventSubscription.unsubscribe();
    }
    /**
     * Method to set this item as a branch (aka category) or not based on its property
     * @param v flag to determine if this item is going to be a branch (aka category) or not
     */
    setAsBranch(v) {
        this.isBranch = v;
        this.r.removeClass(this.el, 'bento-side-nav-leaf');
        this.r.removeClass(this.el, 'bento-side-nav-branch');
        this.r.addClass(this.el, v ? 'bento-side-nav-branch' : 'bento-side-nav-leaf');
    }
    /**
     * Callback when one of this item's children is selected
     * @param s Selected flag
     */
    onChildSelectedChange(s) {
        if (s) {
            this.ariaCurrent = 'location';
        }
        else {
            this.ariaCurrent = null;
        }
        this.selectedChange.emit(s);
        this.cd.detectChanges();
    }
    /**
     * Callback when the label of this navigation item is clicked
     * @param e Mouse event object
     */
    onItemClick(e) {
        if (this.disabled) {
            // No need to do anything when this item is disabled
            return;
        }
        if (this.isBranch && this.sideNav.categoryExpandOnly) {
            this.toggleCollapse();
        }
        else if (!this.selected && (!this.isBranch || this.sideNav.selectableCategories)) {
            this.item.selected = true;
        }
        if (this.item.action && this.selected) {
            // fire item action function callback if there is one
            this.item.action(e);
        }
    }
    /**
     * Toggle current collapsed state
     */
    toggleCollapse() {
        this.collapsed = !this.collapsed;
        this.setAriaExpandedAttribute();
    }
    /**
     * set collapsed attribute
     */
    setAriaExpandedAttribute() {
        if (this.isBranch && this.collapsible) {
            this.r.setAttribute(this.el, 'aria-expanded', String(!this.collapsed));
        }
    }
    /**
     * Filter this item and its offspring to findout if they should be shown in viewport
     * @param searchValue Actual filter string to be used
     */
    filter(searchValue) {
        const compareFunc = this.sideNav.filterCompareFunc || this.defaultCompareFunc;
        let hasMatch = compareFunc(this.item, searchValue);
        if (this.viewItems && this.viewItems.length) {
            let hasOffspringMatch = false;
            // Check child and see there is a match from filtering
            for (const item of this.viewItems) {
                const itemHasMatch = item.filter(searchValue);
                hasOffspringMatch = itemHasMatch || hasOffspringMatch;
                hasMatch = itemHasMatch || hasMatch;
            }
            if (hasOffspringMatch) {
                // Automatically expand this parent node if one of its
                // offsrpings is a match
                this.collapsed = false;
                this.setAriaExpandedAttribute();
                this.cd.markForCheck();
            }
        }
        this.r.setProperty(this.el, 'hidden', !hasMatch);
        return hasMatch;
    }
    /**
     * Render aria-current for current item
     */
    renderAriaCurrent(rla) {
        if (rla) {
            if (rla.isActive !== this.selected) {
                this.item.selected = rla.isActive;
            }
        }
        return this._ariaCurrent;
    }
    /**
     * Update side nav item data model so it triggers when its data gets updated
     * @param item Vanilla BentoSideNavItem object to be converted with data change hooks
     */
    hookItemEvents(item) {
        const itemCollapsedDescriptor = Object.getOwnPropertyDescriptor(item, 'collapsed');
        if (!itemCollapsedDescriptor || itemCollapsedDescriptor.configurable) {
            const tempItem = Object.assign({}, item);
            Object.defineProperties(item, {
                label: {
                    set: v => {
                        this.label = v;
                        this.cd.markForCheck();
                    },
                    get: () => this.label
                },
                collapsed: {
                    set: v => {
                        this.collapsed = v;
                        this.setAriaExpandedAttribute();
                        this.cd.markForCheck();
                    },
                    get: () => this.collapsed
                },
                disabled: {
                    set: v => {
                        this.disabled = v;
                        this.cd.markForCheck();
                    },
                    get: () => this.disabled
                },
                selected: {
                    set: v => {
                        if (typeof v !== 'boolean') {
                            return;
                        }
                        this.selected = v;
                        if (v) {
                            setTimeout(() => {
                                var _a;
                                (_a = this.sideNav) === null || _a === void 0 ? void 0 : _a._setCurrentSideNavItem(this.item, this.isDataInitialized);
                            });
                            this.ariaCurrent = 'page';
                            this.r.addClass(this.el, 'in');
                            setTimeout(() => {
                                this.r.removeClass(this.el, 'in');
                            }, 17); // 60fps wait for one frame
                        }
                        else {
                            this.ariaCurrent = null;
                        }
                        this.cd.markForCheck();
                    },
                    get: () => this.selected
                },
                items: {
                    set: v => {
                        this.items = v;
                        this.setAsBranch(!!this.item.items);
                        this.cd.markForCheck();
                    },
                    get: () => this.items
                }
            });
            this.item.label = tempItem.label;
            this.item.disabled = tempItem.disabled;
            this.item.selected = tempItem.selected;
            this.item.items = tempItem.items;
            this.item.collapsed = tempItem.collapsed;
            this.isDataInitialized = true;
        }
    }
    /**
     * The default method to compare an item against the filter string
     * @param item BentoSideNavItem object to be used for comparison
     * @param search The search string that is used for comparison
     */
    defaultCompareFunc(item, search) {
        return search.length === 0 || item.label.toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
}
BentoSideNavItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavItemComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i1$3.Router, optional: true }, { token: BentoUidService }, { token: i0.ElementRef }, { token: i2.Directionality }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BentoSideNavItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSideNavItemComponent, selector: "li[bentoSideNavItem]", inputs: { _item: ["item", "_item"], depth: "depth", collapsible: "collapsible", searchValue: "searchValue", _sideNav: ["sideNav", "_sideNav"] }, outputs: { selectedChange: "selectedChange" }, viewQueries: [{ propertyName: "rla", first: true, predicate: ["rla"], descendants: true, read: RouterLinkActive }, { propertyName: "_viewItems", predicate: BentoSideNavItemComponent, descendants: true }], ngImport: i0, template: "<button\n  *ngIf=\"collapsible && isBranch\"\n  cdkMonitorElementFocus\n  class=\"btn-expand-collapse\"\n  type=\"button\"\n  [style.left.px]=\"isRTL ? 0 : depth * 16 + 6\"\n  [style.right.px]=\"isRTL ? depth * 16 + 6 : 0\"\n  [attr.aria-controls]=\"uid + '-li'\"\n  [attr.aria-expanded]=\"isBranch && collapsible ? !collapsed : null\"\n  [attr.aria-labelledby]=\"uid\"\n  (click)=\"toggleCollapse()\"\n>\n  <span [ngClass]=\"collapsed ? 'bento-icon-plus-plain ' : 'bento-icon-minus-plain '\" aria-hidden=\"true\"></span>\n</button>\n<div\n  class=\"label\"\n  [style.padding-left.px]=\"isRTL ? 0 : (collapsible ? depth * 16 + 16 : depth * 16) + 16\"\n  [style.padding-right.px]=\"isRTL ? (collapsible ? depth * 16 + 16 : depth * 16) + 16 : 0\"\n>\n  <a\n    *ngIf=\"item?.routerLink?.href && !(isBranch && sideNav.categoryExpandOnly); else defaultLink\"\n    #rla=\"routerLinkActive\"\n    class=\"d-block\"\n    [attr.id]=\"uid\"\n    [routerLink]=\"item?.routerLink.href\"\n    routerLinkActive\n    [class.disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-current]=\"renderAriaCurrent(rla)\"\n    [rel]=\"renderAriaCurrent(rla)\"\n  >\n    <span *ngIf=\"sideNav.itemTemplate; else defaultLabel\">\n      <ng-container *ngTemplateOutlet=\"sideNav.itemTemplate; context: {item: item}\"></ng-container>\n    </span>\n  </a>\n</div>\n<ul *ngIf=\"items\" [hidden]=\"collapsed\">\n  <li\n    bentoSideNavItem\n    *ngFor=\"let subItem of items\"\n    [item]=\"subItem\"\n    [depth]=\"depth + 1\"\n    [sideNav]=\"sideNav\"\n    [collapsible]=\"collapsible\"\n    (selectedChange)=\"onChildSelectedChange($event)\"\n  ></li>\n</ul>\n\n<ng-template #defaultLabel>\n  <span><span [innerHTML]=\"label\" [class.branch-root]=\"isBranch\"></span></span>\n</ng-template>\n\n<ng-template #defaultLink>\n  <a\n    class=\"d-block\"\n    [attr.id]=\"uid\"\n    [attr.href]=\"disabled || (isBranch && !sideNav.selectableCategories) ? null : '#'\"\n    [attr.aria-disabled]=\"disabled\"\n    (click)=\"$event.preventDefault(); onItemClick($event)\"\n    [class.disabled]=\"disabled\"\n    [attr.aria-current]=\"renderAriaCurrent(null)\"\n    [attr.aria-expanded]=\"isBranch && collapsible ? !collapsed : null\"\n  >\n    <span *ngIf=\"sideNav.itemTemplate; else defaultLabel\">\n      <ng-container *ngTemplateOutlet=\"sideNav.itemTemplate; context: {item: item}\"></ng-container>\n    </span>\n  </a>\n</ng-template>\n", styles: [":host{display:block}:host ul{padding-left:0;padding-right:0}:host .label{position:relative;border-top-width:1px;border-bottom-width:1px;border-top-style:solid;border-bottom-style:solid}:host .label:before{content:\"\";border-right-width:1px;border-right-style:solid;width:4px;height:100%;position:absolute;left:0}:host a{font-size:14px;line-height:1.2;padding:5px 0}:host a>span,:host a>div{position:relative}:host a[aria-disabled=true]{pointer-events:none}:host a:hover,:host a:focus{text-decoration:none}:host a[href]:hover,:host a[href]:focus{text-decoration:underline}:host a:before{display:block;content:\"\";position:absolute;left:0;right:0;top:0;bottom:0}:host.bui-side-nav-is-collapsible{padding-left:20px}:host .btn-expand-collapse{background:none;border:none;width:20px;height:28px;position:absolute;padding:0;z-index:1}:host .branch-root{font-weight:700}:host-context([dir=rtl]) .label:before{content:\"\";border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}\n"], components: [{ type: BentoSideNavItemComponent, selector: "li[bentoSideNavItem]", inputs: ["item", "depth", "collapsible", "searchValue", "sideNav"], outputs: ["selectedChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i1$3.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'li[bentoSideNavItem]', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\n  *ngIf=\"collapsible && isBranch\"\n  cdkMonitorElementFocus\n  class=\"btn-expand-collapse\"\n  type=\"button\"\n  [style.left.px]=\"isRTL ? 0 : depth * 16 + 6\"\n  [style.right.px]=\"isRTL ? depth * 16 + 6 : 0\"\n  [attr.aria-controls]=\"uid + '-li'\"\n  [attr.aria-expanded]=\"isBranch && collapsible ? !collapsed : null\"\n  [attr.aria-labelledby]=\"uid\"\n  (click)=\"toggleCollapse()\"\n>\n  <span [ngClass]=\"collapsed ? 'bento-icon-plus-plain ' : 'bento-icon-minus-plain '\" aria-hidden=\"true\"></span>\n</button>\n<div\n  class=\"label\"\n  [style.padding-left.px]=\"isRTL ? 0 : (collapsible ? depth * 16 + 16 : depth * 16) + 16\"\n  [style.padding-right.px]=\"isRTL ? (collapsible ? depth * 16 + 16 : depth * 16) + 16 : 0\"\n>\n  <a\n    *ngIf=\"item?.routerLink?.href && !(isBranch && sideNav.categoryExpandOnly); else defaultLink\"\n    #rla=\"routerLinkActive\"\n    class=\"d-block\"\n    [attr.id]=\"uid\"\n    [routerLink]=\"item?.routerLink.href\"\n    routerLinkActive\n    [class.disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-current]=\"renderAriaCurrent(rla)\"\n    [rel]=\"renderAriaCurrent(rla)\"\n  >\n    <span *ngIf=\"sideNav.itemTemplate; else defaultLabel\">\n      <ng-container *ngTemplateOutlet=\"sideNav.itemTemplate; context: {item: item}\"></ng-container>\n    </span>\n  </a>\n</div>\n<ul *ngIf=\"items\" [hidden]=\"collapsed\">\n  <li\n    bentoSideNavItem\n    *ngFor=\"let subItem of items\"\n    [item]=\"subItem\"\n    [depth]=\"depth + 1\"\n    [sideNav]=\"sideNav\"\n    [collapsible]=\"collapsible\"\n    (selectedChange)=\"onChildSelectedChange($event)\"\n  ></li>\n</ul>\n\n<ng-template #defaultLabel>\n  <span><span [innerHTML]=\"label\" [class.branch-root]=\"isBranch\"></span></span>\n</ng-template>\n\n<ng-template #defaultLink>\n  <a\n    class=\"d-block\"\n    [attr.id]=\"uid\"\n    [attr.href]=\"disabled || (isBranch && !sideNav.selectableCategories) ? null : '#'\"\n    [attr.aria-disabled]=\"disabled\"\n    (click)=\"$event.preventDefault(); onItemClick($event)\"\n    [class.disabled]=\"disabled\"\n    [attr.aria-current]=\"renderAriaCurrent(null)\"\n    [attr.aria-expanded]=\"isBranch && collapsible ? !collapsed : null\"\n  >\n    <span *ngIf=\"sideNav.itemTemplate; else defaultLabel\">\n      <ng-container *ngTemplateOutlet=\"sideNav.itemTemplate; context: {item: item}\"></ng-container>\n    </span>\n  </a>\n</ng-template>\n", styles: [":host{display:block}:host ul{padding-left:0;padding-right:0}:host .label{position:relative;border-top-width:1px;border-bottom-width:1px;border-top-style:solid;border-bottom-style:solid}:host .label:before{content:\"\";border-right-width:1px;border-right-style:solid;width:4px;height:100%;position:absolute;left:0}:host a{font-size:14px;line-height:1.2;padding:5px 0}:host a>span,:host a>div{position:relative}:host a[aria-disabled=true]{pointer-events:none}:host a:hover,:host a:focus{text-decoration:none}:host a[href]:hover,:host a[href]:focus{text-decoration:underline}:host a:before{display:block;content:\"\";position:absolute;left:0;right:0;top:0;bottom:0}:host.bui-side-nav-is-collapsible{padding-left:20px}:host .btn-expand-collapse{background:none;border:none;width:20px;height:28px;position:absolute;padding:0;z-index:1}:host .branch-root{font-weight:700}:host-context([dir=rtl]) .label:before{content:\"\";border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i1$3.Router, decorators: [{
                        type: Optional
                    }] }, { type: BentoUidService }, { type: i0.ElementRef }, { type: i2.Directionality }, { type: i0.NgZone }];
    }, propDecorators: { _item: [{
                type: Input,
                args: ['item']
            }], depth: [{
                type: Input
            }], collapsible: [{
                type: Input
            }], searchValue: [{
                type: Input
            }], _sideNav: [{
                type: Input,
                args: ['sideNav']
            }], selectedChange: [{
                type: Output
            }], _viewItems: [{
                type: ViewChildren,
                args: [BentoSideNavItemComponent]
            }], rla: [{
                type: ViewChild,
                args: ['rla', { read: RouterLinkActive }]
            }] } });

class BentoSideNavComponent {
    constructor(r, elRef, uidGen) {
        /**
         * Item array that is used in component template
         */
        this._itemsForRender = [];
        /**
         * Flag to determine if category items are collapsible
         */
        this.collapsible = false;
        /**
         * Flag to determine if category items only serve as expand and collapse when clicked
         */
        this.categoryExpandOnly = false;
        /**
         * Flag to determine if category items are selectable or not
         */
        this.selectableCategories = true;
        /**
         * Flag to determine if the side navigation can be searched
         */
        this.searchable = false;
        /**
         * Value is used to update searches
         */
        this.searchValue = '';
        /**
         * Callback when an item is selected in the side navigation component
         */
        this.select = new EventEmitter();
        r.setAttribute(elRef.nativeElement, 'role', 'navigation');
        this.uid = `bui-${uidGen.generate()}`;
        this._self = this;
    }
    /**
     * Side navigation menu item array
     */
    set _items(items) {
        this.items = items;
        this._itemsForRender = items;
        this.searchValue = '';
    }
    /**
     * Set current side navigation item
     */
    _setCurrentSideNavItem(item, emitEvent = true) {
        if (this.currentItem === item) {
            return;
        }
        if (this.currentItem) {
            this.currentItem.selected = false;
        }
        this.currentItem = item;
        if (emitEvent) {
            this.select.emit(item);
            this._onSearchValueChange('');
        }
    }
    /**
     * Callback when the search field value changes
     */
    _onSearchValueChange(v) {
        this.searchValue = v == null ? '' : v.trim();
        if (this.bentoReset) {
            setTimeout(() => {
                // Need to align close button when and if the container height changes
                // with the appearance and diappearance of its vertical scrollbar
                this.bentoReset.alignCloseButton();
            });
        }
    }
}
BentoSideNavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoSideNavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSideNavComponent, selector: "bento-side-nav", inputs: { _items: ["items", "_items"], collapsible: "collapsible", categoryExpandOnly: "categoryExpandOnly", selectableCategories: "selectableCategories", searchable: "searchable", itemTemplate: "itemTemplate", filterCompareFunc: "filterCompareFunc" }, outputs: { select: "select" }, host: { properties: { "class.bui-side-nav-collapsible": "this.collapsible" } }, providers: [BentoUidService], viewQueries: [{ propertyName: "bentoReset", first: true, predicate: BentoResetDirective, descendants: true }], ngImport: i0, template: "<label *ngIf=\"searchable\" class=\"sr-only\" [attr.for]=\"uid + '-input'\">\n  {{ 'BENTO_UI_SIDE_NAV_SEARCH' | bentoTranslate }}\n</label>\n<input\n  *ngIf=\"searchable\"\n  bentoReset\n  class=\"form-control\"\n  [attr.id]=\"uid + '-input'\"\n  [attr.placeholder]=\"'BENTO_UI_SIDE_NAV_SEARCH' | bentoTranslate\"\n  [ngModel]=\"searchValue\"\n  (ngModelChange)=\"_onSearchValueChange($event)\"\n/>\n<ul>\n  <li\n    bentoSideNavItem\n    *ngFor=\"let item of _itemsForRender\"\n    [item]=\"item\"\n    [depth]=\"0\"\n    [sideNav]=\"_self\"\n    [collapsible]=\"collapsible\"\n    [searchValue]=\"searchValue\"\n  ></li>\n</ul>\n", styles: [":host{padding:10px 0;display:block;position:relative;border-right-style:solid;border-right-width:1px}:host ul{padding:0}:host>.form-control{margin:0 10px 10px;width:calc(100% - 20px)}:host-context([dir=rtl]){border-right:none;border-left-style:solid;border-left-width:1px}\n"], components: [{ type: BentoSideNavItemComponent, selector: "li[bentoSideNavItem]", inputs: ["item", "depth", "collapsible", "searchValue", "sideNav"], outputs: ["selectedChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-side-nav', providers: [BentoUidService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<label *ngIf=\"searchable\" class=\"sr-only\" [attr.for]=\"uid + '-input'\">\n  {{ 'BENTO_UI_SIDE_NAV_SEARCH' | bentoTranslate }}\n</label>\n<input\n  *ngIf=\"searchable\"\n  bentoReset\n  class=\"form-control\"\n  [attr.id]=\"uid + '-input'\"\n  [attr.placeholder]=\"'BENTO_UI_SIDE_NAV_SEARCH' | bentoTranslate\"\n  [ngModel]=\"searchValue\"\n  (ngModelChange)=\"_onSearchValueChange($event)\"\n/>\n<ul>\n  <li\n    bentoSideNavItem\n    *ngFor=\"let item of _itemsForRender\"\n    [item]=\"item\"\n    [depth]=\"0\"\n    [sideNav]=\"_self\"\n    [collapsible]=\"collapsible\"\n    [searchValue]=\"searchValue\"\n  ></li>\n</ul>\n", styles: [":host{padding:10px 0;display:block;position:relative;border-right-style:solid;border-right-width:1px}:host ul{padding:0}:host>.form-control{margin:0 10px 10px;width:calc(100% - 20px)}:host-context([dir=rtl]){border-right:none;border-left-style:solid;border-left-width:1px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: BentoUidService }]; }, propDecorators: { _items: [{
                type: Input,
                args: ['items']
            }], collapsible: [{
                type: HostBinding,
                args: ['class.bui-side-nav-collapsible']
            }, {
                type: Input
            }], categoryExpandOnly: [{
                type: Input
            }], selectableCategories: [{
                type: Input
            }], searchable: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], filterCompareFunc: [{
                type: Input
            }], select: [{
                type: Output
            }], bentoReset: [{
                type: ViewChild,
                args: [BentoResetDirective]
            }] } });

class BentoSideNavModule extends ConsumerDataValidator {
}
BentoSideNavModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoSideNavModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavModule, declarations: [BentoSideNavComponent, BentoSideNavItemComponent], imports: [CommonModule, FormsModule, BentoTranslateModule, BentoResetModule, RouterModule, A11yModule], exports: [BentoSideNavComponent] });
BentoSideNavModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavModule, imports: [[CommonModule, FormsModule, BentoTranslateModule, BentoResetModule, RouterModule, A11yModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSideNavModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, BentoTranslateModule, BentoResetModule, RouterModule, A11yModule],
                    declarations: [BentoSideNavComponent, BentoSideNavItemComponent],
                    exports: [BentoSideNavComponent]
                }]
        }] });

/**
 * A service provider to control the content of `<bento-skip-links></bento-skip-links>`
 * component and its behaviors
 */
class BentoSkipLinksService {
    constructor() { }
    /**
     * Subscribable when links are changed
     */
    get linkChange() {
        return BentoSkipLinksService.linkChangeSubject;
    }
    /**
     * Update skip links
     */
    updateLinks(links) {
        BentoSkipLinksService.linkChangeSubject.next(links);
    }
}
BentoSkipLinksService.linkChangeSubject = new BehaviorSubject(null);
BentoSkipLinksService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoSkipLinksService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class BentoSkipLinksComponent {
    constructor(changeDetector, location, r, skipLinksService, windowRef, elRef) {
        this.changeDetector = changeDetector;
        this.location = location;
        this.r = r;
        /**
         * Skip links update subscription
         */
        this.skipLinkUpdateSub = Subscription.EMPTY;
        this.skipLinkUpdateSub = skipLinksService.linkChange.subscribe(this.onSkipLinkUpdate.bind(this));
        this.document = windowRef.nativeDocument;
        this.el = elRef.nativeElement;
    }
    onFocusin() {
        this.r.addClass(this.el, 'bui-focused');
    }
    onFocusout() {
        if (!this.el.contains(this.document.activeElement)) {
            this.r.removeClass(this.el, 'bui-focused');
        }
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.skipLinkUpdateSub.unsubscribe();
    }
    /**
     * Link click event listener
     * @param e mouse event that is passed in when user clicks the link
     * @param link the SkipLink that is associsated to this user click
     */
    onLinkClick(e, link) {
        e.preventDefault();
        if (link.isHashAnchor) {
            // This is going to be a hash anchor using HTML5 anchorings using `id` attribute
            const path = this.location.path();
            const hashString = `#${link.anchor}`;
            if (path.substr(path.length - hashString.length, hashString.length) !== hashString) {
                // Need make sure that if this hash has already been called
                // If so this is not going to fire again
                this.location.go(`${this.location.path()}#${link.anchor}`);
            }
        }
        else {
            // Brinng focus to a HTMLElemenet defined by its CSS selector
            const anchorEl = this.document.getElementById(link.anchor);
            if (anchorEl) {
                anchorEl.focus();
            }
            else {
                /* istanbul ignore next */
                throw new Error(`Bento Skip Links - Cannot find element id="${link.anchor}" in viewport`);
            }
        }
    }
    /**
     * Subscription function for SkipLink links updates
     * @param links the new skip link objects that are used for rendering
     */
    onSkipLinkUpdate(links) {
        this.links = links;
        this.changeDetector.markForCheck();
    }
}
BentoSkipLinksComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i3$2.Location }, { token: i0.Renderer2 }, { token: BentoSkipLinksService }, { token: WindowRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoSkipLinksComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSkipLinksComponent, selector: "bento-skip-links", host: { listeners: { "focusin": "onFocusin()", "focusout": "onFocusout()" } }, providers: [Location], ngImport: i0, template: "<div *ngFor=\"let link of links; let i = index\">\n  <div class=\"bui-skip-link-divider\" *ngIf=\"i > 0\"></div>\n  <a href=\"#\" (click)=\"onLinkClick($event, link)\">{{ link.text }}</a>\n</div>\n", styles: [".ng-bento bento-skip-links{border-radius:5px;border-style:solid;border-width:1px;box-shadow:0 0 5px #0000;display:inline-block;padding:10px;position:absolute;margin:0 14px;top:0;transform:translateY(-110%);transition:transform .2s,box-shadow .2s}.ng-bento bento-skip-links div{display:inline-block;vertical-align:top}.ng-bento bento-skip-links .bui-skip-link-divider{width:2px;height:1.5em;vertical-align:top;margin:0 5px}.ng-bento bento-skip-links.bui-focused{box-shadow:0 0 5px #000;transform:translateY(9px)}.ng-bento bento-skip-links a{display:inline-block;padding:0 10px}\n"], directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-skip-links', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [Location], template: "<div *ngFor=\"let link of links; let i = index\">\n  <div class=\"bui-skip-link-divider\" *ngIf=\"i > 0\"></div>\n  <a href=\"#\" (click)=\"onLinkClick($event, link)\">{{ link.text }}</a>\n</div>\n", styles: [".ng-bento bento-skip-links{border-radius:5px;border-style:solid;border-width:1px;box-shadow:0 0 5px #0000;display:inline-block;padding:10px;position:absolute;margin:0 14px;top:0;transform:translateY(-110%);transition:transform .2s,box-shadow .2s}.ng-bento bento-skip-links div{display:inline-block;vertical-align:top}.ng-bento bento-skip-links .bui-skip-link-divider{width:2px;height:1.5em;vertical-align:top;margin:0 5px}.ng-bento bento-skip-links.bui-focused{box-shadow:0 0 5px #000;transform:translateY(9px)}.ng-bento bento-skip-links a{display:inline-block;padding:0 10px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i3$2.Location }, { type: i0.Renderer2 }, { type: BentoSkipLinksService }, { type: WindowRef }, { type: i0.ElementRef }]; }, propDecorators: { onFocusin: [{
                type: HostListener,
                args: ['focusin']
            }], onFocusout: [{
                type: HostListener,
                args: ['focusout']
            }] } });

/**
 * A skip link object to represent each link that is used in SkipLink component
 */
class SkipLink {
    /**
     * * `anchor` - The ID of the element where the link skips to
     * * `text` - The text of the link that is used
     * * `isHashAnchor` (default: `false`) - Flag to decide whether using an location hash `#` or directly focus
     * onto the element by its given HTMLElement ID
     */
    constructor(anchor, text, isHashAnchor = false) {
        this.anchor = anchor;
        this.text = text;
        this.isHashAnchor = isHashAnchor;
    }
}

class BentoSkipLinksModule extends ConsumerDataValidator {
}
BentoSkipLinksModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoSkipLinksModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksModule, declarations: [BentoSkipLinksComponent], imports: [CommonModule, BentoUtilsModule], exports: [BentoSkipLinksComponent] });
BentoSkipLinksModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksModule, providers: [BentoSkipLinksService], imports: [[CommonModule, BentoUtilsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSkipLinksModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoSkipLinksComponent],
                    imports: [CommonModule, BentoUtilsModule],
                    exports: [BentoSkipLinksComponent],
                    providers: [BentoSkipLinksService]
                }]
        }] });

/**
 * Enumeration for different types of badge types supported
 */
var BentoSmartBadgeType;
(function (BentoSmartBadgeType) {
    BentoSmartBadgeType[BentoSmartBadgeType["digit"] = 0] = "digit";
    BentoSmartBadgeType[BentoSmartBadgeType["icon"] = 1] = "icon";
})(BentoSmartBadgeType || (BentoSmartBadgeType = {}));
/**
 * Enumeration for different types of badge styles supported
 */
var BentoSmartBadgeStyle;
(function (BentoSmartBadgeStyle) {
    BentoSmartBadgeStyle[BentoSmartBadgeStyle["success"] = 1] = "success";
    BentoSmartBadgeStyle[BentoSmartBadgeStyle["info"] = 2] = "info";
    BentoSmartBadgeStyle[BentoSmartBadgeStyle["warning"] = 3] = "warning";
    BentoSmartBadgeStyle[BentoSmartBadgeStyle["failure"] = 4] = "failure";
})(BentoSmartBadgeStyle || (BentoSmartBadgeStyle = {}));

class BentoSmartBadgeComponent {
    constructor(r, bentoLogger, changeDetector) {
        this.r = r;
        this.bentoLogger = bentoLogger;
        this.changeDetector = changeDetector;
        this._badgeDynamicClass = 'd-none';
        this._badgeClassList = [];
        /**
         * Hide if there are no details for the smart badge
         */
        this._showBadgeContainer = false;
    }
    get ariaLabel() {
        return this._ariaLabel;
    }
    /**
     * Details about the smart badge
     */
    set updateDetails(details) {
        if (!details) {
            this._showBadgeContainer = false;
            return;
        }
        this.details = details;
        this.defineDetailsSetters(details);
        if (details) {
            this.setBadgeDetails(details);
        }
    }
    /**
     *
     * @param badgeDetails: BentoSmartBadgeDetails
     *
     * Update badge details and convert it with setter and getters
     */
    defineDetailsSetters(badgeDetails) {
        this.type = badgeDetails.type;
        Object.defineProperty(badgeDetails, 'type', {
            set: (type) => {
                this.type = type;
                // Update type property and render
                this.setBadgeType(type);
            },
            get: () => {
                return this.type;
            },
            configurable: true
        });
        this.content = badgeDetails.content;
        Object.defineProperty(badgeDetails, 'content', {
            set: (content) => {
                this.content.value = content.value;
            },
            get: () => {
                return this.content;
            },
            configurable: true
        });
        if (badgeDetails.content) {
            this.contentValue = badgeDetails.content.value;
            Object.defineProperty(badgeDetails.content, 'value', {
                set: (value) => {
                    this.contentValue = value;
                    // Update content property and render
                    this.setBadgeContent({ value });
                },
                get: () => {
                    return this.contentValue;
                },
                configurable: true
            });
        }
        this.color = badgeDetails.color;
        Object.defineProperty(badgeDetails, 'color', {
            set: (color) => {
                this.color = color;
                this.setColor(color);
            },
            get: () => {
                return this.color;
            },
            configurable: true
        });
        this._ariaLabel = badgeDetails.ariaLabel;
        Object.defineProperty(badgeDetails, 'ariaLabel', {
            set: (ariaLabel) => {
                this._ariaLabel = ariaLabel;
                // Update ariaLabel property and render
                this.setAriaLabel(ariaLabel);
            },
            get: () => {
                return this.ariaLabel;
            },
            configurable: true
        });
        this.hidden = badgeDetails.hidden;
        Object.defineProperty(badgeDetails, 'hidden', {
            set: (hidden) => {
                this.hidden = hidden;
                // Update hidden property and render
                this.showHideBadge(hidden);
            },
            get: () => {
                return this.hidden;
            },
            // TypeError: Cannot redefine property: hidden
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cant_redefine_property
            configurable: true
        });
    }
    /**
     *
     * @param badgeDetails: BentoSmartBadgeDetails
     *
     * This method gets called whenever a new `details` object is assigned
     */
    setBadgeDetails(badgeDetails) {
        this.showHideBadge(badgeDetails.hidden);
        // reset css classlist
        this._badgeClassList = [];
        this._badgeDynamicClass = '';
        this._badgeClassList.push('bento-smart-badge');
        this._customStyle = '';
        // ICON badge
        if (badgeDetails.content && badgeDetails.type === BentoSmartBadgeType.icon) {
            this._badgeClassList.push('bento-smart-badge-dot-with-icon');
            let badgeStyleClass = this.getBadgeStyleClass(badgeDetails.content.value);
            badgeStyleClass += '-icon';
            this._badgeClassList.push(badgeStyleClass);
            this._badgeContent = '';
        }
        else if (badgeDetails.content && badgeDetails.type === BentoSmartBadgeType.digit) {
            // DIGIT badge
            this._badgeContent = badgeDetails.content.value + '';
            if (badgeDetails.content.value > 99) {
                this._badgeContent = '99+';
            }
            else if (badgeDetails.content.value <= 0) {
                this._badgeContent = '';
                this._badgeClassList.push('d-none');
            }
            if (badgeDetails.color && this._badgeContent.length) {
                let badgeStyleClass = this.getBadgeStyleClass(badgeDetails.color);
                this._badgeClassList.push(badgeStyleClass);
            }
            this._badgeClassList.push('bento-smart-digit');
            let badgeContentLengthClass = this.getContentLengthClass(this._badgeContent.length);
            this._badgeClassList.push(badgeContentLengthClass);
        }
        // set aria label
        this.setAriaLabel(badgeDetails.ariaLabel);
        // convert the list to string of css classes
        this._badgeDynamicClass = this._badgeClassList.join(' ');
        this.changeDetector.markForCheck();
        // Update badge CSS Class
        this.smartBadgeHost && this.r.setProperty(this.smartBadgeHost.nativeElement, 'className', this._badgeDynamicClass);
    }
    /**
     *
     * @param badgeType: BentoSmartBadgeType
     *
     * Set only the badge type
     */
    setBadgeType(badgeType) {
        this._showBadgeContainer = true;
        let index = this._badgeClassList.indexOf('bento-smart-badge-dot-with-icon');
        if (index > -1) {
            this._badgeClassList.splice(index, 1);
        }
        // ICON badge
        if (badgeType === BentoSmartBadgeType.icon) {
            this._badgeClassList.push('bento-smart-badge-dot-with-icon');
        }
        // convert the list to string of css classes
        this._badgeDynamicClass = this._badgeClassList.join(' ');
        this.changeDetector.markForCheck();
        // Update badge CSS Class
        this.smartBadgeHost && this.r.setProperty(this.smartBadgeHost.nativeElement, 'className', this._badgeDynamicClass);
    }
    /**
     *
     * @param badgeContent: BentoSmartBadgeContent
     *
     * Set the badge content
     */
    setBadgeContent(badgeContent) {
        // filter and remove previous css class list
        const removeList = [
            'd-none',
            'bento-smart-digit',
            'sm',
            'md',
            'lg',
            'bento-smart-badge-success-icon',
            'bento-smart-badge-info-icon',
            'bento-smart-badge-warning-icon',
            'bento-smart-badge-failure-icon'
        ];
        this._badgeClassList = this._badgeClassList.filter(cls => {
            return removeList.indexOf(cls) === -1;
        });
        // set new class list based on the value provided
        // ICON badge - type based on the content value
        if (badgeContent && this.type && this.type === BentoSmartBadgeType.icon) {
            let badgeStyleClass = this.getBadgeStyleClass(badgeContent.value);
            badgeStyleClass += '-icon';
            this._badgeClassList.push(badgeStyleClass);
            this._badgeContent = '';
        }
        else if (badgeContent && this.type === BentoSmartBadgeType.digit) {
            // DIGIT badge
            this._badgeContent = badgeContent.value + '';
            if (badgeContent.value > 99) {
                this._badgeContent = '99+';
            }
            else if (badgeContent.value <= 0) {
                this._badgeContent = '';
                this._badgeClassList.push('d-none');
            }
            this._badgeClassList.push('bento-smart-digit');
            let badgeContentLengthClass = this.getContentLengthClass(this._badgeContent.length);
            this._badgeClassList.push(badgeContentLengthClass);
            this._badgeDynamicClass = this._badgeClassList.join(' ');
            this.changeDetector.markForCheck();
        }
    }
    /**
     *
     * @param style: style type
     *
     * Get the css class based on the style type
     */
    getBadgeStyleClass(style) {
        let badgeClass = 'bento-smart-badge-';
        switch (style) {
            case BentoSmartBadgeStyle.success:
                badgeClass += 'success';
                break;
            case BentoSmartBadgeStyle.info:
                badgeClass += 'info';
                break;
            case BentoSmartBadgeStyle.warning:
                badgeClass += 'warning';
                break;
            case BentoSmartBadgeStyle.failure:
                badgeClass += 'failure';
                break;
        }
        return badgeClass;
    }
    /**
     *
     * @param length: digit type number length.
     * For example:
     * number 100 will have length of 3
     * number 20 will have length of 2
     * number 3 will have length of 1
     *
     * Get the css class based on the length
     */
    getContentLengthClass(length) {
        let badgeContentLengthClass = 'sm';
        switch (length) {
            case 1:
                badgeContentLengthClass = 'sm';
                break;
            case 2:
                badgeContentLengthClass = 'md';
                break;
            case 3:
                badgeContentLengthClass = 'lg';
                break;
        }
        return badgeContentLengthClass;
    }
    setColor(color) {
        let badgeStyleClass = this.getBadgeStyleClass(color);
        this._badgeClassList.push(badgeStyleClass);
        this._badgeDynamicClass = this._badgeClassList.join(' ');
        this.changeDetector.markForCheck();
    }
    setAriaLabel(ariaLabel) {
        // details aria label will override any ariaLabel supplied
        if (ariaLabel) {
            this._ariaLabel = ariaLabel;
        }
        if (!this.ariaLabel) {
            // warn the user
            this.bentoLogger.warn('Accessibility specification mandates to have ariaLabel for Smart badge', this.details);
        }
        this.changeDetector.markForCheck();
    }
    showHideBadge(hidden) {
        this._showBadgeContainer = hidden ? false : true;
        this.changeDetector.markForCheck();
    }
}
BentoSmartBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSmartBadgeComponent, deps: [{ token: i0.Renderer2 }, { token: BentoLogService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoSmartBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSmartBadgeComponent, selector: "bento-smart-badge, [bentoSmartBadge]", inputs: { updateDetails: ["details", "updateDetails"] }, viewQueries: [{ propertyName: "smartBadgeHost", first: true, predicate: ["smartBadgeHost"], descendants: true, static: true }], ngImport: i0, template: "<ng-content></ng-content>\n<span\n  *ngIf=\"_showBadgeContainer\"\n  [attr.aria-live]=\"!details.staticIndicator ? 'polite' : null\"\n  [ngClass]=\"_badgeDynamicClass\"\n  [ngStyle]=\"_customStyle\"\n  #smartBadgeHost\n  [attr.aria-label]=\"ariaLabel\"\n  role=\"text img\"\n>\n  {{ _badgeContent }}\n</span>\n", styles: [".ng-bento bento-smart-badge,.ng-bento [bentoSmartBadge]{display:inline-block;position:relative}.ng-bento .bento-smart-badge{position:absolute;border-width:1px;border-style:solid;left:calc(100% - 2px);bottom:calc(100% - 5px)}[dir=rtl] .ng-bento .bento-smart-badge{left:auto;right:calc(100% - 2px)}.ng-bento .bento-smart-badge-dot-with-icon{background-color:#fff}.ng-bento .bento-smart-badge-warning-icon{background-color:#000}\n"], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSmartBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-smart-badge, [bentoSmartBadge]', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n<span\n  *ngIf=\"_showBadgeContainer\"\n  [attr.aria-live]=\"!details.staticIndicator ? 'polite' : null\"\n  [ngClass]=\"_badgeDynamicClass\"\n  [ngStyle]=\"_customStyle\"\n  #smartBadgeHost\n  [attr.aria-label]=\"ariaLabel\"\n  role=\"text img\"\n>\n  {{ _badgeContent }}\n</span>\n", styles: [".ng-bento bento-smart-badge,.ng-bento [bentoSmartBadge]{display:inline-block;position:relative}.ng-bento .bento-smart-badge{position:absolute;border-width:1px;border-style:solid;left:calc(100% - 2px);bottom:calc(100% - 5px)}[dir=rtl] .ng-bento .bento-smart-badge{left:auto;right:calc(100% - 2px)}.ng-bento .bento-smart-badge-dot-with-icon{background-color:#fff}.ng-bento .bento-smart-badge-warning-icon{background-color:#000}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: BentoLogService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { updateDetails: [{
                type: Input,
                args: ['details']
            }], smartBadgeHost: [{
                type: ViewChild,
                args: ['smartBadgeHost', { static: true }]
            }] } });

class BentoSmartBadgeModule extends ConsumerDataValidator {
}
BentoSmartBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSmartBadgeModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoSmartBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSmartBadgeModule, declarations: [BentoSmartBadgeComponent], imports: [CommonModule, BentoUtilsModule], exports: [BentoSmartBadgeComponent] });
BentoSmartBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSmartBadgeModule, imports: [[CommonModule, BentoUtilsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSmartBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, BentoUtilsModule],
                    declarations: [BentoSmartBadgeComponent],
                    exports: [BentoSmartBadgeComponent]
                }]
        }] });

/**
 * Bento Splitter Group Side Panel Base Class
 */
class BentoSplitterGroupSideComponent {
    constructor(elementRef, r, cd, windowRef, uidGen) {
        this.r = r;
        this.cd = cd;
        /**
         * Panel Aria Label
         */
        this.panelAriaLabel = 'BENTO_UI_SPLITTER_GROUP_SIDE_PANEL';
        /**
         * Bar Aria Label
         */
        this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_SIDE_PANEL';
        /**
         * Class name space
         */
        this.NS = 'bento-splitter';
        this.arrayOfUnlistenHandleDown = [];
        this.keydownSubscriptions = [];
        this.keydownSubscription = Subscription.EMPTY;
        this._isOpen = false;
        this._isOpenMax = false;
        this.r.addClass(elementRef.nativeElement, this.NS + '-group-panel');
        this.window = windowRef.nativeWindow;
        this.el = elementRef.nativeElement;
        this.uid = `bui-${uidGen.generate()}`;
    }
    /**
     * Capitalized string representation of the side
     */
    get side() {
        return this._side;
    }
    /**
     * Open status
     */
    set isOpen(v) {
        this._isOpen = v;
        if (this.isHiddenTimeoutID) {
            // Clear previous timeout when `isOpen` is called too frequently
            clearTimeout(this.isHiddenTimeoutID);
        }
        this.isHiddenTimeoutID = setTimeout(() => {
            this.isHidden = !v;
        }, v ? 0 : 100);
        this.cd.detectChanges();
    }
    get isOpen() {
        return this._isOpen;
    }
    set isOpenMax(v) {
        this._isOpenMax = v;
        this.cd.detectChanges();
    }
    get isOpenMax() {
        return this._isOpenMax;
    }
    ngAfterContentInit() {
        this.applyListeners(this.el.querySelector('.bento-splitter-toggle'));
        this.applyListeners(this.el.querySelector('.bento-splitter-increase'));
        this.applyListeners(this.el.querySelector('.bento-splitter-decrease'));
        this.applyListeners(this.el.querySelector('.bento-splitter-dragdrop'));
    }
    ngOnDestroy() {
        this.arrayOfUnlistenHandleDown.forEach(unlisten => {
            unlisten();
        });
        this.keydownSubscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    applyListeners(el) {
        const pointerDownEventName = !!this.window['PointerEvent']
            ? 'pointerdown'
            : !!this.window['TouchEvent']
                ? 'touchstart'
                : 'mousedown';
        this.arrayOfUnlistenHandleDown.push(this.r.listen(el, pointerDownEventName, e => {
            this._onHandleDown(e);
        }));
        this.keydownSubscription = fromEvent(el, 'keydown').subscribe((e) => {
            switch (e.keyCode) {
                case Keyboard.ENTER:
                case Keyboard.SPACE:
                    if (el.className.includes('toggle')) {
                        this.onEnterOrSpaceDown(this);
                    }
                    else if (el.className.includes('decrease')) {
                        this.onArrowKeysDown(e, this, this._side === 'Top' || this._side === 'Left' ? -1 : 1);
                    }
                    else if (el.className.includes('increase')) {
                        this.onArrowKeysDown(e, this, this._side === 'Top' || this._side === 'Left' ? 1 : -1);
                    }
                    break;
            }
        });
        this.keydownSubscriptions.push(this.keydownSubscription);
    }
    _onHandleDown(event) {
        if (!this.onHandleDown || !!event.button || event.ctrlKey) {
            return;
        }
        // fire callback
        this.onHandleDown(this, event);
    }
}
BentoSplitterGroupSideComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupSideComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: WindowRef }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupSideComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupSideComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupSideComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: WindowRef }, { type: BentoUidService }]; } });

/**
 * Bento Splitter Group Bottom Panel
 */
class BentoSplitterGroupBottomComponent extends BentoSplitterGroupSideComponent {
    constructor(elementRef, r, cd, windowRef, uidGen) {
        super(elementRef, r, cd, windowRef, uidGen);
        this.r = r;
        this.cd = cd;
        /**
         * Bar Aria Label
         */
        this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_BOTTOM_BAR';
        this._side = 'Bottom';
        r.addClass(elementRef.nativeElement, this.NS + '-group-bottom');
    }
    ngAfterViewInit() {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-bottom');
    }
}
BentoSplitterGroupBottomComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupBottomComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: WindowRef }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupBottomComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupBottomComponent, selector: "bento-splitter-group-bottom", viewQueries: [{ propertyName: "handle", first: true, predicate: ["handle"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n", directives: [{ type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupBottomComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-splitter-group-bottom', template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: WindowRef }, { type: BentoUidService }]; }, propDecorators: { handle: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }] } });

/**
 * Bento Splitter Group Left Panel
 */
class BentoSplitterGroupLeftComponent extends BentoSplitterGroupSideComponent {
    constructor(elementRef, r, cd, windowRef, dir, uidGen) {
        super(elementRef, r, cd, windowRef, uidGen);
        this.r = r;
        this.cd = cd;
        /**
         * Bar Aria Label
         */
        this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_LEFT_BAR';
        this._side = dir.value === 'rtl' ? 'Right' : 'Left';
        this.r.addClass(elementRef.nativeElement, this.NS + '-group-' + this._side.toLowerCase());
    }
    ngAfterViewInit() {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-' + this._side.toLowerCase());
    }
}
BentoSplitterGroupLeftComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupLeftComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: WindowRef }, { token: i2.Directionality }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupLeftComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupLeftComponent, selector: "bento-splitter-group-left", viewQueries: [{ propertyName: "handle", first: true, predicate: ["handle"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n", directives: [{ type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupLeftComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-splitter-group-left', template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: WindowRef }, { type: i2.Directionality }, { type: BentoUidService }]; }, propDecorators: { handle: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }] } });

/**
 * Bento Splitter Group Main Panel
 */
class BentoSplitterGroupMainComponent {
    constructor(elementRef, r) {
        this.el = elementRef.nativeElement;
        r.addClass(elementRef.nativeElement, 'bento-splitter-group-panel');
        r.addClass(elementRef.nativeElement, 'bento-splitter-group-main');
    }
}
BentoSplitterGroupMainComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupMainComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupMainComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupMainComponent, selector: "bento-splitter-group-main", ngImport: i0, template: "<div class=\"bento-splitter-group-inner\">\n  <ng-content></ng-content>\n</div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupMainComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-splitter-group-main', template: "<div class=\"bento-splitter-group-inner\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

/**
 * Bento Splitter Group Right Panel
 */
class BentoSplitterGroupRightComponent extends BentoSplitterGroupSideComponent {
    constructor(elementRef, r, cd, windowRef, dir, uidGen) {
        super(elementRef, r, cd, windowRef, uidGen);
        this.r = r;
        this.cd = cd;
        /**
         * Bar Aria Label
         */
        this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_RIGHT_BAR';
        this._side = dir.value === 'rtl' ? 'Left' : 'Right';
        this.r.addClass(elementRef.nativeElement, this.NS + '-group-' + this._side.toLowerCase());
    }
    ngAfterViewInit() {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-' + this._side.toLowerCase());
    }
}
BentoSplitterGroupRightComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupRightComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: WindowRef }, { token: i2.Directionality }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupRightComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupRightComponent, selector: "bento-splitter-group-right", viewQueries: [{ propertyName: "handle", first: true, predicate: ["handle"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n", directives: [{ type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupRightComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-splitter-group-right', template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: WindowRef }, { type: i2.Directionality }, { type: BentoUidService }]; }, propDecorators: { handle: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }] } });

/**
 * Bento Splitter Group Top Panel
 */
class BentoSplitterGroupTopComponent extends BentoSplitterGroupSideComponent {
    constructor(elementRef, r, cd, windowRef, uidGen) {
        super(elementRef, r, cd, windowRef, uidGen);
        this.r = r;
        this.cd = cd;
        /**
         * Bar Aria Label
         */
        this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_TOP_BAR';
        this._side = 'Top';
        this.r.addClass(elementRef.nativeElement, this.NS + '-group-top');
    }
    ngAfterViewInit() {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-top');
    }
}
BentoSplitterGroupTopComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupTopComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: WindowRef }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupTopComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupTopComponent, selector: "bento-splitter-group-top", viewQueries: [{ propertyName: "handle", first: true, predicate: ["handle"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n", directives: [{ type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupTopComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-splitter-group-top', template: "<div class=\"bento-splitter-handle\" #handle>\n\n  <button type=\"button\"\n          tabindex=\"-1\"\n          [attr.aria-hidden]=\"true\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-dragdrop btn-sm\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_RESIZE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-vertical-drag-drop row-resize\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-hor-drag-drop-arrows col-resize\"></i>\n  </button>\n\n\n  <button type=\"button\"\n          [attr.aria-label]=\"isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n          [attr.aria-expanded]=\"isOpen\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-toggle btn-sm\"\n          [attr.aria-controls]=\"uid\"\n          ngbTooltip=\"{{ isOpen ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate) }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-double-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-decrease btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"!isOpen\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_DECREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n  </button>\n  <button type=\"button\"\n          class=\"btn btn-outline-primary btn-icon bento-splitter-increase btn-sm\"\n          [attr.aria-label]=\"'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate\"\n          [attr.aria-controls]=\"uid\"\n          [disabled]=\"isOpenMax\"\n          ngbTooltip=\"{{ 'BENTO_UI_SPLITTER_GROUP_INCREASE_BUTTON' | bentoTranslate }}\"\n          container=\"body\">\n    <i *ngIf=\"side === 'Top'\" aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n    <i *ngIf=\"side === 'Bottom'\" aria-hidden=\"true\" class=\"bento-icon-caret-up-filled\"></i>\n    <i *ngIf=\"side === 'Left'\" aria-hidden=\"true\" class=\"bento-icon-caret-right-filled\"></i>\n    <i *ngIf=\"side === 'Right'\" aria-hidden=\"true\" class=\"bento-icon-caret-left-filled\"></i>\n  </button>\n</div>\n\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: WindowRef }, { type: BentoUidService }]; }, propDecorators: { handle: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }] } });

var SizeUnit;
(function (SizeUnit) {
    SizeUnit[SizeUnit["Px"] = 0] = "Px";
    SizeUnit[SizeUnit["Percent"] = 1] = "Percent";
})(SizeUnit || (SizeUnit = {}));
/**
 * This custom component allows collapsible panes in all four cardinal
 * directions. The splitter handles are draggable in desktop browsers, allowing
 * arbitrary resizing. When collapsed, the splitter retains a memory of the
 * width of its last open position; clicking the splitter handle will restore
 * that position.
 */
class BentoSplitterGroupComponent {
    constructor(elementRef, bentoNotification, windowRef, r, dir) {
        this.bentoNotification = bentoNotification;
        this.windowRef = windowRef;
        this.r = r;
        this.dir = dir;
        /**
         * The amount of pixels moved when an user clicks on the single triangle resize buttons
         */
        this.resizeStepSize = 50;
        /**
         * Maximum width of the left panel
         */
        this.leftMaxWidth = Number.POSITIVE_INFINITY;
        /**
         * Callback when the width of the left panel is changed
         */
        this.leftSizeChange = new EventEmitter();
        /**
         * Callback when flag `leftOpened` changes
         */
        this.leftOpenedChange = new EventEmitter();
        /**
         * Maximum width of the right panel
         */
        this.rightMaxWidth = Number.POSITIVE_INFINITY;
        /**
         * Callback when the width of the right panel is changed
         */
        this.rightSizeChange = new EventEmitter();
        /**
         * Callback when flag `rightOpened` changes
         */
        this.rightOpenedChange = new EventEmitter();
        /**
         * Maximum height of the top panel
         */
        this.topMaxHeight = Number.POSITIVE_INFINITY;
        /**
         * Callback when the height of the top panel is changed
         */
        this.topSizeChange = new EventEmitter();
        /**
         * Callback when flag `topOpened` changes
         */
        this.topOpenedChange = new EventEmitter();
        /**
         * Maximum height of the bottom panel
         */
        this.bottomMaxHeight = Number.POSITIVE_INFINITY;
        /**
         * Callback when the height of the bottom panel is changed
         */
        this.bottomSizeChange = new EventEmitter();
        /**
         * Callback when flag `bottomOpened` changes
         */
        this.bottomOpenedChange = new EventEmitter();
        this._isIE = false;
        /**
         * API related private variables
         */
        this._autoResize = false;
        this.leftSize = 200;
        this.rightSize = 200;
        this.topSize = 100;
        this.bottomSize = 100;
        /**
         * Default variables
         */
        this.defaultHandleWidth = 18; // @TODO should stay in sync with css
        this.autoCloseThreshhold = 50;
        this.isLeftOpen = false;
        this.isRightOpen = false;
        this.isTopOpen = false;
        this.isBottomOpen = false;
        // Event names
        this.subPointerMove = Subscription.EMPTY;
        this.subPointerUp = Subscription.EMPTY;
        this.subPointerCancel = Subscription.EMPTY;
        this.subResize = Subscription.EMPTY;
        this.document = this.windowRef.nativeDocument;
        this.r.addClass(elementRef.nativeElement, 'bento-splitter-group');
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe(() => {
            this.flipDirection();
        });
        this._isIE = windowRef.isIEEdge;
        this.el = elementRef.nativeElement;
    }
    /**
     * Auto Resize
     */
    set autoResize(val) {
        this._autoResize = val;
        if (val) {
            this.r.addClass(this.el, 'bento-splitter-group-autoresize');
        }
        else {
            this.r.removeClass(this.el, 'bento-splitter-group-autoresize');
        }
    }
    /**
     * Set to true for drag only behavior
     */
    set noCollapse(val) {
        if (val) {
            this.r.addClass(this.el, 'no-collapse');
        }
        else {
            this.r.removeClass(this.el, 'no-collapse');
        }
    }
    /**
     * Left panel width
     */
    set leftWidth(size) {
        const s = Number(size);
        this.leftSize = s;
        this.render();
    }
    /**
     * Flag to open/collapse left panel
     */
    set leftOpened(val) {
        if (this.isRtl) {
            this.setRightOpen(val);
        }
        else {
            this.setLeftOpen(val);
        }
        this.render();
    }
    /**
     * Right panel width
     */
    set rightWidth(size) {
        const s = Number(size);
        this.rightSize = s;
        this.render();
    }
    /**
     * Flag to open/collapse right panel
     */
    set rightOpened(val) {
        if (this.isRtl) {
            this.setLeftOpen(val);
        }
        else {
            this.setRightOpen(val);
        }
        this.render();
    }
    /**
     * Top panel height
     */
    set topHeight(size) {
        const s = Number(size);
        if (this.topSize === s) {
            return;
        }
        this.topSize = s;
        this.render();
    }
    /**
     * Flag to open/collapse top panel
     */
    set topOpened(val) {
        this.setTopOpen(val);
        this.render();
    }
    /**
     * Bottom panel height
     */
    set bottomHeight(size) {
        const s = Number(size);
        if (this.bottomSize === s) {
            return;
        }
        this.bottomSize = s;
        this.render();
    }
    /**
     * Flag to open/collapse bottom panel
     */
    set bottomOpened(val) {
        this.setBottomOpen(val);
        this.render();
    }
    /**
     * Panel references
     */
    set _leftPanel(panel) {
        if (this.isRtl) {
            // Change side in RTL
            this.rightPanel = panel;
            this.setRightPanel(panel);
        }
        else {
            this.leftPanel = panel;
            this.setLeftPanel(panel);
        }
        this.render();
    }
    set _topPanel(panel) {
        this.topPanel = panel;
        if (this.topPanel) {
            // Hook callbacks
            this.topPanel.isOpen = this.isTopOpen || false;
            this.r.setStyle(panel.el, 'display', 'none');
            this.topPanel.onHandleDown = (side, event) => {
                this.onSidePanelHandleDown(side, event);
            };
            this.topPanel.onEnterOrSpaceDown = () => {
                this.setTopOpen(!this.isTopOpen);
                this.topOpenedChange.emit(this.isTopOpen);
            };
            this.topPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
        }
        else {
            this.setTopOpen(false);
        }
        this.render();
    }
    set _rightPanel(panel) {
        if (this.isRtl) {
            // Change side in RTL
            this.leftPanel = panel;
            this.setLeftPanel(panel);
        }
        else {
            this.rightPanel = panel;
            this.setRightPanel(panel);
        }
        this.render();
    }
    set _bottomPanel(panel) {
        this.bottomPanel = panel;
        if (this.bottomPanel) {
            // Hook callbacks
            this.bottomPanel.isOpen = this.isBottomOpen || false;
            this.r.setStyle(panel.el, 'display', 'none');
            this.bottomPanel.onHandleDown = (side, event) => {
                this.onSidePanelHandleDown(side, event);
            };
            this.bottomPanel.onEnterOrSpaceDown = () => {
                this.setBottomOpen(!this.isBottomOpen);
                this.bottomOpenedChange.emit(this.isBottomOpen);
            };
            this.bottomPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
        }
        else {
            this.setBottomOpen(false);
        }
        this.render();
    }
    flipDirection() {
        this.isRtl = this.dir.value === 'rtl';
    }
    /**
     * AfterContentInit interface method
     */
    ngAfterContentInit() {
        this.mainPanelInnerEl = this.mainPanel.el.querySelector('.bento-splitter-group-inner');
        this.r.setStyle(this.mainPanel.el, 'display', 'none');
        this.subResize = this.bentoNotification.resizeNotification.subscribe(object => {
            const isVisible = !(this.el.offsetWidth === 0 && this.el.offsetHeight === 0);
            if (isVisible) {
                // Only rerender when other related components resize
                let hasChange = false;
                const elWidth = this.el.offsetWidth;
                const elHeight = this.el.offsetHeight;
                // Normallize width
                if (this.leftSize + this.defaultHandleWidth > elWidth) {
                    this.leftSize = elWidth - this.defaultHandleWidth;
                    hasChange = true;
                }
                if (this.rightSize + this.defaultHandleWidth > elWidth) {
                    this.rightSize = elWidth - this.defaultHandleWidth;
                    hasChange = true;
                }
                if (this.topSize + this.defaultHandleWidth > elHeight) {
                    this.topSize = elHeight - this.defaultHandleWidth;
                    hasChange = true;
                }
                if (this.bottomSize + this.defaultHandleWidth > elHeight) {
                    this.bottomSize = elHeight - this.defaultHandleWidth;
                    hasChange = true;
                }
                // When there are two panels facing each other
                if (this.leftPanel &&
                    this.rightPanel &&
                    this.leftSize + this.rightSize + this.defaultHandleWidth * 2 > elWidth) {
                    const d = (this.leftSize + this.rightSize + this.defaultHandleWidth * 2 - elWidth) * 0.5;
                    this.leftSize -= d;
                    this.rightSize -= d;
                    hasChange = true;
                }
                if (this.topPanel &&
                    this.bottomPanel &&
                    this.topSize + this.bottomSize + this.defaultHandleWidth * 2 > elHeight) {
                    const d = (this.topSize + this.bottomSize + this.defaultHandleWidth * 2 - elHeight) * 0.5;
                    this.topSize -= d;
                    this.bottomSize -= d;
                    hasChange = true;
                }
                if (hasChange) {
                    this.render();
                }
            }
        });
        this.render();
    }
    /**
     * AfterViewChecked interface method
     */
    ngAfterContentChecked() {
        if (this._autoResize) {
            let height = this.mainPanelInnerEl.offsetHeight;
            if (this.topPanel) {
                height += this.topPanel.el.offsetHeight + this.topPanel.el.offsetTop;
            }
            if (this.bottomPanel) {
                height += this.bottomPanel.el.offsetHeight + parseFloat(this.bottomPanel.el.style.bottom);
            }
            this.r.setStyle(this.el, 'height', `${height}px`);
        }
    }
    /**
     * Destroy callback
     */
    ngOnDestroy() {
        this.unsubscribeListeners();
        this.subResize.unsubscribe();
    }
    /**
     * Render panels based on size values
     */
    render() {
        let tempVal;
        this.r.removeStyle(this.mainPanel.el, 'display');
        // Left Panel
        if (this.leftPanel) {
            tempVal = this.leftSize + this.defaultHandleWidth;
            this.r.setStyle(this.leftPanel.el, 'width', `${tempVal}px`);
            this.r.removeStyle(this.leftPanel.el, 'display');
            if (this.isLeftOpen) {
                this.r.setStyle(this.mainPanel.el, 'left', `${tempVal}px`);
                this.r.setStyle(this.leftPanel.el, 'left', '0');
            }
            else {
                this.r.setStyle(this.leftPanel.el, 'left', `${-this.leftSize - 1}px`);
            }
        }
        if (!this.isLeftOpen) {
            this.r.setStyle(this.mainPanel.el, 'left', `${this.leftPanel ? this.defaultHandleWidth : 0}px`);
        }
        // Right Panel
        if (this.rightPanel) {
            tempVal = this.rightSize + this.defaultHandleWidth;
            this.r.setStyle(this.rightPanel.el, 'width', `${tempVal}px`);
            this.r.removeStyle(this.rightPanel.el, 'display');
            if (this.isRightOpen) {
                this.r.setStyle(this.mainPanel.el, 'right', `${tempVal}px`);
                this.r.setStyle(this.rightPanel.el, 'right', '0');
            }
            else {
                this.r.setStyle(this.mainPanel.el, 'right', `${this.defaultHandleWidth}px`);
                this.r.setStyle(this.rightPanel.el, 'right', `${-this.rightSize - 1}px`);
            }
        }
        if (!this.isRightOpen) {
            this.r.setStyle(this.mainPanel.el, 'right', `${this.rightPanel ? this.defaultHandleWidth : 0}px`);
        }
        // Top Panel
        if (this.topPanel) {
            tempVal = this.topSize + this.defaultHandleWidth;
            this.r.setStyle(this.topPanel.el, 'height', `${tempVal}px`);
            this.r.removeStyle(this.topPanel.el, 'display');
            if (this.isTopOpen) {
                this.r.setStyle(this.mainPanel.el, 'top', `${tempVal}px`);
                this.r.setStyle(this.topPanel.el, 'top', '0');
            }
            else {
                this.r.setStyle(this.topPanel.el, 'top', `${-this.topSize - 1}px`);
            }
            if (this.isTopOpen) {
                if (this.leftPanel) {
                    this.r.setStyle(this.leftPanel.el, 'top', `${tempVal}px`);
                }
                if (this.rightPanel) {
                    this.r.setStyle(this.rightPanel.el, 'top', `${tempVal}px`);
                }
            }
            else {
                if (this.leftPanel) {
                    this.r.setStyle(this.leftPanel.el, 'top', `${this.defaultHandleWidth - 1}px`);
                }
                if (this.rightPanel) {
                    this.r.setStyle(this.rightPanel.el, 'top', `${this.defaultHandleWidth - 1}px`);
                }
            }
        }
        if (!this.isTopOpen) {
            this.r.setStyle(this.mainPanel.el, 'top', `${this.topPanel ? this.defaultHandleWidth : 0}px`);
        }
        // Bottom Panel
        if (this.bottomPanel) {
            tempVal = this.bottomSize + this.defaultHandleWidth;
            this.r.setStyle(this.bottomPanel.el, 'height', `${tempVal}px`);
            this.r.removeStyle(this.bottomPanel.el, 'display');
            if (this.isBottomOpen) {
                this.r.setStyle(this.mainPanel.el, 'bottom', `${tempVal}px`);
                this.r.setStyle(this.bottomPanel.el, 'bottom', '0');
            }
            else {
                this.r.setStyle(this.bottomPanel.el, 'bottom', `${-(this.bottomSize + 1)}px`);
            }
            if (this.isBottomOpen) {
                if (this.leftPanel) {
                    this.r.setStyle(this.leftPanel.el, 'bottom', `${tempVal}px`);
                }
                if (this.rightPanel) {
                    this.r.setStyle(this.rightPanel.el, 'bottom', `${tempVal}px`);
                }
            }
            else {
                if (this.leftPanel) {
                    this.r.setStyle(this.leftPanel.el, 'bottom', `${this.defaultHandleWidth - 1}px`);
                }
                if (this.rightPanel) {
                    this.r.setStyle(this.rightPanel.el, 'bottom', `${this.defaultHandleWidth - 1}px`);
                }
            }
        }
        if (!this.isBottomOpen) {
            this.r.setStyle(this.mainPanel.el, 'bottom', `${this.bottomPanel ? this.defaultHandleWidth : 0}px`);
        }
        // Notify resize globally
        this.bentoNotification.emitResize(this);
    }
    /**
     * Unsubscribe user interaction pointer listeners
     */
    unsubscribeListeners() {
        this.subPointerCancel.unsubscribe();
        this.subPointerMove.unsubscribe();
        this.subPointerUp.unsubscribe();
    }
    /**
     * Set left panel
     */
    setLeftPanel(panel) {
        if (this.leftPanel) {
            // Hook callbacks
            this.leftPanel.isOpen = this.isLeftOpen || false;
            this.r.setStyle(panel.el, 'display', 'none');
            this.leftPanel.onHandleDown = (side, event) => {
                this.onSidePanelHandleDown(side, event);
            };
            this.leftPanel.onEnterOrSpaceDown = () => {
                this.setLeftOpen(!this.isLeftOpen);
                this.render();
                this.leftOpenedChange.emit(this.isLeftOpen);
            };
            this.leftPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
        }
        else {
            this.setLeftOpen(false);
        }
    }
    /**
     * Set right panel
     */
    setRightPanel(panel) {
        if (this.rightPanel) {
            // Hook callbacks
            this.rightPanel.isOpen = this.isRightOpen || false;
            this.r.setStyle(panel.el, 'display', 'none');
            this.rightPanel.onHandleDown = (side, event) => {
                this.onSidePanelHandleDown(side, event);
            };
            this.rightPanel.onEnterOrSpaceDown = () => {
                this.setRightOpen(!this.isRightOpen);
                this.render();
                this.rightOpenedChange.emit(this.isRightOpen);
            };
            this.rightPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
        }
        else {
            this.setRightOpen(false);
        }
    }
    /**
     * Set left panel open flag
     */
    setLeftOpen(isOpen) {
        if (isOpen !== this.isLeftOpen) {
            this.isLeftOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-left');
            }
            else {
                this.r.removeClass(this.el, 'opened-left');
            }
            if (this.leftPanel) {
                this.leftPanel.isOpen = isOpen;
            }
        }
    }
    /**
     * Set right panel open flag
     */
    setRightOpen(isOpen) {
        if (isOpen !== this.isRightOpen) {
            this.isRightOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-right');
            }
            else {
                this.r.removeClass(this.el, 'opened-right');
            }
            if (this.rightPanel) {
                this.rightPanel.isOpen = isOpen;
            }
        }
    }
    /**
     * Set top panel open flag
     */
    setTopOpen(isOpen) {
        if (isOpen !== this.isTopOpen) {
            this.isTopOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-top');
            }
            else {
                this.r.removeClass(this.el, 'opened-top');
            }
            if (this.topPanel) {
                this.topPanel.isOpen = isOpen;
            }
            // Need renderer to resize the left and right panels
            this.render();
        }
    }
    /**
     * Set bottom open flag
     */
    setBottomOpen(isOpen) {
        if (isOpen !== this.isBottomOpen) {
            this.isBottomOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-bottom');
            }
            else {
                this.r.removeClass(this.el, 'opened-bottom');
            }
            if (this.bottomPanel) {
                this.bottomPanel.isOpen = isOpen;
            }
            // Need renderer to resize the left and right panels
            this.render();
        }
    }
    /**
     * Callback when a panel mousedown (touchstart) is fired
     *
     * This method contains other mouse or touch event listeners in order share
     * the same class reference
     *
     */
    onSidePanelHandleDown(side, event) {
        this.originalPoint = this.previousPoint = this.getPoint(event);
        this.isDragged = false;
        this.actionButton = event.currentTarget.className.includes('toggle')
            ? 'toggle'
            : event.currentTarget.className.includes('increase')
                ? 'increase'
                : 'decrease';
        this.actionSide = side;
        this.actionSideStr = side.side;
        this.actionSideLowerCase = side.side.toLowerCase();
        if (event.currentTarget.className.includes('bento-splitter-dragdrop')) {
            this.actionButton = 'dragdrop';
            this.isDragged = true;
            this.r.addClass(this.el, `dragging-${this.actionSideLowerCase}`);
        }
        if (event.type === 'pointerdown') {
            this.pointerMoveEventName = 'pointermove';
            this.pointerUpEventName = 'pointerup';
            this.pointerCancelEventName = 'pointercancel';
        }
        else if (event.type === 'touchstart') {
            this.pointerMoveEventName = 'touchmove';
            this.pointerUpEventName = 'touchend';
            this.pointerCancelEventName = 'touchcancel';
        }
        else {
            this.pointerMoveEventName = 'mousemove';
            this.pointerUpEventName = 'mouseup';
        }
        if (event.currentTarget.className.split(' ').filter(element => ['bento-splitter-toggle,bento-splitter-increase,bento-splitter-decrease,bento-splitter-dragdrop']
            .includes(element)) > -1) {
            this.subPointerMove = fromEvent(this.document, this.pointerMoveEventName, {
                capture: true
            }).subscribe(this.onWindowPointerMove.bind(this));
        }
        this.subPointerUp = fromEvent(this.document, this.pointerUpEventName).subscribe(this.onWindowPointerUp.bind(this));
        if (this.pointerCancelEventName) {
            this.subPointerCancel = fromEvent(this.document, this.pointerCancelEventName).subscribe(this.onWindowPointerUp.bind(this));
        }
        this.originalSize =
            (side instanceof BentoSplitterGroupLeftComponent || side instanceof BentoSplitterGroupRightComponent
                ? side.el.offsetWidth
                : side.el.offsetHeight) - this.defaultHandleWidth;
    }
    /*
       Callback when pointer is moving
       */
    onWindowPointerMove(e) {
        const currentPoint = this.getPoint(e);
        const delta = { x: currentPoint.x - this.previousPoint.x, y: currentPoint.y - this.previousPoint.y };
        if (Math.abs(currentPoint.x - this.originalPoint.x) + Math.abs(currentPoint.y - this.originalPoint.y) > 10) {
            // There is no movement but browser fires 'pointermove' somehow
            this.isDragged = true;
        }
        // Stop touch devices from scrolling
        e.preventDefault();
        // Check if the point leaves window
        if (!this.pointerCancelEventName) {
            if (e.button !== 0 || e.buttons !== 1) {
                this.onWindowPointerLeave(e);
            }
        }
        this.moveSidePanel(delta);
        this.dragDirection = '';
        if (this.previousPoint.x > currentPoint.x) {
            this.dragDirection = 'left';
        }
        else if (this.previousPoint.x < currentPoint.x) {
            this.dragDirection = 'right';
        }
        else if (this.previousPoint.y < currentPoint.y) {
            this.dragDirection = 'down';
        }
        else if (this.previousPoint.y > currentPoint.y) {
            this.dragDirection = 'up';
        }
        this.previousPoint = currentPoint;
        this.render();
    }
    /*
     Callback when pointer is up
     */
    onWindowPointerUp(e) {
        const clEl = this.el;
        const cl = clEl.classList;
        let actionSet = false;
        // Remove event listeners
        this.unsubscribeListeners();
        if (cl.contains(`dragging-${this.actionSideLowerCase}`)) {
            this.r.removeClass(clEl, `dragging-${this.actionSideLowerCase}`);
            if (this[`${this.actionSideLowerCase}Size`] < this.autoCloseThreshhold) {
                this[`set${this.actionSideStr}Open`](false);
                actionSet = true;
                if ((this.dragDirection != 'right' && this.dragDirection != 'down')
                    || (this.actionSideLowerCase === 'left' && this.dragDirection === 'right')) {
                    this[`${this.actionSideLowerCase}Size`] = this.originalSize;
                }
            }
        }
        const hasNoCollapse = cl.contains('no-collapse');
        if (!this.isDragged && !hasNoCollapse && this.actionButton == 'toggle') {
            this[`${this.actionSideStr.toLowerCase()}Opened`] = !this[`is${this.actionSideStr}Open`];
            this[`${this.actionSideStr.toLowerCase()}OpenedChange`].emit(this[`is${this.actionSideStr}Open`]);
            this.disableIncreaseBtn();
        }
        if (this.actionSideLowerCase === 'left' || this.actionSideLowerCase === 'right') {
            if (this.actionButton == 'decrease' || this.dragDirection === 'left') {
                if (this[`${this.actionSideLowerCase}Size`] <= this.resizeStepSize) {
                    this[`set${this.actionSideStr}Open`](false);
                    if (!this.isDragged) {
                        this[`${this.actionSideLowerCase}Width`] = this.originalSize;
                    }
                }
                else {
                    this[`${this.actionSideLowerCase}Panel`].isOpenMax = false;
                    if (!this.isDragged) {
                        this[`${this.actionSideLowerCase}Width`] = Math.round(this[`${this.actionSideLowerCase}Size`] - this.resizeStepSize);
                    }
                }
            }
            else if (this.actionButton == 'increase' || this.dragDirection === 'right') {
                if (!this[`is${this.actionSideStr}Open`] && !actionSet) {
                    this[`set${this.actionSideStr}Open`](true);
                    if (!this.isDragged) {
                        this[`${this.actionSideLowerCase}Width`] = Math.round(this.resizeStepSize);
                    }
                }
                else {
                    if (!this.isDragged) {
                        let oppositePanel;
                        let totalElementWidth = Math.round(this.el.offsetWidth - this.resizeStepSize - this.defaultHandleWidth);
                        let delta = this[`${this.actionSideLowerCase}Size`] == 0
                            ? this.autoCloseThreshhold
                            : Math.min(this[`${this.actionSideLowerCase}MaxWidth`], Math.round(this[`${this.actionSideLowerCase}Size`] + this.resizeStepSize));
                        if (this.actionSideLowerCase == 'left' && this.rightPanel) {
                            delta = Math.min(this.rightPanel.el.offsetLeft - this.defaultHandleWidth, delta);
                            oppositePanel = this.rightPanel;
                        }
                        else if (this.actionSideLowerCase == 'right' && this.leftPanel) {
                            oppositePanel = this.leftPanel;
                            delta = Math.min(this.isLeftOpen
                                ? this.el.offsetWidth - this.leftPanel.el.offsetWidth - this.defaultHandleWidth
                                : this.el.offsetWidth - this.defaultHandleWidth * 2, delta);
                        }
                        if (totalElementWidth > this[`${this.actionSideLowerCase}Size`] || oppositePanel) {
                            this[`${this.actionSideLowerCase}Width`] = delta;
                        }
                        else {
                            this[`${this.actionSideLowerCase}Panel`].isOpenMax = true;
                            this[`${this.actionSideLowerCase}Width`] = this.el.offsetWidth - this.defaultHandleWidth;
                        }
                    }
                }
            }
        }
        else if (this.actionSideLowerCase === 'top' || this.actionSideLowerCase === 'bottom') {
            if (this.actionButton == 'decrease' || this.dragDirection === 'up') {
                if (this[`${this.actionSideLowerCase}Size`] <= this.resizeStepSize) {
                    this[`set${this.actionSideStr}Open`](false);
                    if (!this.isDragged) {
                        this[`${this.actionSideLowerCase}Width`] = this.originalSize;
                    }
                }
                else {
                    this[`${this.actionSideLowerCase}Panel`].isOpenMax = false;
                    if (!this.isDragged) {
                        this[`${this.actionSideLowerCase}Height`] = Math.round(this[`${this.actionSideLowerCase}Size`] - this.resizeStepSize);
                    }
                }
            }
            else if (this.actionButton == 'increase' || this.dragDirection === 'down') {
                if (!this[`is${this.actionSideStr}Open`]) {
                    this[`set${this.actionSideStr}Open`](true);
                    if (!this.isDragged) {
                        this[`${this.actionSideLowerCase}Height`] = Math.round(this.resizeStepSize - this.defaultHandleWidth);
                    }
                }
                else {
                    if (!this.isDragged) {
                        let totalElementHeight = Math.round(this.el.offsetHeight - this.resizeStepSize - this.defaultHandleWidth);
                        let oppositePanel = this.actionSideLowerCase === 'top' && this.bottomPanel
                            ? this.bottomPanel
                            : this.actionSideLowerCase === 'bottom' && this.topPanel
                                ? this.topPanel
                                : undefined;
                        if (totalElementHeight > this[`${this.actionSideLowerCase}Size`] || oppositePanel) {
                            this[`${this.actionSideLowerCase}Size`] =
                                this[`${this.actionSideLowerCase}Size`] == 0
                                    ? this.autoCloseThreshhold
                                    : Math.min(this[`${this.actionSideLowerCase}MaxHeight`], Math.round(this[`${this.actionSideLowerCase}Size`] + this.resizeStepSize));
                            if (oppositePanel) {
                                let oppositePanelSize = this.actionSideLowerCase === 'top'
                                    ? oppositePanel.el.offsetTop
                                    : this.el.offsetHeight - oppositePanel.el.offsetHeight;
                                this[`${this.actionSideLowerCase}Size`] = Math.min(oppositePanel.isOpen
                                    ? oppositePanelSize - this.defaultHandleWidth
                                    : this.el.offsetHeight - this.defaultHandleWidth * 2, this[`${this.actionSideLowerCase}Size`]);
                            }
                        }
                        else {
                            this[`${this.actionSideLowerCase}Panel`].isOpenMax = true;
                            this[`${this.actionSideLowerCase}Height`] = this.el.offsetHeight - this.defaultHandleWidth;
                        }
                    }
                }
            }
        }
        this.dragDirection = '';
        this[`${this.actionSideLowerCase}SizeChange`].emit(this[`${this.actionSideLowerCase}Size`]);
        this.render();
    }
    /*
    Callback when pointer leaves window
    */
    onWindowPointerLeave(e) {
        this.onWindowPointerUp(e);
    }
    disableIncreaseBtn() {
        let currentPanelSize, currentPanelPosition, elSize;
        if (this.actionSideLowerCase === 'left' || this.actionSideLowerCase === 'right') {
            currentPanelSize = this[`${this.actionSideLowerCase}Panel`].el.offsetWidth;
            currentPanelPosition = this[`${this.actionSideLowerCase}Panel`].el.offsetLeft;
            elSize = this.el.offsetWidth;
        }
        else {
            currentPanelSize = this[`${this.actionSideLowerCase}Panel`].el.offsetHeight;
            currentPanelPosition = this[`${this.actionSideLowerCase}Panel`].el.offsetTop;
            elSize = this.el.offsetHeight;
        }
        if (currentPanelPosition === 0) {
            this[`${this.actionSideLowerCase}Panel`].isOpenMax = false;
        }
        else if (currentPanelSize === elSize) {
            this[`${this.actionSideLowerCase}Panel`].isOpenMax = true;
        }
    }
    /**
     * Move the current action side with a delta
     */
    moveSidePanel(delta) {
        switch (this.actionSide) {
            case this.leftPanel:
                this.leftSize = Math.max(0, Math.min(this.el.offsetWidth - this.defaultHandleWidth, Math.min(this.leftMaxWidth, this.leftSize + delta.x)));
                if (this.rightPanel) {
                    this.leftSize = Math.min(this.rightPanel.el.offsetLeft - this.defaultHandleWidth, this.leftSize);
                }
                this.r.addClass(this.el, 'dragging-left');
                if (!this.isLeftOpen && Math.abs(delta.x) > 0) {
                    this.leftSize = delta.x;
                    if (this.isRtl) {
                        this.rightOpened = true;
                    }
                    else {
                        this.leftOpened = true;
                    }
                }
                if (this.leftSize === this.el.offsetWidth - this.defaultHandleWidth) {
                    this.leftPanel.isOpenMax = true;
                }
                break;
            case this.rightPanel:
                this.rightSize = Math.max(0, Math.min(this.el.offsetWidth - this.defaultHandleWidth, Math.min(this.rightMaxWidth, this.rightSize - delta.x)));
                if (this.leftPanel) {
                    this.rightSize = Math.min(this.isLeftOpen
                        ? this.el.offsetWidth - this.leftPanel.el.offsetWidth - this.defaultHandleWidth
                        : this.el.offsetWidth - this.defaultHandleWidth * 2, this.rightSize);
                }
                this.r.addClass(this.el, 'dragging-right');
                if (!this.isRightOpen) {
                    if (this.isRtl && delta.x > 0) {
                        this.leftOpened = true;
                        this.rightSize = delta.x;
                    }
                    else if (delta.x < 0) {
                        this.rightOpened = true;
                        this.rightSize = -delta.x;
                    }
                }
                if (this.rightSize === this.el.offsetWidth - this.defaultHandleWidth) {
                    this.rightPanel.isOpenMax = true;
                }
                break;
            case this.topPanel:
                this.topSize = Math.max(0, Math.min(this.el.offsetHeight - this.defaultHandleWidth, Math.min(this.topMaxHeight, this.topSize + delta.y)));
                if (this.bottomPanel) {
                    this.topSize = Math.min(this.bottomPanel.el.offsetTop - this.defaultHandleWidth, this.topSize);
                }
                this.r.addClass(this.el, 'dragging-top');
                if (!this.isTopOpen && delta.y > 0) {
                    this.topSize = delta.y;
                    this.topOpened = true;
                }
                if (this.topSize === this.el.offsetHeight - this.defaultHandleWidth) {
                    this.topPanel.isOpenMax = true;
                }
                break;
            case this.bottomPanel:
                this.bottomSize = Math.max(0, Math.min(this.el.offsetHeight - this.defaultHandleWidth, Math.min(this.bottomMaxHeight, this.bottomSize - delta.y)));
                if (this.topPanel) {
                    this.bottomSize = Math.min(this.isTopOpen
                        ? this.el.offsetHeight - this.topPanel.el.offsetHeight - this.defaultHandleWidth
                        : this.el.offsetHeight - this.defaultHandleWidth * 2, this.bottomSize);
                }
                this.r.addClass(this.el, 'dragging-bottom');
                if (!this.isBottomOpen && delta.y < 0) {
                    this.bottomSize = -delta.y;
                    this.bottomOpened = true;
                }
                if (this.bottomSize === this.el.offsetHeight - this.defaultHandleWidth) {
                    this.bottomPanel.isOpenMax = true;
                }
                break;
        }
    }
    onSideArrowDown(e, sideComponent, direction) {
        const sideLowerCase = sideComponent.side.toLowerCase();
        const wasSideOpen = this[`is${sideComponent.side}Open`];
        this.originalSize =
            (sideComponent instanceof BentoSplitterGroupLeftComponent ||
                sideComponent instanceof BentoSplitterGroupRightComponent
                ? sideComponent.el.offsetWidth
                : sideComponent.el.offsetHeight) - this.defaultHandleWidth;
        const isClosing = ((sideComponent === this.leftPanel || sideComponent === this.topPanel) && direction < 0) ||
            ((sideComponent === this.rightPanel || sideComponent === this.bottomPanel) && direction > 0);
        /* Similar to some graphical applications, holding down shift key amplifies the momentum for each arrow step */
        const momentum = direction * (e.shiftKey ? 50 : 10);
        const delta = !isClosing && !wasSideOpen
            ? /* Using autoCloseThreshold for the first opened size when closed*/
                { x: direction * this.autoCloseThreshhold, y: direction * this.autoCloseThreshhold }
            : /* Otherwise use default momentum */
                { x: momentum, y: momentum };
        this.actionSide = sideComponent;
        this.moveSidePanel(delta);
        this[`${sideLowerCase}SizeChange`].emit(this[`${sideLowerCase}Size`]);
        if (isClosing && this[`${sideLowerCase}Size`] < this.autoCloseThreshhold && this[`is${sideComponent.side}Open`]) {
            this.r.removeClass(this.el, `dragging-${sideLowerCase}`);
            this[`set${sideComponent.side}Open`](false);
            this[`${sideLowerCase}Size`] = this.originalSize;
            // Emit changes
            this[`${sideLowerCase}OpenedChange`].emit(false);
            this.render();
        }
        else if (this[`is${sideComponent.side}Open`]) {
            if (!wasSideOpen) {
                this[`set${sideComponent.side}Open`](true);
                this[`${sideLowerCase}OpenedChange`].emit(true);
            }
            this.render();
        }
    }
    /**
   * Retrieves current pointer coordinate
   */
    getPoint(event) {
        if (event.touches) {
            // This is a TouchEvent
            return { x: event.touches.item(0).screenX, y: event.touches.item(0).screenY };
        }
        else {
            // Cast event type
            return { x: event.pageX ? event.pageX : event.clientX, y: event.pageY ? event.pageY : event.clientY };
        }
    }
}
BentoSplitterGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupComponent, deps: [{ token: i0.ElementRef }, { token: BentoNotification }, { token: WindowRef }, { token: i0.Renderer2 }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoSplitterGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoSplitterGroupComponent, selector: "bento-splitter-group", inputs: { autoResize: "autoResize", resizeStepSize: "resizeStepSize", noCollapse: "noCollapse", leftWidth: "leftWidth", leftMaxWidth: "leftMaxWidth", leftOpened: "leftOpened", rightWidth: "rightWidth", rightMaxWidth: "rightMaxWidth", rightOpened: "rightOpened", topHeight: "topHeight", topMaxHeight: "topMaxHeight", topOpened: "topOpened", bottomHeight: "bottomHeight", bottomMaxHeight: "bottomMaxHeight", bottomOpened: "bottomOpened" }, outputs: { leftSizeChange: "leftWidthChange", leftOpenedChange: "leftOpenedChange", rightSizeChange: "rightWidthChange", rightOpenedChange: "rightOpenedChange", topSizeChange: "topHeightChange", topOpenedChange: "topOpenedChange", bottomSizeChange: "bottomHeightChange", bottomOpenedChange: "bottomOpenedChange" }, host: { properties: { "class.isIE": "this._isIE" } }, providers: [BentoNotification], queries: [{ propertyName: "_leftPanel", first: true, predicate: BentoSplitterGroupLeftComponent, descendants: true }, { propertyName: "_topPanel", first: true, predicate: BentoSplitterGroupTopComponent, descendants: true }, { propertyName: "_rightPanel", first: true, predicate: BentoSplitterGroupRightComponent, descendants: true }, { propertyName: "_bottomPanel", first: true, predicate: BentoSplitterGroupBottomComponent, descendants: true }, { propertyName: "mainPanel", first: true, predicate: BentoSplitterGroupMainComponent, descendants: true, static: true }], ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".ng-bento bento-splitter-group{bottom:0;box-sizing:border-box;left:0;min-height:400px;overflow:hidden;position:absolute;right:0;top:0}.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-default,.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-move,.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-default,.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-move{left:-50%}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{align-items:center;border-width:0;box-sizing:border-box;display:flex;justify-content:center;margin:0;overflow:hidden;padding:0;position:absolute;touch-action:none;z-index:2}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle>.btn{border-radius:3px;position:relative}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle>.btn i{left:50%;margin:0!important;position:absolute;top:50%;transform:translate(-50%,-50%)}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{border-bottom-width:1px;border-style:solid;border-top-width:1px;bottom:auto;left:0;top:auto;width:100%}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top>.btn.btn-icon,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom>.btn.btn-icon{height:14px;margin-right:5px;min-width:auto;padding:0;width:32px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{border-left-width:1px;border-right-width:1px;border-style:solid;flex-direction:column;height:100%;left:auto;right:auto;top:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{height:18px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{width:18px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left>.btn.btn-icon,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right>.btn.btn-icon{height:32px;margin-bottom:5px;min-width:auto;padding:0;width:14px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top{bottom:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{top:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left{right:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{left:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle:focus{outline:none}.ng-bento bento-splitter-group.unselectable div,.ng-bento bento-splitter-group.unselectable span,.ng-bento bento-splitter-group.unselectable p,.ng-bento bento-splitter-group.unselectable strong,.ng-bento bento-splitter-group.unselectable i,.ng-bento bento-splitter-group.unselectable b,.ng-bento bento-splitter-group.unselectable h1,.ng-bento bento-splitter-group.unselectable h2,.ng-bento bento-splitter-group.unselectable h3,.ng-bento bento-splitter-group.unselectable h4,.ng-bento bento-splitter-group.unselectable h5,.ng-bento bento-splitter-group.unselectable h6,.ng-bento bento-splitter-group.unselectable input,.ng-bento bento-splitter-group.unselectable tr{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-splitter-group.bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel{transition:none!important}.ng-bento bento-splitter-group .bento-splitter-group-left,.ng-bento bento-splitter-group .bento-splitter-group-right,.ng-bento bento-splitter-group .bento-splitter-group-top,.ng-bento bento-splitter-group .bento-splitter-group-bottom,.ng-bento bento-splitter-group .bento-splitter-group-main{background-color:transparent;box-sizing:border-box;margin:0;overflow:hidden;padding:0;position:absolute;z-index:0}.ng-bento bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-right>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-top>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-bottom>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-main>.bento-splitter-group-inner{overflow:auto;position:absolute}.ng-bento bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner{right:18px}.ng-bento bento-splitter-group .bento-splitter-group-right>.bento-splitter-group-inner{left:18px}.ng-bento bento-splitter-group .bento-splitter-group-top>.bento-splitter-group-inner{bottom:18px}.ng-bento bento-splitter-group .bento-splitter-group-bottom>.bento-splitter-group-inner{top:18px}.ng-bento bento-splitter-group .bento-splitter-group-left:focus,.ng-bento bento-splitter-group .bento-splitter-group-right:focus,.ng-bento bento-splitter-group .bento-splitter-group-top:focus,.ng-bento bento-splitter-group .bento-splitter-group-bottom:focus,.ng-bento bento-splitter-group .bento-splitter-group-main:focus{outline:none}.ng-bento bento-splitter-group .bento-splitter-group-left{bottom:0;top:0;transition:left .1s,width .1s,top .1s,bottom .1s}.ng-bento bento-splitter-group.opened-left>.bento-splitter-group-main{left:auto}.ng-bento bento-splitter-group .bento-splitter-group-right{bottom:0;top:0;transition:right .1s,width .1s,top .1s,bottom .1s}.ng-bento bento-splitter-group.opened-right>.bento-splitter-group-main{right:auto}.ng-bento bento-splitter-group .bento-splitter-group-top{left:0;right:0;transition:top .1s,height .1s}.ng-bento bento-splitter-group.opened-top>.bento-splitter-group-main{top:0}.ng-bento bento-splitter-group .bento-splitter-group-bottom{left:0;right:0;transition:bottom .1s,height .1s}.ng-bento bento-splitter-group.opened-bottom>.bento-splitter-group-main{bottom:0}.ng-bento bento-splitter-group .bento-splitter-group-main{bottom:0;left:0;overflow:hidden;right:0;top:0;transition:left .1s,right .1s,top .1s,bottom .1s;z-index:1}.ng-bento bento-splitter-group.bento-splitter-group-autoresize{display:block;position:relative;width:100%}.ng-bento bento-splitter-group.bento-splitter-group-autoresize>.bento-splitter-group-main>.bento-splitter-group-inner{display:block;height:auto;margin:0;overflow-x:auto;overflow-y:visible;position:relative;width:100%}.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right{cursor:col-resize}.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom{cursor:row-resize}.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-move{display:block}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-default,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-default,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-default,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-default{display:none}.ng-bento .dragging-left>.bento-splitter-group-panel,.ng-bento .dragging-right>.bento-splitter-group-panel,.ng-bento .dragging-top>.bento-splitter-group-panel,.ng-bento .dragging-bottom>.bento-splitter-group-panel,.ng-bento .bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel{transition:none!important}@media (prefers-reduced-motion: reduce){.ng-bento .dragging-left>.bento-splitter-group-panel,.ng-bento .dragging-right>.bento-splitter-group-panel,.ng-bento .dragging-top>.bento-splitter-group-panel,.ng-bento .dragging-bottom>.bento-splitter-group-panel,.ng-bento .bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel{transition:none}}.ng-bento .row-resize{cursor:n-resize}.ng-bento .col-resize{cursor:e-resize}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-splitter-group', providers: [BentoNotification], encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".ng-bento bento-splitter-group{bottom:0;box-sizing:border-box;left:0;min-height:400px;overflow:hidden;position:absolute;right:0;top:0}.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-default,.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-move,.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-default,.ng-bento [dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-move{left:-50%}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{align-items:center;border-width:0;box-sizing:border-box;display:flex;justify-content:center;margin:0;overflow:hidden;padding:0;position:absolute;touch-action:none;z-index:2}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle>.btn{border-radius:3px;position:relative}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle>.btn i{left:50%;margin:0!important;position:absolute;top:50%;transform:translate(-50%,-50%)}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{border-bottom-width:1px;border-style:solid;border-top-width:1px;bottom:auto;left:0;top:auto;width:100%}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top>.btn.btn-icon,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom>.btn.btn-icon{height:14px;margin-right:5px;min-width:auto;padding:0;width:32px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{border-left-width:1px;border-right-width:1px;border-style:solid;flex-direction:column;height:100%;left:auto;right:auto;top:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{height:18px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{width:18px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left>.btn.btn-icon,.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right>.btn.btn-icon{height:32px;margin-bottom:5px;min-width:auto;padding:0;width:14px}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top{bottom:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{top:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left{right:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{left:0}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle:focus{outline:none}.ng-bento bento-splitter-group.unselectable div,.ng-bento bento-splitter-group.unselectable span,.ng-bento bento-splitter-group.unselectable p,.ng-bento bento-splitter-group.unselectable strong,.ng-bento bento-splitter-group.unselectable i,.ng-bento bento-splitter-group.unselectable b,.ng-bento bento-splitter-group.unselectable h1,.ng-bento bento-splitter-group.unselectable h2,.ng-bento bento-splitter-group.unselectable h3,.ng-bento bento-splitter-group.unselectable h4,.ng-bento bento-splitter-group.unselectable h5,.ng-bento bento-splitter-group.unselectable h6,.ng-bento bento-splitter-group.unselectable input,.ng-bento bento-splitter-group.unselectable tr{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-splitter-group.bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel{transition:none!important}.ng-bento bento-splitter-group .bento-splitter-group-left,.ng-bento bento-splitter-group .bento-splitter-group-right,.ng-bento bento-splitter-group .bento-splitter-group-top,.ng-bento bento-splitter-group .bento-splitter-group-bottom,.ng-bento bento-splitter-group .bento-splitter-group-main{background-color:transparent;box-sizing:border-box;margin:0;overflow:hidden;padding:0;position:absolute;z-index:0}.ng-bento bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-right>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-top>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-bottom>.bento-splitter-group-inner,.ng-bento bento-splitter-group .bento-splitter-group-main>.bento-splitter-group-inner{overflow:auto;position:absolute}.ng-bento bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner{right:18px}.ng-bento bento-splitter-group .bento-splitter-group-right>.bento-splitter-group-inner{left:18px}.ng-bento bento-splitter-group .bento-splitter-group-top>.bento-splitter-group-inner{bottom:18px}.ng-bento bento-splitter-group .bento-splitter-group-bottom>.bento-splitter-group-inner{top:18px}.ng-bento bento-splitter-group .bento-splitter-group-left:focus,.ng-bento bento-splitter-group .bento-splitter-group-right:focus,.ng-bento bento-splitter-group .bento-splitter-group-top:focus,.ng-bento bento-splitter-group .bento-splitter-group-bottom:focus,.ng-bento bento-splitter-group .bento-splitter-group-main:focus{outline:none}.ng-bento bento-splitter-group .bento-splitter-group-left{bottom:0;top:0;transition:left .1s,width .1s,top .1s,bottom .1s}.ng-bento bento-splitter-group.opened-left>.bento-splitter-group-main{left:auto}.ng-bento bento-splitter-group .bento-splitter-group-right{bottom:0;top:0;transition:right .1s,width .1s,top .1s,bottom .1s}.ng-bento bento-splitter-group.opened-right>.bento-splitter-group-main{right:auto}.ng-bento bento-splitter-group .bento-splitter-group-top{left:0;right:0;transition:top .1s,height .1s}.ng-bento bento-splitter-group.opened-top>.bento-splitter-group-main{top:0}.ng-bento bento-splitter-group .bento-splitter-group-bottom{left:0;right:0;transition:bottom .1s,height .1s}.ng-bento bento-splitter-group.opened-bottom>.bento-splitter-group-main{bottom:0}.ng-bento bento-splitter-group .bento-splitter-group-main{bottom:0;left:0;overflow:hidden;right:0;top:0;transition:left .1s,right .1s,top .1s,bottom .1s;z-index:1}.ng-bento bento-splitter-group.bento-splitter-group-autoresize{display:block;position:relative;width:100%}.ng-bento bento-splitter-group.bento-splitter-group-autoresize>.bento-splitter-group-main>.bento-splitter-group-inner{display:block;height:auto;margin:0;overflow-x:auto;overflow-y:visible;position:relative;width:100%}.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right{cursor:col-resize}.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom{cursor:row-resize}.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-move{display:block}.ng-bento bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle .bento-splitter-handle-move,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-default,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-default,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-default,.ng-bento bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-default{display:none}.ng-bento .dragging-left>.bento-splitter-group-panel,.ng-bento .dragging-right>.bento-splitter-group-panel,.ng-bento .dragging-top>.bento-splitter-group-panel,.ng-bento .dragging-bottom>.bento-splitter-group-panel,.ng-bento .bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel{transition:none!important}@media (prefers-reduced-motion: reduce){.ng-bento .dragging-left>.bento-splitter-group-panel,.ng-bento .dragging-right>.bento-splitter-group-panel,.ng-bento .dragging-top>.bento-splitter-group-panel,.ng-bento .dragging-bottom>.bento-splitter-group-panel,.ng-bento .bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel{transition:none}}.ng-bento .row-resize{cursor:n-resize}.ng-bento .col-resize{cursor:e-resize}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoNotification }, { type: WindowRef }, { type: i0.Renderer2 }, { type: i2.Directionality }]; }, propDecorators: { autoResize: [{
                type: Input
            }], resizeStepSize: [{
                type: Input
            }], noCollapse: [{
                type: Input
            }], leftWidth: [{
                type: Input
            }], leftMaxWidth: [{
                type: Input
            }], leftSizeChange: [{
                type: Output,
                args: ['leftWidthChange']
            }], leftOpened: [{
                type: Input
            }], leftOpenedChange: [{
                type: Output
            }], rightWidth: [{
                type: Input
            }], rightMaxWidth: [{
                type: Input
            }], rightSizeChange: [{
                type: Output,
                args: ['rightWidthChange']
            }], rightOpened: [{
                type: Input
            }], rightOpenedChange: [{
                type: Output
            }], topHeight: [{
                type: Input
            }], topMaxHeight: [{
                type: Input
            }], topSizeChange: [{
                type: Output,
                args: ['topHeightChange']
            }], topOpened: [{
                type: Input
            }], topOpenedChange: [{
                type: Output
            }], bottomHeight: [{
                type: Input
            }], bottomMaxHeight: [{
                type: Input
            }], bottomSizeChange: [{
                type: Output,
                args: ['bottomHeightChange']
            }], bottomOpened: [{
                type: Input
            }], bottomOpenedChange: [{
                type: Output
            }], _isIE: [{
                type: HostBinding,
                args: ['class.isIE']
            }], _leftPanel: [{
                type: ContentChild,
                args: [BentoSplitterGroupLeftComponent]
            }], _topPanel: [{
                type: ContentChild,
                args: [BentoSplitterGroupTopComponent]
            }], _rightPanel: [{
                type: ContentChild,
                args: [BentoSplitterGroupRightComponent]
            }], _bottomPanel: [{
                type: ContentChild,
                args: [BentoSplitterGroupBottomComponent]
            }], mainPanel: [{
                type: ContentChild,
                args: [BentoSplitterGroupMainComponent, { static: true }]
            }] } });

class BentoSplitterGroupModule extends ConsumerDataValidator {
}
BentoSplitterGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoSplitterGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupModule, declarations: [BentoSplitterGroupComponent,
        BentoSplitterGroupLeftComponent,
        BentoSplitterGroupRightComponent,
        BentoSplitterGroupTopComponent,
        BentoSplitterGroupBottomComponent,
        BentoSplitterGroupMainComponent,
        BentoSplitterGroupSideComponent], imports: [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        A11yModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule], exports: [BentoSplitterGroupComponent,
        BentoSplitterGroupLeftComponent,
        BentoSplitterGroupRightComponent,
        BentoSplitterGroupTopComponent,
        BentoSplitterGroupBottomComponent,
        BentoSplitterGroupMainComponent,
        BentoSplitterGroupSideComponent] });
BentoSplitterGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            A11yModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoSplitterGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoUtilsModule,
                        A11yModule,
                        BentoFocusMonitorModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule
                    ],
                    declarations: [
                        BentoSplitterGroupComponent,
                        BentoSplitterGroupLeftComponent,
                        BentoSplitterGroupRightComponent,
                        BentoSplitterGroupTopComponent,
                        BentoSplitterGroupBottomComponent,
                        BentoSplitterGroupMainComponent,
                        BentoSplitterGroupSideComponent
                    ],
                    exports: [
                        BentoSplitterGroupComponent,
                        BentoSplitterGroupLeftComponent,
                        BentoSplitterGroupRightComponent,
                        BentoSplitterGroupTopComponent,
                        BentoSplitterGroupBottomComponent,
                        BentoSplitterGroupMainComponent,
                        BentoSplitterGroupSideComponent
                    ]
                }]
        }] });

/* eslint-disable  @typescript-eslint/no-unused-expressions */
/**
 * A component to accomendate scroll panels location and sticks itself to the bottom to its parent scrolling panel
 */
class BentoStickyBarDirective {
    constructor(r, elRef, winRef, tabService, bentoNotification, dir) {
        this.r = r;
        this.winRef = winRef;
        this.tabService = tabService;
        this.bentoNotification = bentoNotification;
        this.dir = dir;
        /**
         * Side where this element becomes sticky
         */
        this.side = 'bottom';
        /**
         * Determine if this component does full width of the scrollable when goes sticky
         */
        this.fullWidth = true;
        /**
         * Show this sticky bar only when a specified HTMLElement is visible
         */
        this.showOnElementVisible = null;
        this.resizeSubscription = Subscription.EMPTY;
        this.document = winRef.nativeDocument;
        this.window = winRef.nativeWindow;
        this.el = elRef.nativeElement;
        this.lastScrolled = performance.now();
        this.stickyEl = this.r.createElement('div');
        this.onWindowScroll = this.onWindowScroll.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        if (dir) {
            this.isRTL = dir.value === 'rtl';
            dir.change.subscribe(() => {
                this.flipDirection();
            });
        }
    }
    flipDirection() {
        this.isRTL = this.dir.value === 'rtl';
        this.checkAllocation();
        setTimeout(() => {
            this.alignBar();
        });
    }
    ngOnInit() {
        // Initialize sticky bar DOM
        this.r.addClass(this.stickyEl, 'bento-sticky-bar');
        this.stickyEl.addEventListener('keydown', e => {
            this.onStickyBarKeydown(e);
        });
        this.document.addEventListener('scroll', this.onWindowScroll, true); // Have to use vanilla JS to utilize `useCapture`
        this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe(() => {
            this.onWindowResize();
        });
        // Get reference visible element
        if (this.showOnElementVisible) {
            if (typeof this.showOnElementVisible === 'string') {
                this.showOnElementVisible = this.document.querySelector(this.showOnElementVisible);
            }
        }
    }
    ngOnDestroy() {
        // Remove all window listeners to prevent memory leak
        this.document.removeEventListener('scroll', this.onWindowScroll, true);
        this.resizeSubscription.unsubscribe();
        if (this.stickyEl.parentElement) {
            // Remove sticky element from any HTMLElement if there is one
            this.stickyEl.parentElement.removeChild(this.stickyEl);
            this.stickyEl = null;
        }
        if (this.placeholder) {
            if (this.placeholder.el.parentElement) {
                this.placeholder.el.parentElement.removeChild(this.placeholder.el);
            }
            if (this.placeholder.marker.parentElement) {
                this.placeholder.marker.parentElement.removeChild(this.placeholder.marker);
            }
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            // There are cases where UI elements are not renderred yet
            this.checkAllocation();
        });
    }
    ngOnChanges(changes) {
        // Update css
        if (changes.side) {
            if (changes.side.currentValue === 'top') {
                this.r.addClass(this.stickyEl, 'top');
            }
            else {
                this.r.removeClass(this.stickyEl, 'top');
            }
        }
    }
    /**
     * Method to align this component with the scrollable
     */
    alignBar() {
        if (this.stickyEl.parentElement) {
            const isFixed = this.stickyEl.classList.contains('fixed');
            // Make sure everything is aligned since the sticky bar is in the view
            const parentRect = isFixed
                ? // scrollParentEl is Document and there is no `getBoundingClientRect()` for Document object
                    {
                        top: 0,
                        left: 0,
                        right: this.viewSize.width,
                        bottom: this.viewSize.height,
                        width: this.viewSize.width,
                        height: this.viewSize.height
                    }
                : this.scrollParentEl.getBoundingClientRect();
            let left = 0;
            let top = 0;
            let width;
            if (this.fullWidth) {
                left += this.scrollParentEl.offsetLeft;
                width = this.scrollParentEl.offsetWidth - this.winRef.scrollbarWidth;
            }
            else {
                const placeholderRect = this.placeholder.el.getBoundingClientRect();
                left = placeholderRect.left - parentRect.left;
                width = this.placeholder.el.offsetWidth;
            }
            if (this.isRTL) {
                left += this.winRef.scrollbarWidth;
            }
            if (this.winRef.isFF) {
                // Firefox has an additional 1px padding on the top left
                // It needs to be removed to avoid the extra pixel on the left
                left--;
            }
            this.r.setStyle(this.stickyEl, 'width', `${width}px`);
            this.r.setStyle(this.stickyEl, 'left', `${left}px`);
            if (isFixed) {
                // Not need to align vertically since this sticky bar is fixed either the
                // top of the viewport or this bottom
                return;
            }
            if (this.side === 'bottom') {
                const parentStyle = this.window.getComputedStyle(this.scrollParentEl);
                // Bottom alignment
                if (this.scrollParentEl.offsetWidth < this.scrollParentEl.scrollWidth &&
                    parentStyle.overflowX === 'auto' &&
                    parentStyle.overflowX === 'scroll') {
                    // There is horizontal scrollbar
                    top =
                        this.scrollParentEl.offsetTop + parentRect.height - this.stickyEl.offsetHeight - this.winRef.scrollbarWidth;
                }
                else {
                    // There is no horizontal scrollbar
                    top = this.scrollParentEl.offsetTop + parentRect.height - this.stickyEl.offsetHeight;
                }
            }
            else {
                // Top alignment
                top = this.scrollParentEl.offsetTop;
            }
            if (this.winRef.isFF) {
                // Firefox has an additional 1px padding on the top left
                // It needs to be removed to avoid the extra pixel on the left
                top--;
            }
            this.r.setStyle(this.stickyEl, 'top', `${top}px`);
        }
    }
    /**
     * A method/callback to check whether sticky bar should be displayed
     */
    checkAllocation(e) {
        if (this.stickyEl == null) {
            // Looks like this item has already destroyed but the unsubscribe didn't catch up
            /* istanbul ignore next */
            return;
        }
        const timeScrolled = performance.now();
        const dTime = timeScrolled - this.lastScrolled;
        const elAtFooterLocation = this.placeholder ? this.placeholder.el : this.el;
        const elRect = elAtFooterLocation.getBoundingClientRect();
        const showOnRefElementRect = this.showOnElementVisible
            ? this.showOnElementVisible.getBoundingClientRect()
            : null;
        let refElementInView = true;
        let parentRect;
        let offsetParent;
        this.lastScrolled = timeScrolled;
        if (dTime > 500 || !e) {
            this.scrollParentEl = this.getScrollParent(elAtFooterLocation);
            this.viewSize = this.getViewSize();
        }
        if (this.scrollParentEl === this.document) {
            if (showOnRefElementRect &&
                (showOnRefElementRect.top + elRect.height > this.viewSize.height || showOnRefElementRect.bottom < 0)) {
                // refElement is not visible in viewport
                refElementInView = false;
            }
            if (((Math.floor(elRect.bottom) > this.viewSize.height && this.side === 'bottom') ||
                (elRect.top < 0 && this.side === 'top')) &&
                refElementInView) {
                if (!this.placeholder) {
                    offsetParent = this.document.body;
                    this.stickyEl.classList.add('fixed');
                    offsetParent.appendChild(this.stickyEl);
                    this.placeholder = this.moveBarToSticky();
                    // Need directive to be able to receive focus
                    this.onElementFocusCancel = this.r.listen(this.placeholder.el, 'focus', event => {
                        this.onElFocus(event);
                    });
                }
            }
            else if (this.stickyEl.parentElement) {
                this.stickyEl.parentElement.removeChild(this.stickyEl);
                this.restoreBarFromSticky();
                // Need directive to remove focus
                this.onElementFocusCancel();
            }
        }
        else if (!e || e.target === this.scrollParentEl) {
            parentRect = this.scrollParentEl.getBoundingClientRect();
            if (showOnRefElementRect &&
                (showOnRefElementRect.top + elRect.height > parentRect.bottom || showOnRefElementRect.bottom < parentRect.top)) {
                // refElement is not visible in viewport
                refElementInView = false;
            }
            if (((Math.floor(elRect.bottom) > parentRect.bottom && this.side === 'bottom') ||
                (elRect.top < parentRect.top && this.side === 'top')) &&
                refElementInView) {
                if (!this.stickyEl.offsetParent) {
                    // Append sticky
                    offsetParent = this.scrollParentEl.offsetParent;
                    this.placeholder = this.moveBarToSticky();
                    this.r.setStyle(this.stickyEl, 'visibility', 'hidden');
                    this.r.appendChild(offsetParent, this.stickyEl);
                    this.r.removeStyle(this.stickyEl, 'visibility');
                    // Need directive to be able to receive focus
                    this.onElementFocusCancel = this.r.listen(this.placeholder.el, 'focus', event => {
                        this.onElFocus(event);
                    });
                    // adjust the top full time in case this content is pushed down but padding changes
                    this.alignBar();
                }
            }
            else {
                if (this.stickyEl && this.stickyEl.parentElement) {
                    this.stickyEl.parentElement.removeChild(this.stickyEl);
                    this.stickyEl.style.top = '-1000px'; // just in case
                    this.restoreBarFromSticky();
                    // Need directive to remove focus
                    this.el.removeAttribute('tabindex');
                    this.onElementFocusCancel();
                }
            }
        }
    }
    /**
     * Callback when window is resized
     */
    onWindowResize() {
        this.checkAllocation();
        setTimeout(() => {
            this.alignBar();
        });
    }
    /**
     * Callback when there is a scrolling
     */
    onWindowScroll(e) {
        this.checkAllocation(e);
    }
    /**
     * Get viewport size (aka window size)
     */
    getViewSize() {
        return {
            width: this.window.innerWidth || this.document.body.clientWidth,
            height: this.window.innerHeight || this.document.body.clientHeight
        };
    }
    /**
     * Tasks to perform when el is focused
     */
    onElFocus(e) {
        const tabbables = this.tabService.findTabbable(this.stickyEl);
        if (tabbables.length) {
            setTimeout(function () {
                tabbables[0].focus();
            });
        }
    }
    /**
     * Used to catch Tab keys
     */
    onStickyBarKeydown(e) {
        // Tab: 9
        if (e.keyCode === Keyboard.TAB) {
            const tabbables = this.tabService.findTabbable(this.stickyEl);
            if (e.target === tabbables[0] && e.shiftKey) {
                // focus back
                if (this.placeholder) {
                    this.placeholder.marker.focus();
                }
            }
            else if (e.target === tabbables[tabbables.length - 1] && !e.shiftKey) {
                if (this.placeholder) {
                    this.placeholder.el.firstChild.focus();
                }
            }
        }
    }
    /**
     * Move directive to the sticky bar
     */
    moveBarToSticky() {
        const placeholder = this.r.createElement('div');
        const previousMarker = this.r.createElement('div');
        const bar = this.el;
        const parent = bar.parentElement;
        previousMarker.className = 'bento-sticky-bar-previous-marker';
        previousMarker.setAttribute('tabindex', '-1');
        placeholder.className = 'bento-sticky-bar-placeholder';
        placeholder.setAttribute('tabindex', '0');
        placeholder.innerHTML = '<div class="bento-sticky-bar-next-marker" tabindex="-1"></div>';
        // copy inner HTML
        parent.insertBefore(placeholder, bar);
        parent.insertBefore(previousMarker, placeholder);
        this.r.setStyle(placeholder, 'height', `${bar.offsetHeight}px`);
        this.stickyEl.innerHTML = '';
        this.stickyEl.appendChild(bar);
        return {
            el: placeholder,
            marker: previousMarker
        };
    }
    /**
     * Restore contents from sticky to bar
     */
    restoreBarFromSticky() {
        const el = this.placeholder.el;
        const marker = this.placeholder.marker;
        const parent = el.parentElement;
        el.style.visibility = 'hidden';
        parent.insertBefore(this.el, el);
        if (el.parentElement) {
            el.parentElement.removeChild(el);
        }
        if (marker.parentElement) {
            marker.parentElement.removeChild(marker);
        }
        this.placeholder = null;
    }
    /**
     * Get a parent that scrolls
     */
    getScrollParent(el) {
        let parent = el.parentElement;
        while (parent) {
            if (parent.scrollHeight > parent.offsetHeight) {
                const style = this.window.getComputedStyle(parent);
                if (style.overflow === 'auto' ||
                    style.overflowY === 'auto' ||
                    style.overflow === 'scroll' ||
                    style.overflowY === 'scroll') {
                    return parent;
                }
            }
            parent = parent.parentElement;
        }
        return this.document;
    }
}
BentoStickyBarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyBarDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WindowRef }, { token: BentoTabService }, { token: BentoNotification }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Directive });
BentoStickyBarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoStickyBarDirective, selector: "[bentoStickyBar]", inputs: { side: "side", fullWidth: "fullWidth", showOnElementVisible: "showOnElementVisible" }, providers: [BentoTabService, BentoNotification], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyBarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoStickyBar]',
                    providers: [BentoTabService, BentoNotification]
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WindowRef }, { type: BentoTabService }, { type: BentoNotification }, { type: i2.Directionality }]; }, propDecorators: { side: [{
                type: Input
            }], fullWidth: [{
                type: Input
            }], showOnElementVisible: [{
                type: Input
            }] } });

class BentoStickyBarModule extends ConsumerDataValidator {
}
BentoStickyBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyBarModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoStickyBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyBarModule, declarations: [BentoStickyBarDirective], exports: [BentoStickyBarDirective] });
BentoStickyBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyBarModule, providers: [], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [BentoStickyBarDirective],
                    declarations: [BentoStickyBarDirective],
                    providers: []
                }]
        }] });

/* eslint-disable  @typescript-eslint/no-unused-expressions */
/**
 * A component to accomendate scroll panels location and sticks itself to the bottom to its parent scrolling panel
 */
class BentoStickyFooterComponent extends BentoStickyBarDirective {
    constructor(r, elRef, winRef, tabService, bn, dir) {
        super(r, elRef, winRef, tabService, bn, dir);
        /**
         * Override super class
         */
        this.side = 'bottom';
        r.addClass(elRef.nativeElement, 'bento-sticky-footer');
    }
}
BentoStickyFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyFooterComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: WindowRef }, { token: BentoTabService }, { token: BentoNotification }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoStickyFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoStickyFooterComponent, selector: "bento-sticky-footer", providers: [BentoTabService, BentoNotification], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".ng-bento bento-sticky-footer{display:flex;clear:both}.ng-bento bento-sticky-footer:after{content:\" \";display:block;height:0;clear:both}.ng-bento .bento-sticky-bar bento-sticky-footer{padding:10px 15px;border-top-width:1px;border-top-style:solid}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-sticky-footer', providers: [BentoTabService, BentoNotification], encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".ng-bento bento-sticky-footer{display:flex;clear:both}.ng-bento bento-sticky-footer:after{content:\" \";display:block;height:0;clear:both}.ng-bento .bento-sticky-bar bento-sticky-footer{padding:10px 15px;border-top-width:1px;border-top-style:solid}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: WindowRef }, { type: BentoTabService }, { type: BentoNotification }, { type: i2.Directionality }]; } });

class BentoStickyFooterModule extends ConsumerDataValidator {
}
BentoStickyFooterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyFooterModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoStickyFooterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyFooterModule, declarations: [BentoStickyFooterComponent], imports: [BentoStickyBarModule], exports: [BentoStickyFooterComponent] });
BentoStickyFooterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyFooterModule, providers: [], imports: [[BentoStickyBarModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoStickyFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [BentoStickyBarModule],
                    exports: [BentoStickyFooterComponent],
                    declarations: [BentoStickyFooterComponent],
                    providers: []
                }]
        }] });

/* eslint-disable  @angular-eslint/directive-selector */
/**
 * A component that accommodates to Tabset tabs to allow text truncation and tooltip when a label is
 * truncated.
 *
 * **Note** Pills are not supported
 */
class BentoTabsLabelComponent {
    /**
     * Constructor
     */
    constructor(elRef, r, bentoNotification, focusMonitor) {
        this.focusMonitor = focusMonitor;
        /**
         * Sets the maximum width of this label before truncation starts, or omit to allow tabs to take maximum
         * possible width in the tabset
         */
        this.maxWidth = 'none';
        this._noTextTruncation = true;
        this._el = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe(() => {
            this.checkTextTruncation();
        });
    }
    /**
     * Text that goes into the tab.  HTML is allowed
     */
    set label(str) {
        this._label = str;
        this.checkTextTruncation();
    }
    /**
     * Label of this component
     */
    get label() {
        return this._label;
    }
    /**
     * Implements view init
     */
    ngAfterViewInit() {
        this.checkTextTruncation();
        this.focusMonitor.monitor(this._el.parentElement).subscribe(origin => {
            if (origin === null) {
                this.truncatedTooltip && this.truncatedTooltip.close();
            }
            else if (origin === 'keyboard') {
                this.truncatedTooltip && this.truncatedTooltip.open();
            }
        });
    }
    /**
     * Implements OnDestroy
     */
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
        this.focusMonitor.stopMonitoring(this._el.parentElement);
    }
    /**
     * Check if the label text is geting truncated
     */
    checkTextTruncation() {
        // Use setTimeout to avoid change detection errors
        setTimeout(() => {
            this._noTextTruncation = this._el.offsetWidth >= this._el.scrollWidth;
        });
    }
}
BentoTabsLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsLabelComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BentoNotification }, { token: i3.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component });
BentoTabsLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTabsLabelComponent, selector: "bento-tabs-label", inputs: { label: "label", maxWidth: "maxWidth" }, host: { properties: { "style.maxWidth": "this.maxWidth" } }, providers: [BentoNotification], viewQueries: [{ propertyName: "truncatedTooltip", first: true, predicate: ["truncatedTooltip"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"_noTextTruncation; then withoutTooltip; else withTooltip\"></div>\n\n<ng-template #withoutTooltip>\n  <div [innerHTML]=\"label\"></div>\n</ng-template>\n\n<ng-template #withTooltip>\n  <div\n    #truncatedTooltip=\"ngbTooltip\"\n    [ngbTooltip]=\"label\"\n    container=\"body\"\n    [placement]=\"'top'\"\n    [innerHTML]=\"label\"\n  ></div>\n</ng-template>\n", directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tabs-label', providers: [BentoNotification], template: "<div *ngIf=\"_noTextTruncation; then withoutTooltip; else withTooltip\"></div>\n\n<ng-template #withoutTooltip>\n  <div [innerHTML]=\"label\"></div>\n</ng-template>\n\n<ng-template #withTooltip>\n  <div\n    #truncatedTooltip=\"ngbTooltip\"\n    [ngbTooltip]=\"label\"\n    container=\"body\"\n    [placement]=\"'top'\"\n    [innerHTML]=\"label\"\n  ></div>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BentoNotification }, { type: i3.FocusMonitor }]; }, propDecorators: { label: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.maxWidth']
            }], truncatedTooltip: [{
                type: ViewChild,
                args: ['truncatedTooltip']
            }] } });

/**
 * Wrap this component around the <code>ngbNav</code> directive to allow it to become responsive and scrollable.
 */
class BentoTabsScrollComponent {
    constructor(elRef, bentoNotification, renderer, changeDetector, dir, winRef) {
        this.renderer = renderer;
        this.changeDetector = changeDetector;
        this.dir = dir;
        /**
         * Disable Left Arrows
         */
        this.disableLeftArrows = true;
        /**
         * Disable Right Arrows
         */
        this.disableRightArrows = false;
        /**
         * Show Nav
         */
        this.showNav = false;
        // keep track of tab widths
        this.tabsWidthArray = [];
        // keep track of entire width of tabs
        this.totalTabsWidth = 0;
        /**
         * Current transform X position
         */
        this.currentPosition = 0;
        this.nativeElement = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this._checkElementWidthAndRender());
        this.isRtl = dir.value === 'rtl';
        this.window = winRef.nativeWindow;
        this.setDirectionLabels();
        dir.change.subscribe(() => {
            this.flipDirection();
            this.setDirectionLabels();
            this._checkElementWidthAndRender();
        });
    }
    /**
     * Called when this component is initialized
     */
    ngAfterViewInit() {
        this._checkElementWidthAndRender();
    }
    /**
     * Called when this component is destroyed
     */
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
        this.changeDetector.detach();
    }
    /**
     * Call this method to manually refresh and render
     * this component with the latest tab count and
     * width calculations.
     */
    refresh() {
        this._checkElementWidthAndRender();
    }
    onLeftMostClick() {
        this._scrollToTab(false, true);
    }
    onLeftClick() {
        this._scrollToTab(false);
    }
    onRightClick() {
        this._scrollToTab(true);
    }
    onRightMostClick() {
        this._scrollToTab(true, true);
    }
    flipDirection() {
        this.isRtl = this.dir.value === 'rtl';
    }
    setDirectionLabels() {
        if (this.isRtl) {
            this._scrollLeftLabel = 'BENTO_UI_TABSET_SCROLL_RIGHT';
            this._scrollRightLabel = 'BENTO_UI_TABSET_SCROLL_LEFT';
        }
        else {
            this._scrollLeftLabel = 'BENTO_UI_TABSET_SCROLL_LEFT';
            this._scrollRightLabel = 'BENTO_UI_TABSET_SCROLL_RIGHT';
        }
    }
    /**
     * Get transform position limit
     */
    getPositionLimit() {
        const pad = 28;
        return this.isRtl
            ? this.totalTabsWidth - this.nativeElement.offsetWidth + pad
            : this.nativeElement.offsetWidth - this.totalTabsWidth - pad;
    }
    /**
     * scroll to the nearest tab with index of currentTab
     */
    _scrollToTab(isToRight, isToEnd = false) {
        if (this.navTabsElement) {
            const positionLimit = this.getPositionLimit();
            const sign = this.isRtl ? 1 : -1;
            if (isToRight) {
                // Scroll to right
                if (!isToEnd) {
                    for (let tabIndex in this.tabsWidthArray) {
                        if (sign * this.currentPosition < this.tabsWidthArray[tabIndex]) {
                            this.currentPosition = sign * this.tabsWidthArray[tabIndex];
                            break;
                        }
                    }
                }
                if (Math.abs(this.currentPosition) >= Math.abs(positionLimit) || isToEnd) {
                    // Position is over limit
                    this.currentPosition = positionLimit;
                }
            }
            else if (isToEnd) {
                this.currentPosition = 0;
            }
            else {
                // Scroll to left
                for (let tabIndex = this.tabsWidthArray.length - 1; tabIndex > -1; tabIndex--) {
                    if (sign * this.currentPosition > this.tabsWidthArray[tabIndex]) {
                        this.currentPosition = sign * this.tabsWidthArray[tabIndex];
                        break;
                    }
                }
            }
            this.renderer.setStyle(this.navTabsElement, 'transform', `translateX(${this.currentPosition}px)`);
            this.updateArrows(positionLimit);
        }
    }
    /**
     * Disable and enable arrow
     */
    updateArrows(positionLimit) {
        // disable / enable arrows
        if (this.currentPosition === 0) {
            this.disableLeftArrows = true;
            this.disableRightArrows = false;
        }
        else if (positionLimit === this.currentPosition) {
            this.disableLeftArrows = false;
            this.disableRightArrows = true;
        }
        else {
            this.disableLeftArrows = false;
            this.disableRightArrows = false;
        }
    }
    /**
     * Calculate and change layout responsively
     */
    _checkElementWidthAndRender() {
        if (!this.element) {
            this.element = this.nativeElement;
        }
        if (!this.navTabsElement) {
            this.navTabsElement = this.element.querySelector('.nav.nav-tabs');
        }
        const width = this.element.offsetWidth;
        const navTabsChildren = this.navTabsElement.children;
        this.totalTabsWidth = 0;
        for (let i = 0; i < navTabsChildren.length; i++) {
            this.tabsWidthArray[i] = this.totalTabsWidth;
            this.totalTabsWidth += this._getTotalWidth(navTabsChildren[i]) - 1;
        }
        const positionLimit = this.getPositionLimit();
        if (Math.abs(this.currentPosition) >= Math.abs(positionLimit)) {
            // Position is over limit
            this.currentPosition = positionLimit;
        }
        else if (this.isRtl === this.currentPosition < 0) {
            // If the current position is positive in LTR mode
            // OR
            // the current position is negative in RTL mode
            this.currentPosition = 0;
        }
        this.renderer.setStyle(this.navTabsElement, 'transform', `translateX(${this.currentPosition}px)`);
        // check if necessary to show navigation
        if (width > this.totalTabsWidth) {
            this.showNav = false;
        }
        else {
            this.showNav = true;
            this.updateArrows(positionLimit);
            setTimeout(() => {
                const navButton = this.nativeElement.getElementsByClassName('bento-tabset-nav-button-container')[0];
                if (width < 400 && !!navButton) {
                    navButton.classList.add('tabset-scroll-nav-buttons');
                }
                else if (!!navButton) {
                    navButton.classList.remove('tabset-scroll-nav-buttons');
                }
            });
        }
        this.changeDetector.detectChanges();
    }
    /**
     * Get total width of an element, including
     * it's padding and margins
     */
    _getTotalWidth(el) {
        if (!el) {
            return;
        }
        const style = this.window.getComputedStyle(el);
        return (Math.ceil(el.getBoundingClientRect().width) +
            parseFloat(style.paddingLeft) +
            parseFloat(style.paddingRight) +
            parseFloat(style.marginLeft !== 'auto' ? style.marginLeft : 0) +
            parseFloat(style.marginRight !== 'auto' ? style.marginRight : 0));
    }
}
BentoTabsScrollComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsScrollComponent, deps: [{ token: i0.ElementRef }, { token: BentoNotification }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i2.Directionality }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Component });
BentoTabsScrollComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTabsScrollComponent, selector: "bento-tabset-scroll", providers: [BentoNotification], ngImport: i0, template: "<div *ngIf=\"showNav\" class=\"bento-tabset-nav-button-container ng-scope\">\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TABSET_SCROLL_LEFTMOST' | bentoTranslate\"\n    [disabled]=\"disableLeftArrows\"\n    (click)=\"onLeftMostClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button left-most\"\n  >\n    <i class=\"bento-icon-chevron-first-left\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"_scrollLeftLabel | bentoTranslate\"\n    [disabled]=\"disableLeftArrows\"\n    (click)=\"onLeftClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button left\"\n  >\n    <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"_scrollRightLabel | bentoTranslate\"\n    [disabled]=\"disableRightArrows\"\n    (click)=\"onRightClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button right\"\n  >\n    <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TABSET_SCROLL_RIGHTMOST' | bentoTranslate\"\n    [disabled]=\"disableRightArrows\"\n    (click)=\"onRightMostClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button right-most\"\n  >\n    <i class=\"bento-icon-chevron-last-right\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n<ng-content></ng-content>\n", directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsScrollComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tabset-scroll', providers: [BentoNotification], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"showNav\" class=\"bento-tabset-nav-button-container ng-scope\">\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TABSET_SCROLL_LEFTMOST' | bentoTranslate\"\n    [disabled]=\"disableLeftArrows\"\n    (click)=\"onLeftMostClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button left-most\"\n  >\n    <i class=\"bento-icon-chevron-first-left\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"_scrollLeftLabel | bentoTranslate\"\n    [disabled]=\"disableLeftArrows\"\n    (click)=\"onLeftClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button left\"\n  >\n    <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"_scrollRightLabel | bentoTranslate\"\n    [disabled]=\"disableRightArrows\"\n    (click)=\"onRightClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button right\"\n  >\n    <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TABSET_SCROLL_RIGHTMOST' | bentoTranslate\"\n    [disabled]=\"disableRightArrows\"\n    (click)=\"onRightMostClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button right-most\"\n  >\n    <i class=\"bento-icon-chevron-last-right\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoNotification }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i2.Directionality }, { type: WindowRef }]; } });

class BentoTabsModule extends ConsumerDataValidator {
}
BentoTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsModule, declarations: [BentoTabsScrollComponent, BentoTabsLabelComponent], imports: [CommonModule, NgbTooltipModule, BentoTranslateModule, BentoNgbTooltipSupportModule], exports: [BentoTabsScrollComponent, BentoTabsLabelComponent] });
BentoTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsModule, imports: [[CommonModule, NgbTooltipModule, BentoTranslateModule, BentoNgbTooltipSupportModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgbTooltipModule, BentoTranslateModule, BentoNgbTooltipSupportModule],
                    declarations: [BentoTabsScrollComponent, BentoTabsLabelComponent],
                    exports: [BentoTabsScrollComponent, BentoTabsLabelComponent]
                }]
        }] });

/**
 * An event class that is associated with Bento Tags Input events
 */
class BentoTagsInputEvent {
    /**
     * Event object constructor
     */
    constructor(tag, cancel, errors) {
        this._isCancellable = false;
        this._errors = errors;
        this._tag = tag;
        if (cancel) {
            this._cancel = cancel;
            this._isCancellable = true;
        }
        else {
            // Default cancel dummy
            this._cancel = () => { };
        }
    }
    /**
     * (Read-only) Check if this event is cancellabled or not
     */
    get isCancellable() {
        return this._isCancellable;
    }
    /**
     * (Read-only) Check if this event is has errors or not
     */
    get hasErrors() {
        return !!this._errors;
    }
    /**
     * (Read-only) An tag object that is associated with this event
     */
    get tag() {
        return this._tag;
    }
    /**
     * Method to cancel the current event *ONLY* if `event.isCancellable` is `true`
     */
    get cancel() {
        return this._cancel;
    }
    /**
     * (Read-only) Errors that are associated with this event
     */
    get errors() {
        return this._errors;
    }
}

/**
 * A utility class to offer helper methods for tags input classes
 */
class BentoTagsInputUtil {
    /**
     *  Help method to execute a `method` based on the existence and reply of the `callback` with a tag
     */
    static exeTagMethodWithEventEmitter(componentRef, eventEmitter, method, tag, data) {
        let hasCancel = false;
        let cancelObservable;
        // There is a callback
        const e = new BentoTagsInputEvent(tag, (o) => {
            if (o && o.subscribe) {
                cancelObservable = o;
            }
            else {
                hasCancel = true;
            }
        });
        // Since this a synchronous emitter we can move on after it without using timeouts
        eventEmitter.emit(e);
        if (cancelObservable) {
            // This is a async reply
            let subscription = cancelObservable.subscribe(v => {
                if (v) {
                    // Delayed `true`
                    method.call(componentRef, tag, data);
                }
                // Don't forget to unsubscribe...
                subscription.unsubscribe();
                subscription = null;
            });
        }
        else if (!hasCancel) {
            // We have an instant reply
            method.call(componentRef, tag, data);
        }
    }
}

const BENTO_TAGS_INPUT_PILL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoTagsInputPillComponent),
    multi: true
};
/* eslint-disable  @angular-eslint/no-host-metadata-property */
/**
 * Tags Input Pill Component
 */
class BentoTagsInputPillComponent {
    /**
     * Main component constructor
     */
    constructor(elRef, r, bentoNotification, translate, changeDetector, sanitizer, windowRef) {
        this.elRef = elRef;
        this.r = r;
        this.bentoNotification = bentoNotification;
        this.translate = translate;
        this.changeDetector = changeDetector;
        this.sanitizer = sanitizer;
        /**
         * EventEmitter for typeahead selected item
         */
        this.typeaheadSelectItem = new EventEmitter();
        /**
         * Main object property name for label rendering
         */
        this.tagPropertyName = 'name';
        /**
         * Flag to disable this tag pill removal
         */
        this.disableRemove = false;
        /**
         * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         * A flag indicating if model values should be restricted to the ones selected from the popup only.
         */
        this.typeheadEditable = true;
        /**
         * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         * A flag indicating if the first match should automatically be focused as you type.
         */
        this.typeheadFocusFirst = false;
        /**
         * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         * Show hint when an option in the result list matches.
         */
        this.typeaheadShowHint = false;
        /**
         * API to support readonly
         */
        this.readonly = false;
        /**
         * Flag to show editing mode
         */
        this._isEditing = false;
        /**
         * Remove notification
         */
        this.remove = new EventEmitter();
        /**
         * Flag to validation of the input
         */
        this._invalid = false;
        /**
         * This is used to bypass the component ENTER key stroke when one of the
         * typeahead item is selected
         */
        this._isTypeaheadAction = false;
        /**
         * Flag the determine wheather need tooltip or not
         */
        this._noTextTruncation = true;
        this.resizeSubscription = Subscription.EMPTY;
        const el = this.elRef.nativeElement;
        this.document = windowRef.nativeDocument;
        this.r.addClass(el, 'ready');
    }
    /**
     * Implements AfterViewInit
     */
    ngAfterViewInit() {
        this.checkTextOverflow();
        this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe(() => {
            // check text overflow on all kinds of layout resizing
            this.checkTextOverflow();
            this.changeDetector.markForCheck();
        });
    }
    /**
     * Focus event handler
     */
    onHostElementFocusAndMouseOver() {
        this.checkTextOverflow();
        this.truncatedTooltip && this.truncatedTooltip.open();
    }
    /**
     * Focusout event handler
     */
    onFocusout() {
        setTimeout(() => {
            if (!this.elRef.nativeElement.contains(this.document.activeElement)) {
                this._onTouchedCallback();
                this.truncatedTooltip && this.truncatedTooltip.close();
            }
        });
    }
    /**
     * Implements ControlValueAccessor
     */
    registerOnChange(fn) {
        this._onChangeCallback = fn;
    }
    /**
     * From ControlValueAccessor interface
     */
    registerOnTouched(fn) {
        this._onTouchedCallback = () => {
            fn();
            this.changeDetector.markForCheck();
        };
    }
    /**
     * NgModel setter
     */
    writeValue(v) {
        if (v) {
            this._data = v;
        }
        else {
            const newValue = {};
            newValue[this.tagPropertyName] = '';
            this._data = newValue;
        }
        this.formattedValue = null;
        this.changeDetector.markForCheck();
    }
    /**
     * Implements OnDestroy lifehook
     */
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
        this.changeDetector.detach();
    }
    /**
     * Main keydown event listener
     */
    onKeydown(e) {
        if (this.disabled || this.readonly) {
            return;
        }
        const button = e.target;
        const isButton = button.classList.contains('bento-tags-input-pill-close-icon') ||
            button.classList.contains('bento-tags-input-pill-edit-icon');
        if (isButton) {
            return;
        }
        switch (e.keyCode) {
            case Keyboard.DELETE:
            case Keyboard.BACKSPACE:
                // Use keyboard DELETE and BACKSPACE to remove the current pill
                // This can only executed when the pill is not in editing mode
                if (!this._isEditing && !this.disableRemove) {
                    this.remove.emit({
                        el: this.elRef.nativeElement,
                        tag: this._data,
                        // Optional
                        keyCode: e.keyCode
                    });
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
            case Keyboard.ENTER:
                if (this._isEditing && !this._isTypeaheadAction) {
                    // Fire keyboard enter
                    this._onKeyboardEnter();
                }
                else if (this.editable) {
                    // Enter edit mode
                    this._onEditClick(e);
                }
                // Prevent form submission
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.ESC:
                if (this._isEditing) {
                    this._toggleEditingMode();
                    this.tagEditCancel.emit(new BentoTagsInputEvent(this._data));
                    this.typeaheadPill && this.typeaheadPill.dismissPopup();
                    // reset invalid flag
                    this._invalid = false;
                    // during the edit process, if there are some error residuals, clear it
                    this.validations.isValidTag(this._data[this.tagPropertyName], this._data);
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.TAB:
                if (this._isEditing) {
                    this._commitEdit(
                    // Success
                    () => {
                        // focus on the next sibling
                        this.elRef.nativeElement.nextElementSibling.focus();
                        // Check if there text overflow
                        this.checkTextOverflow();
                    }, 
                    // Fail
                    () => {
                        this._inputEl.setSelectionRange(0, this._inputText.length);
                    });
                    // Stop Tab function first
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
        } // switch (e.keyCode)
    } // @HostListener()
    /**
     * Callback when ENTER key is pressed
     */
    _onKeyboardEnter() {
        if (!this._inputText || this._inputText.length === 0) {
            // Bug Fix: before removing the pill, reset the editing flag. Without
            // reset, future edit is disabled.
            this._isEditing = false;
            // Fire remove event when the input tries to commit an empty string
            this.remove.emit({
                el: this.elRef.nativeElement,
                tag: this._data,
                // Optional
                // Use Delete button as an empty string commit
                keyCode: Keyboard.DELETE
            });
        }
        else {
            // Commit current change
            this._commitEdit(() => {
                setTimeout(() => {
                    this.elRef.nativeElement.focus();
                });
                // Check if there text overflow
                this.checkTextOverflow();
            });
        }
    }
    /**
     * Fired when keypress event occurs on Edit icon
     * @param e - Key event
     */
    _onKeydownEdit(e) {
        if (e.keyCode === Keyboard.ENTER) {
            // Bug Fix: before removing the pill, reset the editing flag. Without
            // reset, future edit is disabled.
            this._isEditing = false;
            this._onEditClick(e);
            e.stopPropagation();
            e.preventDefault();
        }
    }
    /**
     * Fired when keypress event occurs on Close icon
     * @param e - Key event
     */
    _onKeydownClose(e) {
        if (e.keyCode === Keyboard.ENTER) {
            this._onCloseClick();
            e.stopPropagation();
            e.preventDefault();
        }
    }
    /**
     * Close button click
     */
    _onCloseClick() {
        if (this._isEditing && this.disableRemove) {
            return;
        }
        this.remove.emit({
            el: this.elRef.nativeElement,
            tag: this._data
        });
    }
    /**
     * Edit button click
     */
    _onEditClick(e) {
        if (!this._isEditing) {
            this._toggleEditingMode();
        }
        else {
            this._commitEdit(() => {
                this.elRef.nativeElement.focus();
                // Check if there text overflow
                this.checkTextOverflow();
            });
        }
    }
    /**
     * Apply changes to the main object
     */
    _commitEdit(success, fail) {
        this.formattedValue = this.validations.getFormattedString(this._inputText.trim());
        if (this.tagFormatter) {
            // Call app defined tag formatter for one more layer for text formatting
            this.formattedValue = this.tagFormatter(this.formattedValue);
        }
        if (this.formattedValue === this._data[this.tagPropertyName]) {
            this._toggleEditingMode();
            success.call(this);
        }
        else if (this.validations.isValidTag(String(this.formattedValue), this._data)) {
            this._invalid = false;
            // validation passed
            // now as user to proceed
            BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagEditStart, tagString => {
                // only update tag when the input is valid
                this._data[this.tagPropertyName] = tagString;
                this._toggleEditingMode();
                this._onChangeCallback(this._data);
                success.call(this);
            }, this.formattedValue);
        }
        else {
            // Input is not valid
            this._invalid = true;
            // calling this, will set model onChange, which in turn will call the
            // validator function
            this._onChangeCallback(this._data);
            setTimeout(() => {
                this.r.setProperty(this.pillEmptyInfo.nativeElement, 'innerHTML', this.sanitizer.sanitize(SecurityContext.HTML, this.translate.instantTranslate('BENTO_UI_TAGS_INPUT_EMPTY_PILL')));
            });
            // Re-assign focus to the input field
            this._inputEl.focus();
            if (fail) {
                fail.call(this);
            }
        }
    }
    /**
     * Input field change callback
     */
    _onInputChange(v) {
        this._inputText = v;
        this._resizeInput();
    }
    /**
     * Toggle between editing mode
     */
    _toggleEditingMode() {
        if (!this._isEditing) {
            if (!this.validations.canEdit()) {
                // Indicates that this pill cannot be edited
                return;
            }
            const labelEl = this.elRef.nativeElement.querySelector('.bento-tags-input-pill-label');
            // Set editing mode to `true`
            this._isEditing = true;
            this._inputText = this._data[this.tagPropertyName];
            if (!this._inputEl) {
                this._inputEl = this.elRef.nativeElement.querySelector('input');
            }
            this._inputEl.style.width = labelEl.offsetWidth + 2 + 'px';
            setTimeout(() => {
                if (!this._inputBlurCancel) {
                    // Add input blur subscription
                    this._inputBlurCancel = this.r.listen('window', 'mousedown', e => {
                        if (this.elRef.nativeElement.contains(e.target)) {
                            // blurred within the pill
                            setTimeout(() => {
                                this._inputEl.focus();
                            });
                        }
                        else {
                            this._commitEdit(
                            // Success
                            () => {
                                // Typeahead action is finished
                                this._isTypeaheadAction = false;
                                // Check if there text overflow
                                this.checkTextOverflow();
                            }, 
                            // Fail
                            () => {
                                setTimeout(() => {
                                    // There is an error with the current input
                                    // We highlight it and do it over
                                    this._inputEl.focus();
                                    this._inputEl.setSelectionRange(0, this._inputText.length);
                                    // Typeahead action is finished
                                    this._isTypeaheadAction = false;
                                });
                            });
                        }
                    });
                }
                // focus input
                this._inputEl.focus();
                this._inputEl.setSelectionRange(0, this._inputText.length);
            });
        }
        else {
            // Remove input blur subscription
            if (this._inputBlurCancel) {
                this._inputBlurCancel();
                this._inputBlurCancel = null;
            }
            // Reset HTMLElement reference for sizing
            this._inputSizeEl = null;
            this._isEditing = false;
        }
    }
    /**
     * Callback when a typeahead item is selected
     */
    _onTypeaheadSelectItem(e) {
        this.typeaheadSelectItem.emit(e);
        // Flag globally to let the pill know that this is a typeahead action
        this._isTypeaheadAction = true;
        // Need to update the inputText before simulating keyboard enter
        this._inputText = this.typeaheadInputFormatter ? this.typeaheadInputFormatter(e.item) : e.item;
        // Fire keyboard enter
        this._onKeyboardEnter();
    }
    /**
     * Resize the input width according to its text inside
     */
    _resizeInput() {
        if (!this._inputSizeEl) {
            // Since we are using *ngIf in the template
            // related html elements are created everytime
            // so the references are removed everytime when the pill is done with eidting
            this._inputSizeEl = this.elRef.nativeElement.querySelector('.bento-tags-input-pill-size-ref');
        }
        this._inputSizeEl.innerText = this._inputText;
        this._inputEl.style.width = this._inputSizeEl.offsetWidth + 3 + 'px';
    }
    /**
     * Format str based on the current tag format rules
     */
    _formatTag(str) {
        if (!this.formattedValue) {
            this.formattedValue = this.tagFormatter ? this.tagFormatter(str) : str;
        }
        return this.formattedValue;
    }
    /**
     * Check to see if there is text overflow
     */
    checkTextOverflow() {
        setTimeout(() => {
            const label = this.elRef.nativeElement.querySelector('.bento-tags-input-pill-label');
            this._noTextTruncation = label.scrollWidth <= label.offsetWidth;
        });
    }
    /**
     * Catch double click events to start editing when in editor is enabled
     */
    _onDoubleClick(e) {
        if (this.editable && !this.disabled && !this.readonly) {
            this._onEditClick(e);
        }
    }
}
BentoTagsInputPillComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputPillComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BentoNotification }, { token: BentoTranslate }, { token: i0.ChangeDetectorRef }, { token: i1$2.DomSanitizer }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Component });
BentoTagsInputPillComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTagsInputPillComponent, selector: "bento-tags-input-pill", inputs: { tagEditStart: "tagEditStart", tagEditCancel: "tagEditCancel", typeaheadSelectItem: "typeaheadSelectItem", tagPropertyName: "tagPropertyName", editable: "editable", validations: "validations", disableRemove: "disableRemove", tagFormatter: "tagFormatter", typeahead: "typeahead", typeheadEditable: "typeheadEditable", typeheadFocusFirst: "typeheadFocusFirst", typeaheadInputFormatter: "typeaheadInputFormatter", typeaheadResultFormatter: "typeaheadResultFormatter", typeaheadShowHint: "typeaheadShowHint", readonly: "readonly" }, outputs: { remove: "remove" }, host: { listeners: { "focus": "onHostElementFocusAndMouseOver()", "focusout": "onFocusout()", "keydown": "onKeydown($event)", "dblclick": "_onDoubleClick($event)" }, properties: { "class.editable": "editable && !disabled && !readonly", "class.disable-remove": "disableRemove || disabled || readonly", "class.readonly": "this.readonly", "class.edit": "this._isEditing", "class.invalid": "this._invalid" } }, providers: [BENTO_TAGS_INPUT_PILL_VALUE_ACCESSOR, BentoNotification], viewQueries: [{ propertyName: "truncatedTooltip", first: true, predicate: ["truncatedTooltip"], descendants: true }, { propertyName: "typeaheadPill", first: true, predicate: ["typeaheadPill"], descendants: true }, { propertyName: "pillEmptyInfo", first: true, predicate: ["pillEmptyInfo"], descendants: true, static: true }], ngImport: i0, template: "<div *ngIf=\"editable && !typeahead\" [hidden]=\"!_isEditing\">\n  <input\n    class=\"bento-tags-input-field\"\n    [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT_ELEMENT' | bentoTranslate\"\n    [hidden]=\"!_isEditing\"\n    [class.invalid]=\"_invalid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputChange($event)\"\n  />\n</div>\n\n<div *ngIf=\"editable && typeahead\" [hidden]=\"!_isEditing\">\n  <input\n    class=\"bento-tags-input-field\"\n    [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT_ELEMENT' | bentoTranslate\"\n    [class.invalid]=\"_invalid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputChange($event)\"\n    [ngbTypeahead]=\"typeahead\"\n    [editable]=\"typeheadEditable\"\n    [focusFirst]=\"typeheadFocusFirst\"\n    [inputFormatter]=\"typeaheadInputFormatter\"\n    [resultFormatter]=\"typeaheadResultFormatter\"\n    [showHint]=\"typeaheadShowHint\"\n    (selectItem)=\"_onTypeaheadSelectItem($event)\"\n    [container]=\"'body'\"\n    #typeaheadPill=\"ngbTypeahead\"\n  />\n</div>\n\n<span #pillEmptyInfo class=\"sr-only\" aria-live=\"polite\">\n  <!-- content will be updated with Javascript -->\n</span>\n\n<div [hidden]=\"_isEditing\" *ngIf=\"_noTextTruncation; else labelWithTooltip\" class=\"bento-tags-input-pill-label\">\n  <span class=\"d-inline-block\" (mouseover)=\"onHostElementFocusAndMouseOver()\">{{ _formatTag(_data[tagPropertyName]) }}</span>\n</div>\n\n<ng-template #labelWithTooltip>\n  <div\n    [hidden]=\"_isEditing\"\n    [ngbTooltip]=\"_formatTag(_data[tagPropertyName])\"\n    #truncatedTooltip=\"ngbTooltip\"\n    placement=\"top\"\n    container=\"body\"\n    class=\"bento-tags-input-pill-label\"\n  >\n    <span class=\"d-inline-block\">{{ _formatTag(_data[tagPropertyName]) }}</span>\n  </div>\n</ng-template>\n\n<button\n  *ngIf=\"editable && !disabled && !readonly\"\n  class=\"bento-tags-input-pill-edit-icon\"\n  (mousedown)=\"_onEditClick($event)\"\n  (keydown)=\"_onKeydownEdit($event)\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT' | bentoTranslate | bentoStringReplace: '_LABEL_':_data[tagPropertyName]\"\n>\n  <i class=\"bento-icon-edit\" aria-hidden=\"true\"></i>\n</button>\n<button\n  *ngIf=\"!disableRemove && !disabled && !readonly\"\n  class=\"bento-tags-input-pill-close-icon\"\n  (click)=\"_onCloseClick()\"\n  (keydown)=\"_onKeydownClose($event)\"\n  type=\"button\"\n  [attr.aria-label]=\"\n    'BENTO_UI_TAGS_INPUT_CLOSE' | bentoTranslate | bentoStringReplace: '_LABEL_':_data[tagPropertyName]\n  \"\n>\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div *ngIf=\"_isEditing\" class=\"bento-tags-input-pill-size-ref\"></div>\n", directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$1.NgbTypeahead, selector: "input[ngbTypeahead]", inputs: ["autocomplete", "container", "editable", "focusFirst", "inputFormatter", "ngbTypeahead", "resultFormatter", "resultTemplate", "showHint", "placement", "popupClass"], outputs: ["selectItem"], exportAs: ["ngbTypeahead"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputPillComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tags-input-pill', host: {
                        '[class.editable]': 'editable && !disabled && !readonly',
                        '[class.disable-remove]': 'disableRemove || disabled || readonly'
                    }, providers: [BENTO_TAGS_INPUT_PILL_VALUE_ACCESSOR, BentoNotification], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"editable && !typeahead\" [hidden]=\"!_isEditing\">\n  <input\n    class=\"bento-tags-input-field\"\n    [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT_ELEMENT' | bentoTranslate\"\n    [hidden]=\"!_isEditing\"\n    [class.invalid]=\"_invalid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputChange($event)\"\n  />\n</div>\n\n<div *ngIf=\"editable && typeahead\" [hidden]=\"!_isEditing\">\n  <input\n    class=\"bento-tags-input-field\"\n    [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT_ELEMENT' | bentoTranslate\"\n    [class.invalid]=\"_invalid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputChange($event)\"\n    [ngbTypeahead]=\"typeahead\"\n    [editable]=\"typeheadEditable\"\n    [focusFirst]=\"typeheadFocusFirst\"\n    [inputFormatter]=\"typeaheadInputFormatter\"\n    [resultFormatter]=\"typeaheadResultFormatter\"\n    [showHint]=\"typeaheadShowHint\"\n    (selectItem)=\"_onTypeaheadSelectItem($event)\"\n    [container]=\"'body'\"\n    #typeaheadPill=\"ngbTypeahead\"\n  />\n</div>\n\n<span #pillEmptyInfo class=\"sr-only\" aria-live=\"polite\">\n  <!-- content will be updated with Javascript -->\n</span>\n\n<div [hidden]=\"_isEditing\" *ngIf=\"_noTextTruncation; else labelWithTooltip\" class=\"bento-tags-input-pill-label\">\n  <span class=\"d-inline-block\" (mouseover)=\"onHostElementFocusAndMouseOver()\">{{ _formatTag(_data[tagPropertyName]) }}</span>\n</div>\n\n<ng-template #labelWithTooltip>\n  <div\n    [hidden]=\"_isEditing\"\n    [ngbTooltip]=\"_formatTag(_data[tagPropertyName])\"\n    #truncatedTooltip=\"ngbTooltip\"\n    placement=\"top\"\n    container=\"body\"\n    class=\"bento-tags-input-pill-label\"\n  >\n    <span class=\"d-inline-block\">{{ _formatTag(_data[tagPropertyName]) }}</span>\n  </div>\n</ng-template>\n\n<button\n  *ngIf=\"editable && !disabled && !readonly\"\n  class=\"bento-tags-input-pill-edit-icon\"\n  (mousedown)=\"_onEditClick($event)\"\n  (keydown)=\"_onKeydownEdit($event)\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT' | bentoTranslate | bentoStringReplace: '_LABEL_':_data[tagPropertyName]\"\n>\n  <i class=\"bento-icon-edit\" aria-hidden=\"true\"></i>\n</button>\n<button\n  *ngIf=\"!disableRemove && !disabled && !readonly\"\n  class=\"bento-tags-input-pill-close-icon\"\n  (click)=\"_onCloseClick()\"\n  (keydown)=\"_onKeydownClose($event)\"\n  type=\"button\"\n  [attr.aria-label]=\"\n    'BENTO_UI_TAGS_INPUT_CLOSE' | bentoTranslate | bentoStringReplace: '_LABEL_':_data[tagPropertyName]\n  \"\n>\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div *ngIf=\"_isEditing\" class=\"bento-tags-input-pill-size-ref\"></div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BentoNotification }, { type: BentoTranslate }, { type: i0.ChangeDetectorRef }, { type: i1$2.DomSanitizer }, { type: WindowRef }]; }, propDecorators: { tagEditStart: [{
                type: Input
            }], tagEditCancel: [{
                type: Input
            }], typeaheadSelectItem: [{
                type: Input
            }], tagPropertyName: [{
                type: Input
            }], editable: [{
                type: Input
            }], validations: [{
                type: Input
            }], disableRemove: [{
                type: Input
            }], tagFormatter: [{
                type: Input
            }], typeahead: [{
                type: Input
            }], typeheadEditable: [{
                type: Input
            }], typeheadFocusFirst: [{
                type: Input
            }], typeaheadInputFormatter: [{
                type: Input
            }], typeaheadResultFormatter: [{
                type: Input
            }], typeaheadShowHint: [{
                type: Input
            }], readonly: [{
                type: HostBinding,
                args: ['class.readonly']
            }, {
                type: Input
            }], _isEditing: [{
                type: HostBinding,
                args: ['class.edit']
            }], remove: [{
                type: Output
            }], _invalid: [{
                type: HostBinding,
                args: ['class.invalid']
            }], truncatedTooltip: [{
                type: ViewChild,
                args: ['truncatedTooltip']
            }], typeaheadPill: [{
                type: ViewChild,
                args: ['typeaheadPill']
            }], pillEmptyInfo: [{
                type: ViewChild,
                args: ['pillEmptyInfo', { static: true }]
            }], onHostElementFocusAndMouseOver: [{
                type: HostListener,
                args: ['focus']
            }], onFocusout: [{
                type: HostListener,
                args: ['focusout']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], _onDoubleClick: [{
                type: HostListener,
                args: ['dblclick', ['$event']]
            }] } });

/**
 * Class to contain Tags Input errors
 */
class BentoTagsInputErrors {
    constructor() {
        /**
         * Stack to keep strack on the current errors
         */
        this._errorStack = [];
        /**
         * Error emitter to notify when there is an error
         */
        this._errorEmitter = new EventEmitter();
    }
    /**
     * Check if has error
     */
    hasError() {
        return this._errorStack.length > 0;
    }
    /**
     * Add an error to the error stack
     */
    addError(error, tag) {
        if (this._errorStack.indexOf(error) < 0) {
            this._errorStack.push(error);
            this._errorEmitter.emit({
                errors: this._errorStack.slice(),
                tag
            });
        }
    }
    /**
     * Remove an error from the error stack
     */
    removeError(error, tag) {
        let index;
        if ((index = this._errorStack.indexOf(error)) > -1) {
            this._errorStack.splice(index, 1);
            this._errorEmitter.emit({
                errors: this._errorStack.slice(),
                tag
            });
        }
    }
    /**
     * Reset errors
     */
    reset() {
        if (this._errorStack.length === 0) {
            return;
        }
        this._errorStack = [];
        this._errorEmitter.emit({
            errors: []
        });
    }
    /**
     * Get error notification
     */
    get errorNotification() {
        return this._errorEmitter;
    }
}
BentoTagsInputErrors.DUPLICATE = 'Duplicated string';
BentoTagsInputErrors.MINIMUM_LENGTH = 'Minimum length';

const OPERATORS = '-+=/*%[]()!~&|<>';
const BENTO_TAGS_INPUT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoTagsInputComponent),
    multi: true
};
// https://medium.com/@tarik.nzl/angular-2-custom-form-control-with-validation-json-input-2b4cf9bc2d73
const BENTO_TAGS_INPUT_VALUE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => BentoTagsInputComponent),
    multi: true
};
/**
 * A input field to generate an arbitrary number of pill-like or label-like Tags.
 * All Tags can be pre-added and deleted - both via keyboard (Delete or Backspace) and with mouse or touch.
 * `[rangeLength][formControlName]`, `[rangeLength][formControl]`, `[rangeLength][ngModel]`
 */
class BentoTagsInputComponent {
    /**
     * Component constructor
     */
    constructor(_elementRef, r, windowRef, dir, uidGen, changeDetector, ngZone) {
        this._elementRef = _elementRef;
        this.r = r;
        this.dir = dir;
        this.uidGen = uidGen;
        this.changeDetector = changeDetector;
        this.ngZone = ngZone;
        /**
         * flag to add a tag with a comma
         */
        this.addOnComma = true;
        /**
         * flag to add a tag with enter key
         */
        this.addOnEnter = true;
        /**
         * flag to add a tag when space bar is pressed
         */
        this.addOnSpace = false;
        /**
         * Flag to make string comparison case insensitive
         */
        this.caseInsensitive = false;
        /**
         * flag to allow operator characters to be entered as a tag (eg. `=`)
         */
        this.useOperators = false;
        /**
         * Operators that are allowed in this string
         */
        this.allowedOperators = OPERATORS;
        /**
         * flag to disable keyboard input for text entries
         */
        this.disableInput = false;
        /**
         * flag to disable tag removals
         */
        this.disableTagRemove = false;
        /**
         * indicates the minimum characters are needed for a tag
         */
        this.minTagLength = 1;
        /**
         * A character with which to replace spaces in the label
         */
        this.replaceSpacesWith = ' ';
        /**
         * Property name to display each tag
         */
        this.tagPropertyName = 'name';
        /**
         * Set tag default variable type when created
         */
        this.tagDefaultType = 'auto';
        /**
         * API to support readonly state
         */
        this.readonly = false;
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * A flag indicating if the first match should automatically be focused as you type.
         */
        this.typeheadFocusFirst = false;
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * A flag indicating if model values should be restricted to the ones selected from the popup only.
         */
        this.typeheadEditable = true;
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * Show hint when an option in the result list matches.
         */
        this.typeaheadShowHint = false;
        /**
         * Callback when tag is about to be added. See `BentoTagsInputEvent` for payload details
         */
        this.tagAddStart = new EventEmitter();
        /**
         * Callback when a tag is added. See `BentoTagsInputEvent` for payload details
         */
        this.tagAdded = new EventEmitter();
        /**
         * Callback when a tag is being edited. See `BentoTagsInputEvent` for payload details
         */
        this.tagEditStart = new EventEmitter();
        /**
         * Callback when a tag is edited. See `BentoTagsInputEvent` for payload details
         */
        this.tagEdited = new EventEmitter();
        /**
         * Callback when the editing of a tag is cancelled. See `BentoTagsInputEvent` for payload details
         */
        this.tagEditCancel = new EventEmitter();
        /**
         * Callback when a tag is about to be removed. See `BentoTagsInputEvent` for payload details
         */
        this.tagRemoveStart = new EventEmitter();
        /**
         * Callback when a tag is removed. See `BentoTagsInputEvent` for payload details
         */
        this.tagRemoved = new EventEmitter();
        /**
         * Callback when there is an invalid input. See `BentoTagsInputEvent` for payload details
         */
        this.tagInvalidInput = new EventEmitter();
        /**
         * Callback when an item is selected in [NgbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead).
         * See `NgbTypeaheadSelectItemEvent` for payload details from
         * [NgbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         */
        this.typeaheadSelectItem = new EventEmitter();
        /**
         * Main element disabled state flag
         */
        this._disabled = false;
        /**
         * Array to keep errors
         */
        this._errors = new BentoTagsInputErrors();
        /**
         * Flag to determin if the input is valid
         */
        this._isInputValid = true;
        /**
         * This is used to bypass the component ENTER key stroke when one of the
         * typeahead item is selected
         */
        this._isTypeaheadAction = false;
        /**
         * Placeholder value
         */
        this._placeholder = '';
        this.el = this._elementRef.nativeElement;
        this.document = windowRef.nativeDocument;
        this.bodyEl = this.document.body;
        this.isRtl = this.dir.value === 'rtl';
        dir.change.subscribe(() => {
            this.isRtl = this.dir.value === 'rtl';
            this.changeDetector.markForCheck();
        });
        // Setup pill validation logic
        this._validations = {
            // Tell the pill whether it can edit
            canEdit: () => !this._errors.hasError(),
            // Check if the current string is valid
            isValidTag: (str, tag) => {
                if (!str || String(str).trim().length === 0) {
                    return false;
                }
                // Reset Typeahead flag
                // This function is always called when an entry/selection is finished
                this._isTypeaheadAction = false;
                const formattedStr = this._validations.getFormattedString(str);
                if (this.useOperators) {
                    // Duplicates are allowed with operators
                    // ex. (a) (+) (a) (*) (b) <= where (a) can be used more than 1x
                    return true;
                }
                else if (this._hasDuplicate(formattedStr, tag)) {
                    // There is a duplicate
                    this._errors.addError(BentoTagsInputErrors.DUPLICATE, tag);
                    return false;
                }
                else if (formattedStr.trim().length < this.minTagLength) {
                    // Current string doesn't qualify minLength requirement
                    this._errors.addError(BentoTagsInputErrors.MINIMUM_LENGTH, tag);
                    return false;
                }
                // There is no duplicate
                this._errors.reset();
                // Call validate function when there is no error
                setTimeout(() => this.callValidation());
                return true;
            },
            // Format a string based on the `replaceSpacesWith`
            getFormattedString: str => String(str).replace(/ /gi, this.replaceSpacesWith || ' ')
        };
        // Register error status callback
        this._errorNotificationSubscription = this._errors.errorNotification.subscribe((e) => {
            this._onError(e);
        });
        this.r.addClass(this.el, 'form-control');
        this.r.listen(this.el, 'focusin', e => {
            if (!this.el.classList.contains('bento-tags-input-focused')) {
                // only fire when it is not focued
                this.onFocus(e);
            }
        });
        this.r.listen(this.el, 'click', e => {
            if (!this.el.classList.contains('bento-tags-input-focused') && e.target === this.el) {
                // only fire when it is not focued and user clicks on contents othan than the pills and input
                this.onFocus(e);
                if (!this.disableInput) {
                    // If the main input is not disabled bring focus to it
                    this._inputEl.focus();
                }
                else {
                    // Focus on the first pill if there is one
                    const pill = this._elementRef.nativeElement.querySelector('bento-tags-input-pill');
                    if (pill) {
                        pill.focus();
                    }
                }
            }
        });
        this.r.listen(this.el, 'focusout', e => {
            setTimeout(() => {
                if (e.relatedTarget) {
                    // Most of the browsers have FocusEvent.relatedTarget defined
                    if (!this.el.contains(e.relatedTarget)) {
                        this.onBlur(e);
                    }
                }
                else if (!this.el.contains(this.document.activeElement)) {
                    // But some don't!!
                    this.onBlur(e);
                }
            });
        });
    }
    /**
     * Placeholder for the input field
     */
    set placeholder(str) {
        this._placeholder = str || '';
        this.adjustInputEl();
    }
    get placeholder() {
        return this._placeholder;
    }
    /**
     * Set the maximum width of the tags in pixel
     */
    set tagMaxWidth(value) {
        const trimmed = value ? value.trim() : '100%';
        // Auto should not be allowed
        this._tagMaxWidth = trimmed.toLowerCase().indexOf('auto') > -1 ? '100%' : trimmed;
    }
    get tagMaxWidth() {
        return this._tagMaxWidth;
    }
    /**
     * ID of this element
     */
    set _id(v) {
        this.id = v;
        // setTimeout(() => this.setupAria(), 3000);
    }
    /**
     * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
     * Follow [ngbTypeahead Documentation](https://ng-bootstrap.github.io/#/components/typeahead) for more details
     */
    set typeahead(fn) {
        this._typeahead = fn;
        // Reset input el pointer since the observer can be null
        this._inputElPointer = null;
    }
    /**
     * Flag to make all tags editable
     */
    set editable(v) {
        this._editable = v;
    }
    /**
     * Get current available main input element
     */
    get _inputEl() {
        this._inputElPointer = this._elementRef.nativeElement.querySelector('.bento-tags-input-field-main');
        return this._inputElPointer;
    }
    /**
     * Implements ControlValueAccessor
     */
    registerOnChange(fn) {
        this._onChangeCallback = fn;
    }
    /**
     * From ControlValueAccessor interface
     */
    registerOnTouched(fn) {
        this._onTouchedCallback = () => {
            fn();
            this.changeDetector.markForCheck();
        };
    }
    /**
     * NgModel setter
     */
    writeValue(v) {
        this._data = v ? v.slice() : null;
        this.changeDetector.markForCheck();
        setTimeout(() => {
            this.adjustInputEl();
        });
    }
    /**
     * Set Disabled state for ngModel
     */
    setDisabledState(v) {
        this._disabled = v;
        if (!v) {
            // When showing, bring placeholder up in the view after a local digest cycle
            setTimeout(() => {
                this.adjustInputEl();
            });
        }
    }
    validate(control) {
        if (this.validationErrors && this._errors.hasError()) {
            let returnValue;
            if (this.validationErrors.errors[0] === BentoTagsInputErrors.MINIMUM_LENGTH) {
                returnValue = { minlength: { actualLength: this._inputText.length, requiredLength: this.minTagLength } };
            }
            else if (this.validationErrors.errors[0] === BentoTagsInputErrors.DUPLICATE) {
                returnValue = { duplicate: { valid: false } };
            }
            return returnValue;
        }
        return null;
    }
    // Register callValidation function with registerOnValidatorChange().
    registerOnValidatorChange(fn) {
        this.callValidation = fn;
    }
    /**
     * Init function
     */
    ngOnInit() { }
    /**
     * After View Init function
     */
    ngAfterViewInit() {
        setTimeout(() => this.setupAria());
    }
    /**
     * To be called when this element is destroyed
     */
    ngOnDestroy() {
        this._errorNotificationSubscription.unsubscribe();
        this.mObserver && this.mObserver.disconnect();
        this.changeDetector.detach();
    }
    /**
     * Input `ngModel` change listener
     */
    _onInputTextChange(value) {
        const inputEl = this._inputEl;
        const refEl = this._inputSizeRef.nativeElement;
        if (!inputEl.value || inputEl.value.length === 0) {
            if (this._errors.hasError() && value !== this._inputText) {
                // This happens when typeahead is selecting an item that give an error
                this.r.setValue(inputEl, value);
                this._inputText = value;
            }
            else {
                // When this field is truly empty
                this._inputText = '';
                this.adjustInputEl();
                this._errors.reset();
            }
        }
        else {
            // Normal user entries
            this._inputText = value;
            this.r.setProperty(refEl, 'innerText', inputEl.value);
            setTimeout(() => {
                this.r.setStyle(inputEl, 'width', refEl.offsetWidth + 10 + 'px');
            });
            this._errors.reset();
        }
    }
    /**
     * Main input `keydown` event listener
     */
    _onInputKeydown(e) {
        const inputEl = this._inputEl;
        switch (e.keyCode) {
            // Erase the last pill on BACKSPACE
            case Keyboard.BACKSPACE:
                if (inputEl.selectionStart === 0 &&
                    inputEl.selectionEnd === 0 &&
                    !this.disableTagRemove &&
                    this._data.length > 0) {
                    // Execute pop
                    BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagRemoveStart, tag => {
                        this._data.pop();
                        // Fire `ngModel` callback
                        this._onChangeCallback(this._data.slice());
                        // Fire event callback
                        this.tagRemoved.emit(new BentoTagsInputEvent(tag));
                    }, this._data[this._data.length - 1]);
                }
                else if (!inputEl.value || (inputEl.value && inputEl.value.length <= 1)) {
                    // validate to show/hide new/previous error
                    setTimeout(() => this.callValidation());
                }
                break;
            case Keyboard.ENTER:
                if (this.addOnEnter && !this._isTypeaheadAction) {
                    this._addPill(this._inputText);
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.SPACE:
                if (this.addOnSpace) {
                    this._addPill(this._inputText);
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
            case Keyboard.COMMA:
                if (this.addOnComma) {
                    this._addPill(this._inputText);
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
            default:
                break;
        }
    }
    /**
     * Callback when the input box is blurred
     */
    _onInputBlur(e) {
        this._addPill(this._inputText);
    }
    /**
     * Callback when the input with typeahead blurred
     */
    _onInputBlurWithTypeahead(e) {
        triggerKeyboardEvent(this._inputEl, 'keydown', Keyboard.ENTER);
    }
    /**
     * Callback when a typeahead item is selected
     */
    _onTypeaheadSelectItem(e) {
        // Need to flag the typeahead action
        // since this happens prior to the enter keydown
        // we can stop the ENTER keydown being registered with the main input field
        this._isTypeaheadAction = true;
        if (this.typeaheadSelectItem) {
            this.typeaheadSelectItem.emit(e);
        }
        // We are adding a tag when an item is selected from the typeahead dropdown
        this._addPill(this.typeaheadInputFormatter ? this.typeaheadInputFormatter(e.item) : e.item);
        this._inputText = '';
        this.adjustInputEl();
    }
    /**
     * Force typeahead to display an empty string when an item is selected
     */
    _typeaheadTagsInputFieldFormatter(value) {
        return '';
    }
    /**
     * Callback function to pill update
     */
    _onPillUpdate(tag, index) {
        // Call validate function when the pill is done editing.
        this.callValidation();
        this.tagEdited.emit(new BentoTagsInputEvent(tag));
    }
    /**
     * Callback when a pill is removed
     */
    _onPillRemove(e) {
        // Bug Fix: before removing the pill, reset error object. Without
        // reset, future edit is disabled.
        this.validationErrors = undefined;
        this._errors.reset();
        // Execute `_doRemove` based on `this.tagRemoveStart`
        BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagRemoveStart, this._doRemovePill, e.tag, e);
    }
    /**
     * Execute pill removal
     */
    _doRemovePill(tag, data) {
        // Execute Tag removal
        const index = this._data.indexOf(tag);
        this._data.splice(index, 1);
        // Focus on to the previous/next el sibling to additional keyboard navigation
        if (data.keyCode && data.keyCode === Keyboard.BACKSPACE && data.el.previousElementSibling) {
            // focus on the previous sibling when Backspace is pressed
            data.el.previousElementSibling.focus();
        }
        else {
            data.el.nextElementSibling.focus();
        }
        // Notify ngFormController for changes
        this._onChangeCallback(this._data.slice());
        // Notify Tag removal
        this.tagRemoved.emit(new BentoTagsInputEvent(tag));
    }
    /**
     * Add and push a pill into the data
     */
    _addPill(str) {
        if (!str) {
            return;
        }
        else if (str.trim().length === 0) {
            this._inputText = '';
            this.adjustInputEl();
            return;
        }
        const tag = this._makeTag(str);
        if (this._validations.isValidTag(tag[this.tagPropertyName], tag)) {
            // Execute `_doAddPill` based on `this.tagAddStart`
            BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagAddStart, this._doAddPill, tag);
        }
        else {
            this._onChangeCallback(this._data.slice());
        }
    }
    /**
     * Execute adding a pill from a string
     */
    _doAddPill(tag) {
        this._data.push(tag);
        this._onChangeCallback(this._data.slice());
        // Reset the main input field
        this._inputText = '';
        this.adjustInputEl();
        // Fire callback
        this.tagAdded.emit(new BentoTagsInputEvent(tag));
        // Reset typeahead action flag when pill adding is finished
        this._isTypeaheadAction = false;
    }
    /**
     * Make a tag object with a string
     */
    _makeTag(str) {
        let tagStr;
        if (!str || (tagStr = String(str).trim()).length === 0) {
            return;
        }
        if (tagStr.length === 0) {
            return;
        }
        const num = this.tagDefaultType === 'auto' ? Number(tagStr) : Number.NaN;
        const tag = { type: 'string' };
        if (!isNaN(num)) {
            // Use formatter
            tag[this.tagPropertyName] = this.tagFormatter ? this.tagFormatter(num) : num;
            tag.type = 'number';
        }
        else if (this._isOperator(tagStr) && this.useOperators) {
            // Operators don't need tag formatters
            tag[this.tagPropertyName] = tagStr;
            tag.type = 'operator';
        }
        else {
            // Format tag
            tag[this.tagPropertyName] = this.tagFormatter
                ? this.tagFormatter(this._validations.getFormattedString(tagStr))
                : this._validations.getFormattedString(tagStr);
        }
        return tag;
    }
    /**
     * Check if the content of `str` has already entered in the pill array
     */
    _hasDuplicate(value, tag) {
        let str;
        let dataTag;
        let tagStr;
        if (!value || (str = value.trim()).length === 0) {
            // There isn't a duplicate for an empty entry
            return false;
        }
        if (this.caseInsensitive) {
            str = str.toLowerCase();
        }
        for (let i = 0, len = this._data.length; i < len; i++) {
            dataTag = this._data[i];
            tagStr = this.caseInsensitive ? dataTag[this.tagPropertyName].toLowerCase() : dataTag[this.tagPropertyName];
            // Check value against each tag's propertyName
            if (tagStr === str && tag !== dataTag) {
                // Return immediately when a duplicate found
                return true;
            }
        }
        // No duplicates
        return false;
    }
    /**
     * Show placeholder when permitted
     */
    adjustInputEl() {
        this.ngZone.runOutsideAngular(() => {
            if (!this.disableInput && this._inputSizeRef) {
                // Only execute this method only when the main input is not disabled
                const inputEl = this._inputEl;
                const sizeRefEl = this._inputSizeRef.nativeElement;
                if (this.bodyEl.contains(sizeRefEl)) {
                    if (this.mObserver) {
                        // Remove BODY MutationOberver when Tags Input component is in view
                        this.mObserver.disconnect();
                        this.mObserver = null;
                    }
                    const inputWidth = 2; // Default input width without anything
                    let placeholderWidth = 0; // Default placeholder width
                    if (!!this.placeholder && sizeRefEl) {
                        // Calculate place holder width
                        this.r.setProperty(sizeRefEl, 'innerText', this.placeholder);
                        placeholderWidth = Math.min(this.el.offsetWidth - 16, sizeRefEl.offsetWidth + 6);
                    }
                    inputEl && this.r.setStyle(inputEl, 'width', `${Math.max(inputWidth, placeholderWidth)}px`);
                }
                else if (!this.mObserver) {
                    // Setup document DOM change listener
                    this.mObserver = new MutationObserver(this.onDocumentDOMChange.bind(this));
                    // Only oberve childlist changes for Modal in Body
                    // The rest...? Will figure out later due to perfomance lags when `subtree: true` is used
                    this.mObserver.observe(this.bodyEl, { childList: true });
                }
            }
        });
    }
    /**
     * Callback when error status is updated
     */
    _onError(e) {
        if (!(this._isInputValid = e.errors.length === 0)) {
            if (this.tagInvalidInput) {
                this.validationErrors = e;
                this.tagInvalidInput.emit(new BentoTagsInputEvent(e.tag, null, e.errors));
            }
        }
    }
    /**
     * Check if the current string is an operator
     */
    _isOperator(str) {
        for (let i = 0, len = str.length; i < len; i++) {
            if (this.allowedOperators.indexOf(str.charAt(i)) < 0) {
                return false;
            }
        }
        return true;
    }
    /**
     * Event listner for navigational keystrokes
     */
    _onTagsInputKeydown(e) {
        let focusedEl = this.document.activeElement;
        const inputEl = this._inputEl;
        if (focusedEl.parentElement && focusedEl.parentElement.classList.contains('bento-typeahead')) {
            // If focus is on typeahead input element and contains wrapper element as parent, focus on parent element
            // to be able to reach previous sibling
            focusedEl = focusedEl.parentElement;
        }
        switch (e.keyCode) {
            // Left Key
            case Keyboard.LEFT:
                if (this.isRtl) {
                    this.selectNext(focusedEl, e);
                }
                else {
                    this.selectPrevious(focusedEl, inputEl);
                }
                break;
            // Right Key
            case Keyboard.RIGHT:
                if (this.isRtl) {
                    this.selectPrevious(focusedEl, inputEl);
                }
                else {
                    this.selectNext(focusedEl, e);
                }
                break;
        }
    }
    selectPrevious(focusedEl, inputEl) {
        if (focusedEl.previousElementSibling) {
            // Only execute when there is a pill before the current focused element
            if (inputEl === focusedEl) {
                // check the current selection range then decide if need to focus on the previous pill
                if (inputEl.selectionStart === 0 && inputEl.selectionEnd === 0) {
                    focusedEl.previousElementSibling.focus();
                }
            }
            else {
                // Focus on the previous sibling if it exists
                focusedEl.previousElementSibling.focus();
            }
        }
    }
    selectNext(focusedEl, e) {
        if (e.target.tagName !== 'INPUT') {
            // Only focus to the next sibling when the current focused element is NOT an input
            if (focusedEl.nextElementSibling.classList.contains('bento-typeahead')) {
                // if next sibling is a typeahead wrapper (needed for RTL) focus on actual input element
                focusedEl.nextElementSibling.firstChild.focus();
            }
            else {
                focusedEl.nextElementSibling.focus();
            }
        }
    }
    /**
     * Callback when BODY DOM is mutated
     * This only applies the children of the BODY element
     * DOES NOT apply to subtrees
     *
     * We are using this callback address when this component is
     * used in conjuction with Modal
     *
     * @param mutationList
     * @param observer
     */
    onDocumentDOMChange(mutationList, observer) {
        this.adjustInputEl();
    }
    /**
     * Callback for component focus events
     */
    onFocus(e) {
        this.r.addClass(this._elementRef.nativeElement, 'bento-tags-input-focused');
    }
    /**
     * Callback for component blur events
     */
    onBlur(e) {
        this.r.removeClass(this._elementRef.nativeElement, 'bento-tags-input-focused');
        this._onTouchedCallback();
    }
    /**
     * Setup aria values
     */
    setupAria() {
        let ariaAttribute = this._elementRef.nativeElement.getAttribute('aria-label');
        this.ariaLabel = ariaAttribute ? ariaAttribute : this.ariaLabel;
        ariaAttribute = this._elementRef.nativeElement.getAttribute('aria-describedby');
        this.ariaDescribedby = ariaAttribute ? ariaAttribute : this.ariaDescribedby;
        ariaAttribute = this._elementRef.nativeElement.getAttribute('aria-labelledby');
        this.ariaLabelledby = ariaAttribute ? ariaAttribute : this.ariaLabelledby;
        if (!(typeof this.id === 'string' && this.id.length)) {
            this.id = 'bui-tags-input-' + this.uidGen.generate();
        }
        else {
            this.r.removeAttribute(this._elementRef.nativeElement, 'id');
        }
        if (this.ariaLabel && this.ariaLabel.length) {
            this.r.removeAttribute(this._elementRef.nativeElement, 'aria-label');
        }
        if (this.ariaDescribedby && this.ariaDescribedby.length) {
            this.r.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
        }
        this._inputID = this.id;
    }
}
BentoTagsInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: WindowRef }, { token: i2.Directionality }, { token: BentoUidService }, { token: i0.ChangeDetectorRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BentoTagsInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTagsInputComponent, selector: "bento-tags-input", inputs: { addOnComma: "addOnComma", addOnEnter: "addOnEnter", addOnSpace: "addOnSpace", caseInsensitive: "caseInsensitive", placeholder: "placeholder", useOperators: "useOperators", allowedOperators: "allowedOperators", disableInput: "disableInput", disableTagRemove: "disableTagRemove", minTagLength: "minTagLength", replaceSpacesWith: "replaceSpacesWith", tagPropertyName: "tagPropertyName", tagDefaultType: "tagDefaultType", readonly: "readonly", tagFormatter: "tagFormatter", tagMaxWidth: "tagMaxWidth", _id: ["id", "_id"], typeheadFocusFirst: "typeheadFocusFirst", typeheadEditable: "typeheadEditable", typeaheadInputFormatter: "typeaheadInputFormatter", typeaheadResultFormatter: "typeaheadResultFormatter", typeaheadShowHint: "typeaheadShowHint", typeahead: "typeahead", editable: "editable" }, outputs: { tagAddStart: "tagAddStart", tagAdded: "tagAdded", tagEditStart: "tagEditStart", tagEdited: "tagEdited", tagEditCancel: "tagEditCancel", tagRemoveStart: "tagRemoveStart", tagRemoved: "tagRemoved", tagInvalidInput: "tagInvalidInput", typeaheadSelectItem: "typeaheadSelectItem" }, host: { listeners: { "keydown": "_onTagsInputKeydown($event)" }, properties: { "class.readonly": "this.readonly", "class.disabled": "this._disabled" } }, providers: [BENTO_TAGS_INPUT_VALUE_ACCESSOR, BENTO_TAGS_INPUT_VALUE_VALIDATOR, BentoUidService], viewQueries: [{ propertyName: "_inputSizeRef", first: true, predicate: ["inputSizeRef"], descendants: true, static: true }], ngImport: i0, template: "<bento-tags-input-pill\n  [attr.tabindex]=\"tagMaxWidth ? 0 : null\"\n  *ngFor=\"let pill of _data; let i = index\"\n  [style.max-width]=\"tagMaxWidth\"\n  [ngModel]=\"pill\"\n  (ngModelChange)=\"_onPillUpdate($event, i)\"\n  (remove)=\"_onPillRemove($event)\"\n  [tagEditCancel]=\"tagEditCancel\"\n  [tagEditStart]=\"tagEditStart\"\n  [disableRemove]=\"disableTagRemove\"\n  [tagPropertyName]=\"tagPropertyName\"\n  [editable]=\"_editable\"\n  [validations]=\"_validations\"\n  [tagFormatter]=\"tagFormatter\"\n  [typeahead]=\"_typeahead\"\n  [typeheadEditable]=\"typeheadEditable\"\n  [typeheadFocusFirst]=\"typeheadFocusFirst\"\n  [typeaheadInputFormatter]=\"typeaheadInputFormatter\"\n  [typeaheadResultFormatter]=\"typeaheadResultFormatter\"\n  [typeaheadShowHint]=\"typeaheadShowHint\"\n  [typeaheadSelectItem]=\"typeaheadSelectItem\"\n  [disabled]=\"_disabled\"\n  [readonly]=\"readonly\"\n></bento-tags-input-pill>\n\n<input\n  *ngIf=\"!_typeahead && !_disabled && !readonly\"\n  class=\"bento-tags-input-field bento-tags-input-field-main\"\n  [hidden]=\"disableInput\"\n  [class.invalid]=\"!_isInputValid\"\n  [ngModel]=\"_inputText\"\n  (ngModelChange)=\"_onInputTextChange($event)\"\n  (keydown)=\"_onInputKeydown($event)\"\n  (blur)=\"_onInputBlur($event)\"\n  placeholder=\"{{ placeholder }}\"\n  [attr.id]=\"_inputID\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n  [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n/>\n\n<div *ngIf=\"_typeahead && !_disabled && !readonly\" class=\"bento-typeahead\">\n  <input\n    class=\"bento-tags-input-field bento-tags-input-field-main\"\n    [hidden]=\"disableInput\"\n    [class.invalid]=\"!_isInputValid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputTextChange($event)\"\n    (keydown)=\"_onInputKeydown($event)\"\n    (blur)=\"_onInputBlurWithTypeahead($event)\"\n    placeholder=\"{{ placeholder }}\"\n    [attr.id]=\"_inputID\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n    [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n    [ngbTypeahead]=\"_typeahead\"\n    [editable]=\"typeheadEditable\"\n    [focusFirst]=\"typeheadFocusFirst\"\n    [inputFormatter]=\"_typeaheadTagsInputFieldFormatter\"\n    [resultFormatter]=\"typeaheadResultFormatter\"\n    [showHint]=\"typeaheadShowHint\"\n    (selectItem)=\"_onTypeaheadSelectItem($event)\"\n  />\n</div>\n<div class=\"clearfix\"></div>\n<div #inputSizeRef class=\"bento-tags-input-pill-size-ref\" aria-hidden=\"true\"></div>\n", styles: [".ng-bento bento-tags-input.form-control{display:block;height:auto}.ng-bento bento-tags-input.form-control.disabled,.ng-bento bento-tags-input.form-control[disabled],.ng-bento bento-tags-input.form-control:disabled{opacity:.5;pointer-events:none}.ng-bento bento-tags-input.form-control.readonly{padding-left:0;padding-right:0}[dir=rtl] .ng-bento bento-tags-input.form-control.readonly{margin-left:0}.ng-bento bento-tags-input.form-control .dropdown-menu{transform:none}.ng-bento bento-tags-input.form-control .dropdown-menu:before,.ng-bento bento-tags-input.form-control .dropdown-menu:after{content:\"\";width:0;height:0;border:none}.ng-bento bento-tags-input{cursor:text}.ng-bento bento-tags-input .bento-typeahead{float:left}[dir=rtl] .ng-bento bento-tags-input .bento-typeahead{float:right}.ng-bento bento-tags-input input.bento-tags-input-field{float:left;display:block;padding:0;border:none;box-sizing:border-box;width:0;min-width:1px;max-width:100%;letter-spacing:0}[dir=rtl] .ng-bento bento-tags-input input.bento-tags-input-field{float:right}.ng-bento bento-tags-input input.bento-tags-input-field:focus{outline:none}.ng-bento bento-tags-input input.bento-tags-input-field[disabled]{background:transparent}.ng-bento bento-tags-input .bento-tags-input-pill-size-ref{display:inline-block;padding:0 1px;position:fixed;top:-9999px;white-space:pre;width:auto;letter-spacing:0;opacity:0}.ng-bento bento-tags-input-pill{border-width:1px;border-style:solid;cursor:default;float:left;font-size:14px;opacity:0;overflow:hidden;position:relative;transition:background .1s,color .1s,border-color .1s}[dir=rtl] .ng-bento bento-tags-input-pill{float:right}.ng-bento bento-tags-input-pill.disable-remove{padding-right:10px}[dir=rtl] .ng-bento bento-tags-input-pill.disable-remove{padding-left:10px}.ng-bento bento-tags-input-pill.disable-remove:after{width:13.3px}.ng-bento bento-tags-input-pill input.bento-tags-input-field{display:block;background:none;margin:0}.ng-bento bento-tags-input-pill.ready{opacity:1}.ng-bento bento-tags-input-pill input,.ng-bento bento-tags-input-pill .bento-tags-input-pill-size-ref{min-width:0}.ng-bento bento-tags-input-pill input{margin-right:5px}.ng-bento bento-tags-input-pill.edit{padding-right:25.5px}.ng-bento bento-tags-input-pill.edit .bento-tags-input-pill-close-icon{opacity:.2;transition:opacity .2s}.ng-bento bento-tags-input-pill.edit:after{display:none}.ng-bento bento-tags-input-pill:after{content:\" \";right:-1px;top:0;height:100%;pointer-events:none}[dir=rtl] .ng-bento bento-tags-input-pill:after{right:auto;left:0;transform:scaleX(-1)}.ng-bento bento-tags-input-pill .bento-tags-input-pill-label{display:block;width:100%;vertical-align:top;white-space:pre;word-break:normal;word-wrap:normal;cursor:default}.ng-bento bento-tags-input-pill .bento-tags-input-pill-close-icon{background-color:Transparent;border:none;display:flex}.ng-bento bento-tags-input-pill .bento-tags-input-pill-edit-icon{background-color:Transparent;border:none;display:flex}.ng-bento bento-tags-input-pill .bento-tags-input-pill-edit-icon i{top:0}\n"], components: [{ type: BentoTagsInputPillComponent, selector: "bento-tags-input-pill", inputs: ["tagEditStart", "tagEditCancel", "typeaheadSelectItem", "tagPropertyName", "editable", "validations", "disableRemove", "tagFormatter", "typeahead", "typeheadEditable", "typeheadFocusFirst", "typeaheadInputFormatter", "typeaheadResultFormatter", "typeaheadShowHint", "readonly"], outputs: ["remove"] }], directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgbTypeahead, selector: "input[ngbTypeahead]", inputs: ["autocomplete", "container", "editable", "focusFirst", "inputFormatter", "ngbTypeahead", "resultFormatter", "resultTemplate", "showHint", "placement", "popupClass"], outputs: ["selectItem"], exportAs: ["ngbTypeahead"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tags-input', providers: [BENTO_TAGS_INPUT_VALUE_ACCESSOR, BENTO_TAGS_INPUT_VALUE_VALIDATOR, BentoUidService], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<bento-tags-input-pill\n  [attr.tabindex]=\"tagMaxWidth ? 0 : null\"\n  *ngFor=\"let pill of _data; let i = index\"\n  [style.max-width]=\"tagMaxWidth\"\n  [ngModel]=\"pill\"\n  (ngModelChange)=\"_onPillUpdate($event, i)\"\n  (remove)=\"_onPillRemove($event)\"\n  [tagEditCancel]=\"tagEditCancel\"\n  [tagEditStart]=\"tagEditStart\"\n  [disableRemove]=\"disableTagRemove\"\n  [tagPropertyName]=\"tagPropertyName\"\n  [editable]=\"_editable\"\n  [validations]=\"_validations\"\n  [tagFormatter]=\"tagFormatter\"\n  [typeahead]=\"_typeahead\"\n  [typeheadEditable]=\"typeheadEditable\"\n  [typeheadFocusFirst]=\"typeheadFocusFirst\"\n  [typeaheadInputFormatter]=\"typeaheadInputFormatter\"\n  [typeaheadResultFormatter]=\"typeaheadResultFormatter\"\n  [typeaheadShowHint]=\"typeaheadShowHint\"\n  [typeaheadSelectItem]=\"typeaheadSelectItem\"\n  [disabled]=\"_disabled\"\n  [readonly]=\"readonly\"\n></bento-tags-input-pill>\n\n<input\n  *ngIf=\"!_typeahead && !_disabled && !readonly\"\n  class=\"bento-tags-input-field bento-tags-input-field-main\"\n  [hidden]=\"disableInput\"\n  [class.invalid]=\"!_isInputValid\"\n  [ngModel]=\"_inputText\"\n  (ngModelChange)=\"_onInputTextChange($event)\"\n  (keydown)=\"_onInputKeydown($event)\"\n  (blur)=\"_onInputBlur($event)\"\n  placeholder=\"{{ placeholder }}\"\n  [attr.id]=\"_inputID\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n  [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n/>\n\n<div *ngIf=\"_typeahead && !_disabled && !readonly\" class=\"bento-typeahead\">\n  <input\n    class=\"bento-tags-input-field bento-tags-input-field-main\"\n    [hidden]=\"disableInput\"\n    [class.invalid]=\"!_isInputValid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputTextChange($event)\"\n    (keydown)=\"_onInputKeydown($event)\"\n    (blur)=\"_onInputBlurWithTypeahead($event)\"\n    placeholder=\"{{ placeholder }}\"\n    [attr.id]=\"_inputID\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n    [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n    [ngbTypeahead]=\"_typeahead\"\n    [editable]=\"typeheadEditable\"\n    [focusFirst]=\"typeheadFocusFirst\"\n    [inputFormatter]=\"_typeaheadTagsInputFieldFormatter\"\n    [resultFormatter]=\"typeaheadResultFormatter\"\n    [showHint]=\"typeaheadShowHint\"\n    (selectItem)=\"_onTypeaheadSelectItem($event)\"\n  />\n</div>\n<div class=\"clearfix\"></div>\n<div #inputSizeRef class=\"bento-tags-input-pill-size-ref\" aria-hidden=\"true\"></div>\n", styles: [".ng-bento bento-tags-input.form-control{display:block;height:auto}.ng-bento bento-tags-input.form-control.disabled,.ng-bento bento-tags-input.form-control[disabled],.ng-bento bento-tags-input.form-control:disabled{opacity:.5;pointer-events:none}.ng-bento bento-tags-input.form-control.readonly{padding-left:0;padding-right:0}[dir=rtl] .ng-bento bento-tags-input.form-control.readonly{margin-left:0}.ng-bento bento-tags-input.form-control .dropdown-menu{transform:none}.ng-bento bento-tags-input.form-control .dropdown-menu:before,.ng-bento bento-tags-input.form-control .dropdown-menu:after{content:\"\";width:0;height:0;border:none}.ng-bento bento-tags-input{cursor:text}.ng-bento bento-tags-input .bento-typeahead{float:left}[dir=rtl] .ng-bento bento-tags-input .bento-typeahead{float:right}.ng-bento bento-tags-input input.bento-tags-input-field{float:left;display:block;padding:0;border:none;box-sizing:border-box;width:0;min-width:1px;max-width:100%;letter-spacing:0}[dir=rtl] .ng-bento bento-tags-input input.bento-tags-input-field{float:right}.ng-bento bento-tags-input input.bento-tags-input-field:focus{outline:none}.ng-bento bento-tags-input input.bento-tags-input-field[disabled]{background:transparent}.ng-bento bento-tags-input .bento-tags-input-pill-size-ref{display:inline-block;padding:0 1px;position:fixed;top:-9999px;white-space:pre;width:auto;letter-spacing:0;opacity:0}.ng-bento bento-tags-input-pill{border-width:1px;border-style:solid;cursor:default;float:left;font-size:14px;opacity:0;overflow:hidden;position:relative;transition:background .1s,color .1s,border-color .1s}[dir=rtl] .ng-bento bento-tags-input-pill{float:right}.ng-bento bento-tags-input-pill.disable-remove{padding-right:10px}[dir=rtl] .ng-bento bento-tags-input-pill.disable-remove{padding-left:10px}.ng-bento bento-tags-input-pill.disable-remove:after{width:13.3px}.ng-bento bento-tags-input-pill input.bento-tags-input-field{display:block;background:none;margin:0}.ng-bento bento-tags-input-pill.ready{opacity:1}.ng-bento bento-tags-input-pill input,.ng-bento bento-tags-input-pill .bento-tags-input-pill-size-ref{min-width:0}.ng-bento bento-tags-input-pill input{margin-right:5px}.ng-bento bento-tags-input-pill.edit{padding-right:25.5px}.ng-bento bento-tags-input-pill.edit .bento-tags-input-pill-close-icon{opacity:.2;transition:opacity .2s}.ng-bento bento-tags-input-pill.edit:after{display:none}.ng-bento bento-tags-input-pill:after{content:\" \";right:-1px;top:0;height:100%;pointer-events:none}[dir=rtl] .ng-bento bento-tags-input-pill:after{right:auto;left:0;transform:scaleX(-1)}.ng-bento bento-tags-input-pill .bento-tags-input-pill-label{display:block;width:100%;vertical-align:top;white-space:pre;word-break:normal;word-wrap:normal;cursor:default}.ng-bento bento-tags-input-pill .bento-tags-input-pill-close-icon{background-color:Transparent;border:none;display:flex}.ng-bento bento-tags-input-pill .bento-tags-input-pill-edit-icon{background-color:Transparent;border:none;display:flex}.ng-bento bento-tags-input-pill .bento-tags-input-pill-edit-icon i{top:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: WindowRef }, { type: i2.Directionality }, { type: BentoUidService }, { type: i0.ChangeDetectorRef }, { type: i0.NgZone }]; }, propDecorators: { addOnComma: [{
                type: Input
            }], addOnEnter: [{
                type: Input
            }], addOnSpace: [{
                type: Input
            }], caseInsensitive: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], useOperators: [{
                type: Input
            }], allowedOperators: [{
                type: Input
            }], disableInput: [{
                type: Input
            }], disableTagRemove: [{
                type: Input
            }], minTagLength: [{
                type: Input
            }], replaceSpacesWith: [{
                type: Input
            }], tagPropertyName: [{
                type: Input
            }], tagDefaultType: [{
                type: Input
            }], readonly: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.readonly']
            }], tagFormatter: [{
                type: Input
            }], tagMaxWidth: [{
                type: Input
            }], _id: [{
                type: Input,
                args: ['id']
            }], typeheadFocusFirst: [{
                type: Input
            }], typeheadEditable: [{
                type: Input
            }], typeaheadInputFormatter: [{
                type: Input
            }], typeaheadResultFormatter: [{
                type: Input
            }], typeaheadShowHint: [{
                type: Input
            }], tagAddStart: [{
                type: Output
            }], tagAdded: [{
                type: Output
            }], tagEditStart: [{
                type: Output
            }], tagEdited: [{
                type: Output
            }], tagEditCancel: [{
                type: Output
            }], tagRemoveStart: [{
                type: Output
            }], tagRemoved: [{
                type: Output
            }], tagInvalidInput: [{
                type: Output
            }], typeaheadSelectItem: [{
                type: Output
            }], _inputSizeRef: [{
                type: ViewChild,
                args: ['inputSizeRef', { static: true }]
            }], _disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }], typeahead: [{
                type: Input
            }], editable: [{
                type: Input
            }], _onTagsInputKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class BentoTagsInputModule extends ConsumerDataValidator {
}
BentoTagsInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTagsInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputModule, declarations: [BentoTagsInputComponent, BentoTagsInputPillComponent], imports: [CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, NgbTypeaheadModule, NgbTooltipModule], exports: [BentoTagsInputComponent] });
BentoTagsInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputModule, imports: [[CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, NgbTypeaheadModule, NgbTooltipModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTagsInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, NgbTypeaheadModule, NgbTooltipModule],
                    declarations: [BentoTagsInputComponent, BentoTagsInputPillComponent],
                    exports: [BentoTagsInputComponent]
                }]
        }] });

class BentoRibbonTileComponent {
    constructor(r, elRef) {
        this.r = r;
        this.elRef = elRef;
        /**
         * When this tile is selected
         */
        this.select = new EventEmitter();
        this.r.addClass(this.elRef.nativeElement, 'bento-ribbon-tile');
    }
    /**
     * Set width of this tile
     */
    set width(v) {
        this._styleWidth = `${v}px`;
    }
    ngAfterViewInit() {
        this.r.setAttribute(this.elRef.nativeElement.querySelector('.bento-ribbon-tile-inner'), 'tabindex', '0');
        this.onItemSelect = this.onItemSelect.bind(this);
        this.removeSelectionCallback = this.item.addSelectionCallback(this.onItemSelect);
        this.onItemDeselect = this.onItemDeselect.bind(this);
        this.removeDeselectionCallback = this.item.addDeselectionCallback(this.onItemDeselect);
        if (this.item.selected) {
            // Highlight if the item is pre-selected
            setTimeout(() => this.onItemSelect(this.item));
        }
    }
    ngOnDestroy() {
        this.removeSelectionCallback();
        this.removeDeselectionCallback();
    }
    /**
     * Link click callback
     */
    _onLinkclick(e) {
        if (this.item.onLinkClick) {
            this.item.onLinkClick(this.item);
        }
        e.stopPropagation();
        e.preventDefault();
    }
    /**
     * Callback on host element is clicked
     */
    _onHostClick() {
        this.item.select();
    }
    /**
     * Callback when an element is selected
     */
    onItemSelect(item) {
        this._selected = true;
        this.select.emit(this.item);
    }
    /**
     * Callback when an element is selected
     */
    onItemDeselect(item) {
        this._selected = false;
    }
}
BentoRibbonTileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRibbonTileComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoRibbonTileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoRibbonTileComponent, selector: "bento-ribbon-tile", inputs: { item: "item", width: "width", template: "template" }, outputs: { select: "select" }, host: { listeners: { "click": "_onHostClick()" }, properties: { "style.width": "this._styleWidth", "class.selected": "this._selected" } }, ngImport: i0, template: "<div class=\"bento-ribbon-tile-inner\" [attr.title]=\"item.value ? item.value : item.header ? item.header : null\">\n  <ng-template [ngIf]=\"!template\" [ngIfElse]=\"customTemplate\">\n    <div class=\"bento-ribbon-tile-value-wrapper\">\n      <div class=\"bento-ribbon-tile-value\">{{ item.value }}</div>\n      <a *ngIf=\"item.linkTitle\" (click)=\"_onLinkclick($event)\" class=\"bento-ribbon-tile-link\" tabindex=\"0\">\n        {{ item.linkTitle }}\n      </a>\n    </div>\n    <div class=\"bento-ribbon-tile-header-wrapper\">\n      <div\n        *ngIf=\"item.indicator\"\n        class=\"bento-ribbon-tile-indicator\"\n        [ngClass]=\"[item.indicator.icon, item.indicator.class]\"\n        aria-live=\"polite\"\n        [attr.aria-label]=\"item.ariaLabel || (item.indicator.i18nLabel | bentoTranslate)\"\n      ></div>\n      <p class=\"bento-ribbon-tile-header\">{{ item.header }}</p>\n    </div>\n    <div *ngIf=\"item.description\" class=\"bento-ribbon-tile-description\">{{ item.description }}</div>\n  </ng-template>\n</div>\n<ng-template #customTemplate>\n  <ng-container *ngTemplateOutlet=\"template; context: {item: item}\"></ng-container>\n</ng-template>\n", directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRibbonTileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-ribbon-tile', template: "<div class=\"bento-ribbon-tile-inner\" [attr.title]=\"item.value ? item.value : item.header ? item.header : null\">\n  <ng-template [ngIf]=\"!template\" [ngIfElse]=\"customTemplate\">\n    <div class=\"bento-ribbon-tile-value-wrapper\">\n      <div class=\"bento-ribbon-tile-value\">{{ item.value }}</div>\n      <a *ngIf=\"item.linkTitle\" (click)=\"_onLinkclick($event)\" class=\"bento-ribbon-tile-link\" tabindex=\"0\">\n        {{ item.linkTitle }}\n      </a>\n    </div>\n    <div class=\"bento-ribbon-tile-header-wrapper\">\n      <div\n        *ngIf=\"item.indicator\"\n        class=\"bento-ribbon-tile-indicator\"\n        [ngClass]=\"[item.indicator.icon, item.indicator.class]\"\n        aria-live=\"polite\"\n        [attr.aria-label]=\"item.ariaLabel || (item.indicator.i18nLabel | bentoTranslate)\"\n      ></div>\n      <p class=\"bento-ribbon-tile-header\">{{ item.header }}</p>\n    </div>\n    <div *ngIf=\"item.description\" class=\"bento-ribbon-tile-description\">{{ item.description }}</div>\n  </ng-template>\n</div>\n<ng-template #customTemplate>\n  <ng-container *ngTemplateOutlet=\"template; context: {item: item}\"></ng-container>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { item: [{
                type: Input
            }], width: [{
                type: Input
            }], template: [{
                type: Input
            }], select: [{
                type: Output
            }], _styleWidth: [{
                type: HostBinding,
                args: ['style.width']
            }], _selected: [{
                type: HostBinding,
                args: ['class.selected']
            }], _onHostClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Arrow paddings together on both sides in default layout
 */
const ARROW_PADDING = 40;
/**
 * Main parent component class that defines Bento Tile Ribbon
 */
class BentoTileRibbonComponent {
    constructor(r, windowRef, bentoNotification, transition, dir, elRef) {
        this.r = r;
        this.windowRef = windowRef;
        this.bentoNotification = bentoNotification;
        this.transition = transition;
        this.dir = dir;
        /**
         * Show / Hide collapse toggle button in default theme
         */
        this.showCollapseToggle = true;
        /**
         * Define tile minimum width
         */
        this.tileMinWidth = 260;
        /**
         * Current item width
         */
        this.itemWidth = this.tileMinWidth;
        /**
         * Flag to determine if the left arrow is disabled
         */
        this.disableLeftArrow = false;
        /**
         * Flag to determine if the right arrow is disabled
         */
        this.disableRightArrow = false;
        /**
         * Flag to determine if the ribbon is visible or not
         */
        this.ribbonHidden = false;
        /**
         * Unique class name to component to distinguish from Bento Modern Tile Ribbon
         */
        this.bentoTileRibbonCSSClass = true;
        this.el = elRef.nativeElement;
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe(() => {
            this.flipDirection();
        });
    }
    ngAfterViewInit() {
        this.innerEl = this.innerElRef.nativeElement;
        this.panelEL = this.panelElRef.nativeElement;
        this.r.setStyle(this.innerEl, 'margin-bottom', `-${this.windowRef.scrollbarWidth}px`);
        this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe(() => {
            this.alignItems();
        });
        this.onInnerScroll = this.onInnerScroll.bind(this);
        this.r.listen(this.innerEl, 'scroll', this.onInnerScroll);
        this.r.listen(this.innerEl, 'wheel', (e) => {
            if (e.deltaX === 0) {
                // Only apply to vertical scroll. eg Mouse wheels
                this.r.setProperty(this.innerEl, 'scrollLeft', this.innerEl.scrollLeft + (this.isRtl ? -e.deltaY : e.deltaY));
                e.preventDefault();
            }
        });
    }
    ngAfterViewChecked() {
        if (this.items && this.items.length !== this.itemCount) {
            // Item counts are not aligned
            this.itemCount = this.items.length;
            setTimeout(() => this.alignItems());
        }
    }
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
    }
    /**
     * Toggle ribbon's visibility.  Property `ribbonHidden` is used to determine ribbon's visibility
     */
    toggleVisibility() {
        this.ribbonHidden = !this.ribbonHidden;
    }
    /**
     * Callback when an arrow is clicked
     */
    _onArrowClick(isRight) {
        const scrollLeft = this.innerEl.scrollLeft;
        const itemWidth = this.itemWidth;
        const scrollToIndex = isRight ? Math.round(scrollLeft / itemWidth) + 1 : Math.round(scrollLeft / itemWidth) - 1;
        this.scrollTo(Math.round(scrollToIndex * itemWidth));
    }
    /**
     * Callback when a tile is selected
     */
    _onTileSelect(tile) {
        if (this.selectedTile) {
            this.selectedTile.deselect();
        }
        this.selectedTile = tile;
    }
    onInnerScroll(e) {
        clearTimeout(this.checkArrowTimeout);
        this.checkArrowTimeout = setTimeout(() => {
            this.checkArrowStates();
        }, 500);
    }
    scrollTo(scrollLeft) {
        if (scrollLeft >= 0) {
            this.transition.stop();
            this.transition.duration = 100;
            this.transition.beginVal = this.innerEl.scrollLeft;
            this.transition.endVal = scrollLeft;
            this.transition.onTick(val => this.r.setProperty(this.innerEl, 'scrollLeft', val));
            this.transition.start();
        }
    }
    /**
     * Align tile items
     */
    alignItems() {
        const elWidth = this.el.offsetWidth;
        const hasScroll = this.tileMinWidth * this.itemCount > elWidth;
        const innerWidth = hasScroll
            ? elWidth - (this.el.classList.contains('alt') ? ARROW_PADDING * 2 : ARROW_PADDING)
            : elWidth;
        const numColumnsToFitInner = hasScroll ? Math.floor(innerWidth / this.tileMinWidth) : this.itemCount;
        const adjustedItemWidth = innerWidth / numColumnsToFitInner;
        const panelWidth = adjustedItemWidth * this.itemCount;
        this.r.setStyle(this.panelEL, 'width', `${panelWidth}px`);
        if (hasScroll) {
            this.r.addClass(this.el, 'scroll');
        }
        else {
            this.r.removeClass(this.el, 'scroll');
        }
        this.itemWidth = adjustedItemWidth;
        this.checkArrowStates();
        // when the width is set on the panel the tiles are shifted, this loop
        // moves the tile to the start
        let scrollLeft = 0;
        // this can't loop more than the number of tiles.
        // on some browsers the element's scrollLeft (this.innerEl.scrollLeft)
        // isn't reflected immediately.
        // exitCondition is to mitigate infinite looping
        let exitCondition = this.itemCount - 1;
        while (exitCondition && scrollLeft + this.innerEl.offsetWidth < this.innerEl.scrollWidth) {
            exitCondition--;
            scrollLeft += this.innerEl.scrollLeft;
            const itemWidth = this.itemWidth;
            const scrollToIndex = this.isRtl
                ? Math.round(scrollLeft / itemWidth) + 1
                : Math.round(scrollLeft / itemWidth) - 1;
            this.r.setProperty(this.innerEl, 'scrollLeft', Math.round(scrollToIndex * itemWidth));
        }
    }
    /**
     * Check current state to decide whether to enable or disable arrows
     */
    checkArrowStates() {
        /* left arrow */
        this.disableLeftArrow = this.innerEl.scrollLeft === 0;
        /* right arrow */
        this.disableRightArrow = this.innerEl.scrollLeft === this.innerEl.scrollWidth - this.innerEl.offsetWidth;
    }
    /**
     * RTL
     */
    flipDirection() {
        this.isRtl = this.dir.value === 'rtl';
        setTimeout(() => {
            this.alignItems();
        }, 50);
    }
}
BentoTileRibbonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTileRibbonComponent, deps: [{ token: i0.Renderer2 }, { token: WindowRef }, { token: BentoNotification }, { token: BentoTransition }, { token: i2.Directionality }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoTileRibbonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTileRibbonComponent, selector: "bento-tile-ribbon", inputs: { title: "title", items: "items", tileAriaLabel: "tileAriaLabel", showCollapseToggle: "showCollapseToggle", tileTemplate: "tileTemplate", tileMinWidth: "tileMinWidth" }, host: { attributes: { "role": "region" }, properties: { "attr.aria-label": "this.title", "class.bento-tile-ribbon-hidden": "this.ribbonHidden", "class.bui-bento-tile-ribbon": "this.bentoTileRibbonCSSClass" } }, providers: [BentoNotification, BentoTransition, WindowRef], viewQueries: [{ propertyName: "innerElRef", first: true, predicate: ["inner"], descendants: true, static: true }, { propertyName: "panelElRef", first: true, predicate: ["panel"], descendants: true, static: true }], ngImport: i0, template: "<div\n  class=\"bento-tile-ribbon-header\"\n  [ngClass]=\"title ? 'btrh-title ' : showCollapseToggle ? 'btrh-collapse' : 'btrh-hidden'\"\n  title\n>\n  <!-- intentionally empty title -->\n  <h1 *ngIf=\"title\" class=\"bento-tile-ribbon-header-title\">{{ title }}</h1>\n  <button\n    *ngIf=\"showCollapseToggle\"\n    type=\"button\"\n    class=\"bento-tile-ribbon-visibility-toggle btn btn-link\"\n    (click)=\"toggleVisibility()\"\n  >\n    <i\n      aria-hidden=\"true\"\n      [class.bento-icon-minus-plain]=\"!this.ribbonHidden\"\n      [class.bento-icon-plus-plain]=\"this.ribbonHidden\"\n    ></i>\n    <span class=\"btn-text\">\n      {{ (ribbonHidden ? 'BENTO_UI_TILE_RIBBON_TOGGLE_SHOW' : 'BENTO_UI_TILE_RIBBON_TOGGLE_HIDE') | bentoTranslate }}\n    </span>\n  </button>\n</div>\n\n<div class=\"bento-tile-ribbon-container\" [class.hidden]=\"this.ribbonHidden\" title>\n  <!-- intentionally empty title -->\n  <button\n    class=\"bento-tile-ribbon-arrow left\"\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TILE_RIBBON_SCROLL_LEFT' | bentoTranslate\"\n    (click)=\"_onArrowClick(false)\"\n    [disabled]=\"disableLeftArrow\"\n  >\n    <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"bento-tile-ribbon-wrapper\">\n    <!--\n      dir=\"ltr\" is intentional - to overcome scrollLeft value from different\n      browsers. Set the direction to ltr, this way scrollLeft calculation'll\n      be same for all browsers\n    -->\n    <div dir=\"ltr\" class=\"bento-tile-ribbon-inner\" #inner>\n      <!-- dir=\"ltr\" is intentional -->\n      <div class=\"bento-tile-ribbon-panel\" #panel [attr.dir]=\"isRtl ? 'rtl' : 'ltr'\">\n        <bento-ribbon-tile\n          *ngFor=\"let item of items\"\n          [item]=\"item\"\n          [width]=\"itemWidth\"\n          (select)=\"_onTileSelect($event)\"\n          [template]=\"tileTemplate\"\n          [attr.aria-label]=\"tileAriaLabel ? tileAriaLabel : ('tile' | bentoTranslate)\"\n        ></bento-ribbon-tile>\n      </div>\n    </div>\n  </div>\n  <button\n    class=\"bento-tile-ribbon-arrow right\"\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TILE_RIBBON_SCROLL_RIGHT' | bentoTranslate\"\n    (click)=\"_onArrowClick(true)\"\n    [disabled]=\"disableRightArrow\"\n  >\n    <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n", styles: [".ng-bento .bui-bento-tile-ribbon{display:block;position:relative}.ng-bento .bui-bento-tile-ribbon.scroll .bento-tile-ribbon-arrow{display:block}.ng-bento .bui-bento-tile-ribbon.bento-tile-ribbon-hidden{padding:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header{align-items:center;display:flex}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header h1{display:inline-block;margin:0;padding:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-title{justify-content:space-between}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-collapse{justify-content:flex-end}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle i,.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover{text-decoration:none}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover span{text-decoration:underline}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-container{overflow:hidden;position:relative}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-container.hidden{height:0;margin-top:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-wrapper{overflow:hidden}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-inner{overflow-x:scroll;position:relative;transition:opacity .2s}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-inner:focus{outline:none}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-panel{align-items:stretch;display:flex}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile{display:block;flex-grow:1;position:relative}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile:after{background-color:transparent;bottom:0;content:\" \";display:block;height:4px;position:absolute;transition:background-color .2s}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile.selected{z-index:1}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile.selected .bento-ribbon-tile-inner{border-width:1px;border-style:solid}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-inner{border-width:1px;border-style:solid;min-height:100%;position:relative}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-value{cursor:default;flex-grow:2;font-size:39px;letter-spacing:-1px;line-height:1em;overflow:hidden;text-overflow:ellipsis;transition:color .2s;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-link{cursor:pointer;flex-shrink:4;font-size:.8em;margin-top:8px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator{flex-shrink:0;margin-right:5px}[dir=rtl] .ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator{margin-right:0;margin-left:5px}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class^=bento-icon-],.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class*=\" bento-icon-\"]{vertical-align:baseline}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-value-wrapper{align-items:flex-start;display:flex;justify-content:space-between}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-header-wrapper{align-content:flex-start;align-items:center;display:flex}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-header{cursor:default;font-size:16px;font-weight:700;letter-spacing:.5px;margin:0;overflow:hidden;padding:0;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-header:first-letter{text-transform:uppercase}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-description{cursor:default;font-size:11px;letter-spacing:.3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-arrow{border:none;display:none;font-size:1.7em;height:100%;position:absolute;top:0;z-index:2}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-arrow.left{left:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-arrow.right{right:0}.ng-bento .bui-bento-tile-ribbon.alt{border-bottom-width:0;padding:0}.ng-bento .bui-bento-tile-ribbon.alt .bento-tile-ribbon-container{margin:0}.ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile{padding:0}.ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-right-width:0}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-left-width:0;border-right-width:1px}.ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:0}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:1px;border-right-width:0}.ng-bento .bui-bento-tile-ribbon.alt .bento-tile-ribbon-header.btrh-hidden{display:none}.ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile{padding:0}.ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile:after{left:0;right:0}.ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:0}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:-1px;margin-left:0}.ng-bento .bui-bento-tile-ribbon.alt .bento-tile-ribbon-arrow{border-width:1px;border-style:solid}.ng-bento .bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:-1px}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:0;margin-left:-1px}\n"], components: [{ type: BentoRibbonTileComponent, selector: "bento-ribbon-tile", inputs: ["item", "width", "template"], outputs: ["select"] }], directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTileRibbonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tile-ribbon', providers: [BentoNotification, BentoTransition, WindowRef], encapsulation: ViewEncapsulation.None, host: { role: 'region' }, template: "<div\n  class=\"bento-tile-ribbon-header\"\n  [ngClass]=\"title ? 'btrh-title ' : showCollapseToggle ? 'btrh-collapse' : 'btrh-hidden'\"\n  title\n>\n  <!-- intentionally empty title -->\n  <h1 *ngIf=\"title\" class=\"bento-tile-ribbon-header-title\">{{ title }}</h1>\n  <button\n    *ngIf=\"showCollapseToggle\"\n    type=\"button\"\n    class=\"bento-tile-ribbon-visibility-toggle btn btn-link\"\n    (click)=\"toggleVisibility()\"\n  >\n    <i\n      aria-hidden=\"true\"\n      [class.bento-icon-minus-plain]=\"!this.ribbonHidden\"\n      [class.bento-icon-plus-plain]=\"this.ribbonHidden\"\n    ></i>\n    <span class=\"btn-text\">\n      {{ (ribbonHidden ? 'BENTO_UI_TILE_RIBBON_TOGGLE_SHOW' : 'BENTO_UI_TILE_RIBBON_TOGGLE_HIDE') | bentoTranslate }}\n    </span>\n  </button>\n</div>\n\n<div class=\"bento-tile-ribbon-container\" [class.hidden]=\"this.ribbonHidden\" title>\n  <!-- intentionally empty title -->\n  <button\n    class=\"bento-tile-ribbon-arrow left\"\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TILE_RIBBON_SCROLL_LEFT' | bentoTranslate\"\n    (click)=\"_onArrowClick(false)\"\n    [disabled]=\"disableLeftArrow\"\n  >\n    <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"bento-tile-ribbon-wrapper\">\n    <!--\n      dir=\"ltr\" is intentional - to overcome scrollLeft value from different\n      browsers. Set the direction to ltr, this way scrollLeft calculation'll\n      be same for all browsers\n    -->\n    <div dir=\"ltr\" class=\"bento-tile-ribbon-inner\" #inner>\n      <!-- dir=\"ltr\" is intentional -->\n      <div class=\"bento-tile-ribbon-panel\" #panel [attr.dir]=\"isRtl ? 'rtl' : 'ltr'\">\n        <bento-ribbon-tile\n          *ngFor=\"let item of items\"\n          [item]=\"item\"\n          [width]=\"itemWidth\"\n          (select)=\"_onTileSelect($event)\"\n          [template]=\"tileTemplate\"\n          [attr.aria-label]=\"tileAriaLabel ? tileAriaLabel : ('tile' | bentoTranslate)\"\n        ></bento-ribbon-tile>\n      </div>\n    </div>\n  </div>\n  <button\n    class=\"bento-tile-ribbon-arrow right\"\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TILE_RIBBON_SCROLL_RIGHT' | bentoTranslate\"\n    (click)=\"_onArrowClick(true)\"\n    [disabled]=\"disableRightArrow\"\n  >\n    <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n", styles: [".ng-bento .bui-bento-tile-ribbon{display:block;position:relative}.ng-bento .bui-bento-tile-ribbon.scroll .bento-tile-ribbon-arrow{display:block}.ng-bento .bui-bento-tile-ribbon.bento-tile-ribbon-hidden{padding:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header{align-items:center;display:flex}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header h1{display:inline-block;margin:0;padding:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-title{justify-content:space-between}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-collapse{justify-content:flex-end}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle i,.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover{text-decoration:none}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover span{text-decoration:underline}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-container{overflow:hidden;position:relative}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-container.hidden{height:0;margin-top:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-wrapper{overflow:hidden}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-inner{overflow-x:scroll;position:relative;transition:opacity .2s}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-inner:focus{outline:none}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-panel{align-items:stretch;display:flex}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile{display:block;flex-grow:1;position:relative}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile:after{background-color:transparent;bottom:0;content:\" \";display:block;height:4px;position:absolute;transition:background-color .2s}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile.selected{z-index:1}.ng-bento .bui-bento-tile-ribbon bento-ribbon-tile.selected .bento-ribbon-tile-inner{border-width:1px;border-style:solid}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-inner{border-width:1px;border-style:solid;min-height:100%;position:relative}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-value{cursor:default;flex-grow:2;font-size:39px;letter-spacing:-1px;line-height:1em;overflow:hidden;text-overflow:ellipsis;transition:color .2s;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-link{cursor:pointer;flex-shrink:4;font-size:.8em;margin-top:8px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator{flex-shrink:0;margin-right:5px}[dir=rtl] .ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator{margin-right:0;margin-left:5px}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class^=bento-icon-],.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class*=\" bento-icon-\"]{vertical-align:baseline}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-value-wrapper{align-items:flex-start;display:flex;justify-content:space-between}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-header-wrapper{align-content:flex-start;align-items:center;display:flex}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-header{cursor:default;font-size:16px;font-weight:700;letter-spacing:.5px;margin:0;overflow:hidden;padding:0;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-header:first-letter{text-transform:uppercase}.ng-bento .bui-bento-tile-ribbon .bento-ribbon-tile-description{cursor:default;font-size:11px;letter-spacing:.3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-arrow{border:none;display:none;font-size:1.7em;height:100%;position:absolute;top:0;z-index:2}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-arrow.left{left:0}.ng-bento .bui-bento-tile-ribbon .bento-tile-ribbon-arrow.right{right:0}.ng-bento .bui-bento-tile-ribbon.alt{border-bottom-width:0;padding:0}.ng-bento .bui-bento-tile-ribbon.alt .bento-tile-ribbon-container{margin:0}.ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile{padding:0}.ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-right-width:0}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-left-width:0;border-right-width:1px}.ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:0}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:1px;border-right-width:0}.ng-bento .bui-bento-tile-ribbon.alt .bento-tile-ribbon-header.btrh-hidden{display:none}.ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile{padding:0}.ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile:after{left:0;right:0}.ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:0}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:-1px;margin-left:0}.ng-bento .bui-bento-tile-ribbon.alt .bento-tile-ribbon-arrow{border-width:1px;border-style:solid}.ng-bento .bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:-1px}[dir=rtl] .ng-bento .bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:0;margin-left:-1px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: WindowRef }, { type: BentoNotification }, { type: BentoTransition }, { type: i2.Directionality }, { type: i0.ElementRef }]; }, propDecorators: { title: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }, {
                type: Input
            }], items: [{
                type: Input
            }], tileAriaLabel: [{
                type: Input
            }], showCollapseToggle: [{
                type: Input
            }], tileTemplate: [{
                type: Input
            }], tileMinWidth: [{
                type: Input
            }], ribbonHidden: [{
                type: HostBinding,
                args: ['class.bento-tile-ribbon-hidden']
            }], bentoTileRibbonCSSClass: [{
                type: HostBinding,
                args: ['class.bui-bento-tile-ribbon']
            }], innerElRef: [{
                type: ViewChild,
                args: ['inner', { static: true }]
            }], panelElRef: [{
                type: ViewChild,
                args: ['panel', { static: true }]
            }] } });

/**
 * Class to declare Bento Ribbon Tile object to be used with Tile Ribbon
 */
class BentoRibbonTile {
    constructor(value = '', header = '', description, onTileSelect = tile => { }, linkTitle, onLinkClick = tile => { }, indicator, selected = false, ariaLabel) {
        this.selectionCallbacks = [];
        this.deselectionCallbacks = [];
        this.value = value;
        this.header = header;
        this.description = description;
        this.selectionCallbacks.push(onTileSelect);
        this.linkTitle = linkTitle;
        this.onLinkClick = onLinkClick;
        this.indicator = indicator;
        this._selected = selected;
        this.ariaLabel = ariaLabel;
    }
    /**
     * State to indicate that if this item is selected or not
     */
    get selected() {
        return this._selected;
    }
    /**
     * Set item as selected
     */
    select() {
        if (!this._selected) {
            this._selected = true;
            this.dispatchSelectionCallbacks();
        }
    }
    /**
     * Set item as deselected
     */
    deselect() {
        if (this._selected) {
            this._selected = false;
            this.dispatchDeselectionCallbacks();
        }
    }
    /**
     * Add a selection callback.  The returned function is used to remove the current callback
     */
    addSelectionCallback(c) {
        this.selectionCallbacks.push(c);
        return () => {
            // Callback to remove the assigned one
            const i = this.selectionCallbacks.indexOf(c);
            this.selectionCallbacks.splice(i, 1);
        };
    }
    /**
     * Add a deselection callback.  The returned function is used to remove the current callback
     */
    addDeselectionCallback(c) {
        this.deselectionCallbacks.push(c);
        return () => {
            // Callback to remove the assigned one
            const i = this.deselectionCallbacks.indexOf(c);
            this.deselectionCallbacks.splice(i, 1);
        };
    }
    /**
     * Dispatch selection callbacks
     */
    dispatchSelectionCallbacks() {
        for (const c of this.selectionCallbacks) {
            c(this);
        }
    }
    /**
     * Dispatch deselection callbacks
     */
    dispatchDeselectionCallbacks() {
        for (const c of this.deselectionCallbacks) {
            c(this);
        }
    }
}
/**
 * Success state of the indicator
 */
BentoRibbonTile.SUCCESS = { icon: 'bento-icon-save-solid', class: 'bento-tile-success', i18nLabel: 'BENTO_UI_TILE_SUCCESS' };
/**
 * Info state of the indicator
 */
BentoRibbonTile.INFO = { icon: 'bento-icon-info-filled', class: 'bento-tile-info', i18nLabel: 'BENTO_UI_TILE_INFO' };
/**
 * Danger state of the indicator
 */
BentoRibbonTile.DANGER = { icon: 'bento-icon-danger-filled', class: 'bento-tile-danger', i18nLabel: 'BENTO_UI_TILE_DANGER' };
/**
 * Warning state of the indicator
 */
BentoRibbonTile.WARNING = { icon: 'bento-icon-warning-filled', class: 'bento-tile-warning', i18nLabel: 'BENTO_UI_TILE_WARNING' };

class BentoTileRibbonModule extends ConsumerDataValidator {
}
BentoTileRibbonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTileRibbonModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTileRibbonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTileRibbonModule, declarations: [BentoTileRibbonComponent, BentoRibbonTileComponent], imports: [CommonModule, BentoTranslateModule], exports: [BentoTileRibbonComponent] });
BentoTileRibbonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTileRibbonModule, imports: [[CommonModule, BentoTranslateModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTileRibbonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, BentoTranslateModule],
                    declarations: [BentoTileRibbonComponent, BentoRibbonTileComponent],
                    exports: [BentoTileRibbonComponent]
                }]
        }] });

/* eslint-disable  @angular-eslint/directive-selector */
class BentoTimepickerDirective {
    constructor(elRef, r, timepicker, direction, translate, _focusMonitor, _cdr, _ngZone) {
        this.r = r;
        this.timepicker = timepicker;
        this.translate = translate;
        this._focusMonitor = _focusMonitor;
        this._cdr = _cdr;
        this._ngZone = _ngZone;
        this.directionSubscription = Subscription.EMPTY;
        this.translationChangeSubscription = Subscription.EMPTY;
        this.hourSubscription = Subscription.EMPTY;
        this.minuteSubscription = Subscription.EMPTY;
        this.meridianSubscription = Subscription.EMPTY;
        const oldNgOnChanges = this.timepicker.ngOnChanges;
        const oldSetDisabledState = this.timepicker.setDisabledState;
        this.el = elRef.nativeElement;
        this.isRTL = direction.value === 'rtl';
        this.directionSubscription = direction.change.subscribe(() => {
            this.isRTL = direction.value === 'rtl';
        });
        // Add Bento.UI main component class
        r.addClass(this.el, 'bento-timepicker');
        /**
         * Override `onOnChanges`
         */
        this.timepicker.ngOnChanges = (changes) => {
            oldNgOnChanges.call(this.timepicker, changes);
            if (changes.meridian) {
                setTimeout(() => this.setupMeridianButton(changes.meridian.currentValue));
            }
            if (changes.seconds) {
                setTimeout(() => this.setupSecondInput(changes.seconds.currentValue));
            }
        };
        /**
         * Override `setDisabledState`
         */
        this.timepicker.setDisabledState = isDisabled => {
            oldSetDisabledState.call(this.timepicker, isDisabled);
            if (isDisabled) {
                this.r.addClass(this.el, 'disabled');
            }
            else {
                this.r.removeClass(this.el, 'disabled');
            }
        };
    }
    /**
     * NG OnInit lifecycle hook
     */
    ngOnInit() {
        // hide spinners
        this.timepicker.spinners = false;
    }
    /**
     * Implements after view init
     */
    ngAfterViewInit() {
        this.hourEl = this.el.querySelector('.ngb-tp-hour input');
        this.minuteEl = this.el.querySelector('.ngb-tp-minute input');
        this.meridianButton = this.el.querySelector('.ngb-tp-meridian .btn');
        this.fs = this.el.querySelector('fieldset');
        // A11y: attach a legendEl inside fieldset
        this.legendEl = this.r.createElement('legend');
        this.r.addClass(this.legendEl, 'sr-only');
        this.r.setProperty(this.legendEl, 'innerText', this.translate.instantTranslate('BENTO_UI_TIMEPICKER_LEGEND'));
        this.r.insertBefore(this.fs, this.legendEl, this.fs.firstChild);
        // We need fieldset to be focusable
        this.r.setAttribute(this.fs, 'tabindex', '-1');
        this.setupHourInput();
        this.setupMinuteInput();
        this.translationChangeSubscription = this.translate.translationChange.subscribe(() => this.r.setProperty(this.legendEl, 'innerText', this.translate.instantTranslate('BENTO_UI_TIMEPICKER_LEGEND')));
        this.hourSubscription = this._focusMonitor.monitor(this.hourEl).subscribe(() => this.runInAngularZone());
        this.minuteSubscription = this._focusMonitor.monitor(this.minuteEl).subscribe(() => this.runInAngularZone());
    }
    /**
     * Remove listeners
     */
    ngOnDestroy() {
        // Cancel all listeners
        this.cancelHourInputListener();
        this.cancelMinuteInputListener();
        this.directionSubscription.unsubscribe();
        if (this.cancelSecondInputListener) {
            this.cancelSecondInputListener();
        }
        if (this.cancelMeridianListener) {
            this.cancelMeridianListener();
            this._focusMonitor.stopMonitoring(this.meridianButton);
            this.meridianSubscription.unsubscribe();
        }
        this.translationChangeSubscription.unsubscribe();
        this._focusMonitor.stopMonitoring(this.hourEl);
        this._focusMonitor.stopMonitoring(this.minuteEl);
        this.hourSubscription.unsubscribe();
        this.minuteSubscription.unsubscribe();
    }
    /**
     * Handle blur event
     */
    onHostFocusout(relatedTarget) {
        if (!this.el.contains(relatedTarget)) {
            this.r.removeClass(this.el, 'has-focus');
        }
    }
    /**
     * Setup hour input field
     */
    setupHourInput() {
        this.cancelHourInputListener = this.r.listen(this.hourEl, 'keydown', e => {
            const RIGHT = Keyboard.RIGHT;
            const LEFT = Keyboard.LEFT;
            switch (e.keyCode) {
                case RIGHT:
                    // eslint-disable-next-line  no-bitwise
                    if ((this.hourEl.selectionStart & this.hourEl.selectionEnd) === 2) {
                        this.minuteEl.focus();
                        this.minuteEl.setSelectionRange(0, 2);
                        e.preventDefault();
                    }
                    break;
                case LEFT:
                    // Only happens in RTL
                    // eslint-disable-next-line  no-bitwise
                    if (this.isRTL && (this.minuteEl.selectionStart | this.minuteEl.selectionEnd) === 0 && this.meridianButton) {
                        this.meridianButton.focus();
                    }
                    break;
                default:
                    break;
            }
        });
    }
    /**
     * Setup minute input field
     */
    setupMinuteInput() {
        this.cancelMinuteInputListener = this.r.listen(this.minuteEl, 'keydown', e => {
            const LEFT = Keyboard.LEFT;
            const RIGHT = Keyboard.RIGHT;
            switch (e.keyCode) {
                case LEFT:
                    // eslint-disable-next-line  no-bitwise
                    if ((this.minuteEl.selectionStart | this.minuteEl.selectionEnd) === 0) {
                        this.hourEl.focus();
                        this.hourEl.setSelectionRange(0, 2);
                        e.preventDefault();
                    }
                    break;
                case RIGHT:
                    // eslint-disable-next-line  no-bitwise
                    if ((this.minuteEl.selectionStart & this.minuteEl.selectionEnd) === 2) {
                        if (this.secondEl) {
                            this.secondEl.focus();
                            this.secondEl.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        else if (this.meridianButton) {
                            this.meridianButton.focus();
                        }
                    }
                    break;
                default:
                    break;
            }
        });
    }
    /**
     * Setup second button based on its time
     */
    setupSecondInput(show) {
        if (show) {
            this.secondEl = this.el.querySelector('.ngb-tp-second input');
            if (!this.timepicker.model.second) {
                this.timepicker.updateSecond('00');
            }
            this.cancelSecondInputListener = this.r.listen(this.secondEl, 'keydown', e => {
                const LEFT = Keyboard.LEFT;
                const RIGHT = Keyboard.RIGHT;
                switch (e.keyCode) {
                    case LEFT:
                        // Focus to the "left" input field
                        // eslint-disable-next-line  no-bitwise
                        if ((this.secondEl.selectionStart | this.secondEl.selectionEnd) === 0) {
                            this.minuteEl.focus();
                            this.minuteEl.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        break;
                    case RIGHT:
                        if (!this.isRTL && this.meridianButton) {
                            // Only focus on meridian button in LTR mode
                            this.meridianButton.focus();
                        }
                        break;
                    default:
                        break;
                }
            });
        }
        else {
            this.cancelSecondInputListener();
            this.cancelSecondInputListener = undefined;
            this.secondEl = undefined;
        }
    }
    /**
     * Setup meridian button based on its showing flag
     */
    setupMeridianButton(show) {
        if (show) {
            this.meridianButton = this.el.querySelector('.ngb-tp-meridian .btn');
            this._focusMonitor.stopMonitoring(this.meridianButton);
            this.meridianSubscription.unsubscribe();
            this.meridianSubscription = this._focusMonitor.monitor(this.meridianButton).subscribe(() => this.runInAngularZone());
            this.cancelMeridianListener = this.r.listen(this.meridianButton, 'keydown', e => {
                const LEFT = Keyboard.LEFT;
                const RIGHT = Keyboard.RIGHT;
                switch (e.keyCode) {
                    case Keyboard.UP:
                    case Keyboard.DOWN:
                        // Toggle meridian button when up or down key is pressed
                        this.meridianButton.click();
                        e.preventDefault();
                        break;
                    case LEFT:
                        if (!this.isRTL) {
                            // Can only move focus to the left input in LTR mode
                            // Focus to the "left" input field
                            const input = this.secondEl ? this.secondEl : this.minuteEl;
                            input.focus();
                            input.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        break;
                    case RIGHT:
                        if (this.isRTL) {
                            // Can only move focus to the left input in LTR mode
                            // Focus to the "hour" input field
                            this.hourEl.focus();
                            this.hourEl.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        break;
                    default:
                        break;
                }
            });
        }
        else {
            this.cancelMeridianListener();
            this.cancelMeridianListener = undefined;
            this._focusMonitor.stopMonitoring(this.meridianButton);
            this.meridianSubscription.unsubscribe();
            this.meridianButton = undefined;
        }
    }
    /**
     * FocusMonitor emits on the observable outside of the Angular zone so this puts it back in the Angular zone
     */
    runInAngularZone() {
        this._ngZone.run(() => {
            this._cdr.markForCheck();
        });
    }
}
BentoTimepickerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTimepickerDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: NgbTimepicker }, { token: i2.Directionality }, { token: BentoTranslate }, { token: i3.FocusMonitor }, { token: i0.ChangeDetectorRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
BentoTimepickerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoTimepickerDirective, selector: "ngb-timepicker[bentoTimepicker]", host: { listeners: { "focusout": "onHostFocusout($event.relatedTarget)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTimepickerDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'ngb-timepicker[bentoTimepicker]' }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$1.NgbTimepicker, decorators: [{
                        type: Inject,
                        args: [NgbTimepicker]
                    }] }, { type: i2.Directionality }, { type: BentoTranslate }, { type: i3.FocusMonitor }, { type: i0.ChangeDetectorRef }, { type: i0.NgZone }];
    }, propDecorators: { onHostFocusout: [{
                type: HostListener,
                args: ['focusout', ['$event.relatedTarget']]
            }] } });

class BentoTimepickerModule extends ConsumerDataValidator {
}
BentoTimepickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTimepickerModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTimepickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTimepickerModule, declarations: [BentoTimepickerDirective], imports: [CommonModule, BentoFocusMonitorModule], exports: [BentoTimepickerDirective] });
BentoTimepickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTimepickerModule, imports: [[CommonModule, BentoFocusMonitorModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTimepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, BentoFocusMonitorModule],
                    declarations: [BentoTimepickerDirective],
                    exports: [BentoTimepickerDirective]
                }]
        }] });

class BentoToastAnimationDirective {
    constructor(elRef, r) {
        setTimeout(() => {
            r.addClass(elRef.nativeElement, 'in');
        }, 18);
    }
}
BentoToastAnimationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastAnimationDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
BentoToastAnimationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoToastAnimationDirective, selector: "[toastAnimation]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastAnimationDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[toastAnimation]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

/**
 * Container that is compiled and append as one of the child from the BODY tag
 */
class BentoToastContainerComponent {
    constructor(changeDetector, r, elRef) {
        this.changeDetector = changeDetector;
        this.r = r;
        this.toasts = [];
        this.el = elRef.nativeElement;
    }
    refresh() {
        this.changeDetector.markForCheck();
    }
    ngOnDestroy() {
        while (this.toasts && this.toasts.length) {
            this.toasts.pop().dismiss();
        }
        this.toasts = null;
    }
    set placement(p) {
        this.toastPlacement = p;
        this.r.removeAttribute(this.el, 'class');
        if (p) {
            this.r.addClass(this.el, this.toastPlacement);
        }
    }
    get placement() {
        return this.toastPlacement;
    }
    /**
     * Dismiss a toast
     */
    dismiss(toast, byAction = false) {
        if (this.toasts) {
            const index = this.toasts.indexOf(toast);
            if (index > -1) {
                this.toasts.splice(index, 1);
                if (byAction) {
                    toast.dismissByAction();
                }
                else {
                    toast.dismiss();
                }
            }
        }
    }
}
BentoToastContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastContainerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoToastContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoToastContainerComponent, selector: "bento-toast-container", ngImport: i0, template: "<div class=\"bento-toast-container-inner\" aria-live=\"polite\" aria-atomic=\"true\">\n  <ngb-toast\n    cdkTrapFocus=\"false\"\n    [cdkTrapFocusAutoCapture]=\"true\"\n    toastAnimation\n    *ngFor=\"let toast of toasts\"\n    [autohide]=\"toast.instance.config.duration !== 0\"\n    [delay]=\"toast.instance.config.duration || 5000\"\n    [ngClass]=\"'bento-toast-' + (toast.instance.config.type ? toast.instance.config.type : 'default')\"\n    (hidden)=\"dismiss(toast)\"\n  >\n    <div *ngIf=\"toast.instance.config.template; else defaultMessage\">\n      <ng-container *ngTemplateOutlet=\"toast.instance.config.template; context: {toast: toast.instance}\"></ng-container>\n    </div>\n    <ng-template #defaultMessage>\n      <span [innerHTML]=\"toast.instance.message\"></span>\n    </ng-template>\n    <button\n      *ngIf=\"toast.instance.hasAction\"\n      class=\"bento-toast-action-btn\"\n      type=\"button\"\n      [ngClass]=\"'btn btn-outline-' + (toast.instance.config.type ? toast.instance.config.type : 'primary')\"\n      (click)=\"dismiss(toast, true)\"\n      cdkFocusInitial\n    >\n      <span class=\"btn-text\">{{ toast.instance.config.action }}</span>\n    </button>\n    <button\n      *ngIf=\"toast.instance.showClose\"\n      type=\"button\"\n      cdkMonitorElementFocus\n      class=\"close\"\n      (click)=\"dismiss(toast)\"\n      [attr.aria-label]=\"'BENTO_UI_TOAST_CLOSE_BUTTON' | bentoTranslate\"\n      cdkFocusInitial\n    >\n      <i class=\"bui-toast-close-indicator\" aria-hidden=\"true\"></i>\n    </button>\n  </ngb-toast>\n</div>\n", styles: [":host{display:block;position:fixed}:host button.close{align-items:center;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;text-align:center;text-shadow:none;width:24px}:host button.close i{font-family:bento-icons;font-style:normal;top:0}\n"], components: [{ type: i1$1.NgbToast, selector: "ngb-toast", inputs: ["animation", "delay", "autohide", "header"], outputs: ["shown", "hidden"], exportAs: ["ngbToast"] }], directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { type: BentoToastAnimationDirective, selector: "[toastAnimation]" }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-toast-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bento-toast-container-inner\" aria-live=\"polite\" aria-atomic=\"true\">\n  <ngb-toast\n    cdkTrapFocus=\"false\"\n    [cdkTrapFocusAutoCapture]=\"true\"\n    toastAnimation\n    *ngFor=\"let toast of toasts\"\n    [autohide]=\"toast.instance.config.duration !== 0\"\n    [delay]=\"toast.instance.config.duration || 5000\"\n    [ngClass]=\"'bento-toast-' + (toast.instance.config.type ? toast.instance.config.type : 'default')\"\n    (hidden)=\"dismiss(toast)\"\n  >\n    <div *ngIf=\"toast.instance.config.template; else defaultMessage\">\n      <ng-container *ngTemplateOutlet=\"toast.instance.config.template; context: {toast: toast.instance}\"></ng-container>\n    </div>\n    <ng-template #defaultMessage>\n      <span [innerHTML]=\"toast.instance.message\"></span>\n    </ng-template>\n    <button\n      *ngIf=\"toast.instance.hasAction\"\n      class=\"bento-toast-action-btn\"\n      type=\"button\"\n      [ngClass]=\"'btn btn-outline-' + (toast.instance.config.type ? toast.instance.config.type : 'primary')\"\n      (click)=\"dismiss(toast, true)\"\n      cdkFocusInitial\n    >\n      <span class=\"btn-text\">{{ toast.instance.config.action }}</span>\n    </button>\n    <button\n      *ngIf=\"toast.instance.showClose\"\n      type=\"button\"\n      cdkMonitorElementFocus\n      class=\"close\"\n      (click)=\"dismiss(toast)\"\n      [attr.aria-label]=\"'BENTO_UI_TOAST_CLOSE_BUTTON' | bentoTranslate\"\n      cdkFocusInitial\n    >\n      <i class=\"bui-toast-close-indicator\" aria-hidden=\"true\"></i>\n    </button>\n  </ngb-toast>\n</div>\n", styles: [":host{display:block;position:fixed}:host button.close{align-items:center;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;text-align:center;text-shadow:none;width:24px}:host button.close i{font-family:bento-icons;font-style:normal;top:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

/**
 * Toast data class
 */
class BentoToast {
    constructor(message, config = {}) {
        this.message = message;
        this.config = config;
        this.hasAction = config.action && config.action.length > 0;
        this.showClose = !this.hasAction && ((config.duration <= 0 && config.close == null) || config.close);
    }
}

/**
 * Reference to a BentoToast dispatched from the Bento Toast service
 */
class BentoToastRef {
    constructor(instance) {
        this.instance = instance;
        this.afterDismissed = Observable.create(observer => (this.afterDismissedSubscriber = observer));
        this.afterOpened = new BehaviorSubject(undefined);
        this.onAction = Observable.create(observer => (this.onActionSubscriber = observer));
    }
    /**
     * Marks the dismissal of the toast
     */
    dismiss() {
        if (this.afterDismissedSubscriber) {
            this.afterDismissedSubscriber.next({ dismissedByAction: false });
        }
    }
    /**
     * Marks the dismissal of the toast with the action button
     */
    dismissByAction() {
        if (this.onActionSubscriber) {
            this.onActionSubscriber.next();
        }
        if (this.afterDismissedSubscriber) {
            this.afterDismissedSubscriber.next({ dismissedByAction: true });
        }
    }
}

class BentoToastService {
    constructor(injector, factoryResolver, appRef, winRef) {
        this.injector = injector;
        this.factoryResolver = factoryResolver;
        this.appRef = appRef;
        this._multiple = false;
        // Create and inject `bento-toast-container` component into the `<body>` tag
        this.document = winRef.nativeDocument;
        // Only create container once to avoid memory leak
        const containerFactory = this.factoryResolver.resolveComponentFactory(BentoToastContainerComponent);
        const toastContainerRef = containerFactory.create(this.injector);
        this.appRef.attachView(toastContainerRef.hostView);
        this.document.body.appendChild(toastContainerRef.location.nativeElement);
        this.toastContainer = toastContainerRef.instance;
    }
    /**
     * Flag to determine if we show multiple Toast UI components at a time
     */
    set multiple(v) {
        if (this._multiple !== v) {
            this._multiple = v;
            if (!v && this.toastContainer.toasts.length > 1) {
                this.toastContainer.toasts = [this.toastContainer.toasts[0]];
            }
            this.toastContainer.refresh();
        }
    }
    get multiple() {
        return this._multiple;
    }
    /**
     * This preferred placement of Toast components
     *
     * Possible values are:
     *
     * `"top"`, `"bottom"`, `"start"`, `"end"`, `"top-start"`, `"top-end"`, `"bottom-start"`, `"bottom-end"`
     */
    set placement(p) {
        this.toastContainer.placement = p;
    }
    get placement() {
        return this.toastContainer.placement;
    }
    ngOnDestroy() {
        this.document.body.removeChild(this.toastContainer.el);
        this.toastContainer.ngOnDestroy();
    }
    /**
     * Open a new toast
     *
     * `message` can be either in plain text or html.  Javascript and misc scripts will be automatically filterred
     */
    open(message, config) {
        const toast = new BentoToast(message, config);
        const toastRef = new BentoToastRef(toast);
        toast.toastRef = toastRef;
        if (this.multiple) {
            this.toastContainer.toasts.push(toastRef);
        }
        else {
            this.dismissAll();
            this.toastContainer.toasts = [toastRef];
        }
        this.toastContainer.refresh();
        setTimeout(() => {
            const toastElArr = this.toastContainer.el.querySelectorAll('ngb-toast');
            const lastToastEl = toastElArr.item(toastElArr.length - 1);
            if (lastToastEl) {
                lastToastEl.focus();
            }
        });
        return toastRef;
    }
    /**
     * Dismiss a given toast by its reference
     *
     * All toasts will be dismissed if none is provided in `multiple` mode
     */
    dismiss(toastRef) {
        if (toastRef) {
            toastRef.dismiss();
            const toasts = this.toastContainer.toasts;
            const index = toasts.indexOf(toastRef);
            if (index > -1) {
                toasts.splice(index, 1);
            }
        }
        else {
            this.dismissAll();
            this.toastContainer.toasts = [];
        }
        this.toastContainer.refresh();
    }
    /**
     * Mark all current toasts as dismiss
     */
    dismissAll() {
        if (Array.isArray(this.toastContainer.toasts) && this.toastContainer.toasts.length) {
            for (const oldToastRef of this.toastContainer.toasts) {
                // Need to fire dimiss events before disgarding them
                oldToastRef.dismiss();
            }
        }
    }
}
BentoToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastService, deps: [{ token: i0.Injector }, { token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Injectable });
BentoToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: WindowRef }]; } });

class BentoToastModule extends ConsumerDataValidator {
    constructor(toastConfig) {
        super();
        toastConfig.animation = false;
    }
}
BentoToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastModule, deps: [{ token: i1$1.NgbToastConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastModule, declarations: [BentoToastContainerComponent, BentoToastAnimationDirective], imports: [CommonModule, BentoTranslateModule, A11yModule, NgbToastModule, BentoFocusMonitorModule], exports: [BentoToastContainerComponent] });
BentoToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastModule, providers: [BentoToastService, WindowRef], imports: [[CommonModule, BentoTranslateModule, A11yModule, NgbToastModule, BentoFocusMonitorModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoToastContainerComponent, BentoToastAnimationDirective],
                    imports: [CommonModule, BentoTranslateModule, A11yModule, NgbToastModule, BentoFocusMonitorModule],
                    exports: [BentoToastContainerComponent],
                    providers: [BentoToastService, WindowRef]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbToastConfig }]; } });

class BentoToggleConfig {
    /**
     * Flag to show On/Off labels globally
     */
    get showLabels() {
        return BentoToggleConfig._showLabels;
    }
    set showLabels(v) {
        const vType = typeof v;
        if (vType === 'boolean' && v !== BentoToggleConfig._showLabels) {
            BentoToggleConfig._showLabels = v;
            this.showLabelsChange.emit(v);
        }
        else {
            throw new Error(`BentoToggleConfig: Invalid type ${vType}, must be \`boolean\``);
        }
    }
    /**
     * Event emitter when variable `showLabels` changes
     */
    get showLabelsChange() {
        if (BentoToggleConfig._onChange == null) {
            BentoToggleConfig._onChange = new EventEmitter();
        }
        return BentoToggleConfig._onChange;
    }
}
/**
 * Flag to determine whether to show labels
 */
BentoToggleConfig._showLabels = false;
/**
 * Event emitter when `showLabels` variable changes
 */
BentoToggleConfig._onChange = null;
BentoToggleConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BentoToggleConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleConfig, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const BENTO_TOGGLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BentoToggleComponent),
    multi: true
};
/**
 * A toggle component to switch between two states of a variable.
 */
class BentoToggleComponent {
    constructor(elementRef, r, focusMonitor, changeDetector, pointerService, config, windowRef) {
        this.elementRef = elementRef;
        this.r = r;
        this.focusMonitor = focusMonitor;
        this.changeDetector = changeDetector;
        this.pointerService = pointerService;
        this.config = config;
        /**
         * Flag to lock the current state
         */
        this.readOnly = false;
        this.disabled = false;
        this.tabindex = '0';
        // The internal data model
        this._value = false;
        this.showLabelChangeSub = Subscription.EMPTY;
        this.nobMoveListenerCancel = () => { };
        this.nobUpListenerCancel = () => { };
        this.dirChangeSub = Subscription.EMPTY;
        this.el = elementRef.nativeElement;
        r.addClass(this.el, 'bento-toggle');
        r.addClass(this.el, 'bui-menu-item');
        r.setAttribute(this.el, 'role', 'switch');
        focusMonitor.monitor(elementRef);
        this.document = windowRef.nativeDocument;
        this._onTouchedCallback = () => { };
        this._onChangeCallback = (_) => { };
    }
    ngOnInit() {
        if (typeof this.showLabels !== 'boolean') {
            // Only use global config when `showLabels` input is not
            // manually set for this instance
            this.showLabels = this.config.showLabels;
            this.showLabelChangeSub = this.config.showLabelsChange.subscribe(v => {
                this.showLabels = v;
                this.changeDetector.markForCheck();
            });
        }
        this.initNob();
    }
    /**
     * Implements ControlValueAccessor
     */
    registerOnChange(fn) {
        this._onChangeCallback = fn;
    }
    /**
     * From ControlValueAccessor interface
     */
    registerOnTouched(fn) {
        this._onTouchedCallback = () => {
            fn();
            this.changeDetector.markForCheck();
        };
    }
    /**
     * NgModel setter
     */
    writeValue(v) {
        this._value = v;
        this.changeDetector.markForCheck();
    }
    /**
     * Set Disabled state for ngModel
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.tabindex = isDisabled ? '-1' : '0';
        this.changeDetector.markForCheck();
    }
    set value(v) {
        this._value = v;
        this.changeDetector.markForCheck();
    }
    get value() {
        return this._value;
    }
    /**
     * On Use Keyboard down
     */
    onKeydown(e) {
        if (e.keyCode === Keyboard.ENTER || e.keyCode === Keyboard.SPACE) {
            this.toggle(e);
        }
    }
    /**
     * When an user clicks the toggle
     */
    _onToggleClick(e) {
        if (!this.isMoved) {
            this.toggle(e);
        }
        else {
            // The whole click event is finished
            // reset private flag
            this.isMoved = false;
        }
    }
    /**
     * When an user touches the toggle
     */
    _onToggleTouchStart(e) {
        if (!this.isMoved) {
            this.toggle(e);
        }
    }
    /**
     * When user leaves this component
     */
    _onToggleFocusout() {
        setTimeout(() => {
            if (!this.el.contains(this.document.activeElement)) {
                this._onTouchedCallback();
            }
        });
    }
    ngAfterViewInit() {
        const cbEl = this.el.querySelector('input[type="checkbox"]');
        // Move id to the checkbox element
        if (this.el.hasAttribute('id')) {
            this.r.setAttribute(cbEl, 'id', this.el.getAttribute('id'));
            this.el.removeAttribute('id');
        }
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.elementRef);
        this.showLabelChangeSub.unsubscribe();
        this.dirChangeSub.unsubscribe();
        this.changeDetector.detach();
    }
    onCheckboxChange(value) {
        this.value = value;
        if (!this.disabled) {
            this.el.focus();
        }
    }
    onCheckboxClick(e) {
        if (this.readOnly || this.disabled || this.lockToState === this._value) {
            // prevent label clicking or direct component toggling when either
            // readonly, disabled or its value is at the locked state
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }
    /**
     * Initialize nob interaction
     */
    initNob() {
        this.nobEl = this.el.querySelector('.bento-toggle-nob');
        this.pointerService.listenPointerDown(this.r, this.nobEl, this.onNobDown.bind(this));
    }
    /**
     * Listener when Nob is down
     */
    onNobDown(e) {
        this.isMoved = false;
        this.r.addClass(this.el, 'dragging');
        this.nobIsOnLeft = this.nobEl.offsetLeft <= 0;
        const elRect = this.el.getBoundingClientRect();
        this.elMidPoint = (elRect.right + elRect.left) * 0.5;
        this.nobMoveListenerCancel = this.pointerService.listenPointerMove(this.r, 'document', this.onNobMove.bind(this));
        this.nobUpListenerCancel = this.pointerService.listenPointerUp(this.r, 'document', this.onNobUp.bind(this));
    }
    onNobUp(e) {
        this.r.removeClass(this.el, 'dragging');
        this.nobMoveListenerCancel();
        this.nobUpListenerCancel();
    }
    onNobMove(e) {
        const pointerX = this.pointerService.getPointerXY(e).x;
        if ((this.nobIsOnLeft && pointerX > this.elMidPoint) || (!this.nobIsOnLeft && pointerX < this.elMidPoint)) {
            this.nobIsOnLeft = !this.nobIsOnLeft;
            this.toggle(e);
            setTimeout(() => {
                // need to get the midpoint after rendering
                // in case the user is still dragging
                const elRect = this.el.getBoundingClientRect();
                this.elMidPoint = (elRect.right + elRect.left) * 0.5;
            });
        }
        this.isMoved = true;
        e.preventDefault();
        e.stopPropagation();
    }
    /**
     * The actual toggle method that takes an either click or touch event
     */
    toggle(e) {
        if (this.readOnly || this.lockToState === this._value || this.disabled) {
            return;
        }
        const v = !this._value;
        this.writeValue(v);
        this._onChangeCallback(v);
        e.preventDefault();
        e.stopPropagation();
    }
}
BentoToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i3.FocusMonitor }, { token: i0.ChangeDetectorRef }, { token: BentoPointerService }, { token: BentoToggleConfig }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Component });
BentoToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoToggleComponent, selector: "bento-toggle", inputs: { readOnly: "readOnly", lockToState: "lockToState", showLabels: "showLabels" }, host: { listeners: { "keydown": "onKeydown($event)", "click": "_onToggleClick($event)", "touchstart": "_onToggleTouchStart($event)", "focusout": "_onToggleFocusout()" }, properties: { "class.readonly": "this.readOnly", "attr.aria-readonly": "this.readOnly", "class.disabled": "this.disabled", "attr.aria-disabled": "this.disabled", "attr.tabindex": "this.tabindex", "class.bento-toggle-show-labels": "this.showLabels", "class.on": "this.value", "attr.aria-checked": "this.value" } }, providers: [BENTO_TOGGLE_VALUE_ACCESSOR], ngImport: i0, template: "<div class=\"bento-toggle-nob\">\n  <i\n    role=\"img\"\n    [ngClass]=\"value ? 'toggle-on' : 'toggle-off'\"\n    class=\"bento-toggle-nob-icon bento-toggle-a11y-labels\"\n    [attr.aria-label]=\"value ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n  ></i>\n</div>\n<input\n  aria-hidden=\"true\"\n  [ngModel]=\"value\"\n  (ngModelChange)=\"onCheckboxChange($event)\"\n  tabindex=\"-1\"\n  type=\"checkbox\"\n  [disabled]=\"disabled\"\n  (click)=\"onCheckboxClick($event)\"\n/>\n", styles: [".ng-bento bento-toggle,.ng-bento bento-toggle.dropdown-item{border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-block;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:border-color .1s,box-shadow .3s,background-color .2s;vertical-align:middle}.ng-bento bento-toggle input[type=checkbox],.ng-bento bento-toggle.dropdown-item input[type=checkbox]{width:1px;height:1px;opacity:0;pointer-events:none}.ng-bento bento-toggle .bento-toggle-nob,.ng-bento bento-toggle.dropdown-item .bento-toggle-nob{border-width:1px;border-style:solid;left:-1px;position:absolute;top:-1px;transition:all .2s}.ng-bento bento-toggle .bento-toggle-nob .bento-toggle-nob-icon,.ng-bento bento-toggle.dropdown-item .bento-toggle-nob .bento-toggle-nob-icon{width:12px;height:12px;position:relative;top:5px;left:5px}[dir=rtl] .ng-bento bento-toggle .bento-toggle-nob,[dir=rtl] .ng-bento bento-toggle.dropdown-item .bento-toggle-nob{left:auto;right:-1px}[dir=rtl] .ng-bento bento-toggle .bento-toggle-nob .bento-toggle-nob-icon,[dir=rtl] .ng-bento bento-toggle.dropdown-item .bento-toggle-nob .bento-toggle-nob-icon{right:5px}.ng-bento bento-toggle.on,.ng-bento bento-toggle.dropdown-item.on{transition:border-color .1s .2s,box-shadow .1s,background-color .5s .2s}[dir=rtl] .ng-bento bento-toggle.on .bento-toggle-nob,[dir=rtl] .ng-bento bento-toggle.dropdown-item.on .bento-toggle-nob{left:auto}.ng-bento bento-toggle:focus,.ng-bento bento-toggle.dropdown-item:focus{outline:none}.ng-bento bento-toggle.readonly,.ng-bento bento-toggle.disabled,.ng-bento bento-toggle.dropdown-item.readonly,.ng-bento bento-toggle.dropdown-item.disabled{cursor:default;opacity:.8;pointer-events:none}.ng-bento bento-toggle.disabled,.ng-bento bento-toggle.dropdown-item.disabled{opacity:.5}.ng-bento .bento-toggle-a11y-labels{display:none}.bento-toggle-show-labels .ng-bento .bento-toggle-a11y-labels{display:block}\n"], directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-toggle', providers: [BENTO_TOGGLE_VALUE_ACCESSOR], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bento-toggle-nob\">\n  <i\n    role=\"img\"\n    [ngClass]=\"value ? 'toggle-on' : 'toggle-off'\"\n    class=\"bento-toggle-nob-icon bento-toggle-a11y-labels\"\n    [attr.aria-label]=\"value ? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)\"\n  ></i>\n</div>\n<input\n  aria-hidden=\"true\"\n  [ngModel]=\"value\"\n  (ngModelChange)=\"onCheckboxChange($event)\"\n  tabindex=\"-1\"\n  type=\"checkbox\"\n  [disabled]=\"disabled\"\n  (click)=\"onCheckboxClick($event)\"\n/>\n", styles: [".ng-bento bento-toggle,.ng-bento bento-toggle.dropdown-item{border-style:solid;border-width:1px;box-sizing:border-box;cursor:pointer;display:inline-block;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:border-color .1s,box-shadow .3s,background-color .2s;vertical-align:middle}.ng-bento bento-toggle input[type=checkbox],.ng-bento bento-toggle.dropdown-item input[type=checkbox]{width:1px;height:1px;opacity:0;pointer-events:none}.ng-bento bento-toggle .bento-toggle-nob,.ng-bento bento-toggle.dropdown-item .bento-toggle-nob{border-width:1px;border-style:solid;left:-1px;position:absolute;top:-1px;transition:all .2s}.ng-bento bento-toggle .bento-toggle-nob .bento-toggle-nob-icon,.ng-bento bento-toggle.dropdown-item .bento-toggle-nob .bento-toggle-nob-icon{width:12px;height:12px;position:relative;top:5px;left:5px}[dir=rtl] .ng-bento bento-toggle .bento-toggle-nob,[dir=rtl] .ng-bento bento-toggle.dropdown-item .bento-toggle-nob{left:auto;right:-1px}[dir=rtl] .ng-bento bento-toggle .bento-toggle-nob .bento-toggle-nob-icon,[dir=rtl] .ng-bento bento-toggle.dropdown-item .bento-toggle-nob .bento-toggle-nob-icon{right:5px}.ng-bento bento-toggle.on,.ng-bento bento-toggle.dropdown-item.on{transition:border-color .1s .2s,box-shadow .1s,background-color .5s .2s}[dir=rtl] .ng-bento bento-toggle.on .bento-toggle-nob,[dir=rtl] .ng-bento bento-toggle.dropdown-item.on .bento-toggle-nob{left:auto}.ng-bento bento-toggle:focus,.ng-bento bento-toggle.dropdown-item:focus{outline:none}.ng-bento bento-toggle.readonly,.ng-bento bento-toggle.disabled,.ng-bento bento-toggle.dropdown-item.readonly,.ng-bento bento-toggle.dropdown-item.disabled{cursor:default;opacity:.8;pointer-events:none}.ng-bento bento-toggle.disabled,.ng-bento bento-toggle.dropdown-item.disabled{opacity:.5}.ng-bento .bento-toggle-a11y-labels{display:none}.bento-toggle-show-labels .ng-bento .bento-toggle-a11y-labels{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i3.FocusMonitor }, { type: i0.ChangeDetectorRef }, { type: BentoPointerService }, { type: BentoToggleConfig }, { type: WindowRef }]; }, propDecorators: { readOnly: [{
                type: HostBinding,
                args: ['class.readonly']
            }, {
                type: HostBinding,
                args: ['attr.aria-readonly']
            }, {
                type: Input
            }], lockToState: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }, {
                type: HostBinding,
                args: ['attr.aria-disabled']
            }], tabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], showLabels: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.bento-toggle-show-labels']
            }], value: [{
                type: HostBinding,
                args: ['class.on']
            }, {
                type: HostBinding,
                args: ['attr.aria-checked']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], _onToggleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], _onToggleTouchStart: [{
                type: HostListener,
                args: ['touchstart', ['$event']]
            }], _onToggleFocusout: [{
                type: HostListener,
                args: ['focusout']
            }] } });

class BentoToggleModule extends ConsumerDataValidator {
}
BentoToggleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoToggleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleModule, declarations: [BentoToggleComponent], imports: [CommonModule, FormsModule, BentoUtilsModule, BentoTranslateModule], exports: [BentoToggleComponent] });
BentoToggleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleModule, providers: [BentoToggleConfig], imports: [[CommonModule, FormsModule, BentoUtilsModule, BentoTranslateModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, BentoUtilsModule, BentoTranslateModule],
                    declarations: [BentoToggleComponent],
                    exports: [BentoToggleComponent],
                    providers: [BentoToggleConfig]
                }]
        }] });

class BentoToolbarDropdownComponent {
    constructor(uidGen) {
        this.isOpen = false;
        this.closeMore = new EventEmitter();
        this.uniqueID = uidGen.generate();
    }
    set button(button) {
        this.toolbarbutton = button;
    }
    toggle(button) {
        if (!button.disabled) {
            this.isOpen = !this.isOpen;
        }
    }
    clickAction(subBtn) {
        subBtn.action();
        this.closeMore.emit({});
    }
}
BentoToolbarDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarDropdownComponent, deps: [{ token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoToolbarDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoToolbarDropdownComponent, selector: "[bentoToolbarDropdown]", inputs: { button: "button" }, outputs: { closeMore: "closeMore" }, providers: [BentoUidService], ngImport: i0, template: "<button\n  cdkMonitorElementFocus\n  type=\"button\"\n  class=\"toolbar-dropdown-toggle\"\n  (click)=\"toggle(toolbarbutton)\"\n  [disabled]=\"toolbarbutton.disabled\"\n  [ngClass]=\"(toolbarbutton.disabled ? 'disabled ' : '') + (isOpen ? 'open ' : '')\"\n  aria-haspopup=\"true\"\n  [attr.aria-expanded]=\"isOpen\"\n  id=\"toggle-button-{{ uniqueID }}\"\n>\n  <i *ngIf=\"toolbarbutton.icon\" [class]=\"toolbarbutton.icon\" aria-hidden=\"true\"></i>\n  <span bentoSmartBadge [details]=\"toolbarbutton.smartbadge\" class=\"smart-badge-host\">\n    <span [innerHTML]=\"toolbarbutton.label\"></span>\n  </span>\n  <!-- <span [innerHTML]=\"toolbarbutton.label\"></span> -->\n</button>\n<ul\n  class=\"toolbar-dropdown-menu\"\n  [ngClass]=\"isOpen ? 'open ' : ''\"\n  role=\"menu\"\n  [attr.aria-labelledby]=\"'toggle-button-' + uniqueID\"\n>\n  <li role=\"none\" *ngFor=\"let subBtn of toolbarbutton.dropdown\">\n    <span *ngIf=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n    <ng-container *ngIf=\"subBtn.templateRef\">\n      <ng-content *ngTemplateOutlet=\"subBtn.templateRef; context: {control: subBtn.control}\"></ng-content>\n    </ng-container>\n    <a\n      *ngIf=\"subBtn.anchor\"\n      cdkMonitorElementFocus\n      [ngClass]=\"subBtn.class || subBtn.cssClass\"\n      [attr.href]=\"subBtn.disabled ? null : subBtn.anchor.href\"\n      [attr.target]=\"subBtn.anchor.target\"\n      [class.disabled]=\"subBtn.disabled\"\n      [class.active]=\"subBtn.active\"\n      [attr.id]=\"subBtn.id ? subBtn.id : null\"\n      bentoSmartBadge\n      [details]=\"subBtn.smartbadge\"\n      class=\"smart-badge-host btn-toolbar\"\n    >\n      <span [innerHTML]=\"subBtn.anchor.text || subBtn.label\"></span>\n    </a>\n    <button\n      cdkMonitorElementFocus\n      *ngIf=\"!subBtn.anchor && !subBtn.templateRef\"\n      type=\"button\"\n      (click)=\"clickAction(subBtn)\"\n      [ngClass]=\"subBtn.disabled ? 'disabled ' : ''\"\n      [disabled]=\"subBtn.disabled\"\n      class=\"btn-toolbar\"\n    >\n      <i *ngIf=\"subBtn.icon\" [class]=\"subBtn.icon\" aria-hidden=\"true\"></i>\n      <span bentoSmartBadge [details]=\"subBtn.smartbadge\" class=\"smart-badge-host\">\n        <span [innerHTML]=\"subBtn.label\"></span>\n      </span>\n      <!-- <span [innerHTML]=\"subBtn.label\"></span> -->\n    </button>\n  </li>\n</ul>\n", components: [{ type: BentoSmartBadgeComponent, selector: "bento-smart-badge, [bentoSmartBadge]", inputs: ["details"] }], directives: [{ type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: '[bentoToolbarDropdown]', providers: [BentoUidService], template: "<button\n  cdkMonitorElementFocus\n  type=\"button\"\n  class=\"toolbar-dropdown-toggle\"\n  (click)=\"toggle(toolbarbutton)\"\n  [disabled]=\"toolbarbutton.disabled\"\n  [ngClass]=\"(toolbarbutton.disabled ? 'disabled ' : '') + (isOpen ? 'open ' : '')\"\n  aria-haspopup=\"true\"\n  [attr.aria-expanded]=\"isOpen\"\n  id=\"toggle-button-{{ uniqueID }}\"\n>\n  <i *ngIf=\"toolbarbutton.icon\" [class]=\"toolbarbutton.icon\" aria-hidden=\"true\"></i>\n  <span bentoSmartBadge [details]=\"toolbarbutton.smartbadge\" class=\"smart-badge-host\">\n    <span [innerHTML]=\"toolbarbutton.label\"></span>\n  </span>\n  <!-- <span [innerHTML]=\"toolbarbutton.label\"></span> -->\n</button>\n<ul\n  class=\"toolbar-dropdown-menu\"\n  [ngClass]=\"isOpen ? 'open ' : ''\"\n  role=\"menu\"\n  [attr.aria-labelledby]=\"'toggle-button-' + uniqueID\"\n>\n  <li role=\"none\" *ngFor=\"let subBtn of toolbarbutton.dropdown\">\n    <span *ngIf=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n    <ng-container *ngIf=\"subBtn.templateRef\">\n      <ng-content *ngTemplateOutlet=\"subBtn.templateRef; context: {control: subBtn.control}\"></ng-content>\n    </ng-container>\n    <a\n      *ngIf=\"subBtn.anchor\"\n      cdkMonitorElementFocus\n      [ngClass]=\"subBtn.class || subBtn.cssClass\"\n      [attr.href]=\"subBtn.disabled ? null : subBtn.anchor.href\"\n      [attr.target]=\"subBtn.anchor.target\"\n      [class.disabled]=\"subBtn.disabled\"\n      [class.active]=\"subBtn.active\"\n      [attr.id]=\"subBtn.id ? subBtn.id : null\"\n      bentoSmartBadge\n      [details]=\"subBtn.smartbadge\"\n      class=\"smart-badge-host btn-toolbar\"\n    >\n      <span [innerHTML]=\"subBtn.anchor.text || subBtn.label\"></span>\n    </a>\n    <button\n      cdkMonitorElementFocus\n      *ngIf=\"!subBtn.anchor && !subBtn.templateRef\"\n      type=\"button\"\n      (click)=\"clickAction(subBtn)\"\n      [ngClass]=\"subBtn.disabled ? 'disabled ' : ''\"\n      [disabled]=\"subBtn.disabled\"\n      class=\"btn-toolbar\"\n    >\n      <i *ngIf=\"subBtn.icon\" [class]=\"subBtn.icon\" aria-hidden=\"true\"></i>\n      <span bentoSmartBadge [details]=\"subBtn.smartbadge\" class=\"smart-badge-host\">\n        <span [innerHTML]=\"subBtn.label\"></span>\n      </span>\n      <!-- <span [innerHTML]=\"subBtn.label\"></span> -->\n    </button>\n  </li>\n</ul>\n" }]
        }], ctorParameters: function () { return [{ type: BentoUidService }]; }, propDecorators: { button: [{
                type: Input
            }], closeMore: [{
                type: Output
            }] } });

/**
 * Toolbar takes inspiration from the
 * [Bootstrap Navbar](https://getbootstrap.com/docs/4.0/components/navbar/), but
 * take pains to go beyond that to include responsive behaviors, as well as
 * ARIA roles as we work toward WCAG 2.0 Level AA (Accessibility) conformance.
 *
 * If you are using toolbar within a tabset or another hidden content area,
 * please note that you will need to call the `refresh` method to let the toolbar
 * know to resize itself when it's in view. See the
 * [Toolbars in Tabset](#/components/toolbar#tabs) demo for an example of this.
 *
 * As noted above, the toolbar is responsive and allows the content in the
 * `navbar-nav` element to collapse into a "More" dropdown. The `navbar-nav`
 * element will be generated by the directive with the `items` data
 * model. You can also add transcluded content such as a `navbar-right` element
 * to the toolbar directive. However, this content will be excluded from the
 * responsive behavior.
 */
class BentoToolbarComponent {
    /**
     * Constructor: set up resize notification
     */
    constructor(elRef, bentoNotification, renderer, dir, winRef, _changeDetector) {
        this.elRef = elRef;
        this.renderer = renderer;
        this._changeDetector = _changeDetector;
        this.toolbarID = 0;
        /**
         * Unique ID of this component
         */
        this.uid = `toolbar-id-${this.toolbarID++}`;
        /**
         * Array of data to populate toolbar
         */
        this.items = [];
        this.isGlobalSubnav = false;
        this.moreIsLast = false;
        this.moreIsOpen = false;
        this.uniqueID = `bui-toolbar-${this.uid}`;
        // Pixels
        this.resizeBuffer = 0;
        this._staticWidth = 0;
        this.dirChangeSubscription = Subscription.EMPTY;
        this.prevTbWdith = 0;
        this.prevTbRightContentWidth = 0;
        this.window = winRef.nativeWindow;
        this.nativeElement = elRef.nativeElement;
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this.markForCheck());
        this.isRTL = dir.value === 'rtl';
        this.dirChangeSubscription = dir.change.subscribe(() => {
            this.isRTL = dir.value === 'rtl';
            if (this.openedDropdown) {
                this.alignDropdownMenu(this.openedDropdown);
            }
        });
    }
    ngAfterViewChecked() {
        if (this.checkRefresh() === true) {
            this._refreshTB();
        }
    }
    ngOnDestroy() {
        this._resizeSubscription.unsubscribe();
        this.dirChangeSubscription.unsubscribe();
    }
    wait(ms) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                setTimeout(resolve, ms);
            });
        });
    }
    checkRefresh() {
        if (!this.items || this.items.length === 0 || !this.nativeElement) {
            return false;
        }
        let shouldRefresh = false;
        const tbRightContent = this.nativeElement.querySelector('.navbar-right');
        const tbWidth = this._getTotalWidth(this.nativeElement);
        if (tbWidth) {
            if (tbRightContent) {
                const tbRightContentWidth = tbRightContent.offsetWidth;
                if (this.prevTbRightContentWidth != tbRightContentWidth) {
                    this.prevTbRightContentWidth = tbRightContentWidth;
                    shouldRefresh = true;
                }
            }
            const diffVal = tbWidth - this.prevTbWdith;
            if (Math.abs(diffVal) > this.resizeBuffer) {
                this.prevTbWdith = tbWidth;
                shouldRefresh = true;
            }
        }
        return shouldRefresh;
    }
    closeMoreDropdown() {
        this.moreIsOpen = false;
    }
    onDropdownOpenChange(i, isOpen, dropdown) {
        if (isOpen) {
            this.openedDropdown = dropdown;
            this.dropdowns.forEach(d => {
                // Check if dropdown element is same as the
                // one that trigger it. Close all other dropdowns
                // except the dropdown that just opened.
                if (d !== dropdown) {
                    d.close();
                }
            });
            this.alignDropdownMenu(dropdown);
        }
        else {
            this.openedDropdown = null;
        }
    }
    alignDropdownMenu(dropdown) {
        const menuEl = dropdown['_menu'].nativeElement;
        const toolbarWidth = this._getTotalWidth(this.nativeElement);
        this.renderer.setStyle(menuEl, 'max-width', `${toolbarWidth}px`);
        this.renderer.removeStyle(menuEl, 'left');
        this.renderer.removeStyle(menuEl, 'right');
        this.renderer.setStyle(menuEl, 'visibility', `hidden`);
        setTimeout(() => {
            // if menu is megamenu and not type of takeover
            if (menuEl.localName === 'bento-megamenu' && !menuEl.classList.contains('bento-megamenu-takeover')) {
                const menu = this.nativeElement.querySelector('.column-flex-container');
                menu.setAttribute('style', 'display: flex;flex-direction:row;');
                if (menu.scrollWidth + 20 > toolbarWidth) {
                    menu.setAttribute('style', 'display: flex;flex-direction:column;max-height:45vh;');
                    menu.parentElement.parentElement.style.left =
                        `${this.nativeElement.querySelector('.megamenu-dropdown').offsetLeft}px`;
                    if (menuEl.parentElement.classList.contains('global-subnav')) {
                        menuEl.classList.add('bento-megamenu-subnav-background');
                    }
                }
                else {
                    menu.setAttribute('style', 'display: flex;flex-direction:row;');
                }
            }
            this.renderer.setStyle(menuEl, 'visibility', `visible`);
        });
    }
    _getTotalWidth(el) {
        if (!el || !this.window.getComputedStyle) {
            return;
        }
        const style = this.window.getComputedStyle(el);
        return (Math.ceil(el.offsetWidth) +
            parseFloat(style.paddingLeft) +
            parseFloat(style.paddingRight) +
            parseFloat(style.marginLeft !== 'auto' ? style.marginLeft : 0) +
            parseFloat(style.marginRight !== 'auto' ? style.marginRight : 0));
    }
    /**
     * Call this method to refesh the toolbar when data or data properties have changed;
    */
    refresh() {
        this._refreshTB();
        this.markForCheck();
    }
    markForCheck() {
        this._changeDetector.markForCheck();
    }
    _refreshTB() {
        return __awaiter(this, void 0, void 0, function* () {
            let elWidth = this._getTotalWidth(this.nativeElement);
            // For Edge and Opera browsers
            if (elWidth < 10) {
                yield this.wait(500);
                elWidth = this._getTotalWidth(this.nativeElement);
            }
            const moreDDChildren = this.nativeElement.querySelectorAll('.bento-dditem');
            if (!moreDDChildren || moreDDChildren.length === 0) {
                return;
            }
            const navbarElement = this.nativeElement.querySelector('ul.nav.navbar-nav');
            let moreWidth = 0;
            let moreIsVisible = false;
            this._staticWidth = 0;
            const navbarChildren = navbarElement.children;
            let totalWidth = 0;
            const navBarHeader = this.nativeElement.querySelector('.navbar-header');
            const navBarLeft = this.nativeElement.querySelector('.navbar-left');
            const navBarRight = this.nativeElement.querySelector('.navbar-right');
            let navBarRightWidth;
            navBarRightWidth = navBarRight ? +navBarRight.offsetWidth : 0;
            if (navBarRightWidth >= elWidth) {
                return;
            }
            this.items.map((item, index) => {
                if (navbarChildren[index]) {
                    this.renderer.setStyle(navbarChildren[index], 'display', 'inline-block');
                    item.width = this._getTotalWidth(navbarChildren[index]);
                    // keep track of static buttons width (buttons that won't merge into 'more' button)
                    const isStatic = !!item.static || !!item.megamenu;
                    if (isStatic) {
                        this._staticWidth += +item.width;
                    }
                }
                return item;
            });
            let navBarLeftWidth = navBarLeft ? +navBarLeft.offsetWidth : 0;
            const moreElement = this.nativeElement.querySelector('.more-button');
            moreWidth = moreElement ? moreElement.offsetWidth : 0;
            const pad = 75;
            navBarLeftWidth += navBarHeader ? +navBarHeader.offsetWidth : 0;
            this.renderer.setStyle(moreElement, 'display', 'none');
            if (this.items) {
                let itemsInMainWidth = 0;
                let i;
                const il = this.items.length;
                for (i = 0; i < il; i++) {
                    const td = this.items[i];
                    // if hidden property is set to true,
                    // do not add to cumulative width
                    if (td.hidden) {
                        this.renderer.setStyle(navbarChildren[i], 'display', 'none');
                        this.renderer.setStyle(moreDDChildren[i], 'display', 'none');
                        continue;
                    }
                    const isStatic = !!td.static || !!td.megamenu;
                    // add button button width to total accumulative width
                    // if it's not static (static width tally is already accounted for)
                    if (!isStatic) {
                        totalWidth += +td.width;
                    }
                    const cumulativeWidth = totalWidth + moreWidth + pad + this._staticWidth + navBarLeftWidth + navBarRightWidth;
                    const totalElementWidth = elWidth;
                    if (isStatic) {
                        td.isVisible = true;
                        td.isTransparent = false;
                        this.renderer.setStyle(navbarChildren[i], 'display', 'inline-block');
                        this.renderer.setStyle(moreDDChildren[i], 'display', 'none');
                        continue;
                    }
                    else if (cumulativeWidth < totalElementWidth) {
                        this.renderer.setStyle(navbarChildren[i], 'display', 'inline-block');
                        this.renderer.setStyle(moreDDChildren[i], 'display', 'none');
                        itemsInMainWidth = cumulativeWidth;
                    }
                    else {
                        td.isVisible = false;
                        td.isTransparent = true;
                        this.renderer.setStyle(navbarChildren[i], 'display', 'none');
                        this.renderer.setStyle(moreDDChildren[i], 'display', 'inline');
                        this.renderer.setStyle(moreElement, 'display', 'inline');
                        moreIsVisible = true;
                    }
                    if (moreIsVisible) {
                        moreWidth = moreElement ? moreElement.offsetWidth : 100;
                    }
                    else {
                        moreWidth = 0;
                    }
                }
                // decide whether to align 'more' dropdown menu to the right or left depending on space
                this.moreIsLast = false;
                if (itemsInMainWidth > 300) {
                    this.moreIsLast = true;
                }
            }
            if (this.openedDropdown) {
                this.alignDropdownMenu(this.openedDropdown);
            }
        });
    }
}
BentoToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarComponent, deps: [{ token: i0.ElementRef }, { token: BentoNotification }, { token: i0.Renderer2 }, { token: i2.Directionality }, { token: WindowRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoToolbarComponent, selector: "bento-toolbar", inputs: { moreText: "moreText", items: "items" }, providers: [BentoNotification], viewQueries: [{ propertyName: "dropdowns", predicate: NgbDropdown, descendants: true }], ngImport: i0, template: "<ng-content select=\".navbar-header\"></ng-content>\n<ng-content select=\".navbar-left\"></ng-content>\n<nav>\n  <ul [attr.id]=\"uid\" #tb class=\"nav navbar-nav\" role=\"presentation\">\n    <li *ngFor=\"let button of items; let i = index\">\n      <ng-container *ngIf=\"button.templateRef\">\n        <ng-content *ngTemplateOutlet=\"button.templateRef; context: {control: button.control}\"></ng-content>\n      </ng-container>\n      <a cdkMonitorElementFocus\n         *ngIf=\"button.anchor\"\n         [ngClass]=\"button.class || button.cssClass\"\n         [attr.href]=\"button.disabled ? null : button.anchor.href\"\n         [attr.target]=\"button.anchor.target\"\n         [class.disabled]=\"button.disabled\"\n         [class.active]=\"button.active\"\n         [attr.aria-selected]=\"button.active\"\n         [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n         [attr.id]=\"button.id ? button.id : null\"\n         bentoSmartBadge\n         [details]=\"button.smartbadge\"\n         class=\"smart-badge-host btn-toolbar\">\n        <span [innerHTML]=\"button.anchor.text || button.label\"></span>\n      </a>\n      <a cdkMonitorElementFocus\n         *ngIf=\"button.routerLink\"\n         routerLinkActive=\"router-link-active\"\n         [ngClass]=\"button.class || button.cssClass\"\n         [routerLink]=\"button.disabled ? null : button.routerLink.href\"\n         [queryParams]=\"button.routerLink.queryParams\"\n         [fragment]=\"button.routerLink.fragment\"\n         [class.disabled]=\"button.disabled\"\n         [class.active]=\"button.active\"\n         [attr.aria-selected]=\"button.active\"\n         [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n         [attr.id]=\"button.id ? button.id : null\"\n         bentoSmartBadge\n         [details]=\"button.smartbadge\"\n         class=\"smart-badge-host btn-toolbar\">\n        <span [innerHTML]=\"button.routerLink.text || button.label\"></span>\n      </a>\n      <button cdkMonitorElementFocus\n              type=\"button\"\n              *ngIf=\"!button.templateRef && !button.anchor && !button.routerLink && !button.dropdown && !button.megamenu\"\n              (click)=\"button.action(); moreIsOpen = false\"\n              [ngClass]=\"button.class || button.cssClass\"\n              [class.disabled]=\"button.disabled\"\n              [class.active]=\"button.active\"\n              [attr.aria-selected]=\"button.active\"\n              [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n              [attr.id]=\"button.id ? button.id : null\"\n              [disabled]=\"button.disabled\"\n              class=\"btn-toolbar\">\n        <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n        <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n          <span [innerHTML]=\"button.label\"></span>\n        </span>\n      </button>\n      <div ngbDropdown\n           #dropdown=\"ngbDropdown\"\n           id=\"dropdown-{{ uniqueID }}-{{ i }}\"\n           (openChange)=\"onDropdownOpenChange(i, $event, dropdown)\"\n           [placement]=\"isRTL ? 'bottom right' : 'bottom left'\"\n           display=\"static\"\n           *ngIf=\"button.dropdown || button.megamenu\"\n           class=\"dropdown\"\n           [class.megamenu-dropdown]=\"button.megamenu\">\n        <button cdkMonitorElementFocus\n                ngbDropdownToggle\n                type=\"button\"\n                (click)=\"button.action ? button.action() : 0; moreIsOpen = false\"\n                [ngClass]=\"button.class || button.cssClass\"\n                [class.disabled]=\"button.disabled\"\n                [class.active]=\"button.active\"\n                [attr.aria-selected]=\"button.active\"\n                [attr.id]=\"button.id ? button.id : null\"\n                [disabled]=\"button.disabled\"\n                class=\"btn-toolbar\">\n          <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n          <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n            <span [innerHTML]=\"button.label\"></span>\n          </span>\n          <!-- <span class=\"smart-badge-host\" [innerHTML]=\"button.label\"></span> -->\n        </button>\n        <ul *ngIf=\"button.dropdown\"\n            ngbDropdownMenu\n            class=\"dropdown-menu\"\n            [ngClass]=\"isRTL ? 'dropdown-menu-right ' : ''\"\n            id=\"dropdown-menu-{{ uniqueID }}-{{ i }}\">\n          <li ngbDropdownItem *ngFor=\"let subBtn of button.dropdown\">\n            <span *ngIf=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n            <ng-container *ngIf=\"subBtn.templateRef\">\n              <ng-content *ngTemplateOutlet=\"subBtn.templateRef; context: {control: subBtn.control}\"></ng-content>\n            </ng-container>\n            <a cdkMonitorElementFocus\n               *ngIf=\"subBtn.anchor\"\n               [ngClass]=\"subBtn.class || subBtn.cssClass\"\n               [attr.href]=\"subBtn.disabled ? null : subBtn.anchor.href\"\n               [attr.target]=\"subBtn.anchor.target\"\n               [class.disabled]=\"subBtn.disabled\"\n               [class.active]=\"subBtn.active\"\n               [attr.aria-selected]=\"subBtn.active\"\n               [attr.id]=\"subBtn.id ? subBtn.id : null\"\n               bentoSmartBadge\n               [details]=\"subBtn.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"subBtn.anchor.text || subBtn.label\"></span>\n            </a>\n            <a cdkMonitorElementFocus\n               *ngIf=\"subBtn.routerLink\"\n               [ngClass]=\"subBtn.class || subBtn.cssClass\"\n               [routerLink]=\"subBtn.disabled ? null : subBtn.routerLink.href\"\n               [queryParams]=\"subBtn.routerLink.queryParams\"\n               [fragment]=\"subBtn.routerLink.fragment\"\n               [class.disabled]=\"subBtn.disabled\"\n               [class.active]=\"subBtn.active\"\n               [attr.aria-selected]=\"subBtn.active\"\n               [attr.id]=\"subBtn.id ? subBtn.id : null\"\n               bentoSmartBadge\n               [details]=\"subBtn.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"subBtn.routerLink.text || subBtn.label\"></span>\n            </a>\n            <button cdkMonitorElementFocus\n                    type=\"button\"\n                    *ngIf=\"!subBtn.anchor && !subBtn.routerLink && !subBtn.templateRef\"\n                    (click)=\"subBtn.action()\"\n                    [attr.id]=\"subBtn.id ? subBtn.id : null\"\n                    [ngClass]=\"subBtn.class || {disabled: subBtn.disabled}\"\n                    [disabled]=\"subBtn.disabled\">\n              <i *ngIf=\"subBtn.icon\" [class]=\"subBtn.icon\" aria-hidden=\"true\"></i>\n              <span bentoSmartBadge [details]=\"subBtn.smartbadge\" class=\"smart-badge-host\">\n                <span [innerHTML]=\"subBtn.label\"></span>\n              </span>\n              <!-- <span class=\"smart-badge-host\" [innerHTML]=\"subBtn.label\"></span> -->\n            </button>\n          </li>\n        </ul>\n        <bento-megamenu *ngIf=\"button.megamenu\"\n                        [bentoAppendTo]=\"button.type === 'takeover' ? null : elRef\"\n                        [autoVerticalAlignment]=\"false\"\n                        [autoHideOnContainerScroll]=\"false\"\n                        alignment=\"bottom\"\n                        [autoRealign]=\"true\"\n                        [items]=\"button.megamenu\"\n                        [type]=\"button.type\"\n                        [maxWidth]=\"button.maxWidth\"\n                        [ngClass]=\"isRTL ? 'dropdown-menu-right ' : ''\"\n                        [flowColumnWidth]=\"button.flowColumnWidth\"\n                        [widthElRef]=\"elRef\"\n                        hTagRank=\"3\"\n                        [attr.aria-label]=\"button.ariaLabel ? button.ariaLabel : null\"\n                        [isEmbedded]=\"true\"></bento-megamenu>\n      </div>\n    </li>\n\n    <li class=\"more-button\">\n      <div ngbDropdown\n           #moreDropdown=\"ngbDropdown\"\n           id=\"more-dropdown-{{ uniqueID }}\"\n           (openChange)=\"onDropdownOpenChange(uniqueID, $event, moreDropdown)\"\n           display=\"static\"\n           placement=\"bottom\"\n           [autoClose]=\"'outside'\"\n           class=\"dropdown\"\n           [open]=\"moreIsOpen\">\n        <button cdkMonitorElementFocus\n                ngbDropdownToggle\n                type=\"button\"\n                id=\"more-button-{{ uniqueID }}\"\n                (click)=\"moreIsOpen = !moreIsOpen\"\n                class=\"btn-toolbar\">\n          <span>{{ 'BENTO_UI_NAV_TOOLBAR_MORE' | bentoTranslate: moreText }}</span>\n        </button>\n\n        <ul class=\"dropdown-menu\" ngbDropdownMenu #ddMore [attr.aria-labelledby]=\"'more-button-' + uniqueID\">\n          <li ngbDropdownItem class=\"bento-dditem\" *ngFor=\"let button of items; let i = index; let last = last\">\n            <span *ngIf=\"button.separated && !(i === 0 && last)\" class=\"divider\" role=\"separator\"></span>\n            <ng-container *ngIf=\"button.templateRef\">\n              <ng-content *ngTemplateOutlet=\"button.templateRef; context: {control: button.control}\"></ng-content>\n            </ng-container>\n            <a cdkMonitorElementFocus\n               *ngIf=\"button.anchor\"\n               [ngClass]=\"button.class || button.cssClass\"\n               [attr.href]=\"button.disabled ? null : button.anchor.href\"\n               [attr.target]=\"button.anchor.target\"\n               [class.disabled]=\"button.disabled\"\n               [class.active]=\"button.active\"\n               [attr.aria-selected]=\"button.active\"\n               [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n               [attr.id]=\"button.id ? button.id : null\"\n               bentoSmartBadge\n               [details]=\"button.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"button.anchor.text || button.label\"></span>\n            </a>\n            <a cdkMonitorElementFocus\n               *ngIf=\"button.routerLink\"\n               [ngClass]=\"button.class || button.cssClass\"\n               [routerLink]=\"button.disabled ? null : button.routerLink.href\"\n               [queryParams]=\"button.routerLink.queryParams\"\n               [fragment]=\"button.routerLink.fragment\"\n               [class.disabled]=\"button.disabled\"\n               [class.active]=\"button.active\"\n               [attr.aria-selected]=\"button.active\"\n               [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n               [attr.id]=\"button.id ? button.id : null\"\n               bentoSmartBadge\n               [details]=\"button.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"button.routerLink.text || button.label\"></span>\n            </a>\n            <button cdkMonitorElementFocus\n                    *ngIf=\"!button.anchor && !button.routerLink && !button.dropdown && !button.templateRef\"\n                    type=\"button\"\n                    [ngClass]=\"button.class || button.cssClass\"\n                    [class.disabled]=\"button.disabled\"\n                    [class.active]=\"button.active\"\n                    [attr.aria-selected]=\"button.active\"\n                    [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n                    [disabled]=\"button.disabled\"\n                    (click)=\"button.action(); moreIsOpen = false\">\n              <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n              <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n                <span [innerHTML]=\"button.label\"></span>\n              </span>\n              <!-- <span [innerHTML]=\"button.label\"></span> -->\n            </button>\n            <div bentoToolbarDropdown\n                 *ngIf=\"button.dropdown\"\n                 [button]=\"button\"\n                 (closeMore)=\"closeMoreDropdown()\"\n                 class=\"toolbar-dropdown dropdown\"></div>\n          </li>\n        </ul>\n      </div>\n    </li>\n  </ul>\n</nav>\n<ng-content select=\".navbar-right\"></ng-content>\n<div class=\"clearfix\"></div>\n", styles: [".ng-bento bento-toolbar,.ng-bento .bui-bento-toolbar{border-style:solid;border-width:1px}.ng-bento bento-toolbar .bento-smart-badge,.ng-bento .bui-bento-toolbar .bento-smart-badge{position:relative;left:auto;bottom:auto;right:auto;vertical-align:super;display:inline-block;top:50%;transform:translateY(-50%)}.ng-bento bento-toolbar .navbar-nav,.ng-bento .bui-bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.ng-bento bento-toolbar .navbar-nav>li.transparent,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.ng-bento .bui-bento-toolbar .navbar-nav>li.transparent,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent{opacity:0;height:1px}.ng-bento bento-toolbar .navbar-nav>li>button,.ng-bento bento-toolbar .navbar-nav>li>a,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav>li>button,.ng-bento .bui-bento-toolbar .navbar-nav>li>a,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]{border:none;background:transparent;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.ng-bento bento-toolbar .navbar-nav>li>button:focus,.ng-bento bento-toolbar .navbar-nav>li>a:focus,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus{outline:none}.ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.ng-bento bento-toolbar .divider,.ng-bento .bui-bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle span,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.ng-bento bento-toolbar [ngbdropdown],.ng-bento .bui-bento-toolbar [ngbdropdown]{display:block;position:relative}.ng-bento bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,.ng-bento .bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:after,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:after{content:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"]{vertical-align:middle}[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{text-align:right;padding:0 15px 0 30px}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a[disabled]:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown,.ng-bento .bui-bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.ng-bento bento-toolbar .open.toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.ng-bento bento-toolbar .more-button,.ng-bento .bui-bento-toolbar .more-button{display:none}.ng-bento bento-toolbar .toolbar-dropdown-toggle:after,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .ng-bento bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled{cursor:pointer}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu{list-style:none;max-height:0;overflow:hidden;padding:0;transition:all .3s ease-out;visibility:hidden}.ng-bento bento-toolbar .toolbar-dropdown-menu .divider,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu .divider{display:block}.ng-bento bento-toolbar .toolbar-dropdown-menu>li>a,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.ng-bento bento-toolbar.bg-faded,.ng-bento .bui-bento-toolbar.bg-faded{border:none}.ng-bento bento-toolbar .bento-toolbar-custom-item,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.ng-bento bento-toolbar .bento-toolbar-custom-item label,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .ng-bento bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] .ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}\n"], components: [{ type: BentoSmartBadgeComponent, selector: "bento-smart-badge, [bentoSmartBadge]", inputs: ["details"] }, { type: BentoMegamenuComponent, selector: "bento-megamenu", inputs: ["items", "widthElRef", "maxWidth", "flowColumnWidth", "bentoAppendTo", "type", "hTagRank", "isEmbedded", "ariaLabel"] }, { type: BentoToolbarDropdownComponent, selector: "[bentoToolbarDropdown]", inputs: ["button"], outputs: ["closeMore"] }], directives: [{ type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i1$3.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { type: i1$1.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i1$1.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i1$1.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i1$1.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { type: BentoNgbDropdownAppendToDirective, selector: "[bentoAppendTo].dropdown-menu, bento-megamenu[bentoAppendTo]", inputs: ["bentoAppendTo", "autoRealign", "offset"] }, { type: BentoAppendToDirective, selector: "[bentoAppendTo]:not(.dropdown-menu)", inputs: ["bentoAppendTo", "referenceTo", "reszieWidthToReference", "autoHideOnContainerScroll", "alignment", "autoVerticalAlignment", "open", "side"], outputs: ["openChange"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-toolbar', providers: [BentoNotification], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\".navbar-header\"></ng-content>\n<ng-content select=\".navbar-left\"></ng-content>\n<nav>\n  <ul [attr.id]=\"uid\" #tb class=\"nav navbar-nav\" role=\"presentation\">\n    <li *ngFor=\"let button of items; let i = index\">\n      <ng-container *ngIf=\"button.templateRef\">\n        <ng-content *ngTemplateOutlet=\"button.templateRef; context: {control: button.control}\"></ng-content>\n      </ng-container>\n      <a cdkMonitorElementFocus\n         *ngIf=\"button.anchor\"\n         [ngClass]=\"button.class || button.cssClass\"\n         [attr.href]=\"button.disabled ? null : button.anchor.href\"\n         [attr.target]=\"button.anchor.target\"\n         [class.disabled]=\"button.disabled\"\n         [class.active]=\"button.active\"\n         [attr.aria-selected]=\"button.active\"\n         [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n         [attr.id]=\"button.id ? button.id : null\"\n         bentoSmartBadge\n         [details]=\"button.smartbadge\"\n         class=\"smart-badge-host btn-toolbar\">\n        <span [innerHTML]=\"button.anchor.text || button.label\"></span>\n      </a>\n      <a cdkMonitorElementFocus\n         *ngIf=\"button.routerLink\"\n         routerLinkActive=\"router-link-active\"\n         [ngClass]=\"button.class || button.cssClass\"\n         [routerLink]=\"button.disabled ? null : button.routerLink.href\"\n         [queryParams]=\"button.routerLink.queryParams\"\n         [fragment]=\"button.routerLink.fragment\"\n         [class.disabled]=\"button.disabled\"\n         [class.active]=\"button.active\"\n         [attr.aria-selected]=\"button.active\"\n         [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n         [attr.id]=\"button.id ? button.id : null\"\n         bentoSmartBadge\n         [details]=\"button.smartbadge\"\n         class=\"smart-badge-host btn-toolbar\">\n        <span [innerHTML]=\"button.routerLink.text || button.label\"></span>\n      </a>\n      <button cdkMonitorElementFocus\n              type=\"button\"\n              *ngIf=\"!button.templateRef && !button.anchor && !button.routerLink && !button.dropdown && !button.megamenu\"\n              (click)=\"button.action(); moreIsOpen = false\"\n              [ngClass]=\"button.class || button.cssClass\"\n              [class.disabled]=\"button.disabled\"\n              [class.active]=\"button.active\"\n              [attr.aria-selected]=\"button.active\"\n              [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n              [attr.id]=\"button.id ? button.id : null\"\n              [disabled]=\"button.disabled\"\n              class=\"btn-toolbar\">\n        <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n        <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n          <span [innerHTML]=\"button.label\"></span>\n        </span>\n      </button>\n      <div ngbDropdown\n           #dropdown=\"ngbDropdown\"\n           id=\"dropdown-{{ uniqueID }}-{{ i }}\"\n           (openChange)=\"onDropdownOpenChange(i, $event, dropdown)\"\n           [placement]=\"isRTL ? 'bottom right' : 'bottom left'\"\n           display=\"static\"\n           *ngIf=\"button.dropdown || button.megamenu\"\n           class=\"dropdown\"\n           [class.megamenu-dropdown]=\"button.megamenu\">\n        <button cdkMonitorElementFocus\n                ngbDropdownToggle\n                type=\"button\"\n                (click)=\"button.action ? button.action() : 0; moreIsOpen = false\"\n                [ngClass]=\"button.class || button.cssClass\"\n                [class.disabled]=\"button.disabled\"\n                [class.active]=\"button.active\"\n                [attr.aria-selected]=\"button.active\"\n                [attr.id]=\"button.id ? button.id : null\"\n                [disabled]=\"button.disabled\"\n                class=\"btn-toolbar\">\n          <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n          <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n            <span [innerHTML]=\"button.label\"></span>\n          </span>\n          <!-- <span class=\"smart-badge-host\" [innerHTML]=\"button.label\"></span> -->\n        </button>\n        <ul *ngIf=\"button.dropdown\"\n            ngbDropdownMenu\n            class=\"dropdown-menu\"\n            [ngClass]=\"isRTL ? 'dropdown-menu-right ' : ''\"\n            id=\"dropdown-menu-{{ uniqueID }}-{{ i }}\">\n          <li ngbDropdownItem *ngFor=\"let subBtn of button.dropdown\">\n            <span *ngIf=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n            <ng-container *ngIf=\"subBtn.templateRef\">\n              <ng-content *ngTemplateOutlet=\"subBtn.templateRef; context: {control: subBtn.control}\"></ng-content>\n            </ng-container>\n            <a cdkMonitorElementFocus\n               *ngIf=\"subBtn.anchor\"\n               [ngClass]=\"subBtn.class || subBtn.cssClass\"\n               [attr.href]=\"subBtn.disabled ? null : subBtn.anchor.href\"\n               [attr.target]=\"subBtn.anchor.target\"\n               [class.disabled]=\"subBtn.disabled\"\n               [class.active]=\"subBtn.active\"\n               [attr.aria-selected]=\"subBtn.active\"\n               [attr.id]=\"subBtn.id ? subBtn.id : null\"\n               bentoSmartBadge\n               [details]=\"subBtn.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"subBtn.anchor.text || subBtn.label\"></span>\n            </a>\n            <a cdkMonitorElementFocus\n               *ngIf=\"subBtn.routerLink\"\n               [ngClass]=\"subBtn.class || subBtn.cssClass\"\n               [routerLink]=\"subBtn.disabled ? null : subBtn.routerLink.href\"\n               [queryParams]=\"subBtn.routerLink.queryParams\"\n               [fragment]=\"subBtn.routerLink.fragment\"\n               [class.disabled]=\"subBtn.disabled\"\n               [class.active]=\"subBtn.active\"\n               [attr.aria-selected]=\"subBtn.active\"\n               [attr.id]=\"subBtn.id ? subBtn.id : null\"\n               bentoSmartBadge\n               [details]=\"subBtn.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"subBtn.routerLink.text || subBtn.label\"></span>\n            </a>\n            <button cdkMonitorElementFocus\n                    type=\"button\"\n                    *ngIf=\"!subBtn.anchor && !subBtn.routerLink && !subBtn.templateRef\"\n                    (click)=\"subBtn.action()\"\n                    [attr.id]=\"subBtn.id ? subBtn.id : null\"\n                    [ngClass]=\"subBtn.class || {disabled: subBtn.disabled}\"\n                    [disabled]=\"subBtn.disabled\">\n              <i *ngIf=\"subBtn.icon\" [class]=\"subBtn.icon\" aria-hidden=\"true\"></i>\n              <span bentoSmartBadge [details]=\"subBtn.smartbadge\" class=\"smart-badge-host\">\n                <span [innerHTML]=\"subBtn.label\"></span>\n              </span>\n              <!-- <span class=\"smart-badge-host\" [innerHTML]=\"subBtn.label\"></span> -->\n            </button>\n          </li>\n        </ul>\n        <bento-megamenu *ngIf=\"button.megamenu\"\n                        [bentoAppendTo]=\"button.type === 'takeover' ? null : elRef\"\n                        [autoVerticalAlignment]=\"false\"\n                        [autoHideOnContainerScroll]=\"false\"\n                        alignment=\"bottom\"\n                        [autoRealign]=\"true\"\n                        [items]=\"button.megamenu\"\n                        [type]=\"button.type\"\n                        [maxWidth]=\"button.maxWidth\"\n                        [ngClass]=\"isRTL ? 'dropdown-menu-right ' : ''\"\n                        [flowColumnWidth]=\"button.flowColumnWidth\"\n                        [widthElRef]=\"elRef\"\n                        hTagRank=\"3\"\n                        [attr.aria-label]=\"button.ariaLabel ? button.ariaLabel : null\"\n                        [isEmbedded]=\"true\"></bento-megamenu>\n      </div>\n    </li>\n\n    <li class=\"more-button\">\n      <div ngbDropdown\n           #moreDropdown=\"ngbDropdown\"\n           id=\"more-dropdown-{{ uniqueID }}\"\n           (openChange)=\"onDropdownOpenChange(uniqueID, $event, moreDropdown)\"\n           display=\"static\"\n           placement=\"bottom\"\n           [autoClose]=\"'outside'\"\n           class=\"dropdown\"\n           [open]=\"moreIsOpen\">\n        <button cdkMonitorElementFocus\n                ngbDropdownToggle\n                type=\"button\"\n                id=\"more-button-{{ uniqueID }}\"\n                (click)=\"moreIsOpen = !moreIsOpen\"\n                class=\"btn-toolbar\">\n          <span>{{ 'BENTO_UI_NAV_TOOLBAR_MORE' | bentoTranslate: moreText }}</span>\n        </button>\n\n        <ul class=\"dropdown-menu\" ngbDropdownMenu #ddMore [attr.aria-labelledby]=\"'more-button-' + uniqueID\">\n          <li ngbDropdownItem class=\"bento-dditem\" *ngFor=\"let button of items; let i = index; let last = last\">\n            <span *ngIf=\"button.separated && !(i === 0 && last)\" class=\"divider\" role=\"separator\"></span>\n            <ng-container *ngIf=\"button.templateRef\">\n              <ng-content *ngTemplateOutlet=\"button.templateRef; context: {control: button.control}\"></ng-content>\n            </ng-container>\n            <a cdkMonitorElementFocus\n               *ngIf=\"button.anchor\"\n               [ngClass]=\"button.class || button.cssClass\"\n               [attr.href]=\"button.disabled ? null : button.anchor.href\"\n               [attr.target]=\"button.anchor.target\"\n               [class.disabled]=\"button.disabled\"\n               [class.active]=\"button.active\"\n               [attr.aria-selected]=\"button.active\"\n               [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n               [attr.id]=\"button.id ? button.id : null\"\n               bentoSmartBadge\n               [details]=\"button.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"button.anchor.text || button.label\"></span>\n            </a>\n            <a cdkMonitorElementFocus\n               *ngIf=\"button.routerLink\"\n               [ngClass]=\"button.class || button.cssClass\"\n               [routerLink]=\"button.disabled ? null : button.routerLink.href\"\n               [queryParams]=\"button.routerLink.queryParams\"\n               [fragment]=\"button.routerLink.fragment\"\n               [class.disabled]=\"button.disabled\"\n               [class.active]=\"button.active\"\n               [attr.aria-selected]=\"button.active\"\n               [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n               [attr.id]=\"button.id ? button.id : null\"\n               bentoSmartBadge\n               [details]=\"button.smartbadge\"\n               class=\"smart-badge-host\">\n              <span [innerHTML]=\"button.routerLink.text || button.label\"></span>\n            </a>\n            <button cdkMonitorElementFocus\n                    *ngIf=\"!button.anchor && !button.routerLink && !button.dropdown && !button.templateRef\"\n                    type=\"button\"\n                    [ngClass]=\"button.class || button.cssClass\"\n                    [class.disabled]=\"button.disabled\"\n                    [class.active]=\"button.active\"\n                    [attr.aria-selected]=\"button.active\"\n                    [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n                    [disabled]=\"button.disabled\"\n                    (click)=\"button.action(); moreIsOpen = false\">\n              <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n              <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n                <span [innerHTML]=\"button.label\"></span>\n              </span>\n              <!-- <span [innerHTML]=\"button.label\"></span> -->\n            </button>\n            <div bentoToolbarDropdown\n                 *ngIf=\"button.dropdown\"\n                 [button]=\"button\"\n                 (closeMore)=\"closeMoreDropdown()\"\n                 class=\"toolbar-dropdown dropdown\"></div>\n          </li>\n        </ul>\n      </div>\n    </li>\n  </ul>\n</nav>\n<ng-content select=\".navbar-right\"></ng-content>\n<div class=\"clearfix\"></div>\n", styles: [".ng-bento bento-toolbar,.ng-bento .bui-bento-toolbar{border-style:solid;border-width:1px}.ng-bento bento-toolbar .bento-smart-badge,.ng-bento .bui-bento-toolbar .bento-smart-badge{position:relative;left:auto;bottom:auto;right:auto;vertical-align:super;display:inline-block;top:50%;transform:translateY(-50%)}.ng-bento bento-toolbar .navbar-nav,.ng-bento .bui-bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.ng-bento bento-toolbar .navbar-nav>li.transparent,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.ng-bento .bui-bento-toolbar .navbar-nav>li.transparent,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent{opacity:0;height:1px}.ng-bento bento-toolbar .navbar-nav>li>button,.ng-bento bento-toolbar .navbar-nav>li>a,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav>li>button,.ng-bento .bui-bento-toolbar .navbar-nav>li>a,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]{border:none;background:transparent;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.ng-bento bento-toolbar .navbar-nav>li>button:focus,.ng-bento bento-toolbar .navbar-nav>li>a:focus,.ng-bento bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus{outline:none}.ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,.ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .ng-bento bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.ng-bento bento-toolbar .divider,.ng-bento .bui-bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle span,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,.ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .ng-bento bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.ng-bento bento-toolbar [ngbdropdown],.ng-bento .bui-bento-toolbar [ngbdropdown]{display:block;position:relative}.ng-bento bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,.ng-bento .bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu:after,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu:after{content:none}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"]{vertical-align:middle}[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] .ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a{text-align:right;padding:0 15px 0 30px}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.ng-bento .bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus{outline:none;border-width:1px;border-style:dashed}.ng-bento bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento bento-toolbar [ngbdropdown] a[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] button[disabled]:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a:disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a.disabled:hover,.ng-bento .bui-bento-toolbar [ngbdropdown] a[disabled]:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown,.ng-bento .bui-bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.ng-bento bento-toolbar .open.toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.ng-bento bento-toolbar .more-button,.ng-bento .bui-bento-toolbar .more-button{display:none}.ng-bento bento-toolbar .toolbar-dropdown-toggle:after,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .ng-bento bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] .ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled],.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled{cursor:pointer}.ng-bento bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.ng-bento .bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover{background-color:transparent}.ng-bento bento-toolbar .toolbar-dropdown-menu,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu{list-style:none;max-height:0;overflow:hidden;padding:0;transition:all .3s ease-out;visibility:hidden}.ng-bento bento-toolbar .toolbar-dropdown-menu .divider,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu .divider{display:block}.ng-bento bento-toolbar .toolbar-dropdown-menu>li>a,.ng-bento .bui-bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.ng-bento bento-toolbar.bg-faded,.ng-bento .bui-bento-toolbar.bg-faded{border:none}.ng-bento bento-toolbar .bento-toolbar-custom-item,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.ng-bento bento-toolbar .bento-toolbar-custom-item label,.ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .ng-bento bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] .ng-bento .bui-bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoNotification }, { type: i0.Renderer2 }, { type: i2.Directionality }, { type: WindowRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { dropdowns: [{
                type: ViewChildren,
                args: [NgbDropdown]
            }], moreText: [{
                type: Input
            }], items: [{
                type: Input
            }] } });

class BentoToolbarFilterPipe {
    transform(items, arg) {
        if (!items) {
            return;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        // or the item is a megamenu dropdown
        return items.filter(item => {
            if (item.hasOwnProperty('hidden')) {
                return !item.hidden;
            }
            return item.isVisible === arg;
        });
    }
}
BentoToolbarFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BentoToolbarFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarFilterPipe, name: "bentoToolbarFilter", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'bentoToolbarFilter',
                    pure: false
                }]
        }] });

class BentoToolbarModule extends ConsumerDataValidator {
}
BentoToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarModule, declarations: [BentoToolbarComponent,
        BentoToolbarDropdownComponent,
        BentoToolbarFilterPipe], imports: [CommonModule,
        RouterModule,
        NgbDropdownModule,
        BentoTranslateModule,
        BentoMegamenuModule,
        A11yModule,
        BentoNgbDropdownAnimationModule,
        BentoSmartBadgeModule,
        BentoFocusMonitorModule,
        BentoAppendToModule], exports: [BentoToolbarComponent] });
BentoToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarModule, imports: [[
            CommonModule,
            RouterModule,
            NgbDropdownModule,
            BentoTranslateModule,
            BentoMegamenuModule,
            A11yModule,
            BentoNgbDropdownAnimationModule,
            BentoSmartBadgeModule,
            BentoFocusMonitorModule,
            BentoAppendToModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule,
                        NgbDropdownModule,
                        BentoTranslateModule,
                        BentoMegamenuModule,
                        A11yModule,
                        BentoNgbDropdownAnimationModule,
                        BentoSmartBadgeModule,
                        BentoFocusMonitorModule,
                        BentoAppendToModule
                    ],
                    declarations: [
                        BentoToolbarComponent,
                        BentoToolbarDropdownComponent,
                        BentoToolbarFilterPipe
                    ],
                    exports: [BentoToolbarComponent]
                }]
        }] });

class BentoTransferlistComponent {
    constructor(elRef, r, translate, bentoUIDService, windowRef) {
        this.r = r;
        this.translate = translate;
        this.height = 500;
        this.infoShown = true;
        this.hidePagination = false;
        this.hideFilters = false;
        this.disableTransfer = false;
        this.boxID = '1';
        this.transferItems = new EventEmitter();
        this.itemsSource = undefined;
        this.renderData = undefined;
        this.filteredData = [];
        this.sortDirections = ['', 'asc', 'desc'];
        this.colHeaderSort = {};
        this.activeCol = undefined;
        this.activeColDirection = '';
        this.shiftPressed = false;
        this.selection = [];
        this.focusID = -1;
        this.hasSelection = false;
        this.totalSelected = 0;
        this.isIndeterminate = false;
        this.paginationHeight = 200;
        this.headerHeight = 88;
        this.gridHeight = this.height - this.headerHeight;
        this.gridHeightPagination = this.gridHeight - this.paginationHeight;
        this.totalSelectableItems = 0;
        this.config = {};
        this.tableStyle = { height: this.gridHeight + 'px' };
        this.pageInfo = { page: 1, totalItems: 0, pageSize: 25 };
        this._nativeElement = elRef.nativeElement;
        this.document = windowRef.nativeDocument;
        this.uniqueID = bentoUIDService.generate();
    }
    updateItemSource(items) {
        this.itemsSource = items.slice();
        this.resetAll();
        this.showRenderedData();
        if (this.focusID >= this.renderData.length) {
            this.focusID = this.renderData.length - 1;
        }
    }
    // Multi-select - check if all items are selected
    isAllSelected() {
        return false;
    }
    onRowClick(item, i) {
        this.selection[item[this.columnKey]] = !this.selection[item[this.columnKey]];
        this.onCheckboxChange(item, i);
        const previousRowClicked = Object.assign({}, this.lastRowClicked);
        this.lastRowClicked = {
            id: i,
            selected: this.selection[item[this.columnKey]]
        };
        if (previousRowClicked !== null && this.shiftPressed) {
            this.selectAllBetween(previousRowClicked, this.lastRowClicked);
        }
    }
    onFilterChange() {
        this.pageInfo.page = 1;
        this.showRenderedData();
    }
    onCheckboxChange(item, i) {
        this.totalSelected = this.getSelectedCount();
        if (this.totalSelected > 0 && this.totalSelected !== this.itemsSource.length) {
            this.isIndeterminate = true;
            this.headerCheckboxModel = false;
        }
        else if (this.totalSelected > 0 && this.totalSelected === this.itemsSource.length) {
            this.isIndeterminate = false;
            this.headerCheckboxModel = true;
        }
        else {
            this.isIndeterminate = false;
            this.headerCheckboxModel = false;
        }
        this.focusRow(i);
        this.updateAria(item, i);
    }
    selectAllBetween(lastRowClicked, nextRowClicked) {
        const min = Math.min(lastRowClicked.id, nextRowClicked.id);
        const max = Math.max(lastRowClicked.id, nextRowClicked.id);
        let selected = lastRowClicked.selected;
        if (lastRowClicked.selected !== nextRowClicked.selected) {
            selected = nextRowClicked.selected;
        }
        for (let i = min; i <= max; i++) {
            this.selection[this.renderData[i][this.columnKey]] = selected;
        }
        this.totalSelected = this.getSelectedCount();
    }
    resetAll() {
        this.selection = [];
        this.lastRowClicked = null;
        this.headerCheckboxModel = false;
        this.isIndeterminate = false;
        this.hasSelection = false;
        this.filterValue = '';
        this.activeCol = undefined;
        this.filteredData = [];
        this.totalSelected = 0;
        this.colHeaderSort = {};
    }
    updateAria(item, i) {
        if (this.totalSelected === 0) {
            this.activeDescendant = null;
        }
        else if (this.selection[item[this.columnKey]]) {
            this.updateActiveDescendant(i);
        }
        this.liveRegionMessage =
            this.title +
                ' ' +
                (this.totalSelected > 0
                    ? this.translate
                        .instantTranslate('BENTO_UI_TRANSFER_BOX_SUB_TITLE')
                        .replace('_SELECTED_', String(this.totalSelected))
                        .replace('_TOTAL_', this.pageInfo.totalItems)
                    : this.pageInfo.totalItems);
    }
    updateActiveDescendant(i) {
        this.activeDescendant = 'tb' + this.uniqueID + 'opt' + i;
    }
    onHeaderClick(col) {
        this.activeCol = col.binding;
        // reset other sort
        for (const property in this.colHeaderSort) {
            if (this.colHeaderSort.hasOwnProperty(property)) {
                if (property !== this.activeCol) {
                    this.colHeaderSort[property] = undefined;
                }
            }
        }
        if (this.colHeaderSort[col.binding] === undefined) {
            this.colHeaderSort[col.binding] = { count: 0, sortDirection: '' };
        }
        this.colHeaderSort[col.binding].count++;
        this.colHeaderSort[col.binding].count = this.colHeaderSort[col.binding].count % 3;
        this.colHeaderSort[col.binding].sortDirection = this.sortDirections[this.colHeaderSort[col.binding].count];
        this.showRenderedData();
    }
    // Need to mimic the keyboard functionality of a button
    onHeaderKeypress(e, col) {
        // If spacebar or enter keypress events, trigger onHeaderClick()
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault(); // Prevents window from scrolling on spacebar keypress
            this.onHeaderClick(col);
        }
    }
    isFiltered() {
        return this.filterValue && this.filterValue.length;
    }
    // Multi-select - check if all items are selected
    getSelectedCount() {
        if (!this.itemsSource) {
            return;
        }
        if (this.selection.length === 0) {
            return;
        }
        let count = 0;
        for (let i = 0, ttl = this.selection.length; i < ttl; i++) {
            if (this.selection[i] === true) {
                count++;
            }
        }
        if (count > 0) {
            this.hasSelection = true;
        }
        else {
            this.hasSelection = false;
        }
        return count;
    }
    toggleAll(forceTrue) {
        this.headerCheckboxModel = forceTrue ? true : !this.headerCheckboxModel;
        this.isIndeterminate = false;
        this.checkAll();
    }
    // Multi-select - toggle all checkboxes
    checkAll() {
        if (!this.itemsSource) {
            return;
        }
        if (!this.headerCheckboxModel) {
            this.selection = [];
            this.hasSelection = false;
            // vm.totalSelected = 0;
        }
        else if (this.isFiltered()) {
            this.selection = [];
            this.hasSelection = false;
            if (this.filteredData.length) {
                this.hasSelection = true;
            }
            this.filteredData.forEach(item => {
                this.selection[item[this.columnKey]] = true;
            });
        }
        else {
            if (this.itemsSource.length) {
                this.hasSelection = true;
            }
            this.itemsSource.forEach(item => {
                this.selection[item[this.columnKey]] = true;
            });
        }
        this.totalSelected = this.getSelectedCount();
    }
    // Transfer
    transferItemsClick() {
        this.lastRowClicked = null;
        this.transferItems.emit();
    }
    onFocus() {
        if (this.renderData.length > 0 && this.focusID < 0) {
            this.focusRow(0);
        }
    }
    ngOnInit() {
        this.updateHeight();
    }
    ngOnChanges(changes) {
        if (changes.hidePagination) {
            this.onTogglePagination();
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            let el;
            this.boxAriaLabel = this.title.replace(/\s/g, '');
            // add role, labelby & describeby attribute to the container
            this.r.setAttribute(this._nativeElement, 'aria-labelledby', 'tblabel' + this.uniqueID);
            // give pagination button aria-label as per the BoxID
            const paginationButtonEls = this._nativeElement.querySelectorAll('bento-pagination .paginate-button button');
            for (let i = 0; paginationButtonEls && i < paginationButtonEls.length; i++) {
                this.updateLabel(paginationButtonEls[i]);
            }
            // give pagination combobox (items per page) aria-label as per the BoxID
            el = this._nativeElement.querySelector('bento-pagination .paginate-bento-select select');
            el ? this.updateLabel(el) : '';
        });
    }
    updateLabel(el, overrideText) {
        if (overrideText) {
            this.r.setAttribute(el, 'aria-label', overrideText);
        }
        else {
            this.r.setAttribute(el, 'aria-describedby', 'tblabel' + this.uniqueID);
        }
    }
    trackByFn(index) {
        return index;
    }
    onKeyup(event) {
        if (event.keyCode === Keyboard.SHIFT) {
            this.shiftPressed = false;
            // this.lastRowClickedID = null;
        }
    }
    onKeydown(event) {
        const focusedEl = this.document.activeElement;
        if (!focusedEl.classList.contains('bento-table-body')) {
            return;
        }
        if (event.keyCode === Keyboard.SHIFT) {
            this.shiftPressed = true;
        }
        if (this.totalSelected > 0) {
            switch (event.keyCode) {
                case Keyboard.ENTER:
                    if (this.boxID === '1') {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
                case Keyboard.DELETE:
                case Keyboard.BACKSPACE:
                    if (this.boxID === '2') {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
                case Keyboard.RIGHT:
                    if (event.altKey && ((this.boxID === '1' && !this.isRtl) || (this.boxID === '2' && this.isRtl))) {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
                case Keyboard.LEFT:
                    if (event.altKey && ((this.boxID === '2' && !this.isRtl) || (this.boxID === '1' && this.isRtl))) {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
            }
        }
        switch (event.keyCode) {
            case Keyboard.SPACE:
                if (this.focusID >= 0) {
                    this.selectRow();
                    event.preventDefault();
                }
                break;
            case Keyboard.UP:
                this.moveUpRow(event);
                event.preventDefault();
                break;
            case Keyboard.DOWN:
                this.moveDownRow(event);
                event.preventDefault();
                break;
            case Keyboard.HOME:
                this.focusFirstRow(event);
                event.preventDefault();
                break;
            case Keyboard.END:
                this.focusLastRow(event);
                event.preventDefault();
                break;
            // Character A
            case 65:
                if (event.ctrlKey) {
                    this.toggleAll();
                    event.preventDefault();
                }
                break;
        }
    }
    focusFirstRow(event) {
        if (event.shiftKey && event.ctrlKey) {
            for (let i = this.focusID; i >= 0; i--) {
                this.focusRow(i, true);
                this.selectRow(true);
            }
        }
        else {
            this.focusRow(0, true);
        }
    }
    focusLastRow(event) {
        let pageSize = this.hidePagination ? this.renderData.length - 1 : this.pageInfo.pageSize - 1;
        pageSize = this.renderData.length - 1 < pageSize ? this.renderData.length - 1 : pageSize;
        if (event.shiftKey && event.ctrlKey) {
            for (let i = this.focusID; i <= pageSize; i++) {
                this.focusRow(i, true);
                this.selectRow(true);
            }
        }
        else {
            this.focusRow(pageSize, true);
        }
    }
    focusRow(id, isKeyAction) {
        const currentID = this.focusID;
        this.focusID = id;
        // const range = this.vScroll.measureRangeSize({start: 0, end: 16});
        const tableElement = this._nativeElement.querySelector('.bento-table-body');
        tableElement.focus();
        const rowElement = this._nativeElement.querySelector('#tb' + this.uniqueID + 'opt' + id);
        if (rowElement) {
            rowElement.focus();
        }
        if (isKeyAction) {
            const keyRange = this.vScroll.getRenderedRange();
            const pad = 5;
            if (id <= keyRange.start + pad || id >= keyRange.end - pad) {
                const scrollBehavior = Math.abs(currentID - id) < 100 ? 'smooth' : 'auto';
                this.vScroll.scrollToIndex(id, scrollBehavior);
            }
        }
        this.updateActiveDescendant(id);
    }
    selectRow(forceTrue) {
        const item = this.renderData[this.focusID];
        this.selection[item[this.columnKey]] = forceTrue ? true : !this.selection[item[this.columnKey]];
        this.onCheckboxChange(item, this.focusID);
    }
    moveUpRow(event) {
        if (event.shiftKey) {
            this.selectRow(true);
        }
        const targetRow = this.focusID <= 0 ? 0 : this.focusID - 1;
        this.focusRow(targetRow, true);
        if (event.shiftKey) {
            this.selectRow(true);
        }
    }
    moveDownRow(event) {
        if (event.shiftKey) {
            this.selectRow(true);
        }
        const maxRow = this.hidePagination ? this.renderData.length : this.pageInfo.pageSize;
        const id = this.focusID >= maxRow - 1 ? maxRow - 1 : this.focusID + 1;
        this.focusRow(id, true);
        if (event.shiftKey) {
            this.selectRow(true);
        }
    }
    /** Returns a sorted copy of the data. */
    sortData(data, colID, sortDirection) {
        // return original data if sort reset
        if (!colID || !sortDirection || sortDirection === '') {
            return data;
        }
        // return a copy of the data sorted
        return this.heapSort(data.slice(), colID, sortDirection);
    }
    heapSort(heaparray, colID, sortDirection) {
        function heapify(array, index, heapSize) {
            const left = 2 * index + 1, right = 2 * index + 2;
            let largest = index;
            if (left < heapSize &&
                (sortDirection === 'asc' ? array[left][colID] > array[index][colID] : array[left][colID] < array[index][colID])) {
                largest = left;
            }
            if (right < heapSize &&
                (sortDirection === 'asc'
                    ? array[right][colID] > array[largest][colID]
                    : array[right][colID] < array[largest][colID])) {
                largest = right;
            }
            if (largest !== index) {
                const tmp = array[index];
                array[index] = array[largest];
                array[largest] = tmp;
                heapify(array, largest, heapSize);
            }
        }
        function buildMaxHeap(array) {
            for (let i = Math.floor(array.length / 2); i >= 0; i -= 1) {
                heapify(array, i, array.length);
            }
            return array;
        }
        let size = heaparray.length, temp;
        buildMaxHeap(heaparray);
        for (let i = heaparray.length - 1; i > 0; i -= 1) {
            temp = heaparray[0];
            heaparray[0] = heaparray[i];
            heaparray[i] = temp;
            size -= 1;
            heapify(heaparray, 0, size);
        }
        return heaparray;
    }
    showRenderedData() {
        // var sortedData = ;
        this.lastRowClicked = null;
        let renderData = this.itemsSource;
        if (this.activeCol) {
            renderData = this.sortData(renderData, this.activeCol, this.colHeaderSort[this.activeCol].sortDirection);
        }
        // if filtered
        if (this.isFiltered()) {
            renderData = renderData.slice().filter(item => {
                let searchStr = '';
                if (this.columnDefinitions) {
                    this.columnDefinitions.forEach(colDef => {
                        if (item[colDef.binding]) {
                            searchStr += String(item[colDef.binding]).toLowerCase();
                        }
                    });
                }
                return searchStr.indexOf(this.filterValue.toLowerCase()) !== -1;
            });
            this.filteredData = renderData.slice();
        }
        else {
            this.filteredData = [];
        }
        this.pageInfo.totalItems = renderData.length;
        if (this.pageInfo.totalItems < this.pageInfo.pageSize) {
            this.pageInfo.page = 1;
        }
        const startIndex = (this.pageInfo.page - 1) * this.pageInfo.pageSize;
        if (!this.hidePagination) {
            this.renderData = renderData.slice().splice(startIndex, this.pageInfo.pageSize);
        }
        else {
            this.renderData = renderData;
        }
    }
    onPageChange() {
        setTimeout(() => {
            this.liveRegionMessage = this._nativeElement.querySelector('.paginate-info').innerHTML;
            this.showRenderedData();
        });
    }
    onItemsPerPageChange() {
        setTimeout(() => {
            this.liveRegionMessage = this._nativeElement.querySelector('.paginate-info-select span').innerHTML;
            this.showRenderedData();
        });
    }
    updateHeight() {
        this.gridHeight = this.height - this.headerHeight;
        this.gridHeightPagination = this.gridHeight - this.paginationHeight;
        this.tableStyle.height = this.hidePagination ? this.gridHeight + 'px' : this.gridHeightPagination + 'px';
    }
    onTogglePagination() {
        if (!this.itemsSource) {
            return;
        }
        this.updateHeight();
        this.showRenderedData();
    }
}
BentoTransferlistComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferlistComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BentoTranslate }, { token: BentoUidService }, { token: WindowRef }], target: i0.ɵɵFactoryTarget.Component });
BentoTransferlistComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTransferlistComponent, selector: "bento-transferlist", inputs: { height: "height", title: "title", infoShown: "infoShown", subTitle: "subTitle", columnDefinitions: "columnDefinitions", hidePagination: "hidePagination", hideFilters: "hideFilters", disableTransfer: "disableTransfer", transferBtnText: "transferBtnText", transferBoxDescriptionText: "transferBoxDescriptionText", searchText: "searchText", boxID: "boxID", columnKey: "columnKey", isRtl: "isRtl" }, outputs: { transferItems: "transferItems" }, host: { listeners: { "keyup": "onKeyup($event)", "keydown": "onKeydown($event)" } }, providers: [BentoNotification], viewQueries: [{ propertyName: "filter", first: true, predicate: ["filter"], descendants: true, static: true }, { propertyName: "vScroll", first: true, predicate: CdkVirtualScrollViewport, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"bento-toolbar\">\n  <ul *ngIf=\"boxID === '2'\" class=\"navbar-list\">\n    <li>\n      <button\n        [attr.aria-keyshortcuts]=\"isRtl ? 'Alt+ArrowRight Enter' : 'Alt+ArrowLeft Enter'\"\n        class=\"transferlist-btn btn btn-outline-primary transferbox-transfer-button\"\n        (click)=\"transferItemsClick()\"\n        [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n        [attr.aria-disabled]=\"totalSelected === 0 || disableTransfer\"\n        [disabled]=\"totalSelected === 0 || disableTransfer\"\n      >\n        <i class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n        <span class=\"btn-text\">\n          {{ 'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE' | bentoTranslate: transferBtnText }}\n        </span>\n      </button>\n    </li>\n  </ul>\n  <span class=\"transferbox-searchbox\">\n    <input\n      #filter\n      bentoReset\n      id=\"search{{ uniqueID }}\"\n      class=\"form-control\"\n      [attr.aria-labelledby]=\"'search' + uniqueID\"\n      [(ngModel)]=\"filterValue\"\n      (ngModelChange)=\"onFilterChange()\"\n      type=\"text\"\n    />\n    <label for=\"search{{ uniqueID }}\" class=\"transferbox-searchbox-label\">\n      {{ 'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate: searchText }}\n    </label>\n  </span>\n  <ul *ngIf=\"boxID === '1'\" class=\"navbar-list\">\n    <li>\n      <button\n        [attr.aria-keyshortcuts]=\"!isRtl ? 'Alt+ArrowRight Enter' : 'Alt+ArrowLeft Enter'\"\n        class=\"transferlist-btn btn btn-outline-primary transferbox-transfer-button\"\n        (click)=\"transferItemsClick()\"\n        [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n        [attr.aria-disabled]=\"totalSelected === 0 || disableTransfer\"\n        [disabled]=\"totalSelected === 0 || disableTransfer\"\n      >\n        <span class=\"btn-text\">\n          {{ 'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD' | bentoTranslate: transferBtnText }}\n        </span>\n\n        <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n      </button>\n    </li>\n  </ul>\n</div>\n\n<div class=\"transferlist-header\">\n  <div class=\"transferlist-header-info\" *ngIf=\"infoShown\">\n    <p [attr.id]=\"'tblabel' + uniqueID\" class=\"transferlist-header-title\">\n      {{ title }}\n    </p>\n    <div class=\"transferlist-select-info\">\n      {{\n        totalSelected > 0\n          ? ('BENTO_UI_TRANSFER_BOX_SUB_TITLE'\n            | bentoTranslate: subTitle\n            | bentoStringReplace: '_SELECTED_':totalSelected\n            | bentoStringReplace: '_TOTAL_':pageInfo.totalItems)\n          : pageInfo.totalItems\n      }}\n    </div>\n  </div>\n</div>\n<!-- list -->\n<div class=\"bento-table-grid\">\n  <div class=\"bento-table-header-row\">\n    <bento-checkbox\n      #headerCheckbox\n      id=\"header-cb-{{ uniqueID }}\"\n      [(ngModel)]=\"headerCheckboxModel\"\n      (change)=\"$event ? checkAll() : null\"\n      [indeterminate]=\"isIndeterminate\"\n      [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n    ></bento-checkbox>\n    <label for=\"header-cb-{{ uniqueID }}\" class=\"sr-only\">{{ 'BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL' | bentoTranslate}}</label>\n    <span role=\"button\" tabindex=\"0\" *ngFor=\"let col of columnDefinitions\" class=\"bento-table-column-header\"\n      attr.aria-label=\"{{ 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_SORT_BY' | bentoTranslate }} {{ col.header }}\"\n      (click)=\"onHeaderClick(col)\"\n      (keydown)=\"onHeaderKeypress($event, col)\">\n      {{ col.header }}\n      <i\n        class=\"sort-icon\"\n        [ngClass]=\"\n          (colHeaderSort[col.binding]?.sortDirection === 'asc' ? 'bento-icon-chevron-up ' : '') +\n          (colHeaderSort[col.binding]?.sortDirection === 'desc' ? 'bento-icon-chevron-down ' : '')\n        \"\n        aria-hidden=\"true\"\n      ></i>\n    </span>\n  </div>\n  <cdk-virtual-scroll-viewport\n    itemSize=\"34\"\n    tabindex=\"0\"\n    role=\"listbox\"\n    class=\"bento-table-body\"\n    [attr.id]=\"'tblist' + uniqueID\"\n    [attr.aria-labelledby]=\"'tblabel' + uniqueID\"\n    [attr.aria-activedescendant]=\"activeDescendant\"\n    aria-multiselectable=\"true\"\n    (focus)=\"onFocus()\"\n    [ngStyle]=\"tableStyle\"\n  >\n    <div\n      *cdkVirtualFor=\"let item of renderData; let i = index; trackBy: trackByFn\"\n      class=\"example-item\"\n      class=\"bento-table-row\"\n      role=\"option\"\n      [attr.id]=\"'tb' + uniqueID + 'opt' + i\"\n      [attr.aria-selected]=\"!!selection[item[columnKey]]\"\n      [attr.aria-setsize]=\"renderData.length\"\n      [attr.aria-posinset]=\"i + 1\"\n      [ngClass]=\"(selection[item[columnKey]] ? 'selected ' : '') + (focusID === i ? 'focused ' : '')\"\n      (click)=\"onRowClick(item, i)\"\n    >\n      <span class=\"sr-only\" id=\"cb-a11y-{{ uniqueID }}-{{i}}\">\n        {{\n          'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_CHECKBOX_LABEL'\n            | bentoTranslate\n            | bentoStringReplace: '_ROW_ID_':item[columnKey]\n        }}\n      </span>\n      <bento-checkbox\n        class=\"bento-checkbox\"\n        id=\"cb-{{ uniqueID }}-{{i}}\"\n        [tabIndex]=\"-1\"\n        (click)=\"onRowClick(item, i)\"\n        [attr.aria-labelledby]=\"'cb' + uniqueID + '-i'\"\n        [(ngModel)]=\"selection[item[columnKey]]\"\n      ></bento-checkbox>\n      <label for=\"cb-{{ uniqueID }}-{{i}}\" class=\"font-weight-normal\" *ngFor=\"let col of columnDefinitions\">{{ item[col.binding] }}</label>\n    </div>\n  </cdk-virtual-scroll-viewport>\n</div>\n<bento-pagination\n  *ngIf=\"!hidePagination\"\n  #pagination\n  [(page)]=\"pageInfo.page\"\n  (pageChange)=\"onPageChange()\"\n  (itemsPerPageChange)=\"onItemsPerPageChange()\"\n  [goToLink]=\"false\"\n  [directionLinks]=\"true\"\n  [boundaryLinks]=\"false\"\n  [totalItems]=\"pageInfo.totalItems\"\n  [(itemsPerPage)]=\"pageInfo.pageSize\"\n></bento-pagination>\n<div class=\"sr-only\">\n  \"Last change: \"\n  <span role=\"status\" aria-atomic=\"true\" aria-live=\"polite\" [attr.id]=\"'tb_live_region' + uniqueID\">\n    {{ liveRegionMessage }}\n  </span>\n</div>\n", components: [{ type: BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: i5.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { type: BentoPaginationComponent, selector: "bento-pagination", inputs: ["page", "totalItems", "itemsPerPage", "goToLink", "hideItemsPerPage", "boundaryLinks", "infoText", "infoPageText", "goToText", "directionLinks", "itemsArray", "pageOverride", "useStrings"], outputs: ["pageChange", "itemsPerPageChange", "eventTracking"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { type: i3$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i5.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }], pipes: { "bentoTranslate": BentoTranslatePipe, "bentoStringReplace": BentoStringReplacePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferlistComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-transferlist', providers: [BentoNotification], template: "<div class=\"bento-toolbar\">\n  <ul *ngIf=\"boxID === '2'\" class=\"navbar-list\">\n    <li>\n      <button\n        [attr.aria-keyshortcuts]=\"isRtl ? 'Alt+ArrowRight Enter' : 'Alt+ArrowLeft Enter'\"\n        class=\"transferlist-btn btn btn-outline-primary transferbox-transfer-button\"\n        (click)=\"transferItemsClick()\"\n        [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n        [attr.aria-disabled]=\"totalSelected === 0 || disableTransfer\"\n        [disabled]=\"totalSelected === 0 || disableTransfer\"\n      >\n        <i class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n        <span class=\"btn-text\">\n          {{ 'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE' | bentoTranslate: transferBtnText }}\n        </span>\n      </button>\n    </li>\n  </ul>\n  <span class=\"transferbox-searchbox\">\n    <input\n      #filter\n      bentoReset\n      id=\"search{{ uniqueID }}\"\n      class=\"form-control\"\n      [attr.aria-labelledby]=\"'search' + uniqueID\"\n      [(ngModel)]=\"filterValue\"\n      (ngModelChange)=\"onFilterChange()\"\n      type=\"text\"\n    />\n    <label for=\"search{{ uniqueID }}\" class=\"transferbox-searchbox-label\">\n      {{ 'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate: searchText }}\n    </label>\n  </span>\n  <ul *ngIf=\"boxID === '1'\" class=\"navbar-list\">\n    <li>\n      <button\n        [attr.aria-keyshortcuts]=\"!isRtl ? 'Alt+ArrowRight Enter' : 'Alt+ArrowLeft Enter'\"\n        class=\"transferlist-btn btn btn-outline-primary transferbox-transfer-button\"\n        (click)=\"transferItemsClick()\"\n        [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n        [attr.aria-disabled]=\"totalSelected === 0 || disableTransfer\"\n        [disabled]=\"totalSelected === 0 || disableTransfer\"\n      >\n        <span class=\"btn-text\">\n          {{ 'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD' | bentoTranslate: transferBtnText }}\n        </span>\n\n        <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n      </button>\n    </li>\n  </ul>\n</div>\n\n<div class=\"transferlist-header\">\n  <div class=\"transferlist-header-info\" *ngIf=\"infoShown\">\n    <p [attr.id]=\"'tblabel' + uniqueID\" class=\"transferlist-header-title\">\n      {{ title }}\n    </p>\n    <div class=\"transferlist-select-info\">\n      {{\n        totalSelected > 0\n          ? ('BENTO_UI_TRANSFER_BOX_SUB_TITLE'\n            | bentoTranslate: subTitle\n            | bentoStringReplace: '_SELECTED_':totalSelected\n            | bentoStringReplace: '_TOTAL_':pageInfo.totalItems)\n          : pageInfo.totalItems\n      }}\n    </div>\n  </div>\n</div>\n<!-- list -->\n<div class=\"bento-table-grid\">\n  <div class=\"bento-table-header-row\">\n    <bento-checkbox\n      #headerCheckbox\n      id=\"header-cb-{{ uniqueID }}\"\n      [(ngModel)]=\"headerCheckboxModel\"\n      (change)=\"$event ? checkAll() : null\"\n      [indeterminate]=\"isIndeterminate\"\n      [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n    ></bento-checkbox>\n    <label for=\"header-cb-{{ uniqueID }}\" class=\"sr-only\">{{ 'BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL' | bentoTranslate}}</label>\n    <span role=\"button\" tabindex=\"0\" *ngFor=\"let col of columnDefinitions\" class=\"bento-table-column-header\"\n      attr.aria-label=\"{{ 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_SORT_BY' | bentoTranslate }} {{ col.header }}\"\n      (click)=\"onHeaderClick(col)\"\n      (keydown)=\"onHeaderKeypress($event, col)\">\n      {{ col.header }}\n      <i\n        class=\"sort-icon\"\n        [ngClass]=\"\n          (colHeaderSort[col.binding]?.sortDirection === 'asc' ? 'bento-icon-chevron-up ' : '') +\n          (colHeaderSort[col.binding]?.sortDirection === 'desc' ? 'bento-icon-chevron-down ' : '')\n        \"\n        aria-hidden=\"true\"\n      ></i>\n    </span>\n  </div>\n  <cdk-virtual-scroll-viewport\n    itemSize=\"34\"\n    tabindex=\"0\"\n    role=\"listbox\"\n    class=\"bento-table-body\"\n    [attr.id]=\"'tblist' + uniqueID\"\n    [attr.aria-labelledby]=\"'tblabel' + uniqueID\"\n    [attr.aria-activedescendant]=\"activeDescendant\"\n    aria-multiselectable=\"true\"\n    (focus)=\"onFocus()\"\n    [ngStyle]=\"tableStyle\"\n  >\n    <div\n      *cdkVirtualFor=\"let item of renderData; let i = index; trackBy: trackByFn\"\n      class=\"example-item\"\n      class=\"bento-table-row\"\n      role=\"option\"\n      [attr.id]=\"'tb' + uniqueID + 'opt' + i\"\n      [attr.aria-selected]=\"!!selection[item[columnKey]]\"\n      [attr.aria-setsize]=\"renderData.length\"\n      [attr.aria-posinset]=\"i + 1\"\n      [ngClass]=\"(selection[item[columnKey]] ? 'selected ' : '') + (focusID === i ? 'focused ' : '')\"\n      (click)=\"onRowClick(item, i)\"\n    >\n      <span class=\"sr-only\" id=\"cb-a11y-{{ uniqueID }}-{{i}}\">\n        {{\n          'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_CHECKBOX_LABEL'\n            | bentoTranslate\n            | bentoStringReplace: '_ROW_ID_':item[columnKey]\n        }}\n      </span>\n      <bento-checkbox\n        class=\"bento-checkbox\"\n        id=\"cb-{{ uniqueID }}-{{i}}\"\n        [tabIndex]=\"-1\"\n        (click)=\"onRowClick(item, i)\"\n        [attr.aria-labelledby]=\"'cb' + uniqueID + '-i'\"\n        [(ngModel)]=\"selection[item[columnKey]]\"\n      ></bento-checkbox>\n      <label for=\"cb-{{ uniqueID }}-{{i}}\" class=\"font-weight-normal\" *ngFor=\"let col of columnDefinitions\">{{ item[col.binding] }}</label>\n    </div>\n  </cdk-virtual-scroll-viewport>\n</div>\n<bento-pagination\n  *ngIf=\"!hidePagination\"\n  #pagination\n  [(page)]=\"pageInfo.page\"\n  (pageChange)=\"onPageChange()\"\n  (itemsPerPageChange)=\"onItemsPerPageChange()\"\n  [goToLink]=\"false\"\n  [directionLinks]=\"true\"\n  [boundaryLinks]=\"false\"\n  [totalItems]=\"pageInfo.totalItems\"\n  [(itemsPerPage)]=\"pageInfo.pageSize\"\n></bento-pagination>\n<div class=\"sr-only\">\n  \"Last change: \"\n  <span role=\"status\" aria-atomic=\"true\" aria-live=\"polite\" [attr.id]=\"'tb_live_region' + uniqueID\">\n    {{ liveRegionMessage }}\n  </span>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BentoTranslate }, { type: BentoUidService }, { type: WindowRef }]; }, propDecorators: { filter: [{
                type: ViewChild,
                args: ['filter', { static: true }]
            }], vScroll: [{
                type: ViewChild,
                args: [CdkVirtualScrollViewport, { static: true }]
            }], height: [{
                type: Input
            }], title: [{
                type: Input
            }], infoShown: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], columnDefinitions: [{
                type: Input
            }], hidePagination: [{
                type: Input
            }], hideFilters: [{
                type: Input
            }], disableTransfer: [{
                type: Input
            }], transferBtnText: [{
                type: Input
            }], transferBoxDescriptionText: [{
                type: Input
            }], searchText: [{
                type: Input
            }], boxID: [{
                type: Input
            }], columnKey: [{
                type: Input
            }], isRtl: [{
                type: Input
            }], transferItems: [{
                type: Output
            }], onKeyup: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

/* eslint-disable max-len */
/**
 * The Transferbox is a tool to move items between two lists,
 * typically using the left side as the source for
 * a new list on the right.
 *
 * Please note, the transferbox data must include a column with unique keys.
 * The unique key column name should be provided to the grid using
 * the `columnKey` attribute.
 * This is to ensure that the selection feature works properly.
 * #### Keyboard Shortcuts
 * _Appropriate element must be focused, for shortcut to function._
 * | Key | Function |
 * | --- | -------- |
 * | <kbd>ENTER</kbd> _or_<br><kbd>ALT</kbd> + <kbd>RIGHT</kbd> | Send selected options to the destination box |
 * | <kbd>BACKSPACE</kbd> _or_<br><kbd>DELETE</kbd> _or_<br><kbd>ALT</kbd> + <kbd>LEFT ARROW</kbd> | Remove selected options from the destination box |
 * | <kbd>DOWN ARROW</kbd> | Move focus to the next option |
 * | <kbd>UP ARROW</kbd> | Move focus to the previous option |
 * | <kbd>HOME</kbd> | Move focus to the first option |
 * | <kbd>END</kbd> | Move focus to the last option |
 * | <kbd>SPACE</kbd> | Toggle the selection state of the focused option |
 * | <kbd>SHIFT</kbd> + <kbd>DOWN ARROW</kbd> | Move focus to the next option and select it |
 * | <kbd>SHIFT</kbd> + <kbd>UP ARROW</kbd> | Move focus to the previous option and select it |
 * | <kbd>SHIFT</kbd> + <kbd>Mouse Left-Click<kbd> | Selects/Deslects all rows between previous clicked row |
 * | <kbd>CONTROL</kbd> + <kbd>SHIFT</kbd> + <kbd>HOME</kbd> | Select from the focused option to the beginning of the list |
 * | <kbd>CONTROL</kbd> + <kbd>SHIFT</kbd> + <kbd>END</kbd> | Select from the focused option to the end of the list |
 * | <kbd>CONTROL</kbd> + <kbd>A</kbd> | Toggle Select All/Deselect All options in the list |
 */
class BentoTransferboxBasicComponent {
    constructor(elRef, translate, bentoUIDService, dir) {
        this.translate = translate;
        this.dir = dir;
        /**
         * Event handler for when a transfer action occurs. Returns
         * data collection for both grids as `gridDataOne` and `gridDataTwo`
         */
        this.transfer = new EventEmitter();
        /**
         * Set height of transferbox
         */
        this.height = 500;
        /**
         * Override default column key 'id' (Data must have a column with unique keys)
         */
        this.columnKey = 'id';
        /**
         * Toggle Pagination
         */
        this.hidePagination = false;
        this._nativeElement = elRef.nativeElement;
        this.uniqueID = bentoUIDService.generate();
        this.isRtl = this.dir.value === 'rtl';
        dir.change.subscribe(() => {
            this.isRtl = this.dir.value === 'rtl';
        });
    }
    ngOnInit() {
        this._transferItems();
    }
    transferItemsOne($event) {
        const splitItems = this._splitItems(this.boxOneItemSource, this.boxOne);
        this.boxTwoItemSource = splitItems.selectedItems.concat(this.boxTwoItemSource);
        this.boxOneItemSource = splitItems.gridItems;
        this._transferItems();
        this._updateLiveRegion('add', splitItems.selectedItems.length);
    }
    transferItemsTwo($event) {
        const splitItems = this._splitItems(this.boxTwoItemSource, this.boxTwo);
        this.boxOneItemSource = splitItems.selectedItems.concat(this.boxOneItemSource);
        this.boxTwoItemSource = splitItems.gridItems;
        this._transferItems();
        this._updateLiveRegion('remove', splitItems.selectedItems.length);
    }
    _transferItems() {
        this.boxOne.updateItemSource(this.boxOneItemSource);
        this.boxTwo.updateItemSource(this.boxTwoItemSource);
        this.transfer.emit({
            gridDataOne: this.boxOneItemSource,
            gridDataTwo: this.boxTwoItemSource
        });
    }
    _splitItems(items, transferlist) {
        const gridItems = [];
        const selectedItems = [];
        let sCount = 0;
        let gCount = 0;
        for (let i = 0, ttl = items.length; i < ttl; i++) {
            const item = items[i];
            if (transferlist.selection[item[this.columnKey]] === true) {
                selectedItems[sCount] = item;
                sCount++;
            }
            else {
                gridItems[gCount] = item;
                gCount++;
            }
        }
        return {
            gridItems,
            selectedItems
        };
    }
    _updateLiveRegion(msg, amt) {
        let translateMsg = msg === 'add'
            ? 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_ADDED'
            : 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_REMOVED';
        translateMsg = this.translate.instantTranslate(translateMsg);
        translateMsg = translateMsg.replace('_NUMBER_', String(amt)).replace('_LABEL_', this.boxTwoTitle);
        this.liveRegionMessage = translateMsg;
    }
}
BentoTransferboxBasicComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferboxBasicComponent, deps: [{ token: i0.ElementRef }, { token: BentoTranslate }, { token: BentoUidService }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoTransferboxBasicComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTransferboxBasicComponent, selector: "bento-transferbox-basic", inputs: { height: "height", boxOneItemSource: "boxOneItemSource", boxTwoItemSource: "boxTwoItemSource", columnDefinitions: "columnDefinitions", boxOneTitle: "boxOneTitle", boxTwoTitle: "boxTwoTitle", boxOneSubTitle: "boxOneSubTitle", boxTwoSubTitle: "boxTwoSubTitle", searchText: "searchText", disableTransfer: "disableTransfer", boxOneTransferBtnText: "boxOneTransferBtnText", boxTwoTransferBtnText: "boxTwoTransferBtnText", columnKey: "columnKey", hidePagination: "hidePagination" }, outputs: { transfer: "transfer" }, viewQueries: [{ propertyName: "boxOne", first: true, predicate: ["boxOne"], descendants: true, static: true }, { propertyName: "boxTwo", first: true, predicate: ["boxTwo"], descendants: true, static: true }], ngImport: i0, template: "<div [ngStyle]=\"{height: height + 'px'}\" class=\"bento-transferlist-container\">\n  <bento-transferlist\n    #boxOne\n    class=\"transferlist\"\n    [height]=\"height\"\n    [title]=\"boxOneTitle\"\n    [columnDefinitions]=\"columnDefinitions\"\n    [subTitle]=\"boxOneSubTitle\"\n    [searchText]=\"searchText\"\n    [transferBtnText]=\"boxOneTransferBtnText\"\n    [disableTransfer]=\"disableTransfer\"\n    (transferItems)=\"transferItemsOne($event)\"\n    [hidePagination]=\"hidePagination\"\n    [columnKey]=\"columnKey\"\n    [isRtl]=\"isRtl\"\n  ></bento-transferlist>\n  <bento-transferlist\n    #boxTwo\n    class=\"transferlist\"\n    [height]=\"height\"\n    [title]=\"boxTwoTitle\"\n    [columnDefinitions]=\"columnDefinitions\"\n    [subTitle]=\"boxTwoSubTitle\"\n    [searchText]=\"searchText\"\n    [transferBtnText]=\"boxTwoTransferBtnText\"\n    [disableTransfer]=\"disableTransfer\"\n    (transferItems)=\"transferItemsTwo($event)\"\n    [hidePagination]=\"hidePagination\"\n    [columnKey]=\"columnKey\"\n    [boxID]=\"'2'\"\n    [isRtl]=\"isRtl\"\n  ></bento-transferlist>\n</div>\n<div class=\"sr-only\">\n  \"Last change: \"\n  <span role=\"status\" aria-atomic=\"true\" aria-live=\"polite\" [attr.id]=\"'tb_live_region' + uniqueID\">\n    {{ liveRegionMessage }}\n  </span>\n</div>\n", styles: [".ng-bento bento-transferbox-basic bento-checkbox{margin:0 12px}.ng-bento bento-transferbox-basic bento-checkbox.disabled{background:transparent;opacity:.5}.ng-bento bento-transferbox-basic bento-checkbox.disabled input{cursor:not-allowed}[dir=rtl] .ng-bento bento-transferbox-basic bento-checkbox{margin:0 12px}.ng-bento bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox{pointer-events:none}.ng-bento bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox input{pointer-events:none}.ng-bento bento-transferbox-basic .bento-transferlist-container{display:flex}.ng-bento bento-transferbox-basic .transferlist{position:relative;flex:1;min-width:324px;display:inline-block;vertical-align:top}.ng-bento bento-transferbox-basic .transferlist:first-child{margin-right:30px}[dir=rtl] .ng-bento bento-transferbox-basic .transferlist:first-child{margin-right:0;margin-left:30px}.ng-bento bento-transferbox-basic .sort-icon{margin:0 5px;line-height:1em}.ng-bento bento-transferbox-basic .transferlist-header{position:absolute;right:10px;text-align:right;z-index:2;display:flex;align-items:center;height:44px}[dir=rtl] .ng-bento bento-transferbox-basic .transferlist-header{right:auto;left:10px;text-align:left}.ng-bento bento-transferbox-basic .transferlist-header .transferlist-header-title{margin:0;font-weight:700;font-size:13px;line-height:1.2}.ng-bento bento-transferbox-basic .bento-toolbar{display:flex;align-items:center;padding:10px;justify-content:space-between}.ng-bento bento-transferbox-basic .bento-transferlist-table{border-bottom-width:1px;border-bottom-style:solid;margin-top:43px}.ng-bento bento-transferbox-basic .bento-transferlist-table-header{position:absolute;z-index:0;overflow:hidden}.ng-bento bento-transferbox-basic .bento-transferlist-table-header .cdk-header-cell{font-size:13px}.ng-bento bento-transferbox-basic .bento-transferlist-table-header .cdk-column-select,.ng-bento bento-transferbox-basic .bento-transferlist-table .cdk-column-select{max-width:26px;padding:0 10px}.ng-bento bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{font-size:1em}[dir=rtl] .ng-bento bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{margin:0!important;transform:scaleX(-1)}.ng-bento bento-transferbox-basic .bento-table-grid{border-bottom:none;border-top:none}.ng-bento bento-transferbox-basic .bento-table-grid:after{content:\" \";height:1px;width:100%;display:block;position:absolute;margin-top:-1px;left:0}.ng-bento bento-transferbox-basic .bento-table-column-header{line-height:44px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-transferbox-basic .bento-table-column-header:focus{outline-style:dashed;outline-width:1px}.ng-bento bento-transferbox-basic .bento-table-header-row{height:44px;display:flex;align-items:center;font-size:13px;font-weight:700}.ng-bento bento-transferbox-basic .bento-table-body{overflow-y:auto;padding:0;margin:0}.ng-bento bento-transferbox-basic .bento-table-row{align-items:center;display:flex;height:34px;list-style-type:none;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-transferbox-basic .bento-table-row:focus{outline:none!important}.ng-bento bento-transferbox-basic .bento-table-row.focused:after{content:\" \";display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;border:1px dotted;pointer-events:none}.ng-bento bento-transferbox-basic .bento-table-row label,.ng-bento bento-transferbox-basic .bento-table-header-row label{margin:0;min-width:80px}.ng-bento bento-transferbox-basic .transferbox-searchbox{align-items:center;display:flex;position:relative;width:170px}.ng-bento bento-transferbox-basic .transferbox-searchbox-label{left:12px;position:absolute}\n"], components: [{ type: BentoTransferlistComponent, selector: "bento-transferlist", inputs: ["height", "title", "infoShown", "subTitle", "columnDefinitions", "hidePagination", "hideFilters", "disableTransfer", "transferBtnText", "transferBoxDescriptionText", "searchText", "boxID", "columnKey", "isRtl"], outputs: ["transferItems"] }], directives: [{ type: i3$2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferboxBasicComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-transferbox-basic', encapsulation: ViewEncapsulation.None, template: "<div [ngStyle]=\"{height: height + 'px'}\" class=\"bento-transferlist-container\">\n  <bento-transferlist\n    #boxOne\n    class=\"transferlist\"\n    [height]=\"height\"\n    [title]=\"boxOneTitle\"\n    [columnDefinitions]=\"columnDefinitions\"\n    [subTitle]=\"boxOneSubTitle\"\n    [searchText]=\"searchText\"\n    [transferBtnText]=\"boxOneTransferBtnText\"\n    [disableTransfer]=\"disableTransfer\"\n    (transferItems)=\"transferItemsOne($event)\"\n    [hidePagination]=\"hidePagination\"\n    [columnKey]=\"columnKey\"\n    [isRtl]=\"isRtl\"\n  ></bento-transferlist>\n  <bento-transferlist\n    #boxTwo\n    class=\"transferlist\"\n    [height]=\"height\"\n    [title]=\"boxTwoTitle\"\n    [columnDefinitions]=\"columnDefinitions\"\n    [subTitle]=\"boxTwoSubTitle\"\n    [searchText]=\"searchText\"\n    [transferBtnText]=\"boxTwoTransferBtnText\"\n    [disableTransfer]=\"disableTransfer\"\n    (transferItems)=\"transferItemsTwo($event)\"\n    [hidePagination]=\"hidePagination\"\n    [columnKey]=\"columnKey\"\n    [boxID]=\"'2'\"\n    [isRtl]=\"isRtl\"\n  ></bento-transferlist>\n</div>\n<div class=\"sr-only\">\n  \"Last change: \"\n  <span role=\"status\" aria-atomic=\"true\" aria-live=\"polite\" [attr.id]=\"'tb_live_region' + uniqueID\">\n    {{ liveRegionMessage }}\n  </span>\n</div>\n", styles: [".ng-bento bento-transferbox-basic bento-checkbox{margin:0 12px}.ng-bento bento-transferbox-basic bento-checkbox.disabled{background:transparent;opacity:.5}.ng-bento bento-transferbox-basic bento-checkbox.disabled input{cursor:not-allowed}[dir=rtl] .ng-bento bento-transferbox-basic bento-checkbox{margin:0 12px}.ng-bento bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox{pointer-events:none}.ng-bento bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox input{pointer-events:none}.ng-bento bento-transferbox-basic .bento-transferlist-container{display:flex}.ng-bento bento-transferbox-basic .transferlist{position:relative;flex:1;min-width:324px;display:inline-block;vertical-align:top}.ng-bento bento-transferbox-basic .transferlist:first-child{margin-right:30px}[dir=rtl] .ng-bento bento-transferbox-basic .transferlist:first-child{margin-right:0;margin-left:30px}.ng-bento bento-transferbox-basic .sort-icon{margin:0 5px;line-height:1em}.ng-bento bento-transferbox-basic .transferlist-header{position:absolute;right:10px;text-align:right;z-index:2;display:flex;align-items:center;height:44px}[dir=rtl] .ng-bento bento-transferbox-basic .transferlist-header{right:auto;left:10px;text-align:left}.ng-bento bento-transferbox-basic .transferlist-header .transferlist-header-title{margin:0;font-weight:700;font-size:13px;line-height:1.2}.ng-bento bento-transferbox-basic .bento-toolbar{display:flex;align-items:center;padding:10px;justify-content:space-between}.ng-bento bento-transferbox-basic .bento-transferlist-table{border-bottom-width:1px;border-bottom-style:solid;margin-top:43px}.ng-bento bento-transferbox-basic .bento-transferlist-table-header{position:absolute;z-index:0;overflow:hidden}.ng-bento bento-transferbox-basic .bento-transferlist-table-header .cdk-header-cell{font-size:13px}.ng-bento bento-transferbox-basic .bento-transferlist-table-header .cdk-column-select,.ng-bento bento-transferbox-basic .bento-transferlist-table .cdk-column-select{max-width:26px;padding:0 10px}.ng-bento bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{font-size:1em}[dir=rtl] .ng-bento bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{margin:0!important;transform:scaleX(-1)}.ng-bento bento-transferbox-basic .bento-table-grid{border-bottom:none;border-top:none}.ng-bento bento-transferbox-basic .bento-table-grid:after{content:\" \";height:1px;width:100%;display:block;position:absolute;margin-top:-1px;left:0}.ng-bento bento-transferbox-basic .bento-table-column-header{line-height:44px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-transferbox-basic .bento-table-column-header:focus{outline-style:dashed;outline-width:1px}.ng-bento bento-transferbox-basic .bento-table-header-row{height:44px;display:flex;align-items:center;font-size:13px;font-weight:700}.ng-bento bento-transferbox-basic .bento-table-body{overflow-y:auto;padding:0;margin:0}.ng-bento bento-transferbox-basic .bento-table-row{align-items:center;display:flex;height:34px;list-style-type:none;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-bento bento-transferbox-basic .bento-table-row:focus{outline:none!important}.ng-bento bento-transferbox-basic .bento-table-row.focused:after{content:\" \";display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;border:1px dotted;pointer-events:none}.ng-bento bento-transferbox-basic .bento-table-row label,.ng-bento bento-transferbox-basic .bento-table-header-row label{margin:0;min-width:80px}.ng-bento bento-transferbox-basic .transferbox-searchbox{align-items:center;display:flex;position:relative;width:170px}.ng-bento bento-transferbox-basic .transferbox-searchbox-label{left:12px;position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoTranslate }, { type: BentoUidService }, { type: i2.Directionality }]; }, propDecorators: { boxOne: [{
                type: ViewChild,
                args: ['boxOne', { static: true }]
            }], boxTwo: [{
                type: ViewChild,
                args: ['boxTwo', { static: true }]
            }], transfer: [{
                type: Output
            }], height: [{
                type: Input
            }], boxOneItemSource: [{
                type: Input
            }], boxTwoItemSource: [{
                type: Input
            }], columnDefinitions: [{
                type: Input
            }], boxOneTitle: [{
                type: Input
            }], boxTwoTitle: [{
                type: Input
            }], boxOneSubTitle: [{
                type: Input
            }], boxTwoSubTitle: [{
                type: Input
            }], searchText: [{
                type: Input
            }], disableTransfer: [{
                type: Input
            }], boxOneTransferBtnText: [{
                type: Input
            }], boxTwoTransferBtnText: [{
                type: Input
            }], columnKey: [{
                type: Input
            }], hidePagination: [{
                type: Input
            }] } });

class BentoTransferboxBasicModule extends ConsumerDataValidator {
}
BentoTransferboxBasicModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferboxBasicModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTransferboxBasicModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferboxBasicModule, declarations: [BentoTransferboxBasicComponent, BentoTransferlistComponent], imports: [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        FormsModule,
        BentoPaginationModule,
        BentoCheckboxModule,
        BentoResetModule,
        ScrollingModule,
        BentoFocusMonitorModule], exports: [BentoTransferboxBasicComponent, BentoTransferlistComponent] });
BentoTransferboxBasicModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferboxBasicModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            FormsModule,
            BentoPaginationModule,
            BentoCheckboxModule,
            BentoResetModule,
            ScrollingModule,
            BentoFocusMonitorModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTransferboxBasicModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoUtilsModule,
                        FormsModule,
                        BentoPaginationModule,
                        BentoCheckboxModule,
                        BentoResetModule,
                        ScrollingModule,
                        BentoFocusMonitorModule
                    ],
                    declarations: [BentoTransferboxBasicComponent, BentoTransferlistComponent],
                    exports: [BentoTransferboxBasicComponent, BentoTransferlistComponent]
                }]
        }] });

class BentoTreeBranch {
    constructor() {
        /**
         * Flag to only expand or collapse a tree branch
         */
        this.itemExpandOnly = false;
        /**
         * Flag to a tree item click is considered as a checkbox click
         */
        this.selectAsCheck = false;
        /**
         * Flag to show all checkbobox components
         */
        this.showCheckboxes = true;
    }
    /**
     * API to fire item select callback on tree root
     */
    _emitItemSelect(item, silent = false) { }
    /**
     * API to fire item expand callback on tree root
     */
    _emitItemExpand(event, item, silent = false) { }
    /**
     * API to fire item checkd state
     */
    _emitItemCheck(item, silent = false) { }
    /**
     * API to fire when tree item is destroyed
     */
    _removeTreeItemRef(item) { }
}

/**
 * An class for Bento Tree item options prior or during runtime to be declared to each tree item.
 * This is property can be initialized as a static JSON when the tree is initialized, then it will
 * be automatically converted into a new object with the follow API capabilities.
 *
 * Variable `treeId` represents the `id` of its corresponding HTMLElement.
 */
class BentoTreeItemOption {
    /**
     * Construct BentoTreeItemOption object
     */
    constructor(checked = false, selected = false, collapsed = false, indeterminate = false, hideCheckbox = false, preventSelection = false, isHidden = false, isDisabled = false, level = 0, siblings = [], index, parent) {
        /**
         * Emits checked change
         */
        this._checkedChange = new EventEmitter();
        /**
         * Emits collapsed change
         */
        this._collapsedChange = new EventEmitter();
        /**
         * Emits indeterminate change
         */
        this._indeterminateChange = new EventEmitter();
        /**
         * Emits is hidden change
         */
        this._isHiddenChange = new EventEmitter();
        /**
         * To emit child/children being appended to the current item
         */
        this._itemAppend = new EventEmitter();
        /* Private variables */
        // @ts-ignore
        this._checked = false;
        // @ts-ignore
        this._collapsed = false;
        // @ts-ignore
        this._selected = false;
        // @ts-ignore
        this._indeterminate = false;
        // @ts-ignore
        this._isHidden = false;
        this._isDisabled = false;
        // @ts-ignore
        this._checkedMap = {};
        // @ts-ignore
        this._collapsedMap = {};
        // @ts-ignore
        this._selectedMap = {};
        // @ts-ignore
        this._indeterminateMap = {};
        // @ts-ignore
        this._isHiddenMap = {};
        this._checked = checked;
        this._selectedChange = new BehaviorSubject({ v: selected });
        this._selected = selected;
        this._collapsed = collapsed;
        this._indeterminate = indeterminate;
        this.hideCheckbox = hideCheckbox;
        this.preventSelection = preventSelection;
        this._isHidden = isHidden;
        this._disabledChange = new BehaviorSubject(isDisabled);
        this._isDisabled = isDisabled;
        this.level = level;
        this.parent = parent;
        this.siblings = siblings;
        this.siblingSize = siblings ? siblings.length : 0;
        this.index = index + 1;
    }
    /**
     * Append item(s), single or array, to the current tree item
     * This feature *only* applies to *Bento Tree View* component
     */
    appendItems(data) {
        // Only need to emit to forward this to each subscribers
        this._itemAppend.emit(data);
    }
    /**
     * Flag to determine if this item is checked
     */
    set checked(v) {
        this.setChecked(v, undefined, true);
    }
    get checked() {
        return this.getChecked();
    }
    /**
     * Set `checked` variable with its Bento Tree HTMLElement ID
     */
    setChecked(v, treeId, bubble = true, silent = false) {
        if (this.hideCheckbox) {
            // Don't even bother
            return;
        }
        this._setValueOf('_indeterminate', false, treeId);
        this._setValueOf('_checked', v, treeId);
        // When slient, do not emit changes
        this._checkedChange.emit({ v, treeId, bubble, silent });
    }
    /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     */
    getChecked(treeId) {
        return this._getValueOf('_checked', treeId).value;
    }
    /**
     * Flag to determine if this item is collapsed
     */
    set collapsed(v) {
        this.setCollapsed(v);
    }
    get collapsed() {
        return this.getCollapsed();
    }
    /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     */
    setCollapsed(v, treeId, silent = false) {
        if (this._isSameValue('_collapsed', v, treeId)) {
            return;
        }
        this._setValueOf('_collapsed', v, treeId);
        if (!silent) {
            this._collapsedChange.emit({ v, treeId });
        }
    }
    /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     */
    getCollapsed(treeId) {
        return this._getValueOf('_collapsed', treeId).value;
    }
    /**
     * Set disabled state
     */
    set disabled(v) {
        if (v !== this._isDisabled) {
            this._isDisabled = v;
            this._disabledChange.next(v);
        }
    }
    get disabled() {
        return this._isDisabled;
    }
    /**
     * Flag to determine if this item is selected
     */
    set selected(v) {
        this.setSelected(v);
    }
    get selected() {
        return this.getSelected();
    }
    /**
     * Set `selected` variable with its Bento Tree HTMLElement ID
     */
    setSelected(v, treeId) {
        if (this._isSameValue('_selected', v, treeId)) {
            return;
        }
        this._setValueOf('_selected', v, treeId);
        this._selectedChange.next({ v, treeId });
    }
    /**
     * Get `selected` variable with its Bento Tree HTMLElement ID
     */
    getSelected(treeId) {
        return this._getValueOf('_selected', treeId).value;
    }
    /**
     * Flag to determine if this item is indeterminate
     */
    set indeterminate(v) {
        this.setIndeterminate(v);
    }
    get indeterminate() {
        return this.getIndeterminate();
    }
    /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     */
    setIndeterminate(v, treeId) {
        if (this._isSameValue('_indeterminate', v, treeId)) {
            return;
        }
        this._setValueOf('_indeterminate', v, treeId);
        if (v) {
            this._setValueOf('_checked', false, treeId);
        }
        this._indeterminateChange.emit({ v, treeId });
    }
    /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     */
    getIndeterminate(treeId) {
        return this._getValueOf('_indeterminate', treeId).value;
    }
    /**
     * Flag to determine if this item is hidden
     */
    set isHidden(v) {
        this.setIsHidden(v, undefined, true);
    }
    get isHidden() {
        return this.getIsHidden();
    }
    /**
     * Set `hidden` variable with its Bento Tree HTMLElement ID
     */
    setIsHidden(v, treeId, bubble = true) {
        if (this._isSameValue('_isHidden', v, treeId)) {
            return;
        }
        this._setValueOf('_isHidden', v, treeId);
        this._isHiddenChange.emit({ v, treeId, bubble });
    }
    /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     */
    getIsHidden(treeId) {
        return this._getValueOf('_isHidden', treeId).value;
    }
    /**
     * Set the variable name with value on the map with treeId
     * If treeId is specified, all values of this variable will be updated
     */
    _setValueOf(varName, v, withTreeId) {
        if (withTreeId != null) {
            this[varName + 'Map'][withTreeId] = v;
        }
        else {
            this[varName] = v;
            const map = this[varName + 'Map'];
            if (!map) {
                // Wrong value in `varName`
                return;
            }
            /* eslint-disable */
            for (let label in map) {
                map[label] = v;
            }
            /* eslint-enable */
        }
    }
    /**
     * Get the value from varName with its treeId
     */
    _getValueOf(varName, withTreeId) {
        if (withTreeId != null) {
            const varNameMap = varName + 'Map';
            if (this[varNameMap].hasOwnProperty(withTreeId)) {
                return { value: this[varNameMap][withTreeId], hasMixedValues: false };
            }
            else {
                return { value: this[varName], hasMixedValues: false };
            }
        }
        else {
            let hasMixedValues = false;
            const v = this[varName];
            const map = this[varName + 'Map'];
            /* eslint-disable */
            for (let label in map) {
                if (map[label] !== v) {
                    hasMixedValues = true;
                    break;
                }
            }
            /* eslint-enable */
            return { value: this[varName], hasMixedValues };
        }
    }
    /**
     * Check if the value `v` is the same as the given varName
     */
    _isSameValue(varName, v, treeId) {
        const valueObj = this._getValueOf(varName, treeId);
        return valueObj.value === v && !valueObj.hasMixedValues;
    }
}

let idCounter = 0;
class BentoTreeItemComponent {
    constructor(elRef, r, dir, changeDetector) {
        this.r = r;
        this.dir = dir;
        this.changeDetector = changeDetector;
        /**
         * Check of this node is the last in its sibling array
         */
        this.isLast = false;
        /**
         * Flag to determine if should show checkboxes
         */
        this.showCheckbox = true;
        /*
         * For A11y
         */
        this.ariaLevel = 0;
        this.ariaIndex = 0;
        this.siblingSize = 0;
        /**
         * Notify when a item checkbox is changed
         */
        this.itemCheckChange = new EventEmitter();
        // UID for this node
        this.uid = `bui-tree-item-${idCounter++}`;
        /* Private variables */
        this.isDisabled = false;
        this.checkedSubscription = Subscription.EMPTY;
        this.selectedSubscription = Subscription.EMPTY;
        this.collapsedSubscription = Subscription.EMPTY;
        this.indeterminateSubscription = Subscription.EMPTY;
        this.isHiddenSubscription = Subscription.EMPTY;
        this.isDisabledSubscription = Subscription.EMPTY;
        this.self = this;
    }
    set _ariaSiblings(a) {
        this.siblingSize = a.length;
        this.ariaSiblings = a;
    }
    /**
     * Expand all items
     */
    expandAll() {
        const children = this.children.toArray();
        if (children && children.length > 0) {
            this.options.setCollapsed(false, this.root.id);
            for (const child of children) {
                child.expandAll();
            }
        }
        // Make sure it checks the changes for rendering
        this.changeDetector.markForCheck();
    }
    /**
     * Collapse all items
     */
    collapseAll() {
        const children = this.children.toArray();
        if (children) {
            this.options.setCollapsed(true, this.root.id);
            if (children.length > 0) {
                // Collapse children if the children array isn't empty
                for (let i = 0, len = children.length; i < len; i++) {
                    children[i].collapseAll();
                }
            }
        }
        // Make sure it checks the changes for rendering
        this.changeDetector.markForCheck();
    }
    /**
     * Focus on this tree item
     */
    focus() {
        this.itemLabelElRef.nativeElement.focus();
    }
    /**
     * After view init
     */
    ngAfterViewInit() { }
    /**
     * Init
     */
    ngOnInit() {
        let selectInitialized = false;
        this.itemLabelString = this.treeItem[this.root.itemLabelProp];
        this.options = this.treeItem.$bentoTreeItemOption || new BentoTreeItemOption();
        if (!(this.options instanceof BentoTreeItemOption)) {
            // Options is a simple Object need to convert it to Class
            this.options = new BentoTreeItemOption(this.treeItem.$bentoTreeItemOption.checked, this.treeItem.$bentoTreeItemOption.selected, this.treeItem.$bentoTreeItemOption.collapsed, this.treeItem.$bentoTreeItemOption.indeterminate, this.treeItem.$bentoTreeItemOption.hideCheckbox, this.treeItem.$bentoTreeItemOption.preventSelection, this.treeItem.$bentoTreeItemOption.isHidden, this.treeItem.$bentoTreeItemOption.disabled);
        }
        this.treeItem.$bentoTreeItemOption = this.options;
        // update main Bento Tree data model if this tree item is initially selected
        if (this.options.getSelected(this.root.id)) {
            // Add to selection queue
            this.root._emitItemSelect(this.treeItem, true);
        }
        // selected subscription
        this.selectedSubscription = this.options._selectedChange.subscribe(res => {
            if (res.treeId === this.root.id) {
                if (res.v) {
                    this.r.addClass(this.componentElRef.nativeElement, 'selected');
                    if (selectInitialized) {
                        // Use timeout for selections after initialized to show animations
                        setTimeout(() => {
                            this.r.addClass(this.componentElRef.nativeElement, 'in');
                        }, 34);
                    }
                    else {
                        this.r.addClass(this.componentElRef.nativeElement, 'in');
                    }
                }
                else {
                    this.r.removeClass(this.componentElRef.nativeElement, 'selected');
                    this.r.removeClass(this.componentElRef.nativeElement, 'in');
                    this.r.addClass(this.componentElRef.nativeElement, 'out');
                    setTimeout(() => {
                        this.r.removeClass(this.componentElRef.nativeElement, 'out');
                    });
                }
                this.root._emitItemSelect(this.treeItem, !selectInitialized);
            }
            // Make sure it checks the changes for rendering
            this.changeDetector.markForCheck();
        });
        selectInitialized = true;
        // collapsed subscription
        this.collapsedSubscription = this.options._collapsedChange.subscribe(res => {
            if (res.treeId === this.root.id) {
                this.root._emitItemExpand({ expanded: !res.v, item: this.treeItem }, this);
            }
        });
        // update main Bento Tree data model if this tree item is initially checked
        if (this.options.getChecked(this.root.id)) {
            // set children check status
            this.checkChildren(this.options.getChecked(this.root.id));
            // Add to selection queue
            this.root._emitItemCheck(this.treeItem, true);
        }
        // check subscription
        this.checkedSubscription = this.options._checkedChange.subscribe(res => {
            if (res.treeId === this.root.id || // a check change targeting this tree with a treeId
                res.treeId == null // wildcard on treeId
            ) {
                if (res.bubble) {
                    // Only emit item check change when it needs to bubble up
                    this.itemCheckChange.emit();
                }
                // Notify the root silently
                this.root._emitItemCheck(this.treeItem, true);
                if (!this.options.getIndeterminate(this.root.id)) {
                    // Set check status on children only when the dataModel of this tree item does not
                    // have indeterminate state
                    this.checkChildren(res.v);
                }
            }
            // Make sure it checks the changes for rendering
            this.changeDetector.markForCheck();
        });
        // disabled
        this.isDisabledSubscription = this.options._disabledChange.subscribe(res => {
            this.isDisabled = res;
            // Make sure it checks the changes for rendering
            this.changeDetector.markForCheck();
        });
        // indeterminate
        this.indeterminateSubscription = this.options._indeterminateChange.subscribe(res => {
            if (res.treeId === this.root.id) {
                this.itemCheckChange.emit();
            }
            // Make sure it checks the changes for rendering
            this.changeDetector.markForCheck();
        });
        // isHidden
        this.isHiddenSubscription = this.options._isHiddenChange.subscribe(res => {
            if (res.treeId === this.root.id) {
                this.itemCheckChange.emit();
            }
            // Make sure it checks the changes for rendering
            this.changeDetector.markForCheck();
        });
    }
    /**
     * Check all parent indeterminate relationships
     */
    onChildItemCheckChange() {
        let allChecked = true;
        let allUnchecked = true;
        let hasIndeterminate = false;
        let hasChildren = false;
        // Use data model to determine if this item has to be indeterminate or not
        this.treeItem[this.root.itemChildrenProp].forEach((item) => {
            const option = item.$bentoTreeItemOption;
            if (!option) {
                return;
            }
            hasChildren = true;
            if (!option.hideCheckbox) {
                if (option.getChecked(this.root.id)) {
                    allUnchecked = false;
                }
                else {
                    allChecked = false;
                }
            }
            if (option.getIndeterminate(this.root.id)) {
                hasIndeterminate = true;
            }
        });
        if (hasChildren && allChecked && !hasIndeterminate) {
            this.options.setChecked(true, this.root.id);
        }
        else if (allUnchecked && !hasIndeterminate) {
            this.options.setChecked(false, this.root.id);
            this.options.setIndeterminate(false, this.root.id);
        }
        else {
            this.options.setIndeterminate(true, this.root.id);
        }
    }
    /**
     * Called when a folder is expanded
     */
    onExpandClick(event) {
        // Only enable the expand when there is a data model
        // at least to simulate even when there the children array has no children
        // as long as there is a children array object assigned to `treeData`
        if (this.treeItem[this.root.itemChildrenProp]) {
            const flippedCollapsed = !this.options.getCollapsed(this.root.id);
            this.options.setCollapsed(flippedCollapsed, this.root.id);
        }
    }
    /**
     * Called when a item is clicked
     */
    onItemClick(event) {
        if (this.root.itemExpandOnly && this.treeItem[this.root.itemChildrenProp]) {
            this.onExpandClick(event);
        }
        else if (this.root.selectAsCheck) {
            this.onCheckChanged(!this.checkbox.value);
        }
        else if (!this.options.preventSelection) {
            this.options.setSelected(!this.options.getSelected(this.root.id), this.root.id);
        }
    }
    /**
     * Called with Keyboard Event
     */
    onItemKeydown(event) {
        const isRTL = this.dir.value === 'rtl';
        switch (event.which) {
            // Enter or Space
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                this.onItemClick(null);
                event.preventDefault();
                event.stopPropagation();
                return;
            // Left key
            case Keyboard.LEFT:
                if (isRTL) {
                    this.walkDownTreeItems();
                }
                else {
                    this.walkUpTreeItems();
                }
                event.preventDefault();
                event.stopPropagation();
                return;
            // Up key
            case Keyboard.UP:
                this.focusOnPreviousItem();
                event.preventDefault();
                event.stopPropagation();
                return;
            // Right key
            case Keyboard.RIGHT:
                if (isRTL) {
                    this.walkUpTreeItems();
                }
                else {
                    this.walkDownTreeItems();
                }
                event.preventDefault();
                event.stopPropagation();
                return;
            // Down key
            case Keyboard.DOWN:
                this.focusOnNextItem();
                event.preventDefault();
                event.stopPropagation();
                return;
            default:
        }
    }
    /**
     * Focus to the next available item
     */
    focusOnNextItem() {
        const CTAs = this.activeCTAs;
        const currentCTAIndex = CTAs.indexOf(this.itemLabelElRef.nativeElement);
        CTAs[(currentCTAIndex + 1) % CTAs.length].focus();
    }
    /**
     * Find and focus on the available previous item
     */
    focusOnPreviousItem() {
        const CTAs = this.activeCTAs;
        const currentCTAIndex = CTAs.indexOf(this.itemLabelElRef.nativeElement);
        CTAs[(currentCTAIndex - 1 + CTAs.length) % CTAs.length].focus();
    }
    /**
     * Callback when the checkbox changes its value
     */
    onCheckChanged(v) {
        this.options.setChecked(v, this.root.id);
        // Not going to update children when checkbox is in indeterminate state
        if (this.checkbox.indeterminate) {
            return;
        }
        this.root._emitItemCheck(this.treeItem);
    }
    /**
     * Check all children
     */
    checkChildren(v) {
        const children = this.childrenModelArray;
        if (children && children.length > 0 && !this.options.getIndeterminate(this.root.id)) {
            // Propagate current check state to children
            // This is only used when view is not ready
            children.forEach(item => {
                if (item.$bentoTreeItemOption instanceof BentoTreeItemOption) {
                    // options is defined as an instance of BentoTreeItemOption
                    if (item.$bentoTreeItemOption.getChecked(this.root.id) !== v &&
                        !item.$bentoTreeItemOption.getIsHidden(this.root.id)) {
                        item.$bentoTreeItemOption.setChecked(v, this.root.id, false);
                    }
                }
                else if (item.$bentoTreeItemOption && !item.$bentoTreeItemOption.isHidden) {
                    // option is simply a JSON
                    item.$bentoTreeItemOption.checked = v;
                }
                else {
                    // option doesn't exist
                    item.$bentoTreeItemOption = { checked: v };
                }
            });
        }
    }
    ngOnDestroy() {
        // Clean data object
        if (this.treeItem) {
            this.root._removeTreeItemRef(this.treeItem);
        }
        // Unsbscribe item states
        this.checkedSubscription.unsubscribe();
        this.selectedSubscription.unsubscribe();
        this.collapsedSubscription.unsubscribe();
        this.indeterminateSubscription.unsubscribe();
        this.isHiddenSubscription.unsubscribe();
        this.isDisabledSubscription.unsubscribe();
    }
    /**
     * Walk down the item tree expand if needed
     */
    walkDownTreeItems() {
        if (this.options.getCollapsed(this.root.id)) {
            this.onExpandClick(null);
        }
        else if (this.children && this.children.length > 0) {
            this.focusOnNextItem();
        }
    }
    /**
     * Walk up the hirachy collapse if needed
     */
    walkUpTreeItems() {
        if (!this.options.getCollapsed(this.root.id) && this.treeItem[this.root.itemChildrenProp]) {
            this.onExpandClick(null);
        }
        else if (this.parent) {
            this.parent.focus();
        }
    }
    get activeCTAs() {
        const CTAs = Array.from(this.root.el.querySelectorAll('.bento-tree-item-cta'));
        const disabledCTAs = Array.from(this.root.el.querySelectorAll('.bento-tree-disabled .bento-tree-item-cta'));
        const hiddenCTAs = Array.from(this.root.el.querySelectorAll('[hidden] .bento-tree-item-cta'));
        const activeCTAs = [];
        for (const item of CTAs) {
            if (disabledCTAs.indexOf(item) < 0 && hiddenCTAs.indexOf(item) < 0) {
                activeCTAs.push(item);
            }
        }
        return activeCTAs;
    }
    /**
     * Get the children of this tree item
     */
    get childrenModelArray() {
        return this.treeItem[this.root.itemChildrenProp];
    }
}
BentoTreeItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeItemComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i2.Directionality }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoTreeItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTreeItemComponent, selector: "bento-tree-item", inputs: { treeItem: "treeItem", parent: "parent", root: "root", labelTemplateRef: "labelTemplateRef", isLast: "isLast", showCheckbox: "showCheckbox", ariaLevel: "ariaLevel", ariaIndex: "ariaIndex", _ariaSiblings: ["ariaSiblings", "_ariaSiblings"] }, outputs: { itemCheckChange: "itemCheckChange" }, host: { properties: { "class.bento-tree-disabled": "this.isDisabled" } }, providers: [BentoUidService], viewQueries: [{ propertyName: "checkbox", first: true, predicate: BentoCheckboxComponent, descendants: true }, { propertyName: "itemLabelElRef", first: true, predicate: ["itemLabel"], descendants: true, static: true }, { propertyName: "componentElRef", first: true, predicate: ["componentEl"], descendants: true, static: true }, { propertyName: "children", predicate: BentoTreeItemComponent, descendants: true }], ngImport: i0, template: "<div\n  #componentEl\n  role=\"treeitem\"\n>\n  <button\n    type=\"button\"\n    class=\"expand-button-compiled\"\n    *ngIf=\"treeItem[root.itemChildrenProp]\"\n    (click)=\"onExpandClick($event)\"\n    [attr.aria-label]=\"\n      (options.getCollapsed(root.id)\n        ? ('BENTO_UI_TREE_EXPAND' | bentoTranslate)\n        : ('BENTO_UI_TREE_COLLAPSE' | bentoTranslate)\n      ) | bentoStringReplace: '_LABEL_':itemLabelString\n    \"\n    ngbTooltip=\"{{\n      (options.getCollapsed(root.id)\n        ? ('BENTO_UI_TREE_EXPAND' | bentoTranslate)\n        : ('BENTO_UI_TREE_COLLAPSE' | bentoTranslate)\n      ) | bentoStringReplace: '_LABEL_':itemLabelString\n    }}\"\n    [attr.aria-expanded]=\"treeItem[root.itemChildrenProp] ? !options.getCollapsed(root.id) : null\"\n    [attr.aria-controls]=\"'bento-tree-branch-of-' + uid\"\n  >\n    <i aria-hidden=\"true\"\n      [ngClass]=\"options.getCollapsed(root.id) ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"\n    ></i>\n  </button>\n  <bento-checkbox\n    class=\"tree-item-checkbox\"\n    [ngModel]=\"options.getChecked(root.id)\"\n    (ngModelChange)=\"onCheckChanged($event)\"\n    [indeterminate]=\"options.getIndeterminate(root.id)\"\n    [attr.id]=\"'checkbox-' + uid\"\n    [disabled]=\"options.disabled\"\n    [attr.aria-labeledby]=\"'label-' + uid\"\n    *ngIf=\"showCheckbox && !options.hideCheckbox\"\n  ></bento-checkbox>\n  <i\n    [class]=\"treeItem[root.itemIconProp]\"\n    *ngIf=\"treeItem[root.itemIconProp]\"\n    (click)=\"onItemClick($event)\"\n    aria-hidden=\"true\"\n  ></i>\n  <div\n    class=\"bento-tree-item-cta\"\n    (click)=\"onItemClick($event)\"\n    (keydown)=\"onItemKeydown($event)\"\n    [attr.tabindex]=\"options.preventSelection || options.disabled ? -1 : 0\"\n    [attr.aria-disabled]=\"options.disabled\"\n    [attr.aria-level]=\"ariaLevel\"\n    [attr.aria-posinset]=\"ariaIndex\"\n    [attr.aria-setsize]=\"siblingSize\"\n    [attr.aria-checked]=\"showCheckbox && !options.hideCheckbox && !options.getIndeterminate(root.id) ? options.getChecked(root.id) : null\"\n    [attr.aria-selected]=\"options.getSelected(root.id) ? options.getSelected(root.id) : null\"\n    [attr.aria-expanded]=\"treeItem[root.itemChildrenProp] ? !options.getCollapsed(root.id) : null\"\n    role=\"treeitem\"\n    #itemLabel\n  >\n    <div class=\"bento-tree-item-cta-wrapper\">\n      <ng-container\n        *ngTemplateOutlet=\"labelTemplateRef; context: {item: treeItem, itemUID: uid, treeRoot: root}\"\n      ></ng-container>\n    </div>\n  </div>\n  <div\n    class=\"bento-tree-branch\"\n    *ngIf=\"treeItem[root.itemChildrenProp] && treeItem[root.itemChildrenProp].length > 0\"\n    [hidden]=\"options.getCollapsed(root.id)\"\n    [attr.id]=\"'bento-tree-branch-of-' + uid\"\n  >\n    <div class=\"bento-tree-branch-base\" role=\"group\">\n      <ng-template ngFor let-item [ngForOf]=\"treeItem[root.itemChildrenProp]\" let-isLast=\"last\" let-i=\"index\">\n        <bento-tree-item\n          [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n          [root]=\"root\"\n          [parent]=\"self\"\n          [treeItem]=\"item\"\n          [labelTemplateRef]=\"labelTemplateRef\"\n          [isLast]=\"isLast\"\n          [showCheckbox]=\"showCheckbox\"\n          (itemCheckChange)=\"onChildItemCheckChange()\"\n          [ariaLevel]=\"ariaLevel + 1\"\n          [ariaIndex]=\"i + 1\"\n          [ariaSiblings]=\"treeItem[root.itemChildrenProp]\"\n        ></bento-tree-item>\n      </ng-template>\n    </div>\n  </div>\n</div>\n", components: [{ type: BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: BentoTreeItemComponent, selector: "bento-tree-item", inputs: ["treeItem", "parent", "root", "labelTemplateRef", "isLast", "showCheckbox", "ariaLevel", "ariaIndex", "ariaSiblings"], outputs: ["itemCheckChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "bentoStringReplace": BentoStringReplacePipe, "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tree-item', changeDetection: ChangeDetectionStrategy.OnPush, providers: [BentoUidService], template: "<div\n  #componentEl\n  role=\"treeitem\"\n>\n  <button\n    type=\"button\"\n    class=\"expand-button-compiled\"\n    *ngIf=\"treeItem[root.itemChildrenProp]\"\n    (click)=\"onExpandClick($event)\"\n    [attr.aria-label]=\"\n      (options.getCollapsed(root.id)\n        ? ('BENTO_UI_TREE_EXPAND' | bentoTranslate)\n        : ('BENTO_UI_TREE_COLLAPSE' | bentoTranslate)\n      ) | bentoStringReplace: '_LABEL_':itemLabelString\n    \"\n    ngbTooltip=\"{{\n      (options.getCollapsed(root.id)\n        ? ('BENTO_UI_TREE_EXPAND' | bentoTranslate)\n        : ('BENTO_UI_TREE_COLLAPSE' | bentoTranslate)\n      ) | bentoStringReplace: '_LABEL_':itemLabelString\n    }}\"\n    [attr.aria-expanded]=\"treeItem[root.itemChildrenProp] ? !options.getCollapsed(root.id) : null\"\n    [attr.aria-controls]=\"'bento-tree-branch-of-' + uid\"\n  >\n    <i aria-hidden=\"true\"\n      [ngClass]=\"options.getCollapsed(root.id) ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"\n    ></i>\n  </button>\n  <bento-checkbox\n    class=\"tree-item-checkbox\"\n    [ngModel]=\"options.getChecked(root.id)\"\n    (ngModelChange)=\"onCheckChanged($event)\"\n    [indeterminate]=\"options.getIndeterminate(root.id)\"\n    [attr.id]=\"'checkbox-' + uid\"\n    [disabled]=\"options.disabled\"\n    [attr.aria-labeledby]=\"'label-' + uid\"\n    *ngIf=\"showCheckbox && !options.hideCheckbox\"\n  ></bento-checkbox>\n  <i\n    [class]=\"treeItem[root.itemIconProp]\"\n    *ngIf=\"treeItem[root.itemIconProp]\"\n    (click)=\"onItemClick($event)\"\n    aria-hidden=\"true\"\n  ></i>\n  <div\n    class=\"bento-tree-item-cta\"\n    (click)=\"onItemClick($event)\"\n    (keydown)=\"onItemKeydown($event)\"\n    [attr.tabindex]=\"options.preventSelection || options.disabled ? -1 : 0\"\n    [attr.aria-disabled]=\"options.disabled\"\n    [attr.aria-level]=\"ariaLevel\"\n    [attr.aria-posinset]=\"ariaIndex\"\n    [attr.aria-setsize]=\"siblingSize\"\n    [attr.aria-checked]=\"showCheckbox && !options.hideCheckbox && !options.getIndeterminate(root.id) ? options.getChecked(root.id) : null\"\n    [attr.aria-selected]=\"options.getSelected(root.id) ? options.getSelected(root.id) : null\"\n    [attr.aria-expanded]=\"treeItem[root.itemChildrenProp] ? !options.getCollapsed(root.id) : null\"\n    role=\"treeitem\"\n    #itemLabel\n  >\n    <div class=\"bento-tree-item-cta-wrapper\">\n      <ng-container\n        *ngTemplateOutlet=\"labelTemplateRef; context: {item: treeItem, itemUID: uid, treeRoot: root}\"\n      ></ng-container>\n    </div>\n  </div>\n  <div\n    class=\"bento-tree-branch\"\n    *ngIf=\"treeItem[root.itemChildrenProp] && treeItem[root.itemChildrenProp].length > 0\"\n    [hidden]=\"options.getCollapsed(root.id)\"\n    [attr.id]=\"'bento-tree-branch-of-' + uid\"\n  >\n    <div class=\"bento-tree-branch-base\" role=\"group\">\n      <ng-template ngFor let-item [ngForOf]=\"treeItem[root.itemChildrenProp]\" let-isLast=\"last\" let-i=\"index\">\n        <bento-tree-item\n          [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n          [root]=\"root\"\n          [parent]=\"self\"\n          [treeItem]=\"item\"\n          [labelTemplateRef]=\"labelTemplateRef\"\n          [isLast]=\"isLast\"\n          [showCheckbox]=\"showCheckbox\"\n          (itemCheckChange)=\"onChildItemCheckChange()\"\n          [ariaLevel]=\"ariaLevel + 1\"\n          [ariaIndex]=\"i + 1\"\n          [ariaSiblings]=\"treeItem[root.itemChildrenProp]\"\n        ></bento-tree-item>\n      </ng-template>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i2.Directionality }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { treeItem: [{
                type: Input
            }], parent: [{
                type: Input
            }], root: [{
                type: Input
            }], labelTemplateRef: [{
                type: Input
            }], isLast: [{
                type: Input
            }], showCheckbox: [{
                type: Input
            }], ariaLevel: [{
                type: Input
            }], ariaIndex: [{
                type: Input
            }], _ariaSiblings: [{
                type: Input,
                args: ['ariaSiblings']
            }], itemCheckChange: [{
                type: Output
            }], children: [{
                type: ViewChildren,
                args: [BentoTreeItemComponent]
            }], checkbox: [{
                type: ViewChild,
                args: [BentoCheckboxComponent]
            }], itemLabelElRef: [{
                type: ViewChild,
                args: ['itemLabel', { static: true }]
            }], componentElRef: [{
                type: ViewChild,
                args: ['componentEl', { static: true }]
            }], isDisabled: [{
                type: HostBinding,
                args: ['class.bento-tree-disabled']
            }] } });

/**
 * Bento Tree
 *
 * Features:
 * - Tree Item Custom Template
 * - Keyboard Support
 *   - Enter + Space
 *   - Tab
 * - Checkboxes
 * - Multiple Select
 *
 */
var BentoTreeItemCheckStatus;
(function (BentoTreeItemCheckStatus) {
    BentoTreeItemCheckStatus[BentoTreeItemCheckStatus["Checked"] = 0] = "Checked";
    BentoTreeItemCheckStatus[BentoTreeItemCheckStatus["Unchecked"] = 1] = "Unchecked";
    BentoTreeItemCheckStatus[BentoTreeItemCheckStatus["Indeterminate"] = 2] = "Indeterminate";
})(BentoTreeItemCheckStatus || (BentoTreeItemCheckStatus = {}));
/**
 * The tree view creates a hierarchical view of items in a collection.
 * Users can expand/collapse items in the tree to view the content of the children items,
 * and they can also select individual items.
 */
class BentoTreeComponent extends BentoTreeBranch {
    constructor(elRef, uidService) {
        super();
        /**
         * Flag to multiple tree items can be selected
         */
        this.multiSelect = false;
        /**
         * Flag to only expand or collapse a tree branch
         */
        this.itemExpandOnly = false;
        /**
         * Flag to a tree item click is considered as a checkbox click
         */
        this.selectAsCheck = false;
        /**
         * Flag to show all checkbobox components
         */
        this.showCheckboxes = true;
        /**
         * Flag to show the expand and collapse all buttons
         */
        this.showExpandCollapseAllButtons = false;
        // Event Emitters
        /**
         * Callback to when a item is selected
         */
        this.itemSelect = new EventEmitter();
        /**
         * Callback to when a tree item is expanded or collapsed
         */
        this.itemExpandCollapse = new EventEmitter();
        /**
         * Callback to when a item is checked
         */
        this.itemCheck = new EventEmitter();
        /**
         * Callback to when a item is unchecked
         */
        this.itemUnCheck = new EventEmitter();
        /**
        * Callback to when a item has changed, passes back the event
        */
        this.itemOnChange = new EventEmitter();
        this.api = {};
        this.isInitiated = false;
        this.id = elRef.nativeElement.id || undefined;
        this.uid = uidService.generate();
        this._self = this;
        this.el = elRef.nativeElement;
    }
    /**
     * Main Bento Tree data
     */
    set items(items) {
        if (items) {
            this.treeItems = items;
            if (this.isInitiated) {
                this.updateItems(items);
                this.processItems(null, items);
            }
        }
    }
    ngOnInit() {
        this.isInitiated = true;
        this.updateItems(this.treeItems);
        this.processItems(null, this.treeItems);
    }
    /**
     * Setup tree item option config
     */
    processItems(parent, children, level = 1) {
        for (let i = 0; i < children.length; i++) {
            const item = children[i];
            const itemChildren = item[this.itemChildrenProp];
            let options = item.$bentoTreeItemOption ||
                new BentoTreeItemOption(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, level, item, i, parent);
            if (!(options instanceof BentoTreeItemOption)) {
                // Options is a simple Object need to convert it to Class
                options = new BentoTreeItemOption(options.checked, options.selected, options.collapsed, options.indeterminate, options.hideCheckbox, options.preventSelection, options.isHidden, options.disabled, level, item, i, parent);
            }
            else if (parent && !options.parent) {
                options.parent = parent;
            }
            item.$bentoTreeItemOption = options;
            if (Array.isArray(itemChildren)) {
                // Process children
                this.processItems(item, itemChildren, level + 1);
            }
        }
    }
    /**
     * Expand all items
     */
    expandAll() {
        const children = this.children.toArray();
        if (children && children.length > 0) {
            for (let i = 0, len = children.length; i < len; i++) {
                children[i].expandAll();
            }
        }
    }
    /**
     * Collapse all items
     */
    collapseAll() {
        const children = this.children.toArray();
        if (children && children.length > 0) {
            for (let i = 0, len = children.length; i < len; i++) {
                children[i].collapseAll();
            }
        }
    }
    /**
     * API to fire item expand callback on tree root
     */
    _emitItemExpand(event, item, silent = false) {
        // Fire callback if not silent
        if (!silent) {
            this.itemExpandCollapse.emit(event);
        }
    }
    /**
     * API to fire item select callback on tree root
     */
    _emitItemSelect(item, silent = false) {
        if (!this.selectedItems) {
            this.selectedItems = [];
        }
        const index = this.selectedItems.indexOf(item);
        let tempItem;
        if (item.$bentoTreeItemOption.getSelected(this.id)) {
            // Do the following when a item is selected
            if (!this.multiSelect) {
                // Single Select
                // Pop everything else
                tempItem = this.selectedItems.pop();
                while (tempItem) {
                    if (item !== tempItem) {
                        tempItem.$bentoTreeItemOption.setSelected(false, this.id);
                    }
                    tempItem = this.selectedItems.pop();
                }
                // Add the current selected item
                this.selectedItems.push(item);
            }
            else {
                // Multiselect
                if (index === -1) {
                    this.selectedItems.push(item);
                }
            }
        }
        else if (index > -1) {
            // When a item is deselected
            this.selectedItems.splice(index, 1);
        }
        // Bubble event
        if (!silent) {
            this.itemSelect.emit({
                items: this.selectedItems.slice(),
                cancel: () => {
                    item.$bentoTreeItemOption.setSelected(false, this.id);
                }
            });
        }
    }
    /**
     * API to fire item checkd state
     */
    _emitItemCheck(item, silent = false) {
        if (!this.checkedItems) {
            this.checkedItems = [];
        }
        if (!this.unCheckedItems) {
            this.unCheckedItems = [];
        }
        const index = this.checkedItems.indexOf(item);
        const checked = item.$bentoTreeItemOption.getChecked(this.id);
        const indeterminate = item.$bentoTreeItemOption.getIndeterminate(this.id);
        if (!checked && !indeterminate && index > -1 && this.unCheckedItems.indexOf(item) === -1) {
            this.unCheckedItems.push(item);
        }
        if (checked && !indeterminate && index === -1) {
            this.checkedItems.push(item);
        }
        else if ((!checked || indeterminate) && index > -1) {
            this.checkedItems.splice(index, 1);
        }
        // Bubble event
        if (!silent) {
            this.itemCheck.emit({ items: this.checkedItems.slice() });
            this.itemUnCheck.emit({ items: this.unCheckedItems.slice() });
            this.itemOnChange.emit({ itemEvent: item });
        }
    }
    /**
     * API to fire item destroy state
     */
    _destroyTreeItem(item, silent = false) {
        if (this.selectedItems) {
            const index = this.selectedItems.indexOf(item);
            if (index > -1) {
                this.selectedItems.splice(index, 1);
            }
        }
        if (this.checkedItems) {
            const index = this.checkedItems.indexOf(item);
            if (index > -1) {
                this.checkedItems.splice(index, 1);
            }
        }
    }
    updateItems(items) {
        if (Array.isArray(items)) {
            this.treeItems = items;
            if (this.isInitiated) {
                // Only update items when Tree is ready with all properties assigned
                // Update each item status based on its children statuses
                items.forEach(item => {
                    this.updateTreeItemStatus(item);
                });
                // clean checked and selected items list
                this.checkedItems = [];
                this.selectedItems = [];
            }
        }
    }
    /**
     * Update Tree item data status
     */
    updateTreeItemStatus(item) {
        const itemOption = item.$bentoTreeItemOption;
        if (itemOption) {
            // There are predefined options
            if (itemOption.getIndeterminate && itemOption.getIndeterminate(this.id)) {
                return BentoTreeItemCheckStatus.Indeterminate;
            }
            else if (itemOption.getChecked) {
                if (itemOption.getChecked(this.id)) {
                    // This item is checked by default
                    return BentoTreeItemCheckStatus.Checked;
                }
            }
            else if (itemOption.checked) {
                // This item is checked by default
                return BentoTreeItemCheckStatus.Checked;
            }
            else if (itemOption.hideCheckbox) {
                // We return the checkbox as checked when the checkbox is not visible
                return BentoTreeItemCheckStatus.Checked;
            }
        }
        const children = item[this.itemChildrenProp];
        if (!children || children.length === 0) {
            // No child under this item
            return BentoTreeItemCheckStatus.Unchecked;
        }
        let allChecked = true;
        let allUnchecked = true;
        let allEmpty = true;
        let hasIndeterminate = false;
        let status;
        children.forEach(childItem => {
            if (childItem.$bentoTreeItemOption && childItem.$bentoTreeItemOption.hideCheckbox) {
                // This item doesn't do anything with the checkbox
                // move to the next checkbox
            }
            else {
                status = this.updateTreeItemStatus(childItem);
                allEmpty = false;
                if (status === BentoTreeItemCheckStatus.Indeterminate) {
                    hasIndeterminate = true;
                }
                else if (status === BentoTreeItemCheckStatus.Checked) {
                    allUnchecked = false;
                }
                else if (status === BentoTreeItemCheckStatus.Unchecked) {
                    allChecked = false;
                }
            }
        });
        item.$bentoTreeItemOption = item.$bentoTreeItemOption || new BentoTreeItemOption();
        if (hasIndeterminate || !(allUnchecked || allChecked)) {
            if (item.$bentoTreeItemOption.setIndeterminate) {
                item.$bentoTreeItemOption.setIndeterminate(true, this.id);
            }
            else {
                item.$bentoTreeItemOption.indeterminate = true;
            }
            return BentoTreeItemCheckStatus.Indeterminate;
        }
        else if (allChecked && !allEmpty) {
            if (item.$bentoTreeItemOption.setChecked) {
                item.$bentoTreeItemOption.setChecked(true, this.id);
            }
            else {
                item.$bentoTreeItemOption.checked = true;
            }
            return BentoTreeItemCheckStatus.Checked;
        }
        else {
            if (item.$bentoTreeItemOption.setChecked) {
                item.$bentoTreeItemOption.setChecked(false, this.id);
            }
            else {
                item.$bentoTreeItemOption.checked = false;
            }
            return BentoTreeItemCheckStatus.Unchecked;
        }
    }
}
BentoTreeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeComponent, deps: [{ token: i0.ElementRef }, { token: BentoUidService }], target: i0.ɵɵFactoryTarget.Component });
BentoTreeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTreeComponent, selector: "bento-tree", inputs: { items: "items", multiSelect: "multiSelect", itemIconProp: "itemIconProp", itemChildrenProp: "itemChildrenProp", itemLabelProp: "itemLabelProp", itemExpandOnly: "itemExpandOnly", selectAsCheck: "selectAsCheck", showCheckboxes: "showCheckboxes", showExpandCollapseAllButtons: "showExpandCollapseAllButtons", itemLabelTemplate: "itemLabelTemplate" }, outputs: { itemSelect: "itemSelect", itemExpandCollapse: "itemExpandCollapse", itemCheck: "itemCheck", itemUnCheck: "itemUnCheck", itemOnChange: "itemOnChange" }, providers: [BentoUidService], viewQueries: [{ propertyName: "defaultItemLabelTemplate", first: true, predicate: ["defaultItemLabelTemplate"], descendants: true, static: true }, { propertyName: "children", predicate: i0.forwardRef(function () { return BentoTreeItemComponent; }), descendants: true }], usesInheritance: true, ngImport: i0, template: "<bento-expand-collapse-button-group\n  *ngIf=\"showExpandCollapseAllButtons\"\n  [expandAllTitle]=\"'BENTO_UI_TREE_EXPAND_ALL' | bentoTranslate\"\n  [collapseAllTitle]=\"'BENTO_UI_TREE_COLLAPSE_ALL' | bentoTranslate\"\n  (expand)=\"expandAll()\"\n  (collapse)=\"collapseAll()\"\n></bento-expand-collapse-button-group>\n<div class=\"bento-tree-branch bento-tree-root\" role=\"tree\" *ngIf=\"treeItems && treeItems.length > 0\">\n  <div class=\"bento-tree-branch-base\">\n    <bento-tree-item\n      *ngFor=\"let item of treeItems; index as i\"\n      [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n      [root]=\"_self\"\n      [treeItem]=\"item\"\n      [showCheckbox]=\"showCheckboxes\"\n      [labelTemplateRef]=\"itemLabelTemplate || defaultItemLabelTemplate\"\n      [ariaLevel]=\"1\"\n      [ariaIndex]=\"i + 1\"\n      [ariaSiblings]=\"treeItems\"\n    ></bento-tree-item>\n  </div>\n</div>\n<ng-template #defaultItemLabelTemplate let-n=\"item\" let-r=\"treeRoot\" let-uid=\"itemUID\">\n  <label class=\"bento-tree-item-label\" [attr.id]=\"'label-' + uid\">\n    {{ n[r.itemLabelProp] }}\n  </label>\n</ng-template>\n", styles: [".ng-bento bento-tree{display:block}.ng-bento bento-tree .bento-tree-branch-base{padding-left:24px;display:block;width:100%;font-size:12px}[dir=rtl] .ng-bento bento-tree .bento-tree-branch-base{padding-left:0;padding-right:24px}[dir=rtl] .ng-bento bento-tree .bento-tree-root>.bento-tree-branch-base{padding-left:0}.ng-bento bento-tree-item{list-style:none;white-space:nowrap;display:flex;align-content:stretch;margin-top:-1px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}.ng-bento bento-tree-item>div:before{display:block;position:absolute;box-sizing:border-box;content:\"\";width:100%;left:0;background:none}[dir=rtl] .ng-bento bento-tree-item>div:before{left:auto;right:0}.ng-bento bento-tree-item>div{width:100%}.bento-tree-alt .ng-bento bento-tree-item>div:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.bento-tree-alt .ng-bento bento-tree-item .selected:before{z-index:2}.ng-bento bento-tree-item .tree-item-checkbox{position:relative;z-index:2}.ng-bento bento-tree-item .selected:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.ng-bento bento-tree-item i,.ng-bento bento-tree-item [class^=bento-icon-],.ng-bento bento-tree-item [class*=\" bento-icon-\"]{font-size:14px;margin-right:4px;line-height:1;z-index:2}[dir=rtl] .ng-bento bento-tree-item i,[dir=rtl] .ng-bento bento-tree-item [class^=bento-icon-],[dir=rtl] .ng-bento bento-tree-item [class*=\" bento-icon-\"]{margin-right:0;margin-left:4px}.ng-bento bento-tree-item i.bui-checkbox-unchecked,.ng-bento bento-tree-item i.bui-checkbox-checked,.ng-bento bento-tree-item i.bui-checkbox-indeterminate{margin-right:0}[dir=rtl] .ng-bento bento-tree-item i.bui-checkbox-unchecked,[dir=rtl] .ng-bento bento-tree-item i.bui-checkbox-checked,[dir=rtl] .ng-bento bento-tree-item i.bui-checkbox-indeterminate{margin-left:0}[dir=rtl] .ng-bento bento-tree-item .bento-icon-checkbox,[dir=rtl] .ng-bento bento-tree-item .bento-icon-checkbox-filled,[dir=rtl] .ng-bento bento-tree-item .bento-icon-collapse{margin-left:0}.ng-bento bento-tree-item .expand-button-compiled{align-items:center;background:none;border:none;cursor:default;display:flex;float:left;justify-content:center;margin-left:-30px;opacity:.8;padding:0;position:relative;text-align:center;z-index:2}[dir=rtl] .ng-bento bento-tree-item .expand-button-compiled{margin-left:0;margin-right:-30px;float:right}.ng-bento bento-tree-item .expand-button-compiled:focus,.ng-bento bento-tree-item .expand-button-compiled:hover{outline:none}.ng-bento bento-tree-item .expand-button-compiled .bento-tree-icon{font-size:1.1em}.ng-bento bento-tree-item .expand-button-compiled~.bento-tree-item-cta,.ng-bento bento-tree-item .expand-button-compiled~.bento-tree-item-cta .bento-tree-item-label{font-weight:700}.ng-bento bento-tree-item .expand-button-compiled:hover{opacity:1}.ng-bento bento-tree-item .bento-tree-icon{padding-left:28px;line-height:16px;vertical-align:middle}[dir=rtl] .ng-bento bento-tree-item .bento-tree-icon{padding-left:0;padding-right:28px}.ng-bento bento-tree-item .bento-tree-icon.second-tree-icon{padding:0;width:auto;margin:0;top:0;vertical-align:text-top}.ng-bento bento-tree-item .bento-tree-icon:before{font-size:16px;line-height:16px;left:1px}.ng-bento .bento-tree-disabled{pointer-events:none}.ng-bento bento-tree .bento-tree-branch.bento-tree-root>.bento-tree-branch-base{margin-top:0;position:relative}.ng-bento .bento-tree-item-cta{display:inline-flex;align-items:center;line-height:14px;cursor:default;background-color:transparent;vertical-align:top}.ng-bento .bento-tree-item-cta:focus,.ng-bento .bento-tree-item-cta:hover{outline:none}.ng-bento .bento-tree-item-cta:focus .bento-tree-item-cta-wrapper,.ng-bento .bento-tree-item-cta:hover .bento-tree-item-cta-wrapper{text-decoration:underline}.ng-bento .bento-tree-item-cta:focus .bento-tree-item-cta-wrapper label,.ng-bento .bento-tree-item-cta:hover .bento-tree-item-cta-wrapper label{text-decoration:underline}.ng-bento .bento-tree-item-cta:before{content:\" \";position:absolute;left:0;width:100%;background:transparent;z-index:0}[dir=rtl] .ng-bento .bento-tree-item-cta:before{left:auto;right:0}bento-checkbox+.ng-bento .bento-tree-item-cta{width:calc(100% - 22px)}i+.ng-bento .bento-tree-item-cta{width:calc(100% - 44px)}.selected>.ng-bento .bento-tree-item-cta .bento-tree-item-cta-wrapper{position:relative;z-index:2}.selected>.ng-bento .bento-tree-item-cta:before{content:\"\";display:block;position:absolute;z-index:2;width:4px;left:0;border-right-style:solid;border-right-width:1px;border-top:1px solid;border-bottom:1px solid}[dir=rtl] .selected>.ng-bento .bento-tree-item-cta:before{border-right-width:0;border-right-style:solid;border-left-style:solid;border-left-width:1px;left:auto;right:0}.ng-bento .bento-tree-item-cta-wrapper{width:100%;overflow:hidden;text-overflow:ellipsis;position:relative;z-index:1}.ng-bento .bento-tree-item-cta-wrapper label{margin-bottom:0}\n"], components: [{ type: BentoExpandCollapseButtonGroupComponent, selector: "bento-expand-collapse-button-group", inputs: ["expandAllTitle", "collapseAllTitle"], outputs: ["expand", "collapse"] }, { type: BentoTreeItemComponent, selector: "bento-tree-item", inputs: ["treeItem", "parent", "root", "labelTemplateRef", "isLast", "showCheckbox", "ariaLevel", "ariaIndex", "ariaSiblings"], outputs: ["itemCheckChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tree', providers: [BentoUidService], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<bento-expand-collapse-button-group\n  *ngIf=\"showExpandCollapseAllButtons\"\n  [expandAllTitle]=\"'BENTO_UI_TREE_EXPAND_ALL' | bentoTranslate\"\n  [collapseAllTitle]=\"'BENTO_UI_TREE_COLLAPSE_ALL' | bentoTranslate\"\n  (expand)=\"expandAll()\"\n  (collapse)=\"collapseAll()\"\n></bento-expand-collapse-button-group>\n<div class=\"bento-tree-branch bento-tree-root\" role=\"tree\" *ngIf=\"treeItems && treeItems.length > 0\">\n  <div class=\"bento-tree-branch-base\">\n    <bento-tree-item\n      *ngFor=\"let item of treeItems; index as i\"\n      [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n      [root]=\"_self\"\n      [treeItem]=\"item\"\n      [showCheckbox]=\"showCheckboxes\"\n      [labelTemplateRef]=\"itemLabelTemplate || defaultItemLabelTemplate\"\n      [ariaLevel]=\"1\"\n      [ariaIndex]=\"i + 1\"\n      [ariaSiblings]=\"treeItems\"\n    ></bento-tree-item>\n  </div>\n</div>\n<ng-template #defaultItemLabelTemplate let-n=\"item\" let-r=\"treeRoot\" let-uid=\"itemUID\">\n  <label class=\"bento-tree-item-label\" [attr.id]=\"'label-' + uid\">\n    {{ n[r.itemLabelProp] }}\n  </label>\n</ng-template>\n", styles: [".ng-bento bento-tree{display:block}.ng-bento bento-tree .bento-tree-branch-base{padding-left:24px;display:block;width:100%;font-size:12px}[dir=rtl] .ng-bento bento-tree .bento-tree-branch-base{padding-left:0;padding-right:24px}[dir=rtl] .ng-bento bento-tree .bento-tree-root>.bento-tree-branch-base{padding-left:0}.ng-bento bento-tree-item{list-style:none;white-space:nowrap;display:flex;align-content:stretch;margin-top:-1px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}.ng-bento bento-tree-item>div:before{display:block;position:absolute;box-sizing:border-box;content:\"\";width:100%;left:0;background:none}[dir=rtl] .ng-bento bento-tree-item>div:before{left:auto;right:0}.ng-bento bento-tree-item>div{width:100%}.bento-tree-alt .ng-bento bento-tree-item>div:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.bento-tree-alt .ng-bento bento-tree-item .selected:before{z-index:2}.ng-bento bento-tree-item .tree-item-checkbox{position:relative;z-index:2}.ng-bento bento-tree-item .selected:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.ng-bento bento-tree-item i,.ng-bento bento-tree-item [class^=bento-icon-],.ng-bento bento-tree-item [class*=\" bento-icon-\"]{font-size:14px;margin-right:4px;line-height:1;z-index:2}[dir=rtl] .ng-bento bento-tree-item i,[dir=rtl] .ng-bento bento-tree-item [class^=bento-icon-],[dir=rtl] .ng-bento bento-tree-item [class*=\" bento-icon-\"]{margin-right:0;margin-left:4px}.ng-bento bento-tree-item i.bui-checkbox-unchecked,.ng-bento bento-tree-item i.bui-checkbox-checked,.ng-bento bento-tree-item i.bui-checkbox-indeterminate{margin-right:0}[dir=rtl] .ng-bento bento-tree-item i.bui-checkbox-unchecked,[dir=rtl] .ng-bento bento-tree-item i.bui-checkbox-checked,[dir=rtl] .ng-bento bento-tree-item i.bui-checkbox-indeterminate{margin-left:0}[dir=rtl] .ng-bento bento-tree-item .bento-icon-checkbox,[dir=rtl] .ng-bento bento-tree-item .bento-icon-checkbox-filled,[dir=rtl] .ng-bento bento-tree-item .bento-icon-collapse{margin-left:0}.ng-bento bento-tree-item .expand-button-compiled{align-items:center;background:none;border:none;cursor:default;display:flex;float:left;justify-content:center;margin-left:-30px;opacity:.8;padding:0;position:relative;text-align:center;z-index:2}[dir=rtl] .ng-bento bento-tree-item .expand-button-compiled{margin-left:0;margin-right:-30px;float:right}.ng-bento bento-tree-item .expand-button-compiled:focus,.ng-bento bento-tree-item .expand-button-compiled:hover{outline:none}.ng-bento bento-tree-item .expand-button-compiled .bento-tree-icon{font-size:1.1em}.ng-bento bento-tree-item .expand-button-compiled~.bento-tree-item-cta,.ng-bento bento-tree-item .expand-button-compiled~.bento-tree-item-cta .bento-tree-item-label{font-weight:700}.ng-bento bento-tree-item .expand-button-compiled:hover{opacity:1}.ng-bento bento-tree-item .bento-tree-icon{padding-left:28px;line-height:16px;vertical-align:middle}[dir=rtl] .ng-bento bento-tree-item .bento-tree-icon{padding-left:0;padding-right:28px}.ng-bento bento-tree-item .bento-tree-icon.second-tree-icon{padding:0;width:auto;margin:0;top:0;vertical-align:text-top}.ng-bento bento-tree-item .bento-tree-icon:before{font-size:16px;line-height:16px;left:1px}.ng-bento .bento-tree-disabled{pointer-events:none}.ng-bento bento-tree .bento-tree-branch.bento-tree-root>.bento-tree-branch-base{margin-top:0;position:relative}.ng-bento .bento-tree-item-cta{display:inline-flex;align-items:center;line-height:14px;cursor:default;background-color:transparent;vertical-align:top}.ng-bento .bento-tree-item-cta:focus,.ng-bento .bento-tree-item-cta:hover{outline:none}.ng-bento .bento-tree-item-cta:focus .bento-tree-item-cta-wrapper,.ng-bento .bento-tree-item-cta:hover .bento-tree-item-cta-wrapper{text-decoration:underline}.ng-bento .bento-tree-item-cta:focus .bento-tree-item-cta-wrapper label,.ng-bento .bento-tree-item-cta:hover .bento-tree-item-cta-wrapper label{text-decoration:underline}.ng-bento .bento-tree-item-cta:before{content:\" \";position:absolute;left:0;width:100%;background:transparent;z-index:0}[dir=rtl] .ng-bento .bento-tree-item-cta:before{left:auto;right:0}bento-checkbox+.ng-bento .bento-tree-item-cta{width:calc(100% - 22px)}i+.ng-bento .bento-tree-item-cta{width:calc(100% - 44px)}.selected>.ng-bento .bento-tree-item-cta .bento-tree-item-cta-wrapper{position:relative;z-index:2}.selected>.ng-bento .bento-tree-item-cta:before{content:\"\";display:block;position:absolute;z-index:2;width:4px;left:0;border-right-style:solid;border-right-width:1px;border-top:1px solid;border-bottom:1px solid}[dir=rtl] .selected>.ng-bento .bento-tree-item-cta:before{border-right-width:0;border-right-style:solid;border-left-style:solid;border-left-width:1px;left:auto;right:0}.ng-bento .bento-tree-item-cta-wrapper{width:100%;overflow:hidden;text-overflow:ellipsis;position:relative;z-index:1}.ng-bento .bento-tree-item-cta-wrapper label{margin-bottom:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: BentoUidService }]; }, propDecorators: { items: [{
                type: Input
            }], multiSelect: [{
                type: Input
            }], itemIconProp: [{
                type: Input
            }], itemChildrenProp: [{
                type: Input
            }], itemLabelProp: [{
                type: Input
            }], itemExpandOnly: [{
                type: Input
            }], selectAsCheck: [{
                type: Input
            }], showCheckboxes: [{
                type: Input
            }], showExpandCollapseAllButtons: [{
                type: Input
            }], itemLabelTemplate: [{
                type: Input
            }], itemSelect: [{
                type: Output
            }], itemExpandCollapse: [{
                type: Output
            }], itemCheck: [{
                type: Output
            }], itemUnCheck: [{
                type: Output
            }], itemOnChange: [{
                type: Output
            }], children: [{
                type: ViewChildren,
                args: [forwardRef(() => BentoTreeItemComponent)]
            }], defaultItemLabelTemplate: [{
                type: ViewChild,
                args: ['defaultItemLabelTemplate', { static: true }]
            }] } });

const DEFAULT_PADDING_LEFT = 25;
const BENTO_TREE_ITEM_OPTION = '$bentoTreeItemOption';
let counterId = 0;
/**
 * Tree view that creates a hierarchical view of items in a collection in a panel.
 * Users can expand/collapse items in the tree to view the content of the children items,
 * and they can also select individual items.
 *
 * #### Keyboard Shortcuts
 * _One of the tree items must be focused, for shortcut to function._
 * | Key | Function |
 * | --- | -------- |
 * | <kbd>UP ARROW</kbd> | Select the previous visible tree item.
 * | <kbd>DOWN ARROW</kbd> | Select next visible tree item |
 * | <kbd>LEFT ARROW</kbd> | Collapse the currently selected parent item if it is expanded. Move to the previous parent
 * node (if possible) when the current parent item is collapsed. Move to the previous element in a tree item| |
 * <kbd>RIGHT ARROW</kbd> | Expand the currently selected parent item and move to the first child list item. Move to the
 * previous element in a tree item | | <kbd>HOME</kbd> | Select the root parent node of the tree | | <kbd>END</kbd> |
 * Select the last visible node of the tree | | <kbd>TAB</kbd> | Navigate away from tree | | <kbd>*</kbd> (requires
 * numeric keypad) | Expand all group items |
 *
 */
class BentoTreeViewComponent {
    constructor(winRef, elRef, resizeNotification, directionality, r, changeDetector) {
        this.r = r;
        this.changeDetector = changeDetector;
        /**
         * Flag to determine of the items are collapsed when initially added/appended to the Tree View component
         */
        this.collapseItemsOnAdd = false;
        /**
         * Flag to multiple tree items can be selected
         */
        this.multiSelect = false;
        /**
         * Flag to only expand or collapse a tree branch
         */
        this.itemExpandOnly = false;
        /**
         * Flag to a tree item click is considered as a checkbox click
         */
        this.selectAsCheck = false;
        /**
         * Flag to show all checkbobox components
         */
        this.showCheckboxes = true;
        /**
         * Flag to disable tree node selection
         */
        this.disableSelection = false;
        /**
         * Flag to show the expand and collapse all buttons
         */
        this.showExpandCollapseAllButtons = false;
        /**
         * Make checkboxes to be independent from hierachical relationships
         */
        this.independentCheckbox = false;
        /**
         * Disable HTML focus on leaf items to accomondate custom templates
         */
        this.disableFocusOnLeaves = false;
        /**
         * Callback to when a item is checked
         */
        this.itemCheck = new EventEmitter();
        /**
         * Callback to when a tree item is expanded or collapsed
         */
        this.itemExpandCollapse = new EventEmitter();
        /**
         * Callback to when a item is selected
         */
        this.itemSelect = new EventEmitter();
        /**
         * Default row height
         */
        this.rowHeight = 30;
        /**
         * Flag to determine if APP is in RTL mode
         */
        this.isRTL = false;
        /**
         * Padding left of each level
         */
        this._paddingLeft = DEFAULT_PADDING_LEFT;
        this.uid = `bui-treeview-${counterId++}`;
        this.selectedItems = [];
        this.checkedItems = [];
        this.resizeSubscription = Subscription.EMPTY;
        /**
         * NodeList index where the current focus is assigned to within a tree item row HTMLElement.
         */
        this.activeRowFocusIndex = 0;
        this.directionChangeSubscription = Subscription.EMPTY;
        this.componentInitialized = false;
        this.itemSubscriptions = [];
        // Init some values
        this.document = winRef.nativeDocument;
        this.el = elRef.nativeElement;
        this.isRTL = directionality.value === 'rtl';
        // Subscribe to resize and direction change
        this.resizeSubscription = resizeNotification.resizeNotification.subscribe(() => this.checkViewportSize());
        this.directionChangeSubscription = directionality.change.subscribe(dir => {
            this.isRTL = dir === 'rtl';
            this.changeDetector.markForCheck();
        });
    }
    /**
     * Main Bento Tree data
     */
    set items(data) {
        if (data) {
            this.itemsData = data;
            if (this.componentInitialized) {
                this.initData(data);
            }
        }
        else {
            // Do there is no tree data yet
            this._itemsFlatData = [];
        }
    }
    ngOnInit() {
        this.componentInitialized = true;
        if (this.itemsData) {
            this.initData(this.itemsData);
        }
    }
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
        this.directionChangeSubscription.unsubscribe();
        this.unsubscribeAllItems();
    }
    /**
     * Expand all nodes
     */
    expandAllGroups() {
        // Only there are children
        for (const item of this.itemsData) {
            // expand each child
            this.setAllItemCollapsedState(item, false);
        }
        this.checkViewportSize();
    }
    /**
     * Collapse all nodes
     */
    collapseAllGroups() {
        // Only there are children
        for (const item of this.itemsData) {
            // expand each child
            this.setAllItemCollapsedState(item, true);
        }
        this.checkViewportSize();
    }
    /**
     * Check tree viewport size and re-render
     */
    checkViewportSize() {
        this.cdkViewport.checkViewportSize();
    }
    refreshCDKViewport() {
        this.changeDetector.markForCheck();
    }
    /**
     * When expand/collapse button is clicked
     */
    _onExpandCollapseClick(item) {
        const children = item[this.itemChildrenProp];
        if (!Array.isArray(children)) {
            // This item is not a root of a branch
            return;
        }
        const option = item[BENTO_TREE_ITEM_OPTION];
        const isCollapsed = option.getCollapsed(this.id);
        // Update status
        option.setCollapsed(!isCollapsed, this.id);
    }
    _onCheckChanged(v, item) {
        if (this.selectAsCheck && !this.multiSelect) {
            const oldChecks = this.checkedItems;
            this.checkedItems = [item];
            for (const i of oldChecks) {
                if (i !== item) {
                    i[BENTO_TREE_ITEM_OPTION].setChecked(false, this.id);
                }
            }
        }
        const options = item[BENTO_TREE_ITEM_OPTION];
        options.setChecked(v, this.id);
        this.itemCheck.emit({ items: this.checkedItems.slice() });
    }
    _onItemCTAClick(target, item) {
        const options = item[BENTO_TREE_ITEM_OPTION];
        const activeRowID = this.getFocusedGroupID();
        if (activeRowID == null) {
            // There is no activeRow
            /* istanbul ignore next */
            return;
        }
        const groupFocusables = this.getFocusableElements(activeRowID);
        // Set the active row item index for up/down keyboard supprot
        this.activeRowFocusIndex = Math.max(0, groupFocusables ? groupFocusables.indexOf(target) : 0);
        if (this.selectAsCheck) {
            this._onCheckChanged(!options.getChecked(this.id), item);
        }
        else if (this.itemExpandOnly) {
            this._onExpandCollapseClick(item);
        }
        else {
            if (!this.disableSelection) {
                const nextSelectionStatus = !options.getSelected(this.id);
                options.setSelected(nextSelectionStatus, this.id);
                if (nextSelectionStatus) {
                    this.animateSelectionFeedback(target);
                }
                this.itemSelect.emit({
                    items: this.selectedItems,
                    cancel: () => {
                        // Revert previous selection
                        options.setSelected(!nextSelectionStatus, this.id);
                    }
                });
            }
        }
    }
    /**
     * Forward focus onto the first focusable item in the tree
     */
    _onCDKViewportFocus() {
        const focusableEls = this.getFocusableElements(Math.ceil(this.cdkViewport.measureScrollOffset('top') / this.rowHeight));
        if (focusableEls.length) {
            focusableEls[0].focus();
        }
    }
    /**
     * Making sure that the flattened tree items are rendered in order correctly
     */
    _itemOrderTrackBy(index, item) {
        return index;
    }
    onTreeKeydown(e, keyCode) {
        const activeRowID = this.getFocusedGroupID();
        if (activeRowID == null) {
            // Do nothing when there is no active row
            /* istanbul ignore next */
            return;
        }
        const activeEl = this.document.activeElement;
        const focusableElements = this.getFocusableElements(activeRowID);
        const item = this._itemsFlatData[activeRowID];
        const options = item[BENTO_TREE_ITEM_OPTION];
        const activeElementFocusIndex = focusableElements.indexOf(activeEl);
        switch (keyCode) {
            case Keyboard.UP: // Arrow up
                if (activeRowID > 0) {
                    this.focusToCTA(activeRowID - 1, this.activeRowFocusIndex);
                }
                e.preventDefault();
                break;
            case Keyboard.DOWN: // Arrow Down
                this.focusToCTA(activeRowID + 1, this.activeRowFocusIndex);
                e.preventDefault();
                break;
            case Keyboard.RIGHT:
            case Keyboard.LEFT:
                if ((keyCode === Keyboard.RIGHT && !this.isRTL) || (keyCode === Keyboard.LEFT && this.isRTL)) {
                    // RIGHT in LTR or LEFT in RTL
                    if (Array.isArray(item[this.itemChildrenProp]) && activeElementFocusIndex === focusableElements.length - 1) {
                        if (options.getCollapsed(this.id)) {
                            // Expand this item if its collapsed
                            options.setCollapsed(false, this.id);
                        }
                        else if (item[this.itemChildrenProp].length > 0) {
                            // Move focus to the next row in CDK
                            this.focusToCTA(activeRowID + 1, this.activeRowFocusIndex);
                        }
                    }
                    else {
                        // Move focus to next focusable sibling element
                        this.activeRowFocusIndex = Math.min(focusableElements.length - 1, activeElementFocusIndex + 1);
                        focusableElements[this.activeRowFocusIndex].focus();
                    }
                }
                else {
                    // Left in LTR or RIGHT in RTL
                    if (activeElementFocusIndex === 0) {
                        if (Array.isArray(item[this.itemChildrenProp]) && !options.getCollapsed(this.id)) {
                            // This item has children and is expanded
                            // so we collapse it
                            options.setCollapsed(true, this.id);
                        }
                        else {
                            // This item is either collapsed or doesn't have children
                            // We move up to its parent node
                            const parent = options.parent;
                            if (parent) {
                                const parentIndex = this._itemsFlatData.indexOf(parent);
                                // The current item could be root
                                this.showRowIndex(this._itemsFlatData.indexOf(parent));
                                // Looks like the index doesn't show right away
                                this.focusToCTA(parentIndex, this.activeRowFocusIndex);
                            }
                        }
                    }
                    else {
                        // Move focus to previous focusable sibling element
                        focusableElements[(this.activeRowFocusIndex = activeElementFocusIndex - 1)].focus();
                    }
                }
                e.preventDefault();
                break;
            case Keyboard.HOME: // Focus on the first root
                this.showRowIndex(0);
                this.focusToCTA(0, (this.activeRowFocusIndex = 0));
                e.preventDefault();
                break;
            case Keyboard.END: // Focus on the last item in viewport
                const lastIndex = this._itemsFlatData.length - 1;
                this.showRowIndex(lastIndex);
                this.focusToCTA(lastIndex, 100);
                e.preventDefault();
                break;
            case Keyboard.NUM_ASTERISK: // Expand all nodes
                this.expandAllGroups();
                e.preventDefault();
                break;
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                if (!this.disableFocusOnLeaves && activeEl.classList.contains('bui-tree-item-cta')) {
                    // Only applies to CTA
                    this._onItemCTAClick(activeEl, item);
                    e.preventDefault();
                }
                break;
        }
    }
    initData(data) {
        this.unsubscribeAllItems();
        this.processItemTreeCollection(null, data);
        if (!this.independentCheckbox && this.showCheckboxes) {
            if (Array.isArray(data)) {
                for (const item of data) {
                    this.updateCheckedState(item);
                }
            }
        }
        this.itemCheck.emit({ items: this.checkedItems.slice() });
        this.changeDetector.markForCheck();
    }
    /**
     * Get focuable elements by its rowID within CTA label
     * Will return CTA label element only if there is no focusable children
     */
    getFocusableElements(rowID) {
        const treeItemEl = this.el.querySelector(`#${this.id || this.uid}-${rowID}`);
        const focusSelectorStr = 'button:not(:disabled):not(.bui-tree-view-expand-collapse-btn),' +
            'a[href]:not(:disabled), [tabindex]:not(.bui-tree-view-expand-collapse-btn), input:not(:disabled)';
        return Array.from(treeItemEl.querySelectorAll(focusSelectorStr));
    }
    /**
     * Get tree item ID from the currently focused element
     */
    getFocusedGroupID() {
        const cdkScrollEl = this.cdkViewport.getElementRef().nativeElement;
        const activeEl = this.document.activeElement;
        if (cdkScrollEl.contains(activeEl)) {
            const treeItemIDBase = `${this.id || this.uid}-`;
            // Only get rowID when the focus is in the CDKScrollable
            let parent = activeEl.parentElement;
            while (!parent.hasAttribute('id') || parent.getAttribute('id').indexOf(treeItemIDBase) < 0) {
                parent = parent.parentElement;
                if (parent == null) {
                    // just in case
                    /* istanbul ignore next */
                    return null;
                }
            }
            return parseInt(parent.getAttribute('id').split('-').pop(), 10);
        }
    }
    /**
     * Append child/children to an item
     */
    appendChildrenToItem(children, item) {
        const itemsToAppend = Array.isArray(children) ? children : [children];
        const itemChildren = item[this.itemChildrenProp];
        const options = item[BENTO_TREE_ITEM_OPTION];
        if (itemChildren) {
            // There are already children, we concact the two arrays
            item[this.itemChildrenProp] = itemChildren.concat(itemsToAppend);
        }
        else {
            // No children
            item[this.itemChildrenProp] = itemsToAppend;
        }
        if (!options.getCollapsed(this.id)) {
            // Remove descendants first
            this.removeDescendants(item);
        }
        // Only process the items that are new
        this.processItemTreeCollection(item, item[this.itemChildrenProp], item[BENTO_TREE_ITEM_OPTION].level + 1);
        // Need to refresh the view
        this._itemsFlatData = this._itemsFlatData.slice();
        if (!this.independentCheckbox && this.showCheckboxes) {
            // Again
            // Check all checkboxes
            for (const treeItem of this.itemsData) {
                this.updateCheckedState(treeItem);
            }
        }
        this.changeDetector.markForCheck();
    }
    checkChildren(item, state) {
        const children = item[this.itemChildrenProp];
        if (Array.isArray(children)) {
            for (const child of children) {
                child[BENTO_TREE_ITEM_OPTION].setChecked(state, this.id, false); // Do not bubble
            }
        }
    }
    /**
     * Focus to an element by its given id
     */
    focusToCTA(rowIndex, index) {
        setTimeout(() => {
            const elements = this.getFocusableElements(rowIndex);
            if (elements) {
                elements[Math.min(index, elements.length - 1)].focus();
            }
        }, 100);
    }
    /**
     * Insert all the descendants of a parent in to the flattened array
     */
    insertDescendants(parent) {
        const option = parent[BENTO_TREE_ITEM_OPTION];
        if (option.getCollapsed(this.id)) {
            // This node is collapsed so there is no need to insert its children
            return;
        }
        const children = parent[this.itemChildrenProp];
        if (Array.isArray(children)) {
            // Get the index where the current parent is located in the flatArray
            // Insert its children after the index
            const index = this._itemsFlatData.indexOf(parent) + 1;
            this._itemsFlatData.splice(index, 0, ...children);
            for (const child of children) {
                // Do the same to each child
                this.insertDescendants(child);
            }
        }
        this._itemsFlatData = this._itemsFlatData.slice();
    }
    /**
     * Process an item's ComboboxOption property
     * @param item Tree node item
     */
    processItemOption(item, parent, siblings, index, level) {
        let options = item[BENTO_TREE_ITEM_OPTION] ||
            new BentoTreeItemOption(undefined, undefined, this.collapseItemsOnAdd, undefined, undefined, undefined, undefined, undefined, level, siblings, index, parent);
        if (!(options instanceof BentoTreeItemOption)) {
            // Options is a simple Object need to convert it to Class
            options = new BentoTreeItemOption(options.checked, options.selected, options.collapsed == null ? this.collapseItemsOnAdd : options.collapsed, options.indeterminate, options.hideCheckbox, options.preventSelection, options.isHidden, options.disabled, level, siblings, index, parent);
        }
        if (options.selected) {
            this.selectedItems.push(item);
        }
        item[BENTO_TREE_ITEM_OPTION] = options;
        const subs = this.itemSubscriptions;
        subs[subs.length] = options._itemAppend.subscribe(children => this.appendChildrenToItem(children, item));
        // selected subscription
        subs[subs.length] = options._selectedChange.subscribe(res => {
            if (res.treeId == this.id) {
                if (res.v) {
                    // Update selection
                    this.updateSelections(item);
                }
                else {
                    const itemIndex = this.selectedItems.indexOf(item);
                    if (itemIndex > -1) {
                        this.selectedItems.splice(itemIndex, 1);
                    }
                }
            }
        });
        // collapsed subscription
        // this.collapsedSubscription =
        subs[subs.length] = options._collapsedChange.subscribe(res => {
            if (res.treeId === this.id) {
                const children = item[this.itemChildrenProp];
                let cancel = false;
                let changed = false;
                if (!Array.isArray(children)) {
                    // No need to remove or add descendants from the viewport array
                    return;
                }
                this.itemExpandCollapse.emit({
                    item,
                    cancel: () => {
                        cancel = true;
                        // If the collapse state chaneg has already executed revert it
                        // otherwise revert it silently with disturbing the UI
                        options.setCollapsed(!options.getCollapsed(this.id), this.id, !changed);
                    }
                });
                if (!cancel) {
                    if (this._itemsFlatData.indexOf(item) > -1) {
                        // Update view
                        if (res.v) {
                            // Will remove its descendants
                            this.removeDescendants(item);
                        }
                        else {
                            // Will insert its descendants
                            this.insertDescendants(item);
                        }
                    }
                    this.checkViewportSize();
                    changed = true;
                }
            }
        });
        // check subscription
        subs[subs.length] = options._checkedChange.subscribe(res => {
            if (res.treeId === this.id || // a check change targeting this tree with a treeId
                res.treeId == null // wildcard on treeId
            ) {
                if (res.bubble) {
                    // Only emit item check change when it needs to bubble up
                    if (item[BENTO_TREE_ITEM_OPTION].parent &&
                        !this.independentCheckbox // There is no parent-child relationship for checkbox
                    ) {
                        this.updateParentCheckState(item[BENTO_TREE_ITEM_OPTION].parent);
                    }
                }
                // Get Iten index
                const itemIndex = this.checkedItems.indexOf(item);
                if (res.v && itemIndex === -1) {
                    // If item is checked and is not in `checkedItem` array
                    this.checkedItems.push(item);
                }
                else if (!res.v && itemIndex > -1) {
                    // If item is NOT checked and is in `checkedItem` array
                    this.checkedItems.splice(itemIndex, 1);
                }
                if (!options.getIndeterminate(this.id) &&
                    !res.silent &&
                    !this.independentCheckbox // There is no parent-child relationship for checkbox
                ) {
                    // Set check status on children only when the dataModel of this tree item does not
                    // have indeterminate state
                    this.checkChildren(item, res.v);
                }
            }
        });
        // // indeterminate
        subs[subs.length] = options._indeterminateChange.subscribe(res => {
            if (res.treeId === this.id || res.treeId == null) {
                this.updateParentCheckState(options.parent);
            }
        });
    }
    /**
     * Flatten a tree structed array for view
     */
    processItemTreeCollection(parent, children, level = 1) {
        if (parent == null) {
            // This is the root of the tree so we start fresh
            this._itemsFlatData = children.slice();
        }
        else {
            // Look for parent's index in flattened data array and insert its children
            const fData = this._itemsFlatData;
            const parentOptions = parent[BENTO_TREE_ITEM_OPTION];
            // Insert children into fData only if parend is expanded
            if (!parentOptions.getCollapsed(this.id)) {
                const index = fData.indexOf(parent);
                if (index > -1) {
                    // Parent exists in view
                    fData.splice(index + 1, 0, ...children);
                }
            }
        }
        for (let i = 0; i < children.length; i++) {
            const item = children[i];
            const itemChildren = item[this.itemChildrenProp];
            this.processItemOption(item, parent, children, i, level);
            if (Array.isArray(itemChildren)) {
                // Process children
                this.processItemTreeCollection(item, itemChildren, level + 1);
            }
        }
    }
    /**
     * Remove all descendants of the parent from the flattened array
     */
    removeDescendants(parent) {
        const startIndex = this._itemsFlatData.indexOf(parent) + 1;
        let endIndex = -1;
        let me = parent;
        while (endIndex < 0) {
            const option = me[BENTO_TREE_ITEM_OPTION];
            if (option.index < option.siblingSize) {
                // Found! There is a younger sibling
                // 1 based indexing
                endIndex = this._itemsFlatData.indexOf(option.siblings[option.index]);
            }
            else if (option.parent) {
                // Nope! Need to find itemMarkers parent's younger sibling
                me = option.parent;
            }
            else {
                // This `parent` is the last parent here
                // remove the reset
                endIndex = this._itemsFlatData.length;
            }
        }
        // Now we remove
        this._itemsFlatData.splice(startIndex, endIndex - startIndex);
        this._itemsFlatData = this._itemsFlatData.slice();
    }
    /**
     * Expand or collapse all item and its descendants
     */
    setAllItemCollapsedState(item, state) {
        let children;
        children = item[this.itemChildrenProp];
        if (Array.isArray(children)) {
            item[BENTO_TREE_ITEM_OPTION].setCollapsed(state, this.id);
        }
        if (children && children.length > 0) {
            // Only there are children
            for (const child of children) {
                // expand each child
                this.setAllItemCollapsedState(child, state);
            }
        }
    }
    /**
     * Make a row visible in thescroll pane by its index
     */
    showRowIndex(index) {
        const rowOffsetTop = index * this.rowHeight;
        const viewportEl = this.cdkViewport.getElementRef().nativeElement;
        const listHeight = viewportEl.offsetHeight;
        const scrollTop = viewportEl.scrollTop;
        if (rowOffsetTop + this.rowHeight > listHeight + scrollTop) {
            this.cdkViewport.scrollTo({ top: rowOffsetTop - listHeight + this.rowHeight });
        }
        else if (rowOffsetTop < scrollTop) {
            this.cdkViewport.scrollTo({ top: rowOffsetTop });
        }
        this.cdkViewport.checkViewportSize();
    }
    /**
     * Update checkbox status based on their relationships
     */
    updateCheckedState(item) {
        const option = item[BENTO_TREE_ITEM_OPTION];
        const isChecked = option.getChecked(this.id);
        if (isChecked) {
            option.setChecked(true, this.id, false, true);
            this.checkChildren(item, true);
        }
        else {
            const children = item[this.itemChildrenProp];
            if (!!children && Array.isArray(children) && !!children.length) {
                let allChecked = true;
                let allUnChecked = true;
                let hasIndeterminate = false;
                for (const child of children) {
                    const indetermiate = this.updateCheckedState(child);
                    const childIsChecked = child[BENTO_TREE_ITEM_OPTION].getChecked(this.id);
                    if (indetermiate) {
                        hasIndeterminate = true;
                    }
                    else if (childIsChecked) {
                        allUnChecked = false;
                    }
                    else if (!childIsChecked) {
                        allChecked = false;
                    }
                }
                if (hasIndeterminate || !(allChecked || allUnChecked)) {
                    option.setIndeterminate(true, this.id);
                    return true;
                }
                else if (allChecked) {
                    option.setChecked(true, this.id, false, true);
                }
                else if (allUnChecked) {
                    option.setChecked(false, this.id, false, true);
                }
                return false;
            }
            else {
                // Not indetermindate
                return false;
            }
        }
    }
    updateParentCheckState(item) {
        if (!item) {
            // There is nothing to check
            return;
        }
        let allChecked = true;
        let allUnChecked = true;
        let hasIndeterminate = false;
        const children = item[this.itemChildrenProp];
        const options = item[BENTO_TREE_ITEM_OPTION];
        for (const child of children) {
            const childOptions = child[BENTO_TREE_ITEM_OPTION];
            if (!childOptions.hideCheckbox) {
                const isChecked = childOptions.getChecked(this.id);
                const isIndeterminate = childOptions.getIndeterminate(this.id);
                if (isIndeterminate || !(allChecked || allUnChecked)) {
                    hasIndeterminate = true;
                    break;
                }
                else if (allUnChecked && allChecked) {
                    allChecked = isChecked;
                    allUnChecked = !isChecked;
                }
                else if ((allChecked && !isChecked) || (allUnChecked && isChecked)) {
                    hasIndeterminate = true;
                    break;
                }
            }
        }
        if (hasIndeterminate) {
            options.setIndeterminate(true, this.id);
        }
        else if (allChecked) {
            options.setChecked(true, this.id, true, true);
        }
        else if (allUnChecked) {
            options.setChecked(false, this.id, true, true);
            if (!!item[BENTO_TREE_ITEM_OPTION].parent) {
                this.updateParentCheckState(item[BENTO_TREE_ITEM_OPTION].parent);
            }
        }
    }
    animateSelectionFeedback(el) {
        const ctaEl = el.parentElement;
        this.r.addClass(ctaEl, 'in');
        setTimeout(() => {
            this.r.removeClass(ctaEl, 'in');
        }, 34);
    }
    /**
     * Update already selected item(s) based on configuration with currently selected Item
     */
    updateSelections(selectedItem) {
        if (this.multiSelect) {
            this.selectedItems.push(selectedItem);
        }
        else {
            const oldSelections = this.selectedItems;
            this.selectedItems = [selectedItem];
            for (const item of oldSelections) {
                if (item !== selectedItem) {
                    item[BENTO_TREE_ITEM_OPTION].setSelected(false, this.id);
                }
            }
        }
    }
    /**
     * Unsubscribe all options from items
     */
    unsubscribeAllItems() {
        while (this.itemSubscriptions.length) {
            // unsubscribe all option changes
            this.itemSubscriptions.pop().unsubscribe();
        }
    }
}
BentoTreeViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeViewComponent, deps: [{ token: WindowRef }, { token: i0.ElementRef }, { token: BentoNotification }, { token: i2.Directionality }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoTreeViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoTreeViewComponent, selector: "bento-tree-view", inputs: { items: "items", collapseItemsOnAdd: "collapseItemsOnAdd", id: "id", multiSelect: "multiSelect", itemIconProp: "itemIconProp", itemChildrenProp: "itemChildrenProp", itemLabelProp: "itemLabelProp", itemExpandOnly: "itemExpandOnly", selectAsCheck: "selectAsCheck", showCheckboxes: "showCheckboxes", disableSelection: "disableSelection", showExpandCollapseAllButtons: "showExpandCollapseAllButtons", itemLabelTemplate: "itemLabelTemplate", independentCheckbox: "independentCheckbox", disableFocusOnLeaves: "disableFocusOnLeaves" }, outputs: { itemCheck: "itemCheck", itemExpandCollapse: "itemExpandCollapse", itemSelect: "itemSelect" }, host: { listeners: { "keydown": "onTreeKeydown($event,$event.keyCode)" } }, viewQueries: [{ propertyName: "cdkViewport", first: true, predicate: ["viewport"], descendants: true, static: true }], ngImport: i0, template: "<bento-expand-collapse-button-group\n  *ngIf=\"showExpandCollapseAllButtons\"\n  [expandAllTitle]=\"'BENTO_UI_TREE_VIEW_EXPAND_ALL' | bentoTranslate\"\n  [collapseAllTitle]=\"'BENTO_UI_TREE_VIEW_COLLAPSE_ALL' | bentoTranslate\"\n  (expand)=\"expandAllGroups()\"\n  (collapse)=\"collapseAllGroups()\"\n></bento-expand-collapse-button-group>\n<cdk-virtual-scroll-viewport\n  #viewport\n  [minBufferPx]=\"100\"\n  [maxBufferPx]=\"rowHeight * 10\"\n  (focus)=\"_onCDKViewportFocus()\"\n  class=\"bui-tree-view-viewport\"\n  [itemSize]=\"rowHeight\"\n  role=\"tree\"\n  tabindex=\"0\"\n>\n  <ng-container *cdkVirtualFor=\"let item of _itemsFlatData; let i = index; trackBy: _itemOrderTrackBy\">\n    <ng-container\n      *ngTemplateOutlet=\"row; context: {item: item, options: item.$bentoTreeItemOption, index: i, rowID: uid + '-' + i}\"\n    ></ng-container>\n  </ng-container>\n</cdk-virtual-scroll-viewport>\n\n<ng-template #row let-item=\"item\" let-options=\"options\" let-rowID=\"rowID\">\n  <div\n    class=\"bui-tree-item\"\n    [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n    [ngClass]=\"options.getSelected(id) ? 'selected' : ''\"\n    [style.paddingLeft.px]=\"!isRTL ? options.level * _paddingLeft : 0\"\n    [style.paddingRight.px]=\"isRTL ? options.level * _paddingLeft : 0\"\n    [attr.id]=\"rowID\"\n    [attr.aria-checked]=\"showCheckboxes ? options.getChecked(id) : null\"\n    [attr.aria-selected]=\"options.getSelected(id) ? options.getSelected(id) : null\"\n    [attr.aria-expanded]=\"item[itemChildrenProp] ? !options.getCollapsed(id) : null\"\n    [attr.aria-level]=\"options.level\"\n    role=\"treeitem\"\n    [attr.aria-posinset]=\"options.index\"\n    [attr.aria-setsize]=\"options.siblingSize\"\n  >\n    <button\n      type=\"button\"\n      tabindex=\"-1\"\n      class=\"bui-tree-view-expand-collapse-btn\"\n      *ngIf=\"item[itemChildrenProp]\"\n      (click)=\"_onExpandCollapseClick(item)\"\n      [disabled]=\"options.disabled\"\n      [attr.aria-label]=\"\n        options.getCollapsed(id)\n          ? ('BENTO_UI_TREE_VIEW_EXPAND' | bentoTranslate)\n          : ('BENTO_UI_TREE_VIEW_COLLAPSE' | bentoTranslate)\n      \"\n      [attr.aria-describedby]=\"'label-' + rowID\"\n      [ngbTooltip]=\"\n        options.getCollapsed(id)\n          ? ('BENTO_UI_TREE_VIEW_EXPAND' | bentoTranslate)\n          : ('BENTO_UI_TREE_VIEW_COLLAPSE' | bentoTranslate)\n      \"\n      container=\"body\"\n    >\n      <i\n        aria-hidden=\"true\"\n        [ngClass]=\"options.getCollapsed(id) ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"\n      ></i>\n    </button>\n\n    <label class=\"sr-only\" [attr.id]=\"'label-' + rowID\" [attr.for]=\"'checkbox-' + rowID\">\n      {{ item[itemLabelProp] }}\n    </label>\n    <bento-checkbox\n      class=\"bui-tree-item-checkbox\"\n      [ngModel]=\"options.getChecked(id)\"\n      (ngModelChange)=\"_onCheckChanged($event, item)\"\n      [indeterminate]=\"options.getIndeterminate(id)\"\n      [attr.id]=\"'checkbox-' + rowID\"\n      [disabled]=\"options.disabled\"\n      tabindex=\"-1\"\n      *ngIf=\"showCheckboxes && !options.hideCheckbox\"\n    ></bento-checkbox>\n    <div\n      class=\"bui-tree-item-cta col\"\n      [attr.id]=\"'cta-' + rowID\"\n      (click)=\"_onItemCTAClick($event.target, item)\"\n      [attr.tabindex]=\"disableFocusOnLeaves && !item[itemChildrenProp] ? null : '-1'\"\n    >\n      <i [ngClass]=\"['bui-tree-item-cta-icon', item[itemIconProp]]\" *ngIf=\"item[itemIconProp]\" aria-hidden=\"true\"></i>\n      <div *ngIf=\"itemLabelTemplate; else ctaDefaultTemplate\" class=\"bui-tree-item-custom-template\">\n        <ng-container\n          *ngTemplateOutlet=\"itemLabelTemplate; context: {item: item, options: options, rowID: rowID}\"\n        ></ng-container>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #ctaDefaultTemplate>\n    <div class=\"bui-underline-on-hover-focus bui-tree-item-cta-default-label\">\n      {{ item[itemLabelProp] }}\n    </div>\n  </ng-template>\n</ng-template>\n", styles: [".ng-bento bento-tree-view{display:flex;position:relative;flex-direction:column;height:400px}.ng-bento bento-tree-view bento-expand-collapse-button-group{flex:auto;flex-grow:0;margin-bottom:-1px}.ng-bento .bui-tree-view-viewport{flex-basis:0;flex-grow:1;max-height:100%}.ng-bento .bui-tree-item{position:relative;display:flex;height:30px}.ng-bento .bui-tree-item bento-checkbox{z-index:2}.ng-bento .bui-tree-item.selected .bui-tree-item-cta:after{content:\"\";position:absolute;left:0;width:4px;top:1px;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento .bui-tree-item.selected .bui-tree-item-cta:after{border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}.ng-bento .bui-tree-item:last-of-type .bui-tree-item-cta:before{bottom:0}.ng-bento .bui-tree-item-cta:before{border-color:transparent;border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.ng-bento .bui-tree-view-expand-collapse-btn{align-items:center;background:none;border:none;cursor:default;display:flex;height:30px;justify-content:center;margin-left:-25px;opacity:.8;padding:0;position:relative;width:25px;z-index:1}[dir=rtl] .ng-bento .bui-tree-view-expand-collapse-btn{margin-left:0;margin-right:-20px}.ng-bento .bui-tree-view-expand-collapse-btn:focus,.ng-bento .bui-tree-view-expand-collapse-btn:hover{outline:none}.ng-bento .bui-tree-view-expand-collapse-btn .bento-tree-icon{font-size:1em}.ng-bento .bui-tree-view-expand-collapse-btn:hover{opacity:1}.ng-bento .bui-tree-view-expand-collapse-btn~.bui-tree-item-cta,.ng-bento .bui-tree-view-expand-collapse-btn~.bui-tree-item-cta .bento-tree-item-label{font-weight:700}.ng-bento .bui-tree-item-checkbox{margin-top:8px}.ng-bento .bui-tree-item-cta-icon{margin-right:5px;margin-left:auto}[dir=rtl] .ng-bento .bui-tree-item-cta-icon{margin-right:auto;margin-left:5px}.ng-bento .bui-tree-item-cta{display:inline-flex;line-height:14px;font-size:12px;cursor:default;background-color:transparent;position:static}.ng-bento .bui-tree-item-cta.col{padding:0}.ng-bento .bui-tree-item-cta>div{padding:8px 0;width:100%;position:relative;display:flex;align-items:flex-start;z-index:1}.ng-bento .bui-tree-item-cta:focus,.ng-bento .bui-tree-item-cta:hover{outline:none}.ng-bento .bui-tree-item-cta:focus .bui-underline-on-hover-focus,.ng-bento .bui-tree-item-cta:hover .bui-underline-on-hover-focus{text-decoration:underline;vertical-align:baseline}.ng-bento .bui-tree-item-cta [class*=bento-icon]{font-size:1.2em}.ng-bento .bui-tree-item-cta .btn.btn-link{height:auto;font-size:12px;line-height:1.25em;padding:0;letter-spacing:0;justify-content:flex-start}.ng-bento .bui-tree-item-cta:before{content:\" \";display:block;color:gray;position:absolute;left:0;width:100%;top:0;bottom:-1px;z-index:0}[dir=rtl] .ng-bento .bui-tree-item-cta:before{left:auto;right:0}.ng-bento .bui-tree-item-cta-default-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ng-bento .bui-tree-item-custom-template{display:flex;flex-wrap:wrap}.ng-bento .bui-tree-item-custom-template .col:not(button),.ng-bento .bui-tree-item-custom-template .col-auto:not(button){padding:0}\n"], components: [{ type: BentoExpandCollapseButtonGroupComponent, selector: "bento-expand-collapse-button-group", inputs: ["expandAllTitle", "collapseAllTitle"], outputs: ["expand", "collapse"] }, { type: i5.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { type: BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { type: i5.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "bentoTranslate": BentoTranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-tree-view', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<bento-expand-collapse-button-group\n  *ngIf=\"showExpandCollapseAllButtons\"\n  [expandAllTitle]=\"'BENTO_UI_TREE_VIEW_EXPAND_ALL' | bentoTranslate\"\n  [collapseAllTitle]=\"'BENTO_UI_TREE_VIEW_COLLAPSE_ALL' | bentoTranslate\"\n  (expand)=\"expandAllGroups()\"\n  (collapse)=\"collapseAllGroups()\"\n></bento-expand-collapse-button-group>\n<cdk-virtual-scroll-viewport\n  #viewport\n  [minBufferPx]=\"100\"\n  [maxBufferPx]=\"rowHeight * 10\"\n  (focus)=\"_onCDKViewportFocus()\"\n  class=\"bui-tree-view-viewport\"\n  [itemSize]=\"rowHeight\"\n  role=\"tree\"\n  tabindex=\"0\"\n>\n  <ng-container *cdkVirtualFor=\"let item of _itemsFlatData; let i = index; trackBy: _itemOrderTrackBy\">\n    <ng-container\n      *ngTemplateOutlet=\"row; context: {item: item, options: item.$bentoTreeItemOption, index: i, rowID: uid + '-' + i}\"\n    ></ng-container>\n  </ng-container>\n</cdk-virtual-scroll-viewport>\n\n<ng-template #row let-item=\"item\" let-options=\"options\" let-rowID=\"rowID\">\n  <div\n    class=\"bui-tree-item\"\n    [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n    [ngClass]=\"options.getSelected(id) ? 'selected' : ''\"\n    [style.paddingLeft.px]=\"!isRTL ? options.level * _paddingLeft : 0\"\n    [style.paddingRight.px]=\"isRTL ? options.level * _paddingLeft : 0\"\n    [attr.id]=\"rowID\"\n    [attr.aria-checked]=\"showCheckboxes ? options.getChecked(id) : null\"\n    [attr.aria-selected]=\"options.getSelected(id) ? options.getSelected(id) : null\"\n    [attr.aria-expanded]=\"item[itemChildrenProp] ? !options.getCollapsed(id) : null\"\n    [attr.aria-level]=\"options.level\"\n    role=\"treeitem\"\n    [attr.aria-posinset]=\"options.index\"\n    [attr.aria-setsize]=\"options.siblingSize\"\n  >\n    <button\n      type=\"button\"\n      tabindex=\"-1\"\n      class=\"bui-tree-view-expand-collapse-btn\"\n      *ngIf=\"item[itemChildrenProp]\"\n      (click)=\"_onExpandCollapseClick(item)\"\n      [disabled]=\"options.disabled\"\n      [attr.aria-label]=\"\n        options.getCollapsed(id)\n          ? ('BENTO_UI_TREE_VIEW_EXPAND' | bentoTranslate)\n          : ('BENTO_UI_TREE_VIEW_COLLAPSE' | bentoTranslate)\n      \"\n      [attr.aria-describedby]=\"'label-' + rowID\"\n      [ngbTooltip]=\"\n        options.getCollapsed(id)\n          ? ('BENTO_UI_TREE_VIEW_EXPAND' | bentoTranslate)\n          : ('BENTO_UI_TREE_VIEW_COLLAPSE' | bentoTranslate)\n      \"\n      container=\"body\"\n    >\n      <i\n        aria-hidden=\"true\"\n        [ngClass]=\"options.getCollapsed(id) ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"\n      ></i>\n    </button>\n\n    <label class=\"sr-only\" [attr.id]=\"'label-' + rowID\" [attr.for]=\"'checkbox-' + rowID\">\n      {{ item[itemLabelProp] }}\n    </label>\n    <bento-checkbox\n      class=\"bui-tree-item-checkbox\"\n      [ngModel]=\"options.getChecked(id)\"\n      (ngModelChange)=\"_onCheckChanged($event, item)\"\n      [indeterminate]=\"options.getIndeterminate(id)\"\n      [attr.id]=\"'checkbox-' + rowID\"\n      [disabled]=\"options.disabled\"\n      tabindex=\"-1\"\n      *ngIf=\"showCheckboxes && !options.hideCheckbox\"\n    ></bento-checkbox>\n    <div\n      class=\"bui-tree-item-cta col\"\n      [attr.id]=\"'cta-' + rowID\"\n      (click)=\"_onItemCTAClick($event.target, item)\"\n      [attr.tabindex]=\"disableFocusOnLeaves && !item[itemChildrenProp] ? null : '-1'\"\n    >\n      <i [ngClass]=\"['bui-tree-item-cta-icon', item[itemIconProp]]\" *ngIf=\"item[itemIconProp]\" aria-hidden=\"true\"></i>\n      <div *ngIf=\"itemLabelTemplate; else ctaDefaultTemplate\" class=\"bui-tree-item-custom-template\">\n        <ng-container\n          *ngTemplateOutlet=\"itemLabelTemplate; context: {item: item, options: options, rowID: rowID}\"\n        ></ng-container>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #ctaDefaultTemplate>\n    <div class=\"bui-underline-on-hover-focus bui-tree-item-cta-default-label\">\n      {{ item[itemLabelProp] }}\n    </div>\n  </ng-template>\n</ng-template>\n", styles: [".ng-bento bento-tree-view{display:flex;position:relative;flex-direction:column;height:400px}.ng-bento bento-tree-view bento-expand-collapse-button-group{flex:auto;flex-grow:0;margin-bottom:-1px}.ng-bento .bui-tree-view-viewport{flex-basis:0;flex-grow:1;max-height:100%}.ng-bento .bui-tree-item{position:relative;display:flex;height:30px}.ng-bento .bui-tree-item bento-checkbox{z-index:2}.ng-bento .bui-tree-item.selected .bui-tree-item-cta:after{content:\"\";position:absolute;left:0;width:4px;top:1px;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento .bui-tree-item.selected .bui-tree-item-cta:after{border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}.ng-bento .bui-tree-item:last-of-type .bui-tree-item-cta:before{bottom:0}.ng-bento .bui-tree-item-cta:before{border-color:transparent;border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.ng-bento .bui-tree-view-expand-collapse-btn{align-items:center;background:none;border:none;cursor:default;display:flex;height:30px;justify-content:center;margin-left:-25px;opacity:.8;padding:0;position:relative;width:25px;z-index:1}[dir=rtl] .ng-bento .bui-tree-view-expand-collapse-btn{margin-left:0;margin-right:-20px}.ng-bento .bui-tree-view-expand-collapse-btn:focus,.ng-bento .bui-tree-view-expand-collapse-btn:hover{outline:none}.ng-bento .bui-tree-view-expand-collapse-btn .bento-tree-icon{font-size:1em}.ng-bento .bui-tree-view-expand-collapse-btn:hover{opacity:1}.ng-bento .bui-tree-view-expand-collapse-btn~.bui-tree-item-cta,.ng-bento .bui-tree-view-expand-collapse-btn~.bui-tree-item-cta .bento-tree-item-label{font-weight:700}.ng-bento .bui-tree-item-checkbox{margin-top:8px}.ng-bento .bui-tree-item-cta-icon{margin-right:5px;margin-left:auto}[dir=rtl] .ng-bento .bui-tree-item-cta-icon{margin-right:auto;margin-left:5px}.ng-bento .bui-tree-item-cta{display:inline-flex;line-height:14px;font-size:12px;cursor:default;background-color:transparent;position:static}.ng-bento .bui-tree-item-cta.col{padding:0}.ng-bento .bui-tree-item-cta>div{padding:8px 0;width:100%;position:relative;display:flex;align-items:flex-start;z-index:1}.ng-bento .bui-tree-item-cta:focus,.ng-bento .bui-tree-item-cta:hover{outline:none}.ng-bento .bui-tree-item-cta:focus .bui-underline-on-hover-focus,.ng-bento .bui-tree-item-cta:hover .bui-underline-on-hover-focus{text-decoration:underline;vertical-align:baseline}.ng-bento .bui-tree-item-cta [class*=bento-icon]{font-size:1.2em}.ng-bento .bui-tree-item-cta .btn.btn-link{height:auto;font-size:12px;line-height:1.25em;padding:0;letter-spacing:0;justify-content:flex-start}.ng-bento .bui-tree-item-cta:before{content:\" \";display:block;color:gray;position:absolute;left:0;width:100%;top:0;bottom:-1px;z-index:0}[dir=rtl] .ng-bento .bui-tree-item-cta:before{left:auto;right:0}.ng-bento .bui-tree-item-cta-default-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ng-bento .bui-tree-item-custom-template{display:flex;flex-wrap:wrap}.ng-bento .bui-tree-item-custom-template .col:not(button),.ng-bento .bui-tree-item-custom-template .col-auto:not(button){padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: WindowRef }, { type: i0.ElementRef }, { type: BentoNotification }, { type: i2.Directionality }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { items: [{
                type: Input
            }], collapseItemsOnAdd: [{
                type: Input
            }], id: [{
                type: Input
            }], multiSelect: [{
                type: Input
            }], itemIconProp: [{
                type: Input
            }], itemChildrenProp: [{
                type: Input
            }], itemLabelProp: [{
                type: Input
            }], itemExpandOnly: [{
                type: Input
            }], selectAsCheck: [{
                type: Input
            }], showCheckboxes: [{
                type: Input
            }], disableSelection: [{
                type: Input
            }], showExpandCollapseAllButtons: [{
                type: Input
            }], itemLabelTemplate: [{
                type: Input
            }], independentCheckbox: [{
                type: Input
            }], disableFocusOnLeaves: [{
                type: Input
            }], itemCheck: [{
                type: Output
            }], itemExpandCollapse: [{
                type: Output
            }], itemSelect: [{
                type: Output
            }], cdkViewport: [{
                type: ViewChild,
                args: ['viewport', { static: true }]
            }], onTreeKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event', '$event.keyCode']]
            }] } });

class BentoTreeModule extends ConsumerDataValidator {
}
BentoTreeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoTreeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeModule, declarations: [BentoTreeComponent, BentoTreeItemComponent, BentoTreeViewComponent], imports: [CommonModule,
        BentoCheckboxModule,
        FormsModule,
        BentoTranslateModule,
        BentoExpandCollapseButtonGroupModule,
        BentoUtilsModule,
        ScrollingModule,
        // ExperimentalScrollingModule
        NgbTooltipModule,
        BentoNgbTooltipSupportModule], exports: [BentoTreeComponent, BentoTreeViewComponent] });
BentoTreeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeModule, imports: [[
            CommonModule,
            BentoCheckboxModule,
            FormsModule,
            BentoTranslateModule,
            BentoExpandCollapseButtonGroupModule,
            BentoUtilsModule,
            ScrollingModule,
            // ExperimentalScrollingModule
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoCheckboxModule,
                        FormsModule,
                        BentoTranslateModule,
                        BentoExpandCollapseButtonGroupModule,
                        BentoUtilsModule,
                        ScrollingModule,
                        // ExperimentalScrollingModule
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule
                    ],
                    declarations: [BentoTreeComponent, BentoTreeItemComponent, BentoTreeViewComponent],
                    exports: [BentoTreeComponent, BentoTreeViewComponent]
                }]
        }] });

class BentoUniverseFilterDropdownEllipsisDirective {
    constructor(elRef, sanitizer) {
        this.sanitizer = sanitizer;
        this._nativeElement = elRef.nativeElement;
    }
    set bentoEllipsisText(text) {
        this._eText = text;
        this.checkEllipsis();
    }
    checkEllipsis() {
        const txtElem = this._nativeElement;
        txtElem.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this._eText);
        txtElem.style.pointerEvents = '';
        if (txtElem.offsetWidth > txtElem.scrollWidth) {
            // disable tooltip if full display of label
            txtElem.style.pointerEvents = 'none';
        }
    }
}
BentoUniverseFilterDropdownEllipsisDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownEllipsisDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive });
BentoUniverseFilterDropdownEllipsisDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseFilterDropdownEllipsisDirective, selector: "[bentoUniverseFilterDropdownEllipsis]", inputs: { bentoEllipsisText: "bentoEllipsisText" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownEllipsisDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoUniverseFilterDropdownEllipsis]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$2.DomSanitizer }]; }, propDecorators: { bentoEllipsisText: [{
                type: Input
            }] } });

class BentoUniverseFilterDropdownMenuComponent {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    constructor(_vr, bentoNotification) {
        this._vr = _vr;
        this.onClose = new EventEmitter();
        this.onSelect = new EventEmitter();
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this._onResize());
    }
    ngOnDestroy() {
        this._resizeSubscription.unsubscribe();
    }
    ngOnInit() {
        const template = this.item.modalTemplateUrl || this.item.templateUrl || this.defaultTemplate;
        const context = {
            ctrl: this,
            close: () => {
                this.onClose.emit(this.menuindex);
            },
            filterItem: this.item,
            selectItem: selectedItem => {
                this.onSelect.emit({
                    index: this.menuindex,
                    selectedItem
                });
            }
        };
        this._vr.createEmbeddedView(template, context);
    }
    _onResize() { }
}
BentoUniverseFilterDropdownMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownMenuComponent, deps: [{ token: i0.ViewContainerRef }, { token: BentoNotification }], target: i0.ɵɵFactoryTarget.Component });
BentoUniverseFilterDropdownMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseFilterDropdownMenuComponent, selector: "bento-universe-filter-dropdown-menu", inputs: { item: "item", menuindex: "menuindex", defaultTemplate: "defaultTemplate" }, outputs: { onClose: "onClose", onSelect: "onSelect" }, providers: [BentoNotification], ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bento-universe-filter-dropdown-menu',
                    template: ``,
                    providers: [BentoNotification]
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: BentoNotification }]; }, propDecorators: { item: [{
                type: Input
            }], menuindex: [{
                type: Input
            }], defaultTemplate: [{
                type: Input
            }], onClose: [{
                type: Output
            }], onSelect: [{
                type: Output
            }] } });

class BentoUniverseDropdownPositionDirective {
    constructor(dropdown, elementRef, windowRef, logService) {
        this.dropdown = dropdown;
        this.elementRef = elementRef;
        this.logService = logService;
        /**
         * Input to get the reference of the container that this element is appended to
         */
        this.bentoUniverseFilterDropdownPosition = false;
        this.window = windowRef.nativeWindow;
        this.document = windowRef.nativeDocument;
        this.onChangeSubscription = this.dropdown.openChange.subscribe((open) => {
            if (!open) {
                setTimeout(() => {
                    this.removeMenuFromBody();
                }, 0);
            }
            else {
                this.menuWrapper.appendChild(this.menuRef.nativeElement);
                if (!this.isInBody()) {
                    this.appendMenuToBody();
                }
            }
        });
    }
    ngAfterContentInit() {
        this.oldParent = this.menuRef.nativeElement.parentElement;
        this.findAppendToEl();
        this.createWrapper();
        // override dropdown private method for positioning dropdown menu
        const dropdown = this.dropdown;
        dropdown._positionMenu = () => {
            this.positionDropdown();
        };
    }
    positionDropdown() {
        const triggerEl = this.elementRef.nativeElement;
        // get rect of button
        const triggerRect = triggerEl.getBoundingClientRect();
        // get rect of filter
        const elementRect = this._appendToEl.getBoundingClientRect();
        // get rect of dropdown
        const menuRect = this.menuRef.nativeElement.getBoundingClientRect();
        this.menuRef.nativeElement.style.position = 'absolute';
        this.menuRef.nativeElement.style.minWidth = Math.ceil(triggerRect.width) + 'px';
        this.menuRef.nativeElement.style.left = 'auto';
        this.menuRef.nativeElement.style.right = 'auto';
        if (menuRect.width + triggerRect.left - (elementRect.width + elementRect.left) >= 0) {
            this.menuRef.nativeElement.style.right = '0';
        }
        else {
            this.menuRef.nativeElement.style.left = Math.ceil(triggerRect.left - elementRect.left) - 1 + 'px';
        }
    }
    ngOnDestroy() {
        this.removeMenuFromBody();
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
    }
    findAppendToEl() {
        if (this._appendToEl) {
            // append to Parent is initiated already
            return;
        }
        // Assign `_appendToEl` reference for appending
        if (!this.bentoUniverseFilterDropdownPosition || this.bentoUniverseFilterDropdownPosition === '') {
            this._appendToEl = this.document.body;
        }
        else if (typeof this.bentoUniverseFilterDropdownPosition === 'string') {
            this._appendToEl = this.document.querySelector(this.bentoUniverseFilterDropdownPosition);
            if (!this._appendToEl) {
                this.logService.error('[bentoDropdownPosition]: Selector', this.bentoUniverseFilterDropdownPosition, 'does not exit in the DOM structure.');
                return;
            }
        }
        else if (this.isHTMLElement(this.bentoUniverseFilterDropdownPosition)) {
            this._appendToEl = this.bentoUniverseFilterDropdownPosition;
        }
        else {
            this._appendToEl = this.bentoUniverseFilterDropdownPosition.nativeElement;
        }
    }
    isInBody() {
        return this.menuWrapper.parentNode === this._appendToEl;
    }
    removeMenuFromBody() {
        // this.menuRef.nativeElement.style.display = 'none';
        if (this.isInBody()) {
            if (this.oldParent) {
                this.oldParent.appendChild(this.menuWrapper);
            }
        }
    }
    appendMenuToBody() {
        this.findAppendToEl();
        this._appendToEl.appendChild(this.menuWrapper);
    }
    createWrapper() {
        this.menuWrapper = this.document.createElement('div');
        this.menuWrapper.style.zIndex = '1000';
        this.menuWrapper.style.display = 'block';
        this.menuWrapper.className += 'dropdown-menu-wrapper';
        this.menuWrapper.addEventListener('keyup', (event) => {
            if (event.keyCode === 27) {
                this.dropdown.close();
            }
        });
        this.menuWrapper.appendChild(this.menuRef.nativeElement);
    }
    isHTMLElement(obj) {
        try {
            return obj instanceof HTMLElement;
        }
        catch (e) {
            // Browsers not supporting W3 DOM2.
            return (typeof obj === 'object' &&
                obj.nodeType === 1 &&
                typeof obj.style === 'object' &&
                typeof obj.ownerDocument === 'object');
        }
    }
}
BentoUniverseDropdownPositionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseDropdownPositionDirective, deps: [{ token: forwardRef(() => NgbDropdown) }, { token: i0.ElementRef }, { token: WindowRef }, { token: BentoLogService }], target: i0.ɵɵFactoryTarget.Directive });
BentoUniverseDropdownPositionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseDropdownPositionDirective, selector: "[bentoUniverseFilterDropdownPosition]", inputs: { bentoUniverseFilterDropdownPosition: "bentoUniverseFilterDropdownPosition" }, queries: [{ propertyName: "menuRef", first: true, predicate: ["dropdownMenu"], descendants: true, read: ElementRef }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseDropdownPositionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoUniverseFilterDropdownPosition]'
                }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }, { type: i0.ElementRef }, { type: WindowRef }, { type: BentoLogService }];
    }, propDecorators: { bentoUniverseFilterDropdownPosition: [{
                type: Input
            }], menuRef: [{
                type: ContentChild,
                args: ['dropdownMenu', { read: ElementRef }]
            }] } });

/**
 * Make NgbDropdown to support keyboard navigations
 */
class BentoUniverseFilterKeyboardSupportDirective {
    constructor(elementRef, windowRef, r, dropdown) {
        this.r = r;
        this.dropdown = dropdown;
        this.el = elementRef.nativeElement;
        this.onToggleKeydown = this.onToggleKeydown.bind(this);
        this.onMenuKeydown = this.onMenuKeydown.bind(this);
        // Add a unique class called (b)ento (ui) (d)rop(d)own (k)eyboard (support)
        this.r.addClass(this.el, BentoUniverseFilterKeyboardSupportDirective.CSS_CLASS_NAME);
    }
    ngAfterViewInit() {
        this.dropdownMenuEl = this.dropdownMenu.nativeElement;
        // this.dropdownMenuEl = this.el.querySelector('.dropdown-menu');
        this.dropdownButtonEl = this.el.querySelector('.bento-uni-filter_item-text');
        this.toggleEl = this.el.querySelector('.dropdown-toggle');
        this.r.listen(this.toggleEl, 'keydown', this.onToggleKeydown);
        this.r.listen(this.dropdownMenuEl, 'keydown', this.onMenuKeydown);
        this.onChangeSubscription = this.dropdown.openChange.subscribe((open) => {
            this.isOpen = open;
            if (open) {
                setTimeout(() => {
                    this.dropdownSelectionIndex = 0;
                    // this.dropdownMenuEl.classList.add('show');
                    this.menuItems = Array.from(this.dropdownMenuEl.querySelectorAll('[role="menuitem"]'));
                    this.menuItems[0].focus();
                    const action = this.getAction(this.menuItems[0].tagName);
                    this.menuItems[0][action]();
                }, 0);
            }
            else {
                // this.dropdownMenuEl.classList.remove('show');
            }
        });
    }
    ngOnDestroy() {
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
    }
    getAction(tagName) {
        let action;
        switch (tagName) {
            case 'INPUT':
                action = 'click';
                break;
            default:
                action = 'focus';
                break;
        }
        return action;
    }
    incrementDropdownSelectionIndex() {
        if (this.dropdownSelectionIndex < this.menuItems.length - 1) {
            this.dropdownSelectionIndex++;
        }
        return this.dropdownSelectionIndex;
    }
    decrementDropdownSelectionIndex() {
        if (this.dropdownSelectionIndex > 0) {
            this.dropdownSelectionIndex--;
        }
        return this.dropdownSelectionIndex;
    }
    onMenuKeydown(e) {
        // let currentFocusedIndex = this.menuItems.indexOf(this.document.activeElement as HTMLElement);
        // const menuItemSize = this.menuItems.length;
        // currentFocusedIndex = currentFocusedIndex < 0 ? 0 : currentFocusedIndex;
        switch (e.keyCode) {
            case Keyboard.ENTER:
                setTimeout(() => this.dropdownButtonEl.focus());
                break;
            case Keyboard.UP:
                {
                    this.decrementDropdownSelectionIndex();
                    const action = this.getAction(this.menuItems[this.dropdownSelectionIndex].tagName);
                    this.menuItems[this.dropdownSelectionIndex][action]();
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.DOWN:
                {
                    this.incrementDropdownSelectionIndex();
                    const action = this.getAction(this.menuItems[this.dropdownSelectionIndex].tagName);
                    this.menuItems[this.dropdownSelectionIndex][action]();
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.ESC:
                setTimeout(() => this.dropdownButtonEl.focus());
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout(() => {
                    this.dropdown.close();
                    this.dropdownButtonEl.focus();
                });
                break;
        }
    }
    onToggleKeydown(e) {
        switch (e.keyCode) {
            case Keyboard.ENTER:
                if (this.isOpen) {
                    setTimeout(() => this.dropdown.close());
                }
                else {
                    this.showDropdown();
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.UP:
            case Keyboard.DOWN:
                this.showDropdown();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout(() => this.dropdown.close());
                break;
        }
    }
    showDropdown() {
        if (!this.isOpen) {
            this.dropdown.open();
        }
    }
}
// Class name used to determine if the HTMLElement is initialized already or not
// (B)ento (T)ool(B)ar (K)eyboard (Support)
BentoUniverseFilterKeyboardSupportDirective.CSS_CLASS_NAME = 'bui-tb-k-support';
BentoUniverseFilterKeyboardSupportDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterKeyboardSupportDirective, deps: [{ token: i0.ElementRef }, { token: WindowRef }, { token: i0.Renderer2 }, { token: forwardRef(() => NgbDropdown) }], target: i0.ɵɵFactoryTarget.Directive });
BentoUniverseFilterKeyboardSupportDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseFilterKeyboardSupportDirective, selector: "[bentoUniverseFilterKeyboardSupport]", queries: [{ propertyName: "dropdownMenu", first: true, predicate: ["dropdownMenu"], descendants: true, static: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterKeyboardSupportDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoUniverseFilterKeyboardSupport]'
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: WindowRef }, { type: i0.Renderer2 }, { type: i1$1.NgbDropdown, decorators: [{
                        type: Inject,
                        args: [forwardRef(() => NgbDropdown)]
                    }] }];
    }, propDecorators: { dropdownMenu: [{
                type: ContentChild,
                args: ['dropdownMenu', { static: true }]
            }] } });

/**
 * The universe filter bar is usually positioned under the global header navbar
 * and contains the most widely used filter sets. When an item is clicked, a
 * dropdowm menu opens whereupon a filter selection is made. The dropdown menu
 * can be customized with a template. The universe filter bar is currently
 * limited to four items.
 *
 */
class BentoUniverseFilterDropdownComponent {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    constructor(bentoNotification, dir) {
        this.dir = dir;
        /**
         * Event handler for back button click. Omit this attribute to hide the back button.
         */
        this.onBackButtonClick = new EventEmitter();
        /**
         * Event handler when a filter item is selected. Returns the selected item object (please see
         * BentoUniverseFilterDropdownItemOptions).
         */
        this.onFilterItemChanged = new EventEmitter();
        /**
         * Event handler when the filter is open or closed
         */
        this.openChange = new EventEmitter();
        this.hasBackBtn = false;
        this.isOpen = false;
        this.isOpenArr = [];
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this._onResize());
        this.isRtl = this.dir.value === 'rtl';
        dir.change.subscribe(() => {
            this.isRtl = this.dir.value === 'rtl';
        });
    }
    close() {
        this._dropdownComponents.forEach(dropdown => {
            dropdown.close();
        });
    }
    onSelect($event) {
        this.items[$event.index].selectedName = $event.selectedItem.title;
        this.onFilterItemChanged.emit(this.items[$event.index]);
        this.close();
    }
    onOpenChange(open, i) {
        this.isOpenArr[i] = open;
        this.isOpen = false;
        this.isOpenArr.forEach(item => {
            if (item) {
                this.isOpen = true;
            }
        });
        this.openChange.emit(this.isOpen);
    }
    ngOnDestroy() {
        this._resizeSubscription.unsubscribe();
    }
    ngOnInit() {
        this.hasBackBtn = this.onBackButtonClick.observers.length > 0;
    }
    _onResize() {
        // update ellipsis tooltip trigger
        this._ellipsisText.forEach(item => {
            item.checkEllipsis();
        });
    }
    _onBackButtonClick($event) {
        this.onBackButtonClick.emit($event);
    }
}
BentoUniverseFilterDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownComponent, deps: [{ token: BentoNotification }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Component });
BentoUniverseFilterDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseFilterDropdownComponent, selector: "bento-universe-filter-dropdown", inputs: { items: "items", selectText: "selectText", backBtnDisabled: "backBtnDisabled" }, outputs: { onBackButtonClick: "onBackButtonClick", onFilterItemChanged: "onFilterItemChanged", openChange: "openChange" }, providers: [BentoNotification], viewQueries: [{ propertyName: "_dropdownComponents", predicate: NgbDropdown, descendants: true }, { propertyName: "_ellipsisText", predicate: BentoUniverseFilterDropdownEllipsisDirective, descendants: true }, { propertyName: "menuItems", predicate: NgbDropdownItem, descendants: true }], ngImport: i0, template: "<div\n  #filterElRef\n  class=\"bento-uni-filter row\"\n  [ngClass]=\"(hasBackBtn ? 'has-back-btn ' : '') + (isOpen ? 'open ' : '')\"\n>\n  <button\n    type=\"button\"\n    class=\"bento-uni-filter_back-btn\"\n    *ngIf=\"hasBackBtn\"\n    [disabled]=\"backBtnDisabled\"\n    (click)=\"_onBackButtonClick($event)\"\n    (keypress)=\"$event.which === 13 ? _onBackButtonClick($event) : 0\"\n    tabindex=\"0\"\n    attr.aria-label=\"{{ 'BENTO_UI_UNIVERSAL_FILTER_BACK' | bentoTranslate }}\"\n  >\n    <i class=\"bento-icon-arrow-left\" *ngIf=\"!isRtl\" aria-hidden=\"true\"></i>\n    <i class=\"bento-icon-arrow-right\" *ngIf=\"isRtl\" aria-hidden=\"true\"></i>\n  </button>\n  <div\n    class=\"bento-uni-filter_item dropdown\"\n    *ngFor=\"let i = index; let item; of: items | slice: 0:4\"\n    [ngClass]=\"\n      (selectedName === item.title ? 'selected ' : '') +\n      (items.length >= 4 ? 'col-3' : items.length === 3 ? 'col-4' : items.length === 2 ? 'col-6' : 'col-12')\n    \"\n    (openChange)=\"onOpenChange($event, i)\"\n    [autoClose]=\"'outside'\"\n    ngbDropdown\n    [bentoUniverseFilterDropdownPosition]=\"filterElRef\"\n    bentoUniverseFilterKeyboardSupport\n  >\n    <div class=\"bento-uni-filter_dropdown-toggle\" ngbDropdownToggle role=\"menuitem\">\n      <div class=\"bento-uni-filter_item-header\">{{ item.title }}</div>\n      <button\n        class=\"bento-uni-filter_item-text\"\n        ngbTooltip=\"{{ item.selectedName || selectText || 'Select' }}\"\n        bentoUniverseFilterDropdownEllipsis\n        bentoEllipsisText=\"{{ item.selectedName || item.selectText || selectText || 'Select' }}\"\n        placement=\"bottom\"\n      ></button>\n      <i\n        attr.aria-label=\"{{\n          isOpenArr[i]\n            ? ('BENTO_UI_UNIVERSAL_FILTER_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_UNIVERSAL_FILTER_EXPAND' | bentoTranslate)\n        }} {{ item.title }}\"\n        class=\"bento-uni-filter_carat bento-icon-caret-down-filled\"\n      ></i>\n    </div>\n    <div class=\"bento-uni-filter_dropdown-menu dropdown-menu\" #dropdownMenu ngbDropdownMenu>\n      <bento-universe-filter-dropdown-menu\n        [item]=\"item\"\n        [menuindex]=\"i\"\n        (onClose)=\"close()\"\n        (onSelect)=\"onSelect($event)\"\n        [defaultTemplate]=\"bentoUniFilterTemplate\"\n      ></bento-universe-filter-dropdown-menu>\n    </div>\n  </div>\n</div>\n<div class=\"bento-uni-filter_back-drop\"></div>\n<ng-template #bentoUniFilterTemplate let-c=\"close\" let-s=\"selectItem\" let-i=\"filterItem\">\n  <ul class=\"bento-uni-filter_dropdown-list\">\n    <li\n      *ngFor=\"let item of i.items\"\n      (click)=\"s(item)\"\n      (keydown)=\"$event.which === 13 ? s(item) : 0\"\n      [ngClass]=\"item.title === i.selectedName ? 'selected' : ''\"\n      tabindex=\"-1\"\n      role=\"menuitem\"\n    >\n      {{ item.title }}\n    </li>\n  </ul>\n</ng-template>\n", styles: [".ng-bento bento-universe-filter-dropdown .bento-uni-filter,.ng-bento bento-universe-filter .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,.ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,.ng-bento bento-universe-filter .bento-uni-filter_back-btn{border:none;cursor:pointer;float:left;font-size:20px;margin:0 0 0 -52px;min-height:52px;padding:0;position:relative;text-align:center;transition:background-color .2s;width:52px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_back-btn{margin:0 -52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-],.ng-bento bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled],.ng-bento bento-universe-filter .bento-uni-filter_back-btn[disabled]{opacity:.2;pointer-events:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translate(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px #0000004d}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:before{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:after{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-right .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-left .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item,.ng-bento bento-universe-filter .bento-uni-filter_item{cursor:pointer;min-height:82px;transition:background-color .2s}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show,.ng-bento bento-universe-filter .bento-uni-filter_item:hover,.ng-bento bento-universe-filter .bento-uni-filter_item:focus,.ng-bento bento-universe-filter .bento-uni-filter_item.selected,.ng-bento bento-universe-filter .bento-uni-filter_item.open,.ng-bento bento-universe-filter .bento-uni-filter_item.show{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.show:before{left:0;right:-1px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:last-child:before{border-right:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:after,.ng-bento bento-universe-filter .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-header,.ng-bento bento-universe-filter .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;width:100%;letter-spacing:.1em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,.ng-bento bento-universe-filter .bento-uni-filter_item-text{line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;padding:8px 20px 8px 10px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,.ng-bento bento-universe-filter .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:14px;line-height:20px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_carat{right:auto;left:20px;text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal{display:flex!important;padding:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog{width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:13px;width:100%;letter-spacing:.15em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list,.ng-bento bento-universe-filter .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li.selected{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner,.ng-bento bento-universe-filter .bento-uni-filter .tooltip-inner{text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper,.ng-bento bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content .ng-bento bento-universe-filter-dropdown .bento-uni-filter,.bento-off-canvas-menu-content .ng-bento bento-universe-filter .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}\n"], components: [{ type: BentoUniverseFilterDropdownMenuComponent, selector: "bento-universe-filter-dropdown-menu", inputs: ["item", "menuindex", "defaultTemplate"], outputs: ["onClose", "onSelect"] }], directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: BentoUniverseFilterKeyboardSupportDirective, selector: "[bentoUniverseFilterKeyboardSupport]" }, { type: BentoUniverseDropdownPositionDirective, selector: "[bentoUniverseFilterDropdownPosition]", inputs: ["bentoUniverseFilterDropdownPosition"] }, { type: i1$1.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: BentoUniverseFilterDropdownEllipsisDirective, selector: "[bentoUniverseFilterDropdownEllipsis]", inputs: ["bentoEllipsisText"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i1$1.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }], pipes: { "bentoTranslate": BentoTranslatePipe, "slice": i3$2.SlicePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-universe-filter-dropdown', encapsulation: ViewEncapsulation.None, providers: [BentoNotification], template: "<div\n  #filterElRef\n  class=\"bento-uni-filter row\"\n  [ngClass]=\"(hasBackBtn ? 'has-back-btn ' : '') + (isOpen ? 'open ' : '')\"\n>\n  <button\n    type=\"button\"\n    class=\"bento-uni-filter_back-btn\"\n    *ngIf=\"hasBackBtn\"\n    [disabled]=\"backBtnDisabled\"\n    (click)=\"_onBackButtonClick($event)\"\n    (keypress)=\"$event.which === 13 ? _onBackButtonClick($event) : 0\"\n    tabindex=\"0\"\n    attr.aria-label=\"{{ 'BENTO_UI_UNIVERSAL_FILTER_BACK' | bentoTranslate }}\"\n  >\n    <i class=\"bento-icon-arrow-left\" *ngIf=\"!isRtl\" aria-hidden=\"true\"></i>\n    <i class=\"bento-icon-arrow-right\" *ngIf=\"isRtl\" aria-hidden=\"true\"></i>\n  </button>\n  <div\n    class=\"bento-uni-filter_item dropdown\"\n    *ngFor=\"let i = index; let item; of: items | slice: 0:4\"\n    [ngClass]=\"\n      (selectedName === item.title ? 'selected ' : '') +\n      (items.length >= 4 ? 'col-3' : items.length === 3 ? 'col-4' : items.length === 2 ? 'col-6' : 'col-12')\n    \"\n    (openChange)=\"onOpenChange($event, i)\"\n    [autoClose]=\"'outside'\"\n    ngbDropdown\n    [bentoUniverseFilterDropdownPosition]=\"filterElRef\"\n    bentoUniverseFilterKeyboardSupport\n  >\n    <div class=\"bento-uni-filter_dropdown-toggle\" ngbDropdownToggle role=\"menuitem\">\n      <div class=\"bento-uni-filter_item-header\">{{ item.title }}</div>\n      <button\n        class=\"bento-uni-filter_item-text\"\n        ngbTooltip=\"{{ item.selectedName || selectText || 'Select' }}\"\n        bentoUniverseFilterDropdownEllipsis\n        bentoEllipsisText=\"{{ item.selectedName || item.selectText || selectText || 'Select' }}\"\n        placement=\"bottom\"\n      ></button>\n      <i\n        attr.aria-label=\"{{\n          isOpenArr[i]\n            ? ('BENTO_UI_UNIVERSAL_FILTER_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_UNIVERSAL_FILTER_EXPAND' | bentoTranslate)\n        }} {{ item.title }}\"\n        class=\"bento-uni-filter_carat bento-icon-caret-down-filled\"\n      ></i>\n    </div>\n    <div class=\"bento-uni-filter_dropdown-menu dropdown-menu\" #dropdownMenu ngbDropdownMenu>\n      <bento-universe-filter-dropdown-menu\n        [item]=\"item\"\n        [menuindex]=\"i\"\n        (onClose)=\"close()\"\n        (onSelect)=\"onSelect($event)\"\n        [defaultTemplate]=\"bentoUniFilterTemplate\"\n      ></bento-universe-filter-dropdown-menu>\n    </div>\n  </div>\n</div>\n<div class=\"bento-uni-filter_back-drop\"></div>\n<ng-template #bentoUniFilterTemplate let-c=\"close\" let-s=\"selectItem\" let-i=\"filterItem\">\n  <ul class=\"bento-uni-filter_dropdown-list\">\n    <li\n      *ngFor=\"let item of i.items\"\n      (click)=\"s(item)\"\n      (keydown)=\"$event.which === 13 ? s(item) : 0\"\n      [ngClass]=\"item.title === i.selectedName ? 'selected' : ''\"\n      tabindex=\"-1\"\n      role=\"menuitem\"\n    >\n      {{ item.title }}\n    </li>\n  </ul>\n</ng-template>\n", styles: [".ng-bento bento-universe-filter-dropdown .bento-uni-filter,.ng-bento bento-universe-filter .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,.ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,.ng-bento bento-universe-filter .bento-uni-filter_back-btn{border:none;cursor:pointer;float:left;font-size:20px;margin:0 0 0 -52px;min-height:52px;padding:0;position:relative;text-align:center;transition:background-color .2s;width:52px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_back-btn{margin:0 -52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-],.ng-bento bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled],.ng-bento bento-universe-filter .bento-uni-filter_back-btn[disabled]{opacity:.2;pointer-events:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translate(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px #0000004d}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:before{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:after{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-right .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-left .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item,.ng-bento bento-universe-filter .bento-uni-filter_item{cursor:pointer;min-height:82px;transition:background-color .2s}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show,.ng-bento bento-universe-filter .bento-uni-filter_item:hover,.ng-bento bento-universe-filter .bento-uni-filter_item:focus,.ng-bento bento-universe-filter .bento-uni-filter_item.selected,.ng-bento bento-universe-filter .bento-uni-filter_item.open,.ng-bento bento-universe-filter .bento-uni-filter_item.show{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.show:before{left:0;right:-1px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:last-child:before{border-right:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:after,.ng-bento bento-universe-filter .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-header,.ng-bento bento-universe-filter .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;width:100%;letter-spacing:.1em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,.ng-bento bento-universe-filter .bento-uni-filter_item-text{line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;padding:8px 20px 8px 10px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,.ng-bento bento-universe-filter .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:14px;line-height:20px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_carat{right:auto;left:20px;text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal{display:flex!important;padding:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog{width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:13px;width:100%;letter-spacing:.15em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list,.ng-bento bento-universe-filter .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li.selected{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner,.ng-bento bento-universe-filter .bento-uni-filter .tooltip-inner{text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper,.ng-bento bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content .ng-bento bento-universe-filter-dropdown .bento-uni-filter,.bento-off-canvas-menu-content .ng-bento bento-universe-filter .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}\n"] }]
        }], ctorParameters: function () { return [{ type: BentoNotification }, { type: i2.Directionality }]; }, propDecorators: { items: [{
                type: Input
            }], selectText: [{
                type: Input
            }], backBtnDisabled: [{
                type: Input
            }], onBackButtonClick: [{
                type: Output
            }], onFilterItemChanged: [{
                type: Output
            }], openChange: [{
                type: Output
            }], _dropdownComponents: [{
                type: ViewChildren,
                args: [NgbDropdown]
            }], _ellipsisText: [{
                type: ViewChildren,
                args: [BentoUniverseFilterDropdownEllipsisDirective]
            }], menuItems: [{
                type: ViewChildren,
                args: [NgbDropdownItem]
            }] } });

class BentoUniverseFilterDropdownModule extends ConsumerDataValidator {
}
BentoUniverseFilterDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoUniverseFilterDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownModule, declarations: [BentoUniverseFilterDropdownMenuComponent,
        BentoUniverseFilterDropdownComponent,
        BentoUniverseDropdownPositionDirective,
        BentoUniverseFilterDropdownEllipsisDirective,
        BentoUniverseFilterKeyboardSupportDirective], imports: [CommonModule,
        NgbDropdownModule,
        NgbTooltipModule,
        BentoAppendToModule,
        BentoTranslateModule,
        BentoNgbDropdownAnimationModule], exports: [BentoUniverseFilterDropdownComponent] });
BentoUniverseFilterDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownModule, imports: [[
            CommonModule,
            NgbDropdownModule,
            NgbTooltipModule,
            BentoAppendToModule,
            BentoTranslateModule,
            BentoNgbDropdownAnimationModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NgbDropdownModule,
                        NgbTooltipModule,
                        BentoAppendToModule,
                        BentoTranslateModule,
                        BentoNgbDropdownAnimationModule
                    ],
                    declarations: [
                        BentoUniverseFilterDropdownMenuComponent,
                        BentoUniverseFilterDropdownComponent,
                        BentoUniverseDropdownPositionDirective,
                        BentoUniverseFilterDropdownEllipsisDirective,
                        BentoUniverseFilterKeyboardSupportDirective
                    ],
                    exports: [BentoUniverseFilterDropdownComponent]
                }]
        }] });

class BentoUniverseFilterEllipsisDirective {
    constructor(elRef, sanitizer) {
        this.sanitizer = sanitizer;
        this._nativeElement = elRef.nativeElement;
    }
    set bentoEllipsisText(text) {
        this._eText = text;
        this.checkEllipsis();
    }
    checkEllipsis() {
        const txtElem = this._nativeElement;
        let str = this.sanitizer.sanitize(SecurityContext.HTML, this._eText);
        txtElem.innerHTML = str;
        txtElem.style.pointerEvents = '';
        if (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
            while (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
                const lastIndex = str.lastIndexOf(' ');
                str = str.substring(0, lastIndex);
                txtElem.innerHTML = str + '&hellip;';
                if (lastIndex <= 1) {
                    break;
                }
            }
        }
        else {
            // disable tooltip if full display of label
            txtElem.style.pointerEvents = 'none';
        }
    }
}
BentoUniverseFilterEllipsisDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterEllipsisDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive });
BentoUniverseFilterEllipsisDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseFilterEllipsisDirective, selector: "[bentoUniverseFilterEllipsis]", inputs: { bentoEllipsisText: "bentoEllipsisText" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterEllipsisDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoUniverseFilterEllipsis]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$2.DomSanitizer }]; }, propDecorators: { bentoEllipsisText: [{
                type: Input
            }] } });

/**
 * The universe filter bar is usually positioned under the global header navbar
 * and contains the most widely used filter sets. When an item is clicked, a
 * modal window opens whereupon a filter selection is made. The modal window
 * can be customized with a template. The universe filter bar is currently
 * limited to four items.
 *
 */
class BentoUniverseFilterComponent {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    constructor(modalService, bentoNotification) {
        this.modalService = modalService;
        /**
         * Event handler for back button click. Omit this attribute to hide the back button.
         */
        this.onBackButtonClick = new EventEmitter();
        /**
         * Event handler when a filter item is selected. Returns the selected item object (please see
         * BentoUniverseFilterItemChangedEvent).
         */
        this.onFilterItemChanged = new EventEmitter();
        this.hasBackBtn = false;
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this._onResize());
    }
    ngOnDestroy() {
        this._resizeSubscription.unsubscribe();
    }
    ngOnInit() {
        this.hasBackBtn = this.onBackButtonClick.observers.length > 0;
    }
    _openModal(content, filterItem, filterItems) {
        // populate template with content
        this.modalFilterItem = filterItem;
        // grab NgbModalRef
        const modalTemplateRef = filterItem.modalTemplateUrl || content;
        const modalContent = filterItem.modalComponent || modalTemplateRef;
        const modalOptions = { windowClass: 'bento-uni-filter_modal' };
        this._modalRef = this.modalService.open(modalContent, modalOptions);
        if (this._modalRef.componentInstance) {
            this._modalRef.componentInstance.filterItem = filterItem;
            this._modalRef.componentInstance.filterItems = filterItems;
        }
        // add Result actions
        this._modalRef.result.then(result => {
            this.onFilterItemChanged.emit({ selectedItem: filterItem });
        });
    }
    _modalSelectItem(item, modalFilterItem) {
        // select item and close modal
        modalFilterItem.selectedName = item.title;
        this._modalRef.close();
    }
    _onResize() {
        // iterate through ellipsis items and update text
        this._ellipsisComponents.forEach(item => item.checkEllipsis());
    }
    _onBackButtonClick($event) {
        this.onBackButtonClick.emit($event);
    }
}
BentoUniverseFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterComponent, deps: [{ token: i1$1.NgbModal }, { token: BentoNotification }], target: i0.ɵɵFactoryTarget.Component });
BentoUniverseFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniverseFilterComponent, selector: "bento-universe-filter", inputs: { items: "items", selectText: "selectText", backBtnDisabled: "backBtnDisabled" }, outputs: { onBackButtonClick: "onBackButtonClick", onFilterItemChanged: "onFilterItemChanged" }, providers: [BentoNotification], viewQueries: [{ propertyName: "_ellipsisComponents", predicate: BentoUniverseFilterEllipsisDirective, descendants: true }], ngImport: i0, template: "<div class=\"bento-uni-filter row\" [ngClass]=\"hasBackBtn ? 'has-back-btn' : ''\">\n  <button\n    type=\"button\"\n    class=\"bento-uni-filter_back-btn\"\n    *ngIf=\"hasBackBtn\"\n    [disabled]=\"backBtnDisabled\"\n    (click)=\"_onBackButtonClick($event)\"\n    (keypress)=\"$event.which === 13 ? _onBackButtonClick($event) : 0\"\n    tabindex=\"0\"\n  >\n    <i class=\"bento-icon-arrow-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div\n    class=\"bento-uni-filter_item\"\n    *ngFor=\"let item of items | slice: 0:4\"\n    [ngClass]=\"\n      (selectedName === item.title ? 'selected ' : '') +\n      (items.length >= 4 ? 'col-3' : items.length === 3 ? 'col-4' : items.length === 2 ? 'col-6' : 'col-12')\n    \"\n    (click)=\"_openModal(bentoUniFilterModal, item, items)\"\n    (keypress)=\"$event.which === 13 ? _openModal(bentoUniFilterModal, item, items) : 0\"\n    tabindex=\"0\"\n  >\n    <div class=\"bento-uni-filter_item-header\">{{ item.title }}</div>\n    <div\n      class=\"bento-uni-filter_item-text\"\n      bentoUniverseFilterEllipsis\n      bentoEllipsisText=\"{{ item.selectedName || item.selectText || selectText || 'Select' }}\"\n      ngbTooltip=\"{{ item.selectedName || selectText || 'Select' }}\"\n      placement=\"bottom\"\n    ></div>\n    <i class=\"bento-uni-filter_carat bento-icon-caret-down\" aria-hidden=\"true\"></i>\n  </div>\n</div>\n<ng-template #bentoUniFilterModal let-c=\"close\" let-d=\"dismiss\">\n  <button\n    type=\"button\"\n    class=\"close\"\n    aria-hidden=\"true\"\n    (click)=\"d()\"\n    (keypress)=\"$event.which === 13 ? d() : 0\"\n    tabindex=\"0\"\n  >\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modal-header\">Select {{ modalFilterItem.title }}</div>\n  <div class=\"modal-body\">\n    <ul class=\"bento-uni-filter_modal-list\">\n      <li\n        *ngFor=\"let item of modalFilterItem.items\"\n        (click)=\"_modalSelectItem(item, modalFilterItem)\"\n        (keypress)=\"$event.which === 13 ? _modalSelectItem(item, modalFilterItem) : 0\"\n        tabindex=\"0\"\n      >\n        {{ item.title }}\n      </li>\n    </ul>\n  </div>\n</ng-template>\n", styles: [".ng-bento bento-universe-filter-dropdown .bento-uni-filter,.ng-bento bento-universe-filter .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,.ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,.ng-bento bento-universe-filter .bento-uni-filter_back-btn{border:none;cursor:pointer;float:left;font-size:20px;margin:0 0 0 -52px;min-height:52px;padding:0;position:relative;text-align:center;transition:background-color .2s;width:52px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_back-btn{margin:0 -52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-],.ng-bento bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled],.ng-bento bento-universe-filter .bento-uni-filter_back-btn[disabled]{opacity:.2;pointer-events:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translate(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px #0000004d}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:before{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:after{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-right .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-left .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item,.ng-bento bento-universe-filter .bento-uni-filter_item{cursor:pointer;min-height:82px;transition:background-color .2s}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show,.ng-bento bento-universe-filter .bento-uni-filter_item:hover,.ng-bento bento-universe-filter .bento-uni-filter_item:focus,.ng-bento bento-universe-filter .bento-uni-filter_item.selected,.ng-bento bento-universe-filter .bento-uni-filter_item.open,.ng-bento bento-universe-filter .bento-uni-filter_item.show{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.show:before{left:0;right:-1px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:last-child:before{border-right:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:after,.ng-bento bento-universe-filter .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-header,.ng-bento bento-universe-filter .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;width:100%;letter-spacing:.1em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,.ng-bento bento-universe-filter .bento-uni-filter_item-text{line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;padding:8px 20px 8px 10px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,.ng-bento bento-universe-filter .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:14px;line-height:20px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_carat{right:auto;left:20px;text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal{display:flex!important;padding:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog{width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:13px;width:100%;letter-spacing:.15em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list,.ng-bento bento-universe-filter .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li.selected{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner,.ng-bento bento-universe-filter .bento-uni-filter .tooltip-inner{text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper,.ng-bento bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content .ng-bento bento-universe-filter-dropdown .bento-uni-filter,.bento-off-canvas-menu-content .ng-bento bento-universe-filter .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}\n"], directives: [{ type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: BentoUniverseFilterEllipsisDirective, selector: "[bentoUniverseFilterEllipsis]", inputs: ["bentoEllipsisText"] }, { type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "slice": i3$2.SlicePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-universe-filter', providers: [BentoNotification], encapsulation: ViewEncapsulation.None, template: "<div class=\"bento-uni-filter row\" [ngClass]=\"hasBackBtn ? 'has-back-btn' : ''\">\n  <button\n    type=\"button\"\n    class=\"bento-uni-filter_back-btn\"\n    *ngIf=\"hasBackBtn\"\n    [disabled]=\"backBtnDisabled\"\n    (click)=\"_onBackButtonClick($event)\"\n    (keypress)=\"$event.which === 13 ? _onBackButtonClick($event) : 0\"\n    tabindex=\"0\"\n  >\n    <i class=\"bento-icon-arrow-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div\n    class=\"bento-uni-filter_item\"\n    *ngFor=\"let item of items | slice: 0:4\"\n    [ngClass]=\"\n      (selectedName === item.title ? 'selected ' : '') +\n      (items.length >= 4 ? 'col-3' : items.length === 3 ? 'col-4' : items.length === 2 ? 'col-6' : 'col-12')\n    \"\n    (click)=\"_openModal(bentoUniFilterModal, item, items)\"\n    (keypress)=\"$event.which === 13 ? _openModal(bentoUniFilterModal, item, items) : 0\"\n    tabindex=\"0\"\n  >\n    <div class=\"bento-uni-filter_item-header\">{{ item.title }}</div>\n    <div\n      class=\"bento-uni-filter_item-text\"\n      bentoUniverseFilterEllipsis\n      bentoEllipsisText=\"{{ item.selectedName || item.selectText || selectText || 'Select' }}\"\n      ngbTooltip=\"{{ item.selectedName || selectText || 'Select' }}\"\n      placement=\"bottom\"\n    ></div>\n    <i class=\"bento-uni-filter_carat bento-icon-caret-down\" aria-hidden=\"true\"></i>\n  </div>\n</div>\n<ng-template #bentoUniFilterModal let-c=\"close\" let-d=\"dismiss\">\n  <button\n    type=\"button\"\n    class=\"close\"\n    aria-hidden=\"true\"\n    (click)=\"d()\"\n    (keypress)=\"$event.which === 13 ? d() : 0\"\n    tabindex=\"0\"\n  >\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modal-header\">Select {{ modalFilterItem.title }}</div>\n  <div class=\"modal-body\">\n    <ul class=\"bento-uni-filter_modal-list\">\n      <li\n        *ngFor=\"let item of modalFilterItem.items\"\n        (click)=\"_modalSelectItem(item, modalFilterItem)\"\n        (keypress)=\"$event.which === 13 ? _modalSelectItem(item, modalFilterItem) : 0\"\n        tabindex=\"0\"\n      >\n        {{ item.title }}\n      </li>\n    </ul>\n  </div>\n</ng-template>\n", styles: [".ng-bento bento-universe-filter-dropdown .bento-uni-filter,.ng-bento bento-universe-filter .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,.ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter.has-back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter.has-back-btn{padding:0 52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,.ng-bento bento-universe-filter .bento-uni-filter_back-btn{border:none;cursor:pointer;float:left;font-size:20px;margin:0 0 0 -52px;min-height:52px;padding:0;position:relative;text-align:center;transition:background-color .2s;width:52px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_back-btn{margin:0 -52px 0 0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-],.ng-bento bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:hover:after,.ng-bento bento-universe-filter .bento-uni-filter_back-btn:focus:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled],.ng-bento bento-universe-filter .bento-uni-filter_back-btn[disabled]{opacity:.2;pointer-events:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translate(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px #0000004d}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:before{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu:after{content:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-right .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.align-left .dropdown-menu{transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu,.ng-bento bento-universe-filter .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item,.ng-bento bento-universe-filter .bento-uni-filter_item{cursor:pointer;min-height:82px;transition:background-color .2s}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show,.ng-bento bento-universe-filter .bento-uni-filter_item:hover,.ng-bento bento-universe-filter .bento-uni-filter_item:focus,.ng-bento bento-universe-filter .bento-uni-filter_item.selected,.ng-bento bento-universe-filter .bento-uni-filter_item.open,.ng-bento bento-universe-filter .bento-uni-filter_item.show{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item.show:before{left:0;right:-1px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:hover:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item:focus:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.selected:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.open:last-child:before,.ng-bento bento-universe-filter .bento-uni-filter_item.show:last-child:before{border-right:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item.show:after,.ng-bento bento-universe-filter .bento-uni-filter_item.open:after,.ng-bento bento-universe-filter .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-header,.ng-bento bento-universe-filter .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;width:100%;letter-spacing:.1em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,.ng-bento bento-universe-filter .bento-uni-filter_item-text{line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;padding:8px 20px 8px 10px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_item-text,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,.ng-bento bento-universe-filter .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:14px;line-height:20px}[dir=rtl] .ng-bento bento-universe-filter-dropdown .bento-uni-filter_carat,[dir=rtl] .ng-bento bento-universe-filter .bento-uni-filter_carat{right:auto;left:20px;text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal{display:flex!important;padding:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog{width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:13px;width:100%;letter-spacing:.15em}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i,.ng-bento bento-universe-filter .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list,.ng-bento bento-universe-filter .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:hover,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li:focus,.ng-bento bento-universe-filter .bento-uni-filter_modal-list>li.selected{outline:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}.ng-bento bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li,.ng-bento bento-universe-filter .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner,.ng-bento bento-universe-filter .bento-uni-filter .tooltip-inner{text-align:left}.ng-bento bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper,.ng-bento bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}.ng-bento bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop,.ng-bento bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content .ng-bento bento-universe-filter-dropdown .bento-uni-filter,.bento-off-canvas-menu-content .ng-bento bento-universe-filter .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.NgbModal }, { type: BentoNotification }]; }, propDecorators: { items: [{
                type: Input
            }], selectText: [{
                type: Input
            }], backBtnDisabled: [{
                type: Input
            }], onBackButtonClick: [{
                type: Output
            }], onFilterItemChanged: [{
                type: Output
            }], _ellipsisComponents: [{
                type: ViewChildren,
                args: [BentoUniverseFilterEllipsisDirective]
            }] } });

class BentoUniverseFilterModule extends ConsumerDataValidator {
}
BentoUniverseFilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoUniverseFilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterModule, declarations: [BentoUniverseFilterComponent, BentoUniverseFilterEllipsisDirective], imports: [CommonModule, NgbModalModule, NgbTooltipModule, BentoTranslateModule], exports: [BentoUniverseFilterComponent] });
BentoUniverseFilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterModule, imports: [[CommonModule, NgbModalModule, NgbTooltipModule, BentoTranslateModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniverseFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgbModalModule, NgbTooltipModule, BentoTranslateModule],
                    declarations: [BentoUniverseFilterComponent, BentoUniverseFilterEllipsisDirective],
                    exports: [BentoUniverseFilterComponent]
                }]
        }] });

/**
 * An event class to handle Bento Wizard Component events
 */
class BentoWizardComponentEvent {
    /**
     * Constructor
     */
    constructor(step, oldStep, stopPropagation) {
        this.step = step;
        this.oldStep = oldStep;
        this.stopPropagation = stopPropagation;
    }
}

/**
 * Bento Wizard Nav Step Component
 */
class BentoWizardStepComponent {
    constructor(elRef) {
        /**
         * Title of the current Step component in Bento Wizard nav element
         */
        this.title = '';
        /**
         * Description of the current Step component in Bento Wizard nav element
         */
        this.description = '';
        /**
         * Flag to set the current Step component as disabled
         */
        this.disabled = false;
        /**
         * Flag to show and hide the completed indicator for this step
         */
        this.completed = false;
        this.el = elRef.nativeElement;
    }
    /**
     * Hide current step (only applies to rendering)
     */
    hide() {
        this.el.style.display = 'none';
    }
    /**
     * Show current step (only applies to rendering)
     */
    show() {
        this.el.style.display = 'block';
    }
}
BentoWizardStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardStepComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BentoWizardStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoWizardStepComponent, selector: "bento-wizard-step", inputs: { title: "title", description: "description", disabled: "disabled", completed: "completed" }, ngImport: i0, template: `
    <div class="wizard-step-content">
      <ng-content></ng-content>
    </div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardStepComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bento-wizard-step',
                    template: `
    <div class="wizard-step-content">
      <ng-content></ng-content>
    </div>
  `
                    // changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { title: [{
                type: Input
            }], description: [{
                type: Input
            }], disabled: [{
                type: Input
            }], completed: [{
                type: Input
            }] } });

class BentoWizardComponentEllipsisDirective {
    constructor(elRef, sanitizer) {
        this.sanitizer = sanitizer;
        this._nativeElement = elRef.nativeElement;
    }
    set bentoEllipsisText(text) {
        this._eText = text;
        this.checkEllipsis();
    }
    /**
     * Implements OnInit
     */
    ngOnInit() {
        this.subscription = this.bentoWizardComponentEllipsis.subscribe(() => {
            this.checkEllipsis();
        });
    }
    /**
     * Implements OnDestroy
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    checkEllipsis() {
        const txtElem = this._nativeElement;
        let str = this.sanitizer.sanitize(SecurityContext.HTML, this._eText);
        txtElem.innerHTML = str;
        txtElem.style.pointerEvents = '';
        if (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
            while (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
                const lastIndex = str.lastIndexOf(' ');
                str = str.substring(0, lastIndex);
                txtElem.innerHTML = str + '&hellip;';
                if (lastIndex <= 1) {
                    break;
                }
            }
        }
    }
}
BentoWizardComponentEllipsisDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentEllipsisDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Directive });
BentoWizardComponentEllipsisDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoWizardComponentEllipsisDirective, selector: "[bentoWizardComponentEllipsis]", inputs: { bentoEllipsisText: "bentoEllipsisText", bentoWizardComponentEllipsis: "bentoWizardComponentEllipsis" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentEllipsisDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoWizardComponentEllipsis]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$2.DomSanitizer }]; }, propDecorators: { bentoEllipsisText: [{
                type: Input
            }], bentoWizardComponentEllipsis: [{
                type: Input
            }] } });

class BentoWizardComponentStripComponent {
    constructor(elRef, r, bentoNotification, logService, dir, uidGen, changeDetector) {
        this.r = r;
        this.logService = logService;
        this.uidGen = uidGen;
        this.changeDetector = changeDetector;
        /**
         * Callback when the current step is changing
         * ~@private
         */
        this.currentStepChanging = new EventEmitter();
        /**
         * Callback when the current step is changed
         * ~@private
         */
        this.currentStepChange = new EventEmitter();
        this.stepUIDsChange = new EventEmitter();
        /**
         * Flag to determine if the side arrows should be rendered
         */
        this._useSideArrows = true;
        /**
         * Emit when ellipsis needs to be checked
         */
        this.checkEllipsis = new EventEmitter(true);
        this.isLeftArrowDisabled = false;
        this.isRightArrowDisabled = false;
        this.numSteps = 0;
        this.displayCount = 0;
        this.leftIndex = 0;
        this.resizeSubscription = Subscription.EMPTY;
        this.stepsSubscription = Subscription.EMPTY;
        this.bidiSubscription = Subscription.EMPTY;
        this.el = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe(() => this._onResize());
        this.isRTL = dir.value === 'rtl';
        this.bidiSubscription = dir.change.subscribe(() => {
            this.isRTL = dir.value === 'rtl';
        });
    }
    /**
     * Used to update the first set of steps
     */
    set _steps(s) {
        this.steps = s;
        this.stepsArray = s.toArray();
        this.stepUIDs = [];
        if (s) {
            for (let i = 0; i < s.length; i++) {
                this.stepUIDs[i] = this.uidGen.generate();
            }
        }
        this.stepUIDsChange.emit(this.stepUIDs.slice());
    }
    /**
     * Current step setter
     */
    set currentStep(step) {
        // Bypass if the value is out of boundary or the steps aren't even ready to render
        if (!this.steps || (step && step >= this.steps.length) || step < 0) {
            this.logService.warn('Bento Wizard: ' +
                'Trying to assign `currentStep` but contents and steps are not ready. ' +
                ' Try to assign during `ngAfterViewInit` or similar life hooks.');
            return;
        }
        // if(step === 0 && this.isRTL) {
        //   // for RTL reset the currentStep to the last step
        //   this._currentStep = this.steps.length - 1;
        // } else {
        //   this._currentStep = step;
        // }
        this._currentStep = step;
        this.showStep(step);
    }
    set useSideArrows(bool) {
        this._useSideArrows = bool;
        this.render();
    }
    /**
     * Callback for any resize events for re-rendering
     */
    _onResize() {
        this.render();
    }
    /**
     * Need to handle memory cleanup
     */
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
        this.stepsSubscription.unsubscribe();
        this.bidiSubscription.unsubscribe();
    }
    ngOnInit() {
        if (!this.stepsObservable) {
            this.logService.error('Bento Wizard: [stepsObsersable] is missing');
        }
        else {
            // Subscribe to steps data change
            this.stepsSubscription = this.stepsObservable.subscribe(steps => {
                this.steps = steps;
                this.stepsArray = steps.toArray();
                this.render();
                // Default to the first step
                if (typeof this._currentStep === 'undefined') {
                    this._onStepClick(0, false, true);
                }
            });
        }
    }
    /**
     * Fire first render when the view is ready
     */
    ngAfterViewInit() {
        setTimeout(() => {
            this.marginSide = this.isRTL ? 'marginRight' : 'marginLeft';
            this.render();
        });
    }
    /**
     * render this strip
     */
    render(updateArrows = true) {
        if (!this.container) {
            this.container = this.el.querySelector('.bento-wizard-steps');
            this.ol = this.container.querySelector('.steps');
        }
        this.numSteps = this.steps.length;
        if (this.numSteps === 0) {
            // There is no step to render
            return;
        }
        let width = this.el.offsetWidth;
        // Set the total step object to be displayed
        // in wizard viewport based on its width
        this.displayCount = this.numSteps > 4 ? 4 : this.numSteps; // Default step count
        // Refine displayCount based on the width and numSteps
        if (width < 360 && this.displayCount > 1) {
            this.displayCount = 1;
        }
        else if (width < 720 && this.displayCount > 2) {
            this.displayCount = 2;
        }
        else if (width < 960 && this.displayCount > 3) {
            this.displayCount = 3;
        }
        else if (BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH * this.displayCount +
            (this.displayCount - 1) * BentoWizardComponentStripComponent.STEP_PADDING <
            width &&
            this.numSteps > this.displayCount) {
            this.displayCount = Math.ceil(width / BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH);
        }
        if (this._useSideArrows) {
            if (this.displayCount < this.numSteps) {
                this.r.addClass(this.el, 'side-arrows');
                width -= BentoWizardComponentStripComponent.GAP * 2;
            }
            else {
                this.r.removeClass(this.el, 'side-arrows');
            }
        }
        else {
            this.r.removeClass(this.el, 'side-arrows');
        }
        // Set list container width based on the total step count
        // and their widths
        this._boxWidth =
            (width - (this.displayCount - 1) * BentoWizardComponentStripComponent.STEP_PADDING) / this.displayCount;
        // Cap the step box width
        this._boxWidth =
            this._boxWidth > BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH
                ? BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH
                : this._boxWidth;
        this.r.setStyle(this.ol, 'width', this.numSteps * (this._boxWidth + BentoWizardComponentStripComponent.STEP_PADDING) + 'px');
        if (this._currentStep >= this.numSteps) {
            this._currentStep = this.numSteps - 1;
        }
        this._updateStepContainerOffset(updateArrows);
        setTimeout(() => this.checkEllipsis.emit());
        this.changeDetector.markForCheck();
    }
    // Update step location
    _updateStepContainerOffset(updateArrows = true) {
        // Variables to be used for calculation
        const stepArray = this.ol.children;
        // find the left index
        this.leftIndex = 0;
        if (this.displayCount < this.numSteps) {
            for (let i = 0; i < stepArray.length; i++) {
                const step = stepArray[i];
                if (step.offsetLeft <= 0 && step.offsetLeft + step.offsetWidth > 0) {
                    this.leftIndex = i;
                    break;
                }
            }
            if (this._currentStep < this.leftIndex) {
                this.leftIndex = this._currentStep;
            }
            else if (this._currentStep > this.leftIndex + this.displayCount) {
                this.leftIndex = this._currentStep - this.displayCount + 1;
            }
            else if (this.leftIndex + this.displayCount > this.numSteps - 1) {
                this.leftIndex = this.numSteps - this.displayCount;
            }
            if (updateArrows) {
                this._updateLeftRightArrows();
            }
        }
        this.r.setStyle(this.ol, this.marginSide, -(this._boxWidth * this.leftIndex) + 'px');
    }
    /**
     * Handle
     */
    _onStepClick(step, disabled = false, skipChangingCallback = false) {
        // For browsers still capture clicks
        if (disabled || this._currentStep === step) {
            return;
        }
        let hasCancellable = false;
        if (!skipChangingCallback) {
            this.currentStepChanging.emit(new BentoWizardComponentEvent(step, this._currentStep, (cancellable) => {
                hasCancellable = true;
                if (!!cancellable && cancellable.subscribe) {
                    cancellable.subscribe(response => {
                        if (response) {
                            this._currentStep = step;
                            this.currentStepChange.emit(step);
                        }
                    });
                }
            }));
        }
        if (!hasCancellable) {
            this._currentStep = step;
            this.currentStepChange.emit(step);
        }
    }
    /**
     * Callback when a step has a keydown
     */
    _onKeydown(event, step) {
        const el = event.currentTarget;
        switch (event.keyCode) {
            case Keyboard.LEFT:
                if (this.isRTL) {
                    this.focusNextSibling(el, step);
                }
                else {
                    this.focusPreviousSibling(el, step);
                }
                event.stopPropagation();
                event.preventDefault();
                break;
            case Keyboard.RIGHT:
                if (this.isRTL) {
                    this.focusPreviousSibling(el, step);
                }
                else {
                    this.focusNextSibling(el, step);
                }
                event.stopPropagation();
                event.preventDefault();
                break;
            case Keyboard.HOME:
                this.focusToStepEl(el.parentElement.firstElementChild, 0);
                event.stopPropagation();
                event.preventDefault();
                break;
            case Keyboard.END:
                this.focusToStepEl(el.parentElement.lastElementChild, this.numSteps - 1);
                event.stopPropagation();
                event.preventDefault();
                break;
        }
    }
    /**
     * Callback when left arrow is clicked
     */
    _onLeftArrowClick($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.leftIndex = Math.max(0, this.displayCount === 2 ? this.leftIndex - 1 : this.leftIndex - this.displayCount);
        this.r.setStyle(this.ol, this.marginSide, -this.leftIndex * this._boxWidth + 'px');
        this._updateLeftRightArrows();
    }
    /**
     * Callback when right arrow is clicked
     */
    _onRightArrowClick($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.leftIndex = Math.min(this.displayCount === 2 ? this.leftIndex + 1 : this.leftIndex + this.displayCount, this.numSteps - this.displayCount);
        this.r.setStyle(this.ol, this.marginSide, -this.leftIndex * this._boxWidth + 'px');
        this._updateLeftRightArrows();
    }
    /**
     * Update the side arrows based on the current scroll
     */
    _updateLeftRightArrows() {
        if (typeof this.displayCount === 'undefined') {
            return;
        }
        this.isLeftArrowDisabled = this.leftIndex === 0;
        this.isRightArrowDisabled = this.leftIndex + this.displayCount >= this.numSteps;
    }
    focusPreviousSibling(el, step) {
        const nextStepToShow = (this.numSteps - 1 + step) % this.numSteps;
        if (el.previousElementSibling) {
            this.focusToStepEl(el.previousElementSibling, nextStepToShow);
        }
        else {
            this.focusToStepEl(el.parentElement.lastElementChild, nextStepToShow);
        }
    }
    focusNextSibling(el, step) {
        const nextStepToShow = (1 + step) % this.numSteps;
        if (el.nextElementSibling) {
            this.focusToStepEl(el.nextElementSibling, nextStepToShow);
        }
        else {
            this.focusToStepEl(el.parentElement.firstElementChild, nextStepToShow);
        }
    }
    focusToStepEl(el, step) {
        setTimeout(() => {
            el.focus();
        }, 200 // There is a .2s transition
        );
        this.showStep(step);
    }
    showStep(step) {
        if (this.displayCount === 2) {
            if (step < this.leftIndex) {
                this.leftIndex = step;
            }
            else if (step >= this.leftIndex + this.displayCount) {
                this.leftIndex = step - this.displayCount + 1;
            }
            else if (step === this.leftIndex && step !== 0) {
                this.leftIndex--;
            }
            else if (step === this.leftIndex + 1 && step !== this.numSteps - 1) {
                this.leftIndex++;
            }
        }
        else if (this.displayCount > 2) {
            if (step === 0) {
                this.leftIndex = 0;
            }
            else if (step === this.numSteps - 1) {
                // Sometimes `displayCounter` can be bigger than `numSteps`
                // so `leftIndex` has to be >= 0
                this.leftIndex = Math.max(this.numSteps - this.displayCount, 0);
            }
            else if (step < this.leftIndex) {
                this.leftIndex = step - 1;
            }
            else if (step >= this.leftIndex + this.displayCount) {
                this.leftIndex = step - this.displayCount + 2;
            }
            else if (step === this.leftIndex + this.displayCount - 1) {
                this.leftIndex++;
            }
            else if (step === this.leftIndex) {
                this.leftIndex--;
            }
        }
        // Make if the DOM is ready then move boxes
        if (this.ol) {
            this.r.setStyle(this.ol, this.marginSide, -this.leftIndex * this._boxWidth + 'px');
        }
        this._updateLeftRightArrows();
    }
}
BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH = 350;
BentoWizardComponentStripComponent.STEP_PADDING = 0;
BentoWizardComponentStripComponent.GAP = 37; // in pixels
BentoWizardComponentStripComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentStripComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: BentoNotification }, { token: BentoLogService }, { token: i2.Directionality }, { token: BentoUidService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoWizardComponentStripComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoWizardComponentStripComponent, selector: "bento-wizard-strip", inputs: { stepsObservable: "stepsObservable", _steps: ["steps", "_steps"], hTag: "hTag", currentStep: "currentStep", useSideArrows: "useSideArrows" }, outputs: { currentStepChanging: "currentStepChanging", currentStepChange: "currentStepChange", stepUIDsChange: "stepUIDsChange" }, providers: [BentoNotification], ngImport: i0, template: "<button\n  class=\"wizard-arrow arrow-left flat\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_WIZARD_LEFT' | bentoTranslate\"\n  [disabled]=\"isLeftArrowDisabled\"\n  (click)=\"_onLeftArrowClick($event)\"\n  ngbTooltip=\"{{ 'BENTO_UI_WIZARD_LEFT' | bentoTranslate }}\"\n>\n  <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n</button>\n<button\n  class=\"wizard-arrow arrow-right flat\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_WIZARD_RIGHT' | bentoTranslate\"\n  [disabled]=\"isRightArrowDisabled\"\n  (click)=\"_onRightArrowClick($event)\"\n  ngbTooltip=\"{{ 'BENTO_UI_WIZARD_RIGHT' | bentoTranslate }}\"\n>\n  <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-wizard-steps\">\n  <div class=\"steps\" role=\"tablist\">\n    <button\n      *ngFor=\"let step of stepsArray; let i = index\"\n      class=\"bento-wizard-step flat\"\n      role=\"tab\"\n      [attr.tabindex]=\"i === _currentStep ? '0' : '-1'\"\n      [attr.aria-selected]=\"i === _currentStep\"\n      [ngClass]=\"\n        (i === _currentStep ? 'selected ' : '') +\n        (step.disabled ? 'disabled ' : '') +\n        (step.completed ? 'completed ' : '')\n      \"\n      [disabled]=\"step.disabled\"\n      (keydown)=\"_onKeydown($event, i)\"\n      (click)=\"_onStepClick(i, step.disabled)\"\n      [style.width.px]=\"_boxWidth\"\n      [attr.id]=\"stepUIDs[i]\"\n      [attr.aria-controls]=\"'tab-' + stepUIDs[i]\"\n    >\n      <div class=\"bento-wizard-step-count\"></div>\n      <span *replaceTag=\"hTag\" class=\"title h5 wizard-title\">\n        <i\n          role=\"img\"\n          class=\"bento-icon-save-solid text-success bento-wizard-step-complete-icon\"\n          [attr.aria-label]=\"'BENTO_UI_WIZARD_COMPLETE_LABEL' | bentoTranslate\"\n        ></i>\n        {{ step.title }}\n      </span>\n      <span\n        class=\"description\"\n        [bentoWizardComponentEllipsis]=\"checkEllipsis\"\n        [bentoEllipsisText]=\"step.description\"\n      ></span>\n      <div class=\"bentop-wizard-step-selection-indicator\"></div>\n    </button>\n  </div>\n</div>\n", directives: [{ type: i1$1.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: BentoReplaceTagDirective, selector: "[replaceTag]", inputs: ["replaceTag"] }, { type: BentoWizardComponentEllipsisDirective, selector: "[bentoWizardComponentEllipsis]", inputs: ["bentoEllipsisText", "bentoWizardComponentEllipsis"] }], pipes: { "bentoTranslate": BentoTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentStripComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-wizard-strip', providers: [BentoNotification], template: "<button\n  class=\"wizard-arrow arrow-left flat\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_WIZARD_LEFT' | bentoTranslate\"\n  [disabled]=\"isLeftArrowDisabled\"\n  (click)=\"_onLeftArrowClick($event)\"\n  ngbTooltip=\"{{ 'BENTO_UI_WIZARD_LEFT' | bentoTranslate }}\"\n>\n  <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n</button>\n<button\n  class=\"wizard-arrow arrow-right flat\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_WIZARD_RIGHT' | bentoTranslate\"\n  [disabled]=\"isRightArrowDisabled\"\n  (click)=\"_onRightArrowClick($event)\"\n  ngbTooltip=\"{{ 'BENTO_UI_WIZARD_RIGHT' | bentoTranslate }}\"\n>\n  <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-wizard-steps\">\n  <div class=\"steps\" role=\"tablist\">\n    <button\n      *ngFor=\"let step of stepsArray; let i = index\"\n      class=\"bento-wizard-step flat\"\n      role=\"tab\"\n      [attr.tabindex]=\"i === _currentStep ? '0' : '-1'\"\n      [attr.aria-selected]=\"i === _currentStep\"\n      [ngClass]=\"\n        (i === _currentStep ? 'selected ' : '') +\n        (step.disabled ? 'disabled ' : '') +\n        (step.completed ? 'completed ' : '')\n      \"\n      [disabled]=\"step.disabled\"\n      (keydown)=\"_onKeydown($event, i)\"\n      (click)=\"_onStepClick(i, step.disabled)\"\n      [style.width.px]=\"_boxWidth\"\n      [attr.id]=\"stepUIDs[i]\"\n      [attr.aria-controls]=\"'tab-' + stepUIDs[i]\"\n    >\n      <div class=\"bento-wizard-step-count\"></div>\n      <span *replaceTag=\"hTag\" class=\"title h5 wizard-title\">\n        <i\n          role=\"img\"\n          class=\"bento-icon-save-solid text-success bento-wizard-step-complete-icon\"\n          [attr.aria-label]=\"'BENTO_UI_WIZARD_COMPLETE_LABEL' | bentoTranslate\"\n        ></i>\n        {{ step.title }}\n      </span>\n      <span\n        class=\"description\"\n        [bentoWizardComponentEllipsis]=\"checkEllipsis\"\n        [bentoEllipsisText]=\"step.description\"\n      ></span>\n      <div class=\"bentop-wizard-step-selection-indicator\"></div>\n    </button>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: BentoNotification }, { type: BentoLogService }, { type: i2.Directionality }, { type: BentoUidService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { currentStepChanging: [{
                type: Output
            }], currentStepChange: [{
                type: Output
            }], stepsObservable: [{
                type: Input
            }], _steps: [{
                type: Input,
                args: ['steps']
            }], hTag: [{
                type: Input
            }], stepUIDsChange: [{
                type: Output
            }], currentStep: [{
                type: Input
            }], useSideArrows: [{
                type: Input
            }] } });

/**
 * A simple directive which renders a responsive wizard template. The DOM
 * object flows to 100% of its parent object's width. The 'Previous,' 'Next,'
 * and 'Done' buttons are i18n-ready.
 */
class BentoWizardComponent {
    /**
     * Main constructor
     */
    constructor(elRef, r) {
        this.r = r;
        // Component Properties
        /**
         * Flag to hide default buttons including 'Previous', 'Next' and 'Done'
         */
        this.hideDefaultButtons = false;
        /**
         * Flag to only hide 'Previous' button
         */
        this.hidePreviousButton = false;
        /**
         * Flag to only hide 'Next' button
         */
        this.hideNextButton = false;
        /**
         * Flag to only hide 'Done' button
         */
        this.hideDoneButton = false;
        /**
         * Flag to show 'Cancel' button
         */
        this.showCancelButton = false;
        /**
         * Flag to use Bento Sticky Footer
         */
        this.useStickyFooter = false;
        /**
         * Flag to show if the Bento Sticky Footer in full width of its scrolling panel or align to the Wizard width
         */
        this.stickyFooterFullWidth = true;
        /**
         * A11y: Specify header tag for wizard's Title. The header tag's rank must be
         * in hierarchical order to the page in which the component is used.
         * Headings communicate the organization of the content on the page. Web
         * browsers, plug-ins, and assistive technologies can use them to provide
         * in-page navigation.
         */
        this.hTag = 'h1';
        this._currentStep = 0;
        /**
         * Callback when the current step of a Bento Wizard component is changed
         *
         * This callback will return the index number of the new step
         */
        this.currentStepChange = new EventEmitter();
        // Event Emitters
        /**
         * Callback when the current step of a Bento Wizard component is about to change
         *
         * A `BentoWizardComponentEvent` object is passed in for event-handling
         */
        this.currentStepChanging = new EventEmitter();
        /**
         * Callback when 'Cancel' button is clicked
         */
        this.cancel = new EventEmitter();
        /**
         * Callback when 'Done' button is clicked
         */
        this.done = new EventEmitter();
        this._stepsChangeEventEmitter = new EventEmitter();
        this._stepUIDs = [];
        this._hasCancellable = false;
        this._el = elRef.nativeElement;
    }
    /**
     * Sets the current step of a Bento Wizard component
     */
    set currentStep(step) {
        const _step = !!step ? step : 0;
        if ((this._steps && this._steps.length <= step) || step < 0) {
            return;
        }
        if (this._steps) {
            // Only call this when _steps is ready
            this._onStepChange(_step);
        }
        else {
            // Initialization state, we wait for the content to be ready
            this._initStep = _step;
        }
    }
    /**
     * Callback when content is initialized
     */
    ngAfterContentInit() {
        this._onStepsUpdate();
        this._steps.changes.subscribe(() => {
            this._onStepsUpdate();
        });
        // See if we need to pre-select a step defined by devs
        if (typeof this._initStep !== 'undefined') {
            this._onStepChange(this._initStep);
            this._initStep = null;
        }
    }
    ngAfterViewInit() {
        this.wizardStepElements = this._el.querySelectorAll('.bento-wizard-steps .steps button.bento-wizard-step');
    }
    // Forward the Bento Step Strip to the user
    /**
     * This method is called when the Bento Wizard Strip is about to make changes
     * The Event is forward to the user then let it to decide whether it should call
     * the `_onStepChange(step)` for the actual change
     */
    _onStripStepChanging(event) {
        this.currentStepChanging.emit(event);
    }
    /**
     * Callback from the 'Previous' and 'Next' buttons
     */
    _onButtonStepChanging($event, step) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.currentStepChanging.emit(new BentoWizardComponentEvent(step, this._currentStep, (cancellable) => {
            this._hasCancellable = true;
            if (cancellable) {
                const subscription = cancellable.subscribe(response => {
                    if (response) {
                        this._onStepChange(step);
                    }
                    // unsubscribe from the EventEmitter
                    subscription.unsubscribe();
                });
            }
        }));
        if (!this._hasCancellable) {
            this._onStepChange(step);
        }
        else {
            // Reset the variable for the next step change
            this._hasCancellable = false;
        }
    }
    /**
     * Callback to fire the actual step change of the wizard
     */
    _onStepChange(step) {
        // Steps are not ready
        if (typeof step === 'undefined' ||
            step === this._currentStep ||
            (step === 0 && typeof this._currentStep === 'undefined') ||
            !this._stepsArray ||
            this._stepsArray.length === 0) {
            return;
        }
        this._currentStep = step;
        this._updateViews();
        this.currentStepChange.emit(step);
        if (this.stickyFooter) {
            this.stickyFooter.checkAllocation();
        }
    }
    /**
     * Callback when done button is clicked
     */
    _onDoneClick($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.done.emit();
    }
    /**
     * Callback when cancel button is clicked
     */
    _onCancelClick($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.cancel.emit(this._currentStep);
    }
    // Private methods
    /**
     * Update and render views
     */
    _updateViews() {
        // Step can be out of range when some steps are hidden during the process
        this._currentStep = this._currentStep >= this._stepsArray.length ? this._stepsArray.length - 1 : this._currentStep;
        // Skip update view when `_currentStep` is not ready
        const step = typeof this._currentStep === 'undefined' ? 0 : this._currentStep;
        for (let i = 0; i < this._stepsArray.length; i++) {
            if (i !== step) {
                this._stepsArray[i].hide();
            }
        }
        this._stepsArray[step].show();
        if (this.wizardStepElements && this.wizardStepElements.length && step <= this.wizardStepElements.length) {
            const wizardStepEl = this.wizardStepElements[step];
            wizardStepEl.focus();
        }
    }
    /**
     * Callback when steps container is updated with a new layout
     */
    _onStepsUpdate(emit = true) {
        if (this._steps && this._steps.length) {
            this.r.removeClass(this._el, 'bento-wizard-no-data');
            this._stepsArray = this._steps.toArray();
            this._updateViews();
            if (emit) {
                this._stepsChangeEventEmitter.emit(this._steps);
            }
        }
        else {
            // There is no data
            this.r.addClass(this._el, 'bento-wizard-no-data');
        }
    }
    /**
     * Callback when UIDs are given by the stip
     */
    _onStepUIDsChange(uids) {
        this._stepUIDs = uids;
    }
}
BentoWizardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
BentoWizardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoWizardComponent, selector: "bento-wizard", inputs: { hideDefaultButtons: "hideDefaultButtons", hidePreviousButton: "hidePreviousButton", hideNextButton: "hideNextButton", hideDoneButton: "hideDoneButton", showCancelButton: "showCancelButton", useStickyFooter: "useStickyFooter", stickyFooterFullWidth: "stickyFooterFullWidth", currentStep: "currentStep", hTag: "hTag" }, outputs: { currentStepChange: "currentStepChange", currentStepChanging: "currentStepChanging", cancel: "cancel", done: "done" }, queries: [{ propertyName: "_steps", predicate: BentoWizardStepComponent }], viewQueries: [{ propertyName: "stickyFooter", first: true, predicate: BentoStickyFooterComponent, descendants: true }], ngImport: i0, template: "<div class=\"bento-wizard\">\n  <bento-wizard-strip\n    [steps]=\"_steps\"\n    [stepsObservable]=\"_stepsChangeEventEmitter\"\n    [currentStep]=\"_currentStep\"\n    [hTag]=\"hTag\"\n    (currentStepChanging)=\"_onStripStepChanging($event)\"\n    (currentStepChange)=\"_onStepChange($event)\"\n    (stepUIDsChange)=\"_onStepUIDsChange($event)\"\n  ></bento-wizard-strip>\n  <div\n    class=\"bento-wizard-contents container-fluid\"\n    [attr.id]=\"'tab-' + _stepUIDs[_currentStep]\"\n    [attr.aria-labeledby]=\"_stepUIDs[_currentStep]\"\n    tabindex=\"0\"\n    cdkMonitorElementFocus\n    role=\"tabpanel\"\n  >\n    <ng-content select=\"bento-wizard-step\"></ng-content>\n  </div>\n\n  <ng-container *ngIf=\"useStickyFooter; else defaultFooter\">\n    <bento-sticky-footer [showOnElementVisible]=\"_el\" [fullWidth]=\"stickyFooterFullWidth\">\n      <div class=\"bento-wizard-sticky-footer-content\">\n        <ng-container [ngTemplateOutlet]=\"defaultButtons\"></ng-container>\n      </div>\n    </bento-sticky-footer>\n  </ng-container>\n\n  <ng-template #defaultFooter>\n    <ng-container [ngTemplateOutlet]=\"defaultButtons\"></ng-container>\n  </ng-template>\n\n  <ng-template #defaultButtons>\n    <button\n      class=\"btn btn-outline-primary bento-wizard-prev-button\"\n      type=\"button\"\n      *ngIf=\"_currentStep > 0 && !hideDefaultButtons && !hidePreviousButton\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION' | bentoTranslate\"\n      (click)=\"_onButtonStepChanging($event, _currentStep - 1)\"\n      [disabled]=\"_stepsArray && _stepsArray[_currentStep - 1].disabled\"\n    >\n      <i class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS' | bentoTranslate }}</span>\n    </button>\n    <button\n      class=\"btn btn-primary bento-wizard-next-button\"\n      *ngIf=\"_currentStep < _steps.length - 1 && !hideDefaultButtons && !hideNextButton\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION' | bentoTranslate\"\n      (click)=\"_onButtonStepChanging($event, _currentStep + 1)\"\n      [disabled]=\"_stepsArray && _stepsArray[_currentStep + 1].disabled\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_NEXT' | bentoTranslate }}</span>\n      <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n    </button>\n    <button\n      class=\"btn btn-primary bento-wizard-done-button\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION' | bentoTranslate\"\n      *ngIf=\"_currentStep === _steps.length - 1 && !hideDefaultButtons && !hideDoneButton\"\n      (click)=\"_onDoneClick($event)\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_DONE' | bentoTranslate }}</span>\n    </button>\n    <button\n      class=\"btn btn-outline-primary bento-wizard-cancel-button\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION' | bentoTranslate\"\n      *ngIf=\"showCancelButton\"\n      (click)=\"_onCancelClick($event)\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL' | bentoTranslate }}</span>\n    </button>\n    <ng-content select=\"bento-wizard-custom-button-group\"></ng-content>\n  </ng-template>\n  <div class=\"clearfix\"></div>\n</div>\n", styles: [".ng-bento .html{padding:0;margin:0}.ng-bento bento-wizard .bento-wizard{position:relative;margin-bottom:20px;width:100%}.ng-bento bento-wizard .bento-wizard .arrow-bg-color{display:none}.ng-bento bento-wizard .bento-wizard-no-data{display:none}.ng-bento bento-wizard .bento-wizard>.btn,.ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn,.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn{margin:10px 10px 0 0;float:left}[dir=rtl] .ng-bento bento-wizard .bento-wizard>.btn,[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn,[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn{float:right}.ng-bento bento-wizard .bento-wizard>.btn:last-child,.ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn:last-child,.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:last-child{margin-right:0}.ng-bento bento-wizard .bento-wizard>.btn.float-right,.ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn.float-right,.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn.float-right{margin-right:10px;margin-left:0}.ng-bento bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:left;margin-left:0;margin-right:10px}[dir=rtl] .ng-bento bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:right}[dir=rtl] .ng-bento bento-wizard .bento-wizard>.btn.bento-wizard-prev-button i:before{content:\"\\e646\"}[dir=rtl] .ng-bento bento-wizard .bento-wizard>.btn.bento-wizard-next-button i:before{content:\"\\e641\"}.ng-bento bento-wizard .bento-wizard .bento-wizard-next-button,.ng-bento bento-wizard .bento-wizard .bento-wizard-done-button{float:left}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-next-button,[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-done-button{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-cancel-button{float:right}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-cancel-button{float:left}.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:first-child{margin-left:0}.ng-bento bento-wizard .bento-wizard>.btn.pull-right{margin-left:10px;margin-right:0}.ng-bento bento-wizard .bento-wizard bento-wizard-strip{display:block;overflow:hidden;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;z-index:1}.ng-bento bento-wizard .bento-wizard bento-wizard-strip.side-arrows{position:relative}.ng-bento bento-wizard .bento-wizard bento-wizard-strip.side-arrows>.wizard-arrow{display:flex;z-index:1}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow{display:none;position:absolute;align-items:center;justify-content:center;top:0;padding:0;border-width:1px;border-style:solid;box-sizing:border-box;font-size:23px}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:focus,.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:active{outline:none}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:0}[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:auto;right:0;transform:rotate(180deg)}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:0}[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:auto;left:0;transform:rotate(180deg)}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents{width:100%;border-bottom-width:1px;border-bottom-style:solid;min-height:200px}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents bento-wizard-step{padding:1px 25px 25px;z-index:2}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents:focus{outline:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-keyboard-focused bento-wizard-step,.ng-bento bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-program-focused bento-wizard-step{outline:1px dashed}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps{position:relative;top:0;width:100%;overflow:hidden;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps{border-right-width:1px;border-left-width:1px;border-left-style:solid}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps:before{content:\"\";width:100%;height:100%;position:absolute;border-width:1px;border-style:solid;border-right:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .bento-wizard-step{position:relative}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps{counter-reset:wizardstepcount;margin:0;padding:0;display:block;float:left;white-space:nowrap}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{display:inline-block;vertical-align:top;white-space:normal;cursor:pointer;position:relative;padding:15px 15px 5px;list-style:none;min-height:45px;text-overflow:ellipsis;text-align:left;border-left:none;border-right:none;border-top-width:1px;border-top-style:solid;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus{outline:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]):first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]).selected:first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]):first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]).selected:first-child:after{display:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step[disabled]{cursor:not-allowed}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:first-child{margin-left:0;border-left-width:1px;border-left-style:solid}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{content:\"\";position:absolute;height:100%;top:0;width:25px;left:100%;pointer-events:none;z-index:1}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{right:100%}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:30px}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:15px;padding-right:30px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .title{font-size:14px;line-height:16px;display:block;font-weight:700}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .description{display:block;clear:both;margin:12px 0 0;float:left;font-size:11px;line-height:15px;width:100%;padding:0}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .title{line-height:14px;margin-bottom:4px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .description{width:auto;clear:none;border:none;margin:0;padding:0;line-height:1.2em;max-height:2.4em;overflow:hidden;float:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .bento-wizard-step-count:before{margin-bottom:30px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{position:absolute;left:0;top:-1px}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{right:-1px;transform:scaleX(-1)}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:first-child:after{background:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow{padding:10px 15px 5px 10px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .title{line-height:16px;padding-top:0}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .description{margin-top:0;padding-top:8px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .bento-wizard-step-count:before{margin-bottom:10px;padding-bottom:8px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover{padding:9px 15px 5px 10px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:first-child,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover:first-child{padding-left:9px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.disabled{pointer-events:none;cursor:default}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{display:block;float:left}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{content:counter(wizardstepcount);counter-increment:wizardstepcount;display:block;float:left;padding:10px 12px 8px 0;box-sizing:border-box;margin-right:12px;font-weight:700;font-size:42px;line-height:14px;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{float:right;padding:10px 0 8px 12px;border-left-style:solid;border-left-width:1px;border-right:none;margin-left:12px;margin-right:0}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{top:-1px;right:1px;content:\"\";position:absolute;width:25px;height:100px;pointer-events:none}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{right:auto;left:1px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover{cursor:default;padding-top:15px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child{padding-left:15px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child:after{background:none}.ng-bento bento-wizard .bento-wizard .wizard-title{margin-top:auto}.ng-bento .bento-sticky-bar .bento-wizard-sticky-footer-content{margin:0 -10px}.ng-bento .bento-sticky-bar .bento-wizard-sticky-footer-content .btn{margin-left:10px}.ng-bento .bento-sticky-bar .bento-wizard-sticky-footer-content .btn.float-right{margin-left:0;margin-right:10px}.ng-bento .bento-wizard-step-complete-icon{display:none}.completed>.wizard-title .ng-bento .bento-wizard-step-complete-icon{display:inline-block;vertical-align:bottom}\n"], components: [{ type: BentoWizardComponentStripComponent, selector: "bento-wizard-strip", inputs: ["stepsObservable", "steps", "hTag", "currentStep", "useSideArrows"], outputs: ["currentStepChanging", "currentStepChange", "stepUIDsChange"] }, { type: BentoStickyFooterComponent, selector: "bento-sticky-footer" }], directives: [{ type: i3.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"] }, { type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "bentoTranslate": BentoTranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-wizard', encapsulation: ViewEncapsulation.None, template: "<div class=\"bento-wizard\">\n  <bento-wizard-strip\n    [steps]=\"_steps\"\n    [stepsObservable]=\"_stepsChangeEventEmitter\"\n    [currentStep]=\"_currentStep\"\n    [hTag]=\"hTag\"\n    (currentStepChanging)=\"_onStripStepChanging($event)\"\n    (currentStepChange)=\"_onStepChange($event)\"\n    (stepUIDsChange)=\"_onStepUIDsChange($event)\"\n  ></bento-wizard-strip>\n  <div\n    class=\"bento-wizard-contents container-fluid\"\n    [attr.id]=\"'tab-' + _stepUIDs[_currentStep]\"\n    [attr.aria-labeledby]=\"_stepUIDs[_currentStep]\"\n    tabindex=\"0\"\n    cdkMonitorElementFocus\n    role=\"tabpanel\"\n  >\n    <ng-content select=\"bento-wizard-step\"></ng-content>\n  </div>\n\n  <ng-container *ngIf=\"useStickyFooter; else defaultFooter\">\n    <bento-sticky-footer [showOnElementVisible]=\"_el\" [fullWidth]=\"stickyFooterFullWidth\">\n      <div class=\"bento-wizard-sticky-footer-content\">\n        <ng-container [ngTemplateOutlet]=\"defaultButtons\"></ng-container>\n      </div>\n    </bento-sticky-footer>\n  </ng-container>\n\n  <ng-template #defaultFooter>\n    <ng-container [ngTemplateOutlet]=\"defaultButtons\"></ng-container>\n  </ng-template>\n\n  <ng-template #defaultButtons>\n    <button\n      class=\"btn btn-outline-primary bento-wizard-prev-button\"\n      type=\"button\"\n      *ngIf=\"_currentStep > 0 && !hideDefaultButtons && !hidePreviousButton\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION' | bentoTranslate\"\n      (click)=\"_onButtonStepChanging($event, _currentStep - 1)\"\n      [disabled]=\"_stepsArray && _stepsArray[_currentStep - 1].disabled\"\n    >\n      <i class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS' | bentoTranslate }}</span>\n    </button>\n    <button\n      class=\"btn btn-primary bento-wizard-next-button\"\n      *ngIf=\"_currentStep < _steps.length - 1 && !hideDefaultButtons && !hideNextButton\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION' | bentoTranslate\"\n      (click)=\"_onButtonStepChanging($event, _currentStep + 1)\"\n      [disabled]=\"_stepsArray && _stepsArray[_currentStep + 1].disabled\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_NEXT' | bentoTranslate }}</span>\n      <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n    </button>\n    <button\n      class=\"btn btn-primary bento-wizard-done-button\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION' | bentoTranslate\"\n      *ngIf=\"_currentStep === _steps.length - 1 && !hideDefaultButtons && !hideDoneButton\"\n      (click)=\"_onDoneClick($event)\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_DONE' | bentoTranslate }}</span>\n    </button>\n    <button\n      class=\"btn btn-outline-primary bento-wizard-cancel-button\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION' | bentoTranslate\"\n      *ngIf=\"showCancelButton\"\n      (click)=\"_onCancelClick($event)\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL' | bentoTranslate }}</span>\n    </button>\n    <ng-content select=\"bento-wizard-custom-button-group\"></ng-content>\n  </ng-template>\n  <div class=\"clearfix\"></div>\n</div>\n", styles: [".ng-bento .html{padding:0;margin:0}.ng-bento bento-wizard .bento-wizard{position:relative;margin-bottom:20px;width:100%}.ng-bento bento-wizard .bento-wizard .arrow-bg-color{display:none}.ng-bento bento-wizard .bento-wizard-no-data{display:none}.ng-bento bento-wizard .bento-wizard>.btn,.ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn,.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn{margin:10px 10px 0 0;float:left}[dir=rtl] .ng-bento bento-wizard .bento-wizard>.btn,[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn,[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn{float:right}.ng-bento bento-wizard .bento-wizard>.btn:last-child,.ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn:last-child,.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:last-child{margin-right:0}.ng-bento bento-wizard .bento-wizard>.btn.float-right,.ng-bento bento-wizard .bento-wizard bento-sticky-footer .btn.float-right,.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn.float-right{margin-right:10px;margin-left:0}.ng-bento bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:left;margin-left:0;margin-right:10px}[dir=rtl] .ng-bento bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:right}[dir=rtl] .ng-bento bento-wizard .bento-wizard>.btn.bento-wizard-prev-button i:before{content:\"\\e646\"}[dir=rtl] .ng-bento bento-wizard .bento-wizard>.btn.bento-wizard-next-button i:before{content:\"\\e641\"}.ng-bento bento-wizard .bento-wizard .bento-wizard-next-button,.ng-bento bento-wizard .bento-wizard .bento-wizard-done-button{float:left}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-next-button,[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-done-button{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-cancel-button{float:right}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-cancel-button{float:left}.ng-bento bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:first-child{margin-left:0}.ng-bento bento-wizard .bento-wizard>.btn.pull-right{margin-left:10px;margin-right:0}.ng-bento bento-wizard .bento-wizard bento-wizard-strip{display:block;overflow:hidden;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;z-index:1}.ng-bento bento-wizard .bento-wizard bento-wizard-strip.side-arrows{position:relative}.ng-bento bento-wizard .bento-wizard bento-wizard-strip.side-arrows>.wizard-arrow{display:flex;z-index:1}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow{display:none;position:absolute;align-items:center;justify-content:center;top:0;padding:0;border-width:1px;border-style:solid;box-sizing:border-box;font-size:23px}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:focus,.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:active{outline:none}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:0}[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:auto;right:0;transform:rotate(180deg)}.ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:0}[dir=rtl] .ng-bento bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:auto;left:0;transform:rotate(180deg)}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents{width:100%;border-bottom-width:1px;border-bottom-style:solid;min-height:200px}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents bento-wizard-step{padding:1px 25px 25px;z-index:2}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents:focus{outline:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-keyboard-focused bento-wizard-step,.ng-bento bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-program-focused bento-wizard-step{outline:1px dashed}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps{position:relative;top:0;width:100%;overflow:hidden;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps{border-right-width:1px;border-left-width:1px;border-left-style:solid}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps:before{content:\"\";width:100%;height:100%;position:absolute;border-width:1px;border-style:solid;border-right:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .bento-wizard-step{position:relative}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps{counter-reset:wizardstepcount;margin:0;padding:0;display:block;float:left;white-space:nowrap}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{display:inline-block;vertical-align:top;white-space:normal;cursor:pointer;position:relative;padding:15px 15px 5px;list-style:none;min-height:45px;text-overflow:ellipsis;text-align:left;border-left:none;border-right:none;border-top-width:1px;border-top-style:solid;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus{outline:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]):first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]).selected:first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]):first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]).selected:first-child:after{display:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step[disabled]{cursor:not-allowed}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:first-child{margin-left:0;border-left-width:1px;border-left-style:solid}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{content:\"\";position:absolute;height:100%;top:0;width:25px;left:100%;pointer-events:none;z-index:1}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{right:100%}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:30px}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:15px;padding-right:30px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .title{font-size:14px;line-height:16px;display:block;font-weight:700}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .description{display:block;clear:both;margin:12px 0 0;float:left;font-size:11px;line-height:15px;width:100%;padding:0}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .title{line-height:14px;margin-bottom:4px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .description{width:auto;clear:none;border:none;margin:0;padding:0;line-height:1.2em;max-height:2.4em;overflow:hidden;float:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .bento-wizard-step-count:before{margin-bottom:30px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{position:absolute;left:0;top:-1px}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{right:-1px;transform:scaleX(-1)}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:first-child:after{background:none}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow{padding:10px 15px 5px 10px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .title{line-height:16px;padding-top:0}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .description{margin-top:0;padding-top:8px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .bento-wizard-step-count:before{margin-bottom:10px;padding-bottom:8px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover{padding:9px 15px 5px 10px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:first-child,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover:first-child{padding-left:9px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.disabled{pointer-events:none;cursor:default}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{display:block;float:left}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{float:right}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{content:counter(wizardstepcount);counter-increment:wizardstepcount;display:block;float:left;padding:10px 12px 8px 0;box-sizing:border-box;margin-right:12px;font-weight:700;font-size:42px;line-height:14px;border-right-width:1px;border-right-style:solid}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{float:right;padding:10px 0 8px 12px;border-left-style:solid;border-left-width:1px;border-right:none;margin-left:12px;margin-right:0}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{top:-1px;right:1px;content:\"\";position:absolute;width:25px;height:100px;pointer-events:none}[dir=rtl] .ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{right:auto;left:1px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover{cursor:default;padding-top:15px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child{padding-left:15px}.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child:after,.ng-bento bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child:after{background:none}.ng-bento bento-wizard .bento-wizard .wizard-title{margin-top:auto}.ng-bento .bento-sticky-bar .bento-wizard-sticky-footer-content{margin:0 -10px}.ng-bento .bento-sticky-bar .bento-wizard-sticky-footer-content .btn{margin-left:10px}.ng-bento .bento-sticky-bar .bento-wizard-sticky-footer-content .btn.float-right{margin-left:0;margin-right:10px}.ng-bento .bento-wizard-step-complete-icon{display:none}.completed>.wizard-title .ng-bento .bento-wizard-step-complete-icon{display:inline-block;vertical-align:bottom}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { hideDefaultButtons: [{
                type: Input
            }], hidePreviousButton: [{
                type: Input
            }], hideNextButton: [{
                type: Input
            }], hideDoneButton: [{
                type: Input
            }], showCancelButton: [{
                type: Input
            }], useStickyFooter: [{
                type: Input
            }], stickyFooterFullWidth: [{
                type: Input
            }], currentStep: [{
                type: Input
            }], hTag: [{
                type: Input
            }], currentStepChange: [{
                type: Output
            }], currentStepChanging: [{
                type: Output
            }], cancel: [{
                type: Output
            }], done: [{
                type: Output
            }], stickyFooter: [{
                type: ViewChild,
                args: [BentoStickyFooterComponent]
            }], _steps: [{
                type: ContentChildren,
                args: [BentoWizardStepComponent]
            }] } });

class BentoWizardComponentCustomButtonGroupComponent {
}
BentoWizardComponentCustomButtonGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentCustomButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BentoWizardComponentCustomButtonGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoWizardComponentCustomButtonGroupComponent, selector: "bento-wizard-custom-button-group", ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentCustomButtonGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bento-wizard-custom-button-group',
                    template: `
    <ng-content></ng-content>
  `
                }]
        }] });

class BentoWizardComponentModule extends ConsumerDataValidator {
}
BentoWizardComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoWizardComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentModule, declarations: [BentoWizardComponent,
        BentoWizardStepComponent,
        BentoWizardComponentStripComponent,
        BentoWizardComponentEllipsisDirective,
        BentoWizardComponentCustomButtonGroupComponent], imports: [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        BentoStickyFooterModule,
        A11yModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule], exports: [BentoWizardComponent, BentoWizardStepComponent, BentoWizardComponentCustomButtonGroupComponent] });
BentoWizardComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentModule, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            BentoStickyFooterModule,
            A11yModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoWizardComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BentoTranslateModule,
                        BentoUtilsModule,
                        BentoStickyFooterModule,
                        A11yModule,
                        BentoFocusMonitorModule,
                        NgbTooltipModule,
                        BentoNgbTooltipSupportModule
                    ],
                    declarations: [
                        BentoWizardComponent,
                        BentoWizardStepComponent,
                        BentoWizardComponentStripComponent,
                        BentoWizardComponentEllipsisDirective,
                        BentoWizardComponentCustomButtonGroupComponent
                    ],
                    exports: [BentoWizardComponent, BentoWizardStepComponent, BentoWizardComponentCustomButtonGroupComponent]
                }]
        }] });

/**
 * A directive to render Bootstraps `.input-group-prepend` element when used with Bento
 * form controls such as Number Input and Combobox components.
 */
class BentoInputGroupPrependDirective {
    constructor(elRef, sanitizer, r, logger) {
        this.sanitizer = sanitizer;
        this.r = r;
        this.logger = logger;
        this.el = elRef.nativeElement;
        this.prependEl = this.r.createElement('div');
        this.r.addClass(this.prependEl, 'input-group-prepend');
    }
    /**
     * Static HTML/Text that defines the content of an input group prepend element
     */
    set inputGroupPrepend(html) {
        this.prependHTML = `<div class="input-group-text">${this.sanitizer.sanitize(SecurityContext.HTML, html)}</div>`;
        this.r.setProperty(this.prependEl, 'innerHTML', this.prependHTML);
    }
    get inputGroupPrepend() {
        return this.prependHTML;
    }
    ngAfterViewInit() {
        this.injectPrependEl();
    }
    injectPrependEl() {
        const inputEl = this.el.tagName === 'INPUT' ? this.el : this.el.querySelector('input.form-control');
        if (inputEl && inputEl.classList.contains('form-control')) {
            const wrapperEl = inputEl.parentElement;
            this.r.addClass(wrapperEl, 'input-group');
            wrapperEl.insertBefore(this.prependEl, inputEl);
        }
        else {
            this.logger.warn('BentoInputGroupPrependDirective: Missing `input.form-control`');
        }
    }
}
BentoInputGroupPrependDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoInputGroupPrependDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.DomSanitizer }, { token: i0.Renderer2 }, { token: BentoLogService }], target: i0.ɵɵFactoryTarget.Directive });
BentoInputGroupPrependDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoInputGroupPrependDirective, selector: ":not([type=slider]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=range])[inputGroupPrepend]", inputs: { inputGroupPrepend: "inputGroupPrepend" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoInputGroupPrependDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: ':not([type=slider]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=range])[inputGroupPrepend]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$2.DomSanitizer }, { type: i0.Renderer2 }, { type: BentoLogService }]; }, propDecorators: { inputGroupPrepend: [{
                type: Input
            }] } });

/**
 * A directive to add required asterisk * to labels tied to required form elements
 */
const FormElements = [
    'INPUT',
    'SELECT',
    'TEXTAREA',
    'FIELDSET'
];
// Checkbox & Radio are the only types needed atm
var FormElementTypes;
(function (FormElementTypes) {
    FormElementTypes["checkbox"] = "checkbox";
    FormElementTypes["radio"] = "radio";
    FormElementTypes["text"] = "text";
})(FormElementTypes || (FormElementTypes = {}));
var FormElement;
(function (FormElement) {
    FormElement["input"] = "INPUT";
    FormElement["select"] = "SELECT";
    FormElement["textarea"] = "TEXTAREA";
    FormElement["fieldset"] = "FIELDSET";
    FormElement["label"] = "LABEL";
    FormElement["legend"] = "LEGEND";
})(FormElement || (FormElement = {}));
class BentoRequiredDirective {
    constructor(elRef) {
        this.el = elRef.nativeElement;
    }
    ngAfterViewInit() {
        if (this.el.hasAttribute('required')) {
            // Add timeout to wait for labels to be generated for some bento components
            setTimeout(() => {
                // Determine if element is an input or bento component
                // If el is a form element
                if (FormElements.indexOf(this.el.tagName) !== -1) {
                    this.determineElementType(this.el);
                    // Else, assume el is a bento component
                }
                else {
                    // Attempt to find required child form element quickly
                    if (this.el.querySelector('[required]')) {
                        this.el = this.el.querySelector('[required]');
                    }
                    else {
                        const children = this.el.childNodes;
                        children.forEach(child => {
                            const childEl = child;
                            if (FormElements.indexOf(childEl.tagName) !== -1) {
                                this.el = childEl;
                                this.determineElementType(this.el);
                            }
                        });
                    }
                }
                // If hint text is present in label, parse label text to add *
                if (this.elLabel) {
                    this.parseLabelText(this.elLabel);
                }
            });
        }
    }
    parseLabelText(el) {
        const asterisk = ' * ';
        // If element has child nodes, find actual text content
        if (el.children.length >= 1) {
            // get element text content
            let elText = el.childNodes[0].nodeValue;
            // Add asterisk to label text if not already present
            if (elText && elText.indexOf('*') === -1) {
                el.childNodes[0].nodeValue += asterisk;
            }
            // If element does not have child nodes, update textContent
        }
        else {
            if (el.textContent.indexOf('*') === -1) {
                el.textContent += asterisk;
            }
        }
    }
    // Determine heirarchy of form - determine if checkbox/radio or noraml form field
    determineElementType(el) {
        const elType = el.getAttribute('type');
        // If radio/checkbox, try to find legend associated with the fieldset
        if (elType === FormElementTypes.radio || elType === FormElementTypes.checkbox) {
            this.findLabelFromParent(el, FormElement.fieldset, FormElement.legend);
            // If normal form field, try to find label via [for=] attribute
        }
        else {
            this.findAssociatedLabel(el);
        }
    }
    // Loop through parent elements until the desired parent form element is found
    // This function is primarily used for radio/checkbox groups whos labels are not directly associated with their required form field
    findLabelFromParent(el, parent, target, iteration = 0) {
        // if parent element matches target parent element search for target element
        if (el.parentElement.tagName === parent) {
            this.elLabel = el.parentElement.tagName === parent ? el.parentElement.querySelector(target) : null;
        }
        else {
            // If target parent element is not found, loop through grandparents up to 5 levels
            // to check for target parent element.  Note, this is useful for bento form components with nested input
            iteration = iteration + 1;
            if (iteration <= 5) {
                this.findLabelFromParent(el.parentElement, parent, target, iteration);
            }
        }
    }
    // Find associated form field label via for attribute
    findAssociatedLabel(el) {
        this.elLabel = el.hasAttribute('id') ? document.querySelector(`label[for=${el.getAttribute('id')}]`) : null;
    }
}
BentoRequiredDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRequiredDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
BentoRequiredDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoRequiredDirective, selector: "[bentoRequired]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRequiredDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoRequired]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class BentoFormModule extends ConsumerDataValidator {
}
BentoFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFormModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
BentoFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFormModule, declarations: [BentoInputGroupPrependDirective, BentoRequiredDirective], exports: [BentoInputGroupPrependDirective, BentoRequiredDirective] });
BentoFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFormModule, providers: [], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [BentoInputGroupPrependDirective, BentoRequiredDirective],
                    declarations: [BentoInputGroupPrependDirective, BentoRequiredDirective],
                    providers: []
                }]
        }] });

/**
 * A class to define a actionable item that can be consume by various Bento components
 */
class BentoActionableItem {
    /**
     * Main constructor
     */
    constructor(label, icon, action) {
        /**
         * Flag to determine if this item is disabled
         */
        this.disabled = false;
        this.label = label;
        this.icon = icon;
        this.action = action;
    }
}

/**
 * Get the root of any Zone
 * @param zone - Initial Zone
 * @returns Root Zone
 */
function getZoneRoot(zone) {
    let z = zone;
    while (z.parent) {
        z = z.parent;
    }
    return z;
}
/**
 * This is a ZoneSpec that will keep track of all tasks schedules in the Zone
 * allowing tracking of them
 */
class TrackingZoneSpec {
    constructor() {
        this._changes = new Subject();
        /**
         * This Observable will emit any time that there are new values
         * Uses a throttleTime to avoid many executions.
         * The Observable will emit OUTSIDE of the Angular zone to avoid infinite loops
         */
        this.changes = this._changes.pipe(throttleTime(200), shareReplay());
        this.name = 'TrackingZone';
        // Use of sets allow avoid duplications of tasks
        this.microTasks = new Set();
        this.macroTasks = new Set();
        this.eventTasks = new Set();
        this.properties = { TrackingZone: this };
    }
    getTasksFor(type) {
        switch (type) {
            case 'microTask':
                return this.microTasks;
            case 'macroTask':
                return this.macroTasks;
            case 'eventTask':
                return this.eventTasks;
        }
        throw new Error('Unknown task format: ' + type);
    }
    onScheduleTask(parentZoneDelegate, currentZone, targetZone, task) {
        const tasks = this.getTasksFor(task.type);
        tasks.add(task);
        this.triggerChange(targetZone);
        return parentZoneDelegate.scheduleTask(targetZone, task);
    }
    onCancelTask(parentZoneDelegate, currentZone, targetZone, task) {
        const tasks = this.getTasksFor(task.type);
        tasks.delete(task);
        this.triggerChange(targetZone);
        return parentZoneDelegate.cancelTask(targetZone, task);
    }
    onInvokeTask(parentZoneDelegate, currentZone, targetZone, task, applyThis, applyArgs) {
        if (task.type !== 'eventTask') {
            const tasks = this.getTasksFor(task.type);
            tasks.delete(task);
        }
        try {
            return parentZoneDelegate.invokeTask(targetZone, task, applyThis, applyArgs);
        }
        finally {
            this.triggerChange(targetZone);
        }
    }
    clearEvents() {
        for (const task of Array.from(this.eventTasks)) {
            Zone.current.cancelTask(task);
        }
        this.triggerChange(Zone.current);
    }
    triggerChange(zone) {
        const root = getZoneRoot(zone);
        root.run(() => {
            this._changes.next();
        });
    }
}

/// <reference path="../../../../../../../node_modules/zone.js/zone.d.ts" />
class BentoRestartAnimationOnValueChangeDirective {
    constructor(elementRef, r) {
        this.elementRef = elementRef;
        this.r = r;
    }
    ngOnChanges(changes) {
        if (changes.changeValue) {
            this.r.removeClass(this.elementRef.nativeElement, this.className);
            // This is a trick to force a reflow and restart animations
            void this.elementRef.nativeElement.offsetWidth;
            this.r.addClass(this.elementRef.nativeElement, this.className);
        }
    }
}
BentoRestartAnimationOnValueChangeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRestartAnimationOnValueChangeDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
BentoRestartAnimationOnValueChangeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoRestartAnimationOnValueChangeDirective, selector: "[bentoRestartAnimationOnValueChange]", inputs: { className: "className", changeValue: ["bentoRestartAnimationOnValueChange", "changeValue"] }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoRestartAnimationOnValueChangeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoRestartAnimationOnValueChange]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { className: [{
                type: Input
            }], changeValue: [{
                type: Input,
                args: ['bentoRestartAnimationOnValueChange']
            }] } });
class BentoNgZoneWatcherComponent {
    constructor(winRef, dragDrop, el, ngZone, change) {
        this.winRef = winRef;
        this.dragDrop = dragDrop;
        this.el = el;
        this.ngZone = ngZone;
        this.change = change;
        this.isRecording = false;
        this.eventsSnaptshot = [];
        this.display = 'none';
        this.card = true;
        this.cardAlt = true;
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
    }
    ngOnDestroy() {
        // Removes the shortcut listener
        this.winRef.nativeDocument.removeEventListener('keydown', this.onKeyDown);
    }
    ngOnInit() {
        // Adds a shortcut listener to the while document
        this.winRef.nativeDocument.addEventListener('keydown', this.onKeyDown);
        // Converts the whole component into a draggable item but only allow the
        // `card-header` as the handler to move it around.
        this.drag = this.dragDrop.createDrag(this.el.nativeElement);
        this.drag.withHandles([this.el.nativeElement.querySelector('div.card-header')]);
        this.drag.disableHandle(this.el.nativeElement);
        console.info(`bento-zone-watcher is ready to be used. Press shift + ctrl + <space bar> to open it`);
    }
    onDataChange() {
        this.change.markForCheck();
    }
    onKeyDown(event) {
        // Only listen when shift + ctrl + <space bar> is pressed
        if (event.ctrlKey && event.shiftKey && event.key === ' ') {
            this.display = this.display === 'block' ? 'none' : 'block';
            if (this.display === 'none') {
                this.releaseZone();
            }
            else {
                this.interceptZone();
            }
            this.change.markForCheck();
        }
    }
    logCallback(task) {
        // Using console.dir instead of console.log allow better logging of function
        console.group('NgZone Watcher - Callback log');
        console.dir(task.callback);
        console.groupEnd();
    }
    // Tracking function for the *ngFor
    trackTask(task) {
        return task;
    }
    recordEventsDelta() {
        if (this.isRecording) {
            const delta = Array.from(this.zoneSpec.eventTasks).filter(task => !this.eventsSnaptshot.includes(task));
            console.group('NgZone Watcher - Event leaks detection');
            if (delta.length === 0) {
                console.info('There were no leaks recorded');
            }
            else {
                console.table(delta.map(e => ({
                    'Event Name': e['eventName'],
                    Callback: e.callback,
                    Target: e['target'],
                    Source: e.source
                })));
            }
            console.groupEnd();
            // Cleanup
            this.eventsSnaptshot = [];
            this.isRecording = false;
        }
        else {
            this.eventsSnaptshot = Array.from(this.zoneSpec.eventTasks);
            this.isRecording = true;
        }
        this.change.markForCheck();
    }
    interceptZone() {
        // This change the Angular ngZone to use a custom spec that allows the component to
        // track all tasks being scheduled by Angular
        this.zoneSpec = this.zoneSpec || new TrackingZoneSpec();
        this.originalInnerZone = this.ngZone._inner;
        this.ngZone._inner = this.ngZone._inner.fork(this.zoneSpec);
        if (this.changesSub) {
            this.changesSub.unsubscribe();
        }
        // this.zoneSpec.changes emits outside the Angular Zone, I have to get back to reflect changes
        this.changesSub = this.zoneSpec.changes.subscribe(() => this.ngZone.run(this.onDataChange));
    }
    releaseZone() {
        // Remove changes subs
        if (this.changesSub) {
            this.changesSub.unsubscribe();
            this.changesSub = undefined;
        }
        // Restore original zone
        if (this.originalInnerZone) {
            this.ngZone._inner = this.originalInnerZone;
        }
    }
}
BentoNgZoneWatcherComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgZoneWatcherComponent, deps: [{ token: WindowRef }, { token: i2$1.DragDrop }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BentoNgZoneWatcherComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: BentoNgZoneWatcherComponent, selector: "bento-zone-watcher", host: { properties: { "style.display": "this.display", "class.card": "this.card", "class.card-alt": "this.cardAlt" } }, ngImport: i0, template: "<div class=\"card-header\">\n  NgZone Watcher\n  <i class=\"bento-icon-move\"></i>\n</div>\n<div class=\"card-body\" *ngIf=\"display !== 'none'\">\n  <button class=\"btn btn-sm\" (click)=\"change.markForCheck()\">Click to refresh zone status</button>\n  <h3>Metrics</h3>\n  <table>\n    <tbody>\n      <tr>\n        <td>Pending microTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"zoneSpec.microTasks.size\" className=\"highlight\">\n          <code>{{ zoneSpec.microTasks.size }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Pending macroTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"zoneSpec.macroTasks.size\" className=\"highlight\">\n          <code>{{ zoneSpec.macroTasks.size }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Events Count</td>\n        <td [bentoRestartAnimationOnValueChange]=\"zoneSpec.eventTasks.size\" className=\"highlight\">\n          <code>{{ zoneSpec.eventTasks.size }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Has pending microTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"ngZone.hasPendingMicrotasks\" className=\"highlight\">\n          <code>{{ ngZone.hasPendingMicrotasks }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Has pending macroTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"ngZone.hasPendingMacrotasks\" className=\"highlight\">\n          <code>{{ ngZone.hasPendingMacrotasks }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Zone is stable</td>\n        <td\n          [bentoRestartAnimationOnValueChange]=\"!ngZone.hasPendingMicrotasks && !ngZone.hasPendingMacrotasks\"\n          className=\"highlight\"\n        >\n          <code>\n            {{ !ngZone.hasPendingMicrotasks && !ngZone.hasPendingMacrotasks }}\n          </code>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n  <h3>Event Leak</h3>\n  <p>\n    Use this feature to log all event handlers that are\n    <strong>added and NOT removed</strong>\n    between the start of the recording and the end of it.\n    <br />\n    <i>Check the console for the events delta</i>\n  </p>\n  <button class=\"btn btn-sm\" (click)=\"recordEventsDelta()\">\n    {{ isRecording ? 'Stop recording event leaks' : 'Start recording event leaks' }}\n  </button>\n  <ng-container\n    *ngTemplateOutlet=\"taskTable; context: {title: 'Pending microTasks', tasks: zoneSpec.microTasks}\"\n  ></ng-container>\n  <ng-container\n    *ngTemplateOutlet=\"taskTable; context: {title: 'Pending macroTasks', tasks: zoneSpec.macroTasks}\"\n  ></ng-container>\n</div>\n\n<ng-template #taskTable let-title=\"title\" let-tasks=\"tasks\">\n  <h3>{{ title }}</h3>\n  <table>\n    <thead>\n      <tr>\n        <th>Type</th>\n        <th>Source</th>\n        <th>Callback</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let task of tasks; trackBy: trackTask\">\n        <td [bentoRestartAnimationOnValueChange]=\"task\" className=\"highlight\">\n          <code>{{ task.type }}</code>\n        </td>\n        <td [bentoRestartAnimationOnValueChange]=\"task\" className=\"highlight\">\n          <code>{{ task.source }}</code>\n        </td>\n        <td [bentoRestartAnimationOnValueChange]=\"task\" className=\"highlight\">\n          <button class=\"btn btn-xs\" (click)=\"logCallback(task)\">\n            Console log callback\n            <code>{{ ' ' + (task.callback.name || 'anonymous') }}</code>\n          </button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</ng-template>\n", styles: [".ng-bento :host{border-radius:14px;box-shadow:1px 1px 10px #f4f5f7;overflow:hidden;position:fixed;z-index:9999999}.ng-bento :host table{background:transparent}.ng-bento :host .card-body{max-height:700px;max-width:400px;overflow-y:auto}.ng-bento :host .card-body th{padding:2px 7px}.ng-bento :host .card-body tbody td{padding:2px 7px}.ng-bento :host .highlight code{-webkit-animation:1s value-change-highlight;animation:1s value-change-highlight}@-webkit-keyframes value-change-highlight{0%{filter:brightness(1.4);font-weight:600}to{filter:unset;font-weight:400}}@keyframes value-change-highlight{0%{filter:brightness(1.4);font-weight:600}to{filter:unset;font-weight:400}}\n"], directives: [{ type: i3$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: BentoRestartAnimationOnValueChangeDirective, selector: "[bentoRestartAnimationOnValueChange]", inputs: ["className", "bentoRestartAnimationOnValueChange"] }, { type: i3$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i3$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgZoneWatcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bento-zone-watcher', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"card-header\">\n  NgZone Watcher\n  <i class=\"bento-icon-move\"></i>\n</div>\n<div class=\"card-body\" *ngIf=\"display !== 'none'\">\n  <button class=\"btn btn-sm\" (click)=\"change.markForCheck()\">Click to refresh zone status</button>\n  <h3>Metrics</h3>\n  <table>\n    <tbody>\n      <tr>\n        <td>Pending microTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"zoneSpec.microTasks.size\" className=\"highlight\">\n          <code>{{ zoneSpec.microTasks.size }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Pending macroTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"zoneSpec.macroTasks.size\" className=\"highlight\">\n          <code>{{ zoneSpec.macroTasks.size }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Events Count</td>\n        <td [bentoRestartAnimationOnValueChange]=\"zoneSpec.eventTasks.size\" className=\"highlight\">\n          <code>{{ zoneSpec.eventTasks.size }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Has pending microTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"ngZone.hasPendingMicrotasks\" className=\"highlight\">\n          <code>{{ ngZone.hasPendingMicrotasks }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Has pending macroTasks</td>\n        <td [bentoRestartAnimationOnValueChange]=\"ngZone.hasPendingMacrotasks\" className=\"highlight\">\n          <code>{{ ngZone.hasPendingMacrotasks }}</code>\n        </td>\n      </tr>\n      <tr>\n        <td>Zone is stable</td>\n        <td\n          [bentoRestartAnimationOnValueChange]=\"!ngZone.hasPendingMicrotasks && !ngZone.hasPendingMacrotasks\"\n          className=\"highlight\"\n        >\n          <code>\n            {{ !ngZone.hasPendingMicrotasks && !ngZone.hasPendingMacrotasks }}\n          </code>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n  <h3>Event Leak</h3>\n  <p>\n    Use this feature to log all event handlers that are\n    <strong>added and NOT removed</strong>\n    between the start of the recording and the end of it.\n    <br />\n    <i>Check the console for the events delta</i>\n  </p>\n  <button class=\"btn btn-sm\" (click)=\"recordEventsDelta()\">\n    {{ isRecording ? 'Stop recording event leaks' : 'Start recording event leaks' }}\n  </button>\n  <ng-container\n    *ngTemplateOutlet=\"taskTable; context: {title: 'Pending microTasks', tasks: zoneSpec.microTasks}\"\n  ></ng-container>\n  <ng-container\n    *ngTemplateOutlet=\"taskTable; context: {title: 'Pending macroTasks', tasks: zoneSpec.macroTasks}\"\n  ></ng-container>\n</div>\n\n<ng-template #taskTable let-title=\"title\" let-tasks=\"tasks\">\n  <h3>{{ title }}</h3>\n  <table>\n    <thead>\n      <tr>\n        <th>Type</th>\n        <th>Source</th>\n        <th>Callback</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let task of tasks; trackBy: trackTask\">\n        <td [bentoRestartAnimationOnValueChange]=\"task\" className=\"highlight\">\n          <code>{{ task.type }}</code>\n        </td>\n        <td [bentoRestartAnimationOnValueChange]=\"task\" className=\"highlight\">\n          <code>{{ task.source }}</code>\n        </td>\n        <td [bentoRestartAnimationOnValueChange]=\"task\" className=\"highlight\">\n          <button class=\"btn btn-xs\" (click)=\"logCallback(task)\">\n            Console log callback\n            <code>{{ ' ' + (task.callback.name || 'anonymous') }}</code>\n          </button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</ng-template>\n", styles: [".ng-bento :host{border-radius:14px;box-shadow:1px 1px 10px #f4f5f7;overflow:hidden;position:fixed;z-index:9999999}.ng-bento :host table{background:transparent}.ng-bento :host .card-body{max-height:700px;max-width:400px;overflow-y:auto}.ng-bento :host .card-body th{padding:2px 7px}.ng-bento :host .card-body tbody td{padding:2px 7px}.ng-bento :host .highlight code{-webkit-animation:1s value-change-highlight;animation:1s value-change-highlight}@-webkit-keyframes value-change-highlight{0%{filter:brightness(1.4);font-weight:600}to{filter:unset;font-weight:400}}@keyframes value-change-highlight{0%{filter:brightness(1.4);font-weight:600}to{filter:unset;font-weight:400}}\n"] }]
        }], ctorParameters: function () { return [{ type: WindowRef }, { type: i2$1.DragDrop }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { display: [{
                type: HostBinding,
                args: ['style.display']
            }], card: [{
                type: HostBinding,
                args: ['class.card']
            }], cardAlt: [{
                type: HostBinding,
                args: ['class.card-alt']
            }] } });

class BentoNgZoneWatcherModule {
}
BentoNgZoneWatcherModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgZoneWatcherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BentoNgZoneWatcherModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgZoneWatcherModule, declarations: [BentoNgZoneWatcherComponent, BentoRestartAnimationOnValueChangeDirective], imports: [CommonModule, DragDropModule], exports: [BentoNgZoneWatcherComponent, BentoRestartAnimationOnValueChangeDirective] });
BentoNgZoneWatcherModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgZoneWatcherModule, imports: [[CommonModule, DragDropModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoNgZoneWatcherModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, DragDropModule],
                    declarations: [BentoNgZoneWatcherComponent, BentoRestartAnimationOnValueChangeDirective],
                    exports: [BentoNgZoneWatcherComponent, BentoRestartAnimationOnValueChangeDirective]
                }]
        }] });

const bentoUniqueStableIdAttribute = new InjectionToken('bento.uniqueStableId.attribute');
class BentoUniqueStableIdDirective {
    constructor(el, r, uniqueStableIdAttribute) {
        this.el = el;
        this.r = r;
        this.uniqueStableIdAttribute = uniqueStableIdAttribute;
    }
    set bentoUniqueStableId(id) {
        if (this.uniqueStableIdAttribute && id) {
            this.r.setAttribute(this.el.nativeElement, this.uniqueStableIdAttribute, id);
        }
    }
}
BentoUniqueStableIdDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniqueStableIdDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: bentoUniqueStableIdAttribute, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
BentoUniqueStableIdDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoUniqueStableIdDirective, selector: "[bentoUniqueStableId]", inputs: { bentoUniqueStableId: "bentoUniqueStableId" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniqueStableIdDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[bentoUniqueStableId]'
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [bentoUniqueStableIdAttribute]
                    }] }];
    }, propDecorators: { bentoUniqueStableId: [{
                type: Input
            }] } });

class BentoUniqueStableIdModule {
    static withName(config) {
        return {
            ngModule: BentoUniqueStableIdModule,
            providers: [{ provide: bentoUniqueStableIdAttribute, useValue: config }]
        };
    }
}
BentoUniqueStableIdModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniqueStableIdModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BentoUniqueStableIdModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniqueStableIdModule, declarations: [BentoUniqueStableIdDirective], exports: [BentoUniqueStableIdDirective] });
BentoUniqueStableIdModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniqueStableIdModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoUniqueStableIdModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoUniqueStableIdDirective],
                    imports: [],
                    exports: [BentoUniqueStableIdDirective]
                }]
        }] });

// Imports
// version number placeholder
const BENTO_NG_VERSION = new Version('13.0.0');
class BentoModule {
    constructor(appRef, rFactory, accordionConfig, navConfig) {
        let s = appRef.isStable.subscribe(isStable => {
            if (appRef.components[0] && isStable) {
                // When Application is bootstrapped
                const rootComponentRef = appRef.components[0];
                const appEl = rootComponentRef.location.nativeElement;
                // Assign Bento NG full version to app element's attribute
                let r = rFactory.createRenderer(appEl, null);
                r.setAttribute(appEl, 'bento-ng-version', BENTO_NG_VERSION.full);
                s.unsubscribe();
                r = null;
                s = null;
            }
        });
        accordionConfig.animation = false;
        navConfig.animation = false;
    }
}
BentoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModule, deps: [{ token: i0.ApplicationRef }, { token: i0.RendererFactory2 }, { token: i1$1.NgbAccordionConfig }, { token: i1$1.NgbNavConfig }], target: i0.ɵɵFactoryTarget.NgModule });
BentoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModule, exports: [BentoAlertModule,
        BentoBadgeModule,
        BentoBusyLoaderModule,
        BentoCheckboxModule,
        BentoDatepickerToggleModule,
        BentoDatepickerAccessibilityModule,
        BentoDatepickerMaskModule,
        BentoFileSelectorModule,
        BentoGlobalHeaderModule,
        BentoListModule,
        BentoMegamenuModule,
        BentoMultiselectOverlayModule,
        BentoNumberInputModule,
        BentoOffCanvasMenuModule,
        BentoPaginationModule,
        BentoResetModule,
        BentoSelectModule,
        BentoSideNavModule,
        BentoSplitterGroupModule,
        BentoTabsModule,
        BentoTagsInputModule,
        BentoToggleModule,
        BentoToolbarModule,
        BentoTreeModule,
        BentoTransferboxBasicModule,
        BentoTranslateModule,
        BentoUtilsModule,
        BentoWizardComponentModule,
        BentoUniverseFilterDropdownModule,
        BentoUniverseFilterModule,
        BentoComboboxModule,
        BentoContextualHeaderModule,
        BentoAppendToModule,
        BentoExpandCollapseButtonGroupModule,
        BentoTimepickerModule,
        BentoSkipLinksModule,
        BentoStickyFooterModule,
        BentoStickyBarModule,
        BentoTileRibbonModule,
        BentoScrollableToolbarModule,
        BentoSmartBadgeModule,
        BentoFocusMonitorModule,
        BentoNgbTooltipSupportModule,
        BentoNgbDropdownAnimationModule,
        BentoNgbPopoverAnimationModule,
        BentoToastModule,
        BentoModalConfirmationModule,
        BentoFormModule] });
BentoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModule, imports: [BentoAlertModule,
        BentoBadgeModule,
        BentoBusyLoaderModule,
        BentoCheckboxModule,
        BentoDatepickerToggleModule,
        BentoDatepickerAccessibilityModule,
        BentoDatepickerMaskModule,
        BentoFileSelectorModule,
        BentoGlobalHeaderModule,
        BentoListModule,
        BentoMegamenuModule,
        BentoMultiselectOverlayModule,
        BentoNumberInputModule,
        BentoOffCanvasMenuModule,
        BentoPaginationModule,
        BentoResetModule,
        BentoSelectModule,
        BentoSideNavModule,
        BentoSplitterGroupModule,
        BentoTabsModule,
        BentoTagsInputModule,
        BentoToggleModule,
        BentoToolbarModule,
        BentoTreeModule,
        BentoTransferboxBasicModule,
        BentoTranslateModule,
        BentoUtilsModule,
        BentoWizardComponentModule,
        BentoUniverseFilterDropdownModule,
        BentoUniverseFilterModule,
        BentoComboboxModule,
        BentoContextualHeaderModule,
        BentoAppendToModule,
        BentoExpandCollapseButtonGroupModule,
        BentoTimepickerModule,
        BentoSkipLinksModule,
        BentoStickyFooterModule,
        BentoStickyBarModule,
        BentoTileRibbonModule,
        BentoScrollableToolbarModule,
        BentoSmartBadgeModule,
        BentoFocusMonitorModule,
        BentoNgbTooltipSupportModule,
        BentoNgbDropdownAnimationModule,
        BentoNgbPopoverAnimationModule,
        BentoToastModule,
        BentoModalConfirmationModule,
        BentoFormModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [
                        BentoAlertModule,
                        BentoBadgeModule,
                        BentoBusyLoaderModule,
                        BentoCheckboxModule,
                        BentoDatepickerToggleModule,
                        BentoDatepickerAccessibilityModule,
                        BentoDatepickerMaskModule,
                        BentoFileSelectorModule,
                        BentoGlobalHeaderModule,
                        BentoListModule,
                        BentoMegamenuModule,
                        BentoMultiselectOverlayModule,
                        BentoNumberInputModule,
                        BentoOffCanvasMenuModule,
                        BentoPaginationModule,
                        BentoResetModule,
                        BentoSelectModule,
                        BentoSideNavModule,
                        BentoSplitterGroupModule,
                        BentoTabsModule,
                        BentoTagsInputModule,
                        BentoToggleModule,
                        BentoToolbarModule,
                        BentoTreeModule,
                        BentoTransferboxBasicModule,
                        BentoTranslateModule,
                        BentoUtilsModule,
                        BentoWizardComponentModule,
                        BentoUniverseFilterDropdownModule,
                        BentoUniverseFilterModule,
                        BentoComboboxModule,
                        BentoContextualHeaderModule,
                        BentoAppendToModule,
                        BentoExpandCollapseButtonGroupModule,
                        BentoTimepickerModule,
                        BentoSkipLinksModule,
                        BentoStickyFooterModule,
                        BentoStickyBarModule,
                        BentoTileRibbonModule,
                        BentoScrollableToolbarModule,
                        BentoSmartBadgeModule,
                        BentoFocusMonitorModule,
                        BentoNgbTooltipSupportModule,
                        BentoNgbDropdownAnimationModule,
                        BentoNgbPopoverAnimationModule,
                        BentoToastModule,
                        BentoModalConfirmationModule,
                        BentoFormModule
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ApplicationRef }, { type: i0.RendererFactory2 }, { type: i1$1.NgbAccordionConfig }, { type: i1$1.NgbNavConfig }]; } });

/*
 * Public API Surface of bento-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BENTO_NG_VERSION, BentoActionableItem, BentoAlertComponent, BentoAlertItemComponent, BentoAlertModule, BentoAppendToDirective, BentoAppendToModule, BentoBadgeComponent, BentoBadgeModule, BentoBusyLoaderDirective, BentoBusyLoaderModule, BentoCheckboxComponent, BentoCheckboxModule, BentoComboboxComponent, BentoComboboxListComponent, BentoComboboxModule, BentoComboboxSearchEvent, BentoContextualHeaderComponent, BentoContextualHeaderItem, BentoContextualHeaderModule, BentoDatepickerAccessibilityDirective, BentoDatepickerAccessibilityModule, BentoDatepickerConfigDirective, BentoDatepickerMaskModule, BentoDatepickerToggleDirective, BentoDatepickerToggleModule, BentoExpandCollapseButtonGroupComponent, BentoExpandCollapseButtonGroupModule, BentoFileSelectorComponent, BentoFileSelectorModule, BentoFileSizePipe, BentoFocusMonitorDirective, BentoFocusMonitorModule, BentoFooterTabHelper, BentoFormModule, BentoGlobalHeaderChangeDirective, BentoGlobalHeaderModule, BentoInputGroupPrependDirective, BentoListComponent, BentoListModule, BentoLogService, BentoMegaMenuFlowComponent, BentoMegamenuComponent, BentoMegamenuDefaultComponent, BentoMegamenuModule, BentoMegamenuTakeoverComponent, BentoModalConfirmationCloseReason, BentoModalConfirmationModule, BentoModalConfirmationService, BentoModule, BentoMultiselectListComponent, BentoMultiselectOverlayComponent, BentoMultiselectOverlayModule, BentoNgZoneWatcherComponent, BentoNgZoneWatcherModule, BentoNgbDropdownAnimationDirective, BentoNgbDropdownAnimationModule, BentoNgbDropdownAppendToDirective, BentoNgbPopoverAnimationDirective, BentoNgbPopoverAnimationModule, BentoNgbTooltipSupportDirective, BentoNgbTooltipSupportModule, BentoNotification, BentoNumberInputComponent, BentoNumberInputModule, BentoOffCanvasMenuComponent, BentoOffCanvasMenuModule, BentoPaginationComponent, BentoPaginationModule, BentoPositioning, BentoRefreshNotifierDirective, BentoReplaceTagDirective, BentoRequiredDirective, BentoResetDirective, BentoResetModule, BentoRestartAnimationOnValueChangeDirective, BentoRibbonTile, BentoRibbonTileComponent, BentoScrollableBarComponent, BentoScrollableBarModule, BentoScrollableToolbarComponent, BentoScrollableToolbarModule, BentoSelectDirective, BentoSelectModule, BentoSideNavComponent, BentoSideNavModule, BentoSkipLinksComponent, BentoSkipLinksModule, BentoSkipLinksService, BentoSmartBadgeComponent, BentoSmartBadgeModule, BentoSmartBadgeStyle, BentoSmartBadgeType, BentoSplitterGroupBottomComponent, BentoSplitterGroupComponent, BentoSplitterGroupLeftComponent, BentoSplitterGroupMainComponent, BentoSplitterGroupModule, BentoSplitterGroupRightComponent, BentoSplitterGroupSideComponent, BentoSplitterGroupTopComponent, BentoStickyBarDirective, BentoStickyBarModule, BentoStickyFooterComponent, BentoStickyFooterModule, BentoStringReplacePipe, BentoTabService, BentoTabsLabelComponent, BentoTabsModule, BentoTabsScrollComponent, BentoTagsInputComponent, BentoTagsInputEvent, BentoTagsInputModule, BentoTagsInputPillComponent, BentoTileRibbonComponent, BentoTileRibbonModule, BentoTimepickerDirective, BentoTimepickerModule, BentoToast, BentoToastContainerComponent, BentoToastModule, BentoToastRef, BentoToastService, BentoToggleComponent, BentoToggleConfig, BentoToggleModule, BentoToolbarComponent, BentoToolbarKeyboardSupportDirective, BentoToolbarModule, BentoTransferboxBasicComponent, BentoTransferboxBasicModule, BentoTransferlistComponent, BentoTransition, BentoTranslate, BentoTranslateModule, BentoTranslatePipe, BentoTreeComponent, BentoTreeItemCheckStatus, BentoTreeItemComponent, BentoTreeItemOption, BentoTreeModule, BentoTreeViewComponent, BentoUidService, BentoUniqueStableIdDirective, BentoUniqueStableIdModule, BentoUniverseFilterComponent, BentoUniverseFilterDropdownComponent, BentoUniverseFilterDropdownModule, BentoUniverseFilterModule, BentoUtilsModule, BentoWizardComponent, BentoWizardComponentCustomButtonGroupComponent, BentoWizardComponentEllipsisDirective, BentoWizardComponentEvent, BentoWizardComponentModule, BentoWizardComponentStripComponent, BentoWizardStepComponent, BusyLoader, ConsumerDataValidator, DEFAULT_LIST_HEIGHT, DEFAULT_LIST_MAX_HEIGHT, DEFAULT_LIST_WIDTH, DEFAULT_ROW_HEIGHT, EasingFunctions, FadeInOut, FadeInOutFunc, FadeInOutLong, Keyboard, Selection, SizeUnit, SkipLink, WindowRef, bentoUniqueStableIdAttribute, setConsumerData };
